import r$4, { useContext, createElement, useState, useRef, useEffect, lazy, Suspense, useMemo, useCallback, Fragment as Fragment$1, createContext, useReducer, Children, createRef } from "react";
import { Link } from "react-router-dom";
var jsxRuntime$1 = { exports: {} };
var reactJsxRuntime_production_min$1 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$5 = r$4, k$7 = Symbol.for("react.element"), l$6 = Symbol.for("react.fragment"), m$5 = Object.prototype.hasOwnProperty, n$6 = f$5.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p$6 = { key: true, ref: true, __self: true, __source: true };
function q$8(c2, a, g2) {
  var b2, d2 = {}, e2 = null, h6 = null;
  g2 !== void 0 && (e2 = "" + g2);
  a.key !== void 0 && (e2 = "" + a.key);
  a.ref !== void 0 && (h6 = a.ref);
  for (b2 in a)
    m$5.call(a, b2) && !p$6.hasOwnProperty(b2) && (d2[b2] = a[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a = c2.defaultProps, a)
      d2[b2] === void 0 && (d2[b2] = a[b2]);
  return { $$typeof: k$7, type: c2, key: e2, ref: h6, props: d2, _owner: n$6.current };
}
reactJsxRuntime_production_min$1.Fragment = l$6;
reactJsxRuntime_production_min$1.jsx = q$8;
reactJsxRuntime_production_min$1.jsxs = q$8;
{
  jsxRuntime$1.exports = reactJsxRuntime_production_min$1;
}
const jsx$1 = jsxRuntime$1.exports.jsx;
const jsxs$1 = jsxRuntime$1.exports.jsxs;
const SvgBin = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.505a.25.25 0 0 0-.25.25v.755h4.5v-.755a.25.25 0 0 0-.25-.25h-4zm5.75 1.005v-.755A1.75 1.75 0 0 0 14 2.005h-4a1.75 1.75 0 0 0-1.75 1.75v.755h-3.5a.75.75 0 0 0 0 1.5h.5v14.248c0 .966.783 1.75 1.75 1.75h10a1.75 1.75 0 0 0 1.75-1.75V6.01h.5a.75.75 0 0 0 0-1.5h-3.5zm1.5 1.5H6.75v14.248c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25V6.01zM10 18.5a.75.75 0 0 1-.75-.75v-8.5a.75.75 0 0 1 1.5 0v8.5a.75.75 0 0 1-.75.75zm4 0a.75.75 0 0 1-.75-.75v-8.5a.75.75 0 1 1 1.5 0v8.5a.75.75 0 0 1-.75.75z"
  })]
});
const SvgCalendar = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 6.273a.81.81 0 0 0-.8.818v11.454a.81.81 0 0 0 .8.819h11.2a.81.81 0 0 0 .8-.819V7.091a.81.81 0 0 0-.8-.818H6.4zM4 7.09c0-1.356 1.075-2.455 2.4-2.455h11.2c1.325 0 2.4 1.1 2.4 2.455v11.454C20 19.902 18.925 21 17.6 21H6.4C5.075 21 4 19.901 4 18.546V7.09z"
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2 3c.442 0 .8.366.8.818v3.273a.81.81 0 0 1-.8.818.81.81 0 0 1-.8-.818V3.818A.81.81 0 0 1 15.2 3zM8.8 3c.442 0 .8.366.8.818v3.273a.81.81 0 0 1-.8.818.81.81 0 0 1-.8-.818V3.818A.81.81 0 0 1 8.8 3zM4 10.364a.81.81 0 0 1 .8-.819h14.4c.442 0 .8.367.8.819a.81.81 0 0 1-.8.818H4.8a.81.81 0 0 1-.8-.818z"
  })]
});
const SvgCheck = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.707 5.293a1 1 0 0 1 0 1.414l-11 11a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9 15.586 19.293 5.293a1 1 0 0 1 1.414 0z"
  })]
});
const SvgCheckmark = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "data-testid": "test-icon",
  "aria-hidden": "true",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Zm4.84-13.346.947.948c.165.165.165.494 0 .7l-3.563 3.522-3.563 3.521a.474.474 0 0 1-.7 0L3.213 9.556c-.165-.165-.165-.494 0-.7l.947-.906a.474.474 0 0 1 .7 0l2.472 2.471 5.808-5.767c.205-.205.535-.205.7 0Z"
  })]
});
const SvgChevronDown = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "M11.735 15.882a.357.357 0 0 0 .53 0l4.618-4.63c.156-.126.156-.378 0-.536l-.624-.598c-.125-.157-.374-.157-.53 0l-3.713 3.717-3.745-3.717a.357.357 0 0 0-.53 0l-.624.598c-.156.158-.156.41 0 .536l4.618 4.63z"
  })]
});
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "M14.882 12.265a.357.357 0 0 0 0-.53l-4.63-4.618c-.126-.156-.378-.156-.535 0l-.599.624c-.157.125-.157.374 0 .53l3.717 3.713-3.717 3.745a.357.357 0 0 0 0 .53l.599.624c.157.156.409.156.535 0l4.63-4.618z"
  })]
});
const SvgChevronUp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "M12.265 9.118a.357.357 0 0 0-.53 0l-4.618 4.63c-.156.126-.156.378 0 .536l.624.598c.125.157.374.157.53 0l3.713-3.717 3.745 3.717a.357.357 0 0 0 .53 0l.624-.598c.156-.158.156-.41 0-.536l-4.618-4.63z"
  })]
});
const SvgCog = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "data-testid": "test-icon",
  "aria-hidden": "true",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.667a.833.833 0 0 0-.833.833v.145a2.208 2.208 0 0 1-1.339 2.02.833.833 0 0 1-.22.061 2.208 2.208 0 0 1-2.274-.505l-.007-.007-.05-.05a.836.836 0 0 0-1.18 0 .833.833 0 0 0 0 1.18l.057.057a2.208 2.208 0 0 1 .452 2.411 2.208 2.208 0 0 1-2.012 1.421H2.5a.833.833 0 0 0 0 1.667h.145a2.208 2.208 0 0 1 2.02 1.334 2.208 2.208 0 0 1-.444 2.432l-.007.007-.05.05a.835.835 0 0 0 0 1.18.833.833 0 0 0 1.18 0l.057-.057a2.209 2.209 0 0 1 2.411-.452 2.208 2.208 0 0 1 1.421 2.011v.095a.833.833 0 0 0 1.667 0v-.145a2.208 2.208 0 0 1 1.334-2.02 2.209 2.209 0 0 1 2.432.444l.007.007.05.05a.836.836 0 0 0 .909.181.834.834 0 0 0 .27-.18v-.002a.832.832 0 0 0 0-1.179l-.056-.057a2.209 2.209 0 0 1-.444-2.431 2.209 2.209 0 0 1 2.02-1.335h.078a.834.834 0 0 0 0-1.666h-.145a2.208 2.208 0 0 1-2.021-1.339.837.837 0 0 1-.06-.22 2.208 2.208 0 0 1 .505-2.274l.007-.007.05-.05a.837.837 0 0 0 .181-.909.834.834 0 0 0-.18-.27h-.002a.833.833 0 0 0-1.179 0l-.057.056a2.208 2.208 0 0 1-2.431.444 2.208 2.208 0 0 1-1.335-2.02V2.5A.834.834 0 0 0 10 1.667zM8.232.732A2.5 2.5 0 0 1 12.5 2.5v.073a.542.542 0 0 0 .328.494l.008.004a.542.542 0 0 0 .595-.106l.046-.046a2.5 2.5 0 1 1 3.537 3.537l-.046.046a.541.541 0 0 0-.106.595.83.83 0 0 1 .054.166.543.543 0 0 0 .444.237h.14a2.5 2.5 0 0 1 0 5h-.073a.542.542 0 0 0-.494.328l-.004.008a.542.542 0 0 0 .106.595l.046.046a2.5 2.5 0 0 1 0 3.538l-.59-.59.59.589a2.5 2.5 0 0 1-3.537 0l-.046-.046a.542.542 0 0 0-.595-.106l-.008.004a.542.542 0 0 0-.328.494v.14a2.5 2.5 0 0 1-5 0v-.063a.542.542 0 0 0-.355-.488.932.932 0 0 1-.048-.02.542.542 0 0 0-.595.106l-.046.046a2.501 2.501 0 1 1-3.537-3.537l.046-.046a.542.542 0 0 0 .106-.595l-.004-.008a.542.542 0 0 0-.494-.328H2.5a2.5 2.5 0 1 1 0-5h.063a.542.542 0 0 0 .488-.355.831.831 0 0 1 .02-.048.542.542 0 0 0-.106-.595l-.046-.046a2.5 2.5 0 1 1 3.537-3.537l.046.046a.542.542 0 0 0 .595.106.834.834 0 0 1 .166-.054.542.542 0 0 0 .237-.444V2.5A2.5 2.5 0 0 1 8.232.732zM10 8.333a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334zM6.667 10a3.333 3.333 0 1 1 6.666 0 3.333 3.333 0 0 1-6.666 0z"
  })]
});
const SvgCopy = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "M13.306 14.501H8.292a.837.837 0 0 1-.846-.83c0-.453.383-.829.846-.829h5.023c.472 0 .846.376.846.83a.845.845 0 0 1-.855.829zm0-3.335H8.292a.837.837 0 0 1-.846-.829c0-.454.383-.83.846-.83h5.023c.472 0 .846.376.846.83 0 .454-.383.83-.855.83zm0 6.67H8.292a.837.837 0 0 1-.846-.83c0-.453.383-.829.846-.829h5.023c.472 0 .846.376.846.83 0 .453-.383.829-.855.829z"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M14.99 22H6.61C5.175 22 4 20.848 4 19.442V7.892c0-1.414 1.176-2.557 2.61-2.557h8.38c1.442 0 2.608 1.152 2.608 2.558v11.55c0 1.405-1.166 2.557-2.609 2.557zM6.61 7.002a.903.903 0 0 0-.91.89v11.55c0 .489.41.89.91.89h8.38a.903.903 0 0 0 .907-.89V7.892c0-.488-.41-.89-.908-.89H6.61z"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M18.39 18.665h-1.638a.837.837 0 0 1-.846-.83c0-.453.383-.829.846-.829h1.639a.903.903 0 0 0 .908-.89V4.558c0-.489-.41-.89-.908-.89h-8.38a.903.903 0 0 0-.908.89v1.606c0 .463-.383.83-.846.83-.464 0-.855-.367-.855-.83V4.558C7.402 3.152 8.568 2 10.01 2h8.38C19.833 2 21 3.152 21 4.558v11.55c0 1.414-1.175 2.557-2.61 2.557z"
  })]
});
const SvgCross = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  "data-testid": "test-icon",
  "aria-hidden": "true",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "m23 20.168-8.185-8.187L23 3.807 20.168 1l-8.182 8.179L3.81 1 1 3.81l8.186 8.196L1 20.19 3.81 23l8.203-8.192L20.193 23z"
  })]
});
const SvgExclamation = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm-.006-6.895c.835 0 1.524.69 1.524 1.524a1.51 1.51 0 0 1-1.524 1.524c-.87 0-1.524-.653-1.524-1.524a1.51 1.51 0 0 1 1.524-1.524zm-1.197-1.198-.254-4.935c0-.254.181-.472.435-.472h1.996c.254 0 .435.218.435.472l-.254 4.935c0 .218-.217.4-.435.4h-1.488c-.218 0-.435-.182-.435-.4z"
  })]
});
const SvgEyeClosed = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "M16 12c0-2.21-1.79-4-4-4-.06 0-.11.01-.17.02l4.15 4.15c.01-.06.02-.11.02-.17zm-3.32 3.93-4.61-4.61c-.04.22-.07.45-.07.68 0 2.21 1.79 4 4 4 .23 0 .46-.03.68-.07z"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 18.01c-.65 0-1.29-.11-1.91-.28-1.3-.4-2.48-1.08-3.47-1.97-.07-.06-.14-.11-.2-.18-.07-.07-.14-.15-.21-.22-.85-.89-1.56-1.98-2.08-3.23-.01-.03-.04-.08-.05-.12.02-.05.04-.09.06-.14.44-1.05 1.02-1.98 1.7-2.79L4.4 7.66c-.05.06-.11.12-.17.18-.75.88-1.36 1.87-1.82 2.95-.12.28-.24.57-.35.87a1.03 1.03 0 0 0 0 .7c.11.29.23.58.35.86a11.45 11.45 0 0 0 1.82 2.95c2 2.41 4.78 3.84 7.77 3.84 1.36 0 2.68-.3 3.9-.86l-1.55-1.55c-.75.27-1.54.41-2.35.41zm9.94-6.35c-.14-.39-.31-.77-.49-1.14v-.01C19.55 6.52 15.96 4 12 4c-1.21 0-2.39.25-3.49.69l1.59 1.59C10.72 6.11 11.35 6 12 6c2.89 0 5.56 1.73 7.19 4.52.08.14.16.28.23.43.14.27.27.54.4.83.03.08.07.15.1.23-.03.08-.07.15-.1.23-.12.29-.26.56-.4.83-.08.14-.15.29-.23.43-.23.4-.49.77-.76 1.12l1.43 1.43c.61-.76 1.15-1.61 1.59-2.54v-.01c.18-.37.34-.75.49-1.14a1.03 1.03 0 0 0 0-.7zm-6.28 1.95-3.67-3.66-1.94-1.94-1.22-1.23L7.05 5a1.25 1.25 0 0 0-1.77 0c-.48.49-.48 1.27-.01 1.76l.01.01L6.7 8.18l10.84 10.84c.24.24.56.37.88.37.32 0 .64-.12.88-.37.49-.49.49-1.28 0-1.77l-3.64-3.64z"
  })]
});
const SvgEye = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "M16 11.995a3.998 3.998 0 0 1-4 3.998c-2.21 0-4-1.79-4-3.998 0-.41.08-.79.19-1.16.32.68 1.01 1.16 1.81 1.16 1.1 0 2-.9 2-1.999 0-.8-.48-1.489-1.16-1.809.37-.11.75-.19 1.16-.19 2.21 0 4 1.79 4 3.998zm5.94-.34a1.029 1.029 0 0 1 0 .7c-.14.39-.31.77-.49 1.14v.01c-1.89 3.987-5.49 6.505-9.45 6.505-2.98 0-5.77-1.43-7.77-3.838-.75-.88-1.36-1.878-1.82-2.958-.12-.28-.24-.57-.35-.86a1.03 1.03 0 0 1 0-.699c.11-.29.23-.58.35-.86a11.44 11.44 0 0 1 1.82-2.947C6.23 5.429 9.02 4 12 4c3.96 0 7.55 2.518 9.45 6.506v.01c.18.36.34.74.49 1.14zm-2.02.35c-.03-.08-.07-.15-.1-.23-.12-.29-.26-.56-.4-.83-.08-.14-.15-.29-.23-.43C17.56 7.729 14.89 6 12 6c-.65 0-1.29.11-1.91.28-1.3.4-2.48 1.079-3.47 1.968-.07.06-.14.11-.2.18-.07.06-.14.14-.21.21a10.87 10.87 0 0 0-2.08 3.228c-.01.05-.04.09-.05.14.01.04.04.09.05.13a10.49 10.49 0 0 0 2.08 3.228c.07.07.13.15.21.22.06.06.14.12.2.18a9.41 9.41 0 0 0 3.47 1.968c.62.17 1.26.28 1.91.28 2.89 0 5.56-1.729 7.19-4.517.08-.14.16-.28.23-.43.14-.27.27-.54.4-.83.04-.08.07-.159.1-.229z"
  })]
});
const SvgHelpCircle = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.61a8.39 8.39 0 1 0 0 16.78 8.39 8.39 0 0 0 0-16.78zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z"
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.257 8.23a1.954 1.954 0 0 0-2.174 1.278.805.805 0 1 1-1.518-.534 3.563 3.563 0 0 1 6.925 1.188c0 1.346-1 2.245-1.738 2.737a7.281 7.281 0 0 1-1.525.768l-.03.01-.01.004-.004.001h-.001l-.256-.763.255.764a.805.805 0 0 1-.51-1.526l.017-.006.07-.027a5.68 5.68 0 0 0 1.1-.564c.643-.427 1.022-.907 1.022-1.4a1.954 1.954 0 0 0-1.623-1.93zm-1.062 8.368c0-.445.36-.805.805-.805h.01a.805.805 0 1 1 0 1.61H12a.805.805 0 0 1-.805-.805z"
  })]
});
const SvgImage = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62 4.595c-.566 0-1.025.459-1.025 1.025v12.76c0 .566.459 1.025 1.025 1.025h12.76c.566 0 1.025-.459 1.025-1.025V5.62c0-.566-.459-1.025-1.025-1.025H5.62zM3 5.62A2.62 2.62 0 0 1 5.62 3h12.76A2.62 2.62 0 0 1 21 5.62v12.76A2.62 2.62 0 0 1 18.38 21H5.62A2.62 2.62 0 0 1 3 18.38V5.62z"
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81 8.24a.57.57 0 1 0 0 1.14.57.57 0 0 0 0-1.14zm-2.164.57a2.165 2.165 0 1 1 4.329 0 2.165 2.165 0 0 1-4.33 0zm8.436.803a.797.797 0 0 1 1.127 0l4.557 4.557a.797.797 0 1 1-1.127 1.128l-3.993-3.993-9.462 9.461a.797.797 0 1 1-1.128-1.127L15.082 9.613z"
  })]
});
const SvgInfo = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm.006 6.895c-.835 0-1.524-.69-1.524-1.524 0-.871.69-1.524 1.524-1.524.87 0 1.524.653 1.524 1.524a1.51 1.51 0 0 1-1.524 1.524zm1.197 1.198v4.935c0 .254-.181.472-.435.472H11.28c-.254 0-.435-.218-.435-.472v-4.935c0-.218.217-.4.435-.4h1.488c.218 0 .435.182.435.4z"
  })]
});
const SvgLink = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "M12.638 4.386A4.932 4.932 0 0 1 21 7.896a4.941 4.941 0 0 1-1.385 3.474l-.01.01-2.467 2.47a4.932 4.932 0 0 1-7.441-.534.824.824 0 0 1 1.317-.986 3.292 3.292 0 0 0 3.784 1.113 3.291 3.291 0 0 0 1.177-.757l2.461-2.464a3.295 3.295 0 0 0-2.342-5.576 3.288 3.288 0 0 0-2.31.92l-1.41 1.404a.822.822 0 1 1-1.16-1.168l1.415-1.407.009-.009z"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M8.627 9.015a4.93 4.93 0 0 1 5.676 1.669.824.824 0 0 1-1.317.986 3.292 3.292 0 0 0-3.784-1.113 3.29 3.29 0 0 0-1.176.757l-2.462 2.464a3.294 3.294 0 0 0 2.342 5.576 3.29 3.29 0 0 0 2.309-.92l1.4-1.402a.822.822 0 1 1 1.164 1.164l-1.406 1.408-.01.01a4.932 4.932 0 0 1-6.918-.06 4.941 4.941 0 0 1-.06-6.924l.01-.01 2.467-2.47c.5-.5 1.103-.888 1.765-1.135z"
  })]
});
const SvgLockClosed = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 19 18",
  xmlns: "http://www.w3.org/2000/svg",
  "data-testid": "test-icon",
  "aria-hidden": "true",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.148 6.625H1.886C.85 6.625.01 7.465.01 8.5v7.625C.01 17.16.85 18 1.886 18H16.13c1.036 0 1.875-.84 1.875-1.875V8.5c0-1.036-.839-1.875-1.875-1.875h-1.28c-.129-2.392-.8-4.02-1.867-5.063C11.793.397 10.274.125 9 .125S6.207.397 5.015 1.562c-1.067 1.043-1.738 2.67-1.867 5.063Zm1.752 0h8.2c-.127-2.058-.698-3.186-1.339-3.812-.727-.71-1.707-.938-2.761-.938s-2.035.228-2.762.938c-.64.626-1.212 1.754-1.338 3.812Zm-3.014 1.75a.125.125 0 0 0-.125.125v7.625c0 .069.056.125.125.125H16.13a.125.125 0 0 0 .125-.125V8.5a.125.125 0 0 0-.125-.125H1.886ZM9 10.625c.483 0 .875.392.875.875v2a.875.875 0 0 1-1.75 0v-2c0-.483.392-.875.875-.875Z"
  })]
});
const SvgLockOpen = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 19 18",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "data-testid": "test-icon",
  "aria-hidden": "true",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.886 6.625h1.262c.13-2.392.8-4.02 1.867-5.063C6.207.397 7.726.125 9 .125c1.273 0 2.793.272 3.984 1.437 1.067 1.043 1.739 2.67 1.868 5.063h1.28c1.035 0 1.874.84 1.874 1.875v7.625c0 1.035-.839 1.875-1.875 1.875H1.886A1.875 1.875 0 0 1 .01 16.125V8.5c0-1.036.84-1.875 1.875-1.875Zm3.014 0c.126-2.058.698-3.186 1.338-3.812.727-.71 1.708-.938 2.762-.938s2.034.228 2.761.938l1.223-1.251c1.067 1.043 1.739 2.67 1.868 5.063H4.9ZM1.76 8.5c0-.069.057-.125.126-.125H16.13c.07 0 .125.056.125.125v7.625a.125.125 0 0 1-.125.125H1.886a.125.125 0 0 1-.125-.125V8.5Zm8.115 3a.875.875 0 0 0-1.75 0v2a.875.875 0 0 0 1.75 0v-2Z"
  })]
});
const SvgMail = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "M4.644 5.577a1.03 1.03 0 0 0-1.035 1.015v10.817a1.03 1.03 0 0 0 1.035 1.014h14.712a1.03 1.03 0 0 0 1.035-1.014V6.591a1.03 1.03 0 0 0-1.035-1.015H4.644zM2 6.592C2 5.164 3.188 4 4.644 4h14.712C20.812 4 22 5.164 22 6.592v10.817C22 18.835 20.812 20 19.356 20H4.644C3.188 20 2 18.836 2 17.409V6.591z"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M2.146 6.14a.815.815 0 0 1 1.12-.195L12 11.94l8.734-5.994a.815.815 0 0 1 1.12.194.779.779 0 0 1-.197 1.099l-9.196 6.31a.818.818 0 0 1-.922 0l-9.196-6.31a.779.779 0 0 1-.197-1.099z"
  })]
});
const SvgMaximize = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8 3.9a.9.9 0 0 1 .9-.9h5.4a.9.9 0 0 1 .9.9v5.4a.9.9 0 1 1-1.8 0V4.8h-4.5a.9.9 0 0 1-.9-.9zm-9.9 9.9a.9.9 0 0 1 .9.9v4.5h4.5a.9.9 0 1 1 0 1.8H3.9a.9.9 0 0 1-.9-.9v-5.4a.9.9 0 0 1 .9-.9z"
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.736 3.264a.9.9 0 0 1 0 1.272l-6.3 6.3a.9.9 0 1 1-1.272-1.272l6.3-6.3a.9.9 0 0 1 1.272 0zm-9.9 9.9a.9.9 0 0 1 0 1.272l-6.3 6.3a.9.9 0 1 1-1.272-1.272l6.3-6.3a.9.9 0 0 1 1.272 0z"
  })]
});
const SvgMinimize = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.875c0-.483.392-.875.875-.875h5.25c.483 0 .875.392.875.875v5.25a.875.875 0 0 1-1.75 0V14.75H4.875A.875.875 0 0 1 4 13.875zM13.875 4c.483 0 .875.392.875.875V9.25h4.375a.875.875 0 0 1 0 1.75h-5.25a.875.875 0 0 1-.875-.875v-5.25c0-.483.392-.875.875-.875z"
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.74 3.26a.889.889 0 0 1 0 1.257l-6.223 6.223a.889.889 0 0 1-1.257-1.257l6.223-6.223a.889.889 0 0 1 1.257 0zm-10 10a.889.889 0 0 1 0 1.257L4.517 20.74a.889.889 0 0 1-1.257-1.257l6.223-6.223a.889.889 0 0 1 1.257 0z"
  })]
});
const SvgMinus = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 2",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "data-testid": "test-icon",
  "aria-hidden": "true",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "M5 0h2v2H5V0Z"
  }), /* @__PURE__ */ jsx$1("path", {
    d: "M12 0v2H0V0h12Z"
  })]
});
const SvgPlus = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  "data-testid": "test-icon",
  "aria-hidden": "true",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "M24 10H14V0h-4v10H0v4h10v10h4V14h10z"
  })]
});
const SvgSearch = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.875a6.125 6.125 0 1 0 0 12.25 6.125 6.125 0 0 0 0-12.25zM3.125 11a7.875 7.875 0 1 1 15.75 0 7.875 7.875 0 0 1-15.75 0z"
  }), /* @__PURE__ */ jsx$1("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.381 15.381a.875.875 0 0 1 1.238 0l4 4a.875.875 0 1 1-1.238 1.238l-4-4a.875.875 0 0 1 0-1.238z"
  })]
});
const SvgTriangleDown = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "m11.646 16.646-4.792-4.792A.5.5 0 0 1 7.207 11h9.586a.5.5 0 0 1 .353.854l-4.792 4.792a.5.5 0 0 1-.708 0z"
  })]
});
const SvgTriangleUp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs$1("svg", {
  "aria-hidden": "true",
  "data-testid": "test-icon",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId,
  ...props,
  children: [title ? /* @__PURE__ */ jsx$1("title", {
    id: titleId,
    children: title
  }) : null, /* @__PURE__ */ jsx$1("path", {
    d: "m11.646 9.354-4.792 4.792a.5.5 0 0 0 .353.854h9.586a.5.5 0 0 0 .353-.854l-4.792-4.792a.5.5 0 0 0-.708 0z"
  })]
});
var reactIs$5 = { exports: {} };
var reactIs_production_min$3 = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$5 = Symbol.for("react.element"), c$3 = Symbol.for("react.portal"), d$3 = Symbol.for("react.fragment"), e$3 = Symbol.for("react.strict_mode"), f$4 = Symbol.for("react.profiler"), g$5 = Symbol.for("react.provider"), h$3 = Symbol.for("react.context"), k$6 = Symbol.for("react.server_context"), l$5 = Symbol.for("react.forward_ref"), m$4 = Symbol.for("react.suspense"), n$5 = Symbol.for("react.suspense_list"), p$5 = Symbol.for("react.memo"), q$7 = Symbol.for("react.lazy"), t$4 = Symbol.for("react.offscreen"), u$2;
u$2 = Symbol.for("react.module.reference");
function v$6(a) {
  if (typeof a === "object" && a !== null) {
    var r2 = a.$$typeof;
    switch (r2) {
      case b$5:
        switch (a = a.type, a) {
          case d$3:
          case f$4:
          case e$3:
          case m$4:
          case n$5:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$6:
              case h$3:
              case l$5:
              case q$7:
              case p$5:
              case g$5:
                return a;
              default:
                return r2;
            }
        }
      case c$3:
        return r2;
    }
  }
}
reactIs_production_min$3.ContextConsumer = h$3;
reactIs_production_min$3.ContextProvider = g$5;
reactIs_production_min$3.Element = b$5;
reactIs_production_min$3.ForwardRef = l$5;
reactIs_production_min$3.Fragment = d$3;
reactIs_production_min$3.Lazy = q$7;
reactIs_production_min$3.Memo = p$5;
reactIs_production_min$3.Portal = c$3;
reactIs_production_min$3.Profiler = f$4;
reactIs_production_min$3.StrictMode = e$3;
reactIs_production_min$3.Suspense = m$4;
reactIs_production_min$3.SuspenseList = n$5;
reactIs_production_min$3.isAsyncMode = function() {
  return false;
};
reactIs_production_min$3.isConcurrentMode = function() {
  return false;
};
reactIs_production_min$3.isContextConsumer = function(a) {
  return v$6(a) === h$3;
};
reactIs_production_min$3.isContextProvider = function(a) {
  return v$6(a) === g$5;
};
reactIs_production_min$3.isElement = function(a) {
  return typeof a === "object" && a !== null && a.$$typeof === b$5;
};
reactIs_production_min$3.isForwardRef = function(a) {
  return v$6(a) === l$5;
};
reactIs_production_min$3.isFragment = function(a) {
  return v$6(a) === d$3;
};
reactIs_production_min$3.isLazy = function(a) {
  return v$6(a) === q$7;
};
reactIs_production_min$3.isMemo = function(a) {
  return v$6(a) === p$5;
};
reactIs_production_min$3.isPortal = function(a) {
  return v$6(a) === c$3;
};
reactIs_production_min$3.isProfiler = function(a) {
  return v$6(a) === f$4;
};
reactIs_production_min$3.isStrictMode = function(a) {
  return v$6(a) === e$3;
};
reactIs_production_min$3.isSuspense = function(a) {
  return v$6(a) === m$4;
};
reactIs_production_min$3.isSuspenseList = function(a) {
  return v$6(a) === n$5;
};
reactIs_production_min$3.isValidElementType = function(a) {
  return typeof a === "string" || typeof a === "function" || a === d$3 || a === f$4 || a === e$3 || a === m$4 || a === n$5 || a === t$4 || typeof a === "object" && a !== null && (a.$$typeof === q$7 || a.$$typeof === p$5 || a.$$typeof === g$5 || a.$$typeof === h$3 || a.$$typeof === l$5 || a.$$typeof === u$2 || a.getModuleId !== void 0) ? true : false;
};
reactIs_production_min$3.typeOf = v$6;
{
  reactIs$5.exports = reactIs_production_min$3;
}
function stylis_min$1(W2) {
  function M2(d2, c2, e2, h6, a) {
    for (var m2 = 0, b2 = 0, v2 = 0, n2 = 0, q2, g2, x2 = 0, K2 = 0, k2, u2 = k2 = q2 = 0, l2 = 0, r2 = 0, I2 = 0, t2 = 0, B3 = e2.length, J2 = B3 - 1, y2, f2 = "", p2 = "", F3 = "", G3 = "", C2; l2 < B3; ) {
      g2 = e2.charCodeAt(l2);
      l2 === J2 && b2 + n2 + v2 + m2 !== 0 && (b2 !== 0 && (g2 = b2 === 47 ? 10 : 47), n2 = v2 = m2 = 0, B3++, J2++);
      if (b2 + n2 + v2 + m2 === 0) {
        if (l2 === J2 && (0 < r2 && (f2 = f2.replace(N2, "")), 0 < f2.trim().length)) {
          switch (g2) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f2 += e2.charAt(l2);
          }
          g2 = 59;
        }
        switch (g2) {
          case 123:
            f2 = f2.trim();
            q2 = f2.charCodeAt(0);
            k2 = 1;
            for (t2 = ++l2; l2 < B3; ) {
              switch (g2 = e2.charCodeAt(l2)) {
                case 123:
                  k2++;
                  break;
                case 125:
                  k2--;
                  break;
                case 47:
                  switch (g2 = e2.charCodeAt(l2 + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u2 = l2 + 1; u2 < J2; ++u2) {
                          switch (e2.charCodeAt(u2)) {
                            case 47:
                              if (g2 === 42 && e2.charCodeAt(u2 - 1) === 42 && l2 + 2 !== u2) {
                                l2 = u2 + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (g2 === 47) {
                                l2 = u2 + 1;
                                break a;
                              }
                          }
                        }
                        l2 = u2;
                      }
                  }
                  break;
                case 91:
                  g2++;
                case 40:
                  g2++;
                case 34:
                case 39:
                  for (; l2++ < J2 && e2.charCodeAt(l2) !== g2; ) {
                  }
              }
              if (k2 === 0)
                break;
              l2++;
            }
            k2 = e2.substring(t2, l2);
            q2 === 0 && (q2 = (f2 = f2.replace(ca, "").trim()).charCodeAt(0));
            switch (q2) {
              case 64:
                0 < r2 && (f2 = f2.replace(N2, ""));
                g2 = f2.charCodeAt(1);
                switch (g2) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r2 = c2;
                    break;
                  default:
                    r2 = O2;
                }
                k2 = M2(c2, r2, k2, g2, a + 1);
                t2 = k2.length;
                0 < A2 && (r2 = X2(O2, f2, I2), C2 = H2(3, k2, r2, c2, D2, z2, t2, g2, a, h6), f2 = r2.join(""), C2 !== void 0 && (t2 = (k2 = C2.trim()).length) === 0 && (g2 = 0, k2 = ""));
                if (0 < t2)
                  switch (g2) {
                    case 115:
                      f2 = f2.replace(da, ea);
                    case 100:
                    case 109:
                    case 45:
                      k2 = f2 + "{" + k2 + "}";
                      break;
                    case 107:
                      f2 = f2.replace(fa, "$1 $2");
                      k2 = f2 + "{" + k2 + "}";
                      k2 = w2 === 1 || w2 === 2 && L2("@" + k2, 3) ? "@-webkit-" + k2 + "@" + k2 : "@" + k2;
                      break;
                    default:
                      k2 = f2 + k2, h6 === 112 && (k2 = (p2 += k2, ""));
                  }
                else
                  k2 = "";
                break;
              default:
                k2 = M2(c2, X2(c2, f2, I2), k2, h6, a + 1);
            }
            F3 += k2;
            k2 = I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e2.charCodeAt(++l2);
            break;
          case 125:
          case 59:
            f2 = (0 < r2 ? f2.replace(N2, "") : f2).trim();
            if (1 < (t2 = f2.length))
              switch (u2 === 0 && (q2 = f2.charCodeAt(0), q2 === 45 || 96 < q2 && 123 > q2) && (t2 = (f2 = f2.replace(" ", ":")).length), 0 < A2 && (C2 = H2(1, f2, c2, d2, D2, z2, p2.length, h6, a, h6)) !== void 0 && (t2 = (f2 = C2.trim()).length) === 0 && (f2 = "\0\0"), q2 = f2.charCodeAt(0), g2 = f2.charCodeAt(1), q2) {
                case 0:
                  break;
                case 64:
                  if (g2 === 105 || g2 === 99) {
                    G3 += f2 + e2.charAt(l2);
                    break;
                  }
                default:
                  f2.charCodeAt(t2 - 1) !== 58 && (p2 += P2(f2, q2, g2, f2.charCodeAt(2)));
              }
            I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e2.charCodeAt(++l2);
        }
      }
      switch (g2) {
        case 13:
        case 10:
          b2 === 47 ? b2 = 0 : 1 + q2 === 0 && h6 !== 107 && 0 < f2.length && (r2 = 1, f2 += "\0");
          0 < A2 * Y2 && H2(0, f2, c2, d2, D2, z2, p2.length, h6, a, h6);
          z2 = 1;
          D2++;
          break;
        case 59:
        case 125:
          if (b2 + n2 + v2 + m2 === 0) {
            z2++;
            break;
          }
        default:
          z2++;
          y2 = e2.charAt(l2);
          switch (g2) {
            case 9:
            case 32:
              if (n2 + m2 + b2 === 0)
                switch (x2) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y2 = "";
                    break;
                  default:
                    g2 !== 32 && (y2 = " ");
                }
              break;
            case 0:
              y2 = "\\0";
              break;
            case 12:
              y2 = "\\f";
              break;
            case 11:
              y2 = "\\v";
              break;
            case 38:
              n2 + b2 + m2 === 0 && (r2 = I2 = 1, y2 = "\f" + y2);
              break;
            case 108:
              if (n2 + b2 + m2 + E2 === 0 && 0 < u2)
                switch (l2 - u2) {
                  case 2:
                    x2 === 112 && e2.charCodeAt(l2 - 3) === 58 && (E2 = x2);
                  case 8:
                    K2 === 111 && (E2 = K2);
                }
              break;
            case 58:
              n2 + b2 + m2 === 0 && (u2 = l2);
              break;
            case 44:
              b2 + v2 + n2 + m2 === 0 && (r2 = 1, y2 += "\r");
              break;
            case 34:
            case 39:
              b2 === 0 && (n2 = n2 === g2 ? 0 : n2 === 0 ? g2 : n2);
              break;
            case 91:
              n2 + b2 + v2 === 0 && m2++;
              break;
            case 93:
              n2 + b2 + v2 === 0 && m2--;
              break;
            case 41:
              n2 + b2 + m2 === 0 && v2--;
              break;
            case 40:
              if (n2 + b2 + m2 === 0) {
                if (q2 === 0)
                  switch (2 * x2 + 3 * K2) {
                    case 533:
                      break;
                    default:
                      q2 = 1;
                  }
                v2++;
              }
              break;
            case 64:
              b2 + v2 + n2 + m2 + u2 + k2 === 0 && (k2 = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n2 + m2 + v2))
                switch (b2) {
                  case 0:
                    switch (2 * g2 + 3 * e2.charCodeAt(l2 + 1)) {
                      case 235:
                        b2 = 47;
                        break;
                      case 220:
                        t2 = l2, b2 = 42;
                    }
                    break;
                  case 42:
                    g2 === 47 && x2 === 42 && t2 + 2 !== l2 && (e2.charCodeAt(t2 + 2) === 33 && (p2 += e2.substring(t2, l2 + 1)), y2 = "", b2 = 0);
                }
          }
          b2 === 0 && (f2 += y2);
      }
      K2 = x2;
      x2 = g2;
      l2++;
    }
    t2 = p2.length;
    if (0 < t2) {
      r2 = c2;
      if (0 < A2 && (C2 = H2(2, p2, r2, d2, D2, z2, t2, h6, a, h6), C2 !== void 0 && (p2 = C2).length === 0))
        return G3 + p2 + F3;
      p2 = r2.join(",") + "{" + p2 + "}";
      if (w2 * E2 !== 0) {
        w2 !== 2 || L2(p2, 2) || (E2 = 0);
        switch (E2) {
          case 111:
            p2 = p2.replace(ha, ":-moz-$1") + p2;
            break;
          case 112:
            p2 = p2.replace(Q2, "::-webkit-input-$1") + p2.replace(Q2, "::-moz-$1") + p2.replace(Q2, ":-ms-input-$1") + p2;
        }
        E2 = 0;
      }
    }
    return G3 + p2 + F3;
  }
  function X2(d2, c2, e2) {
    var h6 = c2.trim().split(ia);
    c2 = h6;
    var a = h6.length, m2 = d2.length;
    switch (m2) {
      case 0:
      case 1:
        var b2 = 0;
        for (d2 = m2 === 0 ? "" : d2[0] + " "; b2 < a; ++b2) {
          c2[b2] = Z2(d2, c2[b2], e2).trim();
        }
        break;
      default:
        var v2 = b2 = 0;
        for (c2 = []; b2 < a; ++b2) {
          for (var n2 = 0; n2 < m2; ++n2) {
            c2[v2++] = Z2(d2[n2] + " ", h6[b2], e2).trim();
          }
        }
    }
    return c2;
  }
  function Z2(d2, c2, e2) {
    var h6 = c2.charCodeAt(0);
    33 > h6 && (h6 = (c2 = c2.trim()).charCodeAt(0));
    switch (h6) {
      case 38:
        return c2.replace(F2, "$1" + d2.trim());
      case 58:
        return d2.trim() + c2.replace(F2, "$1" + d2.trim());
      default:
        if (0 < 1 * e2 && 0 < c2.indexOf("\f"))
          return c2.replace(F2, (d2.charCodeAt(0) === 58 ? "" : "$1") + d2.trim());
    }
    return d2 + c2;
  }
  function P2(d2, c2, e2, h6) {
    var a = d2 + ";", m2 = 2 * c2 + 3 * e2 + 4 * h6;
    if (m2 === 944) {
      d2 = a.indexOf(":", 9) + 1;
      var b2 = a.substring(d2, a.length - 1).trim();
      b2 = a.substring(0, d2).trim() + b2 + ";";
      return w2 === 1 || w2 === 2 && L2(b2, 1) ? "-webkit-" + b2 + b2 : b2;
    }
    if (w2 === 0 || w2 === 2 && !L2(a, 1))
      return a;
    switch (m2) {
      case 1015:
        return a.charCodeAt(10) === 97 ? "-webkit-" + a + a : a;
      case 951:
        return a.charCodeAt(3) === 116 ? "-webkit-" + a + a : a;
      case 963:
        return a.charCodeAt(5) === 110 ? "-webkit-" + a + a : a;
      case 1009:
        if (a.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (a.charCodeAt(8) === 45)
          return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11))
          return a.replace(ja, "$1-webkit-$2") + a;
        break;
      case 932:
        if (a.charCodeAt(4) === 45)
          switch (a.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
            case 115:
              return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
            case 98:
              return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
          }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (a.charCodeAt(8) !== 99)
          break;
        b2 = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b2 + "-webkit-" + a + "-ms-flex-pack" + b2 + a;
      case 1005:
        return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
      case 1e3:
        b2 = a.substring(13).trim();
        c2 = b2.indexOf("-") + 1;
        switch (b2.charCodeAt(0) + b2.charCodeAt(c2)) {
          case 226:
            b2 = a.replace(G2, "tb");
            break;
          case 232:
            b2 = a.replace(G2, "tb-rl");
            break;
          case 220:
            b2 = a.replace(G2, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + b2 + a;
      case 1017:
        if (a.indexOf("sticky", 9) === -1)
          break;
      case 975:
        c2 = (a = d2).length - 10;
        b2 = (a.charCodeAt(c2) === 33 ? a.substring(0, c2) : a).substring(d2.indexOf(":", 7) + 1).trim();
        switch (m2 = b2.charCodeAt(0) + (b2.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b2.charCodeAt(8))
              break;
          case 115:
            a = a.replace(b2, "-webkit-" + b2) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(b2, "-webkit-" + (102 < m2 ? "inline-" : "") + "box") + ";" + a.replace(b2, "-webkit-" + b2) + ";" + a.replace(b2, "-ms-" + b2 + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (a.charCodeAt(5) === 45)
          switch (a.charCodeAt(6)) {
            case 105:
              return b2 = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b2 + "-ms-flex-" + b2 + a;
            case 115:
              return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
            default:
              return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
          }
        break;
      case 973:
      case 989:
        if (a.charCodeAt(3) !== 45 || a.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (la.test(d2) === true)
          return (b2 = d2.substring(d2.indexOf(":") + 1)).charCodeAt(0) === 115 ? P2(d2.replace("stretch", "fill-available"), c2, e2, h6).replace(":fill-available", ":stretch") : a.replace(b2, "-webkit-" + b2) + a.replace(b2, "-moz-" + b2.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (a.charCodeAt(5) === 102 ? "-ms-" + a : "") + a, e2 + h6 === 211 && a.charCodeAt(13) === 105 && 0 < a.indexOf("transform", 10))
          return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
    }
    return a;
  }
  function L2(d2, c2) {
    var e2 = d2.indexOf(c2 === 1 ? ":" : "{"), h6 = d2.substring(0, c2 !== 3 ? e2 : 10);
    e2 = d2.substring(e2 + 1, d2.length - 1);
    return R2(c2 !== 2 ? h6 : h6.replace(na, "$1"), e2, c2);
  }
  function ea(d2, c2) {
    var e2 = P2(c2, c2.charCodeAt(0), c2.charCodeAt(1), c2.charCodeAt(2));
    return e2 !== c2 + ";" ? e2.replace(oa, " or ($1)").substring(4) : "(" + c2 + ")";
  }
  function H2(d2, c2, e2, h6, a, m2, b2, v2, n2, q2) {
    for (var g2 = 0, x2 = c2, w3; g2 < A2; ++g2) {
      switch (w3 = S2[g2].call(B2, d2, x2, e2, h6, a, m2, b2, v2, n2, q2)) {
        case void 0:
        case false:
        case true:
        case null:
          break;
        default:
          x2 = w3;
      }
    }
    if (x2 !== c2)
      return x2;
  }
  function T2(d2) {
    switch (d2) {
      case void 0:
      case null:
        A2 = S2.length = 0;
        break;
      default:
        if (typeof d2 === "function")
          S2[A2++] = d2;
        else if (typeof d2 === "object")
          for (var c2 = 0, e2 = d2.length; c2 < e2; ++c2) {
            T2(d2[c2]);
          }
        else
          Y2 = !!d2 | 0;
    }
    return T2;
  }
  function U2(d2) {
    d2 = d2.prefix;
    d2 !== void 0 && (R2 = null, d2 ? typeof d2 !== "function" ? w2 = 1 : (w2 = 2, R2 = d2) : w2 = 0);
    return U2;
  }
  function B2(d2, c2) {
    var e2 = d2;
    33 > e2.charCodeAt(0) && (e2 = e2.trim());
    V2 = e2;
    e2 = [V2];
    if (0 < A2) {
      var h6 = H2(-1, c2, e2, e2, D2, z2, 0, 0, 0, 0);
      h6 !== void 0 && typeof h6 === "string" && (c2 = h6);
    }
    var a = M2(O2, e2, c2, 0, 0);
    0 < A2 && (h6 = H2(-2, a, e2, e2, D2, z2, a.length, 0, 0, 0), h6 !== void 0 && (a = h6));
    V2 = "";
    E2 = 0;
    z2 = D2 = 1;
    return a;
  }
  var ca = /^\0+/g, N2 = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F2 = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q2 = /::(place)/g, ha = /:(read-only)/g, G2 = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z2 = 1, D2 = 1, E2 = 0, w2 = 1, O2 = [], S2 = [], A2 = 0, R2 = null, Y2 = 0, V2 = "";
  B2.use = T2;
  B2.set = U2;
  W2 !== void 0 && U2(W2);
  return B2;
}
var unitlessKeys$1 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize$1(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var reactPropsRegex$1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid$1 = /* @__PURE__ */ memoize$1(function(prop) {
  return reactPropsRegex$1.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var reactIs$4 = { exports: {} };
var reactIs_production_min$2 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$4 = typeof Symbol === "function" && Symbol.for, c$2 = b$4 ? Symbol.for("react.element") : 60103, d$2 = b$4 ? Symbol.for("react.portal") : 60106, e$2 = b$4 ? Symbol.for("react.fragment") : 60107, f$3 = b$4 ? Symbol.for("react.strict_mode") : 60108, g$4 = b$4 ? Symbol.for("react.profiler") : 60114, h$2 = b$4 ? Symbol.for("react.provider") : 60109, k$5 = b$4 ? Symbol.for("react.context") : 60110, l$4 = b$4 ? Symbol.for("react.async_mode") : 60111, m$3 = b$4 ? Symbol.for("react.concurrent_mode") : 60111, n$4 = b$4 ? Symbol.for("react.forward_ref") : 60112, p$4 = b$4 ? Symbol.for("react.suspense") : 60113, q$6 = b$4 ? Symbol.for("react.suspense_list") : 60120, r$3 = b$4 ? Symbol.for("react.memo") : 60115, t$3 = b$4 ? Symbol.for("react.lazy") : 60116, v$5 = b$4 ? Symbol.for("react.block") : 60121, w$4 = b$4 ? Symbol.for("react.fundamental") : 60117, x$4 = b$4 ? Symbol.for("react.responder") : 60118, y$2 = b$4 ? Symbol.for("react.scope") : 60119;
function z$4(a) {
  if (typeof a === "object" && a !== null) {
    var u2 = a.$$typeof;
    switch (u2) {
      case c$2:
        switch (a = a.type, a) {
          case l$4:
          case m$3:
          case e$2:
          case g$4:
          case f$3:
          case p$4:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$5:
              case n$4:
              case t$3:
              case r$3:
              case h$2:
                return a;
              default:
                return u2;
            }
        }
      case d$2:
        return u2;
    }
  }
}
function A$4(a) {
  return z$4(a) === m$3;
}
reactIs_production_min$2.AsyncMode = l$4;
reactIs_production_min$2.ConcurrentMode = m$3;
reactIs_production_min$2.ContextConsumer = k$5;
reactIs_production_min$2.ContextProvider = h$2;
reactIs_production_min$2.Element = c$2;
reactIs_production_min$2.ForwardRef = n$4;
reactIs_production_min$2.Fragment = e$2;
reactIs_production_min$2.Lazy = t$3;
reactIs_production_min$2.Memo = r$3;
reactIs_production_min$2.Portal = d$2;
reactIs_production_min$2.Profiler = g$4;
reactIs_production_min$2.StrictMode = f$3;
reactIs_production_min$2.Suspense = p$4;
reactIs_production_min$2.isAsyncMode = function(a) {
  return A$4(a) || z$4(a) === l$4;
};
reactIs_production_min$2.isConcurrentMode = A$4;
reactIs_production_min$2.isContextConsumer = function(a) {
  return z$4(a) === k$5;
};
reactIs_production_min$2.isContextProvider = function(a) {
  return z$4(a) === h$2;
};
reactIs_production_min$2.isElement = function(a) {
  return typeof a === "object" && a !== null && a.$$typeof === c$2;
};
reactIs_production_min$2.isForwardRef = function(a) {
  return z$4(a) === n$4;
};
reactIs_production_min$2.isFragment = function(a) {
  return z$4(a) === e$2;
};
reactIs_production_min$2.isLazy = function(a) {
  return z$4(a) === t$3;
};
reactIs_production_min$2.isMemo = function(a) {
  return z$4(a) === r$3;
};
reactIs_production_min$2.isPortal = function(a) {
  return z$4(a) === d$2;
};
reactIs_production_min$2.isProfiler = function(a) {
  return z$4(a) === g$4;
};
reactIs_production_min$2.isStrictMode = function(a) {
  return z$4(a) === f$3;
};
reactIs_production_min$2.isSuspense = function(a) {
  return z$4(a) === p$4;
};
reactIs_production_min$2.isValidElementType = function(a) {
  return typeof a === "string" || typeof a === "function" || a === e$2 || a === m$3 || a === g$4 || a === f$3 || a === p$4 || a === q$6 || typeof a === "object" && a !== null && (a.$$typeof === t$3 || a.$$typeof === r$3 || a.$$typeof === h$2 || a.$$typeof === k$5 || a.$$typeof === n$4 || a.$$typeof === w$4 || a.$$typeof === x$4 || a.$$typeof === y$2 || a.$$typeof === v$5);
};
reactIs_production_min$2.typeOf = z$4;
{
  reactIs$4.exports = reactIs_production_min$2;
}
var reactIs$3 = reactIs$4.exports;
var REACT_STATICS$1 = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS$1 = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS$1 = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS$1 = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS$1 = {};
TYPE_STATICS$1[reactIs$3.ForwardRef] = FORWARD_REF_STATICS$1;
TYPE_STATICS$1[reactIs$3.Memo] = MEMO_STATICS$1;
function getStatics$1(component) {
  if (reactIs$3.isMemo(component)) {
    return MEMO_STATICS$1;
  }
  return TYPE_STATICS$1[component["$$typeof"]] || REACT_STATICS$1;
}
var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames$1 = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf;
var objectPrototype$1 = Object.prototype;
function hoistNonReactStatics$1(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== "string") {
    if (objectPrototype$1) {
      var inheritedComponent = getPrototypeOf$1(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype$1) {
        hoistNonReactStatics$1(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames$1(sourceComponent);
    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }
    var targetStatics = getStatics$1(targetComponent);
    var sourceStatics = getStatics$1(sourceComponent);
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];
      if (!KNOWN_STATICS$1[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$1(sourceComponent, key);
        try {
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e2) {
        }
      }
    }
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs$1 = hoistNonReactStatics$1;
function v$4() {
  return (v$4 = Object.assign || function(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var n2 = arguments[t2];
      for (var r2 in n2)
        Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
    }
    return e2;
  }).apply(this, arguments);
}
var g$3 = function(e2, t2) {
  for (var n2 = [e2[0]], r2 = 0, o = t2.length; r2 < o; r2 += 1)
    n2.push(t2[r2], e2[r2 + 1]);
  return n2;
}, S$2 = function(t2) {
  return t2 !== null && typeof t2 == "object" && (t2.toString ? t2.toString() : Object.prototype.toString.call(t2)) === "[object Object]" && !reactIs$5.exports.typeOf(t2);
}, w$3 = Object.freeze([]), E$2 = Object.freeze({});
function b$3(e2) {
  return typeof e2 == "function";
}
function _$1(e2) {
  return e2.displayName || e2.name || "Component";
}
function N$2(e2) {
  return e2 && typeof e2.styledComponentId == "string";
}
var A$3 = typeof process != "undefined" && ({}.REACT_APP_SC_ATTR || {}.SC_ATTR) || "data-styled", I$2 = typeof window != "undefined" && "HTMLElement" in window, P$2 = Boolean(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process != "undefined" && {}.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && {}.REACT_APP_SC_DISABLE_SPEEDY !== "" ? {}.REACT_APP_SC_DISABLE_SPEEDY !== "false" && {}.REACT_APP_SC_DISABLE_SPEEDY : typeof process != "undefined" && {}.SC_DISABLE_SPEEDY !== void 0 && {}.SC_DISABLE_SPEEDY !== "" ? {}.SC_DISABLE_SPEEDY !== "false" && {}.SC_DISABLE_SPEEDY : false);
function j$1(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  throw new Error("An error occurred. See https://git.io/JUIaE#" + e2 + " for more information." + (n2.length > 0 ? " Args: " + n2.join(", ") : ""));
}
var T$2 = function() {
  function e2(e3) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e3;
  }
  var t2 = e2.prototype;
  return t2.indexOfGroup = function(e3) {
    for (var t3 = 0, n2 = 0; n2 < e3; n2++)
      t3 += this.groupSizes[n2];
    return t3;
  }, t2.insertRules = function(e3, t3) {
    if (e3 >= this.groupSizes.length) {
      for (var n2 = this.groupSizes, r2 = n2.length, o = r2; e3 >= o; )
        (o <<= 1) < 0 && j$1(16, "" + e3);
      this.groupSizes = new Uint32Array(o), this.groupSizes.set(n2), this.length = o;
      for (var s = r2; s < o; s++)
        this.groupSizes[s] = 0;
    }
    for (var i = this.indexOfGroup(e3 + 1), a = 0, c2 = t3.length; a < c2; a++)
      this.tag.insertRule(i, t3[a]) && (this.groupSizes[e3]++, i++);
  }, t2.clearGroup = function(e3) {
    if (e3 < this.length) {
      var t3 = this.groupSizes[e3], n2 = this.indexOfGroup(e3), r2 = n2 + t3;
      this.groupSizes[e3] = 0;
      for (var o = n2; o < r2; o++)
        this.tag.deleteRule(n2);
    }
  }, t2.getGroup = function(e3) {
    var t3 = "";
    if (e3 >= this.length || this.groupSizes[e3] === 0)
      return t3;
    for (var n2 = this.groupSizes[e3], r2 = this.indexOfGroup(e3), o = r2 + n2, s = r2; s < o; s++)
      t3 += this.tag.getRule(s) + "/*!sc*/\n";
    return t3;
  }, e2;
}(), x$3 = /* @__PURE__ */ new Map(), k$4 = /* @__PURE__ */ new Map(), V$2 = 1, B$2 = function(e2) {
  if (x$3.has(e2))
    return x$3.get(e2);
  for (; k$4.has(V$2); )
    V$2++;
  var t2 = V$2++;
  return x$3.set(e2, t2), k$4.set(t2, e2), t2;
}, z$3 = function(e2) {
  return k$4.get(e2);
}, M$2 = function(e2, t2) {
  t2 >= V$2 && (V$2 = t2 + 1), x$3.set(e2, t2), k$4.set(t2, e2);
}, G$2 = "style[" + A$3 + '][data-styled-version="5.3.5"]', L$2 = new RegExp("^" + A$3 + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), F$2 = function(e2, t2, n2) {
  for (var r2, o = n2.split(","), s = 0, i = o.length; s < i; s++)
    (r2 = o[s]) && e2.registerName(t2, r2);
}, Y$1 = function(e2, t2) {
  for (var n2 = (t2.textContent || "").split("/*!sc*/\n"), r2 = [], o = 0, s = n2.length; o < s; o++) {
    var i = n2[o].trim();
    if (i) {
      var a = i.match(L$2);
      if (a) {
        var c2 = 0 | parseInt(a[1], 10), u2 = a[2];
        c2 !== 0 && (M$2(u2, c2), F$2(e2, u2, a[3]), e2.getTag().insertRules(c2, r2)), r2.length = 0;
      } else
        r2.push(i);
    }
  }
}, q$5 = function() {
  return typeof window != "undefined" && window.__webpack_nonce__ !== void 0 ? window.__webpack_nonce__ : null;
}, H$2 = function(e2) {
  var t2 = document.head, n2 = e2 || t2, r2 = document.createElement("style"), o = function(e3) {
    for (var t3 = e3.childNodes, n3 = t3.length; n3 >= 0; n3--) {
      var r3 = t3[n3];
      if (r3 && r3.nodeType === 1 && r3.hasAttribute(A$3))
        return r3;
    }
  }(n2), s = o !== void 0 ? o.nextSibling : null;
  r2.setAttribute(A$3, "active"), r2.setAttribute("data-styled-version", "5.3.5");
  var i = q$5();
  return i && r2.setAttribute("nonce", i), n2.insertBefore(r2, s), r2;
}, $$1 = function() {
  function e2(e3) {
    var t3 = this.element = H$2(e3);
    t3.appendChild(document.createTextNode("")), this.sheet = function(e4) {
      if (e4.sheet)
        return e4.sheet;
      for (var t4 = document.styleSheets, n2 = 0, r2 = t4.length; n2 < r2; n2++) {
        var o = t4[n2];
        if (o.ownerNode === e4)
          return o;
      }
      j$1(17);
    }(t3), this.length = 0;
  }
  var t2 = e2.prototype;
  return t2.insertRule = function(e3, t3) {
    try {
      return this.sheet.insertRule(t3, e3), this.length++, true;
    } catch (e4) {
      return false;
    }
  }, t2.deleteRule = function(e3) {
    this.sheet.deleteRule(e3), this.length--;
  }, t2.getRule = function(e3) {
    var t3 = this.sheet.cssRules[e3];
    return t3 !== void 0 && typeof t3.cssText == "string" ? t3.cssText : "";
  }, e2;
}(), W$2 = function() {
  function e2(e3) {
    var t3 = this.element = H$2(e3);
    this.nodes = t3.childNodes, this.length = 0;
  }
  var t2 = e2.prototype;
  return t2.insertRule = function(e3, t3) {
    if (e3 <= this.length && e3 >= 0) {
      var n2 = document.createTextNode(t3), r2 = this.nodes[e3];
      return this.element.insertBefore(n2, r2 || null), this.length++, true;
    }
    return false;
  }, t2.deleteRule = function(e3) {
    this.element.removeChild(this.nodes[e3]), this.length--;
  }, t2.getRule = function(e3) {
    return e3 < this.length ? this.nodes[e3].textContent : "";
  }, e2;
}(), U$2 = function() {
  function e2(e3) {
    this.rules = [], this.length = 0;
  }
  var t2 = e2.prototype;
  return t2.insertRule = function(e3, t3) {
    return e3 <= this.length && (this.rules.splice(e3, 0, t3), this.length++, true);
  }, t2.deleteRule = function(e3) {
    this.rules.splice(e3, 1), this.length--;
  }, t2.getRule = function(e3) {
    return e3 < this.length ? this.rules[e3] : "";
  }, e2;
}(), J$2 = I$2, X$1 = { isServer: !I$2, useCSSOMInjection: !P$2 }, Z$1 = function() {
  function e2(e3, t3, n2) {
    e3 === void 0 && (e3 = E$2), t3 === void 0 && (t3 = {}), this.options = v$4({}, X$1, {}, e3), this.gs = t3, this.names = new Map(n2), this.server = !!e3.isServer, !this.server && I$2 && J$2 && (J$2 = false, function(e4) {
      for (var t4 = document.querySelectorAll(G$2), n3 = 0, r2 = t4.length; n3 < r2; n3++) {
        var o = t4[n3];
        o && o.getAttribute(A$3) !== "active" && (Y$1(e4, o), o.parentNode && o.parentNode.removeChild(o));
      }
    }(this));
  }
  e2.registerId = function(e3) {
    return B$2(e3);
  };
  var t2 = e2.prototype;
  return t2.reconstructWithOptions = function(t3, n2) {
    return n2 === void 0 && (n2 = true), new e2(v$4({}, this.options, {}, t3), this.gs, n2 && this.names || void 0);
  }, t2.allocateGSInstance = function(e3) {
    return this.gs[e3] = (this.gs[e3] || 0) + 1;
  }, t2.getTag = function() {
    return this.tag || (this.tag = (n2 = (t3 = this.options).isServer, r2 = t3.useCSSOMInjection, o = t3.target, e3 = n2 ? new U$2(o) : r2 ? new $$1(o) : new W$2(o), new T$2(e3)));
    var e3, t3, n2, r2, o;
  }, t2.hasNameForId = function(e3, t3) {
    return this.names.has(e3) && this.names.get(e3).has(t3);
  }, t2.registerName = function(e3, t3) {
    if (B$2(e3), this.names.has(e3))
      this.names.get(e3).add(t3);
    else {
      var n2 = /* @__PURE__ */ new Set();
      n2.add(t3), this.names.set(e3, n2);
    }
  }, t2.insertRules = function(e3, t3, n2) {
    this.registerName(e3, t3), this.getTag().insertRules(B$2(e3), n2);
  }, t2.clearNames = function(e3) {
    this.names.has(e3) && this.names.get(e3).clear();
  }, t2.clearRules = function(e3) {
    this.getTag().clearGroup(B$2(e3)), this.clearNames(e3);
  }, t2.clearTag = function() {
    this.tag = void 0;
  }, t2.toString = function() {
    return function(e3) {
      for (var t3 = e3.getTag(), n2 = t3.length, r2 = "", o = 0; o < n2; o++) {
        var s = z$3(o);
        if (s !== void 0) {
          var i = e3.names.get(s), a = t3.getGroup(o);
          if (i && a && i.size) {
            var c2 = A$3 + ".g" + o + '[id="' + s + '"]', u2 = "";
            i !== void 0 && i.forEach(function(e4) {
              e4.length > 0 && (u2 += e4 + ",");
            }), r2 += "" + a + c2 + '{content:"' + u2 + '"}/*!sc*/\n';
          }
        }
      }
      return r2;
    }(this);
  }, e2;
}(), K$2 = /(a)(d)/gi, Q$2 = function(e2) {
  return String.fromCharCode(e2 + (e2 > 25 ? 39 : 97));
};
function ee$1(e2) {
  var t2, n2 = "";
  for (t2 = Math.abs(e2); t2 > 52; t2 = t2 / 52 | 0)
    n2 = Q$2(t2 % 52) + n2;
  return (Q$2(t2 % 52) + n2).replace(K$2, "$1-$2");
}
var te$1 = function(e2, t2) {
  for (var n2 = t2.length; n2; )
    e2 = 33 * e2 ^ t2.charCodeAt(--n2);
  return e2;
}, ne$1 = function(e2) {
  return te$1(5381, e2);
};
function re$1(e2) {
  for (var t2 = 0; t2 < e2.length; t2 += 1) {
    var n2 = e2[t2];
    if (b$3(n2) && !N$2(n2))
      return false;
  }
  return true;
}
var oe$1 = ne$1("5.3.5"), se$1 = function() {
  function e2(e3, t2, n2) {
    this.rules = e3, this.staticRulesId = "", this.isStatic = (n2 === void 0 || n2.isStatic) && re$1(e3), this.componentId = t2, this.baseHash = te$1(oe$1, t2), this.baseStyle = n2, Z$1.registerId(t2);
  }
  return e2.prototype.generateAndInjectStyles = function(e3, t2, n2) {
    var r2 = this.componentId, o = [];
    if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e3, t2, n2)), this.isStatic && !n2.hash)
      if (this.staticRulesId && t2.hasNameForId(r2, this.staticRulesId))
        o.push(this.staticRulesId);
      else {
        var s = Ne$1(this.rules, e3, t2, n2).join(""), i = ee$1(te$1(this.baseHash, s) >>> 0);
        if (!t2.hasNameForId(r2, i)) {
          var a = n2(s, "." + i, void 0, r2);
          t2.insertRules(r2, i, a);
        }
        o.push(i), this.staticRulesId = i;
      }
    else {
      for (var c2 = this.rules.length, u2 = te$1(this.baseHash, n2.hash), l2 = "", d2 = 0; d2 < c2; d2++) {
        var h6 = this.rules[d2];
        if (typeof h6 == "string")
          l2 += h6;
        else if (h6) {
          var p2 = Ne$1(h6, e3, t2, n2), f2 = Array.isArray(p2) ? p2.join("") : p2;
          u2 = te$1(u2, f2 + d2), l2 += f2;
        }
      }
      if (l2) {
        var m2 = ee$1(u2 >>> 0);
        if (!t2.hasNameForId(r2, m2)) {
          var y2 = n2(l2, "." + m2, void 0, r2);
          t2.insertRules(r2, m2, y2);
        }
        o.push(m2);
      }
    }
    return o.join(" ");
  }, e2;
}(), ie$1 = /^\s*\/\/.*$/gm, ae$1 = [":", "[", ".", "#"];
function ce$1(e2) {
  var t2, n2, r2, o, s = e2 === void 0 ? E$2 : e2, i = s.options, a = i === void 0 ? E$2 : i, c2 = s.plugins, u2 = c2 === void 0 ? w$3 : c2, l2 = new stylis_min$1(a), d2 = [], h6 = function(e3) {
    function t3(t4) {
      if (t4)
        try {
          e3(t4 + "}");
        } catch (e4) {
        }
    }
    return function(n3, r3, o2, s2, i2, a2, c3, u3, l3, d3) {
      switch (n3) {
        case 1:
          if (l3 === 0 && r3.charCodeAt(0) === 64)
            return e3(r3 + ";"), "";
          break;
        case 2:
          if (u3 === 0)
            return r3 + "/*|*/";
          break;
        case 3:
          switch (u3) {
            case 102:
            case 112:
              return e3(o2[0] + r3), "";
            default:
              return r3 + (d3 === 0 ? "/*|*/" : "");
          }
        case -2:
          r3.split("/*|*/}").forEach(t3);
      }
    };
  }(function(e3) {
    d2.push(e3);
  }), f2 = function(e3, r3, s2) {
    return r3 === 0 && ae$1.indexOf(s2[n2.length]) !== -1 || s2.match(o) ? e3 : "." + t2;
  };
  function m2(e3, s2, i2, a2) {
    a2 === void 0 && (a2 = "&");
    var c3 = e3.replace(ie$1, ""), u3 = s2 && i2 ? i2 + " " + s2 + " { " + c3 + " }" : c3;
    return t2 = a2, n2 = s2, r2 = new RegExp("\\" + n2 + "\\b", "g"), o = new RegExp("(\\" + n2 + "\\b){2,}"), l2(i2 || !s2 ? "" : s2, u3);
  }
  return l2.use([].concat(u2, [function(e3, t3, o2) {
    e3 === 2 && o2.length && o2[0].lastIndexOf(n2) > 0 && (o2[0] = o2[0].replace(r2, f2));
  }, h6, function(e3) {
    if (e3 === -2) {
      var t3 = d2;
      return d2 = [], t3;
    }
  }])), m2.hash = u2.length ? u2.reduce(function(e3, t3) {
    return t3.name || j$1(15), te$1(e3, t3.name);
  }, 5381).toString() : "", m2;
}
var ue$1 = r$4.createContext();
ue$1.Consumer;
var de$1 = r$4.createContext(), he$1 = (de$1.Consumer, new Z$1()), pe$1 = ce$1();
function fe$1() {
  return useContext(ue$1) || he$1;
}
function me$1() {
  return useContext(de$1) || pe$1;
}
var ve$1 = function() {
  function e2(e3, t2) {
    var n2 = this;
    this.inject = function(e4, t3) {
      t3 === void 0 && (t3 = pe$1);
      var r2 = n2.name + t3.hash;
      e4.hasNameForId(n2.id, r2) || e4.insertRules(n2.id, r2, t3(n2.rules, r2, "@keyframes"));
    }, this.toString = function() {
      return j$1(12, String(n2.name));
    }, this.name = e3, this.id = "sc-keyframes-" + e3, this.rules = t2;
  }
  return e2.prototype.getName = function(e3) {
    return e3 === void 0 && (e3 = pe$1), this.name + e3.hash;
  }, e2;
}(), ge$1 = /([A-Z])/, Se$1 = /([A-Z])/g, we$1 = /^ms-/, Ee$1 = function(e2) {
  return "-" + e2.toLowerCase();
};
function be$1(e2) {
  return ge$1.test(e2) ? e2.replace(Se$1, Ee$1).replace(we$1, "-ms-") : e2;
}
var _e$1 = function(e2) {
  return e2 == null || e2 === false || e2 === "";
};
function Ne$1(e2, n2, r2, o) {
  if (Array.isArray(e2)) {
    for (var s, i = [], a = 0, c2 = e2.length; a < c2; a += 1)
      (s = Ne$1(e2[a], n2, r2, o)) !== "" && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
    return i;
  }
  if (_e$1(e2))
    return "";
  if (N$2(e2))
    return "." + e2.styledComponentId;
  if (b$3(e2)) {
    if (typeof (l2 = e2) != "function" || l2.prototype && l2.prototype.isReactComponent || !n2)
      return e2;
    var u2 = e2(n2);
    return Ne$1(u2, n2, r2, o);
  }
  var l2;
  return e2 instanceof ve$1 ? r2 ? (e2.inject(r2, o), e2.getName(o)) : e2 : S$2(e2) ? function e3(t2, n3) {
    var r3, o2, s2 = [];
    for (var i2 in t2)
      t2.hasOwnProperty(i2) && !_e$1(t2[i2]) && (Array.isArray(t2[i2]) && t2[i2].isCss || b$3(t2[i2]) ? s2.push(be$1(i2) + ":", t2[i2], ";") : S$2(t2[i2]) ? s2.push.apply(s2, e3(t2[i2], i2)) : s2.push(be$1(i2) + ": " + (r3 = i2, (o2 = t2[i2]) == null || typeof o2 == "boolean" || o2 === "" ? "" : typeof o2 != "number" || o2 === 0 || r3 in unitlessKeys$1 ? String(o2).trim() : o2 + "px") + ";"));
    return n3 ? [n3 + " {"].concat(s2, ["}"]) : s2;
  }(e2) : e2.toString();
}
var Ae$1 = function(e2) {
  return Array.isArray(e2) && (e2.isCss = true), e2;
};
function Ce$1(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  return b$3(e2) || S$2(e2) ? Ae$1(Ne$1(g$3(w$3, [e2].concat(n2)))) : n2.length === 0 && e2.length === 1 && typeof e2[0] == "string" ? e2 : Ae$1(Ne$1(g$3(e2, n2)));
}
var Re$1 = function(e2, t2, n2) {
  return n2 === void 0 && (n2 = E$2), e2.theme !== n2.theme && e2.theme || t2 || n2.theme;
}, De$1 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, je$1 = /(^-|-$)/g;
function Te$1(e2) {
  return e2.replace(De$1, "-").replace(je$1, "");
}
var xe$1 = function(e2) {
  return ee$1(ne$1(e2) >>> 0);
};
function ke$1(e2) {
  return typeof e2 == "string" && true;
}
var Ve$1 = function(e2) {
  return typeof e2 == "function" || typeof e2 == "object" && e2 !== null && !Array.isArray(e2);
}, Be$1 = function(e2) {
  return e2 !== "__proto__" && e2 !== "constructor" && e2 !== "prototype";
};
function ze$1(e2, t2, n2) {
  var r2 = e2[n2];
  Ve$1(t2) && Ve$1(r2) ? Me$1(r2, t2) : e2[n2] = t2;
}
function Me$1(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  for (var o = 0, s = n2; o < s.length; o++) {
    var i = s[o];
    if (Ve$1(i))
      for (var a in i)
        Be$1(a) && ze$1(e2, i[a], a);
  }
  return e2;
}
var Ge$1 = r$4.createContext();
Ge$1.Consumer;
var Ye$1 = {};
function qe$1(e2, t2, n2) {
  var o = N$2(e2), i = !ke$1(e2), a = t2.attrs, c2 = a === void 0 ? w$3 : a, d2 = t2.componentId, h6 = d2 === void 0 ? function(e3, t3) {
    var n3 = typeof e3 != "string" ? "sc" : Te$1(e3);
    Ye$1[n3] = (Ye$1[n3] || 0) + 1;
    var r2 = n3 + "-" + xe$1("5.3.5" + n3 + Ye$1[n3]);
    return t3 ? t3 + "-" + r2 : r2;
  }(t2.displayName, t2.parentComponentId) : d2, p2 = t2.displayName, f2 = p2 === void 0 ? function(e3) {
    return ke$1(e3) ? "styled." + e3 : "Styled(" + _$1(e3) + ")";
  }(e2) : p2, g2 = t2.displayName && t2.componentId ? Te$1(t2.displayName) + "-" + t2.componentId : t2.componentId || h6, S2 = o && e2.attrs ? Array.prototype.concat(e2.attrs, c2).filter(Boolean) : c2, A2 = t2.shouldForwardProp;
  o && e2.shouldForwardProp && (A2 = t2.shouldForwardProp ? function(n3, r2, o2) {
    return e2.shouldForwardProp(n3, r2, o2) && t2.shouldForwardProp(n3, r2, o2);
  } : e2.shouldForwardProp);
  var C2, I2 = new se$1(n2, g2, o ? e2.componentStyle : void 0), P2 = I2.isStatic && c2.length === 0, O2 = function(e3, t3) {
    return function(e4, t4, n3, r2) {
      var o2 = e4.attrs, i2 = e4.componentStyle, a2 = e4.defaultProps, c3 = e4.foldedComponentIds, d3 = e4.shouldForwardProp, h7 = e4.styledComponentId, p3 = e4.target;
      var f3 = function(e5, t5, n4) {
        e5 === void 0 && (e5 = E$2);
        var r3 = v$4({}, t5, { theme: e5 }), o3 = {};
        return n4.forEach(function(e6) {
          var t6, n5, s, i3 = e6;
          for (t6 in b$3(i3) && (i3 = i3(r3)), i3)
            r3[t6] = o3[t6] = t6 === "className" ? (n5 = o3[t6], s = i3[t6], n5 && s ? n5 + " " + s : n5 || s) : i3[t6];
        }), [r3, o3];
      }(Re$1(t4, useContext(Ge$1), a2) || E$2, t4, o2), y2 = f3[0], g3 = f3[1], S3 = function(e5, t5, n4, r3) {
        var o3 = fe$1(), s = me$1(), i3 = t5 ? e5.generateAndInjectStyles(E$2, o3, s) : e5.generateAndInjectStyles(n4, o3, s);
        return i3;
      }(i2, r2, y2), w2 = n3, _2 = g3.$as || t4.$as || g3.as || t4.as || p3, N2 = ke$1(_2), A3 = g3 !== t4 ? v$4({}, t4, {}, g3) : t4, C3 = {};
      for (var I3 in A3)
        I3[0] !== "$" && I3 !== "as" && (I3 === "forwardedAs" ? C3.as = A3[I3] : (d3 ? d3(I3, isPropValid$1, _2) : !N2 || isPropValid$1(I3)) && (C3[I3] = A3[I3]));
      return t4.style && g3.style !== t4.style && (C3.style = v$4({}, t4.style, {}, g3.style)), C3.className = Array.prototype.concat(c3, h7, S3 !== h7 ? S3 : null, t4.className, g3.className).filter(Boolean).join(" "), C3.ref = w2, createElement(_2, C3);
    }(C2, e3, t3, P2);
  };
  return O2.displayName = f2, (C2 = r$4.forwardRef(O2)).attrs = S2, C2.componentStyle = I2, C2.displayName = f2, C2.shouldForwardProp = A2, C2.foldedComponentIds = o ? Array.prototype.concat(e2.foldedComponentIds, e2.styledComponentId) : w$3, C2.styledComponentId = g2, C2.target = o ? e2.target : e2, C2.withComponent = function(e3) {
    var r2 = t2.componentId, o2 = function(e4, t3) {
      if (e4 == null)
        return {};
      var n3, r3, o3 = {}, s2 = Object.keys(e4);
      for (r3 = 0; r3 < s2.length; r3++)
        n3 = s2[r3], t3.indexOf(n3) >= 0 || (o3[n3] = e4[n3]);
      return o3;
    }(t2, ["componentId"]), s = r2 && r2 + "-" + (ke$1(e3) ? e3 : Te$1(_$1(e3)));
    return qe$1(e3, v$4({}, o2, { attrs: S2, componentId: s }), n2);
  }, Object.defineProperty(C2, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(t3) {
    this._foldedDefaultProps = o ? Me$1({}, e2.defaultProps, t3) : t3;
  } }), C2.toString = function() {
    return "." + C2.styledComponentId;
  }, i && hoistNonReactStatics_cjs$1(C2, e2, { attrs: true, componentStyle: true, displayName: true, foldedComponentIds: true, shouldForwardProp: true, styledComponentId: true, target: true, withComponent: true }), C2;
}
var He$1 = function(e2) {
  return function e3(t2, r2, o) {
    if (o === void 0 && (o = E$2), !reactIs$5.exports.isValidElementType(r2))
      return j$1(1, String(r2));
    var s = function() {
      return t2(r2, o, Ce$1.apply(void 0, arguments));
    };
    return s.withConfig = function(n2) {
      return e3(t2, r2, v$4({}, o, {}, n2));
    }, s.attrs = function(n2) {
      return e3(t2, r2, v$4({}, o, { attrs: Array.prototype.concat(o.attrs, n2).filter(Boolean) }));
    }, s;
  }(qe$1, e2);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e2) {
  He$1[e2] = He$1(e2);
});
function Ue(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  var o = Ce$1.apply(void 0, [e2].concat(n2)).join(""), s = xe$1(o);
  return new ve$1(s, o);
}
var styled$1 = He$1;
const color = {
  beauBlue: "#CEE4F3",
  black: "#000000",
  blue: "#2E7DAF",
  blueCloud: "#EEF6FB",
  blueCloudDark: "#3092CF",
  blueCultured: "#EBEFF9",
  blueDark: "#041836",
  blueDark2: "#112F5C",
  blueLight: "#F2F6FF",
  blueLight2: "#E5EDFF",
  blueLight3: "#E6EDFF",
  blueLight4: "#57A5FF",
  blueSky: "#9ECCEA",
  blueSkyDark: "#51A5DA",
  blueSkyLight: "#E8EAED",
  green: "#21BF96",
  greenDark: "#0FA67F",
  greenForestDark: "#3BC49D",
  greenForestLight: "#EBF9F5",
  greenLight: "#7AD9C0",
  greenMint: "#33FFCC",
  grey: "#68738D",
  greyDark: "#333333",
  greyDisabled: "#D7DAE0",
  greyIcons: "#B0B5BF",
  greyLight: "#C5CDD9",
  paleBlue2: "#C1D8E7",
  paleCerulean: "#9EC7EA",
  pink: "#DA51BE",
  pinkDark: "#E01FB3",
  pinkLight: "#FDF0FA",
  purple: "#8851DA",
  purpleDark: "#6D30CF",
  purpleLight: "#F3EEFB",
  red: "#EB5757",
  redDark: "#E01F1F",
  redLight: "#FDF0F0",
  white: "#FFFFFF",
  yellow: "#ECA609",
  yellowDark: "#F1A90E",
  yellowLight: "#FEF9EE",
  yellowHover: "#FAE7BC"
};
const gradientColors = {
  beauBlue: "radial-gradient(106.45% 108.64% at 32.33% -4.84%, #ECF5FC 0.52%, #CEE4F3 100%)",
  blue: "linear-gradient(113.54deg, rgba(60, 87, 140, 0.5) 14.91%, rgba(70, 86, 169, 0.5) 30.39%, rgba(129, 161, 225, 0.185) 55.76%), linear-gradient(151.07deg, #145559 33.25%, #414FA7 98.24%)",
  goldShiny: "linear-gradient(113.54deg, rgba(199, 148, 37, 0.6) 14.91%, rgba(204, 147, 23, 0.6) 14.92%, rgba(181, 147, 24, 0) 45.98%, rgba(250, 228, 30, 0) 55.76%, rgba(219, 200, 26, 0) 55.76%), linear-gradient(147.17deg, #DBBB14 48.73%, #B38311 98.22%)",
  lightBlue: "linear-gradient(113.54deg, rgba(117, 183, 251, 0.531738) 14.91%, rgba(209, 103, 255, 0.03) 55.76%), linear-gradient(160.75deg, #427ACB 41.37%, #45FFFF 98.29%)",
  lightGrey: "linear-gradient(90deg,rgba(221, 221, 221, 0),rgba(232, 232, 232, 0.6),rgba(221, 221, 221, 0))",
  purpleToPink: "linear-gradient(113.54deg, rgba(103, 58, 194, 0.6) 14.91%, rgba(122, 74, 221, 0.498) 25.92%, rgba(209, 103, 255, 0.03) 55.76%), linear-gradient(160.75deg, #7A4ADD 41.37%, #D57BFF 98.29%)"
};
const getShade = (shade, percent) => `rgba(
    ${shade === "light" ? "255, 255, 255," : "0, 0, 0,"}
    ${String(percent / 100)}
  )`;
const colorPercentage = (color2, percentage) => {
  const r2 = parseInt(color2.slice(1, 3), 16);
  const g2 = parseInt(color2.slice(3, 5), 16);
  const b2 = parseInt(color2.slice(5, 7), 16);
  return `rgba(${r2},${g2},${b2},${Number(percentage) / 100})`;
};
const breakpoints = {
  xxl: "1400px",
  xl: "1200px",
  lg: "1025px",
  md: "768px",
  sm: "576px",
  xs: "320px"
};
var reactIs$2 = { exports: {} };
var reactIs_production_min$1 = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2 = Symbol.for("react.element"), c$1 = Symbol.for("react.portal"), d$1 = Symbol.for("react.fragment"), e$1 = Symbol.for("react.strict_mode"), f$1 = Symbol.for("react.profiler"), g$2 = Symbol.for("react.provider"), h$1 = Symbol.for("react.context"), k$2 = Symbol.for("react.server_context"), l$2 = Symbol.for("react.forward_ref"), m$1 = Symbol.for("react.suspense"), n$2 = Symbol.for("react.suspense_list"), p$2 = Symbol.for("react.memo"), q$3 = Symbol.for("react.lazy"), t$2 = Symbol.for("react.offscreen"), u$1;
u$1 = Symbol.for("react.module.reference");
function v$3(a) {
  if (typeof a === "object" && a !== null) {
    var r2 = a.$$typeof;
    switch (r2) {
      case b$2:
        switch (a = a.type, a) {
          case d$1:
          case f$1:
          case e$1:
          case m$1:
          case n$2:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$2:
              case h$1:
              case l$2:
              case q$3:
              case p$2:
              case g$2:
                return a;
              default:
                return r2;
            }
        }
      case c$1:
        return r2;
    }
  }
}
reactIs_production_min$1.ContextConsumer = h$1;
reactIs_production_min$1.ContextProvider = g$2;
reactIs_production_min$1.Element = b$2;
reactIs_production_min$1.ForwardRef = l$2;
reactIs_production_min$1.Fragment = d$1;
reactIs_production_min$1.Lazy = q$3;
reactIs_production_min$1.Memo = p$2;
reactIs_production_min$1.Portal = c$1;
reactIs_production_min$1.Profiler = f$1;
reactIs_production_min$1.StrictMode = e$1;
reactIs_production_min$1.Suspense = m$1;
reactIs_production_min$1.SuspenseList = n$2;
reactIs_production_min$1.isAsyncMode = function() {
  return false;
};
reactIs_production_min$1.isConcurrentMode = function() {
  return false;
};
reactIs_production_min$1.isContextConsumer = function(a) {
  return v$3(a) === h$1;
};
reactIs_production_min$1.isContextProvider = function(a) {
  return v$3(a) === g$2;
};
reactIs_production_min$1.isElement = function(a) {
  return typeof a === "object" && a !== null && a.$$typeof === b$2;
};
reactIs_production_min$1.isForwardRef = function(a) {
  return v$3(a) === l$2;
};
reactIs_production_min$1.isFragment = function(a) {
  return v$3(a) === d$1;
};
reactIs_production_min$1.isLazy = function(a) {
  return v$3(a) === q$3;
};
reactIs_production_min$1.isMemo = function(a) {
  return v$3(a) === p$2;
};
reactIs_production_min$1.isPortal = function(a) {
  return v$3(a) === c$1;
};
reactIs_production_min$1.isProfiler = function(a) {
  return v$3(a) === f$1;
};
reactIs_production_min$1.isStrictMode = function(a) {
  return v$3(a) === e$1;
};
reactIs_production_min$1.isSuspense = function(a) {
  return v$3(a) === m$1;
};
reactIs_production_min$1.isSuspenseList = function(a) {
  return v$3(a) === n$2;
};
reactIs_production_min$1.isValidElementType = function(a) {
  return typeof a === "string" || typeof a === "function" || a === d$1 || a === f$1 || a === e$1 || a === m$1 || a === n$2 || a === t$2 || typeof a === "object" && a !== null && (a.$$typeof === q$3 || a.$$typeof === p$2 || a.$$typeof === g$2 || a.$$typeof === h$1 || a.$$typeof === l$2 || a.$$typeof === u$1 || a.getModuleId !== void 0) ? true : false;
};
reactIs_production_min$1.typeOf = v$3;
{
  reactIs$2.exports = reactIs_production_min$1;
}
var react = { exports: {} };
var react_production_min = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l$1 = Symbol.for("react.element"), n$1 = Symbol.for("react.portal"), p$1 = Symbol.for("react.fragment"), q$2 = Symbol.for("react.strict_mode"), r$2 = Symbol.for("react.profiler"), t$1 = Symbol.for("react.provider"), u = Symbol.for("react.context"), v$2 = Symbol.for("react.forward_ref"), w$2 = Symbol.for("react.suspense"), x$2 = Symbol.for("react.memo"), y$1 = Symbol.for("react.lazy"), z$2 = Symbol.iterator;
function A$2(a) {
  if (a === null || typeof a !== "object")
    return null;
  a = z$2 && a[z$2] || a["@@iterator"];
  return typeof a === "function" ? a : null;
}
var B$1 = { isMounted: function() {
  return false;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, C = Object.assign, D = {};
function E$1(a, b2, e2) {
  this.props = a;
  this.context = b2;
  this.refs = D;
  this.updater = e2 || B$1;
}
E$1.prototype.isReactComponent = {};
E$1.prototype.setState = function(a, b2) {
  if (typeof a !== "object" && typeof a !== "function" && a != null)
    throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, a, b2, "setState");
};
E$1.prototype.forceUpdate = function(a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F$1() {
}
F$1.prototype = E$1.prototype;
function G$1(a, b2, e2) {
  this.props = a;
  this.context = b2;
  this.refs = D;
  this.updater = e2 || B$1;
}
var H$1 = G$1.prototype = new F$1();
H$1.constructor = G$1;
C(H$1, E$1.prototype);
H$1.isPureReactComponent = true;
var I$1 = Array.isArray, J$1 = Object.prototype.hasOwnProperty, K$1 = { current: null }, L$1 = { key: true, ref: true, __self: true, __source: true };
function M$1(a, b2, e2) {
  var d2, c2 = {}, k2 = null, h6 = null;
  if (b2 != null)
    for (d2 in b2.ref !== void 0 && (h6 = b2.ref), b2.key !== void 0 && (k2 = "" + b2.key), b2)
      J$1.call(b2, d2) && !L$1.hasOwnProperty(d2) && (c2[d2] = b2[d2]);
  var g2 = arguments.length - 2;
  if (g2 === 1)
    c2.children = e2;
  else if (1 < g2) {
    for (var f2 = Array(g2), m2 = 0; m2 < g2; m2++)
      f2[m2] = arguments[m2 + 2];
    c2.children = f2;
  }
  if (a && a.defaultProps)
    for (d2 in g2 = a.defaultProps, g2)
      c2[d2] === void 0 && (c2[d2] = g2[d2]);
  return { $$typeof: l$1, type: a, key: k2, ref: h6, props: c2, _owner: K$1.current };
}
function N$1(a, b2) {
  return { $$typeof: l$1, type: a.type, key: b2, ref: a.ref, props: a.props, _owner: a._owner };
}
function O(a) {
  return typeof a === "object" && a !== null && a.$$typeof === l$1;
}
function escape(a) {
  var b2 = { "=": "=0", ":": "=2" };
  return "$" + a.replace(/[=:]/g, function(a2) {
    return b2[a2];
  });
}
var P$1 = /\/+/g;
function Q$1(a, b2) {
  return typeof a === "object" && a !== null && a.key != null ? escape("" + a.key) : b2.toString(36);
}
function R(a, b2, e2, d2, c2) {
  var k2 = typeof a;
  if (k2 === "undefined" || k2 === "boolean")
    a = null;
  var h6 = false;
  if (a === null)
    h6 = true;
  else
    switch (k2) {
      case "string":
      case "number":
        h6 = true;
        break;
      case "object":
        switch (a.$$typeof) {
          case l$1:
          case n$1:
            h6 = true;
        }
    }
  if (h6)
    return h6 = a, c2 = c2(h6), a = d2 === "" ? "." + Q$1(h6, 0) : d2, I$1(c2) ? (e2 = "", a != null && (e2 = a.replace(P$1, "$&/") + "/"), R(c2, b2, e2, "", function(a2) {
      return a2;
    })) : c2 != null && (O(c2) && (c2 = N$1(c2, e2 + (!c2.key || h6 && h6.key === c2.key ? "" : ("" + c2.key).replace(P$1, "$&/") + "/") + a)), b2.push(c2)), 1;
  h6 = 0;
  d2 = d2 === "" ? "." : d2 + ":";
  if (I$1(a))
    for (var g2 = 0; g2 < a.length; g2++) {
      k2 = a[g2];
      var f2 = d2 + Q$1(k2, g2);
      h6 += R(k2, b2, e2, f2, c2);
    }
  else if (f2 = A$2(a), typeof f2 === "function")
    for (a = f2.call(a), g2 = 0; !(k2 = a.next()).done; )
      k2 = k2.value, f2 = d2 + Q$1(k2, g2++), h6 += R(k2, b2, e2, f2, c2);
  else if (k2 === "object")
    throw b2 = String(a), Error("Objects are not valid as a React child (found: " + (b2 === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : b2) + "). If you meant to render a collection of children, use an array instead.");
  return h6;
}
function S$1(a, b2, e2) {
  if (a == null)
    return a;
  var d2 = [], c2 = 0;
  R(a, d2, "", "", function(a2) {
    return b2.call(e2, a2, c2++);
  });
  return d2;
}
function T$1(a) {
  if (a._status === -1) {
    var b2 = a._result;
    b2 = b2();
    b2.then(function(b3) {
      if (a._status === 0 || a._status === -1)
        a._status = 1, a._result = b3;
    }, function(b3) {
      if (a._status === 0 || a._status === -1)
        a._status = 2, a._result = b3;
    });
    a._status === -1 && (a._status = 0, a._result = b2);
  }
  if (a._status === 1)
    return a._result.default;
  throw a._result;
}
var U$1 = { current: null }, V$1 = { transition: null }, W$1 = { ReactCurrentDispatcher: U$1, ReactCurrentBatchConfig: V$1, ReactCurrentOwner: K$1 };
react_production_min.Children = { map: S$1, forEach: function(a, b2, e2) {
  S$1(a, function() {
    b2.apply(this, arguments);
  }, e2);
}, count: function(a) {
  var b2 = 0;
  S$1(a, function() {
    b2++;
  });
  return b2;
}, toArray: function(a) {
  return S$1(a, function(a2) {
    return a2;
  }) || [];
}, only: function(a) {
  if (!O(a))
    throw Error("React.Children.only expected to receive a single React element child.");
  return a;
} };
react_production_min.Component = E$1;
react_production_min.Fragment = p$1;
react_production_min.Profiler = r$2;
react_production_min.PureComponent = G$1;
react_production_min.StrictMode = q$2;
react_production_min.Suspense = w$2;
react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W$1;
react_production_min.cloneElement = function(a, b2, e2) {
  if (a === null || a === void 0)
    throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
  var d2 = C({}, a.props), c2 = a.key, k2 = a.ref, h6 = a._owner;
  if (b2 != null) {
    b2.ref !== void 0 && (k2 = b2.ref, h6 = K$1.current);
    b2.key !== void 0 && (c2 = "" + b2.key);
    if (a.type && a.type.defaultProps)
      var g2 = a.type.defaultProps;
    for (f2 in b2)
      J$1.call(b2, f2) && !L$1.hasOwnProperty(f2) && (d2[f2] = b2[f2] === void 0 && g2 !== void 0 ? g2[f2] : b2[f2]);
  }
  var f2 = arguments.length - 2;
  if (f2 === 1)
    d2.children = e2;
  else if (1 < f2) {
    g2 = Array(f2);
    for (var m2 = 0; m2 < f2; m2++)
      g2[m2] = arguments[m2 + 2];
    d2.children = g2;
  }
  return { $$typeof: l$1, type: a.type, key: c2, ref: k2, props: d2, _owner: h6 };
};
react_production_min.createContext = function(a) {
  a = { $$typeof: u, _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null };
  a.Provider = { $$typeof: t$1, _context: a };
  return a.Consumer = a;
};
react_production_min.createElement = M$1;
react_production_min.createFactory = function(a) {
  var b2 = M$1.bind(null, a);
  b2.type = a;
  return b2;
};
react_production_min.createRef = function() {
  return { current: null };
};
react_production_min.forwardRef = function(a) {
  return { $$typeof: v$2, render: a };
};
react_production_min.isValidElement = O;
react_production_min.lazy = function(a) {
  return { $$typeof: y$1, _payload: { _status: -1, _result: a }, _init: T$1 };
};
react_production_min.memo = function(a, b2) {
  return { $$typeof: x$2, type: a, compare: b2 === void 0 ? null : b2 };
};
react_production_min.startTransition = function(a) {
  var b2 = V$1.transition;
  V$1.transition = {};
  try {
    a();
  } finally {
    V$1.transition = b2;
  }
};
react_production_min.unstable_act = function() {
  throw Error("act(...) is not supported in production builds of React.");
};
react_production_min.useCallback = function(a, b2) {
  return U$1.current.useCallback(a, b2);
};
react_production_min.useContext = function(a) {
  return U$1.current.useContext(a);
};
react_production_min.useDebugValue = function() {
};
react_production_min.useDeferredValue = function(a) {
  return U$1.current.useDeferredValue(a);
};
react_production_min.useEffect = function(a, b2) {
  return U$1.current.useEffect(a, b2);
};
react_production_min.useId = function() {
  return U$1.current.useId();
};
react_production_min.useImperativeHandle = function(a, b2, e2) {
  return U$1.current.useImperativeHandle(a, b2, e2);
};
react_production_min.useInsertionEffect = function(a, b2) {
  return U$1.current.useInsertionEffect(a, b2);
};
react_production_min.useLayoutEffect = function(a, b2) {
  return U$1.current.useLayoutEffect(a, b2);
};
react_production_min.useMemo = function(a, b2) {
  return U$1.current.useMemo(a, b2);
};
react_production_min.useReducer = function(a, b2, e2) {
  return U$1.current.useReducer(a, b2, e2);
};
react_production_min.useRef = function(a) {
  return U$1.current.useRef(a);
};
react_production_min.useState = function(a) {
  return U$1.current.useState(a);
};
react_production_min.useSyncExternalStore = function(a, b2, e2) {
  return U$1.current.useSyncExternalStore(a, b2, e2);
};
react_production_min.useTransition = function() {
  return U$1.current.useTransition();
};
react_production_min.version = "18.2.0";
{
  react.exports = react_production_min;
}
var r$1 = react.exports;
function stylis_min(W2) {
  function M2(d2, c2, e2, h6, a) {
    for (var m2 = 0, b2 = 0, v2 = 0, n2 = 0, q2, g2, x2 = 0, K2 = 0, k2, u2 = k2 = q2 = 0, l2 = 0, r2 = 0, I2 = 0, t2 = 0, B3 = e2.length, J2 = B3 - 1, y2, f2 = "", p2 = "", F3 = "", G3 = "", C2; l2 < B3; ) {
      g2 = e2.charCodeAt(l2);
      l2 === J2 && b2 + n2 + v2 + m2 !== 0 && (b2 !== 0 && (g2 = b2 === 47 ? 10 : 47), n2 = v2 = m2 = 0, B3++, J2++);
      if (b2 + n2 + v2 + m2 === 0) {
        if (l2 === J2 && (0 < r2 && (f2 = f2.replace(N2, "")), 0 < f2.trim().length)) {
          switch (g2) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f2 += e2.charAt(l2);
          }
          g2 = 59;
        }
        switch (g2) {
          case 123:
            f2 = f2.trim();
            q2 = f2.charCodeAt(0);
            k2 = 1;
            for (t2 = ++l2; l2 < B3; ) {
              switch (g2 = e2.charCodeAt(l2)) {
                case 123:
                  k2++;
                  break;
                case 125:
                  k2--;
                  break;
                case 47:
                  switch (g2 = e2.charCodeAt(l2 + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u2 = l2 + 1; u2 < J2; ++u2) {
                          switch (e2.charCodeAt(u2)) {
                            case 47:
                              if (g2 === 42 && e2.charCodeAt(u2 - 1) === 42 && l2 + 2 !== u2) {
                                l2 = u2 + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (g2 === 47) {
                                l2 = u2 + 1;
                                break a;
                              }
                          }
                        }
                        l2 = u2;
                      }
                  }
                  break;
                case 91:
                  g2++;
                case 40:
                  g2++;
                case 34:
                case 39:
                  for (; l2++ < J2 && e2.charCodeAt(l2) !== g2; ) {
                  }
              }
              if (k2 === 0)
                break;
              l2++;
            }
            k2 = e2.substring(t2, l2);
            q2 === 0 && (q2 = (f2 = f2.replace(ca, "").trim()).charCodeAt(0));
            switch (q2) {
              case 64:
                0 < r2 && (f2 = f2.replace(N2, ""));
                g2 = f2.charCodeAt(1);
                switch (g2) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r2 = c2;
                    break;
                  default:
                    r2 = O2;
                }
                k2 = M2(c2, r2, k2, g2, a + 1);
                t2 = k2.length;
                0 < A2 && (r2 = X2(O2, f2, I2), C2 = H2(3, k2, r2, c2, D2, z2, t2, g2, a, h6), f2 = r2.join(""), C2 !== void 0 && (t2 = (k2 = C2.trim()).length) === 0 && (g2 = 0, k2 = ""));
                if (0 < t2)
                  switch (g2) {
                    case 115:
                      f2 = f2.replace(da, ea);
                    case 100:
                    case 109:
                    case 45:
                      k2 = f2 + "{" + k2 + "}";
                      break;
                    case 107:
                      f2 = f2.replace(fa, "$1 $2");
                      k2 = f2 + "{" + k2 + "}";
                      k2 = w2 === 1 || w2 === 2 && L2("@" + k2, 3) ? "@-webkit-" + k2 + "@" + k2 : "@" + k2;
                      break;
                    default:
                      k2 = f2 + k2, h6 === 112 && (k2 = (p2 += k2, ""));
                  }
                else
                  k2 = "";
                break;
              default:
                k2 = M2(c2, X2(c2, f2, I2), k2, h6, a + 1);
            }
            F3 += k2;
            k2 = I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e2.charCodeAt(++l2);
            break;
          case 125:
          case 59:
            f2 = (0 < r2 ? f2.replace(N2, "") : f2).trim();
            if (1 < (t2 = f2.length))
              switch (u2 === 0 && (q2 = f2.charCodeAt(0), q2 === 45 || 96 < q2 && 123 > q2) && (t2 = (f2 = f2.replace(" ", ":")).length), 0 < A2 && (C2 = H2(1, f2, c2, d2, D2, z2, p2.length, h6, a, h6)) !== void 0 && (t2 = (f2 = C2.trim()).length) === 0 && (f2 = "\0\0"), q2 = f2.charCodeAt(0), g2 = f2.charCodeAt(1), q2) {
                case 0:
                  break;
                case 64:
                  if (g2 === 105 || g2 === 99) {
                    G3 += f2 + e2.charAt(l2);
                    break;
                  }
                default:
                  f2.charCodeAt(t2 - 1) !== 58 && (p2 += P2(f2, q2, g2, f2.charCodeAt(2)));
              }
            I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e2.charCodeAt(++l2);
        }
      }
      switch (g2) {
        case 13:
        case 10:
          b2 === 47 ? b2 = 0 : 1 + q2 === 0 && h6 !== 107 && 0 < f2.length && (r2 = 1, f2 += "\0");
          0 < A2 * Y2 && H2(0, f2, c2, d2, D2, z2, p2.length, h6, a, h6);
          z2 = 1;
          D2++;
          break;
        case 59:
        case 125:
          if (b2 + n2 + v2 + m2 === 0) {
            z2++;
            break;
          }
        default:
          z2++;
          y2 = e2.charAt(l2);
          switch (g2) {
            case 9:
            case 32:
              if (n2 + m2 + b2 === 0)
                switch (x2) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y2 = "";
                    break;
                  default:
                    g2 !== 32 && (y2 = " ");
                }
              break;
            case 0:
              y2 = "\\0";
              break;
            case 12:
              y2 = "\\f";
              break;
            case 11:
              y2 = "\\v";
              break;
            case 38:
              n2 + b2 + m2 === 0 && (r2 = I2 = 1, y2 = "\f" + y2);
              break;
            case 108:
              if (n2 + b2 + m2 + E2 === 0 && 0 < u2)
                switch (l2 - u2) {
                  case 2:
                    x2 === 112 && e2.charCodeAt(l2 - 3) === 58 && (E2 = x2);
                  case 8:
                    K2 === 111 && (E2 = K2);
                }
              break;
            case 58:
              n2 + b2 + m2 === 0 && (u2 = l2);
              break;
            case 44:
              b2 + v2 + n2 + m2 === 0 && (r2 = 1, y2 += "\r");
              break;
            case 34:
            case 39:
              b2 === 0 && (n2 = n2 === g2 ? 0 : n2 === 0 ? g2 : n2);
              break;
            case 91:
              n2 + b2 + v2 === 0 && m2++;
              break;
            case 93:
              n2 + b2 + v2 === 0 && m2--;
              break;
            case 41:
              n2 + b2 + m2 === 0 && v2--;
              break;
            case 40:
              if (n2 + b2 + m2 === 0) {
                if (q2 === 0)
                  switch (2 * x2 + 3 * K2) {
                    case 533:
                      break;
                    default:
                      q2 = 1;
                  }
                v2++;
              }
              break;
            case 64:
              b2 + v2 + n2 + m2 + u2 + k2 === 0 && (k2 = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n2 + m2 + v2))
                switch (b2) {
                  case 0:
                    switch (2 * g2 + 3 * e2.charCodeAt(l2 + 1)) {
                      case 235:
                        b2 = 47;
                        break;
                      case 220:
                        t2 = l2, b2 = 42;
                    }
                    break;
                  case 42:
                    g2 === 47 && x2 === 42 && t2 + 2 !== l2 && (e2.charCodeAt(t2 + 2) === 33 && (p2 += e2.substring(t2, l2 + 1)), y2 = "", b2 = 0);
                }
          }
          b2 === 0 && (f2 += y2);
      }
      K2 = x2;
      x2 = g2;
      l2++;
    }
    t2 = p2.length;
    if (0 < t2) {
      r2 = c2;
      if (0 < A2 && (C2 = H2(2, p2, r2, d2, D2, z2, t2, h6, a, h6), C2 !== void 0 && (p2 = C2).length === 0))
        return G3 + p2 + F3;
      p2 = r2.join(",") + "{" + p2 + "}";
      if (w2 * E2 !== 0) {
        w2 !== 2 || L2(p2, 2) || (E2 = 0);
        switch (E2) {
          case 111:
            p2 = p2.replace(ha, ":-moz-$1") + p2;
            break;
          case 112:
            p2 = p2.replace(Q2, "::-webkit-input-$1") + p2.replace(Q2, "::-moz-$1") + p2.replace(Q2, ":-ms-input-$1") + p2;
        }
        E2 = 0;
      }
    }
    return G3 + p2 + F3;
  }
  function X2(d2, c2, e2) {
    var h6 = c2.trim().split(ia);
    c2 = h6;
    var a = h6.length, m2 = d2.length;
    switch (m2) {
      case 0:
      case 1:
        var b2 = 0;
        for (d2 = m2 === 0 ? "" : d2[0] + " "; b2 < a; ++b2) {
          c2[b2] = Z2(d2, c2[b2], e2).trim();
        }
        break;
      default:
        var v2 = b2 = 0;
        for (c2 = []; b2 < a; ++b2) {
          for (var n2 = 0; n2 < m2; ++n2) {
            c2[v2++] = Z2(d2[n2] + " ", h6[b2], e2).trim();
          }
        }
    }
    return c2;
  }
  function Z2(d2, c2, e2) {
    var h6 = c2.charCodeAt(0);
    33 > h6 && (h6 = (c2 = c2.trim()).charCodeAt(0));
    switch (h6) {
      case 38:
        return c2.replace(F2, "$1" + d2.trim());
      case 58:
        return d2.trim() + c2.replace(F2, "$1" + d2.trim());
      default:
        if (0 < 1 * e2 && 0 < c2.indexOf("\f"))
          return c2.replace(F2, (d2.charCodeAt(0) === 58 ? "" : "$1") + d2.trim());
    }
    return d2 + c2;
  }
  function P2(d2, c2, e2, h6) {
    var a = d2 + ";", m2 = 2 * c2 + 3 * e2 + 4 * h6;
    if (m2 === 944) {
      d2 = a.indexOf(":", 9) + 1;
      var b2 = a.substring(d2, a.length - 1).trim();
      b2 = a.substring(0, d2).trim() + b2 + ";";
      return w2 === 1 || w2 === 2 && L2(b2, 1) ? "-webkit-" + b2 + b2 : b2;
    }
    if (w2 === 0 || w2 === 2 && !L2(a, 1))
      return a;
    switch (m2) {
      case 1015:
        return a.charCodeAt(10) === 97 ? "-webkit-" + a + a : a;
      case 951:
        return a.charCodeAt(3) === 116 ? "-webkit-" + a + a : a;
      case 963:
        return a.charCodeAt(5) === 110 ? "-webkit-" + a + a : a;
      case 1009:
        if (a.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (a.charCodeAt(8) === 45)
          return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11))
          return a.replace(ja, "$1-webkit-$2") + a;
        break;
      case 932:
        if (a.charCodeAt(4) === 45)
          switch (a.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
            case 115:
              return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
            case 98:
              return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
          }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (a.charCodeAt(8) !== 99)
          break;
        b2 = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b2 + "-webkit-" + a + "-ms-flex-pack" + b2 + a;
      case 1005:
        return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
      case 1e3:
        b2 = a.substring(13).trim();
        c2 = b2.indexOf("-") + 1;
        switch (b2.charCodeAt(0) + b2.charCodeAt(c2)) {
          case 226:
            b2 = a.replace(G2, "tb");
            break;
          case 232:
            b2 = a.replace(G2, "tb-rl");
            break;
          case 220:
            b2 = a.replace(G2, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + b2 + a;
      case 1017:
        if (a.indexOf("sticky", 9) === -1)
          break;
      case 975:
        c2 = (a = d2).length - 10;
        b2 = (a.charCodeAt(c2) === 33 ? a.substring(0, c2) : a).substring(d2.indexOf(":", 7) + 1).trim();
        switch (m2 = b2.charCodeAt(0) + (b2.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b2.charCodeAt(8))
              break;
          case 115:
            a = a.replace(b2, "-webkit-" + b2) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(b2, "-webkit-" + (102 < m2 ? "inline-" : "") + "box") + ";" + a.replace(b2, "-webkit-" + b2) + ";" + a.replace(b2, "-ms-" + b2 + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (a.charCodeAt(5) === 45)
          switch (a.charCodeAt(6)) {
            case 105:
              return b2 = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b2 + "-ms-flex-" + b2 + a;
            case 115:
              return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
            default:
              return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
          }
        break;
      case 973:
      case 989:
        if (a.charCodeAt(3) !== 45 || a.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (la.test(d2) === true)
          return (b2 = d2.substring(d2.indexOf(":") + 1)).charCodeAt(0) === 115 ? P2(d2.replace("stretch", "fill-available"), c2, e2, h6).replace(":fill-available", ":stretch") : a.replace(b2, "-webkit-" + b2) + a.replace(b2, "-moz-" + b2.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (a.charCodeAt(5) === 102 ? "-ms-" + a : "") + a, e2 + h6 === 211 && a.charCodeAt(13) === 105 && 0 < a.indexOf("transform", 10))
          return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
    }
    return a;
  }
  function L2(d2, c2) {
    var e2 = d2.indexOf(c2 === 1 ? ":" : "{"), h6 = d2.substring(0, c2 !== 3 ? e2 : 10);
    e2 = d2.substring(e2 + 1, d2.length - 1);
    return R2(c2 !== 2 ? h6 : h6.replace(na, "$1"), e2, c2);
  }
  function ea(d2, c2) {
    var e2 = P2(c2, c2.charCodeAt(0), c2.charCodeAt(1), c2.charCodeAt(2));
    return e2 !== c2 + ";" ? e2.replace(oa, " or ($1)").substring(4) : "(" + c2 + ")";
  }
  function H2(d2, c2, e2, h6, a, m2, b2, v2, n2, q2) {
    for (var g2 = 0, x2 = c2, w3; g2 < A2; ++g2) {
      switch (w3 = S2[g2].call(B2, d2, x2, e2, h6, a, m2, b2, v2, n2, q2)) {
        case void 0:
        case false:
        case true:
        case null:
          break;
        default:
          x2 = w3;
      }
    }
    if (x2 !== c2)
      return x2;
  }
  function T2(d2) {
    switch (d2) {
      case void 0:
      case null:
        A2 = S2.length = 0;
        break;
      default:
        if (typeof d2 === "function")
          S2[A2++] = d2;
        else if (typeof d2 === "object")
          for (var c2 = 0, e2 = d2.length; c2 < e2; ++c2) {
            T2(d2[c2]);
          }
        else
          Y2 = !!d2 | 0;
    }
    return T2;
  }
  function U2(d2) {
    d2 = d2.prefix;
    d2 !== void 0 && (R2 = null, d2 ? typeof d2 !== "function" ? w2 = 1 : (w2 = 2, R2 = d2) : w2 = 0);
    return U2;
  }
  function B2(d2, c2) {
    var e2 = d2;
    33 > e2.charCodeAt(0) && (e2 = e2.trim());
    V2 = e2;
    e2 = [V2];
    if (0 < A2) {
      var h6 = H2(-1, c2, e2, e2, D2, z2, 0, 0, 0, 0);
      h6 !== void 0 && typeof h6 === "string" && (c2 = h6);
    }
    var a = M2(O2, e2, c2, 0, 0);
    0 < A2 && (h6 = H2(-2, a, e2, e2, D2, z2, a.length, 0, 0, 0), h6 !== void 0 && (a = h6));
    V2 = "";
    E2 = 0;
    z2 = D2 = 1;
    return a;
  }
  var ca = /^\0+/g, N2 = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F2 = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q2 = /::(place)/g, ha = /:(read-only)/g, G2 = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z2 = 1, D2 = 1, E2 = 0, w2 = 1, O2 = [], S2 = [], A2 = 0, R2 = null, Y2 = 0, V2 = "";
  B2.use = T2;
  B2.set = U2;
  W2 !== void 0 && U2(W2);
  return B2;
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize(function(prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1 = typeof Symbol === "function" && Symbol.for, c = b$1 ? Symbol.for("react.element") : 60103, d = b$1 ? Symbol.for("react.portal") : 60106, e = b$1 ? Symbol.for("react.fragment") : 60107, f$2 = b$1 ? Symbol.for("react.strict_mode") : 60108, g$1 = b$1 ? Symbol.for("react.profiler") : 60114, h = b$1 ? Symbol.for("react.provider") : 60109, k$1 = b$1 ? Symbol.for("react.context") : 60110, l$3 = b$1 ? Symbol.for("react.async_mode") : 60111, m$2 = b$1 ? Symbol.for("react.concurrent_mode") : 60111, n$3 = b$1 ? Symbol.for("react.forward_ref") : 60112, p$3 = b$1 ? Symbol.for("react.suspense") : 60113, q$1 = b$1 ? Symbol.for("react.suspense_list") : 60120, r = b$1 ? Symbol.for("react.memo") : 60115, t = b$1 ? Symbol.for("react.lazy") : 60116, v$1 = b$1 ? Symbol.for("react.block") : 60121, w$1 = b$1 ? Symbol.for("react.fundamental") : 60117, x$1 = b$1 ? Symbol.for("react.responder") : 60118, y = b$1 ? Symbol.for("react.scope") : 60119;
function z$1(a) {
  if (typeof a === "object" && a !== null) {
    var u2 = a.$$typeof;
    switch (u2) {
      case c:
        switch (a = a.type, a) {
          case l$3:
          case m$2:
          case e:
          case g$1:
          case f$2:
          case p$3:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n$3:
              case t:
              case r:
              case h:
                return a;
              default:
                return u2;
            }
        }
      case d:
        return u2;
    }
  }
}
function A$1(a) {
  return z$1(a) === m$2;
}
reactIs_production_min.AsyncMode = l$3;
reactIs_production_min.ConcurrentMode = m$2;
reactIs_production_min.ContextConsumer = k$1;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n$3;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g$1;
reactIs_production_min.StrictMode = f$2;
reactIs_production_min.Suspense = p$3;
reactIs_production_min.isAsyncMode = function(a) {
  return A$1(a) || z$1(a) === l$3;
};
reactIs_production_min.isConcurrentMode = A$1;
reactIs_production_min.isContextConsumer = function(a) {
  return z$1(a) === k$1;
};
reactIs_production_min.isContextProvider = function(a) {
  return z$1(a) === h;
};
reactIs_production_min.isElement = function(a) {
  return typeof a === "object" && a !== null && a.$$typeof === c;
};
reactIs_production_min.isForwardRef = function(a) {
  return z$1(a) === n$3;
};
reactIs_production_min.isFragment = function(a) {
  return z$1(a) === e;
};
reactIs_production_min.isLazy = function(a) {
  return z$1(a) === t;
};
reactIs_production_min.isMemo = function(a) {
  return z$1(a) === r;
};
reactIs_production_min.isPortal = function(a) {
  return z$1(a) === d;
};
reactIs_production_min.isProfiler = function(a) {
  return z$1(a) === g$1;
};
reactIs_production_min.isStrictMode = function(a) {
  return z$1(a) === f$2;
};
reactIs_production_min.isSuspense = function(a) {
  return z$1(a) === p$3;
};
reactIs_production_min.isValidElementType = function(a) {
  return typeof a === "string" || typeof a === "function" || a === e || a === m$2 || a === g$1 || a === f$2 || a === p$3 || a === q$1 || typeof a === "object" && a !== null && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k$1 || a.$$typeof === n$3 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y || a.$$typeof === v$1);
};
reactIs_production_min.typeOf = z$1;
{
  reactIs$1.exports = reactIs_production_min;
}
var reactIs = reactIs$1.exports;
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }
  return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== "string") {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];
      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
        try {
          defineProperty(targetComponent, key, descriptor);
        } catch (e2) {
        }
      }
    }
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
function v() {
  return (v = Object.assign || function(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var n2 = arguments[t2];
      for (var r2 in n2)
        Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
    }
    return e2;
  }).apply(this, arguments);
}
var g = function(e2, t2) {
  for (var n2 = [e2[0]], r2 = 0, o = t2.length; r2 < o; r2 += 1)
    n2.push(t2[r2], e2[r2 + 1]);
  return n2;
}, S = function(t2) {
  return t2 !== null && typeof t2 == "object" && (t2.toString ? t2.toString() : Object.prototype.toString.call(t2)) === "[object Object]" && !reactIs$2.exports.typeOf(t2);
}, w = Object.freeze([]), E = Object.freeze({});
function b(e2) {
  return typeof e2 == "function";
}
function _(e2) {
  return e2.displayName || e2.name || "Component";
}
function N(e2) {
  return e2 && typeof e2.styledComponentId == "string";
}
var A = typeof process != "undefined" && ({}.REACT_APP_SC_ATTR || {}.SC_ATTR) || "data-styled", I = typeof window != "undefined" && "HTMLElement" in window, P = Boolean(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process != "undefined" && {}.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && {}.REACT_APP_SC_DISABLE_SPEEDY !== "" ? {}.REACT_APP_SC_DISABLE_SPEEDY !== "false" && {}.REACT_APP_SC_DISABLE_SPEEDY : typeof process != "undefined" && {}.SC_DISABLE_SPEEDY !== void 0 && {}.SC_DISABLE_SPEEDY !== "" ? {}.SC_DISABLE_SPEEDY !== "false" && {}.SC_DISABLE_SPEEDY : false);
function j(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  throw new Error("An error occurred. See https://git.io/JUIaE#" + e2 + " for more information." + (n2.length > 0 ? " Args: " + n2.join(", ") : ""));
}
var T = function() {
  function e2(e3) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e3;
  }
  var t2 = e2.prototype;
  return t2.indexOfGroup = function(e3) {
    for (var t3 = 0, n2 = 0; n2 < e3; n2++)
      t3 += this.groupSizes[n2];
    return t3;
  }, t2.insertRules = function(e3, t3) {
    if (e3 >= this.groupSizes.length) {
      for (var n2 = this.groupSizes, r2 = n2.length, o = r2; e3 >= o; )
        (o <<= 1) < 0 && j(16, "" + e3);
      this.groupSizes = new Uint32Array(o), this.groupSizes.set(n2), this.length = o;
      for (var s = r2; s < o; s++)
        this.groupSizes[s] = 0;
    }
    for (var i = this.indexOfGroup(e3 + 1), a = 0, c2 = t3.length; a < c2; a++)
      this.tag.insertRule(i, t3[a]) && (this.groupSizes[e3]++, i++);
  }, t2.clearGroup = function(e3) {
    if (e3 < this.length) {
      var t3 = this.groupSizes[e3], n2 = this.indexOfGroup(e3), r2 = n2 + t3;
      this.groupSizes[e3] = 0;
      for (var o = n2; o < r2; o++)
        this.tag.deleteRule(n2);
    }
  }, t2.getGroup = function(e3) {
    var t3 = "";
    if (e3 >= this.length || this.groupSizes[e3] === 0)
      return t3;
    for (var n2 = this.groupSizes[e3], r2 = this.indexOfGroup(e3), o = r2 + n2, s = r2; s < o; s++)
      t3 += this.tag.getRule(s) + "/*!sc*/\n";
    return t3;
  }, e2;
}(), x = /* @__PURE__ */ new Map(), k$3 = /* @__PURE__ */ new Map(), V = 1, B = function(e2) {
  if (x.has(e2))
    return x.get(e2);
  for (; k$3.has(V); )
    V++;
  var t2 = V++;
  return x.set(e2, t2), k$3.set(t2, e2), t2;
}, z = function(e2) {
  return k$3.get(e2);
}, M = function(e2, t2) {
  t2 >= V && (V = t2 + 1), x.set(e2, t2), k$3.set(t2, e2);
}, G = "style[" + A + '][data-styled-version="5.3.5"]', L = new RegExp("^" + A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), F = function(e2, t2, n2) {
  for (var r2, o = n2.split(","), s = 0, i = o.length; s < i; s++)
    (r2 = o[s]) && e2.registerName(t2, r2);
}, Y = function(e2, t2) {
  for (var n2 = (t2.textContent || "").split("/*!sc*/\n"), r2 = [], o = 0, s = n2.length; o < s; o++) {
    var i = n2[o].trim();
    if (i) {
      var a = i.match(L);
      if (a) {
        var c2 = 0 | parseInt(a[1], 10), u2 = a[2];
        c2 !== 0 && (M(u2, c2), F(e2, u2, a[3]), e2.getTag().insertRules(c2, r2)), r2.length = 0;
      } else
        r2.push(i);
    }
  }
}, q$4 = function() {
  return typeof window != "undefined" && window.__webpack_nonce__ !== void 0 ? window.__webpack_nonce__ : null;
}, H = function(e2) {
  var t2 = document.head, n2 = e2 || t2, r2 = document.createElement("style"), o = function(e3) {
    for (var t3 = e3.childNodes, n3 = t3.length; n3 >= 0; n3--) {
      var r3 = t3[n3];
      if (r3 && r3.nodeType === 1 && r3.hasAttribute(A))
        return r3;
    }
  }(n2), s = o !== void 0 ? o.nextSibling : null;
  r2.setAttribute(A, "active"), r2.setAttribute("data-styled-version", "5.3.5");
  var i = q$4();
  return i && r2.setAttribute("nonce", i), n2.insertBefore(r2, s), r2;
}, $ = function() {
  function e2(e3) {
    var t3 = this.element = H(e3);
    t3.appendChild(document.createTextNode("")), this.sheet = function(e4) {
      if (e4.sheet)
        return e4.sheet;
      for (var t4 = document.styleSheets, n2 = 0, r2 = t4.length; n2 < r2; n2++) {
        var o = t4[n2];
        if (o.ownerNode === e4)
          return o;
      }
      j(17);
    }(t3), this.length = 0;
  }
  var t2 = e2.prototype;
  return t2.insertRule = function(e3, t3) {
    try {
      return this.sheet.insertRule(t3, e3), this.length++, true;
    } catch (e4) {
      return false;
    }
  }, t2.deleteRule = function(e3) {
    this.sheet.deleteRule(e3), this.length--;
  }, t2.getRule = function(e3) {
    var t3 = this.sheet.cssRules[e3];
    return t3 !== void 0 && typeof t3.cssText == "string" ? t3.cssText : "";
  }, e2;
}(), W = function() {
  function e2(e3) {
    var t3 = this.element = H(e3);
    this.nodes = t3.childNodes, this.length = 0;
  }
  var t2 = e2.prototype;
  return t2.insertRule = function(e3, t3) {
    if (e3 <= this.length && e3 >= 0) {
      var n2 = document.createTextNode(t3), r2 = this.nodes[e3];
      return this.element.insertBefore(n2, r2 || null), this.length++, true;
    }
    return false;
  }, t2.deleteRule = function(e3) {
    this.element.removeChild(this.nodes[e3]), this.length--;
  }, t2.getRule = function(e3) {
    return e3 < this.length ? this.nodes[e3].textContent : "";
  }, e2;
}(), U = function() {
  function e2(e3) {
    this.rules = [], this.length = 0;
  }
  var t2 = e2.prototype;
  return t2.insertRule = function(e3, t3) {
    return e3 <= this.length && (this.rules.splice(e3, 0, t3), this.length++, true);
  }, t2.deleteRule = function(e3) {
    this.rules.splice(e3, 1), this.length--;
  }, t2.getRule = function(e3) {
    return e3 < this.length ? this.rules[e3] : "";
  }, e2;
}(), J = I, X = { isServer: !I, useCSSOMInjection: !P }, Z = function() {
  function e2(e3, t3, n2) {
    e3 === void 0 && (e3 = E), t3 === void 0 && (t3 = {}), this.options = v({}, X, {}, e3), this.gs = t3, this.names = new Map(n2), this.server = !!e3.isServer, !this.server && I && J && (J = false, function(e4) {
      for (var t4 = document.querySelectorAll(G), n3 = 0, r2 = t4.length; n3 < r2; n3++) {
        var o = t4[n3];
        o && o.getAttribute(A) !== "active" && (Y(e4, o), o.parentNode && o.parentNode.removeChild(o));
      }
    }(this));
  }
  e2.registerId = function(e3) {
    return B(e3);
  };
  var t2 = e2.prototype;
  return t2.reconstructWithOptions = function(t3, n2) {
    return n2 === void 0 && (n2 = true), new e2(v({}, this.options, {}, t3), this.gs, n2 && this.names || void 0);
  }, t2.allocateGSInstance = function(e3) {
    return this.gs[e3] = (this.gs[e3] || 0) + 1;
  }, t2.getTag = function() {
    return this.tag || (this.tag = (n2 = (t3 = this.options).isServer, r2 = t3.useCSSOMInjection, o = t3.target, e3 = n2 ? new U(o) : r2 ? new $(o) : new W(o), new T(e3)));
    var e3, t3, n2, r2, o;
  }, t2.hasNameForId = function(e3, t3) {
    return this.names.has(e3) && this.names.get(e3).has(t3);
  }, t2.registerName = function(e3, t3) {
    if (B(e3), this.names.has(e3))
      this.names.get(e3).add(t3);
    else {
      var n2 = /* @__PURE__ */ new Set();
      n2.add(t3), this.names.set(e3, n2);
    }
  }, t2.insertRules = function(e3, t3, n2) {
    this.registerName(e3, t3), this.getTag().insertRules(B(e3), n2);
  }, t2.clearNames = function(e3) {
    this.names.has(e3) && this.names.get(e3).clear();
  }, t2.clearRules = function(e3) {
    this.getTag().clearGroup(B(e3)), this.clearNames(e3);
  }, t2.clearTag = function() {
    this.tag = void 0;
  }, t2.toString = function() {
    return function(e3) {
      for (var t3 = e3.getTag(), n2 = t3.length, r2 = "", o = 0; o < n2; o++) {
        var s = z(o);
        if (s !== void 0) {
          var i = e3.names.get(s), a = t3.getGroup(o);
          if (i && a && i.size) {
            var c2 = A + ".g" + o + '[id="' + s + '"]', u2 = "";
            i !== void 0 && i.forEach(function(e4) {
              e4.length > 0 && (u2 += e4 + ",");
            }), r2 += "" + a + c2 + '{content:"' + u2 + '"}/*!sc*/\n';
          }
        }
      }
      return r2;
    }(this);
  }, e2;
}(), K = /(a)(d)/gi, Q = function(e2) {
  return String.fromCharCode(e2 + (e2 > 25 ? 39 : 97));
};
function ee(e2) {
  var t2, n2 = "";
  for (t2 = Math.abs(e2); t2 > 52; t2 = t2 / 52 | 0)
    n2 = Q(t2 % 52) + n2;
  return (Q(t2 % 52) + n2).replace(K, "$1-$2");
}
var te = function(e2, t2) {
  for (var n2 = t2.length; n2; )
    e2 = 33 * e2 ^ t2.charCodeAt(--n2);
  return e2;
}, ne = function(e2) {
  return te(5381, e2);
};
function re(e2) {
  for (var t2 = 0; t2 < e2.length; t2 += 1) {
    var n2 = e2[t2];
    if (b(n2) && !N(n2))
      return false;
  }
  return true;
}
var oe = ne("5.3.5"), se = function() {
  function e2(e3, t2, n2) {
    this.rules = e3, this.staticRulesId = "", this.isStatic = (n2 === void 0 || n2.isStatic) && re(e3), this.componentId = t2, this.baseHash = te(oe, t2), this.baseStyle = n2, Z.registerId(t2);
  }
  return e2.prototype.generateAndInjectStyles = function(e3, t2, n2) {
    var r2 = this.componentId, o = [];
    if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e3, t2, n2)), this.isStatic && !n2.hash)
      if (this.staticRulesId && t2.hasNameForId(r2, this.staticRulesId))
        o.push(this.staticRulesId);
      else {
        var s = Ne(this.rules, e3, t2, n2).join(""), i = ee(te(this.baseHash, s) >>> 0);
        if (!t2.hasNameForId(r2, i)) {
          var a = n2(s, "." + i, void 0, r2);
          t2.insertRules(r2, i, a);
        }
        o.push(i), this.staticRulesId = i;
      }
    else {
      for (var c2 = this.rules.length, u2 = te(this.baseHash, n2.hash), l2 = "", d2 = 0; d2 < c2; d2++) {
        var h6 = this.rules[d2];
        if (typeof h6 == "string")
          l2 += h6;
        else if (h6) {
          var p2 = Ne(h6, e3, t2, n2), f2 = Array.isArray(p2) ? p2.join("") : p2;
          u2 = te(u2, f2 + d2), l2 += f2;
        }
      }
      if (l2) {
        var m2 = ee(u2 >>> 0);
        if (!t2.hasNameForId(r2, m2)) {
          var y2 = n2(l2, "." + m2, void 0, r2);
          t2.insertRules(r2, m2, y2);
        }
        o.push(m2);
      }
    }
    return o.join(" ");
  }, e2;
}(), ie = /^\s*\/\/.*$/gm, ae = [":", "[", ".", "#"];
function ce(e2) {
  var t2, n2, r2, o, s = e2 === void 0 ? E : e2, i = s.options, a = i === void 0 ? E : i, c2 = s.plugins, u2 = c2 === void 0 ? w : c2, l2 = new stylis_min(a), d2 = [], h6 = function(e3) {
    function t3(t4) {
      if (t4)
        try {
          e3(t4 + "}");
        } catch (e4) {
        }
    }
    return function(n3, r3, o2, s2, i2, a2, c3, u3, l3, d3) {
      switch (n3) {
        case 1:
          if (l3 === 0 && r3.charCodeAt(0) === 64)
            return e3(r3 + ";"), "";
          break;
        case 2:
          if (u3 === 0)
            return r3 + "/*|*/";
          break;
        case 3:
          switch (u3) {
            case 102:
            case 112:
              return e3(o2[0] + r3), "";
            default:
              return r3 + (d3 === 0 ? "/*|*/" : "");
          }
        case -2:
          r3.split("/*|*/}").forEach(t3);
      }
    };
  }(function(e3) {
    d2.push(e3);
  }), f2 = function(e3, r3, s2) {
    return r3 === 0 && ae.indexOf(s2[n2.length]) !== -1 || s2.match(o) ? e3 : "." + t2;
  };
  function m2(e3, s2, i2, a2) {
    a2 === void 0 && (a2 = "&");
    var c3 = e3.replace(ie, ""), u3 = s2 && i2 ? i2 + " " + s2 + " { " + c3 + " }" : c3;
    return t2 = a2, n2 = s2, r2 = new RegExp("\\" + n2 + "\\b", "g"), o = new RegExp("(\\" + n2 + "\\b){2,}"), l2(i2 || !s2 ? "" : s2, u3);
  }
  return l2.use([].concat(u2, [function(e3, t3, o2) {
    e3 === 2 && o2.length && o2[0].lastIndexOf(n2) > 0 && (o2[0] = o2[0].replace(r2, f2));
  }, h6, function(e3) {
    if (e3 === -2) {
      var t3 = d2;
      return d2 = [], t3;
    }
  }])), m2.hash = u2.length ? u2.reduce(function(e3, t3) {
    return t3.name || j(15), te(e3, t3.name);
  }, 5381).toString() : "", m2;
}
var ue = r$1.createContext();
ue.Consumer;
var de = r$1.createContext(), he = (de.Consumer, new Z()), pe = ce();
function fe() {
  return react.exports.useContext(ue) || he;
}
function me() {
  return react.exports.useContext(de) || pe;
}
var ve = function() {
  function e2(e3, t2) {
    var n2 = this;
    this.inject = function(e4, t3) {
      t3 === void 0 && (t3 = pe);
      var r2 = n2.name + t3.hash;
      e4.hasNameForId(n2.id, r2) || e4.insertRules(n2.id, r2, t3(n2.rules, r2, "@keyframes"));
    }, this.toString = function() {
      return j(12, String(n2.name));
    }, this.name = e3, this.id = "sc-keyframes-" + e3, this.rules = t2;
  }
  return e2.prototype.getName = function(e3) {
    return e3 === void 0 && (e3 = pe), this.name + e3.hash;
  }, e2;
}(), ge = /([A-Z])/, Se = /([A-Z])/g, we = /^ms-/, Ee = function(e2) {
  return "-" + e2.toLowerCase();
};
function be(e2) {
  return ge.test(e2) ? e2.replace(Se, Ee).replace(we, "-ms-") : e2;
}
var _e = function(e2) {
  return e2 == null || e2 === false || e2 === "";
};
function Ne(e2, n2, r2, o) {
  if (Array.isArray(e2)) {
    for (var s, i = [], a = 0, c2 = e2.length; a < c2; a += 1)
      (s = Ne(e2[a], n2, r2, o)) !== "" && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
    return i;
  }
  if (_e(e2))
    return "";
  if (N(e2))
    return "." + e2.styledComponentId;
  if (b(e2)) {
    if (typeof (l2 = e2) != "function" || l2.prototype && l2.prototype.isReactComponent || !n2)
      return e2;
    var u2 = e2(n2);
    return Ne(u2, n2, r2, o);
  }
  var l2;
  return e2 instanceof ve ? r2 ? (e2.inject(r2, o), e2.getName(o)) : e2 : S(e2) ? function e3(t2, n3) {
    var r3, o2, s2 = [];
    for (var i2 in t2)
      t2.hasOwnProperty(i2) && !_e(t2[i2]) && (Array.isArray(t2[i2]) && t2[i2].isCss || b(t2[i2]) ? s2.push(be(i2) + ":", t2[i2], ";") : S(t2[i2]) ? s2.push.apply(s2, e3(t2[i2], i2)) : s2.push(be(i2) + ": " + (r3 = i2, (o2 = t2[i2]) == null || typeof o2 == "boolean" || o2 === "" ? "" : typeof o2 != "number" || o2 === 0 || r3 in unitlessKeys ? String(o2).trim() : o2 + "px") + ";"));
    return n3 ? [n3 + " {"].concat(s2, ["}"]) : s2;
  }(e2) : e2.toString();
}
var Ae = function(e2) {
  return Array.isArray(e2) && (e2.isCss = true), e2;
};
function Ce(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  return b(e2) || S(e2) ? Ae(Ne(g(w, [e2].concat(n2)))) : n2.length === 0 && e2.length === 1 && typeof e2[0] == "string" ? e2 : Ae(Ne(g(e2, n2)));
}
var Re = function(e2, t2, n2) {
  return n2 === void 0 && (n2 = E), e2.theme !== n2.theme && e2.theme || t2 || n2.theme;
}, De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, je = /(^-|-$)/g;
function Te(e2) {
  return e2.replace(De, "-").replace(je, "");
}
var xe = function(e2) {
  return ee(ne(e2) >>> 0);
};
function ke(e2) {
  return typeof e2 == "string" && true;
}
var Ve = function(e2) {
  return typeof e2 == "function" || typeof e2 == "object" && e2 !== null && !Array.isArray(e2);
}, Be = function(e2) {
  return e2 !== "__proto__" && e2 !== "constructor" && e2 !== "prototype";
};
function ze(e2, t2, n2) {
  var r2 = e2[n2];
  Ve(t2) && Ve(r2) ? Me(r2, t2) : e2[n2] = t2;
}
function Me(e2) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++)
    n2[r2 - 1] = arguments[r2];
  for (var o = 0, s = n2; o < s.length; o++) {
    var i = s[o];
    if (Ve(i))
      for (var a in i)
        Be(a) && ze(e2, i[a], a);
  }
  return e2;
}
var Ge = r$1.createContext();
Ge.Consumer;
var Ye = {};
function qe(e2, t2, n2) {
  var o = N(e2), i = !ke(e2), a = t2.attrs, c2 = a === void 0 ? w : a, d2 = t2.componentId, h6 = d2 === void 0 ? function(e3, t3) {
    var n3 = typeof e3 != "string" ? "sc" : Te(e3);
    Ye[n3] = (Ye[n3] || 0) + 1;
    var r2 = n3 + "-" + xe("5.3.5" + n3 + Ye[n3]);
    return t3 ? t3 + "-" + r2 : r2;
  }(t2.displayName, t2.parentComponentId) : d2, p2 = t2.displayName, f2 = p2 === void 0 ? function(e3) {
    return ke(e3) ? "styled." + e3 : "Styled(" + _(e3) + ")";
  }(e2) : p2, g2 = t2.displayName && t2.componentId ? Te(t2.displayName) + "-" + t2.componentId : t2.componentId || h6, S2 = o && e2.attrs ? Array.prototype.concat(e2.attrs, c2).filter(Boolean) : c2, A2 = t2.shouldForwardProp;
  o && e2.shouldForwardProp && (A2 = t2.shouldForwardProp ? function(n3, r2, o2) {
    return e2.shouldForwardProp(n3, r2, o2) && t2.shouldForwardProp(n3, r2, o2);
  } : e2.shouldForwardProp);
  var C2, I2 = new se(n2, g2, o ? e2.componentStyle : void 0), P2 = I2.isStatic && c2.length === 0, O2 = function(e3, t3) {
    return function(e4, t4, n3, r2) {
      var o2 = e4.attrs, i2 = e4.componentStyle, a2 = e4.defaultProps, c3 = e4.foldedComponentIds, d3 = e4.shouldForwardProp, h7 = e4.styledComponentId, p3 = e4.target;
      var f3 = function(e5, t5, n4) {
        e5 === void 0 && (e5 = E);
        var r3 = v({}, t5, { theme: e5 }), o3 = {};
        return n4.forEach(function(e6) {
          var t6, n5, s, i3 = e6;
          for (t6 in b(i3) && (i3 = i3(r3)), i3)
            r3[t6] = o3[t6] = t6 === "className" ? (n5 = o3[t6], s = i3[t6], n5 && s ? n5 + " " + s : n5 || s) : i3[t6];
        }), [r3, o3];
      }(Re(t4, react.exports.useContext(Ge), a2) || E, t4, o2), y2 = f3[0], g3 = f3[1], S3 = function(e5, t5, n4, r3) {
        var o3 = fe(), s = me(), i3 = t5 ? e5.generateAndInjectStyles(E, o3, s) : e5.generateAndInjectStyles(n4, o3, s);
        return i3;
      }(i2, r2, y2), w2 = n3, _2 = g3.$as || t4.$as || g3.as || t4.as || p3, N2 = ke(_2), A3 = g3 !== t4 ? v({}, t4, {}, g3) : t4, C3 = {};
      for (var I3 in A3)
        I3[0] !== "$" && I3 !== "as" && (I3 === "forwardedAs" ? C3.as = A3[I3] : (d3 ? d3(I3, isPropValid, _2) : !N2 || isPropValid(I3)) && (C3[I3] = A3[I3]));
      return t4.style && g3.style !== t4.style && (C3.style = v({}, t4.style, {}, g3.style)), C3.className = Array.prototype.concat(c3, h7, S3 !== h7 ? S3 : null, t4.className, g3.className).filter(Boolean).join(" "), C3.ref = w2, react.exports.createElement(_2, C3);
    }(C2, e3, t3, P2);
  };
  return O2.displayName = f2, (C2 = r$1.forwardRef(O2)).attrs = S2, C2.componentStyle = I2, C2.displayName = f2, C2.shouldForwardProp = A2, C2.foldedComponentIds = o ? Array.prototype.concat(e2.foldedComponentIds, e2.styledComponentId) : w, C2.styledComponentId = g2, C2.target = o ? e2.target : e2, C2.withComponent = function(e3) {
    var r2 = t2.componentId, o2 = function(e4, t3) {
      if (e4 == null)
        return {};
      var n3, r3, o3 = {}, s2 = Object.keys(e4);
      for (r3 = 0; r3 < s2.length; r3++)
        n3 = s2[r3], t3.indexOf(n3) >= 0 || (o3[n3] = e4[n3]);
      return o3;
    }(t2, ["componentId"]), s = r2 && r2 + "-" + (ke(e3) ? e3 : Te(_(e3)));
    return qe(e3, v({}, o2, { attrs: S2, componentId: s }), n2);
  }, Object.defineProperty(C2, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(t3) {
    this._foldedDefaultProps = o ? Me({}, e2.defaultProps, t3) : t3;
  } }), C2.toString = function() {
    return "." + C2.styledComponentId;
  }, i && hoistNonReactStatics_cjs(C2, e2, { attrs: true, componentStyle: true, displayName: true, foldedComponentIds: true, shouldForwardProp: true, styledComponentId: true, target: true, withComponent: true }), C2;
}
var He = function(e2) {
  return function e3(t2, r2, o) {
    if (o === void 0 && (o = E), !reactIs$2.exports.isValidElementType(r2))
      return j(1, String(r2));
    var s = function() {
      return t2(r2, o, Ce.apply(void 0, arguments));
    };
    return s.withConfig = function(n2) {
      return e3(t2, r2, v({}, o, {}, n2));
    }, s.attrs = function(n2) {
      return e3(t2, r2, v({}, o, { attrs: Array.prototype.concat(o.attrs, n2).filter(Boolean) }));
    }, s;
  }(qe, e2);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e2) {
  He[e2] = He(e2);
});
var styled = He;
const fontSize = {
  h1: 36,
  h2: 28,
  h3: 24,
  h4: 20,
  h5: 16
};
const fontBreakpoint = {
  h1: Ce`
        @media screen and (max-width: ${breakpoints.xl}) {
            font-size: ${fontSize.h1 - 2}px;
        }

        @media screen and (max-width: ${breakpoints.lg}) {
            font-size: ${fontSize.h1 - 4}px;
        }

        @media screen and (max-width: ${breakpoints.md}) {
            font-size: ${fontSize.h1 - 6}px;
        }

        @media screen and (max-width: ${breakpoints.sm}) {
            font-size: ${fontSize.h1 - 8}px;
        }
    `,
  h2: Ce`
        @media screen and (max-width: ${breakpoints.xl}) {
            font-size: ${fontSize.h2 - 2}px;
        }

        @media screen and (max-width: ${breakpoints.lg}) {
            font-size: ${fontSize.h2 - 4}px;
        }

        @media screen and (max-width: ${breakpoints.md}) {
            font-size: ${fontSize.h2 - 6}px;
        }
    `,
  h3: Ce`
        @media screen and (max-width: ${breakpoints.xl}) {
            font-size: ${fontSize.h3 - 2}px;
        }

        @media screen and (max-width: ${breakpoints.lg}) {
            font-size: ${fontSize.h3 - 4}px;
        }

        @media screen and (max-width: ${breakpoints.md}) {
            font-size: ${fontSize.h3 - 6}px;
        }
    `,
  h4: Ce`
        @media screen and (max-width: ${breakpoints.lg}) {
            font-size: ${fontSize.h4 - 2}px;
        }

        @media screen and (max-width: ${breakpoints.md}) {
            font-size: ${fontSize.h4 - 4}px;
        }
    `,
  h5: Ce`
        @media screen and (max-width: ${breakpoints.md}) {
            font-size: ${fontSize.h5 - 2}px;
        }
    `
};
const heading$1 = Ce`
    -webkit-font-smoothing: antialiased;
    color: ${color.grey};
    fill: ${color.grey};
    font-family: 'open-sans', sans-serif;
    font-size: ${fontSize.h1}px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0;

    ${fontBreakpoint.h1};
`;
const h1$1 = Ce`
    font-size: ${fontSize.h1}px;
    line-height: 40px;
    letter-spacing: -0.75px;

    ${fontBreakpoint.h1};
`;
const h2$1 = Ce`
    font-size: ${fontSize.h2}px;
    line-height: 36px;

    ${fontBreakpoint.h2}
`;
const h3$1 = Ce`
    font-size: ${fontSize.h3}px;
    font-weight: 700;
    line-height: 32px;

    ${fontBreakpoint.h3}
`;
const h4$1 = Ce`
    font-size: ${fontSize.h4}px;
    line-height: 28px;

    ${fontBreakpoint.h4}
`;
const h5 = Ce`
    font-size: ${fontSize.h5}px;
    line-height: 25px;

    ${fontBreakpoint.h5}
`;
const ibm$1 = Ce`
    font-family: IBM Plex Mono, 'Lucida Console', sans-serif;
    font-size: 16px;
    font-style: normal;
`;
const ibmMono = Ce`
    font-family: IBM Plex Mono, 'Lucida Console', monospace;
    font-size: 14px;
`;
const text$1 = Ce`
    -webkit-font-smoothing: antialiased;
    color: ${color.grey};
    fill: ${color.grey};
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 24px;
`;
const textBold500 = Ce`
    font-weight: 500;
`;
const textBold = Ce`
    font-weight: 600;
`;
const textBold700 = Ce`
    font-weight: 700;
`;
const textSmall = Ce`
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 24px;
`;
const semiBold = Ce`
    ${text$1};
    font-weight: 600;
`;
const openSans$1 = Ce`
    -webkit-font-smoothing: antialiased;
    font-family: 'Open Sans', Tahoma, sans-serif;
`;
const fonts = {
  h1: h1$1,
  h2: h2$1,
  h3: h3$1,
  h4: h4$1,
  h5,
  heading: heading$1,
  ibm: ibm$1,
  ibmMono,
  text: text$1,
  textBold,
  textBold700,
  textSmall,
  semiBold,
  textBold500,
  openSans: openSans$1
};
const resetCSS = Ce`
    border: none;
    box-sizing: border-box;
    line-height: 1;
    margin: 0;
    outline: none;
    padding: 0;
`;
const resetButtonCSS = Ce`
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font: inherit;
    outline: inherit;
    padding: 0;
`;
styled.h1`
    ${resetCSS};
    ${fonts.heading};
    ${fonts.h1}
    margin-bottom: 12px;

    &:empty {
        display: none;
    }
`;
styled.h2`
    ${resetCSS};
    ${fonts.heading};
    ${fonts.h2}
    margin-bottom: 12px;

    &:empty {
        display: none;
    }
`;
styled.p`
    ${resetCSS};
    ${fonts.text};

    span {
        ${fonts.textBold};
        color: ${color.blue};
    }

    &:last-of-type {
        margin: 8px 0 16px;
    }
`;
const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? ` ${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)} ` : "66, 135, 245";
};
const coloredGreen$1 = Ce$1`
    background: ${color.greenForestLight};
    color: ${color.green};
`;
const coloredGreenDark$1 = Ce$1`
    background: ${color.greenForestDark};
    color: ${color.white};
`;
const coloredRed$1 = Ce$1`
    background: ${color.redLight};
    color: ${color.red};
`;
const coloredRedDark$1 = Ce$1`
    background: ${color.redDark};
    color: ${color.white};
`;
const coloredGrey$1 = Ce$1`
    background: ${color.blueSkyLight};
    color: ${color.blueDark};
`;
const coloredGrayDark$1 = Ce$1`
    background: ${color.grey};
    color: ${color.white};
`;
const coloredYellow$1 = Ce$1`
    background: ${color.yellowLight};
    color: ${color.yellow};
`;
const coloredYellowDark$1 = Ce$1`
    background: ${color.yellowDark};
    color: ${color.white};
`;
const coloredBlue$1 = Ce$1`
    background: ${color.blueCloud};
    color: ${color.blueSkyDark};
`;
const coloredBlueDark$1 = Ce$1`
    background: ${color.blueCloudDark};
    color: ${color.white};
`;
const coloredPurple$1 = Ce$1`
    background: ${color.purpleLight};
    color: ${color.purple};
`;
const coloredPurpleDark$1 = Ce$1`
    background: ${color.purpleDark};
    color: ${color.white};
`;
const coloredPink$1 = Ce$1`
    background: ${color.pinkLight};
    color: ${color.pink};
`;
const coloredPinkDark$1 = Ce$1`
    background: ${color.pinkDark};
    color: ${color.white};
`;
const coloredBlueLight$1 = Ce$1`
    background: ${color.blueLight3};
    color: ${color.blue};
`;
var colorStyles = {
  coloredBlue: coloredBlue$1,
  coloredBlueDark: coloredBlueDark$1,
  coloredGrayDark: coloredGrayDark$1,
  coloredGreen: coloredGreen$1,
  coloredGreenDark: coloredGreenDark$1,
  coloredGrey: coloredGrey$1,
  coloredPink: coloredPink$1,
  coloredPinkDark: coloredPinkDark$1,
  coloredPurple: coloredPurple$1,
  coloredPurpleDark: coloredPurpleDark$1,
  coloredRed: coloredRed$1,
  coloredRedDark: coloredRedDark$1,
  coloredYellow: coloredYellow$1,
  coloredYellowDark: coloredYellowDark$1,
  coloredBlueLight: coloredBlueLight$1
};
const initialStyles$1 = Ce$1`
    ${resetCSS}
    ${fonts.text}
    ${fonts.textBold700};
    align-items: center;
    border-radius: 20px;
    display: flex;
    font-size: 14px;
    justify-content: center;
    overflow: hidden;
    padding: 2px 20px;
    text-align: center;
    width: 100%;
`;
const regular$1 = Ce$1`
    background: ${color.blueLight};
`;
const activeStatus$1 = Ce$1`
    background: ${color.greenForestLight};
    color: ${color.green};
    display: flex;

    svg {
        fill: ${color.green};
        padding-right: 5px;
    }
`;
const inactiveStatus$1 = Ce$1`
    background: ${color.blueLight};
`;
const discount$1 = Ce$1`
    align-items: center;
    background: ${color.green};
    border-radius: 30px;
    color: ${color.white};
    display: flex;
    font-size: 12px;
    height: 32px;
    justify-content: center;
    padding: 0 4px;
    width: 32px;
`;
const chips$1 = Ce$1`
    align-items: center;
    background: ${color.green};
    border-left: 5px solid;
    border-radius: 5px;
    color: ${color.white};
    display: flex;
    font-size: 12px;
    height: 32px;
    justify-content: center;
    padding: 6px 12px;
    width: 32px;
`;
var themeStyles = {
  activeStatus: activeStatus$1,
  chips: chips$1,
  discount: discount$1,
  inactiveStatus: inactiveStatus$1,
  initialStyles: initialStyles$1,
  regular: regular$1
};
const {
  activeStatus,
  discount,
  inactiveStatus,
  initialStyles,
  regular,
  chips
} = themeStyles;
const {
  coloredBlue,
  coloredBlueDark,
  coloredGrayDark,
  coloredGreen,
  coloredGreenDark,
  coloredGrey,
  coloredPink,
  coloredPinkDark,
  coloredPurple,
  coloredPurpleDark,
  coloredRed,
  coloredRedDark,
  coloredYellow,
  coloredYellowDark,
  coloredBlueLight
} = colorStyles;
const getTheme = (theme, active) => {
  switch (theme) {
    case "status":
      return active ? activeStatus : inactiveStatus;
    case "discount":
      return discount;
    case "chips":
      return chips;
    default:
      return regular;
  }
};
const getColors = (color2, tone) => {
  switch (color2) {
    case "green":
      return tone === "light" ? coloredGreen : coloredGreenDark;
    case "red":
      return tone === "light" ? coloredRed : coloredRedDark;
    case "yellow":
      return tone === "light" ? coloredYellow : coloredYellowDark;
    case "blue":
      return tone === "light" ? coloredBlue : coloredBlueDark;
    case "blueLight":
      return coloredBlueLight;
    case "purple":
      return tone === "light" ? coloredPurple : coloredPurpleDark;
    case "pink":
      return tone === "light" ? coloredPink : coloredPinkDark;
    case "grey":
      return tone === "light" ? coloredGrey : coloredGrayDark;
    default:
      return coloredGrey;
  }
};
const SpanStyled$6 = styled$1.div`
    cursor: pointer;
    display: flex;
    margin-left: 8px;
    padding: auto;
    &:hover{
        svg{
            fill: ${color.blue};
        }
    }
`;
const TagStyled$1 = styled$1.div`
    ${initialStyles}
    ${({ active, theme }) => getTheme(theme, active)}
    ${({ color: color2, theme, tone }) => theme !== "status" && color2 && getColors(color2, tone)}
    width: ${({ width }) => width};

    ${({ width, theme }) => theme === "discount" && Boolean(width) && `height: ${width}; width: ${width}; border-radius: 50%;`};

    ${({ theme, tone }) => theme === "chips" && tone === "dark" && "border: 0px;"};

    ${({ fontSize: fontSize2 }) => Boolean(fontSize2) && `font-size: ${fontSize2}`};
`;
var styles$s = {
  SpanStyled: SpanStyled$6,
  TagStyled: TagStyled$1
};
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = r$4, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
function q(c2, a, g2) {
  var b2, d2 = {}, e2 = null, h6 = null;
  g2 !== void 0 && (e2 = "" + g2);
  a.key !== void 0 && (e2 = "" + a.key);
  a.ref !== void 0 && (h6 = a.ref);
  for (b2 in a)
    m.call(a, b2) && !p.hasOwnProperty(b2) && (d2[b2] = a[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a = c2.defaultProps, a)
      d2[b2] === void 0 && (d2[b2] = a[b2]);
  return { $$typeof: k, type: c2, key: e2, ref: h6, props: d2, _owner: n.current };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const {
  TagStyled,
  SpanStyled: SpanStyled$5
} = styles$s;
const Tag = ({
  active = false,
  color: color$1,
  fontSize: fontSize2,
  hasCancel = false,
  id,
  onCancelClick,
  text: text2 = "Tag",
  theme = "regular",
  tone = "light",
  width = "fit-content",
  ...props
}) => {
  return /* @__PURE__ */ jsxs(TagStyled, {
    active,
    color: color$1,
    "data-testid": "test-tag",
    fontSize: fontSize2,
    id,
    role: "status",
    theme,
    tone,
    width,
    ...props,
    children: [theme === "status" && active && /* @__PURE__ */ jsx(SvgCheckmark, {
      title: "checkmark icon",
      titleId: "tag checkmark icon",
      fill: "inherit",
      fontSize: 12
    }), /* @__PURE__ */ jsx("strong", {
      "data-testid": "test-tag-text",
      children: text2
    }), hasCancel && /* @__PURE__ */ jsx(SpanStyled$5, {
      onClick: onCancelClick,
      children: /* @__PURE__ */ jsx(SvgCross, {
        title: "cross icon",
        titleId: "tag cross icon",
        fill: color.grey
      })
    })]
  });
};
const getThemeColor$1 = (theme) => {
  switch (theme) {
    case "blue":
      return color.blue;
    case "red":
      return color.red;
    case "green":
      return color.green;
    case "yellow":
      return color.yellow;
    default:
      return color.blue;
  }
};
const SectionStyled$9 = styled$1.section`
  background-color: ${color.white};
  border: 1px solid ${(p2) => getThemeColor$1(p2.theme)};
  border-radius: 20px;
  opacity: 0%;
  overflow: hidden;
  transition-delay: 0.3s;
  transition: opacity 0.3s ease-out;
`;
const HeaderStyled$a = styled$1.header`
  display: flex;
  cursor: pointer;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 8px 12px;

  &:hover {
    background-color: ${color.paleBlue2};
  }
`;
const H4Styled$5 = styled$1.h4`
  ${resetCSS}
  ${fonts.heading}
    ${fonts.h4}
    line-height: 1;
  padding: 8px 0;
`;
const DivStyled$w = styled$1.div`
  align-items: center;
  display: flex;
  justify-content: center;

  p {
    ${resetCSS}
    ${fonts.text}
        margin: 0 6px;
    min-width: 100px;
    text-align: right;
  }

  svg {
    margin: 0 6px;
    min-width: 18px;
  }

  div {
    margin: 0 6px;
  }

  &:last-of-type {
    margin-left: auto;
  }
`;
const DivStyledContent$6 = styled$1.div`
  overflow: hidden;
  transition: max-height 0.3s ease-out;
`;
var styles$r = {
  DivStyled: DivStyled$w,
  DivStyledContent: DivStyledContent$6,
  H4Styled: H4Styled$5,
  HeaderStyled: HeaderStyled$a,
  SectionStyled: SectionStyled$9,
  getThemeColor: getThemeColor$1
};
const {
  SectionStyled: SectionStyled$8,
  HeaderStyled: HeaderStyled$9,
  H4Styled: H4Styled$4,
  DivStyled: DivStyled$v,
  DivStyledContent: DivStyledContent$5,
  getThemeColor
} = styles$r;
const Accordion = ({
  children,
  hasLockIcon,
  id,
  isExpanded = false,
  subTitle,
  tagText,
  theme = "blue",
  title,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(isExpanded);
  const [height, setHeight] = useState("");
  const [opacity, setOpacity] = useState("0%");
  const [heightWhenOpen, setHeightWhenOpen] = useState("");
  const formattedID = id.replace(/\s/g, "-");
  const divElement = useRef(null);
  useEffect(() => {
    var _a;
    setHeightWhenOpen(`${(_a = divElement.current) == null ? void 0 : _a.clientHeight}px`);
    setHeight(isOpen ? heightWhenOpen : "0px");
    setOpacity("100%");
  }, []);
  const toggleOpen = () => {
    setHeight(isOpen ? "0px" : heightWhenOpen);
    setIsOpen(!isOpen);
  };
  return /* @__PURE__ */ jsxs(SectionStyled$8, {
    "aria-label": "Accordion item",
    "data-testid": "test-accordion",
    id,
    style: {
      opacity
    },
    theme,
    ...props,
    children: [/* @__PURE__ */ jsxs(HeaderStyled$9, {
      "aria-controls": `content-${formattedID}`,
      "aria-expanded": isOpen,
      "data-testid": "test-accordion-header",
      id: `accordion-control-${formattedID}`,
      role: "button",
      onClick: toggleOpen,
      children: [/* @__PURE__ */ jsxs(DivStyled$v, {
        children: [isOpen ? /* @__PURE__ */ jsx(SvgMinus, {
          title: "minus icon",
          titleId: "accordion minus icon",
          fill: getThemeColor(theme)
        }) : /* @__PURE__ */ jsx(SvgPlus, {
          title: "plus icon",
          titleId: "accordion plus icon",
          fill: getThemeColor(theme)
        }), /* @__PURE__ */ jsx(H4Styled$4, {
          "data-testid": "test-accordion-title",
          children: title
        })]
      }), /* @__PURE__ */ jsxs(DivStyled$v, {
        children: [subTitle && /* @__PURE__ */ jsx("p", {
          "data-testid": "test-accordion-subtitle",
          children: subTitle
        }), hasLockIcon && (isOpen ? /* @__PURE__ */ jsx(SvgLockOpen, {
          title: "lock open icon",
          titleId: "accordion lock open icon",
          fill: getThemeColor(theme)
        }) : /* @__PURE__ */ jsx(SvgLockClosed, {
          title: "lock closed icon",
          titleId: "accordion lock closed icon",
          fill: getThemeColor(theme)
        })), tagText && /* @__PURE__ */ jsx(Tag, {
          text: tagText,
          color: theme,
          tone: "dark"
        })]
      })]
    }), /* @__PURE__ */ jsx(DivStyledContent$5, {
      "aria-hidden": isOpen,
      "data-testid": "test-accordion-content",
      id: `content-${formattedID}`,
      ref: divElement,
      style: {
        maxHeight: height
      },
      children
    })]
  });
};
const roundedEdgeValue = "50%";
const customBackgroundImage = Ce$1`
    background-image: url(${(p2) => p2.image});
    background-position: center;
    background-size: cover;
`;
const DivStyled$u = styled$1.div`
    background: radial-gradient(
        106.45% 108.64% at 32.33% -4.84%,
        #ecf5fc 0.52%,
        #cee4f3 100%
    );
    align-items: center;
    background: ${(p2) => p2.avatarBackground};
    color: ${(props) => props.textColor};
    display: flex;
    flex-direction: column;
    font-size: ${(props) => props.fontSize}px;
    justify-content: center;
    overflow: hidden;
    position: static;
    text-transform: uppercase;
    word-break: break-all;
    ${(p2) => p2.theme === "image" && p2.image && customBackgroundImage};
    span {
        display: none;
    }
    &,
    & > svg {
        height: ${(props) => props.size}px;
        width: ${(props) => props.size}px;
        border-radius: ${(p2) => `${p2.isRounded ? roundedEdgeValue : p2.borderRadius ? `${p2.borderRadius}px` : `${0}px`}`};
    }
`;
const H4Styled$3 = styled$1.h4`
    ${fonts.h4};
    ${fonts.openSans};
    ${fonts.textBold700};
    ${resetCSS};
    color: ${(props) => props.color};
    font-size: inherit;
`;
var styles$q = {
  DivStyled: DivStyled$u,
  H4Styled: H4Styled$3
};
const renderAvatarSVG = () => {
  return /* @__PURE__ */ jsxs("svg", {
    fill: "none",
    height: "40",
    viewBox: "0 0 40 40",
    width: "40",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip0_10877_58906)",
      children: [/* @__PURE__ */ jsx("rect", {
        width: "40",
        height: "40",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M2655.97 1057.92L2057.33 379.103C1974.04 358.083 1855.23 342.077 1768.36 386.995C1562.46 493.432 1477.8 775.773 1221.78 809.817C1021.37 836.472 989.753 682.586 779.595 788.994C548.347 906.028 635.71 1038.26 388.719 1188.91C141.728 1339.56 56.6274 1011.8 -190.072 1158.21C-252.53 1195.35 -301.639 1253.8 -340.231 1320.53L840.276 2659.15L2655.97 1057.92Z",
        fill: "url(#paint0_linear_10877_58906)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M439.737 116.96C511.511 272.122 425.49 442.871 300.446 558.684C185.56 665.091 21.4207 705.627 -117.844 633.385C-261.418 558.908 -339.193 399.814 -313.765 240.07C-287.201 73.1916 -168.35 -67.7567 -1.90678 -94.951C175.938 -124.008 363.851 -47.093 439.737 116.96Z",
        fill: "#21BF96"
      }), /* @__PURE__ */ jsx("g", {
        opacity: "0.6",
        filter: "url(#filter0_f_10877_58906)",
        children: /* @__PURE__ */ jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M177.359 394.15C264.368 312.52 332.423 143.281 391.099 155.128C445.008 166.014 402.95 286.025 358.726 367.158C313.132 450.802 223.772 536.204 137.68 579.776C47.742 625.295 -116.532 625.735 -125.499 567.1C-135.08 504.447 85.365 480.457 177.359 394.15Z",
          fill: "url(#paint1_radial_10877_58906)"
        })
      }), /* @__PURE__ */ jsxs("g", {
        filter: "url(#filter1_d_10877_58906)",
        children: [/* @__PURE__ */ jsx("path", {
          d: "M41.5756 40.4351C41.5141 39.8975 41.3817 32.4488 40.4484 27.2467C40.4484 27.2467 53.821 28.186 54.7487 27.7444C55.0811 27.5837 56.6429 26.0358 58.5677 24.1074C61.8308 20.8758 66.1678 16.5713 67.6046 16.1229C69.8984 15.3833 71.1984 14.878 72.6334 15.572C74.0684 16.266 74.9137 16.8282 74.0474 17.8074C73.0553 18.9364 71.0015 18.2202 71.0015 18.2202C71.0015 18.2202 70.6387 19.6055 69.1798 22.6828C69.1798 22.6828 64.0753 33.8454 57.1038 37.6459C55.1911 38.6936 41.5756 40.4351 41.5756 40.4351Z",
          fill: "white"
        }), /* @__PURE__ */ jsx("path", {
          d: "M-0.986503 43.669C-0.986503 43.669 3.8564 49.2966 7.91557 50.2329L8.27048 49.4256C8.27048 49.4256 9.31383 65.7372 12.5173 73.9434C13.0355 75.2856 39.3018 69.8623 41.5502 67.4015C41.5502 67.4015 37.7196 47.6658 36.9513 41.4612L42.0353 40.8835C42.0353 40.8835 42.1205 29.5839 40.4329 27.2346C40.4329 27.2346 28.4281 25.8873 22.0257 28.319C15.6233 30.7507 8.33864 31.2984 3.60985 36.0929C-0.49119 40.249 -0.986503 43.669 -0.986503 43.669Z",
          fill: "#041836"
        }), /* @__PURE__ */ jsx("path", {
          d: "M42.0356 40.9101L36.9516 41.4877L36.191 39.7568L42.0356 40.9101Z",
          fill: "#041836"
        }), /* @__PURE__ */ jsx("path", {
          d: "M23.2713 12.7689C24.3024 14.8339 27.2744 20.8483 26.1859 22.9945C25.0974 25.1407 22.7183 26.0994 22.7183 26.0994L21.8438 28.689C22.2184 29.4649 21.3266 31.311 19.6239 33.1047C18.3677 34.4365 15.9175 33.536 15.1141 31.9283C14.7526 31.1939 12.7221 27.7663 12.7221 27.7663C12.7221 27.7663 9.08349 21.2061 9.33543 18.8695C9.58737 16.533 9.78318 14.2782 14.5973 12.3066C21.9843 9.29647 23.2713 12.7689 23.2713 12.7689Z",
          fill: "white"
        }), /* @__PURE__ */ jsx("path", {
          d: "M12.9772 23.2278C13.6899 24.435 14.5718 27.3514 13.5774 27.6407C12.583 27.93 11.4777 27.268 10.2826 25.1182C9.08758 22.9683 5.69286 18.6962 6.33899 16.7091C6.98511 14.722 8.34359 14.9745 8.34359 14.9745C8.34359 14.9745 5.00401 12.7129 6.33897 10.6526C6.33897 10.6526 6.66675 9.81739 8.31551 11.9872C8.31551 11.9872 7.23424 9.56359 9.59795 7.72377C11.9617 5.88396 15.6038 8.14973 15.6038 8.14973C15.6038 8.14973 14.9703 7.19132 15.9462 6.24108C16.9221 5.29083 19.7834 5.30229 20.9814 7.23193C20.9814 7.23193 22.7033 4.03441 25.9543 4.72565C29.2052 5.4169 31.1543 7.75596 28.8031 11.702C26.3393 15.8392 22.5957 11.934 21.6054 11.9205C20.6151 11.907 19.5016 11.8505 18.3117 14.3671C17.1219 16.8836 13.1897 16.7199 13.1897 16.7199C13.1897 16.7199 15.2978 19.5016 15.2078 20.051C15.1178 20.6003 14.8028 21.5045 13.8166 20.1834C12.8303 18.8623 13.1476 18.7978 12.7376 18.5995C12.3276 18.4012 10.8482 17.9406 10.5743 19.8639C10.27 22.0071 12.9772 23.2278 12.9772 23.2278Z",
          fill: "#041836"
        }), /* @__PURE__ */ jsx("path", {
          d: "M13.9268 23.1445C12.5774 23.2362 11.0034 22.6504 10.587 20.9104C10.1705 19.1704 11.0943 17.9992 11.822 18.1055C12.5496 18.2118 13.3534 18.7871 13.8471 19.9087",
          stroke: "#041836",
          strokeWidth: "2.1688",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ jsx("path", {
          d: "M8.34365 14.9752C8.34365 14.9752 6.54126 13.9871 4.87842 14.873",
          stroke: "#041836",
          strokeWidth: "2.1688",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ jsx("path", {
          d: "M11.9285 73.7021L6.29912 36.5714",
          stroke: "#041836",
          strokeWidth: "2.1688",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ jsx("path", {
          d: "M14.248 31.8201C14.4094 33.1025 17.2106 36.513 20.0072 34.1973C22.8039 31.8817 23.3505 29.1224 23.3505 29.1224",
          stroke: "#041836",
          strokeWidth: "2.1688",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ jsx("path", {
          d: "M12.9428 91.8226L12.9443 71.0192C12.9443 71.0192 11.1314 46.8785 11.3347 43.7516L11.6749 33.5597",
          stroke: "#041836",
          strokeWidth: "2.1688",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ jsx("path", {
          d: "M39.0663 26.6921C41.1035 29.6242 40.6686 40.3409 40.6686 40.3409",
          stroke: "#041836",
          strokeWidth: "2.1688",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ jsx("path", {
          d: "M21.8292 28.7024L22.7036 26.1127C22.7036 26.1127 21.1097 26.9857 19.8753 26.7212C19.258 26.5889 18.8624 27.3543 19.3101 27.8146C19.7853 28.2753 20.5642 28.6576 21.8292 28.7024Z",
          fill: "#041836"
        }), /* @__PURE__ */ jsx("path", {
          d: "M18.7236 18.4468C18.8152 18.7922 19.0598 19.0158 19.2806 18.9637C19.5014 18.9117 19.6159 18.5829 19.5243 18.2375C19.4328 17.8921 19.1882 17.6686 18.9674 17.7206C18.7466 17.7727 18.6456 18.1154 18.7236 18.4468Z",
          fill: "#041836"
        }), /* @__PURE__ */ jsx("path", {
          d: "M22.5884 17.4805C22.68 17.8259 22.9246 18.0495 23.1454 17.9974C23.3662 17.9454 23.4807 17.6166 23.3892 17.2712C23.2976 16.9258 23.053 16.7023 22.8322 16.7543C22.6114 16.8064 22.4968 17.1352 22.5884 17.4805Z",
          fill: "#041836"
        }), /* @__PURE__ */ jsx("path", {
          d: "M21.3989 17.9601C21.3989 17.9601 22.6816 19.7257 23.7722 20.4563C23.3084 21.1794 22.2216 21.1784 22.2216 21.1784L21.3989 17.9601Z",
          fill: "#21BF96"
        }), /* @__PURE__ */ jsx("path", {
          d: "M20.6904 22.479C20.9244 22.4684 21.1999 22.4447 21.4621 22.3794C21.5175 22.3527 21.5593 22.3119 21.5326 22.2565C21.5058 22.2011 21.4651 22.1592 21.4097 22.186C19.9051 22.5647 18.954 21.6983 18.9404 21.6844C18.8997 21.6425 18.8308 21.6554 18.7889 21.6961C18.7471 21.7368 18.7599 21.8058 18.8006 21.8476C18.8417 21.862 19.5347 22.4908 20.6904 22.479Z",
          fill: "#041836"
        }), /* @__PURE__ */ jsx("path", {
          d: "M17.2094 17.5042C17.2919 17.5053 17.3612 17.4649 17.3899 17.3827C17.7591 16.5343 18.4901 16.3929 18.5041 16.3793C18.6145 16.3533 18.6846 16.2579 18.6725 16.1338C18.6465 16.0233 18.5512 15.9532 18.4272 15.9653C18.3857 15.9785 17.4478 16.1584 17.007 17.2123C16.9644 17.3081 17.0175 17.4465 17.1133 17.4891C17.1543 17.5034 17.1819 17.5038 17.2094 17.5042Z",
          fill: "#041836"
        }), /* @__PURE__ */ jsx("path", {
          d: "M23.8919 15.7228C23.9469 15.7235 23.9883 15.7103 24.0302 15.6696C24.1138 15.5882 24.1292 15.4645 24.0478 15.3808C23.3032 14.5035 22.3525 14.6144 22.325 14.6141C22.201 14.6261 22.1309 14.7215 22.143 14.8456C22.1551 14.9696 22.2644 15.0262 22.3744 15.0277C22.4158 15.0145 23.1457 14.9556 23.7415 15.6519C23.7683 15.7073 23.8369 15.722 23.8919 15.7228Z",
          fill: "#041836"
        })]
      }), /* @__PURE__ */ jsx("path", {
        d: "M-1.07651 45.8184C-0.633859 49.0539 4.02847 57.6014 13.4115 60.397C19.1449 62.1096 26.8011 61.8608 36.868 56.6284C37.1865 56.4506 40.9735 54.7479 41.8552 53.1975C42.7068 51.7242 39.349 53.239 39.7547 52.9974C40.3012 52.6686 41.1528 52.219 41.6557 51.8197C42.4352 51.1905 43.2131 50.1334 42.3011 49.9185C41.3891 49.7035 39.535 50.7839 39.535 50.7839C39.535 50.7839 42.5794 48.8882 41.9088 48.0557C41.2382 47.2232 38.1201 48.921 38.1201 48.921C38.1201 48.921 41.6506 46.646 40.4637 46.0652C39.783 45.7362 38.4335 46.4357 37.54 46.8333C36.1821 47.4406 34.8141 48.3465 33.8385 48.8632C33.8385 48.8632 35.9457 45.8614 34.9449 45.6918C33.944 45.5221 30.9232 49.1094 30.3147 49.7789C29.6894 50.4685 18.0785 52.4166 13.77 47.9689C9.46146 43.5211 9.23008 41.9973 7.76487 41.4232C6.2829 40.8691 -1.72874 41.0944 -1.07651 45.8184Z",
        fill: "white",
        stroke: "#041836",
        strokeWidth: "2",
        strokeMiterlimit: "10"
      }), /* @__PURE__ */ jsx("path", {
        d: "M3.63442 55.7202C3.63442 55.7202 9.651 50.5207 13.8336 48.0562C13.8336 48.0562 8.48903 41.0038 7.82001 35.0715C6.69849 35.4154 3.35568 34.4348 0.0431878 40.3379C-1.71699 43.4757 -3.71183 48.5333 3.63442 55.7202Z",
        fill: "#041836"
      })]
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("filter", {
        id: "filter0_f_10877_58906",
        x: "-245.802",
        y: "34.5374",
        width: "782.296",
        height: "698.094",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/* @__PURE__ */ jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /* @__PURE__ */ jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /* @__PURE__ */ jsx("feGaussianBlur", {
          stdDeviation: "60",
          result: "effect1_foregroundBlur_10877_58906"
        })]
      }), /* @__PURE__ */ jsxs("filter", {
        id: "filter1_d_10877_58906",
        x: "-91.406",
        y: "-85.3722",
        width: "277.847",
        height: "321.256",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/* @__PURE__ */ jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /* @__PURE__ */ jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /* @__PURE__ */ jsx("feOffset", {
          dx: "10",
          dy: "10"
        }), /* @__PURE__ */ jsx("feGaussianBlur", {
          stdDeviation: "50"
        }), /* @__PURE__ */ jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.0159375 0 0 0 0 0.0945625 0 0 0 0 0.2125 0 0 0 0.2 0"
        }), /* @__PURE__ */ jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_10877_58906"
        }), /* @__PURE__ */ jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_10877_58906",
          result: "shape"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_10877_58906",
        x1: "1748.12",
        y1: "1858.54",
        x2: "548.994",
        y2: "498.799",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#21BF96"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.9999",
          stopColor: "#DAFF51"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#DAFF51"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint1_radial_10877_58906",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(160.676 395.235) rotate(-43.7182) scale(263.015 120.42)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#B7E803"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#DAFF51"
        })]
      }), /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_10877_58906",
        children: /* @__PURE__ */ jsx("rect", {
          width: "40",
          height: "40",
          fill: "white"
        })
      })]
    })]
  });
};
const {
  DivStyled: DivStyled$t,
  H4Styled: H4Styled$2
} = styles$q;
const avatarColors = ["#FEB7B7", "#E1B5F6", "#A7D6F9", "#AADCD6", "#F0DC7D"];
const Avatar = ({
  avatarBackground,
  borderRadius,
  fontSize: fontSize2 = 15,
  image,
  isRounded = false,
  size: size2 = 40,
  text: text2,
  textColor = color.white,
  theme,
  avatarKey = 1,
  ...props
}) => {
  const getRandomColor = () => {
    if (avatarBackground) {
      return avatarBackground;
    }
    if (theme == "image" || image) {
      return "transparent";
    }
    const pos = avatarKey % avatarColors.length;
    return avatarColors[pos - 1] || "#FEB7B7";
  };
  return /* @__PURE__ */ jsx(DivStyled$t, {
    "aria-label": "users avatar",
    avatarBackground: getRandomColor(),
    borderRadius,
    "data-testid": "test-avatar",
    fontSize: fontSize2,
    image,
    isRounded,
    role: theme === "image" ? "img" : "generic",
    size: size2,
    textColor,
    theme,
    ...props,
    children: theme === "image" ? !image && renderAvatarSVG() : /* @__PURE__ */ jsx(H4Styled$2, {
      "data-testid": "test-avatar-title",
      textColor,
      children: text2 && text2.length > 1 ? `${text2[0]}${text2[1]}` : text2
    })
  });
};
const getBackgroundColor$1 = (type) => {
  switch (type) {
    case "danger":
      return color.red;
    case "success":
      return color.green;
    case "warning":
      return color.yellow;
    default:
      return color.blue;
  }
};
const DivStyled$s = styled$1.div`
    ${resetCSS}
    ${fonts.text}
    align-items: center;
    border-radius: 6px;
    display: flex;
    height: min-content;
    justify-content: center;
    overflow: hidden;
    padding: 4px 10px;
    width: min-content;
    background-color: ${({ state = "normal" }) => getBackgroundColor$1(state)};
`;
var styles$p = { DivStyled: DivStyled$s };
const ButtonStyled = styled$1.button`
  ${resetButtonCSS};
  display: inline-block;
  vertical-align: sub;

  &:first-child {
    fill: ${color.grey};
    transition: fill 0.2s ease-out;
  }

  &:hover > svg {
    fill: ${color.blue};
  }
`;
const useCopyToClipboard = () => {
  const [copiedText, setCopiedText] = useState(null);
  const copy = async (text2) => {
    if (!(navigator == null ? void 0 : navigator.clipboard)) {
      console.warn("Clipboard not supported");
      return false;
    }
    try {
      await navigator.clipboard.writeText(text2);
      setCopiedText(text2);
      return true;
    } catch (error2) {
      console.warn("Copy failed", error2);
      setCopiedText(null);
      return false;
    }
  };
  return [copiedText, copy];
};
const CopyButton = ({
  text: text2,
  iconSize = 24,
  onCopy = () => {
  },
  revertIn = 3e3,
  ...props
}) => {
  const [, copy] = useCopyToClipboard();
  const [value, set] = useState(false);
  const copyToClipboard = () => {
    copy(`${text2}`);
    set(true);
    setTimeout(() => {
      set(false);
    }, revertIn);
  };
  return /* @__PURE__ */ jsx(ButtonStyled, {
    className: "input_copy",
    "data-testid": "test-copy-button",
    iconSize,
    onClick: (e2) => {
      onCopy(e2);
      copyToClipboard();
    },
    ...props,
    children: value ? /* @__PURE__ */ jsx(SvgCheck, {
      title: "check icon",
      titleId: "copybutton check icon",
      fill: color.green,
      fontSize: iconSize
    }) : /* @__PURE__ */ jsx(SvgCopy, {
      title: "copy icon",
      titleId: "copybutton copy icon",
      fill: color.blue,
      fontSize: iconSize
    })
  });
};
const openSans = Ce$1`
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'Open Sans', Tahoma, Verdana, sans-serif;
`;
const getCSSWeight = (weight) => {
  switch (weight) {
    case "regular":
    case "400":
      return Ce$1`
                font-weight: 400;
            `;
    case "medium":
    case "500":
      return Ce$1`
                font-weight: 500;
            `;
    case "semibold":
    case "600":
      return Ce$1`
                font-weight: 600;
            `;
    case "bold":
    case "700":
      return Ce$1`
                font-weight: 700;
            `;
    default:
      return Ce$1`
                font-weight: ${weight};
            `;
  }
};
const text = Ce$1`
    ${openSans};
    color: ${color.grey};
    fill: ${color.grey};
    font-style: normal;
    letter-spacing: 0;
`;
const heading = Ce$1`
    ${openSans};
    color: ${color.blueDark};
    fill: ${color.blueDark};
    font-style: normal;
    letter-spacing: 0;
`;
const h1 = Ce$1`
    ${heading};
    font-weight: 600;
    font-size: 36px;
    line-height: 40px;
    letter-spacing: -0.75px;
    ${fontBreakpoint.h1};
`;
const h2 = Ce$1`
    ${heading};
    font-size: 32px;
    font-weight: 400;
    line-height: 36px;
    ${fontBreakpoint.h2}
`;
const h3 = Ce$1`
    ${heading};
    font-size: 24px;
    font-weight: 400;
    line-height: 32px;
    ${fontBreakpoint.h3}
`;
const h4 = Ce$1`
    ${heading};
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    ${fontBreakpoint.h4}
`;
const subtitle1 = Ce$1`
    ${heading};
    font-weight: 600;
    color: ${color.blueDark};
    fill: ${color.blueDark};
    font-size: 18px;
    line-height: 24px;
`;
const subtitle2 = Ce$1`
    ${heading};
    font-weight: 600;
    color: ${color.blueDark};
    fill: ${color.blueDark};
    font-size: 16px;
    line-height: 24px;
`;
const caption14 = Ce$1`
    ${text};
    font-size: 14px;
    line-height: 24px;
`;
const caption12 = Ce$1`
    ${text};
    font-size: 12px;
    line-height: 1.5;
`;
const caption10 = Ce$1`
    ${text};
    font-size: 10px;
    line-height: 1.5;
`;
const body18 = Ce$1`
    ${text};
    font-size: 18px;
    line-height: 24px;
`;
const body16 = Ce$1`
    ${text};
    font-size: 16px;
    line-height: 24px;
`;
const italicFont = Ce$1`
    font-style: italic;
`;
const ibm = Ce$1`
    font-family: 'IBM Plex Mono', 'Lucida Console', monospace;
`;
const getFontStyle = (variant) => {
  switch (variant) {
    case "h1":
      return h1;
    case "h2":
      return h2;
    case "h3":
      return h3;
    case "h4":
      return h4;
    case "subtitle1":
      return subtitle1;
    case "subtitle2":
      return subtitle2;
    case "body18":
      return body18;
    case "body16":
      return body16;
    case "caption14":
      return caption14;
    case "caption12":
      return caption12;
    case "caption10":
      return caption10;
    default:
      return body16;
  }
};
const getTypographyStyle = (p2) => Ce$1`
    ${getFontStyle(p2.variant || "body16")};
    ${(p2 == null ? void 0 : p2.monospace) && ibm};
    ${(p2 == null ? void 0 : p2.color) && `color: ${p2.color}`};
    ${(p2 == null ? void 0 : p2.italic) && italicFont};
    ${(p2 == null ? void 0 : p2.weight) && getCSSWeight(p2.weight)};
`;
const getTag = (variant) => {
  switch (variant) {
    case "h1":
      return "h1";
    case "h2":
      return "h2";
    case "h3":
      return "h3";
    case "h4":
      return "h4";
    case "subtitle1":
    case "subtitle2":
      return "h2";
    case "body18":
    case "body16":
    case "caption10":
    case "caption12":
    case "caption14":
    default:
      return "span";
  }
};
const DynamicText = ({
  children,
  copyable,
  iconSize,
  italic,
  monospace,
  onCopy,
  variant = "body16",
  ...props
}) => {
  const Tag2 = getTag(variant);
  return /* @__PURE__ */ jsxs(Tag2, {
    "data-testid": "test-typography",
    ...props,
    children: [children, copyable && /* @__PURE__ */ jsx(CopyButton, {
      iconSize,
      onCopy,
      text: `${children}`
    })]
  });
};
const Typography = styled$1(DynamicText)`
    ${(p2) => getTypographyStyle(p2)};
    margin: 0;
    position: relative;
`;
const {
  DivStyled: DivStyled$r
} = styles$p;
const Badge = ({
  state = "normal",
  text: text2,
  textVariant = "body16",
  ...props
}) => {
  return /* @__PURE__ */ jsx(DivStyled$r, {
    "data-testid": "test-badge",
    state,
    ...props,
    children: /* @__PURE__ */ jsx(Typography, {
      color: "white",
      "data-testid": "test-badge-text",
      variant: textVariant,
      weight: "bold",
      children: text2
    })
  });
};
const rotate = Ue`
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
`;
const StyledSpinnerParent = styled$1.div`
    ${fonts.text}
    display: flex;
    flex-direction: ${(props) => props.direction == "bottom" ? "column" : "row"};
    align-items: center;
    justify-content: center;
    max-width: fit-content;
    text-align: center;
    & > span {
        color: ${(props) => props.spinnerColor};
        font-weight: 500;
        font-size: ${(props) => `${props.fontSize ? props.fontSize : props.size && props.size / 2}px`};
        line-height: 5px;
        margin: 8px;
    }
`;
const StyledSpinnerDiv = styled$1.div`
    width: ${(props) => `${props.size}px`};
    height: ${(props) => `${props.size}px`};
    box-sizing: border-box;
    border: 2px solid ${(props) => props.spinnerColor};
    border-bottom: transparent;
    border-right: transparent;
    border-radius: 50%;
    animation: 1s ${rotate} infinite;
`;
const waveAnim = Ue`
    from {height: 2px; width: 2px;}
    to {height: 7px;width: 7px;}
`;
const DivStyledWaveLoader = styled$1.div`
    display: flex;
    justify-content: center;
    width: fit-content;

    span {
        align-items: center;
        display: flex;
        height: 10px;
        justify-content: center;
        width: 10px;

        &:before {
            animation-direction: alternate;
            animation-duration: 0.4s;
            animation-iteration-count: infinite;
            animation-name: ${waveAnim};
            background-color: ${(props) => props.spinnerColor};
            border-radius: 50%;
            content: '';
            display: block;
        }

        &#anim-delay1:before {
            animation-delay: 0s;
        }
        &#anim-delay2:before {
            animation-delay: 0.1s;
        }
        &#anim-delay3:before {
            animation-delay: 0.2s;
        }
        &#anim-delay4:before {
            animation-delay: 0.3s;
        }
        &#anim-delay5:before {
            animation-delay: 0.4s;
        }
    }
`;
const Loading = ({
  direction = "bottom",
  fontSize: fontSize2,
  size: size2 = 20,
  spinnerColor = color.white,
  spinnerType = "loader",
  text: text2,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(StyledSpinnerParent, {
    "data-testid": "test-loading",
    direction,
    fontSize: fontSize2,
    role: "spinner",
    size: size2,
    spinnerColor,
    ...props,
    children: [spinnerType == "loader" ? /* @__PURE__ */ jsx(StyledSpinnerDiv, {
      spinnerColor,
      size: size2
    }) : /* @__PURE__ */ jsx(WaveLoader, {
      size: size2,
      spinnerColor
    }), text2 && /* @__PURE__ */ jsx("span", {
      children: text2
    })]
  });
};
const WaveLoader = ({
  size: size2,
  spinnerColor,
  ...props
}) => /* @__PURE__ */ jsxs(DivStyledWaveLoader, {
  "aria-busy": "true",
  "aria-label": "loading, please wait",
  "data-testid": "test-loading",
  role: "alert",
  size: size2,
  spinnerColor,
  ...props,
  children: [/* @__PURE__ */ jsx("span", {
    "aria-hidden": "true",
    id: "anim-delay1"
  }), /* @__PURE__ */ jsx("span", {
    "aria-hidden": "true",
    id: "anim-delay2"
  }), /* @__PURE__ */ jsx("span", {
    "aria-hidden": "true",
    id: "anim-delay3"
  }), /* @__PURE__ */ jsx("span", {
    "aria-hidden": "true",
    id: "anim-delay4"
  }), /* @__PURE__ */ jsx("span", {
    "aria-hidden": "true",
    id: "anim-delay5"
  })]
});
const iconLeading = Ce$1`
    span {
        flex-direction: row-reverse;
    }
    svg {
        margin-right: 12px;
    }
`;
const iconTrailing = Ce$1`
    span {
        flex-direction: row;
    }
    svg {
        margin-left: 12px;
    }
`;
const iconOnly = Ce$1`
    align-items: center;
    border-width: 0;
    display: flex;
    height: 32px;
    justify-content: center;
    padding: 0;
    width: 32px;
    text-indent: -99999px;
`;
const smallIconResize$1 = () => Ce$1`
    height: 24px;
    width: 24px;
`;
const largeIconResize$1 = () => Ce$1`
    border-width: 4px;
    height: 40px;
    width: 40px;
`;
const getIconLayoutStyles$1 = (iconLayout) => {
  switch (iconLayout) {
    case "trailing":
      return iconTrailing;
    case "icon-only":
      return iconOnly;
    default:
      return iconLeading;
  }
};
const getIconColor$1 = (color2) => {
  return Ce$1`
        svg {
            fill: ${color2};
        }
    `;
};
var iconStyles = {
  getIconColor: getIconColor$1,
  getIconLayoutStyles: getIconLayoutStyles$1,
  largeIconResize: largeIconResize$1,
  smallIconResize: smallIconResize$1
};
const sizeSmall = Ce$1`
    border-radius: 20px;
    font-size: 14px;
    padding: 0 16px;
`;
const sizeRegular = Ce$1`
    font-size: 14px;
    padding: 2px 14px;
`;
const sizeLarge = Ce$1`
    padding: 6px 22px;
`;
const sizeXL = Ce$1`
    padding: 16px 24px;
`;
const getSizeStyles$1 = (size2) => {
  switch (size2) {
    case "large":
      return sizeLarge;
    case "small":
      return sizeSmall;
    case "xl":
      return sizeXL;
    default:
      return sizeRegular;
  }
};
var sizeStyles = {
  getSizeStyles: getSizeStyles$1
};
const linkStyles$1 = Ce$1`
    background-color: transparent;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid ${color.blue};
    padding: 0px;
    color: ${color.blue};

    :active {
        border-width: 0px;
        border-bottom: 1px solid ${color.blue};
    }

    :hover {
        color: ${color.blueSkyDark};
        border-bottom: 1px solid ${color.blueSkyDark};
    }

    svg {
        fill: ${color.blue};
    }
`;
const textStyles$1 = Ce$1`
    background-color: transparent;
    border-width: 0px;
    color: ${color.blue};

    svg {
        fill: ${color.blue};
    }
`;
const transparentStyles$1 = Ce$1`
    background-color: transparent;
    border-color: transparent;
`;
var PropDisplayStyles = {
  linkStyles: linkStyles$1,
  textStyles: textStyles$1,
  transparentStyles: transparentStyles$1
};
const { getIconColor, getIconLayoutStyles, largeIconResize, smallIconResize } = iconStyles;
const { getSizeStyles } = sizeStyles;
const { linkStyles, textStyles, transparentStyles } = PropDisplayStyles;
const BaseButtonStyled$1 = styled$1.button`
    ${resetCSS}
    ${fonts.text}
    align-items: center;
    background-origin: border-box;
    border-radius: ${({ radius }) => radius ? `${radius}px;` : "12px"};
    border: 2px solid transparent;
    cursor: pointer;
    display: flex;
    font-weight: 600;
    justify-content: center;
    overflow: hidden;
    padding: 2px 4px;
    position: relative;
    text-align: center;
    transition: all 0.2s ease;
    width: ${(p2) => p2.isFullWidth ? "100%" : "fit-content"};

    :hover {
        background-color: ${getShade("light", 10)};
    }

    :focus {
        border-color: ${color.blue};
    }

    :disabled {
        opacity: 50%;
        pointer-events: none;
    }

    span {
        align-items: center;
        display: flex;
        pointer-events: none;
        z-index: 1;
    }

    svg {
        pointer-events: none;
        z-index: 1;
    }

    // minor theme and props style corrections
    ${({ isTransparent }) => isTransparent && transparentStyles}
    ${({ theme, size: size2 }) => theme !== "link" && size2 && getSizeStyles(size2)}
    ${({ theme }) => theme === "link" && linkStyles}
    ${({ theme }) => theme === "text" && textStyles}

    // if icon styles corrections
    ${({ icon, iconLayout }) => icon && iconLayout && getIconLayoutStyles(iconLayout)}
    ${({ icon, iconLayout, size: size2 }) => icon && iconLayout === "icon-only" && size2 === "small" && smallIconResize()}
    ${({ icon, iconLayout, size: size2 }) => icon && iconLayout === "icon-only" && size2 === "large" && largeIconResize()}
    ${({ icon, iconColor }) => icon && iconColor && getIconColor(iconColor)}
`;
var styles$o = {
  BaseButtonStyled: BaseButtonStyled$1
};
const {
  BaseButtonStyled
} = styles$o;
const ButtonBase = ({
  disabled = false,
  icon,
  iconColor,
  iconLayout = "leading",
  id,
  isLoading = false,
  isTransparent = false,
  loadingProps,
  loadingText = "Loading...",
  onClick = (e2) => e2.preventDefault,
  radius,
  size: size2 = "regular",
  theme = "secondary",
  text: text2 = "click",
  type = "button",
  ...props
}) => {
  return /* @__PURE__ */ jsx(BaseButtonStyled, {
    "data-testid": "test-button",
    disabled: disabled || isLoading,
    icon,
    iconColor,
    iconLayout,
    isTransparent,
    id,
    onClick: (e2) => onClick(e2),
    radius,
    size: size2,
    theme,
    type,
    ...props,
    children: /* @__PURE__ */ jsx("span", {
      children: isLoading ? /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(Loading, {
          size: 15,
          ...loadingProps
        }), loadingText]
      }) : /* @__PURE__ */ jsxs(Fragment, {
        children: [text2, icon && icon]
      })
    })
  });
};
const ButtonColored = lazy(() => import("./ButtonColored.js"));
const ButtonCustom = lazy(() => import("./ButtonCustom.js"));
const ButtonOutline = lazy(() => import("./ButtonOutline.js"));
const ButtonPrimary = lazy(() => import("./ButtonPrimary.js"));
const ButtonSecondary = lazy(() => import("./ButtonSecondary.js"));
const ButtonTranslucent = lazy(() => import("./ButtonTranslucent.js"));
const Button = (props) => {
  const BaseButton = () => /* @__PURE__ */ jsx(ButtonBase, {
    ...props
  });
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(Suspense, {
      fallback: BaseButton({
        ...props
      }),
      children: (() => {
        switch (props.theme) {
          case "primary":
            return /* @__PURE__ */ jsx(ButtonPrimary, {
              ...props
            });
          case "secondary":
            return /* @__PURE__ */ jsx(ButtonSecondary, {
              ...props
            });
          case "outline":
            return /* @__PURE__ */ jsx(ButtonOutline, {
              ...props
            });
          case "translucent":
            return /* @__PURE__ */ jsx(ButtonTranslucent, {
              ...props
            });
          case "colored":
            return /* @__PURE__ */ jsx(ButtonColored, {
              ...props
            });
          case "custom":
            return /* @__PURE__ */ jsx(ButtonCustom, {
              customize: props.customize,
              ...props
            });
          default:
            return BaseButton({
              ...props
            });
        }
      })()
    })
  });
};
const getBackgroundColor = (type) => {
  switch (type) {
    case "success":
      return color.green;
    case "warning":
      return color.yellow;
    case "error":
      return color.red;
    default:
      return color.blue;
  }
};
const SectionStyled$7 = styled$1.section`
    ${fonts.text};
    align-items: center;
    color: ${color.white};
    display: flex;
    height: 40px;
    justify-content: center;
    left: 0;
    max-width: 100%;
    padding: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 10001;
    background-color: ${(p2) => p2.type && getBackgroundColor(p2.type)};
    height: ${({ height }) => height};

    button {
        padding: 0 8px;
        margin: 2px 6px;
        border: 0;
    }

    strong {
        margin: 0 8px;
        padding: 2px 8px;
        line-height: 16px;
    }
`;
var styles$n = { SectionStyled: SectionStyled$7 };
const {
  SectionStyled: SectionStyled$6
} = styles$n;
const BannerStrip = ({
  buttonConfig,
  buttonDisplayed = false,
  height = "auto",
  text: text2,
  type = "standard"
}) => /* @__PURE__ */ jsxs(SectionStyled$6, {
  type,
  height,
  "data-testid": "test-banner-strip",
  children: [/* @__PURE__ */ jsx("strong", {
    children: text2
  }), buttonDisplayed && /* @__PURE__ */ jsx(Button, {
    ...buttonConfig
  })]
});
const olStyle = Ce$1`
  ${resetCSS};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;
`;
const navStyle = Ce$1`
  ${resetCSS};
`;
const separatorStyle = Ce$1`
  ${resetCSS};
  color: ${color.greyIcons};
  display: flex;
  margin: 0 2px;
  user-select: none;
`;
const NavStyled$3 = styled$1.nav`
  ${navStyle};
  color: ${(p2) => (p2 == null ? void 0 : p2.color) || color.grey};
`;
const ListStyled$3 = styled$1.ol`
  ${olStyle};
`;
const ListItemStyled$3 = styled$1.li`
  align-items: center;
  display: flex;

  svg:first-child {
    margin-right: 5px;
  }

  &:last-child {
    pointer-events: none;
  }
`;
const Breadcrumb$1 = styled$1(Link)`
  ${fonts.semiBold};
  align-items: center;
  display: flex;
  text-decoration: none;
  transition: all 0.2s ease;
  user-select: none;
  &:hover {
    color: ${color.blueDark};
  }
`;
const BreadcrumbsSeparator$1 = styled$1.li`
  ${separatorStyle};
`;
var styles$m = {
  Breadcrumb: Breadcrumb$1,
  BreadcrumbsSeparator: BreadcrumbsSeparator$1,
  ListItemStyled: ListItemStyled$3,
  ListStyled: ListStyled$3,
  NavStyled: NavStyled$3
};
const {
  Breadcrumb,
  BreadcrumbsSeparator,
  ListItemStyled: ListItemStyled$2,
  ListStyled: ListStyled$2,
  NavStyled: NavStyled$2
} = styles$m;
function getNumberOfRoutesToRender(routes, currentLocation) {
  var _a;
  if (!currentLocation)
    return routes.length - 1;
  for (let i = 0; i < routes.length; i++) {
    if (((_a = routes[i]) == null ? void 0 : _a.path) === currentLocation)
      return i;
  }
  throw new Error("Routes list does not match currentLocation");
}
function renderList(routes, separator, currentLocation) {
  let separatedRoutes = [];
  routes.forEach((route, i) => {
    const crumb = /* @__PURE__ */ jsx(ListItemStyled$2, {
      "data-testid": `test-breadcrumb-item-${i}`,
      children: /* @__PURE__ */ jsxs(Breadcrumb, {
        to: route.path,
        children: [route == null ? void 0 : route.icon, route.breadcrumb]
      })
    }, `breadcrumb-${i}`);
    const routesWithSeparator = getNumberOfRoutesToRender(routes, currentLocation);
    if (i < routesWithSeparator) {
      separatedRoutes = separatedRoutes.concat(crumb, /* @__PURE__ */ jsx(BreadcrumbsSeparator, {
        "data-testid": "test-breadcrumbs-separator",
        children: separator != null ? separator : /* @__PURE__ */ jsx(SvgChevronRight, {
          title: "chevron right icon",
          titleId: "breadcrumbs chevron right icon",
          fill: "currentColor",
          fontSize: 24
        })
      }, `separator-${i}`));
    } else if (routesWithSeparator === i) {
      separatedRoutes.push(crumb);
    }
  });
  return separatedRoutes;
}
const Breadcrumbs = ({
  theme = color.greyIcons,
  style,
  routes,
  separator,
  currentLocation,
  ...props
}) => {
  return /* @__PURE__ */ jsx(NavStyled$2, {
    color: theme,
    "data-testid": "test-breadcrumbs",
    ...props,
    children: /* @__PURE__ */ jsx(ListStyled$2, {
      style,
      "data-testid": "test-breadcrumbs-list",
      children: renderList(routes, separator, currentLocation)
    })
  });
};
Breadcrumbs.Item = ListItemStyled$2;
const defaultTriangleStyle = Ce$1`
  position: absolute;
  height: 0;
  width: 0;
`;
const leftPositionPopover = Ce$1`
  right: ${(props) => props.width && `calc(${props.width}px + 10px)`};
  top: 50%;
  transform: translateY(${(p2) => `${p2.moveBody}%`});
`;
const leftPositionTriangle = Ce$1`
  ${defaultTriangleStyle};
  border-bottom: 10px solid transparent;
  border-left: 10px solid ${color.blueDark2};
  border-top: 10px solid transparent;
  right: -10px;
  top: calc(${(p2) => `${p2.move}%`} - 10px);
`;
const rightPositionPopover = Ce$1`
  left: ${(props) => props.width && `calc(${props.width}px + 10px)`};
  top: 50%;
  transform: translateY(${(p2) => `${p2.moveBody}%`});
`;
const rightPositionTriangle = Ce$1`
  ${defaultTriangleStyle};
  border-bottom: 10px solid transparent;
  border-right: 10px solid ${color.blueDark2};
  border-top: 10px solid transparent;
  left: -10px;
  top: calc(${(p2) => `${p2.move}%`} - 10px);
`;
const topPositionPopover = Ce$1`
  bottom: ${(props) => props.height && `calc(${props.height}px + 10px)`};
  left: 50%;
  transform: translateX(${(p2) => `${p2.moveBody}%`});
`;
const topPositionTriangle = Ce$1`
  ${defaultTriangleStyle};
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid ${color.blueDark2};
  left: calc(${(p2) => `${p2.move}%`} - 10px);
  top: 100%;
`;
const bottomPositionPopover = Ce$1`
  left: 50%;
  top: ${(props) => props.height && `calc(${props.height}px + 10px)`};
  transform: translateX(${(p2) => `${p2.moveBody}%`});
`;
const bottomPositionTriangle = Ce$1`
  ${defaultTriangleStyle}
  border-bottom: 10px solid ${color.blueDark2};
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  left: calc(${(p2) => `${p2.move}%`} - 10px);
  top: -10px;
`;
const getTriangleComp = {
  top: topPositionTriangle,
  bottom: bottomPositionTriangle,
  left: leftPositionTriangle,
  right: rightPositionTriangle
};
const getPopoverComp = {
  top: topPositionPopover,
  bottom: bottomPositionPopover,
  left: leftPositionPopover,
  right: rightPositionPopover
};
const DivStyledTooltipParent$1 = styled$1.div`
  ${fonts.openSans}
  ${resetCSS}
    color: #252525;
  position: relative;
`;
const DivStyled$q = styled$1.div`
  opacity: 0;
  visibility: hidden;
  position: absolute;
  z-index: 1;
  min-width: ${(props) => props.minWidth}px;
  ${({ position }) => getPopoverComp[position]};
`;
const DivStyledTooltipContent$1 = styled$1.div`
  &:hover + ${DivStyled$q} {
    opacity: 1;
    visibility: visible;
    transition: 0.5s;
    transition-delay: 0.1s;
  }
`;
const DivStyledTooltipText$1 = styled$1.div`
  background-color: ${color.blueDark2};
  border-radius: 5px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: ${(props) => props.maxWidth && `${props.maxWidth}px`};
  min-width: fit-content;
  padding: 10px;
  transition: 0.5ms;
`;
const DivStyledArrow$1 = styled$1.div`
  ${({ position }) => getTriangleComp[position]}
`;
var styles$l = {
  DivStyled: DivStyled$q,
  DivStyledArrow: DivStyledArrow$1,
  DivStyledTooltipParent: DivStyledTooltipParent$1,
  DivStyledTooltipContent: DivStyledTooltipContent$1,
  DivStyledTooltipText: DivStyledTooltipText$1
};
const {
  DivStyled: DivStyled$p,
  DivStyledArrow,
  DivStyledTooltipParent,
  DivStyledTooltipContent,
  DivStyledTooltipText
} = styles$l;
const Tooltip = ({
  children,
  content,
  maxWidth,
  minWidth,
  move = 50,
  moveBody = -50,
  position = "bottom",
  ...props
}) => {
  const parentRef = useRef(null);
  const popoverRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [popoverWidth, setPopoverWidth] = useState(0);
  const [popoverHeight, setPopoverHeight] = useState(0);
  useEffect(() => {
    setWidth(parentRef.current ? parentRef.current.offsetWidth : 0);
    setHeight(parentRef.current ? parentRef.current.offsetHeight : 0);
    setPopoverWidth(popoverRef.current ? popoverRef.current.offsetWidth : 0);
    setPopoverHeight(popoverRef.current ? popoverRef.current.offsetHeight : 0);
  }, [parentRef.current, popoverRef.current]);
  return /* @__PURE__ */ jsxs(DivStyledTooltipParent, {
    ref: parentRef,
    "data-testid": "test-tooltip",
    ...props,
    children: [/* @__PURE__ */ jsx(DivStyledTooltipContent, {
      className: "tooltip-content",
      "data-testid": "test-tooltip-content",
      children
    }), /* @__PURE__ */ jsxs(DivStyled$p, {
      "data-testid": "test-tooltip-wrap",
      height,
      minWidth,
      moveBody,
      popoverHeight,
      popoverWidth,
      position,
      ref: popoverRef,
      width,
      children: [/* @__PURE__ */ jsx(DivStyledTooltipText, {
        "data-testid": "test-tooltip-text",
        maxWidth,
        minWidth,
        children: content
      }), /* @__PURE__ */ jsx(DivStyledArrow, {
        "data-testid": "test-tooltip-arrow",
        position,
        move
      })]
    })]
  });
};
const DivStyled$o = styled$1.div`
  ${resetCSS};
  ${fonts.text};
  outline: 2px solid transparent;
  background: ${color.blueLight};
  border-radius: 20px;
  display: grid;
  min-height: fit-content;
  padding: 11px;
  position: relative;
  transition: all 0.2s ease;
  width: 100%;
  ${(p2) => p2.isDisabled ? "opacity:70%;" : `&:hover {
        background: radial-gradient(
            102.8% 102.8% at 3.14% -9.06%,
            #e9fffc 0%,
            #e8fefb 4.74%,
            #e4f4f7 50.11%,
            #e1eef4 83.07%,
            #e0ecf3 100%
        );
    }`}
  ${(p2) => p2.cursorType === "pointer" && "cursor: pointer;"}
    ${(p2) => p2.isSelected && `outline-color: ${color.green};`}
`;
const AbsoluteIconStyled$1 = styled$1.div`
  position: absolute;
  top: -2px;
  ${(p2) => p2.position === "topL" ? "left: -2px;" : "right: -2px;"}
`;
const FooterStyled$5 = styled$1.footer`
  display: grid;
  text-align: center;
`;
const HeaderStyled$8 = styled$1.div`
  position: relative;
`;
var styles$k = { AbsoluteIconStyled: AbsoluteIconStyled$1, DivStyled: DivStyled$o, FooterStyled: FooterStyled$5, HeaderStyled: HeaderStyled$8 };
const {
  AbsoluteIconStyled,
  DivStyled: DivStyled$n,
  FooterStyled: FooterStyled$4,
  HeaderStyled: HeaderStyled$7
} = styles$k;
const Card = ({
  children,
  cursorType = "pointer",
  description,
  id,
  isDisabled = false,
  isSelected,
  onClick,
  setIsSelected,
  title,
  tooltipMove,
  tooltipMoveBody,
  tooltipText,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(DivStyled$n, {
    "aria-label": isSelected ? "card not selected" : "card selected",
    "data-testid": "test-card",
    id,
    onClick: () => {
      if (isDisabled)
        return;
      onClick && onClick();
      if (!setIsSelected)
        return;
      setIsSelected(!isSelected);
    },
    role: "button",
    isSelected,
    isDisabled,
    cursorType,
    ...props,
    children: [/* @__PURE__ */ jsxs(HeaderStyled$7, {
      "data-testid": "test-card-header",
      children: [isSelected && /* @__PURE__ */ jsx(AbsoluteIconStyled, {
        position: "topL",
        children: /* @__PURE__ */ jsx(SvgCheckmark, {
          "data-testid": "test-card-icon-check",
          title: "checkmark icon",
          titleId: "card checkmark icon",
          fill: color.green,
          fontSize: 20
        })
      }), !isDisabled && tooltipText && /* @__PURE__ */ jsx(AbsoluteIconStyled, {
        position: "topR",
        children: /* @__PURE__ */ jsx(Tooltip, {
          children: [/* @__PURE__ */ jsx(SvgHelpCircle, {
            fill: color.blue,
            fontSize: 22,
            titleId: "card help circle icon"
          }, "tip-card")],
          content: tooltipText,
          move: tooltipMove,
          moveBody: tooltipMoveBody,
          position: "bottom"
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      children
    }), (title || description) && /* @__PURE__ */ jsxs(FooterStyled$4, {
      children: [title && /* @__PURE__ */ jsx(Typography, {
        color: color.blue,
        "data-testid": "test-card-title",
        variant: "subtitle2",
        children: title
      }), description && /* @__PURE__ */ jsx(Typography, {
        color: color.blue,
        "data-testid": "test-card-description",
        variant: "caption14",
        children: description
      })]
    })]
  });
};
const arbitrum = (width = "120", height = "160") => {
  return /* @__PURE__ */ jsxs("svg", {
    fill: "none",
    height,
    viewBox: "0,0,120,160",
    width,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      opacity: "0.3",
      d: "M9.09277 104.682V108.659L20.1229 115.042L24.4793 117.54L37.5487 125.033L53.1206 134.006C53.6767 134.283 54.1402 134.561 54.5109 134.746C55.0671 135.116 55.5305 135.301 55.6232 135.393C56.7355 135.948 58.3112 136.226 59.7943 136.226C61.0919 136.226 62.3896 135.948 63.5946 135.486L106.139 110.88C108.549 109.029 110.032 106.162 110.125 103.017V56.0242C110.032 52.6015 108.086 49.4564 105.212 47.6063L64.2434 24.1101C61.37 22.63 57.7551 22.63 54.8817 24.1101C54.5109 24.2951 15.0249 47.1437 15.0249 47.1437C14.4688 47.4213 13.9127 47.6988 13.4492 48.0688C10.8539 49.9189 9.27815 52.879 9.09277 56.0242L9.09277 104.682Z",
      fill: "url(#paint0_linear_173_19021)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M59.5161 25.7751C60.7211 25.7751 61.9261 26.0527 62.9457 26.5152L103.822 49.9189C105.954 51.3065 107.252 53.5266 107.437 56.0242V102.924C107.344 105.144 106.325 107.179 104.656 108.474L62.4822 132.896C61.648 133.173 60.7211 133.358 59.8869 133.358C58.8673 133.358 57.6623 133.173 57.0135 132.803C56.8281 132.711 56.55 132.526 55.9939 132.248C55.6231 132.063 55.1597 131.786 54.6962 131.508L39.1243 122.535L26.055 115.042L21.6986 112.545L11.8734 107.087V104.682V56.1167C11.9661 53.8041 13.1711 51.6765 15.1175 50.3814C15.4883 50.1039 15.8591 49.9189 16.2298 49.7339L16.3225 49.6414L16.4152 49.5489C29.6699 41.871 54.7889 27.3477 56.1793 26.6077C57.1989 26.0527 58.3112 25.7751 59.5161 25.7751ZM59.5161 23C57.8477 23 56.272 23.37 54.7889 24.1101C54.4182 24.2951 14.9322 47.1437 14.9322 47.1437C14.376 47.4213 13.8199 47.6988 13.3564 48.0688C10.7611 49.9189 9.18538 52.879 9 56.0242V104.682V108.659L20.0301 115.042L24.3866 117.54L37.4559 125.033L53.0278 134.006C53.584 134.283 54.0474 134.561 54.4182 134.746C54.9743 135.116 55.4378 135.301 55.5305 135.393C56.6427 135.948 58.2185 136.226 59.7015 136.226C60.9992 136.226 62.2968 135.948 63.5018 135.486L106.139 110.88C108.549 109.029 110.032 106.162 110.125 103.017V56.0242C110.032 52.6015 108.086 49.4564 105.212 47.6063L64.2433 24.1101C62.853 23.37 61.1846 23 59.5161 23Z",
      fill: "url(#paint1_linear_173_19021)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.7",
      d: "M61.7406 96.3563L77.4052 120.87L91.8649 112.545L71.3804 80.168L61.7406 96.3563Z",
      fill: "url(#paint2_linear_173_19021)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.7",
      d: "M105.027 102.647V95.9863L82.596 61.0195L74.2539 75.1727L95.9434 110.139L103.822 105.607C104.564 104.959 105.027 104.034 105.12 103.109L105.027 102.647Z",
      fill: "url(#paint3_linear_173_19021)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M20.4935 113.007L56.0865 56.1168L50.8032 55.9318C45.4272 55.8393 39.6804 57.2269 37.0851 61.5746L16.1371 93.9512L10.5757 102.462V108.012",
      fill: "url(#paint4_linear_173_19021)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36.2359 61.0461C39.1281 56.221 45.3738 54.8382 50.8204 54.9319L50.8293 54.9321L57.8534 55.178L21.3413 113.538L19.6458 112.477L54.3196 57.0555L50.7772 56.9315C45.4807 56.842 40.2451 58.2318 37.9437 62.0871L37.9345 62.1026L16.9767 94.4944L16.9742 94.4983L11.5757 102.759V108.012H9.57568V102.164L15.2975 93.408L15.3 93.4042L36.2359 61.0461Z",
      fill: "url(#paint5_linear_173_19021)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M37.5487 125.033L41.0709 119.02L78.2396 56.1167L63.5946 56.2092L25.4062 117.54",
      fill: "url(#paint6_linear_173_19021)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M79.9985 55.1056L41.9336 119.525L41.9317 119.529L38.4114 125.538L36.6857 124.527L40.2079 118.515L40.2098 118.511L76.4805 57.1279L64.152 57.2058L26.255 118.068L24.5573 117.011L63.0369 55.2128L79.9985 55.1056Z",
      fill: "url(#paint7_linear_173_19021)"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_173_19021",
        x1: "9.09278",
        y1: "79.6129",
        x2: "110.145",
        y2: "79.6129",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_173_19021",
        x1: "59.5625",
        y1: "23",
        x2: "59.5625",
        y2: "136.226",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.348958",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_173_19021",
        x1: "61.7842",
        y1: "100.517",
        x2: "91.8902",
        y2: "100.517",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_173_19021",
        x1: "74.255",
        y1: "85.6105",
        x2: "105.056",
        y2: "85.6105",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_173_19021",
        x1: "10.5592",
        y1: "84.4857",
        x2: "56.0717",
        y2: "84.4857",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_173_19021",
        x1: "33.3311",
        y1: "55.9275",
        x2: "33.3311",
        y2: "113.007",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint6_linear_173_19021",
        x1: "25.4314",
        y1: "90.5737",
        x2: "78.2591",
        y2: "90.5737",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint7_linear_173_19021",
        x1: "51.8227",
        y1: "56.1168",
        x2: "51.8227",
        y2: "125.033",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      })]
    })]
  });
};
const avalancheLogo = (width = "120", height = "160") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M34.8478 120H17.5256C13.8846 120 12.0917 120 10.9884 119.313C9.80234 118.544 9.08518 117.281 9.00243 115.88C8.94727 114.589 9.82993 113.024 11.6228 109.865L54.3766 34.8295C56.197 31.6436 57.1073 30.0506 58.2658 29.4738C59.507 28.8421 60.9965 28.8421 62.2653 29.4738C63.4238 30.0506 64.334 31.6436 66.1545 34.8295L74.9535 50.1004L75.0087 50.1828C76.9671 53.5885 77.9601 55.3463 78.4014 57.159C78.8703 59.1365 78.8703 61.2513 78.4014 63.2289C77.9601 65.069 76.9671 66.7994 74.9811 70.2875L52.5285 109.81L52.4733 109.92C50.4874 113.381 49.4944 115.111 48.1152 116.429C46.5981 117.858 44.7777 118.929 42.7917 119.506C40.9712 120 38.93 120 34.8478 120ZM78.5945 120H103.419C107.088 120 108.908 120 110.012 119.286C111.198 118.517 111.942 117.226 111.998 115.825C112.053 114.589 111.17 113.079 109.46 110.112C109.405 110.003 109.35 109.92 109.267 109.81L96.8269 88.6344L96.689 88.3872C94.9512 85.4484 94.0686 83.9653 92.9377 83.3885C91.6964 82.7568 90.2069 82.7568 88.9657 83.3885C87.8348 83.9653 86.897 85.5308 85.0765 88.6619L72.7193 109.838L72.6641 109.92C70.8436 113.024 69.9334 114.589 70.0161 115.88C70.0989 117.281 70.8161 118.572 72.0021 119.341C73.0779 120 74.9259 120 78.5945 120Z",
      fill: "url(#paint0_linear_173_19026)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M61.7082 30.5928C60.7863 30.1338 59.7139 30.1394 58.8327 30.5878L58.8229 30.5928C58.5343 30.7365 58.165 31.0625 57.5979 31.8836C57.0357 32.6975 56.3838 33.8362 55.4625 35.4485C55.4623 35.4489 55.4621 35.4493 55.4619 35.4497L12.7099 110.482C11.803 112.08 11.1652 113.208 10.7543 114.097C10.345 114.983 10.2386 115.475 10.2509 115.817C10.3136 116.822 10.8226 117.712 11.6581 118.258C11.9541 118.439 12.4365 118.588 13.4081 118.668C14.3858 118.749 15.683 118.75 17.5256 118.75H34.8477C38.9933 118.75 40.835 118.74 42.4534 118.302C44.2324 117.784 45.8761 116.82 47.2546 115.523C48.4675 114.362 49.3627 112.829 51.3719 109.328L51.4258 109.221L73.8942 69.67L73.8948 69.669C75.9193 66.1133 76.7957 64.5637 77.1857 62.9381C77.6087 61.1523 77.6089 59.2375 77.1861 57.4516C76.7975 55.8578 75.9221 54.2792 73.9463 50.8428L73.8914 50.7608L65.0714 35.4536L65.0692 35.4497C64.1476 33.8368 63.4955 32.6977 62.9331 31.8836C62.366 31.0625 61.9968 30.7365 61.7082 30.5928ZM57.7036 28.3573C59.304 27.5448 61.2083 27.5512 62.8224 28.3548C63.6923 28.7879 64.3574 29.5467 64.9902 30.4628C65.6206 31.3755 66.325 32.6083 67.2097 34.1567L67.2376 34.2055L67.2398 34.2094L76.0156 49.4399L76.0711 49.5227L76.0923 49.5596C78.017 52.9068 79.1229 54.8384 79.6159 56.8633L79.6177 56.8706C80.1315 59.0377 80.1315 61.3501 79.6177 63.5173L79.6169 63.5204C79.1391 65.5126 78.0813 67.3699 76.2422 70.5989C76.1847 70.6999 76.1264 70.8022 76.0674 70.906L53.6312 110.4L53.5748 110.512L53.4457 110.737C51.5665 114.012 50.4896 115.889 48.9789 117.333L48.972 117.34C47.3198 118.895 45.3277 120.071 43.1403 120.706L43.1298 120.709L43.1193 120.712C41.1368 121.25 38.9408 121.25 35.0693 121.25H17.4668C15.6962 121.25 14.2954 121.25 13.2027 121.16C12.1019 121.069 11.136 120.878 10.3279 120.375L10.3181 120.368L10.3084 120.362C8.7809 119.372 7.86023 117.742 7.7546 115.954L7.754 115.944L7.75356 115.934C7.71303 114.985 8.02218 114.05 8.48489 113.049C8.94978 112.043 9.64971 110.809 10.5357 109.248L10.5367 109.246L53.2905 34.2107L53.3214 34.1567C54.2061 32.6083 54.9105 31.3755 55.5409 30.4628C56.1724 29.5485 56.8363 28.7908 57.7036 28.3573ZM88.3987 82.2745C89.9962 81.4615 91.9072 81.4615 93.5046 82.2745L93.5056 82.275C94.3401 82.7006 94.9856 83.4121 95.6026 84.2752C96.2207 85.1397 96.9071 86.3002 97.7649 87.751L97.7729 87.7645L97.9116 88.0131L110.311 109.119C110.396 109.236 110.478 109.36 110.558 109.515L110.64 109.657C111.438 111.041 112.084 112.16 112.52 113.083C112.971 114.034 113.287 114.948 113.246 115.878C113.174 117.691 112.211 119.35 110.692 120.335L110.691 120.335C109.877 120.862 108.895 121.062 107.783 121.156C106.678 121.25 105.263 121.25 103.48 121.25H78.5389C76.7517 121.25 75.3325 121.25 74.2287 121.164C73.1263 121.078 72.1484 120.896 71.349 120.407L71.3354 120.398L71.3221 120.39C69.7878 119.395 68.8745 117.735 68.7685 115.957C68.7073 114.99 69.0255 114.041 69.4964 113.046C69.9704 112.043 70.6868 110.821 71.5859 109.288L71.6047 109.256L71.6591 109.174L83.9959 88.0336C84.8971 86.4835 85.6166 85.256 86.2584 84.3465C86.8946 83.4452 87.5554 82.7046 88.3978 82.275L88.3987 82.2745ZM89.5336 84.5021C89.2451 84.6492 88.8715 84.9798 88.3009 85.7882C87.736 86.5885 87.0763 87.7092 86.1571 89.2902L86.1561 89.2919L73.7794 110.501L73.7235 110.585C72.8121 112.139 72.1692 113.241 71.7565 114.114C71.3382 114.999 71.2429 115.477 71.2636 115.8L71.264 115.806C71.324 116.823 71.8392 117.739 72.6677 118.283C72.946 118.449 73.4305 118.594 74.4233 118.671C75.4181 118.749 76.7393 118.75 78.5945 118.75H103.419C105.276 118.75 106.585 118.749 107.572 118.665C108.562 118.581 109.043 118.424 109.332 118.237C110.184 117.684 110.71 116.763 110.749 115.776L110.749 115.77C110.762 115.465 110.665 115.006 110.261 114.153C109.868 113.323 109.268 112.282 108.427 110.824L108.359 110.706L108.343 110.673C108.333 110.655 108.326 110.638 108.268 110.562L108.225 110.505L95.7421 89.2556L95.605 89.01C94.7293 87.5291 94.1076 86.4827 93.5689 85.7291C93.0274 84.9717 92.6661 84.6532 92.3697 84.5021C91.4852 84.0523 90.4181 84.0523 89.5336 84.5021Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("defs", {
      children: /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_173_19026",
        x1: "33.3469",
        y1: "120",
        x2: "70.5292",
        y2: "48.9727",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.85"
        })]
      })
    })]
  });
};
const binanceLogo = (width = "120", height = "160") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M29.168 99.3139C32.9018 95.5571 36.6357 91.7039 40.3695 87.9471C40.4652 88.0434 40.561 88.1397 40.6567 88.2361C46.9755 94.5938 53.1986 100.855 59.5174 107.213C59.8046 107.502 59.7089 107.502 60.0919 107.213C66.4107 100.855 72.6337 94.5938 78.9526 88.2361C79.0483 88.1397 79.0483 88.0434 79.144 87.9471C82.9736 91.8002 86.7075 95.5571 90.4413 99.3139C90.4413 99.3139 90.3456 99.4102 90.2498 99.5066C80.1972 109.621 70.1445 119.736 60.0919 129.85C59.9004 130.043 59.9004 130.043 59.6132 129.85C49.5605 119.736 39.5078 109.621 29.4552 99.5066C29.2637 99.4102 29.168 99.4102 29.168 99.3139Z",
      fill: "url(#paint0_linear_30_8698)",
      fillOpacity: "0.7"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.3693 86.5276L59.8045 106.082L78.183 87.5907C78.2238 87.5122 78.3053 87.3714 78.4408 87.2351L79.1439 86.5276L91.8518 99.3138L91.1443 100.026L91.0779 99.9587C91.1443 100.026 91.1443 100.026 91.1443 100.026L60.7948 130.562C60.7924 130.565 60.7895 130.568 60.7861 130.571C60.751 130.607 60.6678 130.691 60.5789 130.759C60.4576 130.852 60.2213 131 59.8883 131C59.599 131 59.3831 130.884 59.3021 130.839C59.2204 130.794 59.1335 130.736 59.0759 130.697L58.9797 130.632L28.8833 100.351C28.8562 100.339 28.8243 100.325 28.7953 100.31C28.7311 100.278 28.5574 100.187 28.409 100C28.2319 99.7775 28.1719 99.5261 28.1719 99.3139V98.8965L28.4647 98.6019C30.329 96.7261 32.1937 94.8259 34.061 92.923L34.0621 92.9219C35.9282 91.0202 37.797 89.1158 39.6662 87.2351L40.3693 86.5276ZM30.6258 99.2651L59.8523 128.672L89.0304 99.3139L79.1917 89.4146L60.7447 107.975L60.688 108.018C60.678 108.026 60.6488 108.048 60.6145 108.075C60.5576 108.119 60.4864 108.174 60.4653 108.189C60.4644 108.19 60.4628 108.191 60.4607 108.193C60.4184 108.225 60.146 108.435 59.7686 108.435C59.3241 108.435 59.0441 108.159 58.991 108.107C58.9889 108.105 58.9871 108.103 58.9858 108.102C58.9502 108.067 58.9143 108.029 58.8934 108.007L58.8882 108.002C58.8629 107.975 58.8405 107.951 58.8142 107.925L40.3699 89.367C38.7396 91.0122 37.1089 92.674 35.4762 94.3379L35.4749 94.3392C33.86 95.9849 32.2431 97.6325 30.6258 99.2651ZM59.2962 106.562C59.2927 106.564 59.2933 106.564 59.2975 106.561C59.2971 106.561 59.2966 106.561 59.2962 106.562Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M40.3695 71.9566C36.6357 68.1997 32.9018 64.4429 29.168 60.6861C29.168 60.5898 29.2637 60.5898 29.3594 60.4934C39.4121 50.3789 49.4648 40.2643 59.5174 30.1498C59.7089 29.9571 59.8046 29.9571 59.9961 30.1498C70.0488 40.2643 80.1014 50.3789 90.1541 60.4934C90.2498 60.5898 90.2498 60.5898 90.3456 60.6861C86.6117 64.4429 82.8779 68.1997 79.144 71.9566C79.144 71.9566 79.0483 71.8603 78.9526 71.7639C72.6337 65.4062 66.4107 59.1448 60.0919 52.7871C59.8046 52.4981 59.9004 52.4981 59.5174 52.7871C53.1986 59.0485 46.8798 65.4062 40.6567 71.6676C40.561 71.7639 40.4652 71.8603 40.3695 71.9566Z",
      fill: "url(#paint1_linear_30_8698)",
      fillOpacity: "0.7"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M59.7567 31.3283L88.9348 60.6861L79.144 70.5372L60.7949 52.0751C60.7686 52.0487 60.7462 52.025 60.7208 51.9982C60.7011 51.9773 60.662 51.9356 60.6233 51.8982C60.6219 51.8969 60.6202 51.8952 60.6181 51.8931C60.5649 51.8408 60.285 51.5651 59.8405 51.5651C59.4631 51.5651 59.1906 51.7746 59.1483 51.8072C59.1462 51.8088 59.1447 51.8099 59.1438 51.8106C59.1227 51.8261 59.0515 51.8812 58.9945 51.9253C58.9602 51.9518 58.9311 51.9744 58.921 51.982L58.8674 52.0224L58.8197 52.0697C52.6385 58.1947 46.4578 64.4114 40.3695 70.5372L30.5786 60.6861L59.7567 31.3283ZM78.4409 72.6686L79.144 73.376L91.7562 60.6861L91.0021 59.9273L91.0013 59.9265L90.9998 59.925L90.9975 59.9227L90.9925 59.9176C90.9957 59.9209 90.9892 59.9143 90.9925 59.9176L90.9461 59.871L90.9439 59.8687L90.9334 59.8581L90.931 59.8557L90.9297 59.8545L90.8915 59.816L60.6936 29.4321C60.5949 29.3327 60.265 29 59.7567 29C59.2484 29 58.9185 29.3327 58.8199 29.4321L28.7022 59.7353C28.6947 59.7403 28.6862 59.746 28.6766 59.7525C28.6294 59.7841 28.4886 59.8797 28.3693 60.0512C28.2304 60.2509 28.172 60.475 28.172 60.6861V61.1034L40.3695 73.376L41.3598 72.3796C47.4475 66.2544 53.6237 60.0401 59.8015 53.9144L78.4409 72.6686ZM60.3129 53.4384C60.3164 53.4358 60.3158 53.4364 60.3116 53.4394C60.312 53.4391 60.3124 53.4387 60.3129 53.4384Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M59.7084 91.4151C55.9746 87.6582 52.145 83.8051 48.4111 80.0482C52.145 76.2914 55.9746 72.4382 59.8041 68.5851C63.538 72.3419 67.3676 76.1951 71.1014 79.9519C67.3676 83.8051 63.538 87.5619 59.7084 91.4151Z",
      fill: "url(#paint2_linear_30_8698)",
      fillOpacity: "0.7"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M59.804 67.1656L72.5031 79.9429L71.8132 80.6548C69.3218 83.2258 66.783 85.7589 64.2369 88.2994C62.9618 89.5715 61.685 90.8455 60.4113 92.127L59.7082 92.8344L47.0002 80.0482L59.804 67.1656ZM49.8217 80.0482L59.7087 89.9961C60.7596 88.9417 61.8081 87.8956 62.853 86.8531C65.1562 84.5551 67.442 82.2744 69.6984 79.9598L59.804 70.0045L49.8217 80.0482Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M32.4228 79.952C32.4228 80.0483 32.3271 80.0483 32.3271 80.0483C32.3271 80.1446 32.2314 80.1446 32.2314 80.1446C28.689 83.7088 25.0509 87.3693 21.5085 90.9335C21.2213 91.2225 21.2213 91.2225 20.9341 90.9335C17.3917 87.3693 13.7536 83.7088 10.2113 80.1446C9.92404 79.8556 9.92404 79.8556 10.2113 79.663C13.7536 76.0988 17.3917 72.4383 20.9341 68.8741C21.1256 68.6815 21.1256 68.6815 21.4128 68.8741C24.9552 72.4383 28.5933 76.0988 32.1356 79.663C32.2314 79.7593 32.3271 79.8556 32.4228 79.952Z",
      fill: "url(#paint3_linear_30_8698)",
      fillOpacity: "0.7"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.1735 70.0527L31.0122 79.952L21.2214 89.803L11.3827 79.9038L21.1735 70.0527ZM32.8053 80.9867L22.2117 91.6454C22.2072 91.65 22.2024 91.6548 22.1973 91.6599C22.1407 91.7171 22.0493 91.8093 21.959 91.882C21.8661 91.9568 21.6053 92.1555 21.2214 92.1555C20.8375 92.1555 20.5767 91.9568 20.4838 91.882C20.3934 91.8093 20.3021 91.7171 20.2455 91.6599C20.2404 91.6548 20.2356 91.65 20.2311 91.6454L9.50824 80.8566C9.50371 80.852 9.49893 80.8472 9.49394 80.8422C9.4365 80.7845 9.35088 80.6986 9.28352 80.6167C9.28234 80.6152 9.28103 80.6137 9.27959 80.6119C9.22635 80.5476 9 80.2739 9 79.8677C9 79.3814 9.30825 79.0978 9.39515 79.0213C9.4543 78.9692 9.52226 78.9197 9.57697 78.8819L20.2311 68.1622C20.2335 68.1597 20.2364 68.1567 20.2398 68.1533C20.2749 68.1177 20.3581 68.0333 20.447 67.9652C20.5682 67.8723 20.8046 67.7244 21.1376 67.7244C21.4269 67.7244 21.6428 67.8399 21.7238 67.8849C21.8055 67.9303 21.8923 67.9887 21.95 68.0274C21.9549 68.0307 21.9596 68.0339 21.9641 68.0369L22.0462 68.0919L33.4189 79.5346V79.952C33.4189 80.1526 33.3661 80.3699 33.2358 80.5665C33.1795 80.6515 33.1163 80.7212 33.052 80.7782C32.9723 80.8693 32.8859 80.937 32.8053 80.9867Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M109.589 79.952C109.589 80.0483 109.494 80.0483 109.494 80.0483C109.494 80.1446 109.398 80.1446 109.398 80.1446C105.855 83.7088 102.217 87.3693 98.675 90.9335C98.3878 91.2225 98.3878 91.2225 98.1963 90.9335C94.6539 87.3693 91.0158 83.7088 87.4734 80.1446C87.282 79.952 87.282 79.952 87.4734 79.663C91.1115 76.0025 94.6539 72.4383 98.292 68.7778C98.4835 68.5851 98.5792 68.5851 98.7707 68.7778C102.409 72.4383 105.951 76.0025 109.589 79.663C109.398 79.8556 109.494 79.8556 109.589 79.952Z",
      fill: "url(#paint4_linear_30_8698)",
      fillOpacity: "0.7"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M98.5312 69.9564L108.322 79.8075L98.4355 89.7549L88.6446 79.9038L98.5312 69.9564ZM109.971 80.9867L99.3779 91.6455C99.3734 91.65 99.3686 91.6548 99.3637 91.6598C99.3063 91.7176 99.2209 91.8038 99.1395 91.8715C99.1381 91.8727 99.1366 91.874 99.1349 91.8754C99.0707 91.9291 98.8002 92.1555 98.3996 92.1555C97.9204 92.1555 97.6398 91.8477 97.5628 91.7592C97.5111 91.6997 97.4619 91.6313 97.4242 91.5762L86.7702 80.8566C86.7677 80.8542 86.7648 80.8512 86.7614 80.8478C86.7261 80.8126 86.6421 80.7288 86.5743 80.6392C86.482 80.5173 86.3337 80.278 86.3337 79.9399C86.3337 79.6464 86.4495 79.4277 86.4942 79.3463C86.5394 79.2639 86.5975 79.1763 86.636 79.1184C86.6393 79.1134 86.6424 79.1087 86.6454 79.1041L86.7003 79.0213L97.5887 68.0658C97.5905 68.0641 97.5924 68.0622 97.5944 68.0602C97.693 67.9607 98.0229 67.6281 98.5312 67.6281C99.0395 67.6281 99.3694 67.9607 99.468 68.0602C99.47 68.0622 99.4719 68.0641 99.4737 68.0658L111 79.663L110.577 80.0886C110.558 80.2487 110.503 80.4138 110.402 80.5665C110.346 80.6515 110.283 80.7213 110.218 80.7783C110.138 80.8693 110.052 80.937 109.971 80.9867Z",
      fill: "white"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_30_8698",
        x1: "59.8046",
        y1: "87.9471",
        x2: "59.8046",
        y2: "129.995",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_30_8698",
        x1: "59.7568",
        y1: "30.0053",
        x2: "59.7568",
        y2: "71.9566",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_30_8698",
        x1: "59.7563",
        y1: "68.5851",
        x2: "59.7563",
        y2: "91.4151",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_30_8698",
        x1: "21.2093",
        y1: "68.7296",
        x2: "21.2093",
        y2: "91.1502",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_30_8698",
        x1: "98.4596",
        y1: "68.6333",
        x2: "98.4596",
        y2: "91.1502",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      })]
    })]
  });
};
const bundle = (width = "303", height = "398") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 303 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M284.732 225.46C288.042 198.31 283.226 170.788 270.895 146.375C258.564 121.962 239.27 101.754 215.455 88.3048C191.639 74.856 164.37 68.7708 137.096 70.8187C109.822 72.8666 83.7682 82.9557 62.2279 99.8102C40.6876 116.665 24.6286 139.528 16.0813 165.509C7.53404 191.489 6.88238 219.421 14.2087 245.772C21.5351 272.124 36.5104 295.711 57.2413 313.551C77.9721 331.392 103.528 342.685 130.676 346.003C148.707 348.206 166.995 346.836 184.497 341.97C201.998 337.104 218.369 328.838 232.675 317.644C246.981 306.45 258.942 292.548 267.874 276.73C276.806 260.913 282.535 243.491 284.732 225.46Z",
      fill: "#8227B7"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M190.465 151.294C188.632 152.291 184.869 153.385 183.036 154.51C176.359 157.682 170.421 162.218 165.604 167.825C155.956 180.176 156.856 195.581 169.689 210.022C188.986 231.603 228.288 238.968 259.421 228.515C289.364 217.162 298.208 190.403 279.265 169.916C271.482 160.685 257.073 153.513 242.182 149.332C234.505 147.201 226.575 146.119 218.607 146.116C210.824 147.113 201.143 149.204 190.465 151.294Z",
      fill: "url(#paint0_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M184.355 108.615L199.664 109.837L216.356 113.857C216.356 113.857 222.563 110.963 213.14 94.721C207.157 84.397 201.69 84.6543 191.848 71.5322C183.679 61.4655 181.524 55.9336 176.282 55.4512C169.528 64.1028 182.972 99.5132 184.355 108.615Z",
      fill: "url(#paint1_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M156.888 135.47C156.888 135.47 150.198 117.717 158.561 91.8907C162.418 79.1035 168.036 66.9152 175.253 55.6763C176.217 54.2612 177.44 55.3868 177.89 56.1587C177.89 65.2606 191.784 82.4351 197.187 102.987L156.888 135.47Z",
      fill: "url(#paint2_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M264.213 204.844C289.943 167.279 249.386 110.963 220.215 102.89C191.044 94.8175 162.967 115.273 148.333 150.683C136.401 179.404 150.584 204.394 170.203 217.226C201.079 237.488 246.202 233.854 264.213 204.844Z",
      fill: "url(#paint3_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.8",
      children: /* @__PURE__ */ jsx("g", {
        opacity: "0.8",
        children: /* @__PURE__ */ jsx("path", {
          opacity: "0.8",
          d: "M208.669 159.881C214.008 161.2 218.317 166.314 220.215 174.805C223.11 187.477 215.326 201.274 202.011 198.379C190.465 195.935 186.606 189.631 186.606 179.082C186.606 168.533 196.672 155.379 208.669 159.881Z",
          fill: "#318CB6"
        })
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.8",
      children: /* @__PURE__ */ jsx("g", {
        opacity: "0.8",
        children: /* @__PURE__ */ jsx("path", {
          opacity: "0.8",
          d: "M161.294 138.558C171.715 134.988 178.469 148.206 176.378 161.94C175.092 172.457 168.145 179.982 162.613 176.863C152.193 170.848 149.941 162.583 150.585 156.601C151.228 150.619 153.125 141.292 161.294 138.558Z",
          fill: "#3493B9"
        })
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M257.748 151.584L258.005 152.163C259.215 150.223 259.923 148.012 260.064 145.73V145.216C260.097 143.271 259.56 141.359 258.52 139.716C258.942 141.263 259.222 142.846 259.356 144.444C259.292 146.906 258.746 149.332 257.748 151.584Z",
      fill: "#744984"
    }), /* @__PURE__ */ jsx("path", {
      d: "M231.247 176.895L170.879 143.865C168.659 142.675 166.858 144.09 166.858 147.081L148.655 162.39C146.21 162.39 144.634 187.541 147.272 190.886L196.222 217.998C204.842 222.598 222.563 214.3 227.902 201.917C232.726 190.725 234.592 184.936 234.592 184.936C234.703 183.427 234.459 181.913 233.878 180.517C233.297 179.12 232.395 177.879 231.247 176.895Z",
      fill: "url(#paint4_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M224.396 191.626L233.82 185.901L228.803 182.524L222.627 183.875L224.396 191.626Z",
      fill: "url(#paint5_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M154.734 126.915L164.382 121.094L167.952 133.444C167.952 133.444 162.71 135.856 162.838 135.888C162.967 135.921 154.734 126.915 154.734 126.915Z",
      fill: "url(#paint6_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M190.723 159.141C190.723 159.141 199.438 172.231 204.938 175.222C210.438 178.213 230.668 185.868 230.668 185.868C233.241 187.283 235.363 185.611 235.363 182.169V164.319C235.363 160.589 236.007 159.206 233.788 157.887C231.72 156.964 229.565 156.253 227.355 155.764C221.148 154.478 193.81 141.388 182.328 135.341C172.68 130.228 168.949 128.587 167.566 123.056C167.701 122.013 168.04 121.008 168.563 120.097C168.563 120.097 162.13 120.933 162.13 123.506L162.516 142.803C162.87 146.116 188.117 157.726 190.723 159.141Z",
      fill: "url(#paint7_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M212.27 198.701L224.234 191.722L210.758 179.082L208.828 180.112L212.27 198.701Z",
      fill: "url(#paint8_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M142.96 133.798L155.15 126.658L161.55 144.476L142.96 133.798Z",
      fill: "url(#paint9_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M162.547 154.189L221.404 191.465C223.977 192.848 226.099 191.175 226.099 187.734V169.884C226.075 168.147 225.636 166.441 224.82 164.909C224.003 163.376 222.832 162.06 221.404 161.072L158.302 126.69C155.729 125.275 153.606 126.948 153.606 130.389L157.755 145.377C157.776 147.124 158.224 148.841 159.059 150.376C159.894 151.912 161.092 153.221 162.547 154.189Z",
      fill: "url(#paint10_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M146.05 164.287L209.087 198.668C211.66 200.051 213.783 198.379 213.783 194.938V177.088C213.764 175.346 213.328 173.633 212.511 172.094C211.694 170.556 210.52 169.235 209.087 168.243L146.05 133.894C143.477 132.511 141.354 134.151 141.354 137.625V155.378C141.363 157.131 141.794 158.857 142.612 160.407C143.429 161.958 144.608 163.289 146.05 164.287Z",
      fill: "url(#paint11_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M207.254 201.756L212.271 198.54L210.76 195.002C210.76 195.002 204.745 197.736 204.745 197.929C204.745 198.122 207.254 201.756 207.254 201.756Z",
      fill: "url(#paint12_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M138.105 136.724L142.962 133.798L145.02 135.792L140.518 140.037L138.105 136.724Z",
      fill: "url(#paint13_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M141.097 167.279L204.134 201.66C206.707 203.075 208.83 201.403 208.83 197.961V180.111C208.785 178.401 208.337 176.725 207.521 175.222C206.705 173.718 205.544 172.429 204.134 171.46L141.097 136.918C138.524 135.503 136.401 137.175 136.401 140.616V158.595C136.44 160.311 136.886 161.993 137.703 163.502C138.519 165.012 139.682 166.306 141.097 167.279Z",
      fill: "url(#paint14_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M204.134 171.46L161.327 148.239C154.219 144.444 147.047 140.359 139.971 136.853C139.547 136.739 139.099 136.751 138.682 136.888C138.264 137.025 137.897 137.282 137.623 137.625C137.057 138.388 136.752 139.313 136.755 140.262V146.309C136.755 150.361 136.755 154.414 136.497 158.466V140.23C136.515 139.194 136.84 138.187 137.43 137.336C137.758 136.92 138.202 136.61 138.705 136.444C139.208 136.278 139.749 136.264 140.26 136.403C147.529 140.037 154.508 144.122 161.648 147.949L204.134 171.46Z",
      fill: "url(#paint15_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M202.815 172.811L142.415 139.812C140.228 138.59 138.427 140.038 138.427 143.029V158.306C138.449 159.786 138.822 161.24 139.515 162.548C140.209 163.857 141.202 164.982 142.415 165.832L202.815 198.765C205.002 199.988 206.836 198.54 206.836 195.549V180.369C206.812 178.88 206.436 177.419 205.737 176.105C205.038 174.791 204.036 173.662 202.815 172.811Z",
      fill: "url(#paint16_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M202.815 172.81L163.031 151.197L143.155 140.391C142.423 139.844 141.527 139.561 140.614 139.587C140.188 139.686 139.798 139.9 139.486 140.207C139.174 140.513 138.952 140.9 138.845 141.324C138.626 142.228 138.54 143.16 138.588 144.09V146.92C138.588 150.683 138.588 154.446 138.588 158.241C138.588 154.446 138.588 150.683 138.588 146.92V144.09C138.513 143.128 138.6 142.16 138.845 141.227C138.956 140.73 139.21 140.276 139.576 139.922C139.941 139.567 140.403 139.328 140.904 139.233C141.897 139.2 142.873 139.506 143.67 140.101L163.481 151.004L202.815 172.81Z",
      fill: "url(#paint17_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M156.567 151.937L187.056 168.661V166.506L156.567 149.782V151.937Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M223.174 187.219L217.996 190.435C216.999 191.046 216.195 190.435 216.195 189.148V182.201C216.205 181.522 216.373 180.855 216.686 180.252C216.998 179.649 217.447 179.127 217.996 178.728L223.174 175.512C224.171 174.9 224.975 175.512 224.975 176.798V183.713C224.97 184.397 224.805 185.071 224.492 185.68C224.179 186.289 223.728 186.816 223.174 187.219Z",
      fill: "url(#paint18_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M223.142 174.547L222.467 174.161L222.241 174.386L222.917 174.965L223.142 174.547Z",
      fill: "#BFB9DB"
    }), /* @__PURE__ */ jsx("path", {
      d: "M222.627 186.994L217.449 190.21C216.452 190.789 215.648 190.21 215.648 188.891V181.944C215.668 181.267 215.84 180.603 216.152 180.001C216.464 179.4 216.907 178.877 217.449 178.471L222.627 175.254C223.624 174.675 224.428 175.254 224.428 176.541V183.488C224.414 184.171 224.244 184.841 223.932 185.448C223.62 186.056 223.174 186.584 222.627 186.994Z",
      fill: "url(#paint19_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M222.628 181.365C222.611 182.202 222.405 183.024 222.026 183.77C221.648 184.516 221.106 185.167 220.441 185.675C219.218 186.415 218.221 185.675 218.221 184.067C218.242 183.232 218.453 182.413 218.838 181.672C219.222 180.931 219.77 180.287 220.441 179.789C221.502 179.05 222.628 179.757 222.628 181.365Z",
      fill: "url(#paint20_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M234.142 164.963L231.569 166.603V184.131L234.142 182.555V164.963Z",
      fill: "url(#paint21_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M259.581 158.595V145.73C259.462 148.011 258.765 150.224 257.555 152.162C255.759 154.969 253.405 157.377 250.64 159.238C245.263 162.867 239.393 165.705 233.209 167.664L232.855 168.147L233.209 181.108C248.711 176.316 259.581 168.018 259.581 158.595Z",
      fill: "url(#paint22_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M260.128 158.595V145.73C259.967 148.017 259.238 150.228 258.005 152.162C256.173 155.01 253.776 157.451 250.962 159.334C245.354 163.095 239.234 166.031 232.79 168.05V181.912C248.871 177.088 260.064 168.597 260.064 159.013L260.128 158.595Z",
      fill: "url(#paint23_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M231.569 166.603L230.668 166.153V183.617L231.569 184.132V166.603Z",
      fill: "url(#paint24_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M230.668 166.153L231.569 166.603L234.141 164.963L233.305 164.545L230.668 166.153Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M178.63 200.984V203.171C178.63 206.999 176.475 208.703 173.677 206.999C172.136 205.905 170.879 204.458 170.012 202.78C169.145 201.101 168.692 199.239 168.692 197.35V194.134L171.618 197.35L174.224 197.832C175.253 199.762 176.282 201.274 178.63 200.984Z",
      fill: "#FA4A76"
    }), /* @__PURE__ */ jsx("path", {
      d: "M174.127 198.186L171.522 197.704L168.595 194.488V197.704C168.628 199.541 169.114 201.342 170.01 202.946C170.056 201.804 170.489 200.711 171.236 199.847C171.984 198.982 173.003 198.397 174.127 198.186Z",
      fill: "#020A21"
    }), /* @__PURE__ */ jsx("path", {
      d: "M180.817 190.757C180.173 189.116 179.723 187.541 175.124 185.096C170.525 182.652 167.276 182.395 166.89 183.456V183.713C166.472 184.935 167.694 186.929 172.133 190.853L172.776 191.496H173.033C172.776 191.496 172.776 191.496 172.776 191.754H173.291C173.516 192.011 173.516 192.011 173.677 192.011C173.837 192.011 174.352 192.236 174.513 192.236C176.121 193.458 181.138 193.458 180.817 190.757Z",
      fill: "url(#paint25_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M175.092 186.64C176.025 187.09 177.247 188.055 176.957 188.795C176.668 189.535 175.735 189.277 175.092 188.795C174.449 188.312 173.194 187.38 173.194 186.64C173.194 185.9 174.127 185.965 175.092 186.64Z",
      fill: "#CCCCCC"
    }), /* @__PURE__ */ jsx("path", {
      d: "M182.007 197.607C182.235 197.769 182.423 197.98 182.557 198.226C182.69 198.471 182.766 198.744 182.779 199.023C182.751 199.804 182.482 200.557 182.007 201.177C181.556 202.11 180.334 202.593 177.986 201.949L176.571 201.177C175.887 200.694 175.261 200.133 174.706 199.505C174.223 198.733 173.773 198.09 173.484 197.607C173.219 197.017 173.056 196.387 173.001 195.742V192.526C173.001 192.043 173.291 191.754 173.773 192.043C173.995 192.208 174.177 192.421 174.305 192.666C174.433 192.911 174.504 193.182 174.513 193.459C174.513 193.459 174.802 195.613 174.802 195.806C174.658 196.582 174.658 197.378 174.802 198.154C174.914 198.514 175.096 198.847 175.34 199.135C175.583 199.422 175.881 199.657 176.218 199.827C178.823 201.531 179.755 200.599 180.238 199.827C180.519 199.417 180.685 198.939 180.72 198.444C180.817 197.447 181.749 197.607 182.007 197.607Z",
      fill: "#020A21"
    }), /* @__PURE__ */ jsx("path", {
      d: "M174.384 191.432C174.615 191.583 174.806 191.788 174.941 192.029C175.075 192.27 175.149 192.54 175.156 192.815V196.031C175.127 196.452 175.029 196.865 174.867 197.254C174.577 197.704 174.384 198.476 173.452 198.669C172.794 198.721 172.137 198.551 171.586 198.186C169.202 196.743 167.351 194.565 166.312 191.979C165.833 191.089 165.579 190.095 165.572 189.084C165.572 188.602 165.861 188.313 166.312 188.602C166.543 188.76 166.734 188.971 166.868 189.217C167.002 189.463 167.076 189.737 167.084 190.017C167.368 192.272 168.522 194.326 170.3 195.742C170.664 196.105 171.075 196.419 171.522 196.675C171.972 196.964 172.455 197.157 172.744 196.964C172.864 196.949 172.975 196.893 173.057 196.805C173.139 196.716 173.188 196.602 173.194 196.482C173.41 196.112 173.511 195.687 173.484 195.26V192.043C173.387 191.239 173.87 190.95 174.384 191.432Z",
      fill: "#020A21"
    }), /* @__PURE__ */ jsx("path", {
      d: "M279.554 95.6539C275.695 92.4377 271.868 93.4991 259.743 106.911C247.618 120.322 241.346 116.559 231.311 126.819C228.254 129.437 226.162 133.005 225.369 136.951C224.576 140.898 225.128 144.997 226.937 148.593C229.253 153.571 232.533 158.042 236.586 161.747L246.91 167.954L255.272 148.335C258.52 137.336 285.537 107.393 279.554 95.6539Z",
      fill: "url(#paint26_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M240.124 138.268C251.863 116.495 269.327 117.427 276.724 97.1652C276.852 96.8205 277.082 96.5232 277.384 96.3133C277.686 96.1034 278.045 95.9908 278.412 95.9908C278.78 95.9908 279.139 96.1034 279.441 96.3133C279.743 96.5232 279.973 96.8205 280.101 97.1652C283.317 103.823 288.463 112.732 290.907 135.181C291.574 140.141 291.173 145.186 289.731 149.979C288.288 154.771 285.839 159.2 282.545 162.969C267.654 181.848 223.624 168.887 240.124 138.268Z",
      fill: "url(#paint27_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M152.997 161.393C153.106 161.452 153.197 161.541 153.26 161.648C153.322 161.756 153.354 161.879 153.351 162.004V165.863L150.134 163.934C150.025 163.866 149.934 163.772 149.872 163.659C149.81 163.546 149.779 163.419 149.781 163.29V159.431L152.997 161.393Z",
      fill: "url(#paint28_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M160.49 157.437C160.6 157.504 160.69 157.598 160.752 157.711C160.814 157.824 160.846 157.951 160.844 158.08V161.811L157.628 159.881C157.52 159.812 157.431 159.716 157.369 159.604C157.308 159.492 157.275 159.366 157.274 159.238V155.378L160.49 157.437Z",
      fill: "url(#paint29_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.4",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M170.75 169.916C170.854 169.983 170.94 170.073 171.001 170.179C171.063 170.285 171.098 170.405 171.104 170.527V174.387L167.888 172.457C167.778 172.39 167.688 172.295 167.626 172.182C167.563 172.07 167.532 171.942 167.534 171.814V167.986L170.75 169.916Z",
        fill: "url(#paint30_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.4",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M200.113 176.606C200.222 176.666 200.313 176.754 200.376 176.862C200.438 176.97 200.47 177.093 200.466 177.217V181.077L197.25 179.147C197.14 179.08 197.05 178.985 196.988 178.872C196.926 178.76 196.894 178.633 196.896 178.504V174.677L200.113 176.606Z",
        fill: "url(#paint31_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M185.673 168.951C185.787 169.017 185.882 169.11 185.95 169.223C186.017 169.335 186.055 169.463 186.059 169.594V173.422L182.843 171.492C182.733 171.433 182.642 171.344 182.58 171.236C182.517 171.129 182.486 171.006 182.489 170.881V167.021L185.673 168.951Z",
      fill: "url(#paint32_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M189.243 180.465C189.353 180.524 189.444 180.612 189.507 180.72C189.569 180.828 189.6 180.951 189.597 181.076V184.935L186.381 183.005C186.271 182.938 186.181 182.843 186.119 182.731C186.057 182.618 186.025 182.491 186.027 182.362V178.535L189.243 180.465Z",
      fill: "url(#paint33_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M203.329 186.255C203.439 186.322 203.529 186.416 203.591 186.529C203.653 186.642 203.685 186.769 203.683 186.898V190.725L200.467 188.795C200.357 188.736 200.266 188.648 200.203 188.54C200.141 188.432 200.11 188.309 200.113 188.184V184.325L203.329 186.255Z",
      fill: "url(#paint34_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.4",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M189.436 175.962C189.546 176.021 189.637 176.11 189.699 176.218C189.762 176.326 189.793 176.449 189.79 176.573V180.433L186.574 178.503C186.464 178.436 186.373 178.341 186.311 178.228C186.249 178.115 186.218 177.988 186.22 177.86V174L189.436 175.962Z",
        fill: "url(#paint35_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.4",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M157.789 161.072C157.951 161.11 158.093 161.207 158.188 161.343C158.282 161.48 158.324 161.646 158.303 161.811V165.671L155.087 163.741C154.974 163.676 154.878 163.582 154.811 163.47C154.743 163.357 154.706 163.229 154.701 163.098V159.142L157.789 161.072Z",
        fill: "url(#paint36_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.4",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M166.087 160.621C166.196 160.68 166.287 160.769 166.35 160.876C166.412 160.984 166.444 161.107 166.44 161.232V165.027L163.224 163.097C163.109 163.036 163.015 162.942 162.952 162.828C162.889 162.714 162.861 162.584 162.87 162.454V158.595L166.087 160.621Z",
        fill: "url(#paint37_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.4",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M171.811 163.837C171.921 163.904 172.012 163.999 172.074 164.112C172.136 164.225 172.167 164.352 172.165 164.48V168.243L168.788 166.281C168.679 166.222 168.588 166.134 168.525 166.026C168.463 165.918 168.431 165.795 168.434 165.67V161.811L171.811 163.837Z",
        fill: "url(#paint38_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.4",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M178.79 166.346C178.904 166.404 178.999 166.491 179.067 166.598C179.135 166.706 179.173 166.83 179.176 166.957V170.816L175.96 168.887C175.85 168.819 175.76 168.725 175.698 168.612C175.636 168.499 175.604 168.372 175.606 168.243V164.384L178.79 166.346Z",
        fill: "url(#paint39_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.4",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M204.07 183.97C204.18 184.03 204.271 184.118 204.333 184.226C204.396 184.334 204.427 184.457 204.424 184.582V188.441L201.208 186.511C201.098 186.444 201.007 186.349 200.945 186.237C200.883 186.124 200.852 185.997 200.854 185.868V182.041L204.07 183.97Z",
        fill: "url(#paint40_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.4",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M180.817 175.094C180.93 175.152 181.026 175.239 181.093 175.346C181.161 175.454 181.199 175.578 181.203 175.705V179.564L177.986 177.635C177.876 177.567 177.786 177.473 177.724 177.36C177.662 177.247 177.63 177.12 177.633 176.991V173.164L180.817 175.094Z",
        fill: "url(#paint41_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M217.405 312.652C215.317 313.191 211.909 313.798 209.793 314.361C201.936 316.346 194.274 318.82 186.876 321.759C170.389 328.506 158.436 337.142 155.605 345.148C151.428 357.134 172.917 361.16 202.786 355.425C232.628 349.128 260.492 334.286 263.899 322.906C265.988 317.779 261.783 313.911 254.859 311.482C250.398 310.229 245.696 309.65 240.982 309.773C234.717 310.335 226.418 311.482 217.405 312.652Z",
      fill: "url(#paint42_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M235.653 239L221.437 240.126L205.807 243.889C205.807 243.889 200.018 241.187 209.023 226.071C214.619 216.422 219.701 216.712 228.867 204.49C236.457 195.131 238.516 189.985 243.34 189.535C249.386 197.415 236.972 230.349 235.653 239Z",
      fill: "url(#paint43_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M235.653 239L221.437 240.126L205.807 243.889C205.807 243.889 200.018 241.187 209.023 226.071C214.619 216.422 219.701 216.712 228.867 204.49C236.457 195.131 238.516 189.985 243.34 189.535C249.386 197.415 236.972 230.349 235.653 239Z",
      fill: "url(#paint44_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M256.687 261.996C256.687 261.996 266.335 246.687 258.552 222.662C252.763 205.101 247.714 194.52 244.111 189.631C243.243 188.313 242.117 189.374 241.667 190.082C241.667 198.54 228.802 214.525 223.689 233.693L256.687 261.996Z",
      fill: "url(#paint45_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M161.262 328.411C137.237 293.451 175.06 241.026 202.205 233.5C229.349 225.975 255.497 245.047 269.102 277.981C280.198 304.739 267.011 327.96 248.775 339.957C217.482 360.476 178.019 355.33 161.262 328.411Z",
      fill: "url(#paint46_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M154.605 272.48C153.929 271.773 153.318 271.162 153.929 270.744C154.54 270.326 155.216 269.425 155.666 270.036C156.374 270.036 156.374 271.355 156.374 271.773C156.17 272.039 155.898 272.245 155.586 272.37C155.275 272.494 154.936 272.532 154.605 272.48Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M133.313 242.73C136.883 239.836 149.169 231.152 166.666 240.833C184.162 250.514 185.545 246.333 194.872 255.788C210.406 270.454 189.983 288.304 189.983 288.304L180.334 294.061L172.583 275.793C169.624 265.501 133.539 245.432 133.313 242.73Z",
      fill: "url(#paint47_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M186.735 266.466C175.832 246.172 144.442 242.184 141.708 241.798C138.974 241.412 134.214 241.155 133.249 242.73C130.033 248.938 141.708 242.73 139.424 263.571C138.825 268.167 139.209 272.837 140.551 277.273C141.892 281.709 144.161 285.809 147.208 289.301C161.166 306.926 202.108 294.929 186.735 266.466Z",
      fill: "url(#paint48_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M240.027 324.84V326.834C240.027 330.437 242.021 331.98 244.658 330.437C246.079 329.415 247.238 328.073 248.043 326.52C248.848 324.966 249.275 323.245 249.29 321.495V318.633L246.588 321.849L244.144 322.267C243.179 323.682 242.31 325.001 240.027 324.84Z",
      fill: "#030922"
    }), /* @__PURE__ */ jsx("path", {
      d: "M240.027 324.84V326.834C240.027 330.437 242.021 331.98 244.658 330.437C246.079 329.415 247.238 328.073 248.043 326.52C248.848 324.966 249.275 323.245 249.29 321.495V318.633L246.588 321.849L244.144 322.267C243.179 323.682 242.31 325.001 240.027 324.84Z",
      fill: "#FF6CD0"
    }), /* @__PURE__ */ jsx("path", {
      d: "M244.305 322.106L246.749 321.688L249.451 318.472V321.367C249.439 323.082 248.985 324.766 248.132 326.255C247.988 325.258 247.545 324.327 246.862 323.587C246.179 322.846 245.287 322.33 244.305 322.106Z",
      fill: "#030922"
    }), /* @__PURE__ */ jsx("path", {
      d: "M236.714 315.481C237.108 314.036 237.834 312.702 238.833 311.586C239.832 310.469 241.078 309.601 242.471 309.049C247.36 306.154 251.123 306.605 251.541 307.73V307.988C251.991 309.306 250.673 311.204 245.977 315.578L245.141 316.189C245.398 316.189 245.398 316.189 245.398 316.446H244.883C244.594 316.736 244.594 316.736 244.433 316.736C244.272 316.736 243.726 316.993 243.565 316.993C241.603 318.344 236.264 318.344 236.714 315.481Z",
      fill: "url(#paint49_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M243.34 311.461C242.471 311.911 241.313 312.779 241.603 313.455C241.892 314.13 242.729 313.905 243.34 313.455C243.951 313.005 245.076 312.168 245.076 311.461C245.076 310.753 244.305 310.753 243.34 311.461Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M236.972 321.689C236.756 321.835 236.578 322.031 236.455 322.261C236.332 322.49 236.266 322.747 236.264 323.007C236.289 323.729 236.536 324.425 236.972 325.001C237.422 325.87 238.548 326.32 240.735 325.709L242.021 325.001C242.666 324.542 243.259 324.013 243.79 323.425C244.208 322.718 244.658 322.107 244.916 321.689C245.166 321.129 245.319 320.531 245.366 319.92V317.057C245.366 316.607 245.077 316.35 244.658 316.607C244.442 316.753 244.265 316.949 244.142 317.179C244.019 317.409 243.953 317.665 243.951 317.926C243.951 317.926 243.694 319.92 243.694 320.113C243.822 320.836 243.822 321.576 243.694 322.3C243.589 322.637 243.418 322.949 243.192 323.22C242.966 323.49 242.688 323.713 242.375 323.876C239.931 325.452 239.159 324.551 238.644 323.876C238.381 323.483 238.226 323.028 238.194 322.557C238.185 322.414 238.144 322.274 238.074 322.149C238.004 322.023 237.907 321.915 237.79 321.832C237.673 321.748 237.538 321.692 237.397 321.668C237.255 321.643 237.11 321.65 236.972 321.689Z",
      fill: "#030922"
    }), /* @__PURE__ */ jsx("path", {
      d: "M244.047 315.899C243.837 316.051 243.664 316.248 243.541 316.477C243.418 316.705 243.349 316.959 243.34 317.218V320.113C243.365 320.499 243.452 320.879 243.597 321.238C243.886 321.689 244.047 322.364 244.916 322.557C245.528 322.604 246.139 322.446 246.652 322.107C248.888 320.79 250.62 318.763 251.573 316.35C252.03 315.522 252.273 314.593 252.281 313.648C252.281 313.198 252.023 312.94 251.573 313.198C251.367 313.351 251.199 313.55 251.081 313.778C250.964 314.007 250.901 314.26 250.898 314.516C250.573 316.651 249.417 318.571 247.681 319.855C247.326 320.169 246.95 320.459 246.556 320.724C246.106 320.981 245.687 321.142 245.398 320.981C245.284 320.973 245.178 320.922 245.1 320.838C245.023 320.755 244.98 320.645 244.98 320.531C244.788 320.188 244.699 319.797 244.723 319.405V316.51C244.916 315.642 244.497 315.481 244.047 315.899Z",
      fill: "#030922"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.8",
      children: /* @__PURE__ */ jsx("g", {
        opacity: "0.8",
        children: /* @__PURE__ */ jsx("path", {
          opacity: "0.8",
          d: "M257.684 265.148C247.199 261.546 240.542 274.797 242.568 288.562C243.854 299.047 250.769 306.573 256.365 303.517C266.85 297.471 269.037 289.27 268.426 283.223C267.815 277.177 265.885 267.753 257.684 265.148Z",
          fill: "#5DA7F3"
        })
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.8",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.8",
        d: "M262.734 267.592C261.298 266.166 259.486 265.179 257.509 264.746C255.533 264.313 253.474 264.452 251.573 265.148C245.141 267.946 241.442 277.594 242.729 288.047C243.887 296.506 249.901 302.552 256.269 299.818C265.371 295.38 268.072 288.722 267.815 279.813C267.903 277.53 267.494 275.255 266.617 273.145C265.739 271.035 264.414 269.14 262.734 267.592Z",
        fill: "white"
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M254.339 268.3C249.451 270.744 245.881 275.633 246.138 285.41C246.138 292.068 252.152 298.95 258.199 296.506C263.345 294.319 269.102 287.597 266.657 276.951C265.081 270.551 258.359 266.274 254.339 268.3Z",
      fill: "url(#paint50_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M254.339 268.3C249.451 270.744 245.881 275.633 246.138 285.41C246.138 292.068 252.152 298.95 258.199 296.506C263.345 294.319 269.102 287.597 266.657 276.951C265.081 270.551 258.359 266.274 254.339 268.3Z",
      fill: "url(#paint51_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M258.295 272.384C258.295 272.384 258.295 272.384 258.102 272.384C257.569 272.599 257.099 272.944 256.734 273.388C256.368 273.832 256.12 274.36 256.012 274.925C256.012 275.697 256.269 277.015 257.137 277.176C258.006 277.337 259.324 275.697 259.678 274.828C260.032 273.96 259.775 271.966 258.295 272.384Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M252.763 278.848V279.041C252.763 279.749 253.374 280.617 254.082 280.521C254.79 280.424 255.208 279.556 255.401 278.945C255.432 278.748 255.414 278.545 255.349 278.356C255.284 278.167 255.174 277.997 255.028 277.861C254.882 277.724 254.705 277.625 254.512 277.573C254.319 277.521 254.116 277.517 253.921 277.562C253.64 277.669 253.388 277.842 253.187 278.066C252.986 278.289 252.84 278.558 252.763 278.848Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M261.415 292.742C260.739 293.193 260.128 293.45 259.421 293.9C257.52 295.132 255.733 296.531 254.082 298.081C250.319 301.683 247.649 305.414 247.875 308.148C247.875 312.329 253.921 312.329 261.672 307.891C269.423 303.452 275.502 296.505 275.502 292.324C275.536 291.893 275.476 291.46 275.326 291.055C275.176 290.649 274.941 290.281 274.635 289.975C274.329 289.669 273.961 289.433 273.555 289.284C273.15 289.134 272.717 289.074 272.286 289.108C271.012 289.139 269.752 289.378 268.555 289.816C266.011 290.332 263.589 291.325 261.415 292.742Z",
      fill: "url(#paint52_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M264.438 269.328C264.438 269.328 258.874 261.995 251.573 265.147C245.141 267.945 241.346 277.594 242.632 288.047C242.917 289.735 243.358 291.393 243.951 293C244.814 289.623 245.888 286.304 247.167 283.062C249 278.334 252.41 272.127 258.778 270.197C260.617 269.655 262.521 269.363 264.438 269.328Z",
      fill: "url(#paint53_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M244.047 293.032C244.598 290.243 245.329 287.493 246.234 284.798C247.053 282.062 248.289 279.469 249.901 277.112C251.538 274.722 253.651 272.696 256.108 271.162C256.72 270.802 257.354 270.479 258.005 270.197C258.687 269.901 259.385 269.643 260.096 269.425C261.517 269.077 262.975 268.904 264.438 268.91C265.052 268.824 265.642 268.616 266.175 268.299C266.657 267.981 267.029 267.52 267.236 266.98C267.442 266.409 267.442 265.783 267.236 265.212C267.152 264.903 266.998 264.618 266.786 264.378C266.574 264.138 266.31 263.95 266.014 263.829C266.366 263.895 266.699 264.04 266.988 264.251C267.277 264.462 267.516 264.736 267.686 265.051C268.047 265.684 268.162 266.429 268.008 267.141C267.935 267.512 267.79 267.866 267.58 268.18C267.37 268.495 267.1 268.765 266.786 268.975C266.178 269.367 265.502 269.64 264.792 269.779C263.414 269.774 262.041 269.947 260.707 270.293C259.378 270.664 258.11 271.228 256.944 271.966C254.426 273.365 252.233 275.284 250.512 277.594C248.874 279.872 247.574 282.374 246.652 285.023C245.622 287.637 244.752 290.312 244.047 293.032Z",
      fill: "#0D1276"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.8",
      children: /* @__PURE__ */ jsxs("g", {
        opacity: "0.8",
        children: [/* @__PURE__ */ jsx("path", {
          opacity: "0.8",
          d: "M210.245 289.076C204.906 290.298 200.596 294.865 198.731 302.359C195.836 313.648 203.62 325.869 216.967 323.328C228.513 321.141 232.34 315.642 232.34 306.122C232.34 296.602 222.306 284.991 210.245 289.076Z",
          fill: "#5090CD"
        }), /* @__PURE__ */ jsx("path", {
          opacity: "0.8",
          d: "M210.502 287.95C205.163 289.172 200.853 293.707 198.988 301.233C196.093 312.522 203.877 324.744 217.224 322.203C228.77 320.016 232.597 314.516 232.597 304.996C232.597 295.476 222.917 284.027 210.502 287.95Z",
          fill: "white"
        })]
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M214.104 293.032C205.613 294.769 203.008 303.678 204.038 310.432C204.831 313.741 206.804 316.648 209.587 318.607C212.369 320.567 215.77 321.445 219.154 321.077C222.873 320.408 226.173 318.288 228.33 315.185C230.486 312.082 231.321 308.249 230.652 304.53C229.982 300.811 227.862 297.51 224.759 295.354C221.656 293.198 217.823 292.363 214.104 293.032Z",
      fill: "url(#paint54_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M214.104 293.032C205.613 294.769 203.008 303.678 204.038 310.432C204.831 313.741 206.804 316.648 209.587 318.607C212.369 320.567 215.77 321.445 219.154 321.077C222.873 320.408 226.173 318.288 228.33 315.185C230.486 312.082 231.321 308.249 230.652 304.53C229.982 300.811 227.862 297.51 224.759 295.354C221.656 293.198 217.823 292.363 214.104 293.032Z",
      fill: "url(#paint55_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M217.835 297.664L217.224 298.082C216.098 299.047 213.815 303.324 217.417 303.324C217.94 303.402 218.471 303.402 218.993 303.324C219.52 303.021 219.972 302.603 220.317 302.103C220.662 301.602 220.891 301.03 220.987 300.43C221.148 299.401 220.28 297.214 218.543 297.632C218.307 297.591 218.066 297.602 217.835 297.664Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M220.022 317.765L217.578 318.376C215.082 319.064 212.632 319.913 210.245 320.917C204.938 323.265 201.175 326.223 200.114 329.054C198.795 333.17 205.71 334.553 215.23 332.656C224.75 330.758 233.659 325.291 234.785 321.367C235.492 319.63 234.077 318.151 231.89 317.443C230.459 316.977 228.956 316.77 227.452 316.832C225.619 316.961 222.917 317.411 220.022 317.765Z",
      fill: "url(#paint56_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M210.245 286.729C204.906 287.951 200.596 293.643 198.892 301.137C198.613 302.497 198.409 303.872 198.281 305.254C198.281 305.254 201.497 305.962 210.502 298.436C217.932 292.003 231.536 298.436 231.536 298.436C231.536 298.436 225.522 283.512 210.245 286.729Z",
      fill: "url(#paint57_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M195.129 300.269C194.997 300.818 194.984 301.388 195.089 301.942C195.195 302.497 195.416 303.023 195.74 303.485C196.033 303.886 196.415 304.214 196.856 304.443C197.296 304.671 197.784 304.795 198.281 304.804C198.569 304.846 198.861 304.846 199.149 304.804L200.178 304.546C200.886 304.289 201.497 304 202.205 303.678C203.52 302.95 204.797 302.156 206.032 301.298C207.254 300.43 208.476 299.561 209.634 298.596C210.237 298.086 210.871 297.614 211.532 297.181L212.593 296.667C212.929 296.486 213.285 296.346 213.654 296.248C216.629 295.363 219.773 295.209 222.82 295.798C224.328 296.052 225.812 296.428 227.259 296.924C228.7 297.384 230.108 297.942 231.472 298.596C228.658 297.487 225.721 296.72 222.724 296.313C219.806 295.8 216.805 296.044 214.008 297.02C213.662 297.111 213.335 297.263 213.043 297.471L212.078 297.985C211.466 298.393 210.875 298.834 210.309 299.304C209.184 300.269 207.962 301.201 206.739 302.102C205.492 303.01 204.18 303.827 202.816 304.546C202.104 304.906 201.374 305.228 200.629 305.511C200.275 305.511 199.857 305.768 199.503 305.833C199.069 305.931 198.618 305.931 198.184 305.833C197.523 305.837 196.873 305.66 196.305 305.32C195.738 304.979 195.275 304.489 194.968 303.903C194.663 303.342 194.518 302.708 194.55 302.07C194.52 301.746 194.556 301.42 194.656 301.11C194.755 300.801 194.916 300.514 195.129 300.269Z",
      fill: "#0D1276"
    }), /* @__PURE__ */ jsx("path", {
      d: "M210.341 301.33C210.001 301.577 209.741 301.919 209.593 302.312C209.445 302.706 209.415 303.134 209.507 303.545C209.6 303.955 209.81 304.329 210.113 304.621C210.415 304.914 210.796 305.111 211.21 305.189C211.42 305.218 211.635 305.192 211.832 305.113C212.03 305.034 212.203 304.905 212.335 304.739C213.043 304.321 213.043 304.128 213.236 302.905C213.282 302.663 213.276 302.414 213.22 302.174C213.164 301.934 213.059 301.708 212.91 301.512C212.762 301.315 212.574 301.151 212.359 301.031C212.143 300.911 211.905 300.838 211.66 300.815C211.196 300.917 210.751 301.091 210.341 301.33Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M294.928 199.216C294.181 198.891 293.364 198.762 292.554 198.841C291.743 198.92 290.966 199.204 290.296 199.666L266.271 213.624C264.069 215.205 262.268 217.279 261.012 219.68C259.755 222.082 259.078 224.744 259.035 227.454V248.649C258.904 249.805 259.089 250.974 259.57 252.034C260.052 253.093 260.811 254.001 261.768 254.663C262.991 255.242 266.496 256.528 266.496 256.528L269.712 252.122C269.873 252.122 270.002 252.122 270.002 252.347V262.703C269.982 262.902 270.037 263.101 270.156 263.262C270.275 263.422 270.449 263.533 270.645 263.572L274.987 265.373L279.876 246.301L280.133 246.076L290.168 240.061C292.396 238.478 294.221 236.392 295.495 233.973C296.769 231.554 297.456 228.869 297.5 226.135L299.109 200.856C299.109 200.856 295.249 199.441 294.928 199.216Z",
      fill: "url(#paint58_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M294.896 201.499L270.87 215.393C268.651 216.986 266.84 219.081 265.582 221.506C264.325 223.932 263.657 226.619 263.634 229.351V250.257C263.634 255.595 266.85 258.008 270.87 255.724L274.312 253.762C274.312 253.762 274.601 253.762 274.601 253.987V264.344C274.601 265.566 275.695 265.501 276.338 264.344L284.475 248.07L284.7 247.844L294.896 241.991C297.094 240.4 298.893 238.319 300.149 235.913C301.404 233.508 302.084 230.843 302.132 228.129V206.999C302.132 201.66 298.851 199.215 294.896 201.499Z",
      fill: "url(#paint59_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M290.94 216.261C289.106 214.91 286.148 216.582 284.314 220.12L283.253 222.082C282.963 222.532 282.545 222.79 282.32 222.597L281.323 221.825C279.49 220.442 276.499 222.146 274.698 225.652C272.897 229.158 272.865 233.178 274.698 234.561L282.385 240.382C282.642 240.382 283.06 240.382 283.285 239.868L290.972 225.17C292.805 221.664 292.805 217.676 290.94 216.261Z",
      fill: "url(#paint60_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M290.94 216.261C289.106 214.91 286.148 216.582 284.314 220.12L283.253 222.082C282.963 222.532 282.545 222.79 282.32 222.597L281.323 221.825C279.49 220.442 276.499 222.146 274.698 225.652C272.897 229.158 272.865 233.178 274.698 234.561L282.385 240.382C282.642 240.382 283.06 240.382 283.285 239.868L290.972 225.17C292.805 221.664 292.805 217.676 290.94 216.261Z",
      fill: "#FFF5F5"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.11",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.11",
        d: "M66.0305 268.814C64.769 268.086 63.3381 267.702 61.8816 267.702C60.425 267.702 58.9941 268.086 57.7327 268.814L8.23528 297.309C8.06237 297.416 7.9196 297.565 7.82057 297.742C7.72154 297.92 7.66956 298.119 7.66956 298.323C7.66956 298.526 7.72154 298.725 7.82057 298.903C7.9196 299.08 8.06237 299.229 8.23528 299.336L58.1508 328.121C59.2585 328.768 60.5183 329.109 61.8012 329.109C63.084 329.109 64.3439 328.768 65.4515 328.121L115.431 299.368C115.604 299.261 115.747 299.112 115.846 298.935C115.945 298.758 115.997 298.558 115.997 298.355C115.997 298.152 115.945 297.952 115.846 297.774C115.747 297.597 115.604 297.448 115.431 297.342L66.0305 268.814Z",
        fill: "url(#paint61_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.11",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.11",
        d: "M66.0305 260.484C64.769 259.756 63.3381 259.373 61.8816 259.373C60.425 259.373 58.9941 259.756 57.7327 260.484L8.23528 288.98C8.06237 289.086 7.9196 289.235 7.82057 289.413C7.72154 289.59 7.66956 289.79 7.66956 289.993C7.66956 290.196 7.72154 290.396 7.82057 290.573C7.9196 290.75 8.06237 290.899 8.23528 291.006L58.1508 319.952C59.2585 320.599 60.5183 320.94 61.8012 320.94C63.084 320.94 64.3439 320.599 65.4515 319.952L115.431 291.199C115.604 291.092 115.747 290.943 115.846 290.766C115.945 290.589 115.997 290.389 115.997 290.186C115.997 289.983 115.945 289.783 115.846 289.606C115.747 289.428 115.604 289.279 115.431 289.173L66.0305 260.484Z",
        fill: "url(#paint62_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.11",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.11",
        d: "M66.0305 252.154C64.769 251.426 63.3381 251.042 61.8816 251.042C60.425 251.042 58.9941 251.426 57.7327 252.154L8.23528 280.811C8.06237 280.917 7.9196 281.066 7.82057 281.243C7.72154 281.421 7.66956 281.621 7.66956 281.824C7.66956 282.027 7.72154 282.226 7.82057 282.404C7.9196 282.581 8.06237 282.73 8.23528 282.837L58.1508 311.783C59.2585 312.43 60.5183 312.771 61.8012 312.771C63.084 312.771 64.3439 312.43 65.4515 311.783L115.431 282.837C115.604 282.73 115.747 282.581 115.846 282.404C115.945 282.226 115.997 282.027 115.997 281.824C115.997 281.621 115.945 281.421 115.846 281.243C115.747 281.066 115.604 280.917 115.431 280.811L66.0305 252.154Z",
        fill: "url(#paint63_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.11",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.11",
        d: "M66.0302 243.824C64.771 243.09 63.3392 242.703 61.8813 242.703C60.4235 242.703 58.9917 243.09 57.7324 243.824L8.23507 272.32C8.0617 272.422 7.91802 272.568 7.8182 272.743C7.71839 272.918 7.66589 273.116 7.66589 273.317C7.66589 273.518 7.71839 273.716 7.8182 273.891C7.91802 274.066 8.0617 274.212 8.23507 274.314L58.1505 303.26C59.2582 303.907 60.5181 304.248 61.8009 304.248C63.0838 304.248 64.3436 303.907 65.4513 303.26L115.431 274.314C115.604 274.207 115.747 274.058 115.846 273.881C115.945 273.704 115.997 273.504 115.997 273.301C115.997 273.098 115.945 272.898 115.846 272.721C115.747 272.543 115.604 272.394 115.431 272.288L66.0302 243.824Z",
        fill: "url(#paint64_linear_10025_65880)"
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M115.431 272.32L66.0303 243.825C64.7711 243.09 63.3393 242.703 61.8814 242.703C60.4235 242.703 58.9918 243.09 57.7325 243.825L8.23515 272.32C8.05536 272.416 7.9059 272.56 7.80362 272.736C7.70133 272.912 7.65028 273.114 7.65623 273.317V298.307C7.65151 298.515 7.70277 298.72 7.80462 298.901C7.90648 299.082 8.05519 299.232 8.23515 299.336L58.1506 328.121C59.2583 328.768 60.5181 329.109 61.801 329.109C63.0839 329.109 64.3437 328.768 65.4514 328.121L115.431 299.368C115.609 299.262 115.756 299.111 115.857 298.931C115.959 298.75 116.012 298.546 116.01 298.339V273.349C116.012 273.142 115.959 272.938 115.857 272.758C115.756 272.577 115.609 272.427 115.431 272.32Z",
      fill: "url(#paint65_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M115.431 272.32L66.0303 243.825C64.7711 243.09 63.3393 242.703 61.8814 242.703C60.4235 242.703 58.9918 243.09 57.7325 243.825L8.23515 272.32C8.05536 272.416 7.9059 272.56 7.80362 272.736C7.70133 272.912 7.65028 273.114 7.65623 273.317L58.2793 302.263C59.4038 302.912 60.6794 303.254 61.9779 303.254C63.2764 303.254 64.552 302.912 65.6765 302.263L116.01 273.317C116.006 273.116 115.951 272.918 115.849 272.744C115.748 272.57 115.604 272.424 115.431 272.32Z",
      fill: "url(#paint66_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M115.431 273.188L65.4517 302.134C64.344 302.781 63.0842 303.122 61.8013 303.122C60.5184 303.122 59.2586 302.781 58.1509 302.134L8.23541 273.188C8.06404 273.071 7.92115 272.917 7.8173 272.738C7.66509 273.002 7.62362 273.316 7.70193 273.612C7.78024 273.907 7.97198 274.159 8.23541 274.314L58.1509 303.259C59.2586 303.906 60.5184 304.248 61.8013 304.248C63.0842 304.248 64.344 303.906 65.4517 303.259L115.431 274.314C115.565 274.24 115.683 274.14 115.777 274.02C115.871 273.9 115.939 273.763 115.978 273.615C116.017 273.468 116.026 273.314 116.004 273.163C115.982 273.012 115.929 272.867 115.85 272.738C115.758 272.926 115.612 273.082 115.431 273.188Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.2",
      d: "M61.8491 276.694C65.7747 276.694 68.957 274.851 68.957 272.577C68.957 270.304 65.7747 268.461 61.8491 268.461C57.9236 268.461 54.7413 270.304 54.7413 272.577C54.7413 274.851 57.9236 276.694 61.8491 276.694Z",
      fill: "#180D5B"
    }), /* @__PURE__ */ jsxs("g", {
      opacity: "0.61",
      children: [/* @__PURE__ */ jsx("path", {
        opacity: "0.61",
        d: "M65.2907 244.724C64.2492 244.123 63.0679 243.807 61.8654 243.807C60.6629 243.807 59.4816 244.123 58.4401 244.724L17.6587 268.235C17.5117 268.319 17.3896 268.441 17.3047 268.588C17.2199 268.735 17.1752 268.902 17.1752 269.071C17.1752 269.241 17.2199 269.407 17.3047 269.554C17.3896 269.701 17.5117 269.823 17.6587 269.907L58.7939 293.675C59.7162 294.196 60.7577 294.471 61.8172 294.471C62.8766 294.471 63.9181 294.196 64.8404 293.675L106.04 269.939C106.187 269.855 106.309 269.733 106.394 269.586C106.479 269.439 106.523 269.273 106.523 269.103C106.523 268.934 106.479 268.767 106.394 268.62C106.309 268.473 106.187 268.352 106.04 268.267L65.2907 244.724Z",
        fill: "url(#paint67_linear_10025_65880)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.61",
        d: "M65.2907 237.874C64.2492 237.272 63.0679 236.956 61.8654 236.956C60.6629 236.956 59.4816 237.272 58.4401 237.874L17.6587 261.513C17.5117 261.597 17.3896 261.719 17.3047 261.866C17.2199 262.013 17.1752 262.179 17.1752 262.349C17.1752 262.518 17.2199 262.685 17.3047 262.832C17.3896 262.979 17.5117 263.101 17.6587 263.185L58.7939 286.953C59.7162 287.474 60.7577 287.748 61.8172 287.748C62.8766 287.748 63.9181 287.474 64.8404 286.953L106.04 263.217C106.187 263.133 106.309 263.011 106.394 262.864C106.479 262.717 106.523 262.551 106.523 262.381C106.523 262.211 106.479 262.045 106.394 261.898C106.309 261.751 106.187 261.629 106.04 261.545L65.2907 237.874Z",
        fill: "url(#paint68_linear_10025_65880)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.61",
        d: "M65.2907 230.991C64.2492 230.39 63.0679 230.073 61.8654 230.073C60.6629 230.073 59.4816 230.39 58.4401 230.991L17.6587 254.502C17.5117 254.586 17.3896 254.708 17.3047 254.855C17.2199 255.002 17.1752 255.168 17.1752 255.338C17.1752 255.508 17.2199 255.674 17.3047 255.821C17.3896 255.968 17.5117 256.09 17.6587 256.174L58.7939 279.91C59.7109 280.447 60.7545 280.73 61.8172 280.73C62.8799 280.73 63.9234 280.447 64.8404 279.91L106.04 256.174C106.187 256.09 106.309 255.968 106.394 255.821C106.479 255.674 106.523 255.508 106.523 255.338C106.523 255.168 106.479 255.002 106.394 254.855C106.309 254.708 106.187 254.586 106.04 254.502L65.2907 230.991Z",
        fill: "url(#paint69_linear_10025_65880)"
      })]
    }), /* @__PURE__ */ jsx("path", {
      d: "M40.5582 141.903L55.4492 143.093L71.7553 147.017C71.7553 147.017 77.7696 144.186 68.5391 128.363C62.6856 118.296 57.3789 118.553 47.7946 105.849C39.8184 96.2006 37.7279 90.6687 32.6141 90.1863C26.1174 98.5162 39.3038 133.026 40.5582 141.903Z",
      fill: "url(#paint70_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M13.7672 168.243C13.7672 168.243 7.3348 150.94 15.4075 125.757C19.1504 113.312 24.629 101.456 31.6815 90.5398C32.582 89.1569 33.772 90.2504 34.2544 90.9901C34.2544 99.8668 47.7946 116.72 53.1014 136.66L13.7672 168.243Z",
      fill: "url(#paint71_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M13.7672 168.243C13.7672 168.243 7.3348 150.94 15.4075 125.757C19.1504 113.312 24.629 101.456 31.6815 90.5398C32.582 89.1569 33.772 90.2504 34.2544 90.9901C34.2544 99.8668 47.7946 116.72 53.1014 136.66L13.7672 168.243Z",
      fill: "url(#paint72_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M118.39 235.784C143.541 199.119 103.949 144.186 75.4859 136.307C47.0225 128.427 19.7169 148.399 5.43699 182.909C-6.1735 210.922 7.62401 235.237 26.7604 247.78C56.8641 267.528 100.83 263.99 118.39 235.784Z",
      fill: "url(#paint73_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M47.0547 189.503C51.6742 189.509 56.1918 188.145 60.0359 185.583C63.8799 183.021 66.8777 179.377 68.6499 175.111C70.4221 170.845 70.8891 166.149 69.9918 161.617C69.0945 157.086 66.8732 152.922 63.609 149.654C60.3448 146.385 56.1843 144.158 51.654 143.254C47.1238 142.351 42.4273 142.811 38.1588 144.578C33.8904 146.344 30.2418 149.337 27.6746 153.177C25.1075 157.018 23.7373 161.533 23.7373 166.153C23.7288 169.219 24.3259 172.256 25.4943 175.091C26.6627 177.926 28.3795 180.502 30.5459 182.671C32.7124 184.841 35.2861 186.561 38.1191 187.733C40.9521 188.906 43.9888 189.507 47.0547 189.503Z",
      fill: "url(#paint74_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M49.1455 176.863C52.0629 176.882 54.9202 176.035 57.3553 174.428C59.7903 172.821 61.6933 170.527 62.823 167.837C63.9527 165.147 64.2582 162.182 63.7008 159.319C63.1434 156.455 61.7481 153.821 59.692 151.752C57.6358 149.682 55.0113 148.269 52.1514 147.693C49.2914 147.117 46.3247 147.403 43.6275 148.515C40.9302 149.627 38.624 151.515 37.0011 153.939C35.3782 156.364 34.5118 159.215 34.5118 162.133C34.5032 166.025 36.0391 169.763 38.7826 172.524C41.526 175.286 45.2529 176.846 49.1455 176.863Z",
      fill: "url(#paint75_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M46.8617 166.442C49.363 166.449 51.8099 165.713 53.8927 164.328C55.9755 162.943 57.6006 160.971 58.5622 158.662C59.5238 156.353 59.7787 153.811 59.2946 151.357C58.8105 148.903 57.6093 146.647 55.8429 144.877C54.0765 143.106 51.8243 141.899 49.3716 141.408C46.9189 140.918 44.3758 141.166 42.0643 142.122C39.7529 143.078 37.7769 144.698 36.3866 146.777C34.9963 148.856 34.2542 151.301 34.2542 153.803C34.25 155.461 34.5729 157.104 35.2046 158.637C35.8363 160.171 36.7643 161.564 37.9355 162.738C39.1066 163.913 40.4979 164.844 42.0296 165.48C43.5613 166.115 45.2034 166.442 46.8617 166.442Z",
      fill: "url(#paint76_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M46.8617 166.442C49.363 166.449 51.8099 165.713 53.8927 164.328C55.9755 162.943 57.6006 160.971 58.5622 158.662C59.5238 156.353 59.7787 153.811 59.2946 151.357C58.8105 148.903 57.6093 146.647 55.8429 144.877C54.0765 143.106 51.8243 141.899 49.3716 141.408C46.9189 140.918 44.3758 141.166 42.0643 142.122C39.7529 143.078 37.7769 144.698 36.3866 146.777C34.9963 148.856 34.2542 151.301 34.2542 153.803C34.25 155.461 34.5729 157.104 35.2046 158.637C35.8363 160.171 36.7643 161.564 37.9355 162.738C39.1066 163.913 40.4979 164.844 42.0296 165.48C43.5613 166.115 45.2034 166.442 46.8617 166.442Z",
      fill: "url(#paint77_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M44.932 155.186C47.0198 155.192 49.0625 154.579 50.8015 153.423C52.5405 152.268 53.8976 150.623 54.701 148.696C55.5044 146.769 55.7179 144.647 55.3145 142.598C54.9111 140.55 53.9089 138.667 52.4349 137.189C50.9609 135.71 49.0812 134.702 47.034 134.292C44.9868 133.883 42.8641 134.09 40.9346 134.887C39.0051 135.685 37.3557 137.037 36.1951 138.772C35.0345 140.508 34.415 142.549 34.415 144.637C34.4065 146.022 34.6725 147.394 35.1976 148.676C35.7227 149.958 36.4966 151.123 37.4744 152.103C38.4523 153.084 39.6148 153.862 40.8948 154.391C42.1748 154.92 43.547 155.19 44.932 155.186Z",
      fill: "url(#paint78_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M44.932 155.186C47.0198 155.192 49.0625 154.579 50.8015 153.423C52.5405 152.268 53.8976 150.623 54.701 148.696C55.5044 146.769 55.7179 144.647 55.3145 142.598C54.9111 140.55 53.9089 138.667 52.4349 137.189C50.9609 135.71 49.0812 134.702 47.034 134.292C44.9868 133.883 42.8641 134.09 40.9346 134.887C39.0051 135.685 37.3557 137.037 36.1951 138.772C35.0345 140.508 34.415 142.549 34.415 144.637C34.4065 146.022 34.6725 147.394 35.1976 148.676C35.7227 149.958 36.4966 151.123 37.4744 152.103C38.4523 153.084 39.6148 153.862 40.8948 154.391C42.1748 154.92 43.547 155.19 44.932 155.186Z",
      fill: "url(#paint79_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M44.0314 146.116C45.7376 146.122 47.4072 145.622 48.8289 144.679C50.2505 143.735 51.3603 142.391 52.0176 140.817C52.675 139.243 52.8503 137.509 52.5213 135.834C52.1924 134.16 51.374 132.621 50.1698 131.413C48.9657 130.204 47.4299 129.38 45.757 129.045C44.0842 128.71 42.3494 128.878 40.7726 129.53C39.1957 130.181 37.8476 131.286 36.8991 132.704C35.9505 134.122 35.4442 135.79 35.4442 137.496C35.4225 138.631 35.6295 139.759 36.0529 140.813C36.4764 141.866 37.1076 142.824 37.9089 143.628C38.7103 144.432 39.6653 145.067 40.7172 145.494C41.7691 145.922 42.8962 146.133 44.0314 146.116Z",
      fill: "url(#paint80_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M44.0314 146.116C45.7376 146.122 47.4072 145.622 48.8289 144.679C50.2505 143.735 51.3603 142.391 52.0176 140.817C52.675 139.243 52.8503 137.509 52.5213 135.834C52.1924 134.16 51.374 132.621 50.1698 131.413C48.9657 130.204 47.4299 129.38 45.757 129.045C44.0842 128.71 42.3494 128.878 40.7726 129.53C39.1957 130.181 37.8476 131.286 36.8991 132.704C35.9505 134.122 35.4442 135.79 35.4442 137.496C35.4225 138.631 35.6295 139.759 36.0529 140.813C36.4764 141.866 37.1076 142.824 37.9089 143.628C38.7103 144.432 39.6653 145.067 40.7172 145.494C41.7691 145.922 42.8962 146.133 44.0314 146.116Z",
      fill: "url(#paint81_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M42.5197 137.689C43.8633 137.696 45.1785 137.303 46.2987 136.561C47.4189 135.819 48.2937 134.762 48.8122 133.522C49.3308 132.283 49.4698 130.917 49.2116 129.599C48.9534 128.28 48.3096 127.068 47.3618 126.116C46.4141 125.164 45.205 124.514 43.8877 124.25C42.5704 123.985 41.2043 124.118 39.9624 124.63C38.7205 125.143 37.6588 126.013 36.9117 127.13C36.1645 128.246 35.7657 129.56 35.7657 130.903C35.7615 131.793 35.933 132.674 36.2706 133.498C36.6081 134.321 37.1049 135.069 37.7325 135.7C38.3601 136.33 39.1061 136.831 39.9276 137.172C40.7492 137.514 41.6301 137.689 42.5197 137.689Z",
      fill: "url(#paint82_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M42.5197 137.689C43.8633 137.696 45.1785 137.303 46.2987 136.561C47.4189 135.819 48.2937 134.762 48.8122 133.522C49.3308 132.283 49.4698 130.917 49.2116 129.599C48.9534 128.28 48.3096 127.068 47.3618 126.116C46.4141 125.164 45.205 124.514 43.8877 124.25C42.5704 123.985 41.2043 124.118 39.9624 124.63C38.7205 125.143 37.6588 126.013 36.9117 127.13C36.1645 128.246 35.7657 129.56 35.7657 130.903C35.7615 131.793 35.933 132.674 36.2706 133.498C36.6081 134.321 37.1049 135.069 37.7325 135.7C38.3601 136.33 39.1061 136.831 39.9276 137.172C40.7492 137.514 41.6301 137.689 42.5197 137.689Z",
      fill: "url(#paint83_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M41.4584 130.903C42.5298 130.909 43.5788 130.597 44.4723 130.006C45.3658 129.415 46.0633 128.571 46.4762 127.582C46.8892 126.594 46.9989 125.505 46.7914 124.454C46.584 123.403 46.0687 122.437 45.3111 121.679C44.5535 120.922 43.5878 120.406 42.5367 120.199C41.4856 119.991 40.3965 120.101 39.4079 120.514C38.4193 120.927 37.5758 121.625 36.9845 122.518C36.3933 123.412 36.081 124.461 36.0873 125.532C36.0742 126.241 36.2042 126.945 36.4695 127.603C36.7348 128.26 37.1299 128.858 37.6313 129.359C38.1327 129.86 38.73 130.256 39.3876 130.521C40.0451 130.786 40.7494 130.916 41.4584 130.903Z",
      fill: "url(#paint84_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M41.4584 130.903C42.5298 130.909 43.5788 130.597 44.4723 130.006C45.3658 129.415 46.0633 128.571 46.4762 127.582C46.8892 126.594 46.9989 125.505 46.7914 124.454C46.584 123.403 46.0687 122.437 45.3111 121.679C44.5535 120.922 43.5878 120.406 42.5367 120.199C41.4856 119.991 40.3965 120.101 39.4079 120.514C38.4193 120.927 37.5758 121.625 36.9845 122.518C36.3933 123.412 36.081 124.461 36.0873 125.532C36.0742 126.241 36.2042 126.945 36.4695 127.603C36.7348 128.26 37.1299 128.858 37.6313 129.359C38.1327 129.86 38.73 130.256 39.3876 130.521C40.0451 130.786 40.7494 130.916 41.4584 130.903Z",
      fill: "url(#paint85_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M130.194 129.263C126.431 126.24 122.7 127.173 110.897 140.263C99.093 153.353 92.9501 149.911 83.1728 159.56C66.8988 174.933 88.2866 193.587 88.2866 193.587L98.3533 199.634L106.49 180.53C109.707 169.916 136.047 140.713 130.194 129.263Z",
      fill: "url(#paint86_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M91.7925 170.817C103.21 149.59 120.224 150.49 127.46 130.743C127.591 130.423 127.813 130.15 128.1 129.957C128.386 129.765 128.723 129.662 129.068 129.662C129.413 129.662 129.751 129.765 130.037 129.957C130.323 130.15 130.546 130.423 130.676 130.743C133.893 137.175 138.813 145.923 141.193 167.794C141.848 172.632 141.46 177.554 140.057 182.23C138.653 186.906 136.267 191.228 133.056 194.906C118.583 213.271 75.6793 200.663 91.7925 170.817Z",
      fill: "url(#paint87_linear_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M38.4354 222.18C38.036 220.656 37.2834 219.247 36.2385 218.068C35.1937 216.89 33.8859 215.973 32.4211 215.393C27.2752 212.37 23.3514 212.821 22.7725 214.01V214.3C22.3222 215.683 23.673 217.773 28.626 222.244L29.6552 222.919C29.3979 222.919 29.3979 222.919 29.3979 223.209H29.9446C30.2019 223.466 30.2019 223.466 30.3949 223.466C30.5879 223.466 31.1346 223.756 31.2954 223.756C33.3216 225.171 38.9178 225.171 38.4354 222.18Z",
      fill: "url(#paint88_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M38.4354 222.18C38.036 220.656 37.2834 219.247 36.2385 218.068C35.1937 216.89 33.8859 215.973 32.4211 215.393C27.2752 212.37 23.3514 212.821 22.7725 214.01V214.3C22.3222 215.683 23.673 217.773 28.626 222.244L29.6552 222.919C29.3979 222.919 29.3979 222.919 29.3979 223.209H29.9446C30.2019 223.466 30.2019 223.466 30.3949 223.466C30.5879 223.466 31.1346 223.756 31.2954 223.756C33.3216 225.171 38.9178 225.171 38.4354 222.18Z",
      fill: "url(#paint89_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M31.4885 217.934C32.4212 218.416 33.6112 219.317 33.3217 220.057C33.0323 220.796 32.1317 220.507 31.4885 220.057C30.8453 219.606 29.6553 218.674 29.6553 217.934C29.6553 217.194 30.588 217.323 31.4885 217.934Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M38.2744 228.676C38.491 228.829 38.6681 229.031 38.7911 229.266C38.9141 229.501 38.9796 229.762 38.982 230.027C38.9572 230.788 38.7113 231.526 38.2744 232.15C37.792 233.05 36.602 233.5 34.3185 232.857L32.8712 232.15C32.1963 231.666 31.5809 231.105 31.038 230.477C30.5877 229.77 30.1053 229.126 29.848 228.676C29.5997 228.093 29.4476 227.474 29.3977 226.843V223.82C29.3977 223.369 29.655 223.08 30.1053 223.369C30.3297 223.517 30.5145 223.717 30.6435 223.953C30.7725 224.188 30.8417 224.452 30.845 224.72C30.845 224.72 31.1345 226.843 31.1345 227.004C30.9892 227.769 30.9892 228.554 31.1345 229.319C31.3576 230.019 31.8412 230.606 32.4853 230.96C35.0582 232.6 35.9588 231.667 36.4412 230.96C36.7053 230.544 36.8601 230.068 36.8915 229.577C37.0844 228.483 37.985 228.676 38.2744 228.676Z",
      fill: "#030922"
    }), /* @__PURE__ */ jsx("path", {
      d: "M30.7807 222.629C31.0013 222.78 31.1833 222.982 31.3118 223.216C31.4403 223.451 31.5118 223.713 31.5204 223.98V227.003C31.4952 227.414 31.3972 227.817 31.2309 228.193C30.9415 228.676 30.7807 229.383 29.848 229.576C29.2056 229.613 28.567 229.456 28.0147 229.126C25.7035 227.714 23.9099 225.593 22.901 223.079C22.4252 222.211 22.1711 221.239 22.1613 220.249C22.1613 219.799 22.4507 219.509 22.901 219.799C23.1216 219.95 23.3036 220.151 23.4321 220.386C23.5606 220.621 23.6321 220.882 23.6407 221.15C23.941 223.363 25.0953 225.372 26.8569 226.746C27.223 227.084 27.6216 227.386 28.0469 227.646C28.5293 227.936 28.9796 228.097 29.2369 227.936C29.3573 227.929 29.4716 227.881 29.5598 227.798C29.648 227.716 29.7044 227.605 29.7193 227.486C29.9068 227.118 29.9955 226.708 29.9766 226.296V223.272C29.848 222.436 30.3304 222.179 30.7807 222.629Z",
      fill: "#030922"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.8",
      children: /* @__PURE__ */ jsxs("g", {
        opacity: "0.8",
        children: [/* @__PURE__ */ jsx("path", {
          opacity: "0.8",
          d: "M64.2614 191.851C69.4716 193.138 73.7492 198.283 75.486 206.42C78.3484 218.771 70.7581 232.15 57.7647 229.384C46.508 227.004 42.745 220.893 42.745 210.537C42.745 200.181 52.5544 187.541 64.2614 191.851Z",
          fill: "#5090CD"
        }), /* @__PURE__ */ jsx("path", {
          opacity: "0.8",
          d: "M64.0687 190.757C69.279 192.012 73.7173 197.19 75.3254 205.295C78.1557 217.645 70.5654 231.024 57.572 228.258C46.3153 225.717 42.5201 219.703 42.5201 209.25C42.5201 198.798 51.9115 186.287 64.0687 190.757Z",
          fill: "white"
        })]
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M59.5016 190.757C67.7351 192.654 70.3724 202.464 69.1502 209.861C67.9281 217.258 60.2735 222.726 54.42 221.6C50.5613 220.622 47.2489 218.151 45.2106 214.732C43.1722 211.313 42.5747 207.224 43.5492 203.364C45.2217 195.163 51.0752 188.827 59.5016 190.757Z",
      fill: "url(#paint90_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M59.7588 193.619C60.9373 194.502 61.7774 195.762 62.1388 197.189C62.2879 197.87 62.1712 198.582 61.8124 199.18C61.4537 199.778 60.8802 200.216 60.209 200.405C59.6894 200.427 59.1694 200.373 58.6653 200.245C57.1858 199.762 56.5426 197.028 56.7355 195.742C56.7799 195.249 56.9554 194.778 57.2439 194.376C57.5324 193.975 57.9233 193.658 58.3758 193.458C58.6013 193.367 58.8462 193.333 59.0879 193.361C59.3296 193.39 59.5604 193.478 59.7588 193.619Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M65.0333 200.76C65.3257 200.911 65.5776 201.13 65.7679 201.398C65.9582 201.667 66.0812 201.977 66.1268 202.303C66.1931 202.869 66.0543 203.44 65.7356 203.912C65.417 204.384 64.9395 204.726 64.39 204.876C63.2 205.134 62.396 203.3 62.396 202.303C62.4028 201.851 62.5441 201.41 62.8018 201.038C63.0595 200.666 63.422 200.379 63.8433 200.213C63.8433 200.213 64.1327 200.213 64.2292 200.213L64.583 200.374C64.692 200.544 64.8486 200.678 65.0333 200.76Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M53.9052 223.337L56.2852 223.98C58.7383 224.728 61.1263 225.674 63.4251 226.811C67.6395 228.474 71.0806 231.651 73.0738 235.72C74.3602 240.287 67.6705 241.734 58.3435 239.643C49.0165 237.553 40.3328 231.571 39.2393 227.293C38.596 225.363 39.8825 223.82 42.0696 222.983C43.4532 222.501 44.9151 222.283 46.3793 222.34C48.4055 222.533 51.0749 222.919 53.9052 223.337Z",
      fill: "url(#paint91_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.8",
      children: /* @__PURE__ */ jsx("g", {
        opacity: "0.8",
        children: /* @__PURE__ */ jsx("path", {
          opacity: "0.8",
          d: "M18.0446 171.105C28.2078 167.632 34.801 180.432 32.8713 193.973C31.5848 204.232 24.8308 211.565 19.4276 208.542C9.20002 202.592 7.14166 194.519 7.62409 188.666C8.10652 182.812 10.1006 173.743 18.0446 171.105Z",
          fill: "#5DA7F3"
        })
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.8",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.8",
        d: "M13.1238 173.486C14.517 172.089 16.2824 171.122 18.2097 170.7C20.137 170.278 22.145 170.419 23.9945 171.106C30.4269 173.647 33.9648 183.263 32.6783 193.426C31.5848 201.66 25.7313 207.513 19.4275 204.972C10.5508 200.663 7.9135 193.973 8.1708 185.386C8.08587 183.162 8.48476 180.946 9.33991 178.892C10.1951 176.837 11.4861 174.993 13.1238 173.486Z",
        fill: "white"
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M21.3573 171.267C26.1173 173.647 29.5908 178.407 29.3978 188.023C29.3978 194.456 23.5443 201.306 17.6908 198.926C14.2709 197.232 11.5648 194.377 10.0564 190.872C8.54806 187.366 8.33572 183.438 9.45736 179.79C10.9368 173.486 17.4014 169.337 21.3573 171.267Z",
      fill: "url(#paint92_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M22.451 174.386C22.7287 174.415 22.9944 174.515 23.2229 174.676C23.9715 175.231 24.4872 176.045 24.6701 176.959C24.6701 177.409 24.4129 179.146 23.6731 179.146C23.4802 179.146 23.0299 179.339 22.8369 179.146C22.6439 178.953 21.5826 178.053 21.1002 176.766C20.6177 175.48 20.8429 174.579 21.8399 174.29C22.0487 174.254 22.2634 174.288 22.451 174.386Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M25.8281 181.816C26.214 182.62 26.214 183.713 25.2813 183.713C25.0883 183.713 24.4772 183.906 23.5445 182.62C23.4563 182.402 23.4295 182.164 23.4671 181.931C23.5047 181.699 23.6052 181.482 23.7577 181.303C23.9102 181.124 24.1089 180.99 24.3322 180.916C24.5554 180.842 24.7947 180.83 25.024 180.883C25.2138 180.976 25.3828 181.107 25.5209 181.267C25.659 181.428 25.7635 181.614 25.8281 181.816Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M14.5712 200.212C15.2144 200.663 15.8577 200.823 16.5009 201.306C18.3848 202.481 20.1322 203.862 21.7111 205.423C25.3776 208.896 28.1436 212.563 27.7576 215.071C27.7576 219.188 21.9041 219.188 14.3139 214.878C6.72364 210.568 0.87015 203.943 0.87015 199.826C0.854279 199.408 0.92819 198.992 1.0869 198.605C1.24562 198.218 1.48545 197.869 1.79023 197.583C2.09501 197.296 2.45766 197.078 2.85375 196.944C3.24983 196.809 3.67014 196.761 4.08635 196.803C5.33563 196.814 6.57453 197.031 7.75283 197.446C10.1936 197.883 12.516 198.825 14.5712 200.212Z",
      fill: "url(#paint93_radial_10025_65880)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M52.8119 255.917C48.2579 255.945 43.7188 255.394 39.3038 254.277L39.529 253.505C39.7219 253.505 57.8613 258.619 71.9805 250.482C75.8487 248.11 79.1834 244.962 81.774 241.236C84.3647 237.511 86.1551 233.289 87.0323 228.837L87.8042 229.062C86.9029 233.618 85.0654 237.937 82.408 241.746C79.7506 245.555 76.3312 248.771 72.3664 251.189C66.3661 254.428 59.6291 256.057 52.8119 255.917Z",
      fill: "url(#paint94_linear_10025_65880)",
      fillOpacity: "0.4"
    }), /* @__PURE__ */ jsx("path", {
      d: "M60.0484 258.748C57.4148 258.769 54.7827 258.618 52.1687 258.297V257.493C59.8247 258.401 67.5794 257.999 75.1002 256.303C90.9883 252.508 100.83 243.085 104.593 228.258L105.365 228.451C100.669 247.33 86.4213 254.438 75.261 257.075C70.2722 258.221 65.167 258.782 60.0484 258.748Z",
      fill: "url(#paint95_linear_10025_65880)",
      fillOpacity: "0.4"
    }), /* @__PURE__ */ jsx("path", {
      d: "M67.2526 260.388V259.584C68.6999 259.584 108.388 259.166 117.104 224.206L117.876 224.399C109.031 259.97 68.7642 260.388 67.2526 260.388Z",
      fill: "url(#paint96_linear_10025_65880)",
      fillOpacity: "0.4"
    }), /* @__PURE__ */ jsx("path", {
      d: "M68.2496 254.823C51.5964 254.525 35.2259 250.468 20.3604 242.956L20.7141 242.216C53.5837 257.943 84.3306 257.975 112.344 242.216L112.762 242.923C99.2137 250.698 83.8701 254.8 68.2496 254.823Z",
      fill: "url(#paint97_linear_10025_65880)",
      fillOpacity: "0.4"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_10025_65880",
        x1: "257.266",
        y1: "150.522",
        x2: "191.495",
        y2: "228.869",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.02",
          stopColor: "#031D36",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.94",
          stopColor: "#031D36"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_10025_65880",
        x1: "190.047",
        y1: "89.7037",
        x2: "201.24",
        y2: "80.6662",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#73CFD7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.14",
          stopColor: "#50B7C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.3",
          stopColor: "#3280B0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.44",
          stopColor: "#164E9D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.52",
          stopColor: "#083596"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3A9076"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_10025_65880",
        x1: "194.003",
        y1: "99.288",
        x2: "165.926",
        y2: "95.1713",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#041836"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3D93C1"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint3_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(193.373 169.729) rotate(-0.861679) scale(84.1982 84.2879)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.02",
          stopColor: "#A0ECE7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.33",
          stopColor: "#93F0EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#59CEE7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#30A6C6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.91",
          stopColor: "#239BC5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#896DAE"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_10025_65880",
        x1: "180.141",
        y1: "202.131",
        x2: "190.198",
        y2: "176.156",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#49BFDA",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5",
          stopColor: "#2E7B9A",
          stopOpacity: "0.52"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#153B5E"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_10025_65880",
        x1: "220.923",
        y1: "179.809",
        x2: "204.059",
        y2: "159.069",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint6_linear_10025_65880",
        x1: "1069.72",
        y1: "1159.97",
        x2: "991.166",
        y2: "1070.35",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint7_linear_10025_65880",
        x1: "5480",
        y1: "4602.27",
        x2: "5144.5",
        y2: "4129.23",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint8_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(169.837 122.678) rotate(85.2233) scale(77.4618 94.7552)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint9_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(169.837 122.678) rotate(85.2233) scale(77.4618 94.7552)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint10_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(169.837 122.678) rotate(85.2233) scale(77.4618 94.7552)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint11_linear_10025_65880",
        x1: "4836.2",
        y1: "4916.69",
        x2: "4604.64",
        y2: "4505.38",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint12_linear_10025_65880",
        x1: "710.712",
        y1: "676.294",
        x2: "686.998",
        y2: "633.801",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint13_linear_10025_65880",
        x1: "560.602",
        y1: "602.129",
        x2: "538.632",
        y2: "562.976",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint14_linear_10025_65880",
        x1: "133.86",
        y1: "128.71",
        x2: "206.605",
        y2: "206.216",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#43E8E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.45",
          stopColor: "#3A8FA2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.84",
          stopColor: "#387E97"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#385397"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint15_linear_10025_65880",
        x1: "136.047",
        y1: "155.057",
        x2: "203.587",
        y2: "152.677",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint16_linear_10025_65880",
        x1: "140.485",
        y1: "137.549",
        x2: "208.281",
        y2: "206.309",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#37A0DA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#43E8E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint17_linear_10025_65880",
        x1: "3142.41",
        y1: "1266.16",
        x2: "4418.26",
        y2: "1181.6",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint18_linear_10025_65880",
        x1: "852.851",
        y1: "1239.27",
        x2: "890.976",
        y2: "1251.7",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#43E8E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.45",
          stopColor: "#3A8FA2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.84",
          stopColor: "#387E97"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#385397"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint19_linear_10025_65880",
        x1: "784.782",
        y1: "1295.68",
        x2: "721.554",
        y2: "1237.57",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint20_linear_10025_65880",
        x1: "535.16",
        y1: "608.894",
        x2: "538.321",
        y2: "624.795",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint21_linear_10025_65880",
        x1: "418.186",
        y1: "1336.35",
        x2: "456.892",
        y2: "1344.06",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint22_linear_10025_65880",
        x1: "2268.89",
        y1: "2232.77",
        x2: "2490.99",
        y2: "2232.77",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#041836"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3D93C1"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint23_linear_10025_65880",
        x1: "2315.38",
        y1: "2285.8",
        x2: "2547.2",
        y2: "2285.8",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#041836"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3D93C1"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint24_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(230.696 164.524) scale(0.925764 18.4823)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#D3FFF8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#D2FDF7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#C8E9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#C2DDE9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#C0D8E7"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint25_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(173.823 188.049) scale(8.72717 8.73585)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.47",
          stopColor: "#041836"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3A9076"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint26_linear_10025_65880",
        x1: "258.006",
        y1: "129.07",
        x2: "246.042",
        y2: "114.115",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#95F1EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.22",
          stopColor: "#50B7C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.38",
          stopColor: "#3280B0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#164E9D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#083596"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3A9076"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint27_linear_10025_65880",
        x1: "4569.72",
        y1: "-160704",
        x2: "5199.67",
        y2: "-160736",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#041836"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3D93C1"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint28_linear_10025_65880",
        x1: "151.517",
        y1: "165.863",
        x2: "151.517",
        y2: "159.431",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint29_linear_10025_65880",
        x1: "347.238",
        y1: "380.77",
        x2: "347.238",
        y2: "367.905",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint30_linear_10025_65880",
        x1: "368.887",
        y1: "417.02",
        x2: "368.887",
        y2: "404.284",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint31_linear_10025_65880",
        x1: "439.677",
        y1: "444.511",
        x2: "439.677",
        y2: "431.775",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint32_linear_10025_65880",
        x1: "400.45",
        y1: "414.135",
        x2: "400.45",
        y2: "401.399",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint33_linear_10025_65880",
        x1: "407.921",
        y1: "448.561",
        x2: "407.921",
        y2: "435.824",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint34_linear_10025_65880",
        x1: "443.536",
        y1: "466.575",
        x2: "443.536",
        y2: "453.839",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint35_linear_10025_65880",
        x1: "408.328",
        y1: "436.378",
        x2: "408.328",
        y2: "423.513",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint36_linear_10025_65880",
        x1: "343.611",
        y1: "395.227",
        x2: "343.611",
        y2: "382.235",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint37_linear_10025_65880",
        x1: "359.147",
        y1: "390.29",
        x2: "359.147",
        y2: "377.489",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint38_linear_10025_65880",
        x1: "380.1",
        y1: "400.003",
        x2: "380.1",
        y2: "387.138",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint39_linear_10025_65880",
        x1: "385.92",
        y1: "407.529",
        x2: "385.92",
        y2: "394.664",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint40_linear_10025_65880",
        x1: "439.206",
        y1: "459.043",
        x2: "439.206",
        y2: "446.307",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint41_linear_10025_65880",
        x1: "390.053",
        y1: "432.502",
        x2: "390.053",
        y2: "419.766",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#B2E0F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#96D6F7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint42_linear_10025_65880",
        x1: "264.421",
        y1: "333.903",
        x2: "155.083",
        y2: "333.903",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#051937"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#051937",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint43_linear_10025_65880",
        x1: "230.314",
        y1: "221.247",
        x2: "219.862",
        y2: "212.82",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#9EAAEA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.14",
          stopColor: "#8192DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.3",
          stopColor: "#5066C9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.44",
          stopColor: "#233EB4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.52",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint44_linear_10025_65880",
        x1: "228.063",
        y1: "218.867",
        x2: "219.347",
        y2: "213.206",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FCA4F3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.22",
          stopColor: "#DF81DB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.38",
          stopColor: "#C750C9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#B423A5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#AC0D9C"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint45_linear_10025_65880",
        x1: "226.358",
        y1: "228.965",
        x2: "251.573",
        y2: "225.267",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6726A5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#DA4DEF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint46_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(212.977 282.42) rotate(-119.578) scale(68.4152 65.6231)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.02",
          stopColor: "#F0B2F5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.33",
          stopColor: "#FCA2F3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#F966E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#E345D3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.91",
          stopColor: "#E233D0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint47_linear_10025_65880",
        x1: "3926.62",
        y1: "-124395",
        x2: "4118.52",
        y2: "-124115",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FCA4F3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.22",
          stopColor: "#DF81DB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.38",
          stopColor: "#C750C9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#B423A5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#AC0D9C"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint48_linear_10025_65880",
        x1: "3646.91",
        y1: "-121036",
        x2: "2974.92",
        y2: "-121085",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6726A5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#DA4DEF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint49_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(246.747 316.189) rotate(-135) scale(11.371 11.4044)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.47",
          stopColor: "#051140"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint50_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(225.561 274.204) rotate(53.1301) scale(16.75 13.4324)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.02",
          stopColor: "#0D1276"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.47",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint51_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(256.452 282.317) rotate(53.148) scale(16.8068 13.4897)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.0221768",
          stopColor: "#0D1276"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.471",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint52_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(260.743 284.865) rotate(142.406) scale(14.9681 6.76012)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FF6CD0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.21",
          stopColor: "#FC6ED1",
          stopOpacity: "0.78"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.37",
          stopColor: "#F374D3",
          stopOpacity: "0.62"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#E37DD7",
          stopOpacity: "0.48"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#CC8BDC",
          stopOpacity: "0.35"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#AF9DE3",
          stopOpacity: "0.22"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.87",
          stopColor: "#8BB3EB",
          stopOpacity: "0.11"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#64CBF4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint53_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(424319 -133643) rotate(180) scale(118.94 329.1)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.02",
          stopColor: "#F0B2F5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.33",
          stopColor: "#FCA2F3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#F966E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#E345D3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.91",
          stopColor: "#E233D0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint54_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(257627 -353545) rotate(124.579) scale(134.132 142.298)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.02",
          stopColor: "#0D1276"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.47",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint55_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(217.058 306.901) rotate(45.2967) scale(18.3612 15.3533)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.0221768",
          stopColor: "#0D1276"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.471",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint56_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(636423 -210574) rotate(160.477) scale(181.315 42.3436)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FF6CD0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.21",
          stopColor: "#FC6ED1",
          stopOpacity: "0.78"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.37",
          stopColor: "#F374D3",
          stopOpacity: "0.62"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#E37DD7",
          stopOpacity: "0.48"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#CC8BDC",
          stopOpacity: "0.35"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#AF9DE3",
          stopOpacity: "0.22"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.87",
          stopColor: "#8BB3EB",
          stopOpacity: "0.11"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#64CBF4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint57_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(827899 -38257.4) rotate(180) scale(225.433 129.735)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.02",
          stopColor: "#F0B2F5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.33",
          stopColor: "#FCA2F3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#F966E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#E345D3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.91",
          stopColor: "#E233D0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint58_linear_10025_65880",
        x1: "292.387",
        y1: "208.446",
        x2: "272.382",
        y2: "236.17",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C74966"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CC305A"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint59_linear_10025_65880",
        x1: "282.899",
        y1: "200.663",
        x2: "282.899",
        y2: "265.244",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FF7999"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#F42058"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint60_linear_10025_65880",
        x1: "282.835",
        y1: "215.811",
        x2: "282.835",
        y2: "240.447",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#EF7C97"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E53866"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint61_linear_10025_65880",
        x1: "7.65637",
        y1: "298.403",
        x2: "116.01",
        y2: "298.403",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5761D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.07",
          stopColor: "#5472D8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.28",
          stopColor: "#4E9CDB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#49BDDD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.67",
          stopColor: "#45D5DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#43E3E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint62_linear_10025_65880",
        x1: "674.967",
        y1: "4869.55",
        x2: "4324.52",
        y2: "4869.55",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5761D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.07",
          stopColor: "#5472D8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.28",
          stopColor: "#4E9CDB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#49BDDD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.67",
          stopColor: "#45D5DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#43E3E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint63_linear_10025_65880",
        x1: "674.967",
        y1: "4713.38",
        x2: "4324.52",
        y2: "4713.38",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5761D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.07",
          stopColor: "#5472D8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.28",
          stopColor: "#4E9CDB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#49BDDD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.67",
          stopColor: "#45D5DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#43E3E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint64_linear_10025_65880",
        x1: "674.985",
        y1: "4532.42",
        x2: "4324.66",
        y2: "4532.42",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5761D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.07",
          stopColor: "#5472D8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.28",
          stopColor: "#4E9CDB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#49BDDD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.67",
          stopColor: "#45D5DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#43E3E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint65_linear_10025_65880",
        x1: "675.119",
        y1: "6600.5",
        x2: "4325.58",
        y2: "6600.5",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint66_linear_10025_65880",
        x1: "7.65623",
        y1: "273.06",
        x2: "116.01",
        y2: "273.06",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint67_linear_10025_65880",
        x1: "61.8493",
        y1: "297.245",
        x2: "61.8493",
        y2: "263.571",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint68_linear_10025_65880",
        x1: "2067.72",
        y1: "4055.53",
        x2: "2070.03",
        y2: "3408.93",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint69_linear_10025_65880",
        x1: "2073.08",
        y1: "3847.45",
        x2: "2073.08",
        y2: "3425.99",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint70_linear_10025_65880",
        x1: "806.948",
        y1: "-120342",
        x2: "982.079",
        y2: "-120235",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#9EAAEA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.14",
          stopColor: "#8192DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.3",
          stopColor: "#5066C9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.44",
          stopColor: "#233EB4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.52",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint71_linear_10025_65880",
        x1: "49.9495",
        y1: "132.801",
        x2: "22.5796",
        y2: "128.813",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2525C6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#4D91EE"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint72_linear_10025_65880",
        x1: "49.0785",
        y1: "126.784",
        x2: "19.8519",
        y2: "128.637",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2525C6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#4D91EE"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint73_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(65.0315 189.149) rotate(-3.9005) scale(70.9208 70.9952)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.02",
          stopColor: "#B2E5F5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.33",
          stopColor: "#A2D5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#66AFF9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#4593E3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.91",
          stopColor: "#3389E2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BBEEF8"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint74_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(26.0877 159.107) scale(17.774)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#3781E8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3D8EE3",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint75_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(49.0264 162.127) scale(14.4904 14.4078)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF8FE7"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint76_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(10.8698 153.059) scale(12.4814)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFB1E2"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint77_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(46.7023 153.638) scale(12.5342 12.5406)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFB1E2"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint78_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(25.2327 139.852) scale(10.6135)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFBAE0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint79_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(44.8157 144.147) scale(10.6784 10.6838)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFBAE0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint80_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(37.4704 129.515) scale(8.7455)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFCCDE"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint81_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(43.8437 137.653) scale(8.79994 8.80422)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFCCDE"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint82_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(46.0717 119.173) scale(6.87753)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFCCD5"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint83_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(42.1847 131.188) scale(6.92443 6.92778)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFCCD5"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint84_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(50.8632 107.57) scale(5.00956)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFCCC8"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint85_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(41.338 125.755) scale(5.04204 5.0446)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFCCC8"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint86_linear_10025_65880",
        x1: "109.192",
        y1: "161.843",
        x2: "97.5493",
        y2: "147.274",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A4D7FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.22",
          stopColor: "#8192DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.38",
          stopColor: "#5066C9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#233EB4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint87_linear_10025_65880",
        x1: "97.925",
        y1: "160.232",
        x2: "132.267",
        y2: "165.896",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2525C6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#4D91EE"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint88_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-92405.3 26822.7) scale(47.1942 34.7247)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.47",
          stopColor: "#051140"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint89_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(33.3151 222.907) rotate(-135.124) scale(11.9824 12.0175)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.47",
          stopColor: "#051140"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint90_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(55.9774 205.987) rotate(48.916) scale(19.1379 15.8543)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.0221768",
          stopColor: "#0D1276"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.471",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint91_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-423699 -139751) rotate(21.8562) scale(175.218 50.1608)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FF6CD0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.21",
          stopColor: "#FC6ED1",
          stopOpacity: "0.78"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.37",
          stopColor: "#F374D3",
          stopOpacity: "0.62"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#E37DD7",
          stopOpacity: "0.48"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#CC8BDC",
          stopOpacity: "0.35"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#AF9DE3",
          stopOpacity: "0.22"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.87",
          stopColor: "#8BB3EB",
          stopOpacity: "0.11"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#64CBF4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint92_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(18.8523 185.017) rotate(53.1763) scale(16.4563 13.2046)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.0221768",
          stopColor: "#0D1276"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.471",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint93_radial_10025_65880",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-239314 -171408) rotate(37.6024) scale(122.321 43.809)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FF6CD0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.21",
          stopColor: "#FC6ED1",
          stopOpacity: "0.78"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.37",
          stopColor: "#F374D3",
          stopOpacity: "0.62"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#E37DD7",
          stopOpacity: "0.48"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#CC8BDC",
          stopOpacity: "0.35"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#AF9DE3",
          stopOpacity: "0.22"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.87",
          stopColor: "#8BB3EB",
          stopOpacity: "0.11"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#64CBF4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint94_linear_10025_65880",
        x1: "63.554",
        y1: "228.837",
        x2: "63.554",
        y2: "255.926",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#E6EDFF",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BCEEF9"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint95_linear_10025_65880",
        x1: "78.7667",
        y1: "228.258",
        x2: "78.7667",
        y2: "258.75",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#E6EDFF",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BCEEF9"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint96_linear_10025_65880",
        x1: "92.5641",
        y1: "224.206",
        x2: "92.5641",
        y2: "260.388",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#E6EDFF",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BCEEF9"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint97_linear_10025_65880",
        x1: "66.5611",
        y1: "242.216",
        x2: "66.5611",
        y2: "254.823",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#E6EDFF",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BCEEF9"
        })]
      })]
    })]
  });
};
const chest = (width = "298", height = "398") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 298 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M293.983 225.39C297.294 198.224 292.476 170.687 280.138 146.26C267.799 121.832 248.495 101.612 224.665 88.1553C200.836 74.6986 173.551 68.6099 146.261 70.659C118.972 72.7082 92.9022 82.8031 71.3494 99.6674C49.7966 116.532 33.7282 139.408 25.1759 165.404C16.6237 191.4 15.9716 219.348 23.3022 245.715C30.6329 272.081 45.6169 295.682 66.3598 313.533C87.1028 331.384 112.673 342.684 139.838 346.003C157.879 348.208 176.178 346.837 193.689 341.968C211.201 337.1 227.581 328.829 241.896 317.628C256.21 306.428 268.178 292.517 277.115 276.691C286.052 260.864 291.784 243.432 293.983 225.39Z",
      fill: "#1EC5F9"
    }), /* @__PURE__ */ jsx("path", {
      d: "M292.986 300.468C293.436 298.73 292.986 287.145 292.986 279.807C292.986 277.008 292.986 274.047 292.986 274.047C292.986 274.047 216.846 326.888 186.146 329.72C150.264 333.163 113.417 331.554 78.6298 321.868C51.0509 314.691 23.9226 297.443 24.4696 279.357L24.9202 301.69C25.1776 316.172 39.5302 330.363 67.7206 340.533C119.21 358.007 180.707 357.524 233.13 343.397C254.562 336.928 287.837 324.796 292.986 300.468Z",
      fill: "url(#paint0_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M159.806 331.305C233.958 329.829 293.583 304.188 292.983 274.033C292.383 243.878 231.785 220.629 157.633 222.105C83.4813 223.58 23.8558 249.222 24.4559 279.376C25.0559 309.531 85.6543 332.78 159.806 331.305Z",
      fill: "url(#paint1_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M41.9758 176.636C45.8338 207.688 46.5777 239.049 44.1963 270.25L169.701 319.036L281.047 275.302C278.461 243.74 279.227 211.994 283.332 180.594L128.864 147.416L41.9758 176.636Z",
      fill: "url(#paint2_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M41.8472 176.636L169.862 218.792L283.332 180.594L128.703 147.416L41.8472 176.636Z",
      fill: "url(#paint3_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M54.2687 176.604L128.928 151.503L268.528 181.431L169.83 214.641L54.2687 176.604Z",
      fill: "url(#paint4_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M169.637 319.036L169.862 216.991L41.9758 176.636C44.5004 207.773 45.2418 239.028 44.1963 270.25L169.701 319.036H169.637Z",
      fill: "url(#paint5_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M169.862 216.991L169.637 319.036L281.047 275.302C280.135 243.715 280.898 212.101 283.332 180.594L169.862 216.991Z",
      fill: "url(#paint6_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M257.587 305.52L169.766 319.036L281.047 275.303L280.628 251.811C293.082 262.977 295.914 271.956 287.451 290.428L257.587 305.52Z",
      fill: "url(#paint7_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M66.1115 206.95L141.929 232.18L142.38 284.924L67.3665 257.152L66.1115 206.95Z",
      fill: "#B3B3B3"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M197.473 232.02L258.198 211.649L257.329 262.302L197.151 284.893L197.473 232.02Z",
      fill: "#B3B3B3"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M70.1018 256.219L142.348 282.993L141.929 232.18L68.9111 207.884L70.1018 256.219Z",
      fill: "url(#paint8_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M197.473 232.019L197.151 282.768L254.304 261.303L255.141 212.646L197.473 232.019Z",
      fill: "url(#paint9_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M66.1115 206.95L67.3665 257.152L70.1019 256.219L68.9112 207.883L66.1115 206.95Z",
      fill: "url(#paint10_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M142.348 282.993L70.1019 256.219L67.3665 257.152L142.38 284.924L142.348 282.993Z",
      fill: "url(#paint11_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M254.304 261.304L197.151 282.768V284.892L257.329 262.301L254.304 261.304Z",
      fill: "url(#paint12_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M255.141 212.647L254.305 261.304L257.33 262.302L258.198 211.649L255.141 212.647Z",
      fill: "url(#paint13_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.3",
      children: /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M69.1042 215.639C75.9909 210.233 135.3 231.15 141.994 239.903V232.18L68.9111 207.884L69.1042 215.639Z",
        fill: "#041836"
      })
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M41.9758 176.636L169.862 216.991L281.401 181.238C276.96 183.684 253.918 191.343 228.013 199.774C207.932 206.21 184.504 212.904 169.862 218.793C151.616 211.552 118.373 202.348 92.3065 194.046C65.4678 185.486 43.4883 178.277 41.9758 176.636Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M119.403 257.635C176.187 257.635 222.22 211.602 222.22 154.818C222.22 98.033 176.187 52 119.403 52C62.6182 52 16.5852 98.033 16.5852 154.818C16.5852 211.602 62.6182 257.635 119.403 257.635Z",
      fill: "url(#paint14_radial_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M107.303 202.799C132.896 202.799 153.643 182.052 153.643 156.459C153.643 130.866 132.896 110.119 107.303 110.119C81.7099 110.119 60.9626 130.866 60.9626 156.459C60.9626 182.052 81.7099 202.799 107.303 202.799Z",
      fill: "url(#paint15_radial_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M74.0599 202.799C99.6529 202.799 120.4 182.052 120.4 156.459C120.4 130.866 99.6529 110.119 74.0599 110.119C48.4669 110.119 27.7196 130.866 27.7196 156.459C27.7196 182.052 48.4669 202.799 74.0599 202.799Z",
      fill: "url(#paint16_radial_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M66.5942 172.484L182.091 157.424C181.737 139.531 180.418 121.349 170.409 104.1C157.827 82.5393 137.649 73.3678 117.408 80.1901C93.8835 88.0744 76.7312 114.27 70.7456 138.115C68.3328 149.37 66.9434 160.819 66.5942 172.324V172.484Z",
      fill: "url(#paint17_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M185.245 180.659L220.643 105.452L143.023 83.2476H142.669C135.093 81.1426 127.054 81.4008 119.628 83.9877C96.6832 91.518 80.0779 117.005 74.1566 140.368C73.9635 141.044 73.8026 141.752 73.6417 142.46L138.518 164.697L185.148 180.787L185.245 180.659Z",
      fill: "url(#paint18_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M169.862 207.208L283.332 180.015C282.978 162.476 281.69 144.809 271.843 129.201C259.582 109.893 239.662 103.457 219.775 112.886C196.669 123.827 179.838 152.05 173.917 176.282C171.563 186.435 170.194 196.791 169.83 207.208H169.862Z",
      fill: "url(#paint19_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M146.531 167.4L70.0696 141.205C70.2627 140.24 70.5202 139.242 70.7454 138.277C76.7311 114.27 93.8834 88.0424 117.408 80.3512C124.712 77.8232 132.592 77.4655 140.095 79.3214L116.7 72.4669L113.707 71.598C106.433 69.8729 98.8181 70.2638 91.7595 72.7243C68.6537 80.4477 51.8231 106.192 45.9341 129.781C43.6039 140.837 42.2791 152.082 41.9758 163.378L169.862 207.208C170.216 196.793 171.574 186.436 173.917 176.282C179.806 151.889 196.637 123.827 219.742 112.886C228.32 108.557 238.179 107.494 247.482 109.893L220.579 102.202L217.972 101.43C209.089 99.4381 199.791 100.575 191.649 104.648C168.929 115.299 152.452 142.911 146.595 166.885C146.61 167.046 146.61 167.207 146.595 167.368L146.531 167.4Z",
      fill: "url(#paint20_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M190.007 179.757L262.285 161.704C257.33 145.614 249.928 136.313 241.625 132.42C220.643 127.882 196.057 152.339 190.007 179.757Z",
      fill: "url(#paint21_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M241.497 132.42C249.799 136.314 257.201 145.485 262.157 161.704L267.273 163.442C261.32 143.973 251.859 134.672 241.529 132.42H241.497Z",
      fill: "url(#paint22_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M262.286 161.704L190.008 179.758C189.782 180.82 189.557 181.882 189.396 182.976L267.563 163.507L262.286 161.704Z",
      fill: "url(#paint23_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.65",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M217.972 101.43C210.537 99.7226 202.761 100.272 195.639 103.006C205.409 104.192 214.92 106.964 223.797 111.213C231.368 108.292 239.666 107.83 247.514 109.893L217.972 101.43ZM117.408 80.1903C123.89 77.9564 130.834 77.4137 137.585 78.6134C138.422 78.7743 139.258 78.9352 140.095 79.1605L113.707 71.598C106.433 69.8729 98.8181 70.2638 91.7595 72.7243C100.559 74.3901 109.179 76.89 117.504 80.1903H117.408Z",
      fill: "url(#paint24_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M78.3725 117.874C82.6624 109.238 88.3003 101.341 95.0743 94.4788C90.8587 94.7362 71.7755 90.424 69.8124 86.7554C63.1593 93.5016 57.6292 101.27 53.4324 109.765C58.9675 109.765 75.251 115.171 78.3725 117.874ZM173.048 118.26C166.029 125.566 160.149 133.887 155.606 142.943C163.104 142.557 180.225 149.379 183.089 151.889C187.719 142.66 193.707 134.178 200.852 126.724C195.864 126.917 175.591 120.803 173.048 118.26Z",
      fill: "url(#paint25_radial_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M155.67 86.8517L142.798 83.1187C136.012 81.2046 128.828 81.2046 122.042 83.1187C146.176 88.5857 169.949 95.5393 193.225 103.94C193.998 103.586 194.77 103.296 195.542 103.006C198.384 101.965 201.329 101.231 204.328 100.818L155.67 86.8517Z",
      fill: "url(#paint26_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M123.747 191.6L169.862 207.208L217.232 195.944L171.214 204.44C172.244 176.604 175.397 166.209 188.785 141.977C174.818 162.798 170.087 176.926 168.865 204.569L123.747 191.6Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M54.2689 176.604L5.67596 133.096L0.140869 104.616L200.724 126.724C180.838 147.847 169.447 175.567 168.736 204.569L243.363 189.734L169.83 214.642L54.2689 176.604Z",
      fill: "url(#paint27_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M168.736 317.684C168.414 283.894 168.124 250.555 168.253 216.991L169.379 218.503L41.9758 176.636C45.0227 207.765 46.3012 239.041 45.8053 270.314L44.7756 268.769C86.0957 284.828 127.223 301.143 168.736 317.684ZM170.538 320.355C128.349 304.265 85.7417 288.174 43.4883 271.762C43.1728 271.641 42.9035 271.423 42.7186 271.14C42.5338 270.857 42.4428 270.523 42.4585 270.185C44.0675 239.018 43.9063 207.785 41.9758 176.636L170.345 215.446C170.671 215.543 170.956 215.743 171.159 216.015C171.362 216.288 171.472 216.619 171.471 216.958C171.439 251.456 171.021 286.115 170.699 320.355H170.538Z",
      fill: "url(#paint28_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M171.15 217.924V319.036L168.961 317.523C168.961 317.523 282.045 274.111 280.661 275.302C279.893 243.708 280.785 212.095 283.332 180.594C245.648 193.241 208.351 205.759 171.15 217.924ZM168.543 216.025C207.16 203.957 245.358 192.211 283.332 180.626C281.042 212.13 280.409 243.732 281.433 275.302C281.723 276.139 170.377 320.098 170.216 320.548C169.972 320.643 169.708 320.676 169.447 320.645C169.187 320.614 168.938 320.52 168.722 320.371C168.507 320.222 168.331 320.022 168.21 319.789C168.089 319.557 168.026 319.298 168.028 319.036L168.543 216.057V216.025Z",
      fill: "#AAF4F1"
    }), /* @__PURE__ */ jsx("path", {
      d: "M204.167 101.076L164.552 89.5872L144.729 83.8912C138.197 81.7048 131.203 81.2829 124.455 82.6683C98.7106 88.654 82.2018 113.53 75.0255 137.376L74.3497 139.886C74.0923 140.69 73.867 141.527 75.3152 142.718C75.2695 142.925 75.1832 143.122 75.0613 143.296C74.9393 143.47 74.7841 143.618 74.6046 143.731C74.4251 143.845 74.2248 143.922 74.0154 143.958C73.8059 143.994 73.5914 143.988 73.3843 143.941C73.178 143.899 72.9823 143.816 72.8085 143.697C72.6347 143.578 72.4865 143.426 72.3725 143.249C72.2585 143.072 72.1812 142.874 72.1449 142.667C72.1087 142.459 72.1143 142.247 72.1614 142.042C73.9957 141.527 74.1566 140.722 74.3497 139.886L75.0255 137.376C83.1351 107.898 110.682 73.0141 144.826 83.505C157.505 87.1093 191.262 96.6026 204.36 100.271C204.778 100.271 204.65 101.108 204.167 100.979V101.076Z",
      fill: "#AAF4F1"
    }), /* @__PURE__ */ jsx("path", {
      d: "M170.892 205.985C207.996 197.103 245.326 188.543 283.332 180.015C283.283 170.627 282.356 161.265 280.564 152.05C278.76 142.871 275.019 134.181 269.59 126.563C264.273 118.861 256.503 113.189 247.547 110.472C238.541 108.15 228.999 109.155 220.676 113.304C212.356 117.407 204.956 123.154 198.921 130.199C192.802 137.233 187.64 145.045 183.571 153.434C179.506 161.775 176.48 170.583 174.561 179.661C173.602 184.19 172.882 188.766 172.404 193.37C172.168 195.687 171.975 198.004 171.825 200.321L171.6 203.829V204.698C171.6 204.987 171.6 205.341 171.6 205.341C171.6 205.341 171.214 205.631 170.892 205.985ZM168.832 208.463C168.527 207.539 168.375 206.572 168.382 205.599C168.358 205.224 168.358 204.847 168.382 204.472V203.603L168.639 200.096C168.832 197.747 169.058 195.397 169.347 193.048C169.898 188.344 170.693 183.671 171.729 179.05C173.852 169.798 177.094 160.84 181.383 152.372C185.688 143.896 191.099 136.029 197.473 128.976C203.742 121.816 211.408 116.012 220 111.92C228.706 107.752 238.623 106.86 247.933 109.41C257.117 112.265 265.059 118.154 270.459 126.112C275.814 133.842 279.477 142.615 281.208 151.857C282.843 161.098 283.629 170.47 283.557 179.854C245.68 189.605 207.353 199.291 168.832 208.463Z",
      fill: "url(#paint29_linear_10025_65881)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M147.336 168.816C121.591 160.288 95.3958 151.632 69.5547 142.75C69.1831 142.63 68.8703 142.375 68.6793 142.035C68.4883 141.695 68.4331 141.295 68.5249 140.915C70.5377 132.39 73.6647 124.167 77.8251 116.458C81.9112 108.744 87.0684 101.648 93.1432 95.3795C99.1935 89.0661 106.523 84.1179 114.64 80.866C122.733 77.5748 131.673 76.9878 140.127 79.1926L120.819 73.8828C117.601 73.0783 114.382 71.9519 111.164 71.437C107.911 70.8959 104.599 70.7877 101.317 71.1152C88.0586 72.4668 76.4092 80.3833 67.7526 90.1019C59.0683 100.063 52.5774 111.74 48.7015 124.374C44.7111 136.893 44.0997 150.119 43.3917 163.474L42.2976 161.865L170.345 205.695L168.221 207.111C168.8 195.316 170.711 183.625 173.917 172.259C177.303 160.93 182.404 150.186 189.042 140.4C195.497 130.506 203.988 122.102 213.95 115.75C218.816 112.478 224.316 110.266 230.093 109.257C235.87 108.248 241.794 108.465 247.482 109.893L230.973 105.162L222.703 102.813C219.985 101.911 217.197 101.233 214.368 100.786C208.68 100.094 202.909 100.676 197.473 102.491C192.063 104.348 186.972 107.029 182.38 110.44C173.3 117.417 165.743 126.178 160.176 136.185C157.299 141.084 154.845 146.22 152.838 151.535C151.809 154.174 150.908 156.877 150.103 159.58C149.717 160.964 149.299 162.283 149.009 163.667L148.526 165.727L148.301 166.789V167.304C148.129 167.889 147.794 168.414 147.336 168.816ZM145.759 165.984C145.616 166.007 145.482 166.067 145.369 166.157C145.256 166.247 145.169 166.365 145.115 166.499L145.276 165.984L145.598 164.954L146.241 162.863C146.66 161.479 147.207 160.127 147.657 158.743C148.623 156.008 149.653 153.305 150.875 150.698C153.243 145.426 155.963 140.319 159.017 135.412C165.066 125.625 172.918 117.075 182.155 110.215C186.809 106.824 191.968 104.185 197.441 102.395C202.919 100.62 208.724 100.092 214.432 100.85C217.248 101.327 220.023 102.016 222.735 102.91L231.006 105.259L247.514 109.99C241.833 108.658 235.934 108.543 230.205 109.652C224.475 110.762 219.046 113.07 214.272 116.426C204.586 122.896 196.399 131.367 190.265 141.269C183.958 151.014 179.193 161.673 176.137 172.871C173.288 184.124 171.733 195.666 171.503 207.272C171.478 207.696 171.29 208.094 170.978 208.382C170.666 208.67 170.255 208.826 169.83 208.817C169.691 208.835 169.55 208.835 169.412 208.817L41.3 164.922C40.9699 164.809 40.6866 164.59 40.4944 164.299C40.3023 164.008 40.2121 163.661 40.238 163.313C41.2034 150.087 42.1045 136.507 46.4811 123.666C50.6841 110.845 57.5491 99.0556 66.6262 89.0721C75.669 79.4179 87.7368 71.437 101.317 70.3429C104.662 70.095 108.024 70.268 111.325 70.8578C114.543 71.4692 117.761 72.6599 120.98 73.5288L140.095 79.2248C131.656 77.2852 122.815 78.132 114.897 81.6383C107.047 85.0787 100.016 90.1462 94.2695 96.5059C88.5233 102.819 83.7018 109.916 79.9491 117.584C76.1405 125.199 73.349 133.281 71.6464 141.623L70.5845 139.757C95.7176 148.285 120.593 157.07 145.759 165.984Z",
      fill: "url(#paint30_linear_10025_65881)"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_10025_65881",
        x1: "24.4374",
        y1: "313.951",
        x2: "293.34",
        y2: "313.951",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_10025_65881",
        x1: "24.4382",
        y1: "276.725",
        x2: "292.954",
        y2: "276.725",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_10025_65881",
        x1: "82.2983",
        y1: "163.442",
        x2: "274.417",
        y2: "309.767",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_10025_65881",
        x1: "143.764",
        y1: "206.789",
        x2: "182.928",
        y2: "148.188",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.77",
          stopColor: "#7FEFEA",
          stopOpacity: "0.32"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_10025_65881",
        x1: "149.749",
        y1: "182.975",
        x2: "233.837",
        y2: "161.865",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_10025_65881",
        x1: "92.3709",
        y1: "291.167",
        x2: "119.596",
        y2: "202.863",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5",
          stopColor: "#AAF4F1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint6_linear_10025_65881",
        x1: "152.002",
        y1: "218.664",
        x2: "324.716",
        y2: "290.878",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint7_linear_10025_65881",
        x1: "337.234",
        y1: "349.865",
        x2: "235.447",
        y2: "291.393",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#29A2D9",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3879B2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint8_linear_10025_65881",
        x1: "1711.69",
        y1: "4791.09",
        x2: "3387.51",
        y2: "4791.09",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint9_linear_10025_65881",
        x1: "3805.27",
        y1: "4541.27",
        x2: "4850.25",
        y2: "4541.27",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint10_linear_10025_65881",
        x1: "151.905",
        y1: "3061.44",
        x2: "156.853",
        y2: "3061.44",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint11_linear_10025_65881",
        x1: "67.3665",
        y1: "270.572",
        x2: "142.38",
        y2: "270.572",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint12_linear_10025_65881",
        x1: "3941.43",
        y1: "1903.54",
        x2: "5066.76",
        y2: "1903.54",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint13_linear_10025_65881",
        x1: "568.111",
        y1: "3567.89",
        x2: "568.111",
        y2: "2770.61",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint14_radial_10025_65881",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(119.403 154.818) scale(102.818)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint15_radial_10025_65881",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(107.303 156.459) scale(46.3403)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.13",
          stopColor: "white",
          stopOpacity: "0.98"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.26",
          stopColor: "white",
          stopOpacity: "0.94"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.38",
          stopColor: "white",
          stopOpacity: "0.86"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5",
          stopColor: "white",
          stopOpacity: "0.75"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.63",
          stopColor: "white",
          stopOpacity: "0.61"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.75",
          stopColor: "white",
          stopOpacity: "0.44"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.87",
          stopColor: "white",
          stopOpacity: "0.24"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "white",
          stopOpacity: "0.01"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint16_radial_10025_65881",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(74.0599 156.459) scale(46.3403)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.13",
          stopColor: "white",
          stopOpacity: "0.83"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.37",
          stopColor: "white",
          stopOpacity: "0.54"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.59",
          stopColor: "white",
          stopOpacity: "0.31"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.77",
          stopColor: "white",
          stopOpacity: "0.14"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.92",
          stopColor: "white",
          stopOpacity: "0.04"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint17_linear_10025_65881",
        x1: "66.5942",
        y1: "123.353",
        x2: "182.091",
        y2: "123.353",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#43E8E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#3A8FA2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#387E97"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint18_linear_10025_65881",
        x1: "96.6837",
        y1: "153.659",
        x2: "148.173",
        y2: "90.9064",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#153A61"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint19_linear_10025_65881",
        x1: "6269.4",
        y1: "-216.217",
        x2: "10271.5",
        y2: "-216.217",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint20_linear_10025_65881",
        x1: "124.037",
        y1: "37.8077",
        x2: "16.9113",
        y2: "268.205",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint21_linear_10025_65881",
        x1: "4523.07",
        y1: "73.0144",
        x2: "6150.05",
        y2: "73.0144",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint22_linear_10025_65881",
        x1: "2274.25",
        y1: "-126.027",
        x2: "2338.4",
        y2: "102.212",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint23_linear_10025_65881",
        x1: "4860.66",
        y1: "451.329",
        x2: "6759.34",
        y2: "451.329",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint24_linear_10025_65881",
        x1: "164.295",
        y1: "110.44",
        x2: "170.892",
        y2: "86.6586",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "white",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#CDD1EA",
          stopOpacity: "0.32"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#616DBE"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint25_radial_10025_65881",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(134.753 67.5805) rotate(2.86241) scale(184.948 184.487)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#B18654"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#000505"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint26_linear_10025_65881",
        x1: "151.391",
        y1: "81.251",
        x2: "149.106",
        y2: "90.0251",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#153A61"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint27_linear_10025_65881",
        x1: "9415.27",
        y1: "5029.38",
        x2: "9423.24",
        y2: "2970.67",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint28_linear_10025_65881",
        x1: "40.2381",
        y1: "248.496",
        x2: "171.471",
        y2: "248.496",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#AAF4F1"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint29_linear_10025_65881",
        x1: "6301.48",
        y1: "3515.19",
        x2: "10478.5",
        y2: "3515.19",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#AAF4F1"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint30_linear_10025_65881",
        x1: "9463.21",
        y1: "6940.49",
        x2: "9499.36",
        y2: "940.353",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      })]
    })]
  });
};
const comingSoon = (width = "491", height = "329") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 491 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("g", {
      opacity: "0.7",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.7",
        d: "M379.591 182.084C389.402 101.415 331.941 28.068 251.248 18.2596C170.554 8.45125 97.1861 65.8954 87.3748 146.565C77.5635 227.234 135.025 300.581 215.718 310.389C296.411 320.198 369.779 262.754 379.591 182.084Z",
        fill: "#21BF96"
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M125.906 233.311C117.525 233.311 110.574 226.568 110.574 217.984V175.886C110.574 168.734 104.851 163.012 97.696 163.012H97.0827C94.0164 163.012 91.5634 160.559 91.5634 157.494C91.5634 154.429 94.0164 151.976 97.0827 151.976H97.696C110.779 151.976 121.613 162.603 121.613 175.886V217.984C121.613 220.232 123.453 222.072 125.701 222.072C127.95 222.072 129.79 220.232 129.79 217.984V185.696C129.79 176.091 137.558 168.325 147.166 168.325H161.884C164.95 168.325 167.403 170.777 167.403 173.843C167.403 176.908 164.95 179.361 161.884 179.361H147.166C143.69 179.361 140.829 182.222 140.829 185.696V218.189C141.033 226.568 134.287 233.311 125.906 233.311Z",
      fill: "url(#paint0_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M343.204 175.273H322.149C319.083 175.273 316.63 172.821 316.63 169.755C316.63 166.69 319.083 164.238 322.149 164.238H343.204C348.315 164.238 352.608 159.946 352.608 154.837V132.971C352.608 122.957 360.784 114.783 370.801 114.783H379.591C383.884 114.783 387.563 111.308 387.563 106.812V77.9978C387.563 74.9324 390.017 72.48 393.083 72.48C396.149 72.48 398.602 74.9324 398.602 77.9978V106.812C398.602 117.235 390.017 125.818 379.591 125.818H370.801C366.917 125.818 363.646 129.088 363.646 132.971V154.633C363.646 166.077 354.447 175.273 343.204 175.273Z",
      fill: "url(#paint1_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M399.215 78.2023H386.541C378.978 78.2023 372.845 72.0715 372.845 64.5102V59.4012C372.845 53.8835 377.342 49.3876 382.862 49.3876C384.293 49.3876 385.724 50.6137 385.724 52.2486C385.724 53.8835 384.497 55.1096 382.862 55.1096C380.409 55.1096 378.365 57.1532 378.365 59.6056V64.7145C378.365 69.2105 382.044 72.8889 386.541 72.8889H399.215C403.713 72.8889 407.392 69.2105 407.392 64.7145V59.6056C407.392 57.1532 405.348 55.1096 402.895 55.1096C401.464 55.1096 400.033 53.8835 400.033 52.2486C400.033 50.6137 401.26 49.3876 402.895 49.3876C408.414 49.3876 412.912 53.8835 412.912 59.4012V64.7145C412.912 72.0715 406.779 78.2023 399.215 78.2023Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M308.453 259.673H167.403C163.928 259.673 161.066 256.812 161.066 253.338V165.259C161.066 161.785 163.928 158.924 167.403 158.924H308.453C311.928 158.924 314.79 161.785 314.79 165.259V253.338C314.79 256.812 311.928 259.673 308.453 259.673Z",
      fill: "url(#paint2_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M154.729 153.407C150.641 153.407 147.37 156.677 147.37 160.764V183.244C147.37 187.331 150.641 190.601 154.729 190.601C158.818 190.601 162.088 187.331 162.088 183.244V160.968C162.088 156.881 158.818 153.407 154.729 153.407Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M322.149 153.407C318.061 153.407 314.79 156.677 314.79 160.764V183.244C314.79 187.331 318.061 190.601 322.149 190.601C326.238 190.601 329.508 187.331 329.508 183.244V160.968C329.508 156.881 326.238 153.407 322.149 153.407Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M208.287 178.236C208.287 180.211 209.889 181.812 211.865 181.812C213.84 181.812 215.442 180.211 215.442 178.236C215.442 176.261 213.84 174.66 211.865 174.66C209.889 174.66 208.287 176.261 208.287 178.236Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M208.287 191.52C208.287 193.495 209.889 195.096 211.865 195.096C213.84 195.096 215.442 193.495 215.442 191.52C215.442 189.544 213.84 187.943 211.865 187.943C209.889 187.943 208.287 189.544 208.287 191.52Z",
      fill: "#EB5757"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.878 78.2023H386.541C378.978 78.2023 372.845 72.0715 372.845 64.5102V59.4012C372.845 53.8835 377.342 49.3876 382.862 49.3876C384.293 49.3876 385.724 50.6137 385.724 52.2486C385.724 53.8835 384.497 55.1096 382.862 55.1096C380.409 55.1096 378.365 57.1532 378.365 59.6056V64.7145C378.365 69.2105 382.044 72.8889 386.541 72.8889H392.878C394.309 72.8889 395.74 74.1151 395.74 75.75C395.74 76.9761 394.514 78.2023 392.878 78.2023Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M224.845 178.236C224.845 180.211 226.448 181.812 228.423 181.812C230.398 181.812 232 180.211 232 178.236C232 176.261 230.398 174.66 228.423 174.66C226.448 174.66 224.845 176.261 224.845 178.236Z",
      fill: "#F8FEFF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M224.845 191.52C224.845 193.495 226.448 195.096 228.423 195.096C230.398 195.096 232 193.495 232 191.52C232 189.544 230.398 187.943 228.423 187.943C226.448 187.943 224.845 189.544 224.845 191.52Z",
      fill: "#EB5757"
    }), /* @__PURE__ */ jsx("path", {
      d: "M241.199 178.236C241.199 180.211 242.801 181.812 244.776 181.812C246.751 181.812 248.354 180.211 248.354 178.236C248.354 176.261 246.751 174.66 244.776 174.66C242.801 174.66 241.199 176.261 241.199 178.236Z",
      fill: "#EB5757"
    }), /* @__PURE__ */ jsx("path", {
      d: "M241.199 191.52C241.199 193.495 242.801 195.096 244.776 195.096C246.751 195.096 248.354 193.495 248.354 191.52C248.354 189.544 246.751 187.943 244.776 187.943C242.801 187.943 241.199 189.544 241.199 191.52Z",
      fill: "#F8FEFF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M257.757 178.236C257.757 180.211 259.359 181.812 261.334 181.812C263.309 181.812 264.912 180.211 264.912 178.236C264.912 176.261 263.309 174.66 261.334 174.66C259.359 174.66 257.757 176.261 257.757 178.236Z",
      fill: "#F8FEFF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M257.757 191.52C257.757 193.495 259.359 195.096 261.334 195.096C263.309 195.096 264.912 193.495 264.912 191.52C264.912 189.544 263.309 187.943 261.334 187.943C259.359 187.943 257.757 189.544 257.757 191.52Z",
      fill: "#EB5757"
    }), /* @__PURE__ */ jsx("path", {
      d: "M76.4363 178.747H71.3258C65.8065 178.747 61.3093 174.251 61.3093 168.733C61.3093 167.303 62.5358 165.872 64.1712 165.872C65.6021 165.872 67.033 167.099 67.033 168.733C67.033 171.186 69.0772 173.229 71.5303 173.229H76.6408C81.138 173.229 84.8176 169.551 84.8176 165.055V152.589C84.8176 148.093 81.138 144.415 76.6408 144.415H71.5303C68.8728 144.415 66.8286 146.458 66.8286 148.911C66.8286 150.341 65.6021 151.772 63.9667 151.772C62.5358 151.772 61.1049 150.545 61.1049 148.911C61.1049 143.393 65.6021 138.897 71.1214 138.897H76.2319C83.7955 138.897 89.9281 145.028 89.9281 152.589V165.259C90.1325 172.616 83.9999 178.747 76.4363 178.747Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M87.2707 167.917C81.9557 167.917 77.4585 163.625 77.4585 158.107C77.4585 152.794 81.7513 148.298 87.2707 148.298C92.79 148.298 97.0828 152.59 97.0828 158.107C97.0828 163.625 92.79 167.917 87.2707 167.917Z",
      fill: "url(#paint3_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M402.077 75.5457C402.077 70.2323 397.785 65.7364 392.265 65.7364C386.95 65.7364 382.453 70.0279 382.453 75.5457C382.453 80.859 386.746 85.3549 392.265 85.3549C397.785 85.1506 402.077 80.859 402.077 75.5457Z",
      fill: "url(#paint4_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M242.426 52.6575H231.591C224.232 52.6575 218.304 58.5839 218.304 65.9409V80.246H255.917V65.9409C255.713 58.7883 249.785 52.6575 242.426 52.6575Z",
      fill: "url(#paint5_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M260.415 146.867H213.602C212.785 146.867 211.967 147.48 211.967 148.502V157.29C211.967 158.107 212.58 158.925 213.602 158.925H260.415C261.232 158.925 262.05 158.312 262.05 157.29V148.502C261.845 147.48 261.232 146.867 260.415 146.867Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M323.58 109.265H302.934V113.148H323.58V109.265Z",
      fill: "url(#paint6_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M302.116 101.703H290.26V120.096H302.116C305.387 120.096 308.044 117.439 308.044 114.169V107.63C308.044 104.36 305.387 101.703 302.116 101.703Z",
      fill: "url(#paint7_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M329.508 110.899C329.508 113.352 327.464 115.395 325.011 115.395C322.558 115.395 320.514 113.352 320.514 110.899C320.514 108.447 322.558 106.403 325.011 106.403C327.464 106.403 329.508 108.447 329.508 110.899Z",
      fill: "url(#paint8_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M281.879 71.4583H191.934C186.006 71.4583 181.304 76.1585 181.304 82.085V138.284C181.304 144.21 186.006 148.911 191.934 148.911H281.879C287.807 148.911 292.508 144.21 292.508 138.284V82.085C292.508 76.1585 287.807 71.4583 281.879 71.4583Z",
      fill: "url(#paint9_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M271.044 80.8594H202.972C198.475 80.8594 195 84.5378 195 88.8294V131.336C195 135.832 198.679 139.306 202.972 139.306H271.044C275.541 139.306 279.016 135.628 279.016 131.336V89.0338C279.016 84.5378 275.337 80.8594 271.044 80.8594Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M235.054 17.6228V55.225H238.938V17.6228H235.054Z",
      fill: "url(#paint10_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M171.901 120.096H183.757V101.703H171.901C168.63 101.703 165.973 104.36 165.973 107.63V114.374C165.973 117.439 168.63 120.096 171.901 120.096Z",
      fill: "url(#paint11_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M150.323 112.516H170.969V108.633H150.323V112.516Z",
      fill: "url(#paint12_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M144.304 110.899C144.304 108.447 146.348 106.403 148.801 106.403C151.254 106.403 153.298 108.447 153.298 110.899C153.298 113.352 151.254 115.395 148.801 115.395C146.348 115.395 144.304 113.352 144.304 110.899Z",
      fill: "url(#paint13_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M237.111 11.5811C239.564 11.5811 241.608 13.6247 241.608 16.077C241.608 18.5293 239.564 20.5729 237.111 20.5729C234.658 20.5729 232.614 18.5293 232.614 16.077C232.614 13.6247 234.658 11.5811 237.111 11.5811Z",
      fill: "url(#paint14_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M215.646 103.543C218.582 103.543 220.961 100.706 220.961 97.2076C220.961 93.7088 218.582 90.8724 215.646 90.8724C212.711 90.8724 210.331 93.7088 210.331 97.2076C210.331 100.706 212.711 103.543 215.646 103.543Z",
      fill: "url(#paint15_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M255.917 103.543C258.853 103.543 261.232 100.706 261.232 97.2076C261.232 93.7088 258.853 90.8724 255.917 90.8724C252.982 90.8724 250.602 93.7088 250.602 97.2076C250.602 100.706 252.982 103.543 255.917 103.543Z",
      fill: "url(#paint16_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M221.166 121.322C221.166 121.322 235.68 135.219 250.602 122.549",
      stroke: "#2E7DAF",
      strokeWidth: "3",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /* @__PURE__ */ jsx("path", {
      d: "M285.967 259.674H192.138V275.205H285.967V259.674Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M299 203.581H179C174.582 203.581 171 207.163 171 211.581V241.581C171 245.999 174.582 249.581 179 249.581H299C303.418 249.581 307 245.999 307 241.581V211.581C307 207.163 303.418 203.581 299 203.581Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M247 213.581H243C242.448 213.581 242 214.029 242 214.581V220.581C242 221.133 242.448 221.581 243 221.581H247C247.552 221.581 248 221.133 248 220.581V214.581C248 214.029 247.552 213.581 247 213.581Z",
      fill: "url(#paint17_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M254 213.581H250C249.448 213.581 249 214.029 249 214.581V220.581C249 221.133 249.448 221.581 250 221.581H254C254.552 221.581 255 221.133 255 220.581V214.581C255 214.029 254.552 213.581 254 213.581Z",
      fill: "url(#paint18_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M261 213.581H257C256.448 213.581 256 214.029 256 214.581V220.581C256 221.133 256.448 221.581 257 221.581H261C261.552 221.581 262 221.133 262 220.581V214.581C262 214.029 261.552 213.581 261 213.581Z",
      fill: "url(#paint19_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M268 213.581H264C263.448 213.581 263 214.029 263 214.581V220.581C263 221.133 263.448 221.581 264 221.581H268C268.552 221.581 269 221.133 269 220.581V214.581C269 214.029 268.552 213.581 268 213.581Z",
      fill: "url(#paint20_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M275 213.581H271C270.448 213.581 270 214.029 270 214.581V220.581C270 221.133 270.448 221.581 271 221.581H275C275.552 221.581 276 221.133 276 220.581V214.581C276 214.029 275.552 213.581 275 213.581Z",
      fill: "url(#paint21_linear_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M282 213.581H278C277.448 213.581 277 214.029 277 214.581V220.581C277 221.133 277.448 221.581 278 221.581H282C282.552 221.581 283 221.133 283 220.581V214.581C283 214.029 282.552 213.581 282 213.581Z",
      fill: "url(#paint22_linear_202_9308)",
      fillOpacity: "0.6"
    }), /* @__PURE__ */ jsx("path", {
      d: "M289 213.581H285C284.448 213.581 284 214.029 284 214.581V220.581C284 221.133 284.448 221.581 285 221.581H289C289.552 221.581 290 221.133 290 220.581V214.581C290 214.029 289.552 213.581 289 213.581Z",
      fill: "url(#paint23_linear_202_9308)",
      fillOpacity: "0.6"
    }), /* @__PURE__ */ jsx("path", {
      d: "M296 213.581H292C291.448 213.581 291 214.029 291 214.581V220.581C291 221.133 291.448 221.581 292 221.581H296C296.552 221.581 297 221.133 297 220.581V214.581C297 214.029 296.552 213.581 296 213.581Z",
      fill: "url(#paint24_linear_202_9308)",
      fillOpacity: "0.6"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.47 194.279H359.762V297.072H392.47V194.279Z",
      fill: "url(#paint25_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M430.083 288.488H359.762V300.546H430.083V288.488Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.47 216.35H359.762V218.802H392.47V216.35Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.47 224.933H359.762V227.385H392.47V224.933Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.47 233.516H359.762V235.969H392.47V233.516Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.47 242.1H359.762V244.552H392.47V242.1Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.47 250.887H359.762V253.339H392.47V250.887Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.47 259.47H359.762V261.923H392.47V259.47Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.47 268.052H359.762V270.505H392.47V268.052Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.47 276.636H359.762V279.088H392.47V276.636Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M392.47 285.219H359.762V287.671H392.47V285.219Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M438.055 169.96C437.851 169.96 437.851 169.96 437.646 169.96C436.215 169.96 434.784 169.143 433.967 168.121L435.602 166.895C436.215 167.508 436.829 167.916 437.851 167.916C439.486 168.121 441.53 167.099 442.961 165.873C445.619 163.216 447.05 159.333 446.845 155.45C444.188 156.064 441.939 155.859 440.099 154.837C438.668 154.02 437.646 152.181 437.442 150.546C437.237 149.115 437.851 147.889 438.873 146.867C440.304 145.641 442.552 145.641 444.392 146.663C445.823 147.48 446.845 148.911 447.663 150.75C447.867 151.363 448.072 152.181 448.276 152.794C451.547 151.568 454.409 148.911 455.226 145.846C455.022 145.846 454.818 145.641 454.613 145.437C452.364 144.211 450.934 141.758 450.934 139.306C450.934 138.489 451.342 137.058 452.16 136.445C452.773 136.036 453.387 136.036 454 136.241C454.818 136.445 455.022 137.262 455.226 137.671C456.248 139.51 457.271 141.35 457.475 143.598C457.475 143.802 457.475 144.006 457.475 144.211C458.702 144.415 459.928 144.211 460.746 143.598L461.768 145.437C460.337 146.254 458.701 146.459 457.066 146.254C456.044 150.137 452.364 153.203 448.48 154.633C448.889 159.129 447.254 163.829 443.983 167.099C442.757 168.938 440.304 169.96 438.055 169.96ZM441.735 147.889C441.121 147.889 440.713 148.094 440.304 148.298C439.69 148.911 439.486 149.728 439.69 150.137C439.69 151.159 440.508 152.385 441.326 152.794C442.961 153.816 445.005 153.611 446.641 153.203C446.436 152.589 446.232 151.976 446.027 151.363C445.414 149.933 444.597 148.707 443.574 148.094C442.961 148.094 442.348 147.889 441.735 147.889ZM453.387 138.284C453.387 138.284 453.182 138.897 453.182 139.306C453.182 141.145 454.204 142.78 455.635 143.598C455.431 141.758 454.409 140.124 453.591 138.693C453.591 138.693 453.387 138.489 453.387 138.284Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M453.182 162.398H420.475V265.191H453.182V162.398Z",
      fill: "url(#paint26_radial_202_9308)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M490.795 256.609H420.475V268.666H490.795V256.609Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M453.182 184.47H420.475V186.922H453.182V184.47Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M453.182 193.257H420.475V195.71H453.182V193.257Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M453.182 201.84H420.475V204.293H453.182V201.84Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M453.182 210.423H420.475V212.875H453.182V210.423Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M453.182 219.006H420.475V221.458H453.182V219.006Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M453.182 227.589H420.475V230.042H453.182V227.589Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M453.182 236.173H420.475V238.625H453.182V236.173Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M453.182 244.756H420.475V247.208H453.182V244.756Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M453.182 253.338H420.475V255.791H453.182V253.338Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M275.541 307.698C275.337 307.698 275.132 307.698 274.928 307.698C271.657 307.493 268.591 305.245 267.16 301.976C265.934 299.115 265.729 295.845 266.751 292.371L268.795 292.984C267.978 295.845 267.978 298.706 269.204 301.158C270.431 303.815 272.884 305.45 275.337 305.654C276.972 305.859 278.608 305.245 280.039 304.224C278.812 302.793 277.79 300.75 277.177 298.297C276.155 294.823 275.95 291.145 276.359 287.466C276.359 286.444 276.563 285.423 277.381 284.81C278.608 283.379 281.061 283.583 282.287 284.605C283.514 285.627 284.331 287.057 284.74 288.488C286.376 293.188 286.58 297.275 285.353 300.954C284.945 302.18 284.127 303.406 283.105 304.632C286.171 306.472 290.464 305.45 292.917 303.202C293.121 302.998 293.326 302.793 293.53 302.589C292.508 301.567 291.895 300.136 291.282 298.706C289.033 293.597 289.237 287.466 291.69 282.562C291.895 282.153 292.304 281.131 293.326 280.927C293.939 280.722 294.757 280.927 295.574 281.335C300.072 284.196 300.072 290.532 299.663 292.984C299.254 295.845 298.436 299.523 296.188 302.589C297.21 303.406 298.232 304.019 299.254 304.224C302.934 305.245 306.818 302.998 309.271 300.545C307.022 297.889 306.204 293.597 306.818 287.875C307.022 286.036 307.226 283.992 308.453 282.357C309.679 280.518 311.928 279.292 314.381 280.109C317.039 281.131 317.856 284.401 317.652 287.057C317.243 291.962 315.403 296.662 312.132 300.341C315.199 302.793 320.105 301.976 323.171 299.932C325.011 298.706 326.646 296.867 328.077 294.823C327.464 294.006 327.055 293.188 326.646 292.371C325.42 290.123 323.58 287.058 323.784 283.583C323.989 281.54 325.011 279.701 326.442 278.474C327.668 277.453 329.099 277.044 330.53 277.248C333.392 277.657 335.232 280.927 335.232 283.583C335.232 286.24 334.005 288.488 332.779 290.94C332.166 292.166 331.348 293.597 330.53 294.823C331.144 295.641 331.757 296.458 332.574 297.071C334.21 298.297 336.663 299.115 338.503 298.297L339.32 300.136C336.867 301.158 333.597 300.75 331.144 298.706C330.326 298.093 329.713 297.48 329.099 296.662C327.668 298.502 326.033 300.341 324.193 301.567C320.514 304.019 314.586 305.041 310.702 301.771C307.022 305.45 302.525 307.085 298.641 306.063C297.21 305.654 295.983 305.041 294.757 304.019C294.552 304.224 294.144 304.632 293.939 304.837C290.668 307.698 285.149 308.924 281.265 306.063C279.63 306.88 277.79 307.698 275.541 307.698ZM279.425 285.627C279.016 285.627 278.608 285.831 278.403 286.036C277.994 286.444 277.994 287.057 277.994 287.671C277.585 291.145 277.994 294.414 278.812 297.889C279.425 300.137 280.243 301.771 281.265 302.998C282.083 302.18 282.696 301.158 283.105 299.932C284.536 296.049 283.514 291.758 282.492 288.897C282.083 287.875 281.674 286.649 280.856 286.036C280.447 285.831 279.834 285.627 279.425 285.627ZM293.735 282.357C293.735 282.357 293.53 282.357 293.326 282.97C291.077 287.466 291.077 292.984 292.917 297.48C293.326 298.706 293.939 299.728 294.757 300.545C296.597 297.889 297.21 294.619 297.619 292.166C297.823 290.532 298.232 284.605 294.552 282.357C293.939 282.357 293.735 282.357 293.735 282.357ZM312.746 281.335C311.724 281.335 310.702 282.153 310.088 282.97C309.271 284.196 309.066 286.036 308.862 287.671C308.248 292.575 308.862 296.254 310.497 298.502C313.359 295.027 314.994 290.94 315.403 286.444C315.608 284.605 315.199 282.153 313.563 281.54C313.359 281.335 312.95 281.335 312.746 281.335ZM329.304 278.883C328.486 278.883 327.873 279.292 327.26 279.701C326.237 280.518 325.42 281.949 325.42 283.379C325.215 285.831 326.442 288.284 328.077 290.94C328.282 291.553 328.69 291.962 329.099 292.575C329.713 291.553 330.326 290.532 330.735 289.51C331.961 287.466 332.983 285.423 332.779 283.175C332.779 281.335 331.552 279.087 329.713 278.883C329.713 278.883 329.508 278.883 329.304 278.883Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M69.9835 272.74C70.1879 272.74 70.3923 272.74 70.5967 272.944C73.663 273.762 76.3205 276.623 77.3426 279.892C78.1602 282.958 77.7514 286.227 76.116 289.497L74.2763 288.475C75.7072 285.819 76.1161 282.958 75.2984 280.301C74.4807 277.644 72.4365 275.396 69.9835 274.783C68.3481 274.375 66.7127 274.579 65.0774 275.396C66.0995 277.031 66.7127 279.075 66.9172 281.732C67.1216 285.41 66.9172 289.088 65.8951 292.563C65.6906 293.584 65.2818 294.402 64.4641 295.015C62.8288 296.241 60.7846 295.628 59.558 294.402C58.5359 293.176 58.1271 291.541 57.9227 290.315C57.105 285.41 57.7183 281.323 59.558 278.053C60.1713 276.827 61.1934 275.805 62.2155 274.783C59.558 272.331 55.2652 272.74 52.4033 274.375C52.1989 274.579 51.7901 274.783 51.5857 274.988C52.1989 276.214 52.8122 277.644 53.221 279.279C54.4475 284.797 53.221 290.723 49.9503 295.219C49.7459 295.628 48.9282 296.445 47.9061 296.65C47.2928 296.65 46.4752 296.445 45.8619 295.832C41.7735 292.154 43.2044 286.023 43.8177 283.571C44.6354 280.914 46.0663 277.236 48.9282 274.783C48.1105 273.762 47.2928 273.148 46.2707 272.535C42.7956 270.9 38.7072 272.331 35.8453 274.375C37.4807 277.44 37.4807 281.732 36.0497 287.249C35.4365 289.088 34.8232 290.928 33.3923 292.563C31.9613 293.993 29.3039 295.015 27.2597 293.789C24.8067 292.358 24.6022 288.884 25.4199 286.227C26.6464 281.527 29.3039 277.236 33.1879 273.966C30.5304 270.9 25.6243 270.9 22.3536 272.535C20.3094 273.557 18.2652 274.988 16.6299 276.623C17.0387 277.644 17.2431 278.462 17.652 279.484C18.4696 281.936 19.6962 285.41 18.8785 288.475C18.4696 290.315 17.0387 292.154 15.4033 293.176C13.9724 293.993 12.5415 293.993 11.3149 293.584C8.45306 292.563 7.22654 289.088 7.8398 286.432C8.24864 283.775 9.884 281.732 11.5194 279.688C12.337 278.462 13.3591 277.44 14.3812 276.214C13.9724 275.396 13.3591 274.375 12.7459 273.557C11.5194 272.127 9.27074 270.696 7.02212 271.309L6.61328 269.266C9.27074 268.653 12.337 269.674 14.3812 272.127C14.9945 272.944 15.6078 273.557 16.0166 274.375C17.652 272.74 19.4917 271.309 21.7404 270.287C25.8288 268.448 31.7569 268.448 35.0276 272.331C39.3205 269.266 44.0221 268.448 47.4973 270.287C48.7238 270.9 49.9503 271.922 50.9724 272.944C51.1768 272.74 51.5857 272.535 51.7901 272.331C55.4696 270.083 61.1934 269.879 64.4641 273.353C65.8951 272.74 67.9393 272.331 69.9835 272.74ZM62.4199 293.789C62.8288 293.789 63.2376 293.789 63.442 293.584C63.8509 293.176 64.0553 292.563 64.2597 292.154C65.2818 288.884 65.4862 285.41 65.2818 281.936C65.0774 279.688 64.6685 277.849 63.8509 276.418C63.0332 277.031 62.2155 278.053 61.6022 279.075C59.558 282.549 59.7625 287.045 60.1713 289.906C60.3757 291.132 60.5801 292.154 61.3978 292.971C61.3978 293.584 61.8067 293.789 62.4199 293.789ZM47.7017 294.606C47.7017 294.606 47.9061 294.606 48.3149 293.993C51.1768 289.906 52.4033 284.593 51.1768 279.688C50.9724 278.462 50.5636 277.44 49.9503 276.418C47.7017 278.666 46.4752 281.732 45.8619 284.184C45.4531 285.819 44.0221 291.541 47.2928 294.402C47.4973 294.606 47.7017 294.606 47.7017 294.606ZM28.6906 292.154C29.7127 292.358 30.9392 291.745 31.5525 291.132C32.5746 289.906 33.1879 288.271 33.5967 286.841C35.0276 282.14 35.0276 278.462 33.8011 275.805C30.5304 278.666 28.0774 282.549 26.8509 286.841C26.442 288.68 26.2376 291.132 27.8729 291.95C28.2818 292.154 28.4862 292.154 28.6906 292.154ZM11.9282 291.745C12.7459 291.95 13.5636 291.541 13.9724 291.336C15.1989 290.723 16.221 289.293 16.4254 288.067C17.0387 285.614 16.221 282.958 15.1989 280.097C14.9945 279.484 14.7901 278.87 14.5857 278.257C13.768 279.075 13.1547 280.097 12.337 280.914C10.9061 282.753 9.47516 284.593 9.06632 286.636C8.65748 288.475 9.47516 290.928 11.3149 291.541C11.7238 291.745 11.9282 291.745 11.9282 291.745Z",
      fill: "#2E7DAF"
    }), /* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip0_202_9308)",
      children: [/* @__PURE__ */ jsx("path", {
        d: "M83.6933 220.678L80.0386 220.326C84.5634 212.572 73.2513 207.462 67.1601 212.044C65.7678 211.691 64.2015 211.339 62.8093 210.986C62.6352 205.7 56.5441 208.519 52.7154 208.519C49.2347 208.519 48.7126 210.458 48.1905 212.925C46.7982 213.101 45.2319 213.453 44.0137 213.982C37.5745 209.224 26.2623 212.572 30.9612 220.326C25.9143 220.502 23.3038 221.03 24.1739 226.669C23.3038 232.308 26.0883 232.837 31.1352 233.013C26.7844 240.766 37.9225 245.876 44.0137 241.295C45.406 241.647 46.7982 242 48.1905 242.176C48.3645 247.638 54.4557 246.405 58.2844 246.581C61.7651 246.581 62.2872 244.643 62.8093 242.176C64.3756 242 65.7678 241.647 67.1601 241.119C73.2513 245.7 84.5634 240.414 80.0386 232.837C82.127 232.66 87.522 232.66 86.9999 229.665C86.3038 226.317 88.9143 221.03 83.6933 220.678ZM55.4999 229.841C51.6712 229.841 48.1905 228.608 46.7982 226.669C49.5828 222.44 61.417 222.44 64.3756 226.669C62.8093 228.431 59.5027 229.841 55.4999 229.841Z",
        fill: "#2E7DAF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M55.4999 229.841C42.9695 230.017 42.9695 218.916 55.4999 218.916C68.0303 218.74 68.0303 229.841 55.4999 229.841ZM83.6933 220.678L79.3425 220.326C78.8204 219.445 78.2983 218.74 77.6021 217.859C83.5193 214.158 80.2126 212.749 75.8618 210.282C72.7292 208.872 70.2928 210.81 67.3342 211.339C66.116 211.515 62.9834 210.81 62.9834 210.81C62.9834 210.81 63.1574 208.343 61.243 207.286C58.8066 206.405 54.6298 206.581 52.7154 206.581C49.2347 206.581 48.7126 208.52 48.1905 210.987C43.8397 213.454 39.6629 208.696 35.3121 210.81C30.9613 213.277 27.6546 214.158 33.5718 217.859C32.7016 218.564 32.1795 219.445 31.8314 220.326C27.3066 220.678 23.1298 220.15 24.174 225.965C24.174 228.432 29.9171 228.255 31.8314 228.608C32.3535 229.489 32.8756 230.194 33.5718 231.075C27.6546 234.775 30.9613 235.832 35.3121 238.123C39.4889 240.238 43.6657 235.48 48.1905 237.771C48.3646 243.233 54.4557 242 58.2845 242.176C61.7651 242.176 62.2872 240.238 62.8093 237.771C67.3342 235.304 71.337 240.062 75.6878 237.947C80.0386 235.48 83.3452 234.599 77.4281 230.899C78.1242 230.194 78.8204 229.313 79.1684 228.432C81.0828 228.079 86.8259 228.432 86.8259 225.788C86.9999 223.498 87.522 220.854 83.6933 220.678Z",
        fill: "url(#paint27_radial_202_9308)"
      })]
    }), /* @__PURE__ */ jsx("path", {
      d: "M183.88 221.581C183.504 221.581 183.212 221.489 183.004 221.305C182.804 221.113 182.684 220.849 182.644 220.513H182.584C182.472 220.897 182.252 221.197 181.924 221.413C181.596 221.621 181.192 221.725 180.712 221.725C180.088 221.725 179.592 221.561 179.224 221.233C178.856 220.905 178.672 220.449 178.672 219.865C178.672 218.617 179.588 217.993 181.42 217.993H182.512V217.585C182.512 217.193 182.416 216.897 182.224 216.697C182.032 216.497 181.72 216.397 181.288 216.397C180.896 216.397 180.58 216.473 180.34 216.625C180.1 216.777 179.896 216.973 179.728 217.213L178.852 216.469C179.044 216.125 179.352 215.837 179.776 215.605C180.208 215.365 180.764 215.245 181.444 215.245C182.26 215.245 182.896 215.437 183.352 215.821C183.816 216.197 184.048 216.761 184.048 217.513V220.429H184.78V221.581H183.88ZM181.228 220.669C181.596 220.669 181.9 220.585 182.14 220.417C182.388 220.241 182.512 220.005 182.512 219.709V218.881H181.456C180.616 218.881 180.196 219.145 180.196 219.673V219.913C180.196 220.161 180.288 220.349 180.472 220.477C180.656 220.605 180.908 220.669 181.228 220.669Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M188.771 221.725C188.091 221.725 187.503 221.621 187.007 221.413C186.511 221.197 186.123 220.909 185.843 220.549L186.743 219.733C186.999 220.013 187.291 220.229 187.619 220.381C187.955 220.533 188.343 220.609 188.783 220.609C189.167 220.609 189.475 220.545 189.707 220.417C189.939 220.289 190.055 220.093 190.055 219.829C190.055 219.605 189.975 219.453 189.815 219.373C189.663 219.293 189.459 219.233 189.203 219.193L188.207 219.037C187.951 218.997 187.699 218.941 187.451 218.869C187.211 218.789 186.995 218.681 186.803 218.545C186.619 218.409 186.471 218.237 186.359 218.029C186.247 217.813 186.191 217.553 186.191 217.249C186.191 216.601 186.431 216.105 186.911 215.761C187.399 215.417 188.067 215.245 188.915 215.245C189.515 215.245 190.023 215.329 190.439 215.497C190.863 215.665 191.211 215.901 191.483 216.205L190.679 217.093C190.503 216.901 190.267 216.733 189.971 216.589C189.683 216.437 189.315 216.361 188.867 216.361C188.083 216.361 187.691 216.605 187.691 217.093C187.691 217.317 187.771 217.473 187.931 217.561C188.091 217.641 188.299 217.701 188.555 217.741L189.539 217.897C189.803 217.937 190.055 217.997 190.295 218.077C190.543 218.149 190.759 218.253 190.943 218.389C191.135 218.525 191.287 218.697 191.399 218.905C191.511 219.113 191.567 219.369 191.567 219.673C191.567 220.313 191.319 220.817 190.823 221.185C190.335 221.545 189.651 221.725 188.771 221.725Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M195.967 221.725C195.287 221.725 194.699 221.621 194.203 221.413C193.707 221.197 193.319 220.909 193.039 220.549L193.939 219.733C194.195 220.013 194.487 220.229 194.815 220.381C195.151 220.533 195.539 220.609 195.979 220.609C196.363 220.609 196.671 220.545 196.903 220.417C197.135 220.289 197.251 220.093 197.251 219.829C197.251 219.605 197.171 219.453 197.011 219.373C196.859 219.293 196.655 219.233 196.399 219.193L195.403 219.037C195.147 218.997 194.895 218.941 194.647 218.869C194.407 218.789 194.191 218.681 193.999 218.545C193.815 218.409 193.667 218.237 193.555 218.029C193.443 217.813 193.387 217.553 193.387 217.249C193.387 216.601 193.627 216.105 194.107 215.761C194.595 215.417 195.263 215.245 196.111 215.245C196.711 215.245 197.219 215.329 197.635 215.497C198.059 215.665 198.407 215.901 198.679 216.205L197.875 217.093C197.699 216.901 197.463 216.733 197.167 216.589C196.879 216.437 196.511 216.361 196.063 216.361C195.279 216.361 194.887 216.605 194.887 217.093C194.887 217.317 194.967 217.473 195.127 217.561C195.287 217.641 195.495 217.701 195.751 217.741L196.735 217.897C196.999 217.937 197.251 217.997 197.491 218.077C197.739 218.149 197.955 218.253 198.139 218.389C198.331 218.525 198.483 218.697 198.595 218.905C198.707 219.113 198.763 219.369 198.763 219.673C198.763 220.313 198.515 220.817 198.019 221.185C197.531 221.545 196.847 221.725 195.967 221.725Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M203.33 221.725C202.834 221.725 202.394 221.649 202.01 221.497C201.626 221.345 201.302 221.129 201.038 220.849C200.782 220.569 200.586 220.233 200.45 219.841C200.314 219.441 200.246 218.993 200.246 218.497C200.246 217.993 200.314 217.541 200.45 217.141C200.594 216.741 200.794 216.401 201.05 216.121C201.306 215.841 201.614 215.625 201.974 215.473C202.342 215.321 202.754 215.245 203.21 215.245C203.658 215.245 204.062 215.321 204.422 215.473C204.782 215.617 205.086 215.825 205.334 216.097C205.59 216.369 205.786 216.697 205.922 217.081C206.058 217.465 206.126 217.889 206.126 218.353V218.857H201.782V219.013C201.782 219.461 201.922 219.825 202.202 220.105C202.482 220.377 202.874 220.513 203.378 220.513C203.762 220.513 204.09 220.437 204.362 220.285C204.642 220.125 204.874 219.917 205.058 219.661L205.934 220.537C205.71 220.865 205.382 221.145 204.95 221.377C204.526 221.609 203.986 221.725 203.33 221.725ZM203.222 216.373C202.79 216.373 202.442 216.509 202.178 216.781C201.914 217.053 201.782 217.413 201.782 217.861V217.945H204.59V217.837C204.59 217.389 204.466 217.033 204.218 216.769C203.978 216.505 203.646 216.373 203.222 216.373Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M207.225 221.581V215.389H208.497V216.241H208.569C208.665 215.969 208.801 215.737 208.977 215.545C209.161 215.345 209.417 215.245 209.745 215.245C210.057 215.245 210.305 215.337 210.489 215.521C210.673 215.697 210.793 215.949 210.849 216.277H210.909C211.013 215.997 211.165 215.757 211.365 215.557C211.573 215.349 211.865 215.245 212.241 215.245C212.697 215.245 213.025 215.409 213.225 215.737C213.425 216.065 213.525 216.549 213.525 217.189V221.581H212.265V217.369C212.265 217.009 212.213 216.757 212.109 216.613C212.013 216.469 211.865 216.397 211.665 216.397C211.481 216.397 211.325 216.457 211.197 216.577C211.077 216.697 211.017 216.881 211.017 217.129V221.581H209.745V217.369C209.745 217.009 209.697 216.757 209.601 216.613C209.505 216.469 209.357 216.397 209.157 216.397C208.965 216.397 208.805 216.457 208.677 216.577C208.557 216.697 208.497 216.881 208.497 217.129V221.581H207.225Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M214.805 212.701H216.341V216.481H216.425C216.593 216.105 216.821 215.805 217.109 215.581C217.405 215.357 217.793 215.245 218.273 215.245C218.625 215.245 218.945 215.313 219.233 215.449C219.529 215.577 219.781 215.777 219.989 216.049C220.197 216.313 220.357 216.649 220.469 217.057C220.581 217.465 220.637 217.941 220.637 218.485C220.637 219.029 220.581 219.505 220.469 219.913C220.357 220.321 220.197 220.661 219.989 220.933C219.781 221.197 219.529 221.397 219.233 221.533C218.945 221.661 218.625 221.725 218.273 221.725C217.793 221.725 217.405 221.613 217.109 221.389C216.821 221.165 216.593 220.865 216.425 220.489H216.341V221.581H214.805V212.701ZM217.625 220.501C218.073 220.501 218.417 220.365 218.657 220.093C218.905 219.821 219.029 219.449 219.029 218.977V217.993C219.029 217.521 218.905 217.149 218.657 216.877C218.417 216.605 218.073 216.469 217.625 216.469C217.273 216.469 216.969 216.557 216.713 216.733C216.465 216.901 216.341 217.161 216.341 217.513V219.457C216.341 219.809 216.465 220.073 216.713 220.249C216.969 220.417 217.273 220.501 217.625 220.501Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M222.036 220.369H224.004V213.913H222.036V212.701H225.54V220.369H227.52V221.581H222.036V220.369Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M233.659 215.389H235.219L232.255 222.685C232.087 223.109 231.863 223.429 231.583 223.645C231.303 223.869 230.907 223.981 230.395 223.981H229.267V222.769H230.743L231.211 221.521L228.715 215.389H230.347L231.295 217.981L231.955 219.949H232.039L232.699 217.981L233.659 215.389Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M181.984 230.429C181.624 230.429 181.368 230.353 181.216 230.201C181.072 230.049 181 229.865 181 229.649V229.361C181 229.145 181.072 228.961 181.216 228.809C181.368 228.657 181.624 228.581 181.984 228.581C182.344 228.581 182.596 228.657 182.74 228.809C182.892 228.961 182.968 229.145 182.968 229.361V229.649C182.968 229.865 182.892 230.049 182.74 230.201C182.596 230.353 182.344 230.429 181.984 230.429ZM179.176 236.369H181.216V232.601H179.176V231.389H182.752V236.369H184.648V237.581H179.176V236.369Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M186.095 237.581V231.389H187.631V232.481H187.691C187.827 232.145 188.035 231.857 188.315 231.617C188.603 231.369 188.999 231.245 189.503 231.245C190.111 231.245 190.603 231.449 190.979 231.857C191.363 232.257 191.555 232.833 191.555 233.585V237.581H190.019V233.801C190.019 232.905 189.631 232.457 188.855 232.457C188.695 232.457 188.543 232.477 188.399 232.517C188.255 232.557 188.123 232.621 188.003 232.709C187.891 232.789 187.799 232.889 187.727 233.009C187.663 233.129 187.631 233.273 187.631 233.441V237.581H186.095Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M200.414 231.389H201.95V232.481H202.034C202.202 232.105 202.43 231.805 202.718 231.581C203.014 231.357 203.402 231.245 203.882 231.245C204.234 231.245 204.554 231.313 204.842 231.449C205.138 231.577 205.39 231.777 205.598 232.049C205.806 232.313 205.966 232.649 206.078 233.057C206.19 233.465 206.246 233.941 206.246 234.485C206.246 235.029 206.19 235.505 206.078 235.913C205.966 236.321 205.806 236.661 205.598 236.933C205.39 237.197 205.138 237.397 204.842 237.533C204.554 237.661 204.234 237.725 203.882 237.725C203.402 237.725 203.014 237.613 202.718 237.389C202.43 237.165 202.202 236.865 202.034 236.489H201.95V239.981H200.414V231.389ZM203.234 236.501C203.682 236.501 204.026 236.365 204.266 236.093C204.514 235.821 204.638 235.449 204.638 234.977V233.993C204.638 233.521 204.514 233.149 204.266 232.877C204.026 232.605 203.682 232.469 203.234 232.469C202.882 232.469 202.578 232.557 202.322 232.733C202.074 232.901 201.95 233.161 201.95 233.513V235.457C201.95 235.809 202.074 236.073 202.322 236.249C202.578 236.417 202.882 236.501 203.234 236.501Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M207.681 236.369H209.217V232.601H207.681V231.389H210.753V233.081H210.849C210.905 232.865 210.981 232.657 211.077 232.457C211.181 232.249 211.309 232.069 211.461 231.917C211.621 231.757 211.813 231.629 212.037 231.533C212.261 231.437 212.529 231.389 212.841 231.389H213.513V232.829H212.241C211.777 232.829 211.413 232.965 211.149 233.237C210.885 233.509 210.753 233.857 210.753 234.281V236.369H212.901V237.581H207.681V236.369Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M217.577 237.725C217.105 237.725 216.681 237.649 216.305 237.497C215.937 237.345 215.621 237.129 215.357 236.849C215.101 236.569 214.901 236.229 214.757 235.829C214.621 235.429 214.553 234.981 214.553 234.485C214.553 233.989 214.621 233.541 214.757 233.141C214.901 232.741 215.101 232.401 215.357 232.121C215.621 231.841 215.937 231.625 216.305 231.473C216.681 231.321 217.105 231.245 217.577 231.245C218.041 231.245 218.461 231.321 218.837 231.473C219.213 231.625 219.529 231.841 219.785 232.121C220.049 232.401 220.249 232.741 220.385 233.141C220.529 233.541 220.601 233.989 220.601 234.485C220.601 234.981 220.529 235.429 220.385 235.829C220.249 236.229 220.049 236.569 219.785 236.849C219.529 237.129 219.213 237.345 218.837 237.497C218.461 237.649 218.041 237.725 217.577 237.725ZM217.577 236.549C218.017 236.549 218.365 236.417 218.621 236.153C218.877 235.881 219.005 235.485 219.005 234.965V234.005C219.005 233.485 218.877 233.093 218.621 232.829C218.365 232.557 218.017 232.421 217.577 232.421C217.137 232.421 216.789 232.557 216.533 232.829C216.277 233.093 216.149 233.485 216.149 234.005V234.965C216.149 235.485 216.277 235.881 216.533 236.153C216.789 236.417 217.137 236.549 217.577 236.549Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M228.084 238.229C228.084 238.877 227.812 239.353 227.268 239.657C226.732 239.969 225.892 240.125 224.748 240.125C224.188 240.125 223.72 240.089 223.344 240.017C222.968 239.953 222.664 239.857 222.432 239.729C222.208 239.601 222.048 239.445 221.952 239.261C221.856 239.085 221.808 238.885 221.808 238.661C221.808 238.317 221.908 238.053 222.108 237.869C222.308 237.685 222.588 237.549 222.948 237.461V237.365C222.708 237.285 222.516 237.173 222.372 237.029C222.236 236.885 222.168 236.685 222.168 236.429C222.168 236.125 222.268 235.897 222.468 235.745C222.676 235.593 222.948 235.477 223.284 235.397V235.337C222.916 235.161 222.628 234.913 222.42 234.593C222.212 234.273 222.108 233.885 222.108 233.429C222.108 233.085 222.168 232.781 222.288 232.517C222.416 232.245 222.592 232.017 222.816 231.833C223.048 231.641 223.324 231.497 223.644 231.401C223.964 231.297 224.32 231.245 224.712 231.245C225.128 231.245 225.504 231.301 225.84 231.413V231.149C225.84 230.909 225.916 230.709 226.068 230.549C226.228 230.389 226.448 230.309 226.728 230.309H227.844V231.461H226.38V231.665C226.684 231.849 226.916 232.089 227.076 232.385C227.244 232.673 227.328 233.021 227.328 233.429C227.328 233.773 227.264 234.081 227.136 234.353C227.016 234.625 226.84 234.853 226.608 235.037C226.384 235.221 226.108 235.365 225.78 235.469C225.46 235.565 225.104 235.613 224.712 235.613C224.552 235.613 224.396 235.609 224.244 235.601C224.1 235.585 223.96 235.557 223.824 235.517C223.712 235.557 223.604 235.621 223.5 235.709C223.396 235.797 223.344 235.913 223.344 236.057C223.344 236.249 223.436 236.369 223.62 236.417C223.804 236.457 224.024 236.477 224.28 236.477H225.684C226.116 236.477 226.484 236.521 226.788 236.609C227.092 236.689 227.34 236.809 227.532 236.969C227.724 237.121 227.864 237.305 227.952 237.521C228.04 237.737 228.084 237.973 228.084 238.229ZM226.644 238.337C226.644 238.153 226.568 238.005 226.416 237.893C226.272 237.789 226 237.737 225.6 237.737H223.464C223.224 237.873 223.104 238.073 223.104 238.337C223.104 238.553 223.192 238.733 223.368 238.877C223.552 239.021 223.86 239.093 224.292 239.093H225.288C226.192 239.093 226.644 238.841 226.644 238.337ZM224.712 234.605C225.104 234.605 225.392 234.513 225.576 234.329C225.76 234.137 225.852 233.889 225.852 233.585V233.273C225.852 232.969 225.76 232.725 225.576 232.541C225.392 232.349 225.104 232.253 224.712 232.253C224.328 232.253 224.044 232.349 223.86 232.541C223.676 232.725 223.584 232.969 223.584 233.273V233.585C223.584 233.889 223.676 234.137 223.86 234.329C224.044 234.513 224.328 234.605 224.712 234.605Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M229.267 236.369H230.803V232.601H229.267V231.389H232.339V233.081H232.435C232.491 232.865 232.567 232.657 232.663 232.457C232.767 232.249 232.895 232.069 233.047 231.917C233.207 231.757 233.399 231.629 233.623 231.533C233.847 231.437 234.115 231.389 234.427 231.389H235.099V232.829H233.827C233.363 232.829 232.999 232.965 232.735 233.237C232.471 233.509 232.339 233.857 232.339 234.281V236.369H234.487V237.581H229.267V236.369Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M239.306 237.725C238.81 237.725 238.37 237.649 237.986 237.497C237.602 237.345 237.278 237.129 237.014 236.849C236.758 236.569 236.562 236.233 236.426 235.841C236.29 235.441 236.222 234.993 236.222 234.497C236.222 233.993 236.29 233.541 236.426 233.141C236.57 232.741 236.77 232.401 237.026 232.121C237.282 231.841 237.59 231.625 237.95 231.473C238.318 231.321 238.73 231.245 239.186 231.245C239.634 231.245 240.038 231.321 240.398 231.473C240.758 231.617 241.062 231.825 241.31 232.097C241.566 232.369 241.762 232.697 241.898 233.081C242.035 233.465 242.102 233.889 242.102 234.353V234.857H237.758V235.013C237.758 235.461 237.898 235.825 238.178 236.105C238.458 236.377 238.85 236.513 239.354 236.513C239.738 236.513 240.066 236.437 240.338 236.285C240.618 236.125 240.85 235.917 241.034 235.661L241.91 236.537C241.686 236.865 241.358 237.145 240.926 237.377C240.502 237.609 239.962 237.725 239.306 237.725ZM239.198 232.373C238.766 232.373 238.418 232.509 238.154 232.781C237.89 233.053 237.758 233.413 237.758 233.861V233.945H240.566V233.837C240.566 233.389 240.442 233.033 240.194 232.769C239.954 232.505 239.622 232.373 239.198 232.373Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M246.334 237.725C245.654 237.725 245.066 237.621 244.57 237.413C244.074 237.197 243.686 236.909 243.406 236.549L244.306 235.733C244.562 236.013 244.854 236.229 245.182 236.381C245.518 236.533 245.906 236.609 246.346 236.609C246.73 236.609 247.038 236.545 247.27 236.417C247.502 236.289 247.618 236.093 247.618 235.829C247.618 235.605 247.538 235.453 247.378 235.373C247.226 235.293 247.022 235.233 246.766 235.193L245.77 235.037C245.514 234.997 245.262 234.941 245.014 234.869C244.774 234.789 244.558 234.681 244.366 234.545C244.182 234.409 244.034 234.237 243.922 234.029C243.81 233.813 243.754 233.553 243.754 233.249C243.754 232.601 243.994 232.105 244.474 231.761C244.962 231.417 245.63 231.245 246.478 231.245C247.078 231.245 247.586 231.329 248.002 231.497C248.426 231.665 248.774 231.901 249.046 232.205L248.242 233.093C248.066 232.901 247.83 232.733 247.534 232.589C247.246 232.437 246.878 232.361 246.43 232.361C245.646 232.361 245.254 232.605 245.254 233.093C245.254 233.317 245.334 233.473 245.494 233.561C245.654 233.641 245.862 233.701 246.118 233.741L247.102 233.897C247.366 233.937 247.618 233.997 247.858 234.077C248.106 234.149 248.322 234.253 248.506 234.389C248.698 234.525 248.85 234.697 248.962 234.905C249.074 235.113 249.13 235.369 249.13 235.673C249.13 236.313 248.882 236.817 248.386 237.185C247.898 237.545 247.214 237.725 246.334 237.725Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M253.529 237.725C252.849 237.725 252.261 237.621 251.765 237.413C251.269 237.197 250.881 236.909 250.601 236.549L251.501 235.733C251.757 236.013 252.049 236.229 252.377 236.381C252.713 236.533 253.101 236.609 253.541 236.609C253.925 236.609 254.233 236.545 254.465 236.417C254.697 236.289 254.813 236.093 254.813 235.829C254.813 235.605 254.733 235.453 254.573 235.373C254.421 235.293 254.217 235.233 253.961 235.193L252.965 235.037C252.709 234.997 252.457 234.941 252.209 234.869C251.969 234.789 251.753 234.681 251.561 234.545C251.377 234.409 251.229 234.237 251.117 234.029C251.005 233.813 250.949 233.553 250.949 233.249C250.949 232.601 251.189 232.105 251.669 231.761C252.157 231.417 252.825 231.245 253.673 231.245C254.273 231.245 254.781 231.329 255.197 231.497C255.621 231.665 255.969 231.901 256.241 232.205L255.437 233.093C255.261 232.901 255.025 232.733 254.729 232.589C254.441 232.437 254.073 232.361 253.625 232.361C252.841 232.361 252.449 232.605 252.449 233.093C252.449 233.317 252.529 233.473 252.689 233.561C252.849 233.641 253.057 233.701 253.313 233.741L254.297 233.897C254.561 233.937 254.813 233.997 255.053 234.077C255.301 234.149 255.517 234.253 255.701 234.389C255.893 234.525 256.045 234.697 256.157 234.905C256.269 235.113 256.325 235.369 256.325 235.673C256.325 236.313 256.077 236.817 255.581 237.185C255.093 237.545 254.409 237.725 253.529 237.725Z",
      fill: "#CEE4F3"
    }), /* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip1_202_9308)",
      children: [/* @__PURE__ */ jsx("path", {
        d: "M185 298.581C180 295.581 134.134 277.812 132.467 275.197C132.77 271.35 133.315 270.043 128.01 267.889C121.948 265.581 109.064 262.889 104.214 267.504C104.214 269.043 104.214 270.581 104.214 272.12C98.9093 270.889 97.6968 269.504 98.1515 276.274C96.7874 289.966 116.34 285.812 125.282 287.658C132.709 288.735 181.514 318.581 185.151 305.197C185 302.889 185 300.735 185 298.581Z",
        fill: "#2E7DAF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M177.725 301.658C168.631 302.428 129.223 279.043 119.826 279.812C112.399 280.428 99.061 279.812 98 271.966C98.3031 271.197 99.9704 271.197 100.88 271.351C104.669 272.274 114.369 275.966 116.037 270.581C86.784 265.351 121.038 263.043 128.01 267.043C136.801 270.274 130.89 274.12 134.831 276.274L182.272 295.812C188.031 298.428 183.787 301.658 177.725 301.658Z",
        fill: "url(#paint28_radial_202_9308)"
      })]
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("radialGradient", {
        id: "paint0_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(116.081 148.041) rotate(86.1122) scale(86.7823 86.5379)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint1_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(343.129 67.5062) rotate(86.6736) scale(109.609 93.5934)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint2_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(210.761 154.049) rotate(83.6544) scale(107.91 174.736)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_202_9308",
        x1: "61.3493",
        y1: "136.605",
        x2: "96.5996",
        y2: "152.427",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_202_9308",
        x1: "366.344",
        y1: "54.0429",
        x2: "401.594",
        y2: "69.8649",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint5_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(230.464 51.3225) rotate(84.3253) scale(29.5131 42.8073)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint6_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(309.608 109.077) rotate(68.8162) scale(4.4329 22.0175)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint7_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(296.009 100.813) rotate(85.9687) scale(19.6275 20.2897)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint8_linear_202_9308",
        x1: "313.13",
        y1: "101.044",
        x2: "329.287",
        y2: "108.296",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint9_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(217.254 67.7106) rotate(84.026) scale(82.8994 126.493)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint10_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(234.867 43.0691) rotate(-35.2077) scale(5.06019 35.1383)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint11_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(171.722 100.813) rotate(85.9687) scale(19.6275 20.2898)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint12_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(164.295 112.704) rotate(-111.184) scale(4.43289 22.0175)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint13_linear_202_9308",
        x1: "136.921",
        y1: "101.044",
        x2: "153.077",
        y2: "108.296",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint14_linear_202_9308",
        x1: "225.23",
        y1: "6.22152",
        x2: "241.387",
        y2: "13.4733",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint15_linear_202_9308",
        x1: "201.606",
        y1: "83.3204",
        x2: "221.699",
        y2: "90.8845",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint16_linear_202_9308",
        x1: "241.876",
        y1: "83.3204",
        x2: "261.97",
        y2: "90.8845",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint17_linear_202_9308",
        x1: "243.69",
        y1: "230.844",
        x2: "254.754",
        y2: "220.587",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint18_linear_202_9308",
        x1: "250.69",
        y1: "230.844",
        x2: "261.754",
        y2: "220.587",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint19_linear_202_9308",
        x1: "257.69",
        y1: "230.844",
        x2: "268.754",
        y2: "220.587",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint20_linear_202_9308",
        x1: "264.69",
        y1: "230.844",
        x2: "275.754",
        y2: "220.587",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint21_linear_202_9308",
        x1: "271.69",
        y1: "230.844",
        x2: "282.754",
        y2: "220.587",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint22_linear_202_9308",
        x1: "278.69",
        y1: "230.844",
        x2: "289.754",
        y2: "220.587",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint23_linear_202_9308",
        x1: "285.69",
        y1: "230.844",
        x2: "296.754",
        y2: "220.587",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint24_linear_202_9308",
        x1: "292.69",
        y1: "230.844",
        x2: "303.754",
        y2: "220.587",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint25_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(370.336 189.305) rotate(88.6715) scale(109.454 37.397)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint26_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(431.048 157.424) rotate(88.6715) scale(109.454 37.397)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint27_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(44.3587 204.844) rotate(82.6607) scale(38.2261 71.3929)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint28_radial_202_9308",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(126.125 263.242) rotate(80.1872) scale(39.6057 98.0457)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00520833",
          stopColor: "#ECF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#CEE4F3"
        })]
      }), /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_202_9308",
        children: /* @__PURE__ */ jsx("rect", {
          width: "63",
          height: "40",
          fill: "white",
          transform: "translate(24 206.581)"
        })
      }), /* @__PURE__ */ jsx("clipPath", {
        id: "clip1_202_9308",
        children: /* @__PURE__ */ jsx("rect", {
          width: "87",
          height: "44",
          fill: "white",
          transform: "translate(98 264.581)"
        })
      })]
    })]
  });
};
const confirmed = (width = "491", height = "329") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 491 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M189.762 64.7126C181.111 72.8261 147.059 69.4147 133.438 54.9394C119.817 40.4641 131.966 20.4569 140.525 12.3434C149.176 4.22986 167.122 9.39301 180.743 23.7761C194.363 38.3436 198.321 56.599 189.762 64.7126Z",
      fill: "url(#paint0_linear_322_19075)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M90.1823 58.3506C92.7591 63.2372 87.1452 78.1735 79.0464 82.5068C70.9476 86.8402 63.4009 79.0033 60.824 74.2089C58.2471 69.3223 62.6647 61.8542 70.8555 57.5208C79.0464 53.1875 87.6054 53.4641 90.1823 58.3506Z",
      fill: "url(#paint1_linear_322_19075)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M403.553 187.338C403.553 260.913 345.112 333.935 211.942 319.091C122.947 309.133 60.181 246.438 60.181 172.77C60.181 123.167 78.5874 79.9258 120.738 74.6704C141.169 72.1811 165.006 77.3442 199.149 97.3514C298.544 155.714 403.553 113.763 403.553 187.338Z",
      fill: "url(#paint2_radial_322_19075)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M152.027 279.353C150.186 253.537 175.403 240.721 179.36 215.92C182.489 191.026 165.463 176.09 151.751 157.558C134.357 133.678 140.062 99.8409 159.941 79.1883C32.2009 40.5568 21.8013 259.714 158.469 305.076C154.696 297.055 152.763 288.388 152.027 279.353Z",
      fill: "url(#paint3_linear_322_19075)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M105.735 264.416C107.3 262.296 108.68 259.991 109.876 257.686C110.337 256.303 110.705 254.827 110.981 253.352C111.257 248.742 111.073 244.132 110.613 239.522C108.312 225.693 103.894 212.324 100.397 198.77C93.8629 173.784 91.8382 147.969 98.0964 122.706C101.41 109.429 107.484 97.4434 116.319 87.0249C120.46 82.1383 125.89 77.8972 131.504 74.9468C131.688 74.8546 131.872 74.7624 132.056 74.6702C49.8716 74.0248 35.6066 200.153 101.594 269.211C102.974 267.643 104.355 266.076 105.735 264.416Z",
      fill: "url(#paint4_linear_322_19075)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M353.67 139.302C349.897 141.699 346.123 144.004 342.258 146.217C336.368 149.628 330.386 152.671 324.864 156.543C319.71 160.876 314.74 165.671 310.415 170.834C308.666 173.323 307.194 175.905 305.813 178.579C305.077 180.884 304.433 183.096 303.973 185.494C303.696 189.182 303.788 192.869 304.157 196.65C305.721 205.593 308.39 214.352 311.335 222.926C315.108 233.898 319.434 244.685 321.551 256.21C324.68 273.175 325.232 289.955 320.998 306.92C320.998 307.012 320.906 307.104 320.906 307.197C377.782 284.516 403.643 236.664 403.643 187.522C403.551 155.621 383.948 145.295 353.67 139.302Z",
      fill: "url(#paint5_linear_322_19075)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M370.602 266.26C364.712 255.196 374.835 222.742 391.217 213.891C407.599 205.04 424.072 223.203 429.962 234.267C435.852 245.331 427.386 261.373 411.004 270.224C394.622 279.076 376.492 277.232 370.602 266.26Z",
      fill: "url(#paint6_linear_322_19075)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M367.84 112.354L226.203 228.708C214.975 237.931 196.752 237.931 185.525 228.708L155.706 204.212L117.697 172.988L117.237 173.366C110.979 178.507 110.979 186.824 117.237 191.965L155.614 223.491L185.432 247.987C196.66 257.21 214.883 257.21 226.111 247.987L368.3 131.331C374.558 126.19 374.558 117.873 368.3 112.732L367.84 112.354Z",
      fill: "#B7E803"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.16",
      d: "M367.84 112.354L226.203 228.708C214.975 237.931 196.752 237.931 185.525 228.708L155.706 204.212L117.697 172.988L117.237 173.366C110.979 178.507 110.979 186.824 117.237 191.965L155.614 223.491L185.432 247.987C196.66 257.21 214.883 257.21 226.111 247.987L368.3 131.331C374.558 126.19 374.558 117.873 368.3 112.732L367.84 112.354Z",
      fill: "url(#paint7_linear_322_19075)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M185.616 228.708C196.844 237.932 215.066 237.932 226.294 228.708L367.932 112.354L340.874 90.127C334.616 84.986 324.493 84.986 318.234 90.127L212.213 177.146C208.716 180.019 203.102 180.019 199.605 177.146L167.486 150.761C161.228 145.62 151.104 145.62 144.846 150.761L117.789 172.988L155.798 204.212L185.616 228.708Z",
      fill: "url(#paint8_linear_322_19075)"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_322_19075",
        x1: "127.29",
        y1: "38.7857",
        x2: "194.277",
        y2: "38.7857",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A4E9D9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.4009",
          stopColor: "#81D7CC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7779",
          stopColor: "#66C9C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#5CC4BF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_322_19075",
        x1: "60.086",
        y1: "69.064",
        x2: "90.8682",
        y2: "69.064",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A4E9D9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.4009",
          stopColor: "#81D7CC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7779",
          stopColor: "#66C9C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#5CC4BF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint2_radial_322_19075",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(219.08 258.377) scale(234.999 235.426)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5CC4BF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2221",
          stopColor: "#66C9C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5991",
          stopColor: "#81D7CC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E9D9"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_322_19075",
        x1: "57.8677",
        y1: "178.948",
        x2: "182.108",
        y2: "194.095",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A4E9D9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.4009",
          stopColor: "#81D7CC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7779",
          stopColor: "#66C9C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#5CC4BF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_322_19075",
        x1: "165.874",
        y1: "218.35",
        x2: "2.3236",
        y2: "64.2676",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A4E9D9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.4009",
          stopColor: "#81D7CC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7779",
          stopColor: "#66C9C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#5CC4BF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_322_19075",
        x1: "460.367",
        y1: "287.901",
        x2: "314.706",
        y2: "207.712",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A4E9D9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.4009",
          stopColor: "#81D7CC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7779",
          stopColor: "#66C9C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#5CC4BF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint6_linear_322_19075",
        x1: "368.892",
        y1: "243.683",
        x2: "431.876",
        y2: "243.683",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A4E9D9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.4009",
          stopColor: "#81D7CC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7779",
          stopColor: "#66C9C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#5CC4BF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint7_linear_322_19075",
        x1: "112.667",
        y1: "183.64",
        x2: "372.989",
        y2: "183.64",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#3BBFFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2913",
          stopColor: "#2F93F0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.6027",
          stopColor: "#256BE2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8498",
          stopColor: "#1E52D9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1C49D6"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint8_linear_322_19075",
        x1: "128.941",
        y1: "174.652",
        x2: "347.428",
        y2: "186.013",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#D5F364"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B7E803"
        })]
      })]
    })]
  });
};
const coinbaseLogo = (width = "120", height = "160") => {
  return /* @__PURE__ */ jsx("svg", {
    fill: "none",
    height,
    width,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2272.000000 1704.000000",
    children: /* @__PURE__ */ jsx("g", {
      transform: "translate(150.000000,1800.000000) scale(0.200000,-0.20000)",
      fill: "#ffffff",
      stroke: "none",
      children: /* @__PURE__ */ jsx("path", {
        d: "M4605 9995 c-11 -2 -116 -16 -233 -30 -267 -32 -469 -71 -698 -134 -947 -261 -1781 -782 -2427 -1516 -457 -520 -779 -1074 -993 -1710 -108 -323 -189 -683 -234 -1045 -16 -131 -24 -760 -12 -956 24 -378 120 -842 254 -1233 312 -908 867 -1690 1637 -2305 678 -541 1502 -895 2389 -1026 199 -29 391 -40 712 -40 321 0 513 11 712 40 887 131 1711 485 2389 1026 580 463 1015 992 1365 1659 182 348 357 847 438 1255 75 377 96 591 96 1020 0 423 -21 646 -96 1020 -119 600 -372 1207 -719 1730 -428 645 -976 1169 -1632 1561 -148 88 -541 282 -693 342 -341 135 -656 222 -1012 283 -304 51 -353 55 -798 59 -234 2 -434 2 -445 0z m955 -1518 c772 -134 1426 -475 1960 -1023 291 -299 471 -556 650 -928 175 -362 293 -777 334 -1167 l6 -56 -143 -6 c-78 -4 -478 -7 -888 -7 l-747 0 -22 98 c-99 433 -365 821 -730 1064 -221 147 -472 246 -722 283 -125 19 -382 19 -515 0 -481 -68 -921 -351 -1203 -772 -187 -280 -275 -557 -287 -899 -9 -274 20 -450 122 -719 65 -172 208 -396 344 -538 196 -204 390 -339 617 -429 231 -93 413 -128 664 -129 374 -2 705 104 1025 327 81 57 311 282 377 369 125 167 237 404 297 627 l36 138 745 0 c410 0 809 -3 888 -7 l143 -6 -6 -56 c-15 -126 -58 -364 -90 -493 -99 -397 -267 -776 -498 -1123 -188 -282 -507 -618 -793 -833 -376 -283 -817 -494 -1264 -606 -311 -77 -397 -88 -779 -93 -435 -7 -590 8 -918 88 -975 237 -1805 888 -2281 1789 -141 267 -264 608 -327 910 -53 251 -57 295 -62 638 -4 218 -1 371 6 444 47 446 172 861 380 1263 218 422 552 825 942 1139 101 81 360 254 484 323 357 198 770 336 1175 392 80 11 156 23 170 25 14 2 192 3 395 1 340 -3 382 -5 515 -28z"
      })
    })
  });
};
const cronosLogo = (width = "120", height = "160") => {
  return /* @__PURE__ */ jsxs("svg", {
    fill: "none",
    height,
    viewBox: "0,0,120,160",
    width,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M60.0166 23L59.975 23.0249V23L10 51.7417V109.258L59.975 138V137.975L60.0166 138L110 109.258V51.7583L60.0166 23ZM50.1448 115.29L24.8244 100.733V60.259L60.0166 40.0429V40.0594L95.1923 60.2839V100.741L60.0166 120.965L50.1448 115.298V115.29Z",
      fill: "url(#paint0_linear_15291_165803)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M59.9992 64.8326L73.6249 72.6788L83.3469 67.0862L59.9992 53.6475L36.6348 67.0862V93.9389L59.9992 107.353L83.3469 93.9389L73.6249 88.3297L59.9992 96.1759L46.3734 88.3297V72.6788L59.9992 64.8326Z",
      fill: "url(#paint1_linear_15291_165803)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M59.9958 22.0002C59.8168 21.9965 59.637 22.0408 59.4765 22.1331L9.50145 50.8749C9.19123 51.0533 9 51.3839 9 51.7417V109.258C9 109.616 9.19134 109.947 9.50169 110.125L59.4763 138.867C59.6369 138.959 59.8168 139.004 59.9959 139C60.1748 139.003 60.3545 138.959 60.5151 138.867L110.498 110.125C110.809 109.947 111 109.616 111 109.258V51.7583C111 51.4005 110.809 51.0699 110.499 50.8915L60.5154 22.1332C60.3547 22.0408 60.1748 21.9965 59.9958 22.0002ZM59.996 136.858L109 108.68V52.3366L59.9957 24.1417L11 52.3202V108.68L59.996 136.858ZM60.6545 39.2726C60.612 39.2375 60.5662 39.2056 60.5176 39.1774C60.2087 38.9986 59.828 38.998 59.5185 39.1758L24.3263 59.3919C24.0158 59.5702 23.8244 59.901 23.8244 60.259V100.733C23.8244 101.091 24.0157 101.421 24.326 101.6L49.5461 116.099C49.5782 116.123 49.6118 116.145 49.647 116.166L59.5188 121.833C59.8273 122.01 60.2067 122.01 60.5151 121.832L95.6907 101.608C96.001 101.43 96.1923 101.099 96.1923 100.741V60.2839C96.1923 59.926 96.001 59.5953 95.6907 59.4169L60.6545 39.2726ZM60.002 41.2045L25.8244 60.8378V100.154L50.6432 114.423C50.678 114.443 50.7113 114.465 50.743 114.489L60.0163 119.812L94.1923 100.162V60.8624L60.002 41.2045Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M59.5006 52.7806C59.8094 52.603 60.1893 52.6031 60.498 52.7808L83.8458 66.2195C84.1559 66.398 84.347 66.7286 84.3469 67.0863C84.3469 67.4441 84.1557 67.7746 83.8456 67.953L74.1236 73.5456C73.8147 73.7233 73.4347 73.7232 73.1259 73.5454L59.9992 65.9866L47.3734 73.2569V87.7516L59.9992 95.022L73.1259 87.4631C73.4351 87.2851 73.8157 87.2853 74.1247 87.4636L83.8467 93.0727C84.1565 93.2515 84.3473 93.5821 84.3469 93.9398C84.3466 94.2975 84.1553 94.6278 83.8451 94.806L60.4973 108.22C60.189 108.397 59.8097 108.397 59.5013 108.22L36.1369 94.8061C35.8263 94.6278 35.6348 94.297 35.6348 93.9389V67.0862C35.6348 66.7284 35.826 66.3978 36.1362 66.2194L59.5006 52.7806ZM37.6348 67.6647V93.3599L59.999 106.2L81.3427 93.937L73.6245 89.484L60.4982 97.0425C60.1893 97.2204 59.8091 97.2204 59.5002 97.0425L45.8744 89.1963C45.5644 89.0178 45.3734 88.6874 45.3734 88.3297V72.6788C45.3734 72.3211 45.5644 71.9907 45.8744 71.8122L59.5002 63.966C59.8091 63.7881 60.1893 63.7881 60.4982 63.966L73.6252 71.525L81.3419 67.086L59.999 54.8012L37.6348 67.6647Z",
      fill: "white"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_15291_165803",
        x1: "48.1043",
        y1: "96.0843",
        x2: "92.1822",
        y2: "62.5542",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.85"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_15291_165803",
        x1: "48.1043",
        y1: "96.0843",
        x2: "92.1822",
        y2: "62.5542",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.85"
        })]
      })]
    })]
  });
};
const cryptoLogo = (width = "120", height = "160") => {
  return /* @__PURE__ */ jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 120 160",
    fill: "none",
    children: [/* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip0_15291_165803)",
      children: [/* @__PURE__ */ jsx("path", {
        d: "M109.8 109.4V51.8L59.9 23L10 51.8V109.4L59.9 138.2L109.8 109.4Z",
        fill: "url(#paint0_linear_15291_165803)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M107.8 52.9549L59.9 25.3092L12 52.9549V108.245L59.9 135.891L107.8 108.245V52.9549ZM109.8 109.4V51.8L59.9 23L10 51.8V109.4L59.9 138.2L109.8 109.4Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M78.9461 115H72.1437L64 107.39V103.488L72.4311 95.2927V82.3171L83.4491 75L96 84.6585L78.9461 115Z",
        fill: "url(#paint1_linear_15291_165803)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M72.4311 95.2927L64 103.488V107.39L72.1437 115H78.9461L96 84.6585L83.4491 75L72.4311 82.3171V95.2927ZM74.4311 83.3897L83.3635 77.4577L93.4083 85.1877L77.776 113H72.9327L66 106.522V104.333L73.8251 96.7268C74.2126 96.3503 74.4311 95.833 74.4311 95.2927V83.3897Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M50.8346 94L52.063 81.8692L48 71H72L68.0315 81.8692L69.1654 94H59.9055H50.8346Z",
        fill: "url(#paint2_linear_15291_165803)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M52.063 81.8692L50.8346 94H69.1654L68.0315 81.8692L72 71H48L52.063 81.8692ZM50.8828 73L53.9364 81.1689C54.0439 81.4566 54.0838 81.7651 54.0528 82.0707L53.0474 92H66.9697L66.0402 82.0553C66.0126 81.7599 66.051 81.462 66.1528 81.1833L69.1406 73H50.8828Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M56 107.293L47.9048 115H41.0476L24 84.561L36.5714 75L47.6191 82.2195V95.1951L56 103.39V107.293Z",
        fill: "url(#paint3_linear_15291_165803)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M47.6191 95.1951V82.2195L36.5714 75L24 84.561L41.0476 115H47.9048L56 107.293V103.39L47.6191 95.1951ZM54 104.232L46.2208 96.6251C45.836 96.2488 45.6191 95.7333 45.6191 95.1951V83.3017L36.6588 77.4463L26.5945 85.1005L42.2198 113H47.1049L54 106.435V104.232Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M40.4486 49H78.4547L83 68H36L40.4486 49Z",
        fill: "url(#paint4_linear_15291_165803)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.0344 51L38.5224 66H80.4651L76.8768 51H42.0344ZM78.4547 49H40.4486L36 68H83L78.4547 49Z",
        fill: "white"
      })]
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_15291_165803",
        x1: "34.5045",
        y1: "114.029",
        x2: "128.952",
        y2: "42.4689",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.85"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_15291_165803",
        x1: "71.8571",
        y1: "106.607",
        x2: "103.859",
        y2: "84.2163",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.85"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_15291_165803",
        x1: "53.8929",
        y1: "89.1741",
        x2: "73.3987",
        y2: "71.3729",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.85"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_15291_165803",
        x1: "31.8571",
        y1: "106.607",
        x2: "63.8594",
        y2: "84.2163",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.85"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_15291_165803",
        x1: "47.5402",
        y1: "64.0134",
        x2: "59.8654",
        y2: "37.3485",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.85"
        })]
      }), /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_15291_165803",
        children: /* @__PURE__ */ jsx("rect", {
          width: "99.8",
          height: "115.2",
          fill: "white",
          transform: "translate(10 23)"
        })
      })]
    })]
  });
};
const discord = (width = "84", height = "84") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M60.9533 83H23.0467C10.8717 83 1 73.1283 1 60.9533V23.0467C1 10.8717 10.8717 1 23.0467 1H60.9533C73.1283 1 83 10.8717 83 23.0467V60.9533C83 73.1952 73.1302 83 60.9533 83Z",
      fill: "url(#paint0_radial_904_19971)",
      stroke: "url(#paint1_linear_904_19971)",
      strokeWidth: "2"
    }), /* @__PURE__ */ jsx("path", {
      d: "M64.2448 53.1068L59.963 53.4821C59.6382 53.2874 59.3187 53.0822 59.0061 52.87L63.2756 52.4841C63.5934 52.6999 63.9165 52.9086 64.2448 53.1068Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M64.2448 53.1068L59.963 53.4821C59.6382 53.2874 59.3187 53.0822 59.0061 52.87L63.2756 52.4841C63.5934 52.6999 63.9165 52.9086 64.2448 53.1068Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M63.8551 59.3981L59.5681 59.656C58.5393 58.506 57.6049 57.2742 56.7742 55.9727L61.0192 55.6394C61.8614 56.9675 62.8098 58.2246 63.8551 59.3981Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M63.8551 59.3981L59.5681 59.656C58.5393 58.506 57.6049 57.2742 56.7742 55.9727L61.0192 55.6394C61.8614 56.9675 62.8098 58.2246 63.8551 59.3981Z",
      fill: "#530591"
    }), /* @__PURE__ */ jsx("path", {
      d: "M63.8551 59.3981L59.5681 59.656C58.5393 58.506 57.6049 57.2742 56.7742 55.9727L61.0192 55.6394C61.8614 56.9675 62.8098 58.2246 63.8551 59.3981Z",
      fill: "url(#paint2_linear_904_19971)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M61.0175 55.6324L56.7742 55.9656C57.9126 55.2398 58.9808 54.4083 59.9645 53.482L64.2463 53.1067C63.252 54.0493 62.1709 54.895 61.0175 55.6324Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M61.0175 55.6324L56.7742 55.9656C57.9126 55.2398 58.9808 54.4083 59.9645 53.482L64.2463 53.1067C63.2525 54.0492 62.172 54.8949 61.0192 55.6324",
      fill: "#B251FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M59.0245 48.4731L54.8091 48.9308C59.6147 47.9451 58.3609 39.0525 53.4331 39.5682C54.5716 39.5138 58.0885 38.5614 59.145 39.0999C62.9256 40.4662 63.2783 47.5557 59.0245 48.4731Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M59.0242 48.4729L54.8088 48.9307C55.902 48.7641 56.7751 47.9976 57.2693 47.0311L61.5143 46.54C61.0132 47.517 60.1174 48.3028 59.0242 48.4694",
      fill: "#B251FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M61.5147 46.5404L57.2697 47.0315C58.8413 44.1866 57.1143 39.1843 53.428 39.5684C54.5683 39.5105 58.0834 38.5634 59.1399 39.1001C61.9024 40.1612 62.8157 44.0199 61.5095 46.5404",
      fill: "url(#paint3_linear_904_19971)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M58.8703 48.4924L54.6584 48.952C54.9571 48.9064 58.7621 48.5065 59.024 48.4731C58.9751 48.4819 58.9245 48.4872 58.8703 48.4924Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M58.8703 48.4924L54.6584 48.952C54.9571 48.9064 58.7621 48.5065 59.024 48.4731C58.9751 48.4819 58.9245 48.4872 58.8738 48.4924",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M53.6323 26.7239L49.499 27.5693C49.6911 26.6923 49.9426 25.7592 50.2202 24.9103L54.3605 24.0193C54.0776 24.884 53.8244 25.8346 53.6323 26.7239Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M53.6323 26.7239L49.499 27.5693C49.6911 26.6923 49.9426 25.7592 50.2202 24.9103L54.3605 24.0193C54.0794 24.884 53.8262 25.8346 53.6323 26.7239Z",
      fill: "#B251FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M42.5393 28.1551L46.5836 27.3132C44.8897 27.7307 41.6941 28.5129 39.9287 28.8269C40.7879 28.5626 41.6581 28.3387 42.5393 28.1551Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M43.9399 28.0028L39.9236 28.8359C41.572 28.2957 44.8497 27.6994 46.5784 27.3223C45.6925 27.5023 44.813 27.7292 43.9399 28.0028Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M45.0093 50.7266L40.9685 51.1545C45.9487 50.1636 44.66 41.0623 39.5715 41.6183C40.7363 41.5551 44.075 40.6396 45.1594 41.1763C49.0919 42.5479 49.3993 49.818 45.0093 50.7266Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M45.0085 50.7267L40.9678 51.1547C42.0854 50.9793 43.0021 50.1988 43.5242 49.2095L47.5964 48.75C47.0726 49.7533 46.1418 50.5531 45.0085 50.7267Z",
      fill: "#B251FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M47.5973 48.7504L43.5251 49.2099C45.1805 46.2896 43.3365 41.1996 39.5664 41.6188C40.7329 41.5539 44.0682 40.6436 45.1543 41.1768C47.9972 42.2291 48.9628 46.1791 47.599 48.7504",
      fill: "url(#paint4_linear_904_19971)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M44.841 50.7494L40.802 51.1756C40.8579 51.1756 40.9138 51.1633 40.9766 51.1545L45.0174 50.7266C44.9528 50.7353 44.9004 50.7441 44.841 50.7494Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M44.841 50.7494L40.802 51.1756C40.8579 51.1756 40.9138 51.1633 40.9766 51.1545L45.0174 50.7266C44.9615 50.7353 44.9056 50.7441 44.8428 50.7494",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M51.1267 57.2024C46.8118 57.6392 42.097 57.8742 37.9497 56.3816L41.9538 56.0483C44.9085 57.0246 48.0236 57.4165 51.1267 57.2024Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M51.1267 57.2024C46.8118 57.6392 42.097 57.8742 37.9497 56.3816L41.9538 56.0483C44.9085 57.0246 48.0236 57.4165 51.1267 57.2024Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M33.8694 29.809L29.9875 30.6193C33.6945 28.0114 37.9397 26.2775 42.4067 25.5469C39.3703 26.5444 36.4944 27.9801 33.8694 29.809Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M33.8694 29.809L29.9875 30.6193C33.6945 28.0114 37.9397 26.2775 42.4067 25.5469C39.3701 26.5455 36.4942 27.9824 33.8694 29.8125",
      fill: "url(#paint5_linear_904_19971)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M43.4309 62.992C37.8674 63.7585 32.3808 61.6853 27.5403 58.9754L31.4064 58.686C35.1166 60.8524 39.1931 62.3122 43.4309 62.992Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M43.4309 62.992C37.8674 63.7585 32.3808 61.6853 27.5403 58.9754L31.4064 58.686C35.1155 60.852 39.1908 62.3118 43.4274 62.992",
      fill: "#530591"
    }), /* @__PURE__ */ jsx("path", {
      d: "M43.4309 62.992C37.8674 63.7585 32.3808 61.6853 27.5403 58.9754L31.4064 58.686C35.1155 60.852 39.1908 62.3118 43.4274 62.992",
      fill: "url(#paint6_linear_904_19971)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M31.4089 58.686L27.5427 58.9754C25.2038 49.5126 26.0638 39.5373 29.9874 30.6192L33.8693 29.8088C29.8967 38.8975 29.0316 49.0515 31.4089 58.686Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M31.4089 58.686L27.5427 58.9754C25.2038 49.5126 26.0638 39.5373 29.9874 30.6192L33.8693 29.8088C29.8967 38.8975 29.0316 49.0515 31.4089 58.686Z",
      fill: "#B251FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M63.3116 25.9241C69.2389 33.2318 72.7066 42.2391 73.2161 51.6511C70.5885 54.7811 67.4172 57.406 63.8564 59.3984C62.8102 58.2227 61.8612 56.9632 61.0188 55.6326C62.1716 54.8952 63.2521 54.0495 64.2458 53.1069C63.9175 52.9087 63.5944 52.7 63.2766 52.4843C57.2993 57.1936 49.1322 58.4898 41.9535 56.0483C41.7003 56.3693 41.4296 56.685 41.1625 56.9902C42.4436 57.5683 43.7768 58.0223 45.1438 58.346C44.6929 59.9379 44.1202 61.4924 43.4308 62.9957C39.1942 62.3155 35.1189 60.8557 31.4098 58.6898C29.0316 49.0542 29.8968 38.8988 33.8702 29.8091C36.4952 27.9802 39.3711 26.5445 42.4075 25.547C42.9436 26.317 43.4849 27.1764 43.9407 28.0025C47.0774 27.0353 50.3533 26.6031 53.6322 26.7239C53.8261 25.8346 54.0793 24.884 54.3604 24.0193C57.42 24.2167 60.4351 24.8583 63.3116 25.9241ZM45.0094 50.7268C50.0542 49.7148 48.7428 40.4556 43.581 41.0186C38.4733 41.9868 39.8283 51.3091 45.0094 50.7268ZM59.0246 48.473C63.8895 47.4644 62.6183 38.4351 57.6276 38.9402C52.6998 39.9066 54.0199 49.0027 59.0246 48.473Z",
      fill: "url(#paint7_linear_904_19971)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M26.6438 22.1129L23.6064 22.6309C23.6336 22.5817 23.6561 22.5299 23.6735 22.4764C23.6924 22.422 23.7068 22.366 23.7165 22.3092C23.7265 22.2502 23.732 22.1905 23.733 22.1306C23.7331 22.0688 23.7289 22.007 23.7203 21.9457C23.7002 21.8127 23.6574 21.6842 23.5937 21.5658C23.5327 21.4533 23.4521 21.3525 23.3558 21.2681C23.2637 21.188 23.1566 21.1268 23.0407 21.0883C22.9261 21.0507 22.8046 21.0395 22.6851 21.0554L25.7136 20.5082C25.8348 20.4921 25.9582 20.5038 26.0743 20.5424C26.1915 20.5815 26.2995 20.644 26.3919 20.7261C26.4898 20.8119 26.5716 20.9143 26.6336 21.0288C26.6981 21.1514 26.7409 21.2842 26.7602 21.4214C26.7688 21.4835 26.773 21.5461 26.7729 21.6088C26.7719 21.6695 26.7664 21.7301 26.7564 21.7899C26.7469 21.848 26.7325 21.9052 26.7134 21.9609C26.6947 22.015 26.6719 22.0675 26.645 22.118",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M26.0335 22.5739L22.9961 23.0805C23.0601 23.0695 23.1226 23.0508 23.1821 23.0248C23.241 22.9983 23.2966 22.9652 23.3479 22.926C23.3995 22.8869 23.4462 22.8419 23.4871 22.7918C23.5304 22.7413 23.5678 22.6861 23.5985 22.6271L26.6359 22.1091C26.6044 22.1691 26.5667 22.2256 26.5232 22.2776C26.4812 22.3279 26.4342 22.3737 26.3828 22.4144C26.331 22.4535 26.275 22.4867 26.2157 22.5131C26.1551 22.5401 26.0913 22.5592 26.0259 22.5701",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M26.6438 22.1129L23.6064 22.6309C23.6336 22.5817 23.6561 22.5299 23.6735 22.4764C23.6924 22.422 23.7068 22.366 23.7165 22.3092C23.7265 22.2502 23.732 22.1905 23.733 22.1306C23.7331 22.0688 23.7289 22.007 23.7203 21.9457C23.7002 21.8127 23.6574 21.6842 23.5937 21.5658C23.5327 21.4533 23.4521 21.3525 23.3558 21.2681C23.2637 21.188 23.1566 21.1268 23.0407 21.0883C22.9261 21.0507 22.8046 21.0395 22.6851 21.0554L25.7136 20.5082C25.8348 20.4921 25.9582 20.5038 26.0743 20.5424C26.1915 20.5815 26.2995 20.644 26.3919 20.7261C26.4898 20.8119 26.5716 20.9143 26.6336 21.0288C26.6981 21.1514 26.7409 21.2842 26.7602 21.4214C26.7688 21.4835 26.773 21.5461 26.7729 21.6088C26.7719 21.6695 26.7664 21.7301 26.7564 21.7899C26.7469 21.848 26.7325 21.9052 26.7134 21.9609C26.6947 22.015 26.6719 22.0675 26.645 22.118",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M26.0332 22.574L22.9958 23.0806H22.9756L26.013 22.574H26.0332Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M26.6438 22.1129L23.6064 22.6309C23.6336 22.5817 23.6561 22.5299 23.6735 22.4764C23.6924 22.422 23.7068 22.366 23.7165 22.3092C23.7265 22.2502 23.732 22.1905 23.733 22.1306C23.7331 22.0688 23.7289 22.007 23.7203 21.9457C23.7002 21.8127 23.6574 21.6842 23.5937 21.5658C23.5327 21.4533 23.4521 21.3525 23.3558 21.2681C23.2637 21.188 23.1566 21.1268 23.0407 21.0883C22.9261 21.0507 22.8046 21.0395 22.6851 21.0554L25.7136 20.5082C25.8348 20.4921 25.9582 20.5038 26.0743 20.5424C26.1915 20.5815 26.2995 20.644 26.3919 20.7261C26.4898 20.8119 26.5716 20.9143 26.6336 21.0288C26.6981 21.1514 26.7409 21.2842 26.7602 21.4214C26.7688 21.4835 26.773 21.5461 26.7729 21.6088C26.7719 21.6695 26.7664 21.7301 26.7564 21.7899C26.7469 21.848 26.7325 21.9052 26.7134 21.9609C26.6947 22.015 26.6719 22.0675 26.645 22.118",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M26.6812 31.8994L23.6324 32.2451L23.6096 30.7608L26.6571 30.3884L26.6812 31.8994Z",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M23.4164 26.0783L20.4119 26.5292L20.3625 26.1923L23.3658 25.7351L23.4164 26.0783Z",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M22.786 27.0624L19.7866 27.4968C19.8429 27.4887 19.8979 27.4729 19.9499 27.4499C20.0017 27.4283 20.0506 27.4002 20.0954 27.3664C20.1419 27.3329 20.1844 27.2943 20.222 27.2511C20.2595 27.207 20.2921 27.159 20.3194 27.108L23.3226 26.6672C23.2953 26.7191 23.2627 26.7679 23.2252 26.8129C23.1875 26.8567 23.1451 26.8962 23.0986 26.9307C23.0531 26.9645 23.0039 26.993 22.9518 27.0155C22.8989 27.0384 22.8431 27.0541 22.786 27.0624Z",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M23.3196 26.6672L20.3164 27.1079C20.3383 27.067 20.3573 27.0247 20.3734 26.9813C20.3889 26.9349 20.4011 26.8875 20.4101 26.8394C20.4181 26.7896 20.4223 26.7392 20.4227 26.6887C20.4237 26.6366 20.4203 26.5845 20.4126 26.5329L23.4171 26.082C23.4248 26.1344 23.4282 26.1874 23.4272 26.2403C23.4271 26.2917 23.4224 26.343 23.4133 26.3936C23.4055 26.4428 23.3932 26.4911 23.3766 26.538C23.3617 26.584 23.3427 26.6285 23.3196 26.671",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M23.3661 25.7352L20.3629 26.1924C20.3456 26.079 20.3092 25.9694 20.2553 25.8682C20.2037 25.7725 20.1356 25.6868 20.0541 25.6149C19.9761 25.5484 19.8858 25.4981 19.7883 25.4667C19.6907 25.4354 19.5873 25.4267 19.4858 25.4414L22.4776 24.9702C22.5803 24.955 22.6851 24.9636 22.7839 24.9955C22.8827 25.0275 22.974 25.0792 23.0522 25.1475C23.1354 25.2184 23.2045 25.3044 23.256 25.4008C23.3121 25.5031 23.3494 25.6146 23.3661 25.7301",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M26.7729 38.7094L23.7179 38.9361C22.2648 36.5372 21.4501 35.1923 19.9971 32.7935L23.0003 32.4553L26.7729 38.7094Z",
      fill: "url(#paint8_linear_904_19971)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M22.1735 31.0863L19.1816 31.4498L23.6086 30.7608L26.6561 30.3884L22.1735 31.0863Z",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M23.0138 32.4806L20.0106 32.8188L19.1816 31.4497L22.1735 31.0862L23.0138 32.4806Z",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M26.0133 22.5776L22.9797 23.088L11.6604 24.6889L14.551 24.1975L26.0133 22.5776Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M25.7082 20.5032L22.6797 21.0503L11.3528 22.6107L14.237 22.08L25.7082 20.5032Z",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M14.2378 22.0864L11.3536 22.6158H11.3447H11.3169L14.2011 22.0864H14.21H14.2201H14.2378Z",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M14.9875 28.2214L12.0894 28.6406L19.7878 27.4969L22.786 27.0625L14.9875 28.2214Z",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M22.4771 24.9751L19.4853 25.4462L11.7817 26.562L14.6748 26.1036L22.4771 24.9751Z",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M14.988 28.2212L12.0898 28.6404C11.986 28.6561 11.8799 28.6479 11.7797 28.6164C11.6795 28.5854 11.5865 28.5346 11.5064 28.4669C11.4223 28.3959 11.352 28.31 11.2988 28.2136C11.2427 28.1118 11.2054 28.0007 11.1887 27.8856L14.0742 27.4512C14.0912 27.5689 14.1293 27.6827 14.1869 27.7868C14.2408 27.8834 14.312 27.9693 14.3969 28.0401C14.4779 28.1098 14.5722 28.1624 14.6741 28.1946C14.7756 28.2261 14.8829 28.2344 14.988 28.2187",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M14.0736 27.4511L11.1881 27.8855L11.1375 27.5423L14.023 27.1028L14.0736 27.4511Z",
      fill: "#031023"
    }), /* @__PURE__ */ jsx("path", {
      d: "M14.0229 27.103L11.1386 27.5424C11.1305 27.4901 11.1267 27.4371 11.1273 27.3841C11.1284 27.3332 11.1335 27.2823 11.1424 27.2322C11.1512 27.1831 11.1639 27.1348 11.1804 27.0878C11.1962 27.0419 11.2157 26.9975 11.2386 26.9548L14.1254 26.5039C14.1022 26.5475 14.0824 26.5928 14.0659 26.6394C14.0493 26.6873 14.0366 26.7364 14.0279 26.7863C14.0184 26.8377 14.0133 26.8898 14.0128 26.9421C14.0118 26.9959 14.0152 27.0497 14.0229 27.103Z",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M14.1251 26.504L11.2383 26.9549C11.2672 26.9035 11.3011 26.8551 11.3395 26.8105C11.377 26.7664 11.4195 26.7269 11.4661 26.6927C11.5119 26.6586 11.5616 26.6301 11.6142 26.6078C11.6681 26.5856 11.7247 26.5702 11.7825 26.5622L14.6756 26.1038C14.6172 26.1125 14.5602 26.1286 14.506 26.1519C14.4517 26.1736 14.4006 26.2025 14.3541 26.238C14.3075 26.2727 14.2651 26.3127 14.2276 26.3571C14.1888 26.4024 14.1549 26.4516 14.1263 26.504",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M22.4779 24.9751C22.5806 24.9598 22.6854 24.9685 22.7842 25.0004C22.883 25.0324 22.9743 25.0841 23.0525 25.1524C23.1357 25.2233 23.2048 25.3092 23.2562 25.4057C23.3124 25.508 23.3497 25.6195 23.3664 25.735L23.417 26.0782C23.434 26.1936 23.4306 26.3111 23.4068 26.4252C23.3833 26.5326 23.3405 26.6347 23.2803 26.7267C23.2271 26.8133 23.158 26.8889 23.0765 26.9496C22.9912 27.0088 22.8933 27.0474 22.7905 27.0623L14.9933 28.2212C14.8882 28.2368 14.781 28.2286 14.6795 28.1971C14.5776 28.1649 14.4833 28.1123 14.4023 28.0426C14.3174 27.9717 14.2461 27.8859 14.1922 27.7893C14.1347 27.6852 14.0965 27.5714 14.0796 27.4537L14.0277 27.1054C14.0104 26.9878 14.0143 26.8682 14.0391 26.752C14.0625 26.6435 14.1054 26.5401 14.1656 26.4468C14.2234 26.357 14.2987 26.2798 14.3871 26.2201C14.4754 26.161 14.5757 26.1221 14.6807 26.1061L22.4779 24.9751Z",
      fill: "#9B84EE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M14.5498 24.1974L11.6605 24.6888C11.5361 24.7065 11.4093 24.6956 11.2897 24.6571C11.1694 24.6194 11.0579 24.5578 10.9619 24.476C10.8599 24.3913 10.7741 24.2887 10.7088 24.1733C10.6417 24.0509 10.5967 23.9176 10.5759 23.7795C10.5673 23.7165 10.5631 23.653 10.5632 23.5895C10.5646 23.5279 10.5705 23.4665 10.581 23.4058C10.5923 23.3475 10.6075 23.2899 10.6265 23.2336C10.6462 23.1791 10.6699 23.1262 10.6974 23.0753L13.574 22.5535C13.5459 22.6052 13.5218 22.6589 13.5019 22.7143C13.4821 22.7717 13.4669 22.8306 13.4563 22.8904C13.4459 22.9519 13.44 23.0141 13.4386 23.0765C13.4379 23.1414 13.4421 23.2061 13.4513 23.2703C13.4715 23.4109 13.5174 23.5465 13.5867 23.6705C13.6514 23.7882 13.7372 23.893 13.8398 23.9796C13.9374 24.0621 14.05 24.1249 14.1714 24.1645C14.2939 24.2039 14.4236 24.2151 14.5511 24.1974",
      fill: "#7820BE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M13.5851 22.5538L10.7085 23.0756C10.7409 23.0166 10.779 22.961 10.8224 22.9097C10.8653 22.8601 10.9133 22.8151 10.9654 22.7754C11.0171 22.7351 11.0736 22.7015 11.1337 22.6754C11.1941 22.6483 11.2574 22.6284 11.3223 22.6158L14.2065 22.0864C14.1407 22.0988 14.0766 22.1188 14.0154 22.146C13.9552 22.1738 13.8979 22.2077 13.8446 22.2473C13.792 22.2883 13.7436 22.3346 13.7003 22.3853C13.6565 22.4376 13.6179 22.494 13.5851 22.5538Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M25.7085 20.5031C25.8297 20.487 25.9531 20.4987 26.0691 20.5373C26.1863 20.5764 26.2944 20.6389 26.3868 20.7209C26.4846 20.8067 26.5665 20.9092 26.6285 21.0236C26.6929 21.1463 26.7358 21.2791 26.7551 21.4163C26.7763 21.5546 26.7733 21.6956 26.7462 21.8329C26.7196 21.9592 26.6707 22.0797 26.6019 22.1888C26.5361 22.2924 26.45 22.3816 26.3488 22.451C26.2478 22.5186 26.1326 22.5619 26.0122 22.5777L14.5486 24.1975C14.4212 24.2153 14.2914 24.204 14.169 24.1646C14.048 24.1269 13.9355 24.0663 13.8374 23.986C13.7348 23.8995 13.649 23.7947 13.5843 23.677C13.515 23.553 13.4691 23.4174 13.4489 23.2768C13.4279 23.1361 13.4326 22.9928 13.4628 22.8538C13.4907 22.7239 13.5421 22.6003 13.6146 22.489C13.6834 22.3822 13.7734 22.2908 13.8792 22.2205C13.9843 22.1497 14.1042 22.1038 14.2297 22.0863L25.7085 20.5031Z",
      fill: "#9B84EE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M14.9526 33.756L12.0506 34.0765C11.7605 34.1086 11.4668 34.077 11.1901 33.984C10.9111 33.8906 10.6532 33.7434 10.4307 33.5509C10.1999 33.3505 10.007 33.1103 9.86121 32.8416C9.70541 32.5548 9.6017 32.2427 9.55493 31.9196L12.4227 31.5574C12.4706 31.8863 12.5755 32.2044 12.7328 32.4971C12.8809 32.7708 13.0768 33.0157 13.3112 33.2203C13.5331 33.4154 13.7911 33.5651 14.0705 33.6611C14.3509 33.7555 14.6484 33.7879 14.9425 33.756",
      fill: "url(#paint9_linear_904_19971)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M12.4271 31.5573L9.5593 31.9195L8.16211 22.4649L11.0046 21.9292L12.4271 31.5573Z",
      fill: "#B251FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M11.0045 21.9293L8.16206 22.4663C8.13947 22.3154 8.12932 22.1629 8.13168 22.0103C8.13393 21.8634 8.1479 21.7168 8.17345 21.5721C8.19922 21.4318 8.23604 21.2937 8.28355 21.1592C8.32942 21.0281 8.38615 20.901 8.45314 20.7793L11.2981 20.2131C11.2303 20.3348 11.1728 20.4619 11.126 20.5931C11.0776 20.7299 11.0408 20.8706 11.0159 21.0136C10.99 21.1612 10.9756 21.3107 10.9729 21.4607C10.9716 21.6157 10.9822 21.7707 11.0045 21.9242",
      fill: "url(#paint10_linear_904_19971)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M11.2993 20.2132L8.45435 20.7793C8.53056 20.6444 8.61955 20.5172 8.72011 20.3993C8.81996 20.2827 8.93149 20.1766 9.05296 20.0827C9.17323 19.9899 9.30356 19.9108 9.44149 19.8471C9.58183 19.7823 9.72919 19.7338 9.88064 19.7028L12.7434 19.1189C12.5902 19.1501 12.4411 19.199 12.2992 19.2645C12.1591 19.3299 12.0266 19.4107 11.9043 19.5052C11.7816 19.6005 11.6692 19.7083 11.5689 19.8269C11.4665 19.9482 11.3762 20.0793 11.2993 20.2182",
      fill: "#B9A6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M30.5132 28.7734L29.1401 19.4556C29.0929 19.1285 28.9888 18.8121 28.8325 18.5209C28.6868 18.2485 28.494 18.0041 28.263 17.799C28.0418 17.6032 27.7836 17.4538 27.5037 17.3595C27.2274 17.2664 26.9334 17.2378 26.6443 17.2759L12.8787 19.0896C12.5762 19.1291 12.2867 19.2369 12.032 19.4049C11.7805 19.5711 11.5653 19.7865 11.3993 20.0382C11.2252 20.3042 11.1016 20.6 11.0348 20.9108C10.9631 21.2439 10.9524 21.5872 11.0031 21.924L12.4256 31.5496C12.4742 31.8873 12.5836 32.2134 12.7484 32.5121C12.9023 32.7908 13.1066 33.0386 13.3508 33.2429C13.5834 33.439 13.8533 33.5859 14.1443 33.6748C14.4362 33.763 14.7443 33.7838 15.0454 33.7356L23.0185 32.4691L26.7911 38.7231L26.6848 31.8839L28.7616 31.5546C29.049 31.508 29.3221 31.3967 29.5602 31.2291C29.7987 31.0598 30.0009 30.8445 30.155 30.5959C30.3178 30.3343 30.4322 30.0456 30.4929 29.7435C30.5547 29.4236 30.5615 29.0955 30.5132 28.7734ZM14.9872 28.2212C14.8821 28.2368 14.7748 28.2286 14.6733 28.1971C14.5714 28.1649 14.4771 28.1123 14.3961 28.0426C14.3112 27.9717 14.24 27.8859 14.1861 27.7893C14.1285 27.6851 14.0903 27.5714 14.0734 27.4536L14.0215 27.1054C14.0043 26.9878 14.0081 26.8682 14.0329 26.752C14.0564 26.6434 14.0992 26.54 14.1595 26.4468C14.2172 26.357 14.2925 26.2798 14.3809 26.2201C14.4693 26.161 14.5695 26.122 14.6746 26.1061L22.4768 24.9776C22.5795 24.9624 22.6843 24.971 22.7831 25.0029C22.8819 25.0349 22.9732 25.0866 23.0514 25.1549C23.1346 25.2258 23.2037 25.3118 23.2551 25.4082C23.3113 25.5105 23.3486 25.622 23.3652 25.7375L23.4159 26.0807C23.4329 26.1961 23.4295 26.3136 23.4057 26.4278C23.3822 26.5351 23.3393 26.6373 23.2792 26.7292C23.2258 26.8149 23.1567 26.8897 23.0754 26.9496C22.9904 27.0085 22.893 27.0471 22.7907 27.0623L14.9872 28.2212ZM26.7456 21.8329C26.7189 21.9591 26.6701 22.0796 26.6013 22.1887C26.5355 22.2923 26.4494 22.3815 26.3482 22.4509C26.2472 22.5185 26.132 22.5618 26.0116 22.5776L14.548 24.1974C14.4206 24.2152 14.2908 24.2039 14.1683 24.1645C14.0474 24.1268 13.9348 24.0662 13.8368 23.9859C13.7341 23.8994 13.6483 23.7946 13.5836 23.6769C13.5144 23.5529 13.4685 23.4173 13.4482 23.2767C13.4273 23.136 13.432 22.9927 13.4621 22.8537C13.49 22.7238 13.5415 22.6002 13.614 22.4889C13.6828 22.3821 13.7728 22.2907 13.8785 22.2204C13.9837 22.1496 14.1035 22.1037 14.2291 22.0862L25.7002 20.5093C25.8215 20.4932 25.9448 20.5049 26.0609 20.5435C26.1781 20.5826 26.2862 20.6451 26.3786 20.7272C26.4764 20.813 26.5583 20.9155 26.6203 21.0299C26.6847 21.1525 26.7275 21.2853 26.7469 21.4225C26.7698 21.5584 26.7694 21.6971 26.7456 21.8329Z",
      fill: "url(#paint11_linear_904_19971)"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("radialGradient", {
        id: "paint0_radial_904_19971",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(24.0686 21.9525) scale(45.3023)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#DA3CFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#6900D2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_904_19971",
        x1: "42",
        y1: "0",
        x2: "42",
        y2: "84",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#CF68FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#6A01D3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_904_19971",
        x1: "59.7208",
        y1: "56.1519",
        x2: "60.5744",
        y2: "61.0562",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#530591"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B251FF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_904_19971",
        x1: "57.035",
        y1: "39.9689",
        x2: "59.7319",
        y2: "49.3803",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#530591"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.604167",
          stopColor: "#B251FF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_904_19971",
        x1: "43.1632",
        y1: "42.0562",
        x2: "45.9314",
        y2: "51.566",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#530591"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.604167",
          stopColor: "#B251FF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_904_19971",
        x1: "35.7915",
        y1: "26.6415",
        x2: "36.138",
        y2: "29.7641",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#B9A6FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B251FF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint6_linear_904_19971",
        x1: "34.153",
        y1: "59.256",
        x2: "34.6341",
        y2: "64.8341",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#530591"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B251FF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint7_linear_904_19971",
        x1: "39.4448",
        y1: "19.9982",
        x2: "73.3215",
        y2: "53.1523",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E8E6FF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint8_linear_904_19971",
        x1: "22.8168",
        y1: "33.2822",
        x2: "25.0196",
        y2: "40.7886",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#530591"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B251FF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint9_linear_904_19971",
        x1: "11.8011",
        y1: "31.8803",
        x2: "12.25",
        y2: "35.0001",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.0156501",
          stopColor: "#B251FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.942708",
          stopColor: "#530591"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint10_linear_904_19971",
        x1: "9.61133",
        y1: "20.6993",
        x2: "9.87295",
        y2: "22.0529",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#B9A6FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B251FF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint11_linear_904_19971",
        x1: "15.2156",
        y1: "15.0452",
        x2: "33.4529",
        y2: "29.7572",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E8E6FF"
        })]
      })]
    })]
  });
};
const documentation = (width = "84", height = "84") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M0 26.25C0 11.7525 11.7525 0 26.25 0H57.75C72.2475 0 84 11.7525 84 26.25V57.75C84 72.2475 72.2475 84 57.75 84H26.25C11.7525 84 0 72.2475 0 57.75V26.25Z",
      fill: "url(#paint0_radial_904_19919)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M26.25 1H57.75C71.6952 1 83 12.3048 83 26.25V57.75C83 71.6952 71.6952 83 57.75 83H26.25C12.3048 83 1 71.6952 1 57.75V26.25C1 12.3048 12.3048 1 26.25 1Z",
      stroke: "url(#paint1_linear_904_19919)",
      strokeWidth: "2"
    }), /* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip0_904_19919)",
      children: [/* @__PURE__ */ jsx("path", {
        d: "M72.8013 27.4177C72.8013 27.4177 72.6409 26.8557 68.7077 26.6954C64.7752 26.535 62.6883 26.3746 60.842 26.2136C58.9957 26.0532 61.9659 21.7992 66.2995 22.2008C70.633 22.6024 70.3931 21.9602 71.7302 23.1103C72.9848 24.1893 73.6033 25.0902 72.8001 27.4177H72.8013Z",
        fill: "#59AFFB"
      }), /* @__PURE__ */ jsx("path", {
        d: "M35.5064 17.2109C35.5064 17.2109 31.5337 20.4613 31.5337 26.3611C31.5337 32.2608 32.2561 44.4201 28.7646 53.0884C25.273 61.7568 21.8307 63.2428 19.9358 64.0441C15.762 65.8096 10.8264 66.4518 10.8264 66.4518C10.8264 66.4518 13.5956 68.3783 22.3842 70.0636C31.1728 71.7489 37.5678 76.8261 41.1656 77.1669C44.9779 77.5278 48.1079 77.5278 56.094 73.9166C67.1566 68.9135 66.8091 57.3023 66.0868 51.2828C65.3644 45.2633 62.8948 39.0586 63.5989 32.1806C64.1208 27.084 64.8431 23.8738 67.8529 22.7899C70.8626 21.7067 72.6154 24.0208 72.6154 24.0208C72.6154 24.0208 70.5819 20.0615 59.7064 19.8604C49.3479 19.669 46.8242 19.3786 42.1292 18.8975C37.4341 18.4157 35.5076 17.2122 35.5076 17.2122L35.5064 17.2109Z",
        fill: "url(#paint2_linear_904_19919)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M12.7914 68.6987C12.7914 68.6987 14.7938 68.9563 21.2993 70.4642C26.8376 71.7485 29.8874 72.6313 37.0309 75.6811C39.4385 76.9387 41.4987 77.206 41.4987 77.206C41.4987 77.206 39.0376 74.8785 39.3583 72.3901C39.6791 69.9016 44.5753 68.8584 46.1804 68.6981C38.7162 67.0929 32.8571 66.7716 23.8674 64.6045C14.8782 62.4374 12.631 60.1901 10.6243 62.1968C8.61758 64.2035 10.3837 67.6543 12.7914 68.6981V68.6987Z",
        fill: "url(#paint3_linear_904_19919)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M56.1073 24.1055L42.338 22.8704C42.3089 23.2792 42.2214 23.6851 42.1333 24.0909L55.6947 25.3813C55.8387 24.9566 56.0094 24.5393 56.1079 24.1055H56.1073Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M56.9477 24.1809C56.8499 24.6183 56.6908 25.0375 56.5498 25.4628L59.6653 25.7593L60.2272 24.475L56.9483 24.1809H56.9477Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M41.2796 23.9567C41.3513 23.5776 41.4515 23.1851 41.4849 22.7939L36.0681 22.3079L35.6265 23.4719L41.2699 24.009C41.2729 23.9913 41.2766 23.9743 41.2796 23.9567Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M47.0699 26.9633L35.0248 25.7585L34.9045 26.8418L46.8354 28.2118C46.8779 27.7926 46.966 27.3776 47.0699 26.9627V26.9633Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M47.9237 27.0486C47.8119 27.4623 47.7081 27.8833 47.6655 28.3074L59.024 29.6118L59.1042 28.1671L47.9231 27.0492L47.9237 27.0486Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M55.8125 34.182L58.8623 34.5076L58.742 32.9827L55.962 32.699C55.9133 33.1941 55.8392 33.6868 55.8125 34.182Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M50.1098 32.1014C50.0375 32.5875 49.9913 33.0771 50.0217 33.5632L54.9683 34.0911C55.0005 33.5978 55.0752 33.1057 55.1201 32.6124L50.1092 32.1008L50.1098 32.1014Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M49.2665 32.0155L41.0435 31.1765L41.1941 32.6212L49.1674 33.4724C49.1516 32.987 49.1966 32.5003 49.2665 32.0155Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M44.3855 35.5107L59.0733 37.3163V38.5205L44.3855 36.7143V35.5107Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M53.2016 41.6145L59.7952 42.3734L59.7047 40.9286L53.1323 40.1741C53.153 40.6546 53.1621 41.137 53.2016 41.6145Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M52.2791 40.0759L46.0701 39.3633L46.1904 40.808L52.3441 41.5158C52.3125 41.037 52.3034 40.5553 52.2791 40.0759Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M47.0637 43.6973L60.2169 45.0217L60.4575 46.5867L47.0941 45.2021L47.0637 43.6973Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M56.2126 49.2061L46.913 48.0317L46.5515 49.5366L56.2381 50.7128C56.2618 50.2098 56.2563 49.7067 56.212 49.2061H56.2126Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M57.0743 50.8146L61.4212 51.3425L61.2104 49.8377L57.064 49.314C57.098 49.8146 57.0986 50.3146 57.0743 50.8146Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M49.2072 52.8596L45.7096 52.4258L45.0474 53.6299L48.5589 54.0923C48.7898 53.6889 49.0085 53.2794 49.2072 52.8602V52.8596Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M50.0854 52.969C49.894 53.3918 49.6832 53.8044 49.4602 54.2108L61.0581 55.7369L61.2385 54.3524L50.0848 52.969H50.0854Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M43.2429 56.5193L60.579 58.4452L59.9769 59.6493L41.9185 57.4822L43.2429 56.5193Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M52.8175 61.1336L38.9073 59.5886L37.2117 60.6117L51.219 62.2727C51.7865 61.9586 52.312 61.5589 52.8169 61.133L52.8175 61.1336Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M53.955 61.26C53.4884 61.6658 53.0145 62.0662 52.5151 62.4271L57.5188 63.0207L58.9635 61.8165L53.955 61.26Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M46.3493 64.3919L37.1694 63.1057C36.3347 63.4405 35.5054 63.7953 34.6621 64.1039L44.0558 65.5103C44.7934 65.0917 45.5644 64.7284 46.3493 64.3925V64.3919Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M48.0141 64.6252C47.1575 64.9642 46.3033 65.3178 45.4771 65.7225L53.5646 66.9333L55.8921 65.7291L48.0141 64.6252Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M35.5006 62.8719L30.1185 62.1179L26.7576 62.9205L32.7327 63.8148C33.6798 63.5797 34.5936 63.237 35.5006 62.8719Z",
        fill: "#0070FF"
      }), /* @__PURE__ */ jsx("path", {
        d: "M29.487 61.9293C24.8029 61.9293 20.3988 60.1049 17.0859 56.7926C13.7737 53.4803 11.9492 49.0762 11.9492 44.3915C11.9492 39.7068 13.7737 35.3034 17.0859 31.9905C20.3982 28.6782 24.8023 26.8538 29.487 26.8538C34.1717 26.8538 38.5751 28.6782 41.888 31.9905C45.2003 35.3028 47.0247 39.7068 47.0247 44.3915C47.0247 49.0762 45.2003 53.4797 41.888 56.7926C38.5757 60.1055 34.1717 61.9293 29.487 61.9293Z",
        fill: "url(#paint4_linear_904_19919)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M29.4864 27.4924C31.7683 27.4924 33.9815 27.9389 36.0642 28.8198C38.0763 29.671 39.8837 30.8897 41.436 32.442C42.9883 33.9942 44.207 35.8017 45.0581 37.8138C45.9391 39.8965 46.3856 42.1097 46.3856 44.3916C46.3856 46.6735 45.9391 48.8868 45.0581 50.9694C44.207 52.9816 42.9883 54.789 41.436 56.3413C39.8837 57.8935 38.0763 59.1123 36.0642 59.9634C33.9815 60.8443 31.7683 61.2909 29.4864 61.2909C27.2044 61.2909 24.9912 60.8443 22.9086 59.9634C20.8964 59.1123 19.089 57.8935 17.5367 56.3413C15.9845 54.789 14.7657 52.9816 13.9146 50.9694C13.0336 48.8868 12.5871 46.6735 12.5871 44.3916C12.5871 42.1097 13.0336 39.8965 13.9146 37.8138C14.7657 35.8017 15.9845 33.9942 17.5367 32.442C19.089 30.8897 20.8964 29.671 22.9086 28.8198C24.9912 27.9389 27.2044 27.4924 29.4864 27.4924ZM29.4864 26.2166C19.4486 26.2166 11.3113 34.3539 11.3113 44.3916C11.3113 54.4294 19.4486 62.5667 29.4864 62.5667C39.5241 62.5667 47.6614 54.4294 47.6614 44.3916C47.6614 34.3539 39.5241 26.2166 29.4864 26.2166Z",
        fill: "#00397F"
      }), /* @__PURE__ */ jsx("path", {
        d: "M31.0514 39.644L46.3358 41.4855C46.1438 40.3792 45.769 39.1313 45.0715 37.61C45.0697 37.6064 45.0679 37.6027 45.0667 37.5991C43.3929 37.4034 38.6438 36.8482 31.4129 35.9921C31.6534 32.8621 31.1723 29.3706 31.1723 29.3706L38.7568 30.3335C38.7568 30.3335 39.1498 30.3584 39.7246 30.5407C39.0545 30.0693 38.3108 29.633 37.473 29.2187C33.6207 27.3147 32.3187 26.5923 26.6413 27.3153C26.6413 27.3153 28.4031 31.8986 25.7549 46.1052C24.1911 54.4916 17.9006 57.629 17.9006 57.629C17.9006 57.629 25.2464 63.7092 32.7015 61.468C35.6839 60.5713 37.789 59.5403 39.3358 58.5062C39.3358 58.5062 24.5908 55.6964 26.1164 55.9771C27.6419 56.2577 29.4876 51.8434 29.4876 50.1982C28.6048 49.9977 44.6037 52.7565 44.6037 52.7565C45.2422 51.604 45.7793 50.245 46.0995 48.8737C46.0995 48.8737 32.6176 46.8276 30.25 46.426C31.0125 43.3761 31.0526 39.644 31.0526 39.644H31.0514Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M29.4864 62.5674C39.5242 62.5674 47.6614 54.4302 47.6614 44.3924C47.6614 34.3545 39.5242 26.2173 29.4864 26.2173C19.4485 26.2173 11.3113 34.3545 11.3113 44.3924C11.3113 54.4302 19.4485 62.5674 29.4864 62.5674Z",
        stroke: "#00397F",
        strokeWidth: "0.711686",
        strokeMiterlimit: "10"
      }), /* @__PURE__ */ jsx("path", {
        d: "M29.6851 59.8736C38.2956 59.8736 45.2757 52.8935 45.2757 44.283C45.2757 35.6725 38.2956 28.6924 29.6851 28.6924C21.0746 28.6924 14.0945 35.6725 14.0945 44.283C14.0945 52.8935 21.0746 59.8736 29.6851 59.8736Z",
        fill: "url(#paint5_linear_904_19919)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M29.6851 59.8736C38.2956 59.8736 45.2757 52.8935 45.2757 44.283C45.2757 35.6725 38.2956 28.6924 29.6851 28.6924C21.0746 28.6924 14.0945 35.6725 14.0945 44.283C14.0945 52.8935 21.0746 59.8736 29.6851 59.8736Z",
        fill: "url(#paint6_radial_904_19919)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M18.6514 45.2629C19.7153 45.2629 20.5779 44.4004 20.5779 43.3364C20.5779 42.2724 19.7153 41.4099 18.6514 41.4099C17.5874 41.4099 16.7249 42.2724 16.7249 43.3364C16.7249 44.4004 17.5874 45.2629 18.6514 45.2629Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M21.9854 54.1356C23.9137 54.1356 25.4769 52.5724 25.4769 50.6441C25.4769 48.7158 23.9137 47.1526 21.9854 47.1526C20.0571 47.1526 18.4939 48.7158 18.4939 50.6441C18.4939 52.5724 20.0571 54.1356 21.9854 54.1356Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M20.5164 29.2506C21.6136 29.2506 22.5031 28.3612 22.5031 27.264C22.5031 26.1668 21.6136 25.2773 20.5164 25.2773C19.4192 25.2773 18.5298 26.1668 18.5298 27.264C18.5298 28.3612 19.4192 29.2506 20.5164 29.2506Z",
        fill: "#00397F"
      }), /* @__PURE__ */ jsx("path", {
        d: "M12.1496 24.6751C13.28 24.6751 14.1964 23.7587 14.1964 22.6283C14.1964 21.4979 13.28 20.5815 12.1496 20.5815C11.0192 20.5815 10.1028 21.4979 10.1028 22.6283C10.1028 23.7587 11.0192 24.6751 12.1496 24.6751Z",
        fill: "#00397F"
      }), /* @__PURE__ */ jsx("path", {
        d: "M39.3598 13.961C40.4902 13.961 41.4066 13.0446 41.4066 11.9142C41.4066 10.7838 40.4902 9.86743 39.3598 9.86743C38.2294 9.86743 37.313 10.7838 37.313 11.9142C37.313 13.0446 38.2294 13.961 39.3598 13.961Z",
        fill: "#00397F"
      }), /* @__PURE__ */ jsx("path", {
        d: "M19.4952 26.963L12.4721 23.3913C12.0645 23.1592 12.4363 22.5796 12.8737 22.7491L21.3015 26.2406L19.4959 26.963H19.4952Z",
        fill: "#00397F"
      }), /* @__PURE__ */ jsx("path", {
        d: "M12.7521 21.9059L38.8774 10.5894L39.72 13.1173L12.9532 22.9898C11.5175 23.4473 11.3717 22.494 12.7527 21.9066L12.7521 21.9059Z",
        fill: "#00397F"
      }), /* @__PURE__ */ jsx("path", {
        d: "M39.1181 11.6727L11.7893 6.73651C11.7893 6.73651 12.632 6.13505 15.762 4.93091C21.5409 6.49592 40.0811 11.0707 40.0811 11.0707L39.1181 11.6727Z",
        fill: "url(#paint7_linear_904_19919)"
      })]
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("radialGradient", {
        id: "paint0_radial_904_19919",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(19.7683 20.2907) scale(56.959 55.8519)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.15",
          stopColor: "#52E8FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.26",
          stopColor: "#4EE1FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#44CEFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.59",
          stopColor: "#33AFFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#1C84FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#004EFF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_904_19919",
        x1: "0",
        y1: "42",
        x2: "84",
        y2: "42",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#80E5FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.23",
          stopColor: "#7DDBFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.62",
          stopColor: "#74C2FB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#6BA3F8"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_904_19919",
        x1: "36.7409",
        y1: "77.2799",
        x2: "46.2282",
        y2: "16.2243",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#89C7FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.05",
          stopColor: "#9ACFFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2",
          stopColor: "#C5E3FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.33",
          stopColor: "#E5F2FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.44",
          stopColor: "#F8FBFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.72",
          stopColor: "#FDFEFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.79",
          stopColor: "#F6FAFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#EAF5FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.89",
          stopColor: "#D9ECFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.93",
          stopColor: "#C3E2FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.96",
          stopColor: "#A8D5FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#88C6FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#78BEFF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_904_19919",
        x1: "10.7276",
        y1: "69.3117",
        x2: "47.1555",
        y2: "69.3117",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#CFE8FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_904_19919",
        x1: "20.8721",
        y1: "32.1691",
        x2: "38.552",
        y2: "57.2531",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.08",
          stopColor: "#57FFFC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.22",
          stopColor: "#4FF5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#3CDCFC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#1CB3FE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#008EFF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_904_19919",
        x1: "22.4985",
        y1: "54.9465",
        x2: "37.7429",
        y2: "32.3255",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.27",
          stopColor: "white",
          stopOpacity: "0.56"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.62",
          stopColor: "white",
          stopOpacity: "0.26"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.87",
          stopColor: "white",
          stopOpacity: "0.07"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint6_radial_904_19919",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(27.145 47.0655) scale(19.9959)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.66",
          stopColor: "white",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7",
          stopColor: "white",
          stopOpacity: "0.07"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.77",
          stopColor: "white",
          stopOpacity: "0.26"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.87",
          stopColor: "white",
          stopOpacity: "0.56"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "white",
          stopOpacity: "0.97"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint7_linear_904_19919",
        x1: "35.3461",
        y1: "10.0612",
        x2: "14.9447",
        y2: "6.32696",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#00397F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#00397F",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_904_19919",
        children: /* @__PURE__ */ jsx("rect", {
          width: "63.408",
          height: "72.388",
          fill: "white",
          transform: "translate(9.75269 4.93091)"
        })
      })]
    })]
  });
};
const ethereumLogo = (width = "120", height = "160") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M60.6279 63.8676C60.6279 47.3579 60.6279 30.8482 60.6279 14.3385C60.5142 14.3385 60.5142 14.3385 60.4005 14.2255C59.8319 15.1301 59.2634 16.0347 58.6949 16.9394C54.6017 23.7242 50.5085 30.6221 46.3015 37.4069C42.4357 43.7393 38.5699 50.0718 34.704 56.4043C31.293 61.9452 27.9957 67.4861 24.5847 73.1401C22.9929 75.854 21.2873 78.568 19.6955 81.2819C19.4681 81.6211 19.2407 81.9604 19.2407 82.2996C19.6955 82.6388 20.0366 82.4127 20.3777 82.1865C27.1998 79.1334 33.9081 76.0802 40.7302 72.914C46.9837 70.087 53.1236 67.26 59.3771 64.433C59.9456 64.433 60.4005 64.3199 60.6279 63.8676Z",
      fill: "url(#paint0_linear_30_8567)",
      fillOpacity: "0.6"
    }), /* @__PURE__ */ jsx("path", {
      d: "M59.6272 145.783C59.6272 145.457 59.6272 145.021 59.6272 144.694C59.6272 134.783 59.6272 124.872 59.6272 114.961C59.6272 113.981 59.4152 113.327 58.4614 112.892C53.2682 109.842 48.1809 106.684 43.0937 103.525C38.6424 100.802 34.191 98.0796 29.7397 95.3568C26.9841 93.6142 24.1226 91.9805 21.367 90.2379C21.473 90.4557 21.367 90.2379 21.261 90.3468V90.4557C21.367 90.5646 21.367 90.7825 21.473 90.8914C34.0851 109.189 46.8031 127.486 59.4152 145.783C59.4152 145.783 59.5212 145.783 59.6272 145.783Z",
      fill: "url(#paint1_linear_30_8567)",
      fillOpacity: "0.6"
    }), /* @__PURE__ */ jsx("path", {
      d: "M60.3696 64.317C60.3696 48.4158 60.3696 32.5145 60.3696 16.6132C60.4756 16.6132 60.4756 16.6132 60.5816 16.5043C61.1115 17.3756 61.6414 18.2469 62.1714 19.1182C65.9868 25.653 69.8022 32.2967 73.7236 38.8314C77.3271 44.9305 80.9305 51.0297 84.534 57.1288C87.7135 62.4655 90.787 67.8022 93.9666 73.2479C95.4503 75.8618 97.0401 78.4757 98.5239 81.0896C98.7359 81.4163 98.9478 81.7431 98.9478 82.0698C98.5239 82.3966 98.2059 82.1787 97.888 81.9609C91.5289 79.0203 85.2759 76.0796 78.9168 73.0301C73.0877 70.3072 67.3646 67.5844 61.5355 64.8616C61.1115 64.8616 60.5816 64.7527 60.3696 64.317Z",
      fill: "url(#paint2_linear_30_8567)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M60.3697 64.3176C61.1116 64.6443 61.7475 64.8621 62.4894 65.1889C66.8348 67.2582 71.2861 69.3276 75.6314 71.288C77.7511 72.2682 79.9768 73.3573 82.0965 74.3375C85.17 75.7534 88.2435 77.1693 91.3171 78.5851C93.4368 79.5654 95.6624 80.6545 97.7821 81.6347C98.206 81.8525 98.524 82.0703 98.9479 82.0703C99.1599 82.3971 98.8419 82.506 98.63 82.6149C96.6163 83.813 94.6026 85.1199 92.4829 86.3179C89.1974 88.2784 85.9119 90.2388 82.7324 92.1992C79.0229 94.4864 75.3135 96.6647 71.604 98.9518C68.0006 101.13 64.3971 103.308 60.7937 105.487C60.1578 105.704 60.1578 105.269 60.0518 104.833C59.9458 104.289 59.9458 103.744 59.9458 103.199C59.9458 90.8923 59.9458 78.4762 59.9458 66.1691C60.0518 65.7334 59.8398 64.971 60.3697 64.3176Z",
      fill: "url(#paint3_linear_30_8567)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M60.3687 64.3176C60.3687 77.6049 60.3687 91.0012 60.3687 104.289C60.3687 104.724 60.0508 105.378 60.7927 105.596C60.4747 105.922 60.2627 105.813 59.9448 105.596C57.8251 104.289 55.8114 103.091 53.6917 101.784C50.7242 100.041 47.8626 98.1894 44.895 96.4468C40.6557 93.8329 36.5223 91.3279 32.2829 88.714C29.1034 86.7536 25.8179 84.7932 22.5324 82.8327C22.2145 82.6149 22.0025 82.506 21.7905 82.1793C22.1085 81.8525 22.5324 81.7436 22.8504 81.5258C27.1957 79.4564 31.647 77.3871 35.9924 75.4267C39.3839 73.9019 42.6694 72.2682 46.0609 70.7434C50.6182 68.5652 55.2815 66.3869 59.8388 64.3176C60.1567 64.4265 60.2627 64.4265 60.3687 64.3176Z",
      fill: "url(#paint4_linear_30_8567)",
      fillOpacity: "0.6"
    }), /* @__PURE__ */ jsx("path", {
      d: "M59.522 145.783C59.522 145.457 59.522 145.021 59.522 144.694C59.522 134.783 59.522 124.872 59.522 114.961C59.522 113.981 59.7339 113.327 60.6878 112.892C65.881 109.842 70.9683 106.684 76.0555 103.525C80.5068 100.802 84.9581 98.0796 89.4095 95.3568C92.1651 93.6142 95.0266 91.9805 97.7822 90.2379C97.6762 90.4557 97.7822 90.2379 97.8882 90.3468V90.4557C97.7822 90.5646 97.7822 90.7825 97.6762 90.8914C85.0641 109.189 72.346 127.486 59.7339 145.783C59.628 145.783 59.628 145.783 59.522 145.783Z",
      fill: "url(#paint5_linear_30_8567)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M60.4815 12.1895C60.9346 12.3668 61.2565 12.8174 61.2565 13.3453V62.5739C61.2565 62.7312 61.2273 62.887 61.1704 63.033C60.9591 63.5759 60.5939 63.9876 60.0985 64.2252C59.7771 64.3793 59.4496 64.4355 59.172 64.4546C56.2715 65.8366 53.3475 67.1928 50.43 68.5459L50.4268 68.5474C47.4318 69.9365 44.4436 71.3224 41.4829 72.735L41.4714 72.7405C38.1885 74.2641 34.9317 75.7877 31.673 77.3124L31.6712 77.3132L31.6697 77.3139C28.4198 78.8344 25.168 80.3559 21.8896 81.8774C21.8793 81.8829 21.8674 81.8892 21.8542 81.8964C21.7043 81.977 21.3699 82.1569 21.0384 82.2299C20.5052 82.3473 19.9658 82.2336 19.4815 81.8603C19.1785 81.6268 19.0002 81.2604 19.0002 80.8712C19.0002 80.4376 19.1392 80.0759 19.2597 79.8282C19.3726 79.5962 19.5137 79.3786 19.6105 79.2295C20.403 77.8724 21.1951 76.543 21.984 75.2188L21.9859 75.2157C22.7812 73.8807 23.5733 72.5512 24.3649 71.1954L24.374 71.18C26.393 67.8336 28.3654 64.4571 30.3521 61.0561C31.5968 58.9253 32.8471 56.785 34.118 54.6363C34.1183 54.6357 34.1187 54.6351 34.119 54.6345L45.2423 35.6923C45.2428 35.6914 45.2433 35.6905 45.2438 35.6897C47.2049 32.3128 49.1922 28.909 51.1788 25.5066C53.1661 22.1029 55.1527 18.7004 57.1125 15.3256C57.1342 15.2883 57.1578 15.2521 57.1832 15.2174C57.6066 14.6372 57.9652 14.0273 58.3441 13.3831C58.4979 13.1215 58.655 12.8543 58.8211 12.5811C59.0155 12.2616 59.341 12.0506 59.7052 12.0079C59.9791 11.9759 60.2525 12.0416 60.4815 12.1895ZM22.6759 78.7981C23.1293 78.0321 23.5831 77.2704 24.038 76.5068L24.0396 76.5042C24.832 75.1741 25.6277 73.8386 26.4238 72.4752C28.4472 69.1213 30.4371 65.7149 32.4311 62.3016C33.6745 60.1731 34.9195 58.0419 36.1752 55.9189L36.1772 55.9155L47.3055 36.9647L47.3086 36.9595C49.2682 33.585 51.2545 30.1831 53.2416 26.7797L53.2422 26.7786C55.1184 23.5652 56.9954 20.3504 58.8502 17.1583V61.9916C58.688 61.9967 58.5283 62.0356 58.3809 62.106C55.4202 63.5186 52.432 64.9045 49.437 66.2936L49.4331 66.2953C46.4432 67.6821 43.4465 69.072 40.4752 70.4895C37.1905 72.014 33.9325 73.5383 30.6764 75.0617L30.6742 75.0627C28.0119 76.3083 25.351 77.5533 22.6759 78.7981ZM60.0389 12.1089C60.035 12.1088 60.0333 12.1088 60.0334 12.1088L60.0389 12.1089Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.6935 88.5773C20.0786 88.2029 20.6569 88.1317 21.1172 88.402C24.0928 90.1493 26.961 91.8959 29.8199 93.6369C34.3802 96.3615 39.0474 99.1957 43.6097 102.03C48.9066 105.296 54.1946 108.557 59.4812 111.708C60.1057 112.066 60.5974 112.527 60.9032 113.156C61.1983 113.762 61.2554 114.396 61.2554 114.961V146.655C61.2554 146.983 61.1287 147.297 60.9031 147.529C60.8857 147.547 60.8398 147.594 60.7942 147.637C60.7461 147.681 60.6393 147.776 60.4844 147.856C60.3089 147.946 60.1457 147.979 60.023 147.992C59.9384 148.001 59.8548 148 59.8419 148L59.8404 148C59.4525 148 59.0884 147.808 58.8625 147.484C49.574 134.167 40.3375 120.794 31.1185 107.446C27.3032 101.923 23.4909 96.4031 19.6791 90.8936C19.5723 90.7594 19.5071 90.63 19.4681 90.5418C19.4355 90.4682 19.4099 90.3958 19.3941 90.3486C19.2755 90.1536 19.2112 89.9269 19.2112 89.6932V89.5843C19.2112 89.2564 19.3379 88.942 19.5636 88.7101C19.5814 88.6917 19.6 88.6737 19.6194 88.6559C19.6428 88.6288 19.6675 88.6025 19.6935 88.5773ZM24.1235 93.0514C27.11 97.3707 30.0965 101.695 33.0844 106.021C41.6502 118.422 50.2277 130.841 58.8492 143.218V114.961C58.8492 114.545 58.8004 114.363 58.751 114.261C58.7141 114.186 58.6266 114.049 58.3022 113.864L58.2829 113.852C52.976 110.689 47.6704 107.418 42.3739 104.152L42.3699 104.15L42.3664 104.148C37.816 101.32 33.1587 98.492 28.6063 95.7721L28.5976 95.7669C27.1091 94.8604 25.6231 93.9555 24.1235 93.0514Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M60.295 12.0079C60.6593 12.0506 60.9848 12.2616 61.1791 12.5811C61.3452 12.8543 61.5024 13.1215 61.6562 13.3831C62.035 14.0273 62.3937 14.6372 62.8171 15.2174C62.8425 15.2521 62.8661 15.2883 62.8877 15.3256C64.8476 18.7004 66.834 22.1027 68.8214 25.5064L68.822 25.5075C70.8083 28.9095 72.7955 32.313 74.7563 35.6895C74.7569 35.6905 74.7574 35.6914 74.7579 35.6923L85.8812 54.6345C85.8815 54.635 85.8818 54.6356 85.8821 54.6361C87.1531 56.7848 88.4035 58.9253 89.6482 61.0561C91.6349 64.4571 93.6072 67.8336 95.6262 71.18L95.6353 71.1954C96.427 72.5512 97.2191 73.8807 98.0144 75.2157L98.0155 75.2175C98.8046 76.5421 99.597 77.872 100.39 79.2295C100.487 79.3785 100.628 79.5962 100.74 79.8282C100.861 80.0759 101 80.4376 101 80.8712C101 81.2604 100.822 81.6268 100.519 81.8603C100.034 82.2336 99.495 82.3473 98.9619 82.2299C98.6304 82.1569 98.296 81.977 98.1461 81.8964C98.1328 81.8892 98.1209 81.8828 98.1107 81.8774C94.8323 80.3559 91.5805 78.8344 88.3306 77.3139L88.329 77.3132L88.3276 77.3125C85.0688 75.7878 81.8119 74.2641 78.5288 72.7404L78.5173 72.7351C75.5566 71.3225 72.5685 69.9365 69.5734 68.5474L69.5704 68.546C66.6502 67.1916 63.7234 65.8341 60.8202 64.4508C60.5676 64.4276 60.2773 64.3672 59.9813 64.2252C59.5441 64.0155 59.1851 63.6722 58.9152 63.21C58.803 63.0178 58.7438 62.798 58.7438 62.5739V13.3453C58.7438 12.8174 59.0657 12.3668 59.5188 12.1895C59.7478 12.0416 60.0211 11.9759 60.295 12.0079ZM59.9669 12.1088C59.967 12.1088 59.9653 12.1088 59.9613 12.1089L59.9669 12.1088ZM97.3243 78.7981C96.871 78.0321 96.4171 77.2704 95.9622 76.5068L95.9615 76.5055C95.1687 75.1749 94.3728 73.8389 93.5764 72.4751C91.553 69.1211 89.5631 65.7148 87.5691 62.3015C86.3257 60.173 85.0808 58.0418 83.8251 55.9189L83.823 55.9155L72.6917 36.9595C70.7318 33.5847 68.7454 30.1824 66.758 26.7786L66.7574 26.7775C64.8814 23.5645 63.0046 20.3501 61.15 17.1583V61.9916C61.3122 61.9967 61.4719 62.0356 61.6194 62.106C64.5801 63.5186 67.5682 64.9045 70.5633 66.2936L70.5673 66.2954C73.5571 67.6821 76.5538 69.072 79.525 70.4895C82.8097 72.014 86.0678 73.5383 89.3238 75.0617L89.3261 75.0627C91.9883 76.3083 94.6493 77.5533 97.3243 78.7981Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M59.0209 61.7827C59.3615 61.3627 59.9301 61.2224 60.4191 61.4378C60.7011 61.562 60.981 61.668 61.2864 61.7836C61.3442 61.8055 61.4028 61.8277 61.4626 61.8505C61.8131 61.9838 62.2019 62.1359 62.576 62.3259C64.8539 63.3605 67.1043 64.4216 69.3458 65.4785L69.3496 65.4802C71.603 66.5427 73.8475 67.601 76.1171 68.6316C76.1275 68.6363 76.1378 68.6412 76.1481 68.6462C77.2485 69.1847 78.3506 69.6971 79.4652 70.2152L79.4704 70.2177C80.5784 70.7328 81.6988 71.2536 82.8208 71.8026C85.0112 72.8529 87.1948 73.8483 89.3556 74.8332C90.3195 75.2726 91.279 75.71 92.2325 76.1492C92.2409 76.1531 92.2493 76.1571 92.2576 76.1612C93.3581 76.6997 94.4602 77.2121 95.5748 77.7302L95.5804 77.7328C96.6897 78.2485 97.8113 78.7699 98.9346 79.3196L98.9554 79.3301C99.1111 79.41 99.2484 79.4956 99.3471 79.5575L99.373 79.5737C99.4679 79.6333 99.5235 79.6682 99.5797 79.699C99.6334 79.7284 99.6597 79.7379 99.6707 79.7413C99.6779 79.7435 99.6813 79.7441 99.6892 79.7441C100.091 79.7441 100.467 79.9507 100.69 80.2947C100.83 80.5104 100.984 80.8438 100.96 81.2607C100.935 81.7008 100.725 82.0181 100.54 82.2087C100.372 82.3812 100.192 82.484 100.103 82.5326C100.052 82.5604 100.005 82.5839 99.9735 82.5991C99.9624 82.6046 99.9535 82.609 99.9461 82.6126C99.9456 82.6128 99.9451 82.6131 99.9447 82.6133C97.8438 83.9086 95.7339 85.2093 93.7268 86.4035C92.3939 87.2167 91.0745 88.0053 89.7667 88.7869C87.7107 90.0157 85.6836 91.2272 83.6784 92.4902L83.6559 92.504C81.7545 93.6439 79.8521 94.8114 77.9434 95.9828L77.9406 95.9845C76.0369 97.1529 74.1269 98.3251 72.216 99.4706C70.3582 100.616 68.5012 101.734 66.6506 102.848L66.6473 102.85C64.7917 103.967 62.9425 105.08 61.0941 106.219C61.0188 106.266 60.9388 106.303 60.8556 106.332C60.5842 106.425 60.2518 106.49 59.8946 106.43C59.5057 106.365 59.1882 106.167 58.9582 105.905C58.7511 105.668 58.6432 105.412 58.5837 105.243C58.5274 105.083 58.4878 104.92 58.464 104.822L58.46 104.805C58.4554 104.786 58.4512 104.767 58.4475 104.748C58.3179 104.082 58.318 103.433 58.3181 102.914L58.3181 64.6435C58.3181 64.5621 58.326 64.4809 58.3415 64.4011C58.3415 64.4011 58.3424 64.3963 58.3437 64.3856C58.345 64.3743 58.3466 64.3584 58.3481 64.3368C58.3513 64.2915 58.3533 64.2353 58.3548 64.1574C58.3553 64.1324 58.3557 64.1039 58.3562 64.0728C58.3582 63.935 58.361 63.744 58.3744 63.5584C58.4088 63.0816 58.5226 62.3973 59.0209 61.7827ZM98.9772 80.3473C98.9765 80.3477 98.9756 80.3481 98.9746 80.3486C98.9825 80.3439 98.9841 80.3435 98.9772 80.3473ZM97.39 81.3044C96.4589 80.8552 95.5254 80.4212 94.583 79.9831L94.578 79.9808C93.4727 79.4669 92.355 78.9474 91.2357 78.3998C90.3044 77.9709 89.3592 77.54 88.4048 77.105C86.2325 76.1147 84.0123 75.1027 81.799 74.0413L81.7905 74.0372C80.6901 73.4987 79.588 72.9863 78.4734 72.4681L78.4682 72.4657C77.3639 71.9523 76.2473 71.4332 75.129 70.8862C72.8479 69.8503 70.5945 68.7878 68.35 67.7295L68.3461 67.7277C66.0927 66.6652 63.8482 65.6069 61.5786 64.5764C61.5611 64.5685 61.5439 64.5601 61.5268 64.5513C61.3056 64.4377 61.0568 64.3348 60.7603 64.2203C60.7575 64.3557 60.7521 64.5454 60.7244 64.7451V102.872C60.7244 103.126 60.7251 103.352 60.7332 103.56C62.3007 102.6 63.867 101.657 65.4288 100.717L65.4312 100.716C67.2868 99.5991 69.1361 98.486 70.9844 97.3463L70.9972 97.3386C72.8987 96.1987 74.8011 95.0312 76.7097 93.8598L76.7118 93.8585C78.6142 92.691 80.5227 91.5197 82.4322 90.3749C84.4492 89.1048 86.5239 87.8646 88.6001 86.6235C89.9054 85.8432 91.2113 85.0626 92.5039 84.2739L92.5153 84.2669C94.0897 83.3303 95.7304 82.3261 97.39 81.3044Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M60.4076 61.432C60.8571 61.6234 61.1503 62.0742 61.1503 62.5743V103.852C61.1503 103.978 61.1392 104.092 61.1297 104.175C61.1288 104.182 61.1279 104.19 61.127 104.197C61.3027 104.343 61.4383 104.54 61.5125 104.768C61.6566 105.213 61.5441 105.702 61.2218 106.033C60.9194 106.344 60.4511 106.658 59.8274 106.594C59.3764 106.547 59.0167 106.299 58.8781 106.203C56.7657 104.901 54.665 103.606 52.4613 102.312C52.4521 102.306 52.4429 102.301 52.4338 102.295C50.9547 101.372 49.4485 100.449 47.9375 99.5229L47.9355 99.5216C46.4294 98.5984 44.9186 97.6723 43.4335 96.7458C41.2586 95.4374 39.0845 94.1024 36.9159 92.7707L36.9144 92.7698C34.7409 91.4351 32.5729 90.1038 30.4057 88.8001L30.3848 88.7873C27.1218 86.7321 23.7501 84.7829 20.3552 82.8205C20.3288 82.8053 20.3029 82.7889 20.2777 82.7717C20.2321 82.7405 20.1837 82.7111 20.1009 82.6611L20.0944 82.6573C20.0236 82.6146 19.9132 82.548 19.8047 82.4699C19.5639 82.2967 19.2289 81.9955 19.0618 81.4804C18.9177 81.0362 19.0302 80.5464 19.3524 80.2152C19.651 79.9084 19.9767 79.7282 20.195 79.6161C20.3003 79.5619 20.3726 79.5263 20.426 79.5C20.5119 79.4576 20.5488 79.4393 20.5956 79.4073C20.6466 79.3724 20.7001 79.3415 20.7556 79.315C25.3186 77.134 29.7752 75.0622 34.3369 72.9908C36.0875 72.1731 37.811 71.3829 39.5301 70.5947L39.532 70.5939C41.2548 69.804 42.9732 69.0161 44.7175 68.2013L44.7267 68.197C47.8156 66.7863 50.8977 65.333 53.9585 63.8896C55.6192 63.1066 57.2735 62.3264 58.9194 61.5577C59.0757 61.4846 59.2455 61.4468 59.4172 61.4468C59.4301 61.4468 59.4421 61.4468 59.4533 61.4468C59.7503 61.3096 60.0953 61.2991 60.4076 61.432ZM58.744 103.238V64.3569C57.4983 64.9411 56.2434 65.5329 54.9822 66.1276C51.9133 67.5747 48.8076 69.0392 45.7086 70.4546C43.9576 71.2725 42.2336 72.0629 40.5139 72.8513L40.5124 72.852C38.7895 73.6419 37.0711 74.4298 35.3268 75.2446L35.3152 75.25C31.0033 77.2079 26.7871 79.1655 22.4862 81.2154C25.5567 82.9916 28.6365 84.7863 31.6318 86.6724C33.8056 87.9802 35.9787 89.3146 38.1463 90.6457L38.1487 90.6472C40.3221 91.9818 42.4901 93.3131 44.6573 94.6168L44.6739 94.627C46.153 95.5498 47.6592 96.4731 49.1702 97.3993L49.1725 97.4007C50.6767 98.3227 52.1856 99.2476 53.669 100.173C55.411 101.196 57.0876 102.219 58.744 103.238ZM21.1797 80.4406C21.1797 80.4406 21.1801 80.4409 21.1809 80.4415L21.1797 80.4406Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.08 88.4044L99.4788 89.4754L98.8738 88.4068C99.2464 88.184 99.7065 88.1831 100.08 88.4044ZM99.6063 89.7006L100.726 90.0842C100.742 90.0341 100.756 89.983 100.765 89.9312L99.6043 89.6972C100.765 89.9312 100.765 89.9314 100.765 89.9312L100.766 89.9298L100.767 89.9252L100.768 89.9185L100.77 89.9031C100.772 89.892 100.774 89.8788 100.777 89.8639C100.781 89.8352 100.786 89.795 100.789 89.7473L100.79 89.7435C100.794 89.6892 100.811 89.4558 100.726 89.1933C100.602 88.8121 100.339 88.5949 100.286 88.5506L100.281 88.5471C100.231 88.5056 100.187 88.4737 100.155 88.4522C100.139 88.441 100.124 88.4314 100.111 88.4236L100.094 88.4129L100.087 88.4084L100.083 88.4064L100.082 88.4054L100.08 88.4044C100.08 88.4043 100.08 88.4044 99.4788 89.4754L98.8738 88.4068L97.9176 88.9789C97.3262 89.333 96.5078 89.8234 95.5999 90.3682C93.7868 91.4561 91.6136 92.7634 90.1791 93.637C85.6188 96.3616 80.9516 99.1957 76.3894 102.03C71.0925 105.296 65.8045 108.557 60.5179 111.708C59.8934 112.066 59.4017 112.527 59.0959 113.156C58.8008 113.762 58.7437 114.396 58.7437 114.961V146.655C58.7437 146.983 58.8704 147.297 59.096 147.529C59.296 147.734 59.5163 147.856 59.7121 147.923C59.8079 147.956 59.8956 147.975 59.9704 147.986C60.0079 147.991 60.0426 147.995 60.074 147.997C60.0897 147.998 60.1046 147.999 60.1188 147.999L60.1394 148L60.1492 148L60.154 148L60.1564 148L60.1576 148C60.1582 148 60.1588 148 60.1587 146.764L60.1588 148C60.5466 148 60.9107 147.808 61.1366 147.484C70.4248 134.167 79.661 120.795 88.8797 107.448C92.6951 101.924 96.5075 96.404 100.319 90.8944C100.41 90.7813 100.47 90.6749 100.502 90.6153C100.554 90.5196 100.595 90.4272 100.624 90.3572C100.655 90.2848 100.679 90.2197 100.695 90.1734C100.704 90.1498 100.711 90.1298 100.716 90.1147L100.722 90.0956L100.725 90.0889L100.725 90.0863L100.726 90.0852L100.726 90.0842C100.726 90.0841 100.726 90.0842 99.6063 89.7006ZM95.8576 93.0773C92.8771 97.388 89.8966 101.703 86.9146 106.021C78.3489 118.422 69.7714 130.841 61.1499 143.218V114.961C61.1499 114.545 61.1987 114.363 61.2481 114.261C61.285 114.186 61.3725 114.049 61.6969 113.864L61.7162 113.852C67.0231 110.689 72.3287 107.418 77.6252 104.152L77.6292 104.15L77.6327 104.148C82.1831 101.32 86.8404 98.492 91.3928 95.7721L91.4015 95.7669C92.5848 95.0463 94.2787 94.0258 95.8576 93.0773Z",
      fill: "white"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_30_8567",
        x1: "39.9343",
        y1: "14.2255",
        x2: "39.9343",
        y2: "82.4726",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#F2F6FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#F2F6FF",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_30_8567",
        x1: "40.4441",
        y1: "90.2379",
        x2: "40.4441",
        y2: "145.783",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#F2F6FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#F2F6FF",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_30_8567",
        x1: "79.6587",
        y1: "16.5043",
        x2: "79.6587",
        y2: "82.2364",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_30_8567",
        x1: "79.4818",
        y1: "64.3176",
        x2: "79.4818",
        y2: "105.545",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_30_8567",
        x1: "41.2916",
        y1: "64.3176",
        x2: "41.2916",
        y2: "105.802",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#F2F6FF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#F2F6FF",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_30_8567",
        x1: "78.7051",
        y1: "90.2379",
        x2: "78.7051",
        y2: "145.783",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      })]
    })]
  });
};
const fantomLogo = (width = "120", height = "160") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M26 42.1622L59.6 24.0001L93.2 42.1622V80.0001V117.838L59.6 136L26 117.838V80.0001V42.1622Z",
      fill: "url(#paint0_linear_9446_42744)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M57.6979 23.323C58.8848 22.6815 60.3152 22.6815 61.5021 23.323L91.5531 39.5668C93.4918 40.6148 94.7 42.6412 94.7 44.8451V115.155C94.7 117.359 93.4918 119.385 91.5531 120.433L62.4531 136.163C60.6728 137.125 58.5272 137.125 56.7469 136.163L27.6469 120.433C25.7082 119.385 24.5 117.359 24.5 115.155V44.8451C24.5 42.6412 25.7082 40.6148 27.6469 39.5668L57.6979 23.323ZM27.5 44.6781V77.3834L56.5423 60.3766L27.5 44.6781ZM58.1 62.941L28.9684 80L58.1 97.059V62.941ZM61.1 97.059L90.2316 80L61.1 62.941V97.059ZM59.6 58.6192L90.0455 42.1622L59.6 25.7051L29.1545 42.1622L59.6 58.6192ZM91.7 44.6781L62.6577 60.3766L91.7 77.3834V44.6781ZM91.7 82.6166L62.6319 99.6385C60.7594 100.735 58.4406 100.735 56.5681 99.6385L27.5 82.6166V114.559C27.5 116.028 28.3054 117.379 29.5979 118.078L57.6979 133.267C58.8848 133.908 60.3152 133.908 61.5021 133.267L89.6021 118.078C90.8945 117.379 91.7 116.028 91.7 114.559V82.6166Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("defs", {
      children: /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_9446_42744",
        x1: "42.5",
        y1: "112.5",
        x2: "120.99",
        y2: "71.3123",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.85"
        })]
      })
    })]
  });
};
const lazyNft = (width = "289", height = "398") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 289 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M279.639 225.452C282.949 198.296 278.132 170.769 265.798 146.35C253.464 121.932 234.167 101.718 210.346 88.2667C186.525 74.8148 159.25 68.7283 131.97 70.7767C104.69 72.8251 78.63 82.9164 57.0849 99.7746C35.5398 116.633 19.4772 139.501 10.9281 165.488C2.3789 191.474 1.72709 219.412 9.05506 245.769C16.383 272.126 31.3617 295.719 52.0972 313.563C72.8326 331.408 98.3937 342.704 125.548 346.022C143.583 348.226 161.876 346.855 179.381 341.988C196.886 337.121 213.261 328.854 227.57 317.657C241.879 306.461 253.843 292.555 262.777 276.734C271.711 260.913 277.441 243.487 279.639 225.452Z",
      fill: "#FF6CD0"
    }), /* @__PURE__ */ jsx("path", {
      d: "M83.8893 133.126L104.349 130.392L118.053 123.186C118.053 123.186 135.199 126.403 117.796 110.318C107.148 100.506 99.7165 101.665 83.1172 89.3115C70.5391 79.9181 65.5529 73.8703 58.6365 74.1599C52.1061 85.9981 79.4499 122.51 83.8893 133.126Z",
      fill: "url(#paint0_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M55.4196 165.392C55.4196 165.392 42.0694 152.138 45.7689 120.162C47.3096 104.65 51.2038 89.4639 57.3176 75.125C57.477 74.8147 57.7261 74.5596 58.0326 74.3929C58.339 74.2262 58.6885 74.1556 59.0356 74.1903C59.3827 74.225 59.7114 74.3634 59.9787 74.5875C60.246 74.8116 60.4397 75.111 60.5345 75.4467C63.3011 85.8695 86.7846 101.986 99.5557 123.7L55.4196 165.392Z",
      fill: "url(#paint1_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M226.174 74.192C219.225 73.9024 214.271 79.9502 201.661 89.3436C185.094 101.697 177.662 100.667 167.014 110.318C149.45 126.403 166.628 123.186 166.628 123.186L180.3 130.456L200.792 133.19C205.231 122.51 232.575 85.9981 226.174 74.192Z",
      fill: "url(#paint2_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M185.094 123.668C197.961 102.018 221.348 85.9017 224.115 75.4146C224.21 75.0789 224.403 74.7795 224.671 74.5554C224.938 74.3313 225.267 74.1929 225.614 74.1582C225.961 74.1234 226.31 74.194 226.617 74.3608C226.923 74.5275 227.172 74.7826 227.332 75.0929C233.432 89.4362 237.326 104.621 238.88 120.13C242.58 152.106 229.23 165.36 229.23 165.36L185.094 123.668Z",
      fill: "url(#paint3_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M232.414 252.603C274.234 204.349 204.91 105.493 143.306 107.552C119.983 105.847 65.1991 127.979 47.7634 180.158C-1.77711 294.262 186.702 308.03 232.414 252.603Z",
      fill: "url(#paint4_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M183.549 186.302C196.697 186.302 207.355 176.926 207.355 165.359C207.355 153.793 196.697 144.417 183.549 144.417C170.402 144.417 159.744 153.793 159.744 165.359C159.744 176.926 170.402 186.302 183.549 186.302Z",
      fill: "url(#paint5_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M101.1 186.302C114.247 186.302 124.905 176.926 124.905 165.359C124.905 153.793 114.247 144.417 101.1 144.417C87.9526 144.417 77.2946 153.793 77.2946 165.359C77.2946 176.926 87.9526 186.302 101.1 186.302Z",
      fill: "url(#paint6_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M150.544 209.335C148.922 209.412 147.326 208.91 146.04 207.92C144.976 206.995 144.317 205.69 144.206 204.284V196.886C144.206 196.752 144.233 196.62 144.285 196.496C144.337 196.373 144.414 196.262 144.51 196.169C144.606 196.076 144.72 196.003 144.844 195.955C144.969 195.907 145.102 195.884 145.236 195.888C145.503 195.888 145.761 195.992 145.953 196.178C146.145 196.365 146.257 196.618 146.265 196.886V204.252C146.352 205.079 146.756 205.84 147.391 206.375C148.076 206.826 148.847 207.13 149.656 207.268C150.464 207.407 151.292 207.376 152.088 207.18C153.847 206.902 155.437 205.975 156.545 204.581C157.653 203.187 158.198 201.428 158.071 199.652C158.063 199.384 158.158 199.124 158.339 198.926C158.519 198.727 158.769 198.607 159.036 198.591C159.173 198.565 159.314 198.572 159.447 198.61C159.581 198.648 159.704 198.716 159.807 198.81C159.91 198.903 159.989 199.019 160.04 199.148C160.09 199.278 160.11 199.417 160.098 199.556C160.269 201.842 159.568 204.109 158.135 205.899C156.703 207.69 154.646 208.871 152.377 209.206C151.77 209.295 151.157 209.338 150.544 209.335Z",
      fill: "#051140"
    }), /* @__PURE__ */ jsx("path", {
      d: "M138.963 209.335C138.363 209.382 137.761 209.382 137.162 209.335C134.887 209.007 132.822 207.829 131.383 206.037C129.944 204.246 129.239 201.975 129.409 199.684C129.425 199.417 129.546 199.166 129.744 198.986C129.942 198.806 130.203 198.71 130.47 198.719C130.741 198.735 130.994 198.854 131.18 199.052C131.365 199.249 131.468 199.51 131.468 199.781C131.349 201.555 131.896 203.31 133.003 204.702C134.109 206.095 135.695 207.024 137.451 207.308C138.247 207.503 139.075 207.532 139.883 207.394C140.691 207.255 141.462 206.953 142.148 206.504C142.791 205.96 143.195 205.187 143.274 204.349V196.885C143.274 196.612 143.382 196.351 143.575 196.157C143.768 195.964 144.03 195.856 144.303 195.856C144.576 195.856 144.838 195.964 145.031 196.157C145.224 196.351 145.333 196.612 145.333 196.885V204.252C145.289 204.952 145.108 205.637 144.799 206.266C144.49 206.895 144.059 207.457 143.531 207.919C142.228 208.925 140.606 209.427 138.963 209.335Z",
      fill: "#051140"
    }), /* @__PURE__ */ jsx("path", {
      d: "M156.656 190.741C155.787 188.296 154.147 187.717 144.593 187.717C135.038 187.717 133.43 188.296 132.561 190.741C131.693 193.186 133.88 195.245 144.593 197.818C155.273 195.245 157.364 192.928 156.656 190.741Z",
      fill: "url(#paint7_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M146.973 192.06C148.807 192.06 150.19 191.417 150.19 190.613C150.19 189.808 148.71 189.165 146.973 189.165C145.236 189.165 143.756 189.808 143.756 190.613C143.756 191.417 145.139 192.06 146.973 192.06Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M101.711 178.131C93.4651 178.428 85.3746 175.833 78.8388 170.796C78.7206 170.693 78.6238 170.567 78.5541 170.426C78.4845 170.285 78.4432 170.132 78.4328 169.975C78.4223 169.818 78.4428 169.661 78.4932 169.512C78.5436 169.363 78.6227 169.226 78.7262 169.107C78.8297 168.989 78.9555 168.892 79.0964 168.823C79.2373 168.753 79.3905 168.712 79.5474 168.701C79.7042 168.691 79.8616 168.711 80.0104 168.762C80.1593 168.812 80.2968 168.891 80.4151 168.995C86.5232 173.63 94.0487 176.006 101.711 175.718C109.374 176.012 116.902 173.635 123.007 168.995C123.246 168.786 123.558 168.68 123.875 168.701C124.192 168.722 124.487 168.869 124.696 169.107C124.905 169.346 125.011 169.658 124.989 169.975C124.968 170.292 124.822 170.587 124.583 170.796C118.048 175.833 109.957 178.428 101.711 178.131Z",
      fill: "#051140"
    }), /* @__PURE__ */ jsx("path", {
      d: "M183.035 178.131C174.789 178.427 166.698 175.833 160.162 170.796C160.049 170.685 159.958 170.553 159.896 170.406C159.835 170.26 159.803 170.103 159.803 169.944C159.803 169.785 159.835 169.628 159.896 169.481C159.958 169.335 160.049 169.202 160.162 169.091C160.391 168.869 160.696 168.745 161.015 168.745C161.333 168.745 161.639 168.869 161.867 169.091C167.973 173.732 175.5 176.108 183.163 175.815C190.826 176.103 198.351 173.727 204.459 169.091C204.698 168.882 205.01 168.777 205.327 168.798C205.644 168.819 205.939 168.965 206.148 169.204C206.357 169.443 206.463 169.755 206.442 170.072C206.421 170.388 206.274 170.684 206.036 170.893C199.452 175.924 191.313 178.485 183.035 178.131Z",
      fill: "#051140"
    }), /* @__PURE__ */ jsx("path", {
      d: "M142.727 152.653C158.521 152.653 171.325 139.849 171.325 124.054C171.325 108.26 158.521 95.4561 142.727 95.4561C126.932 95.4561 114.128 108.26 114.128 124.054C114.128 139.849 126.932 152.653 142.727 152.653Z",
      fill: "url(#paint8_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M141.15 138.659C152.095 138.659 160.967 129.787 160.967 118.843C160.967 107.899 152.095 99.0267 141.15 99.0267C130.206 99.0267 121.334 107.899 121.334 118.843C121.334 129.787 130.206 138.659 141.15 138.659Z",
      fill: "url(#paint9_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M141.15 124.891C150.673 124.891 158.393 117.171 158.393 107.648C158.393 98.1251 150.673 90.4053 141.15 90.4053C131.628 90.4053 123.908 98.1251 123.908 107.648C123.908 117.171 131.628 124.891 141.15 124.891Z",
      fill: "url(#paint10_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M141.15 112.28C149.252 112.28 155.819 105.713 155.819 97.6113C155.819 89.5097 149.252 82.9421 141.15 82.9421C133.049 82.9421 126.481 89.5097 126.481 97.6113C126.481 105.713 133.049 112.28 141.15 112.28Z",
      fill: "url(#paint11_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M141.151 100.828C147.831 100.828 153.246 95.413 153.246 88.7328C153.246 82.0526 147.831 76.6372 141.151 76.6372C134.47 76.6372 129.055 82.0526 129.055 88.7328C129.055 95.413 134.47 100.828 141.151 100.828Z",
      fill: "url(#paint12_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M141.15 87.0598C146.409 87.0598 150.673 82.7966 150.673 77.5377C150.673 72.2788 146.409 68.0156 141.15 68.0156C135.892 68.0156 131.628 72.2788 131.628 77.5377C131.628 82.7966 135.892 87.0598 141.15 87.0598Z",
      fill: "url(#paint13_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M141.15 75.8971C144.988 75.8971 148.099 72.7861 148.099 68.9485C148.099 65.111 144.988 62 141.15 62C137.313 62 134.202 65.111 134.202 68.9485C134.202 72.7861 137.313 75.8971 141.15 75.8971Z",
      fill: "url(#paint14_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M142.534 245.654C179.11 245.654 208.77 253.889 208.77 264.055C208.77 274.22 179.11 282.455 142.534 282.455C105.957 282.455 76.3296 274.381 76.3296 264.055C76.3296 253.728 105.99 245.654 142.534 245.654Z",
      fill: "url(#paint15_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M238.012 251.895H237.98C236.612 251.895 235.503 253.004 235.503 254.372V320.898C235.503 322.266 236.612 323.375 237.98 323.375H238.012C239.38 323.375 240.489 322.266 240.489 320.898V254.372C240.489 253.004 239.38 251.895 238.012 251.895Z",
      fill: "url(#paint16_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M246.054 256.013C246.355 253.975 245.893 251.898 244.758 250.179C243.622 248.461 241.892 247.222 239.9 246.7C237.907 246.178 235.792 246.41 233.96 247.35C232.127 248.291 230.707 249.875 229.97 251.798C229.748 252.274 229.617 252.787 229.584 253.31C229.283 255.348 229.744 257.425 230.88 259.143C232.016 260.862 233.746 262.101 235.738 262.623C237.731 263.145 239.846 262.913 241.678 261.973C243.51 261.032 244.931 259.448 245.668 257.525C245.89 257.049 246.021 256.536 246.054 256.013Z",
      fill: "url(#paint17_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.25",
      d: "M103.287 260.966H185.351V291.012C185.834 292.91 181.845 323.825 173.384 325.272C154.179 327.998 134.685 327.998 115.48 325.272C107.051 323.825 103.062 292.91 103.513 291.012L103.287 260.966Z",
      fill: "url(#paint18_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.25",
      d: "M109.464 238.995H179.11V290.176C179.496 291.785 176.118 322.345 168.945 323.632C152.609 325.948 136.029 325.948 119.694 323.632C112.52 322.41 109.142 291.785 109.528 290.176L109.464 238.995Z",
      fill: "url(#paint19_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.6",
      d: "M142.96 297.394C200.311 296.821 246.723 288.391 246.625 278.566C246.526 268.741 199.955 261.242 142.605 261.815C85.2542 262.389 38.8422 270.818 38.9404 280.643C39.0387 290.468 85.61 297.968 142.96 297.394Z",
      fill: "url(#paint20_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.6",
      d: "M142.379 316.805C188.499 316.443 225.837 309.755 225.775 301.867C225.713 293.978 188.275 287.878 142.154 288.24C96.0339 288.602 58.696 295.29 58.758 303.178C58.8199 311.066 96.2582 317.167 142.379 316.805Z",
      fill: "url(#paint21_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.6",
      d: "M142.344 328.804C176.384 328.536 203.941 323.596 203.896 317.768C203.85 311.941 176.218 307.434 142.179 307.701C108.139 307.969 80.5815 312.909 80.6272 318.736C80.673 324.564 108.305 329.071 142.344 328.804Z",
      fill: "url(#paint22_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.7",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.7",
        d: "M118.246 332.896H167.014V259.068H118.246V332.896Z",
        fill: "url(#paint23_linear_9907_50791)"
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M200.181 330.58L200.406 351.844H190.466C188.536 352.327 186.412 352.809 184.032 353.26C157.687 357.226 130.912 357.432 104.51 353.871C102.033 353.485 99.8773 353.034 98.0759 352.584H88.1034L87.8782 331.32C87.8782 328.875 93.3148 326.366 104.285 324.404C130.639 320.427 157.424 320.21 183.839 323.76C194.648 325.851 200.149 328.103 200.181 330.58Z",
      fill: "url(#paint24_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M88.1999 331.61L88.4251 352.713H87.9104L87.6852 331.449C87.6852 329.262 92.0924 327.01 100.875 325.176C92.4141 327.074 88.1677 329.358 88.1999 331.61Z",
      fill: "#DEFCF2"
    }), /* @__PURE__ */ jsx("path", {
      d: "M199.537 351.844L199.28 330.773C199.28 328.296 193.779 325.884 182.745 324.082C156.342 320.521 129.568 320.727 103.223 324.694L100.006 325.337C101.261 325.047 102.612 324.79 104.027 324.533C130.381 320.555 157.167 320.339 183.582 323.889C194.583 325.691 200.084 328.103 200.117 330.58L200.342 351.844H199.537Z",
      fill: "#DEFCF2"
    }), /* @__PURE__ */ jsx("path", {
      d: "M144.921 361.585C175.995 361.274 201.142 356.716 201.089 351.404C201.036 346.092 175.802 342.037 144.729 342.348C113.655 342.659 88.5078 347.217 88.5609 352.529C88.614 357.841 113.847 361.896 144.921 361.585Z",
      fill: "url(#paint25_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M105.957 359.308C119.327 361.221 132.826 362.082 146.33 361.881C132.345 362.204 118.358 361.375 104.51 359.404C87.3637 356.605 83.4069 352.23 93.1542 348.66C84.6937 352.295 89.0043 356.541 105.957 359.308Z",
      fill: "#DEFCF2"
    }), /* @__PURE__ */ jsx("path", {
      d: "M184 358.793C178.177 359.822 171.357 360.594 164.119 361.141C170.553 360.594 176.73 359.887 182.038 358.922C203.945 354.997 203.913 348.885 182.038 345.314C162.263 342.633 142.261 342.051 122.364 343.577C142.874 341.888 163.507 342.416 183.903 345.153C205.875 348.756 205.939 354.804 184 358.793Z",
      fill: "#DEFCF2"
    }), /* @__PURE__ */ jsx("path", {
      d: "M54.4868 240.475C54.4868 239.231 53.4858 238.223 52.251 238.223C51.0162 238.223 50.0153 239.231 50.0153 240.475V300.245C50.0153 301.489 51.0162 302.497 52.251 302.497C53.4858 302.497 54.4868 301.489 54.4868 300.245V240.475Z",
      fill: "url(#paint26_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M59.5373 241.922C59.8094 240.088 59.3949 238.218 58.3731 236.67C57.3514 235.122 55.7943 234.006 54.0005 233.536C52.2068 233.066 50.3025 233.274 48.6528 234.121C47.0031 234.968 45.7242 236.394 45.0612 238.126C44.8457 238.545 44.7249 239.006 44.7073 239.477C44.4352 241.312 44.8497 243.182 45.8715 244.729C46.8932 246.277 48.4503 247.393 50.2441 247.863C52.0378 248.334 53.9421 248.125 55.5918 247.278C57.2415 246.431 58.5204 245.005 59.1834 243.273C59.3799 242.847 59.4997 242.39 59.5373 241.922Z",
      fill: "url(#paint27_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M256.22 200.585C256.22 199.714 255.514 199.008 254.643 199.008C253.773 199.008 253.067 199.714 253.067 200.585V242.887C253.067 243.758 253.773 244.463 254.643 244.463C255.514 244.463 256.22 243.758 256.22 242.887V200.585Z",
      fill: "url(#paint28_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M259.79 201.614C259.89 200.373 259.551 199.137 258.832 198.121C258.113 197.105 257.059 196.374 255.856 196.056C254.653 195.738 253.376 195.853 252.249 196.381C251.121 196.909 250.215 197.816 249.689 198.944C249.526 199.228 249.437 199.549 249.432 199.877C249.275 201.158 249.588 202.452 250.312 203.52C251.035 204.588 252.121 205.358 253.369 205.688C254.616 206.018 255.941 205.884 257.098 205.313C258.255 204.741 259.165 203.77 259.662 202.579C259.753 202.266 259.797 201.94 259.79 201.614Z",
      fill: "url(#paint29_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.7",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.7",
        d: "M35.0243 180.962C35.0243 179.665 33.9801 178.613 32.692 178.613C31.4039 178.613 30.3597 179.665 30.3597 180.962V243.37C30.3597 244.667 31.4039 245.718 32.692 245.718C33.9801 245.718 35.0243 244.667 35.0243 243.37V180.962Z",
        fill: "url(#paint30_linear_9907_50791)"
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M41.0721 182.313C41.3729 180.275 40.9113 178.198 39.7756 176.48C38.64 174.761 36.9101 173.522 34.9176 173C32.9251 172.478 30.81 172.71 28.9777 173.651C27.1453 174.591 25.7245 176.175 24.9875 178.099C24.7623 178.562 24.631 179.065 24.6015 179.578C24.3007 181.616 24.7623 183.693 25.898 185.412C27.0336 187.13 28.7635 188.369 30.756 188.891C32.7485 189.413 34.8636 189.181 36.6959 188.241C38.5283 187.3 39.9491 185.716 40.6861 183.793C40.9039 183.327 41.0348 182.826 41.0721 182.313Z",
      fill: "url(#paint31_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M15.7551 237.258H15.7229C14.8701 237.258 14.1788 237.949 14.1788 238.802V280.429C14.1788 281.282 14.8701 281.973 15.7229 281.973H15.7551C16.6079 281.973 17.2992 281.282 17.2992 280.429V238.802C17.2992 237.949 16.6079 237.258 15.7551 237.258Z",
      fill: "url(#paint32_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M23.2182 240.539C23.4561 238.723 23.0237 236.882 22.0019 235.362C20.9802 233.842 19.4392 232.746 17.6677 232.281C15.8962 231.815 14.0157 232.012 12.3786 232.833C10.7415 233.655 9.45998 235.045 8.77424 236.743C8.57775 237.169 8.45796 237.627 8.42038 238.094C8.14825 239.929 8.5628 241.799 9.58455 243.346C10.6063 244.894 12.1633 246.01 13.9571 246.48C15.7509 246.951 17.6552 246.742 19.3049 245.895C20.9545 245.048 22.2335 243.622 22.8965 241.89C23.1008 241.469 23.2106 241.007 23.2182 240.539Z",
      fill: "url(#paint33_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M272.915 238.03C272.915 237.053 272.123 236.261 271.146 236.261C270.169 236.261 269.377 237.053 269.377 238.03V285.126C269.377 286.103 270.169 286.895 271.146 286.895C272.123 286.895 272.915 286.103 272.915 285.126V238.03Z",
      fill: "url(#paint34_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M276.84 239.188C277.063 237.742 276.742 236.264 275.94 235.04C275.137 233.816 273.909 232.933 272.494 232.561C271.079 232.19 269.576 232.355 268.275 233.027C266.975 233.698 265.969 234.827 265.452 236.196C265.295 236.531 265.197 236.89 265.163 237.258C264.977 238.693 265.321 240.146 266.13 241.346C266.939 242.546 268.157 243.41 269.557 243.777C270.957 244.143 272.442 243.987 273.735 243.338C275.028 242.689 276.041 241.591 276.583 240.25C276.747 239.92 276.835 239.557 276.84 239.188Z",
      fill: "url(#paint35_radial_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M219.129 148.31L228.425 137.855H219.45V133.512H235.535V137.244L226.206 147.699H235.503V152.138H219.129V148.31Z",
      fill: "url(#paint36_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M254.901 96.0029L274.202 74.2566H255.544V65.2814H289V73.002L269.699 94.7483H289V103.884H254.901V96.0029Z",
      fill: "url(#paint37_linear_9907_50791)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M241.486 132.29L255.705 116.205H241.969V109.643H266.546V115.369L252.359 131.454H266.546V137.984H241.486V132.29Z",
      fill: "url(#paint38_linear_9907_50791)"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_9907_50791",
        x1: "84.7257",
        y1: "107.101",
        x2: "95.8884",
        y2: "93.1075",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#9EAAEA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.14",
          stopColor: "#8192DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.3",
          stopColor: "#5066C9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.44",
          stopColor: "#233EB4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.52",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_9907_50791",
        x1: "94.3122",
        y1: "117.138",
        x2: "56.256",
        y2: "119.84",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2525C6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#4D91EE"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_9907_50791",
        x1: "190.176",
        y1: "115.143",
        x2: "175.7",
        y2: "100.667",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#9EAAEA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.14",
          stopColor: "#8192DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.3",
          stopColor: "#5066C9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.44",
          stopColor: "#233EB4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.52",
          stopColor: "#0D2AAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_9907_50791",
        x1: "195.002",
        y1: "111.926",
        x2: "230.388",
        y2: "116.752",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2525C6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#4D91EE"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint4_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(143.53 200.391) rotate(90) scale(86.8568 127.839)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#B2E5F5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.251083",
          stopColor: "#A2D5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#66AFF9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#4593E3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.91",
          stopColor: "#3389E2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#9CFFFC"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint5_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(179.914 171.973) scale(17.7895 25.4391)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#65AEF8",
          stopOpacity: "0.5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.26",
          stopColor: "#6BB2F9",
          stopOpacity: "0.33"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.58",
          stopColor: "#72B6F9",
          stopOpacity: "0.15"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.83",
          stopColor: "#76B9FA",
          stopOpacity: "0.04"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#77BAFA",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint6_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(67244.9 -190.063) rotate(180) scale(263.285 331.217)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#65AEF8",
          stopOpacity: "0.5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.26",
          stopColor: "#6BB2F9",
          stopOpacity: "0.33"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.58",
          stopColor: "#72B6F9",
          stopOpacity: "0.15"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.83",
          stopColor: "#76B9FA",
          stopOpacity: "0.04"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#77BAFA",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint7_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(145.138 198.783) rotate(-63.4349) scale(10.7899 13.8604)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.47",
          stopColor: "#051140"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FF6CD0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint8_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(148.903 127.368) scale(22.2289)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2F42D0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3684A6",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint9_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(141.343 129.33) scale(17.9826)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFB9D7"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint10_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(142.148 116.977) scale(17.2427)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFC0E1"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint11_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(141.408 103.981) scale(14.6691)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFCCDC"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint12_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(141.665 93.1078) scale(12.0956)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFCCDE"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint13_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(141.665 81.012) scale(9.52208)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFCCD5"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint14_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(141.279 70.75) scale(6.94854)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FFCCC8"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint15_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(146.747 264.731) rotate(1.36393) scale(67.5744 17.8321)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.32",
          stopColor: "#9CFFFC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.33",
          stopColor: "#9BFEFC",
          stopOpacity: "0.98"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.52",
          stopColor: "#88ECF9",
          stopOpacity: "0.64"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.69",
          stopColor: "#78DEF7",
          stopOpacity: "0.37"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.84",
          stopColor: "#6DD4F5",
          stopOpacity: "0.17"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.94",
          stopColor: "#67CDF4",
          stopOpacity: "0.05"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#64CBF4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint16_linear_9907_50791",
        x1: "237.98",
        y1: "253.342",
        x2: "237.98",
        y2: "322.506",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint17_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(201.576 220.422) rotate(-30.1735) scale(8.12837)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint18_linear_9907_50791",
        x1: "144.271",
        y1: "327.299",
        x2: "144.271",
        y2: "260.934",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#9CFFFC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.04",
          stopColor: "#94F1F1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.19",
          stopColor: "#72B6C2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#558499"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.49",
          stopColor: "#3D5A78"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.63",
          stopColor: "#2B3A5E"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#1E244C"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.89",
          stopColor: "#161641"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#13113D"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint19_linear_9907_50791",
        x1: "144.271",
        y1: "325.369",
        x2: "144.271",
        y2: "239.059",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#70E8FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.15",
          stopColor: "#5AB5CF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.3",
          stopColor: "#4584A3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#335A7E"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.6",
          stopColor: "#253A62"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.75",
          stopColor: "#1B244D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.88",
          stopColor: "#151641"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#13113D"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint20_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(142.785 279.036) rotate(-0.122938) scale(103.172 17.5392)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint21_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(8344.74 681.871) scale(4307.51 125.243)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint22_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(6199.18 629.158) rotate(0.122939) scale(2345.99 68.2668)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint23_linear_9907_50791",
        x1: "142.662",
        y1: "331.449",
        x2: "142.662",
        y2: "260.033",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.44",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.86",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint24_linear_9907_50791",
        x1: "94.6798",
        y1: "339.134",
        x2: "189.772",
        y2: "338.183",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint25_linear_9907_50791",
        x1: "163.095",
        y1: "323.171",
        x2: "122.633",
        y2: "386.924",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint26_linear_9907_50791",
        x1: "146.734",
        y1: "4040.67",
        x2: "146.734",
        y2: "5283.09",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint27_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-6501.92 -38840.3) scale(34.1841 33.7888)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint28_linear_9907_50791",
        x1: "519.585",
        y1: "2328.58",
        x2: "519.585",
        y2: "2949.95",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint29_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-3667.21 -26341.2) scale(16.7683 16.0761)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint30_linear_9907_50791",
        x1: "102.893",
        y1: "2905.76",
        x2: "102.893",
        y2: "4260.6",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint31_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-7175.46 -42851.2) scale(42.1246 41.5849)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint32_linear_9907_50791",
        x1: "46.2566",
        y1: "2863.38",
        x2: "46.2566",
        y2: "3464.8",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint33_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-6658.54 -38418) scale(34.0703 33.4995)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint34_linear_9907_50791",
        x1: "586.684",
        y1: "3196.85",
        x2: "586.684",
        y2: "3968.01",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint35_radial_9907_50791",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-4187.68 -30752.9) scale(21.2319 20.8867)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint36_linear_9907_50791",
        x1: "219.129",
        y1: "142.777",
        x2: "235.503",
        y2: "142.777",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint37_linear_9907_50791",
        x1: "3140.39",
        y1: "488.756",
        x2: "3501.84",
        y2: "488.756",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0.3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint38_linear_9907_50791",
        x1: "2257.55",
        y1: "767.155",
        x2: "2452.76",
        y2: "767.155",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0.3"
        })]
      })]
    })]
  });
};
const looking = (width = "323", height = "391") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 323 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      opacity: "0.7",
      d: "M292.365 226.24C301.592 150.424 247.556 81.4911 171.672 72.2729C95.7889 63.0547 26.7939 117.042 17.5674 192.858C8.34092 268.673 62.377 337.607 138.26 346.825C214.144 356.043 283.139 302.055 292.365 226.24Z",
      fill: "#21BF96"
    }), /* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip0_461_44785)",
      children: [/* @__PURE__ */ jsx("path", {
        opacity: "0.8",
        d: "M152.134 389.706C186.658 386.777 213.866 376.174 212.968 366.026C212.027 355.877 183.321 350.018 148.797 352.948C114.316 355.877 87.1072 366.479 88.0056 376.628C88.904 386.777 117.653 392.635 152.134 389.706Z",
        fill: "url(#paint0_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M281.162 270.684C247.664 280.915 217.59 236.978 194.317 232.233C176.221 228.562 163.472 242.919 169.932 258.059C166.509 254.553 166.338 253.893 163.044 251.5C160.477 233.925 173.697 218.702 198.381 223.735C224.948 229.139 250.616 265.362 275.686 257.688L281.162 270.684Z",
        fill: "url(#paint1_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M169.802 257.853C169.845 257.936 169.845 258.019 169.888 258.061C169.845 258.019 169.845 258.019 169.802 257.978C169.802 257.978 169.802 257.895 169.802 257.853Z",
        fill: "url(#paint2_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M281.16 270.685C280.818 270.808 280.476 270.85 280.091 270.973L277.182 264.125C252.07 271.799 226.444 235.576 199.877 230.172C177.802 225.675 164.882 237.35 164.241 252.491C163.856 252.202 163.471 251.913 163 251.542C160.433 233.967 173.653 218.744 198.337 223.777C224.904 229.182 250.572 265.404 275.642 257.73L281.16 270.685Z",
        fill: "#123161"
      }), /* @__PURE__ */ jsx("path", {
        d: "M285.952 254.099C285.438 251.046 280.262 252.779 275.727 254.883C271.406 256.863 266.144 260.411 265.759 265.238L267.77 264.908C268.241 262.804 275.856 260.617 278.166 259.957C281.674 258.967 286.508 257.152 285.952 254.099Z",
        fill: "url(#paint3_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M271.535 259.71L277.182 253.769L285.396 269.157L278.38 271.096C274.187 268.91 271.706 265.609 271.535 259.71Z",
        fill: "url(#paint4_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M291.855 259.215C293.438 262.02 288.39 264.578 283.599 266.476C279.021 268.25 273.588 264.99 270.166 261.566L271.92 260.287C273.631 261.566 280.048 261.896 282.144 260.659C285.438 258.72 290.273 256.409 291.855 259.215Z",
        fill: "url(#paint5_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M275.385 247.292C274.7 244.28 269.609 246.26 265.16 248.529C260.925 250.716 259.257 256.904 259.085 261.731L261.096 261.319C261.438 259.215 265.588 254.223 267.813 253.48C271.321 252.366 276.069 250.345 275.385 247.292Z",
        fill: "url(#paint6_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M154.573 355.794C154.573 355.794 117.525 337.023 108.156 325.719C99.728 304.513 83.9847 251.83 92.5408 205.087C92.5408 205.087 117.953 187.1 170.102 188.255C215.407 189.245 233.418 204.138 233.418 204.138C233.418 204.138 232.348 280.131 205.824 334.795C183.45 348.12 154.573 355.794 154.573 355.794Z",
        fill: "url(#paint7_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M140.755 224.271C140.755 224.271 117.525 337.023 108.156 325.719C99.728 304.513 83.9847 251.83 92.5408 205.087C92.5408 205.087 117.953 187.1 170.102 188.255C215.407 189.245 233.418 204.138 233.418 204.138L140.755 224.271Z",
        fill: "url(#paint8_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M205.824 333.434L154.572 355.794L233.417 204.139C228.668 250.923 221.225 295.438 205.824 333.434Z",
        fill: "url(#paint9_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M195.557 249.149L225.289 267.59L221.225 282.608L191.492 264.166L195.557 249.149Z",
        fill: "url(#paint10_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M195.599 248.984L200.648 248.736L229.054 265.899L225.033 282.112L221.353 282.648L221.268 282.483L225.289 267.549L195.813 249.273C195.685 249.149 195.599 248.984 195.599 248.984Z",
        fill: "url(#paint11_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M229.396 235.494L259.128 253.935L255.064 268.952L225.332 250.552L229.396 235.494Z",
        fill: "url(#paint12_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M229.439 235.37L234.487 235.081L262.893 252.243L258.872 268.457L255.15 268.993L255.064 268.869L259.086 253.893L229.61 235.658C229.524 235.493 229.439 235.37 229.439 235.37Z",
        fill: "url(#paint13_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M206.124 262.433L263.792 244.281C263.792 244.281 305.76 269.941 306.145 274.108C306.53 278.275 300.455 300.883 297.888 306.948C295.364 312.971 275.6 319.077 275.6 319.077L243.985 312.022L203.087 286.939C203.129 286.98 200.434 275.8 206.124 262.433Z",
        fill: "#123161"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M306.187 275.016C305.888 280.833 300.327 301.254 297.931 306.989C295.407 313.012 275.642 319.118 275.642 319.118L244.241 312.146L249.631 291.188L306.187 275.016Z",
        fill: "#123161"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M302.038 293.87C300.498 299.398 298.958 304.514 297.888 306.948C295.364 312.971 275.599 319.077 275.599 319.077L243.984 312.022L203.086 286.939C203.086 286.939 200.434 276.089 205.91 262.887C212.669 267.755 238.423 286.237 247.535 290.28C258.059 294.942 276.113 302.987 276.113 302.987L302.038 293.87Z",
        fill: "url(#paint14_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M302.038 293.87C300.498 299.398 298.958 304.514 297.888 306.948C295.364 312.971 275.599 319.077 275.599 319.077L244.198 312.105L249.546 291.229C260.198 295.974 276.07 302.987 276.07 302.987L302.038 293.87Z",
        fill: "url(#paint15_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M272.904 317.798C271.193 313.425 274.958 303.895 276.54 301.956C278.123 300.017 298.23 290.858 302.166 293.004C302.893 293.416 305.631 295.561 306.958 296.964C312.776 303.111 322.572 316.726 321.417 320.232C319.963 324.523 308.369 334.383 304.134 332.774C300.327 331.33 274.444 321.8 272.904 317.798Z",
        fill: "url(#paint16_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M307.043 297.005C308.369 298.408 309.824 300.141 311.364 302.08C306.872 302.121 302.936 302.864 299.342 304.184C295.193 305.752 291.514 308.186 288.048 311.362C284.797 314.291 282.829 318.706 281.246 323.285C279.407 322.378 277.695 321.511 276.369 320.686C278.123 315.777 280.391 310.991 284.284 307.484C288.262 303.854 292.54 301.09 297.375 299.233C300.369 298.161 303.578 297.377 307.043 297.005ZM316.455 309.011C317.695 310.826 318.808 312.6 319.621 314.25C317.952 314.126 310.252 313.961 303.834 320.108C300.883 322.955 298.744 326.668 297.289 330.175C295.749 329.556 294.038 328.896 292.241 328.153C293.952 324.11 296.433 319.737 299.941 316.354C305.674 310.867 312.262 309.341 316.455 309.011Z",
        fill: "url(#paint17_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M156.54 310.99C151.963 303.069 146.872 277.615 151.492 223.817C109.952 226.045 92.5404 205.087 92.5404 205.087C83.9842 251.83 99.7275 304.513 108.155 325.719C117.567 337.023 154.572 355.794 154.572 355.794C154.572 355.794 183.407 348.12 205.738 334.877C207.792 331.371 209.631 328.029 210.401 323.408C194.144 322.006 159.834 316.642 156.54 310.99Z",
        fill: "url(#paint18_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M149.31 223.941C144.433 280.132 146.572 306.906 151.236 314.662C154.53 320.191 191.834 324.523 209.759 326.132C210.016 325.265 210.23 324.358 210.401 323.367C194.102 321.965 159.834 316.601 156.54 310.908C151.963 302.987 146.872 277.532 151.492 223.735C150.765 223.859 150.038 223.9 149.31 223.941Z",
        fill: "url(#paint19_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M163 356.165C160.348 355.299 152.433 342.386 152.433 342.386L159.022 335.455C164.883 328.606 186.444 327.658 188.54 334.341C189.866 338.755 167.449 357.65 163 356.165Z",
        fill: "#C6A98D"
      }), /* @__PURE__ */ jsx("path", {
        d: "M173.481 337.766C178.615 335.703 183.749 334.589 188.455 334.259C186.145 327.699 164.84 328.648 159.022 335.455L152.433 342.386C152.433 342.386 154.444 345.646 156.754 348.987C160.647 344.614 166.465 340.571 173.481 337.766Z",
        fill: "#AF8461"
      }), /* @__PURE__ */ jsx("path", {
        d: "M175.92 356.537C176.947 346.182 171.086 339.127 163 338.385C154.957 337.642 147.77 343.5 146.744 353.814C145.717 364.169 151.578 371.224 159.663 371.967C167.706 372.709 174.85 366.851 175.92 356.537Z",
        fill: "#123161"
      }), /* @__PURE__ */ jsx("path", {
        d: "M174.765 361.694C171.128 361.859 167.963 357.692 167.706 352.411C167.492 347.997 169.417 344.202 172.155 343.005C169.845 340.365 166.637 338.715 163 338.385C154.957 337.642 147.77 343.5 146.744 353.814C145.717 364.169 151.578 371.224 159.663 371.967C166.251 372.585 172.241 368.79 174.765 361.694Z",
        fill: "url(#paint20_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M166.722 354.597C167.364 348.203 163.984 343.871 159.278 343.458C154.615 343.005 150.423 346.676 149.781 353.03C149.139 359.424 152.562 363.756 157.225 364.169C161.888 364.623 166.08 360.992 166.722 354.597Z",
        fill: "url(#paint21_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M159.621 355.217C159.877 352.576 158.465 350.761 156.54 350.596C154.615 350.431 152.861 351.916 152.605 354.556C152.348 357.197 153.76 359.012 155.685 359.177C157.61 359.342 159.364 357.857 159.621 355.217Z",
        fill: "#123161"
      }), /* @__PURE__ */ jsx("path", {
        d: "M156.155 355.794C162.915 356.578 177.374 325.1 177.374 325.1C177.374 325.1 116.369 308.639 108.369 326.049C113.546 333.268 144.177 354.391 156.155 355.794Z",
        fill: "url(#paint22_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M145.802 311.444C141.225 303.523 136.134 278.068 140.754 224.271C109.268 222.786 92.5404 205.087 92.5404 205.087C83.9842 251.83 99.7275 304.513 108.155 325.719C117.567 337.023 154.572 355.794 154.572 355.794C154.572 355.794 183.407 348.12 205.738 334.877C207.792 331.371 209.631 328.029 210.401 323.408C194.144 322.006 149.096 317.096 145.802 311.444Z",
        fill: "url(#paint23_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M93.7384 240.774C92.8827 220.806 94.6368 216.928 97.717 202.117C94.2517 203.891 92.5405 205.088 92.5405 205.088C83.9844 251.83 108.327 325.925 108.412 326.008C113.246 332.732 140.284 351.628 153.589 355.258C154.23 355.588 154.615 355.794 154.615 355.794C154.615 355.794 154.829 355.753 155.171 355.629C155.514 355.712 155.856 355.753 156.198 355.794C157.139 355.918 158.209 355.382 159.364 354.433C127.45 324.028 98.487 352.453 93.7384 240.774Z",
        fill: "url(#paint24_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M129.461 246.673C129.333 234.874 123.771 226.995 117.482 227.077C111.194 227.16 106.531 235.163 106.702 247.004C106.83 258.803 112.049 268.333 118.338 268.25C124.627 268.126 129.632 258.473 129.461 246.673Z",
        fill: "url(#paint25_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M119.108 243.332C122.83 243.166 126.381 244.28 129.461 246.302C129.204 234.709 123.728 226.994 117.482 227.036C111.194 227.118 106.531 235.122 106.702 246.962C106.702 247.787 106.744 248.571 106.787 249.355C110.124 245.807 114.359 243.538 119.108 243.332Z",
        fill: "url(#paint26_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M126.893 247.499C126.807 238.835 122.786 233.018 118.294 233.059C113.802 233.1 110.465 239 110.551 247.705C110.679 256.369 114.401 263.382 118.893 263.299C123.428 263.258 126.979 256.162 126.893 247.499Z",
        fill: "url(#paint27_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M109.695 294.983C102.936 276.501 108.07 255.131 123.214 245.105C125.866 244.817 127.449 248.076 125.31 249.974C116.583 255.254 112.134 277.656 117.096 291.188C124.112 310.331 151.449 318.293 220.711 293.292L224.348 305.421C183.963 319.984 125.524 338.178 109.695 294.983Z",
        fill: "#123161"
      }), /* @__PURE__ */ jsx("path", {
        d: "M119.107 248.365C112.861 256.657 103.62 273.943 107.428 284.917C108.155 287.021 115.514 288.672 116.84 290.528C112.219 276.955 116.711 255.172 125.268 249.933C127.449 248.035 125.866 244.776 123.171 245.065C121.759 246.096 120.391 247.21 119.107 248.365Z",
        fill: "url(#paint28_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M221.909 297.335C184.476 310.248 130.315 327.452 110.636 297.253C127.663 337.601 184.69 319.696 224.305 305.38L221.909 297.335Z",
        fill: "url(#paint29_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M220.925 307.113L228.241 307.526L223.492 290.652L217.888 294.117C216.647 298.656 217.246 302.74 220.925 307.113Z",
        fill: "url(#paint30_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M225.674 307.525H227C227.642 307.525 228.069 306.865 227.898 306.205L223.791 291.601C223.663 291.064 223.15 290.776 222.679 290.941L221.567 291.271C221.224 291.353 221.011 291.683 220.925 292.013C220.027 296.428 221.695 302.946 225.032 307.154C225.16 307.402 225.417 307.525 225.674 307.525Z",
        fill: "url(#paint31_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M239.15 281.74C238.337 278.605 233.545 280.214 229.353 282.194C225.674 283.927 221.652 288.878 221.524 293.498C221.524 294.117 221.995 294.612 222.551 294.53L222.765 294.488C223.107 294.447 223.406 294.158 223.535 293.828C224.262 291.559 230.209 287.929 232.134 287.434C235.471 286.526 239.963 284.835 239.15 281.74Z",
        fill: "url(#paint32_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M245.353 303.895C246.85 306.577 242.444 308.639 238.166 310.042C234.486 311.28 227.385 308.227 224.176 305.215C223.706 304.761 223.749 303.978 224.262 303.606L224.305 303.565C224.561 303.359 224.904 303.359 225.203 303.524C227.214 304.638 234.872 305.545 236.626 304.638C239.577 303.029 243.855 301.213 245.353 303.895Z",
        fill: "url(#paint33_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M244.882 293.045C246.508 295.644 242.187 297.913 237.994 299.563C234.444 300.966 227 301.585 223.62 299.439C223.021 299.068 223.021 298.16 223.535 297.748C223.749 297.583 224.048 297.5 224.305 297.583C226.358 298.16 234.486 295.231 236.198 294.159C239.064 292.508 243.256 290.446 244.882 293.045Z",
        fill: "url(#paint34_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M164.925 350.555C168.177 346.924 190.123 331.412 190.123 331.412L205.781 333.433C205.824 333.433 170.358 351.916 164.925 350.555Z",
        fill: "url(#paint35_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M174.508 212.555C188.498 211.358 199.492 207.068 199.107 202.983C198.722 198.858 187.086 196.506 173.139 197.703C159.193 198.899 148.155 203.19 148.54 207.274C148.883 211.358 160.519 213.751 174.508 212.555Z",
        fill: "url(#paint36_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M238.422 183.14L230.294 77.1956L215.877 71.0898L101.653 75.7104C98.7435 75.7929 95.0216 75.6692 94.2088 78.392C90.5296 90.8512 81.1607 126.414 85.1393 153.065C90.0591 185.945 103.792 214.618 103.792 214.618L114.872 216.392C117.481 216.805 120.134 216.887 122.786 216.557C150.166 213.133 199.193 205.665 238.422 183.14Z",
        fill: "url(#paint37_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M238.422 183.139C247.877 146.752 250.914 109.828 230.294 77.1949L215.877 71.0891C215.877 71.0891 153.332 211.111 161.631 209.502C187.128 204.551 214.38 196.919 238.422 183.139Z",
        fill: "url(#paint38_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M238.422 183.139C247.877 146.752 250.914 109.828 230.294 77.1949L215.877 71.0891C215.877 71.0891 153.332 211.111 161.631 209.502C187.128 204.551 214.38 196.919 238.422 183.139Z",
        fill: "url(#paint39_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M129.46 93.9446C105.161 123.319 105.674 167.668 132.284 191.308C134.637 193.371 137.845 194.237 140.925 193.494L222.166 174.929C225.118 174.269 227.599 172.248 228.754 169.525C239.963 142.874 237.909 116.388 222.551 89.9428C220.754 86.8899 217.332 85.0334 213.695 85.2396C201.118 85.941 152.134 89.1589 136.989 90.1491C134.08 90.3553 131.3 91.7168 129.46 93.9446Z",
        fill: "url(#paint40_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M167.706 186.522L222.893 174.764C225.417 174.228 227.471 172.536 228.412 170.185C240.647 140.316 237.225 113.458 222.037 88.87C220.54 86.4359 217.759 85.0745 214.85 85.2808L209.845 85.6521L167.706 186.522Z",
        fill: "url(#paint41_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M148.797 105.579L157.054 105.208C158.765 105.125 160.262 106.487 160.305 108.219L161.674 138.336C161.759 139.945 160.562 141.389 158.979 141.554L150.722 142.585C148.925 142.833 147.3 141.43 147.214 139.615L145.802 108.838C145.759 107.147 147.086 105.661 148.797 105.579ZM195.898 102.774L201.973 102.485C203.684 102.402 205.182 103.764 205.267 105.496L206.679 134.54C206.765 136.273 205.438 137.717 203.727 137.8L197.652 138.088C195.941 138.171 194.444 136.809 194.358 135.077L192.947 106.033C192.861 104.341 194.187 102.856 195.898 102.774Z",
        fill: "url(#paint42_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M150.679 103.516L158.936 103.145C160.647 103.062 162.144 104.424 162.187 106.156L163.556 136.273C163.642 137.882 162.444 139.326 160.861 139.491L152.604 140.522C150.808 140.77 149.182 139.367 149.096 137.552L147.685 106.775C147.642 105.084 148.968 103.598 150.679 103.516ZM197.781 100.711L203.856 100.422C205.567 100.339 207.064 101.701 207.15 103.433L208.562 132.477C208.647 134.21 207.321 135.654 205.61 135.737L199.535 136.025C197.824 136.108 196.326 134.746 196.241 133.014L194.829 103.97C194.743 102.278 196.07 100.793 197.781 100.711Z",
        fill: "url(#paint43_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M151.449 106.197L156.583 105.95C157.653 105.909 158.551 106.734 158.594 107.806L159.278 122.452C159.321 123.442 158.594 124.35 157.61 124.474L152.519 125.134C151.407 125.258 150.38 124.432 150.337 123.277L149.653 108.219C149.567 107.146 150.38 106.239 151.449 106.197ZM198.508 103.681L202.273 103.516C203.342 103.475 204.241 104.3 204.283 105.372L204.968 120.596C205.011 121.668 204.198 122.576 203.128 122.617L199.364 122.782C198.294 122.823 197.396 121.998 197.353 120.926L196.669 105.702C196.626 104.671 197.439 103.763 198.508 103.681Z",
        fill: "url(#paint44_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M229.995 77.071L216.904 71.5015C216.219 71.2127 215.449 71.0477 214.679 71.0889L96.134 74.7194C96.134 74.7194 95.0645 75.0907 94.2944 76.9885C89.9736 87.6737 71.749 116.223 75.8987 143.946C80.0057 171.423 96.4334 204.262 100.113 211.894C100.797 213.338 102.209 214.37 103.835 214.7L109.482 215.772C111.535 216.185 113.246 214.246 112.519 212.348C108.54 201.787 94.6794 178.601 93.011 143.946C91.9843 122.823 104.134 97.7813 108.925 87.5086C110.936 83.2181 115.043 80.1239 119.877 79.3813C136.476 76.6997 179.086 71.5427 229.995 77.071Z",
        fill: "url(#paint45_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M229.995 77.0712L215.834 71.0479C169.973 66.6748 138.487 66.2622 96.1339 74.6784L113.76 81.7331C115.556 80.0828 122.016 79.0102 131.214 77.855C156.198 74.7196 201.546 73.3994 229.995 77.0712Z",
        fill: "url(#paint46_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M179.219 170.321C187.09 168.918 195.176 162.235 196.887 152.003C197.101 150.559 196.032 149.487 194.663 149.734L190.128 150.559C189.016 150.766 187.903 151.797 187.689 152.952C186.663 157.903 182.855 160.254 179.689 160.832C176.524 161.41 172.887 160.378 172.245 155.716C172.16 154.602 171.09 153.984 169.978 154.149L165.443 154.974C164.074 155.221 162.919 156.706 162.962 158.068C163.732 167.969 171.518 171.724 179.219 170.321Z",
        fill: "url(#paint47_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M180.642 170.762C188.514 169.36 196.6 162.676 198.311 152.445C198.525 151.001 197.455 149.928 196.086 150.176L191.551 151.001C190.439 151.207 189.327 152.239 189.113 153.394C188.086 158.344 184.279 160.696 181.113 161.273C177.947 161.851 174.311 160.82 173.669 156.158C173.584 155.044 172.514 154.425 171.402 154.59L166.867 155.415C165.498 155.663 164.343 157.148 164.386 158.509C165.113 168.411 172.899 172.165 180.642 170.762Z",
        fill: "url(#paint48_linear_461_44785)"
      }), /* @__PURE__ */ jsxs("g", {
        clipPath: "url(#clip1_461_44785)",
        children: [/* @__PURE__ */ jsx("path", {
          opacity: "0.1",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M164.817 73.1225C165.05 72.1937 166.051 70.5971 166.98 70.8297L181.256 74.9062C182.186 75.1388 178.942 74.3268 181.256 74.9062C176.374 74.8677 180.482 74.8677 172.079 74.9062L166.078 75.2257C165.149 74.993 164.584 74.0514 164.817 73.1225Z",
          fill: "#041836"
        }), /* @__PURE__ */ jsx("path", {
          d: "M167.291 71.9996C167.291 71.9996 166.06 43.279 186.675 24.4473",
          stroke: "#A4E4F3",
          strokeWidth: "4.4348",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      }), /* @__PURE__ */ jsx("path", {
        d: "M187.727 13.4548C192.005 13.4548 195.684 16.9616 195.684 21.1284C195.684 25.2539 192.048 28.8019 187.727 28.8019C183.449 28.8019 179.77 25.2952 179.77 21.1284C179.77 17.0028 183.278 13.4548 187.727 13.4548Z",
        fill: "url(#paint49_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M187.086 14.9814C190.251 14.9814 192.947 17.5805 192.947 20.6334C192.947 23.6863 190.251 26.2854 187.086 26.2854C183.92 26.2854 181.225 23.6863 181.225 20.6334C181.225 17.5805 183.92 14.9814 187.086 14.9814Z",
        fill: "url(#paint50_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M308.155 305.545C315.471 303.523 319.92 307.649 318.08 314.703C316.241 321.758 308.882 329.143 301.567 331.123C294.251 333.145 289.802 329.019 291.642 321.964C293.439 314.91 300.84 307.566 308.155 305.545Z",
        fill: "#E9F5FB"
      }), /* @__PURE__ */ jsx("path", {
        d: "M321.16 313.796C321.16 313.837 321.16 313.837 321.16 313.796L316.412 309.34C310.979 304.266 297.118 312.682 294.551 322.707C293.096 328.359 295.791 329.597 300.626 334.176C300.583 334.135 300.54 334.052 300.454 333.97C305.717 339.457 319.877 330.958 322.487 320.809C323.299 317.715 322.7 315.281 321.16 313.796Z",
        fill: "#FFFBF3"
      }), /* @__PURE__ */ jsx("path", {
        d: "M321.16 313.837C317.995 310.867 312.262 312.724 308.412 315.281C300.54 320.521 296.476 330.051 300.54 334.053C300.198 333.723 300.283 333.805 299.428 333.021H299.385C298.957 332.691 296.091 329.927 295.62 329.515H295.577C285.909 319.985 307.727 301.296 315.257 308.351C315.299 308.392 316.027 309.093 316.454 309.506H316.497C318.166 311.073 320.604 313.301 321.16 313.837Z",
        fill: "url(#paint51_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M312.946 315.364C317.524 314.044 320.347 316.725 319.192 321.346C318.037 325.967 313.374 330.752 308.797 332.031C304.219 333.351 301.396 330.67 302.551 326.049C303.706 321.47 308.369 316.684 312.946 315.364Z",
        fill: "#AAD9F0"
      }), /* @__PURE__ */ jsx("path", {
        d: "M317.952 317.261C317.267 316.106 316.069 315.611 314.658 315.653C310.636 315.735 304.861 320.191 303.62 325.636C303.449 326.338 303.406 326.998 303.406 327.534C303.535 334.836 316.241 330.092 318.337 321.14C318.679 319.943 318.679 318.334 317.952 317.261Z",
        fill: "#005995"
      }), /* @__PURE__ */ jsx("path", {
        d: "M318.381 321.139C316.284 330.092 303.536 334.836 303.45 327.534C306.402 330.422 314.231 325.554 315.557 319.613C315.942 317.839 315.643 316.436 314.701 315.652C316.113 315.611 317.311 316.106 317.996 317.261C318.68 318.334 318.68 319.943 318.381 321.139Z",
        fill: "url(#paint52_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M285.353 284.958L266.444 275.304L258.144 280.832L244.241 259.091L262.551 269.033L272.262 264.495C272.262 264.536 285.267 284.752 285.353 284.958Z",
        fill: "url(#paint53_linear_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M266.273 250.097C266.059 253.191 269.866 252.16 273.332 250.716C276.626 249.355 275.898 245.064 272.647 245.394C270.08 245.889 266.487 247.003 266.273 250.097Z",
        fill: "url(#paint54_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M278.08 256.121C277.866 259.215 280.775 258.843 284.241 257.399C287.535 256.038 286.808 251.747 283.556 252.077C280.989 252.573 278.294 253.026 278.08 256.121Z",
        fill: "url(#paint55_radial_461_44785)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M285.439 261.071C285.738 262.391 287.535 263.216 290.273 262.103C292.84 261.03 292.283 257.647 289.759 257.894C287.706 258.266 285.139 259.71 285.439 261.071Z",
        fill: "url(#paint56_radial_461_44785)"
      })]
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("radialGradient", {
        id: "paint0_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(150.471 371.308) rotate(-4.33852) scale(46.36 44.7265)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.00504299",
          stopColor: "#A4E4F3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_461_44785",
        x1: "162.774",
        y1: "250.38",
        x2: "279.961",
        y2: "245.008",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_461_44785",
        x1: "169.802",
        y1: "257.97",
        x2: "169.881",
        y2: "257.966",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint3_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(275.815 258.765) rotate(-2.44098) scale(8.55423 8.2504)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint4_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(278.379 262.416) rotate(-2.44098) scale(7.94111 7.65906)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint5_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(281.215 262.608) rotate(-2.44098) scale(8.41615 8.11723)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint6_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(267.232 253.72) rotate(-2.44098) scale(8.24102 7.94833)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint7_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(164.044 271.736) rotate(-2.44098) scale(79.8375 77.0019)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint8_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(154.549 241.85) scale(42.283 40.7757)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#94BBD6"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint9_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(231.989 231.611) scale(120.591 116.292)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.323",
          stopColor: "#F8F5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#9AD6EA"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint10_linear_461_44785",
        x1: "191.604",
        y1: "266.571",
        x2: "225.151",
        y2: "265.033",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#7EB0D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B7D4E1"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint11_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(212.679 265.635) rotate(-2.44098) scale(17.1942 16.5835)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#F1FAFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BFFDFF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint12_linear_461_44785",
        x1: "225.437",
        y1: "252.95",
        x2: "258.992",
        y2: "251.412",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#7EB0D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B7D4E1"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint13_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(246.528 251.992) rotate(-2.44098) scale(17.2007 16.5898)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#F1FAFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BFFDFF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint14_linear_461_44785",
        x1: "252.616",
        y1: "283.777",
        x2: "241.87",
        y2: "304.097",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint15_linear_461_44785",
        x1: "285.642",
        y1: "289.291",
        x2: "261.823",
        y2: "311.334",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint16_linear_461_44785",
        x1: "302.748",
        y1: "305.212",
        x2: "295.46",
        y2: "317.699",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint17_linear_461_44785",
        x1: "303.964",
        y1: "308.553",
        x2: "287.707",
        y2: "327.946",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint18_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(150.163 279.311) rotate(-2.44098) scale(69.6104 67.138)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint19_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(177.168 275.142) rotate(-2.44098) scale(44.2158 42.6454)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.323",
          stopColor: "#F8F5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#9AD6EA"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint20_linear_461_44785",
        x1: "146.572",
        y1: "355.79",
        x2: "174.431",
        y2: "354.513",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint21_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(158.242 353.816) rotate(-2.44098) scale(9.74068 9.39472)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#F8F5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#9AD6EA"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint22_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(143.395 336.907) rotate(-2.44098) scale(28.2424 27.2393)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint23_linear_461_44785",
        x1: "156.896",
        y1: "257.303",
        x2: "94.7381",
        y2: "366.462",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#7EB0D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B7D4E1"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint24_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(124.36 279.08) rotate(-2.44098) scale(61.3809 59.2008)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.323",
          stopColor: "#F8F5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#9AD6EA"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint25_linear_461_44785",
        x1: "106.717",
        y1: "248.099",
        x2: "129.515",
        y2: "247.054",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#F8F5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#9AD6EA"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint26_linear_461_44785",
        x1: "106.277",
        y1: "238.445",
        x2: "129.063",
        y2: "237.401",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#F8F5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#9AD6EA"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint27_linear_461_44785",
        x1: "118.087",
        y1: "248.82",
        x2: "124.018",
        y2: "238.79",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint28_linear_461_44785",
        x1: "106.044",
        y1: "268.421",
        x2: "127.233",
        y2: "267.45",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint29_linear_461_44785",
        x1: "111.263",
        y1: "310.548",
        x2: "224.332",
        y2: "305.365",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint30_linear_461_44785",
        x1: "225.592",
        y1: "299.167",
        x2: "218.771",
        y2: "300.682",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#7EB0D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B7D4E1"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint31_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(224.274 299.226) scale(5.94971 6.52369)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint32_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(230.352 287.197) rotate(-2.77498) scale(7.83028 8.5825)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint33_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(234.856 306.636) rotate(-2.775) scale(8.06377 8.8385)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint34_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(234.202 296.444) rotate(-2.77499) scale(8.32504 9.12481)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint35_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(185.31 340.709) rotate(-2.44098) scale(16.1551 15.5813)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint36_linear_461_44785",
        x1: "148.506",
        y1: "207.022",
        x2: "199.104",
        y2: "202.894",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint37_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(176.579 108.88) rotate(-2.44098) scale(101.314 101.791)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint38_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(201.907 139.704) rotate(-2.44098) scale(57.1513 57.4206)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint39_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(248.263 136.503) scale(88.8518 85.6843)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.323",
          stopColor: "#F8F5FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#9AD6EA"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint40_linear_461_44785",
        x1: "111.552",
        y1: "140.096",
        x2: "235.896",
        y2: "134.396",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint41_linear_461_44785",
        x1: "165.41",
        y1: "136.127",
        x2: "235.847",
        y2: "132.898",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1407",
          stopColor: "#123161"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#041836"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint42_linear_461_44785",
        x1: "172.343",
        y1: "106.876",
        x2: "174.02",
        y2: "140.221",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.0155217",
          stopColor: "#123161",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#051938"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint43_linear_461_44785",
        x1: "174.629",
        y1: "104.97",
        x2: "174.218",
        y2: "125.272",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint44_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(177.307 114.328) rotate(8.54163) scale(22.3924 21.6529)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#D7FFFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint45_linear_461_44785",
        x1: "135.788",
        y1: "168.675",
        x2: "150.873",
        y2: "104.489",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#7EB0D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B7D4E1"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint46_linear_461_44785",
        x1: "156.131",
        y1: "91.8228",
        x2: "153.89",
        y2: "97.3568",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#7EB0D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B7D4E1"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint47_linear_461_44785",
        x1: "188.437",
        y1: "147.648",
        x2: "170.132",
        y2: "169.58",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.0155217",
          stopColor: "#123161",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#051938"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint48_linear_461_44785",
        x1: "189.834",
        y1: "148.091",
        x2: "171.528",
        y2: "170.023",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint49_linear_461_44785",
        x1: "163.71",
        y1: "10.7285",
        x2: "191.94",
        y2: "23.8674",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#6BFFE8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.0474436",
          stopColor: "#68F8E5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5011",
          stopColor: "#49B6C8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8307",
          stopColor: "#358DB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint50_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(185.214 18.8729) scale(5.05929 4.87894)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#D7FFFF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.1145",
          stopColor: "#CFF9FB",
          stopOpacity: "0.8855"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2944",
          stopColor: "#B8E7F0",
          stopOpacity: "0.7056"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5171",
          stopColor: "#94CBDF",
          stopOpacity: "0.4829"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7713",
          stopColor: "#61A5C7",
          stopOpacity: "0.2287"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2E7DAF",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint51_linear_461_44785",
        x1: "111.303",
        y1: "273.013",
        x2: "348.037",
        y2: "334.669",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#128EF9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A9D4F3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint52_linear_461_44785",
        x1: "111.578",
        y1: "274.913",
        x2: "347.382",
        y2: "336.327",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#128EF9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A9D4F3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint53_linear_461_44785",
        x1: "281.533",
        y1: "283.473",
        x2: "270.351",
        y2: "243.724",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FCDE00"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FDE1A9"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint54_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(270.9 248.812) rotate(-168.237) scale(3.61946 5.09966)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint55_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(282.239 255.323) rotate(-168.238) scale(3.32991 4.6917)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint56_radial_461_44785",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(288.71 260.214) rotate(-168.237) scale(2.57527 3.62846)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.387",
          stopColor: "#D8E8F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A4E4F3"
        })]
      }), /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_461_44785",
        children: /* @__PURE__ */ jsx("rect", {
          width: "247.7",
          height: "377.076",
          fill: "white",
          transform: "translate(75.2997 13.2488)"
        })
      }), /* @__PURE__ */ jsx("clipPath", {
        id: "clip1_461_44785",
        children: /* @__PURE__ */ jsx("rect", {
          width: "27.5109",
          height: "54.3107",
          fill: "white",
          transform: "translate(164.766 26.3135)"
        })
      })]
    })]
  });
};
const marketplace = (width = "292", height = "398") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 292 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M279.726 225.434C283.044 198.214 278.216 170.62 265.852 146.143C253.489 121.666 234.145 101.405 210.267 87.9211C186.389 74.4371 159.049 68.336 131.704 70.3893C104.359 72.4426 78.2366 82.558 56.6401 99.4565C35.0435 116.355 18.9425 139.278 10.3728 165.327C1.80324 191.375 1.14988 219.38 8.49537 245.8C15.8409 272.22 30.8553 295.869 51.6404 313.756C72.4254 331.644 98.0476 342.966 125.267 346.293C143.345 348.502 161.681 347.128 179.228 342.249C196.775 337.371 213.189 329.083 227.533 317.86C241.876 306.637 253.868 292.698 262.824 276.839C271.779 260.98 277.522 243.513 279.726 225.434Z",
      fill: "#ED1818"
    }), /* @__PURE__ */ jsx("path", {
      d: "M238.064 323.559L84.3468 337.103C77.834 337.68 71.3507 335.712 66.258 331.612C61.1653 327.511 57.8594 321.597 57.0343 315.111L31.7534 116.056C31.3693 112.608 31.7403 109.119 32.8408 105.829C33.9412 102.54 35.7446 99.5293 38.1258 97.007C40.5069 94.4848 43.4086 92.5111 46.6294 91.2233C49.8501 89.9355 53.3126 89.3643 56.7764 89.5495L209.429 97.9012C214.882 98.198 220.068 100.359 224.118 104.021C228.168 107.684 230.837 112.627 231.679 118.023L260.701 294.248C261.269 297.676 261.125 301.185 260.276 304.556C259.428 307.926 257.893 311.085 255.769 313.836C253.645 316.587 250.976 318.87 247.93 320.543C244.883 322.216 241.525 323.243 238.064 323.559Z",
      fill: "url(#paint0_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M238.193 322.301L82.7992 336.844C76.596 337.104 70.525 335.002 65.8097 330.963C61.0945 326.924 58.0855 321.248 57.3893 315.078L31.7859 114.056C31.257 110.056 31.907 105.988 33.6562 102.351C32.5921 103.705 27.9809 82.4229 27.9809 82.4229L24.4338 81.9714L28.4968 120.248L54.2937 320.173C54.9899 326.343 57.9989 332.019 62.7141 336.058C67.4294 340.097 73.5004 342.199 79.7036 341.939L235.098 327.396C239.604 327.208 243.972 325.781 247.721 323.273C251.47 320.764 254.455 317.27 256.348 313.176C254.153 315.91 251.396 318.14 248.264 319.715C245.131 321.289 241.697 322.171 238.193 322.301Z",
      fill: "url(#paint1_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M35.494 144.658L61.2586 198.863L228.584 196.284L236.129 145.851L248.254 128.18L228.197 113.25L52.5844 109.219L35.494 144.658Z",
      fill: "url(#paint2_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M266.183 340.23L46.8125 352L14.7277 112.057L275.889 122.763L266.183 340.23Z",
      fill: "url(#paint3_radial_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M130.394 127.567C97.6968 127.987 74.7053 159.072 79.6067 195.284C82.8313 221.081 100.309 245.653 125.106 254.714C133.415 257.441 142.192 258.451 150.903 257.68C159.505 256.438 167.651 253.028 174.572 247.77C181.494 242.513 186.964 235.581 190.469 227.627C191.756 224.852 192.834 221.985 193.693 219.05C194.841 215.209 195.619 211.268 196.015 207.28C200.626 166.94 167.929 126.536 130.394 127.567Z",
      fill: "url(#paint4_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M182.955 152.59L177.183 155.009L175.861 143.174L181.601 140.724L182.955 152.59Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M181.601 140.724L175.861 143.174L170.444 143.271L176.216 140.82L181.601 140.724Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M176.216 140.821L170.444 143.271L169.831 137.79L175.603 135.371L176.216 140.821Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M190.405 180.193L184.632 182.611L183.343 171.067L189.115 168.649L190.405 180.193Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M184.761 168.713L178.989 171.164L177.183 155.009L182.956 152.59L184.761 168.713Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M189.115 168.649L183.343 171.067L178.99 171.164L184.762 168.713L189.115 168.649Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M182.956 152.59L177.184 155.009L171.766 155.106L177.538 152.687L182.956 152.59Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M178.183 158.427L172.411 160.878L171.766 155.106L177.538 152.687L178.183 158.427Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M190.405 180.193L184.633 182.611L180.279 182.676L186.051 180.257L190.405 180.193Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.312 168.81L173.572 171.261L172.411 160.877L178.183 158.427L179.312 168.81Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M178.183 158.427L172.411 160.877L167.8 160.942L173.54 158.524L178.183 158.427Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M178.2 158.394L178.168 158.398L179.33 168.781L179.362 168.777L178.2 158.394Z",
      fill: "url(#paint5_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.312 168.81L173.572 171.261L172.411 160.877L178.151 158.459L179.312 168.81Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.332 168.831L173.566 171.259L173.579 171.289L179.344 168.861L179.332 168.831Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M174.217 164.586L168.477 167.037L167.8 160.942L173.54 158.524L174.217 164.586Z",
      fill: "#638487"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.312 168.81L173.572 171.261L168.155 171.358L173.927 168.907L179.312 168.81Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M173.927 168.907L168.155 171.357L163.511 171.422L169.283 169.003L173.927 168.907Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M190.437 219.501L184.665 221.952L180.279 182.676L186.051 180.258L190.437 219.501Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M181.279 186.126L175.507 188.545L170.089 188.642L175.862 186.223L181.279 186.126Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M175.861 186.223L170.089 188.642L169.444 182.87L175.216 180.451L175.861 186.223Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M170.573 180.515L164.801 182.966L164.221 177.484L169.96 175.066L170.573 180.515Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M175.217 180.451L169.445 182.87L164.801 182.966L170.573 180.516L175.217 180.451Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M185.019 219.598L179.279 222.016L175.507 188.545L181.279 186.126L185.019 219.598Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M190.437 219.501L184.665 221.952L179.28 222.016L185.019 219.598L190.437 219.501Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M185.019 219.598L179.279 222.016L175.507 188.545L181.247 186.126L185.019 219.598Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M185.664 225.37L179.924 227.788L179.28 222.016L185.019 219.598L185.664 225.37Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M174.217 164.586L168.477 167.037L152.741 167.295L158.513 164.876L174.217 164.586Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M158.513 164.876L152.741 167.295L152.064 161.233L157.836 158.814L158.513 164.876Z",
      fill: "#27606A"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.28 214.503L173.54 216.921L172.83 210.859L178.602 208.44L179.28 214.503Z",
      fill: "#638487"
    }), /* @__PURE__ */ jsx("path", {
      d: "M169.283 169.004L163.511 171.422L153.74 171.583L159.48 169.165L169.283 169.004Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M185.02 219.598L179.248 222.016L173.83 222.145L179.602 219.695L185.02 219.598Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.667 220.146L173.895 222.564L173.83 222.145L179.602 219.694L179.667 220.146Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.667 220.146L173.895 222.564H173.637L179.409 220.146H179.667Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M169.961 175.066L164.221 177.484L154.418 177.678L160.19 175.259L169.961 175.066Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M185.664 225.37L179.924 227.788L174.765 227.885L180.505 225.467L185.664 225.37Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M180.215 225.176L174.443 227.627L173.894 222.564L179.666 220.146L180.215 225.176Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.409 220.146H179.667L180.215 225.176H179.989L179.409 220.146Z",
      fill: "url(#paint6_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.989 225.176L174.217 227.627L173.637 222.564L179.409 220.146L179.989 225.176Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M180.215 225.176L174.443 227.627H174.217L179.989 225.176H180.215Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M160.803 180.709L155.031 183.128L154.418 177.678L160.19 175.26L160.803 180.709Z",
      fill: "#638487"
    }), /* @__PURE__ */ jsx("path", {
      d: "M181.15 231.239L175.41 233.657L174.765 227.885L180.505 225.467L181.15 231.239Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M159.481 169.165L153.741 171.583L149.13 171.68L154.902 169.262L159.481 169.165Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M168.735 203.152L162.963 205.571L161.093 188.803L166.865 186.384L168.735 203.152Z",
      fill: "#638487"
    }), /* @__PURE__ */ jsx("path", {
      d: "M166.865 186.384L161.093 188.803L155.708 188.899L161.447 186.481L166.865 186.384Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M160.803 180.709L155.031 183.127L150.42 183.224L156.192 180.773L160.803 180.709Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M175.603 135.371L169.831 137.79L129.911 138.499L135.65 136.081L175.603 135.371Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M156.837 186.546L151.064 188.996L150.42 183.224L156.192 180.774L156.837 186.546Z",
      fill: "#638487"
    }), /* @__PURE__ */ jsx("path", {
      d: "M163.35 203.217L157.578 205.668L155.708 188.9L161.447 186.481L163.35 203.217Z",
      fill: "#3E787A"
    }), /* @__PURE__ */ jsx("path", {
      d: "M163.35 203.217L161.447 186.481L166.865 186.384L168.735 203.152L163.35 203.217Z",
      fill: "url(#paint7_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M168.735 203.152L162.963 205.571L157.578 205.668L163.35 203.217L168.735 203.152Z",
      fill: "#3B7274"
    }), /* @__PURE__ */ jsx("path", {
      d: "M136.231 141.272L130.491 143.69L129.911 138.499L135.65 136.08L136.231 141.272Z",
      fill: "#27606A"
    }), /* @__PURE__ */ jsx("path", {
      d: "M154.901 169.262L149.129 171.68L138.553 171.841L144.293 169.423L154.901 169.262Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M136.231 141.272L130.491 143.69L125.622 143.787L131.362 141.336L136.231 141.272Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M157.836 158.814L152.064 161.233L132.49 161.555L138.263 159.137L157.836 158.814Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M132.039 147.399L126.299 149.817L125.622 143.787L131.362 141.337L132.039 147.399Z",
      fill: "#27606A"
    }), /* @__PURE__ */ jsx("path", {
      d: "M144.293 169.423L138.553 171.841L133.91 171.938L139.682 169.52L144.293 169.423Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M156.836 186.546L151.064 188.996L140.487 189.19L146.227 186.739L156.836 186.546Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M146.227 186.739L140.488 189.19L139.843 183.386L145.582 180.967L146.227 186.739Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M138.263 159.136L132.491 161.555L128.105 161.652L133.877 159.201L138.263 159.136Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M133.877 159.201L128.105 161.652H127.621L133.361 159.233L133.877 159.201Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.989 225.176L174.217 227.627L155.417 227.949L161.19 225.531L179.989 225.176Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M178.603 208.44L172.83 210.859L148.388 211.278L154.16 208.86L178.603 208.44Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M132.039 147.399L126.299 149.817L121.366 149.914L127.138 147.463L132.039 147.399Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M145.582 180.967L139.843 183.386L135.199 183.482L140.971 181.032L145.582 180.967Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M140.971 181.031L135.199 183.482L134.587 178.032L140.359 175.582L140.971 181.031Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M181.15 231.239L175.41 233.657L156.095 234.012L161.867 231.561L181.15 231.239Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.28 214.503L173.54 216.921L149.065 217.373L154.837 214.922L179.28 214.503Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M154.837 214.922L154.16 208.86L178.602 208.44L179.279 214.503L154.837 214.922Z",
      fill: "#041735"
    }), /* @__PURE__ */ jsx("path", {
      d: "M154.837 214.922L149.065 217.373L148.388 211.278L154.16 208.86L154.837 214.922Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M135.038 169.584L129.266 172.035L128.105 161.652L133.877 159.201L135.038 169.584Z",
      fill: "#638487"
    }), /* @__PURE__ */ jsx("path", {
      d: "M174.249 164.586L173.54 158.395H178.151L179.312 168.778L135.038 169.552L133.877 159.169L157.836 158.75L158.513 164.844L174.249 164.586Z",
      fill: "url(#paint8_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M139.681 169.52L133.909 171.938L129.266 172.035L135.038 169.584L139.681 169.52Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M127.783 153.268L122.011 155.686L121.366 149.914L127.138 147.463L127.783 153.268Z",
      fill: "#27606A"
    }), /* @__PURE__ */ jsx("path", {
      d: "M140.358 175.582L134.586 178.032L129.943 178.097L135.715 175.679L140.358 175.582Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M133.361 159.233L127.621 161.651L122.72 161.748L128.492 159.297L133.361 159.233Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M161.189 225.531L155.417 227.949L150.258 228.046L156.03 225.595L161.189 225.531Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M156.03 225.595L150.258 228.046H150L155.772 225.595H156.03Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M136.36 181.483L130.62 183.902L129.943 178.097L135.715 175.679L136.36 181.483Z",
      fill: "#638487"
    }), /* @__PURE__ */ jsx("path", {
      d: "M164.124 247.684L158.352 250.103L156.095 234.012L161.867 231.561L164.124 247.684Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M129.105 165.102L123.333 167.52L122.72 161.748L128.492 159.297L129.105 165.102Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M164.124 247.684L158.352 250.103H157.933L163.705 247.652H164.124",
      fill: "#020C1C"
    }), /* @__PURE__ */ jsx("path", {
      d: "M129.137 165.102L123.365 167.52L117.947 167.617L123.687 165.199L129.137 165.102Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M130.104 174.034L124.332 176.485L123.333 167.52L129.105 165.102L130.104 174.034Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M130.298 175.775L124.526 178.194L124.332 176.485L130.104 174.034L130.298 175.775Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M135.715 175.679L129.943 178.097L124.526 178.194L130.298 175.776L135.715 175.679Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M127.783 153.268L122.011 155.686L111.982 155.88L117.754 153.429L127.783 153.268Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M124.235 170.068L118.496 172.519L117.947 167.617L123.687 165.199L124.235 170.068Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M129.653 169.971L123.881 172.422L118.496 172.518L124.236 170.068L129.653 169.971Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M124.687 174.131L118.947 176.549L118.496 172.519L124.236 170.068L124.687 174.131Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M117.754 153.429L111.982 155.88L107.629 155.944L113.369 153.526L117.754 153.429Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M124.235 170.068L118.496 172.519L113.852 172.583L119.624 170.165L124.235 170.068Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M113.369 153.526L107.629 155.944H106.823L112.595 153.526H113.369Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M120.269 175.937L114.497 178.355L113.852 172.583L119.624 170.165L120.269 175.937Z",
      fill: "#3F0F56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M112.595 153.526L106.823 155.944L101.438 156.041L107.177 153.622L112.595 153.526Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M175.539 135.371L176.152 140.821H181.537L182.891 152.687H177.474L178.119 158.427H173.475L174.185 164.489L158.513 164.844L157.836 158.75L128.492 159.265L129.137 165.07H123.687L124.236 169.939H119.624L120.269 175.711H115.11L113.24 158.975H107.822L107.177 153.203L127.783 152.848L127.17 147.496H132.071L131.394 141.433H136.263L135.683 136.242L175.539 135.371Z",
      fill: "url(#paint9_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M182.956 152.59L184.762 168.713H189.115L190.405 180.257H186.051L190.437 219.662H185.02L181.279 186.126H175.862L175.217 180.354H170.573L169.961 174.905H160.287L160.899 180.386H156.288L156.933 186.159L146.324 186.352L145.583 180.967H140.971L140.359 175.517L130.395 175.775C129.911 171.422 129.04 163.618 128.589 159.298H133.974L135.135 169.681L179.409 168.907C179.022 165.231 178.054 156.395 177.635 152.784L182.956 152.59Z",
      fill: "#041735"
    }), /* @__PURE__ */ jsx("path", {
      d: "M136.36 181.483L130.62 183.901L125.203 183.998L130.975 181.58L136.36 181.483Z",
      fill: "#3B7274"
    }), /* @__PURE__ */ jsx("path", {
      d: "M130.975 181.579L125.203 183.998L124.558 178.194L130.33 175.775L130.975 181.579Z",
      fill: "#3E787A"
    }), /* @__PURE__ */ jsx("path", {
      d: "M130.975 181.58L130.33 175.776L135.715 175.679L136.36 181.483L130.975 181.58Z",
      fill: "url(#paint10_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.602 219.662H185.019L185.664 225.434H180.505L181.15 231.239L161.802 231.561L164.059 247.684C162.286 247.91 160.48 248.039 158.706 248.103L155.708 225.531L180.15 225.08L179.602 220.049V219.662Z",
      fill: "#041735"
    }), /* @__PURE__ */ jsx("path", {
      d: "M131.523 186.707L125.751 189.125L125.138 183.676L130.91 181.257L131.523 186.707Z",
      fill: "#638487"
    }), /* @__PURE__ */ jsx("path", {
      d: "M136.683 186.61L130.91 189.061L125.751 189.125L131.523 186.707L136.683 186.61Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M129.653 169.971L124.235 170.068L123.687 165.199L129.105 165.102L129.653 169.971Z",
      fill: "url(#paint11_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M130.104 174.034L130.298 175.775H124.881L124.236 169.971H129.653L130.104 174.034Z",
      fill: "#041735"
    }), /* @__PURE__ */ jsx("path", {
      d: "M130.298 175.775L124.526 178.194L119.141 178.29L124.913 175.872L130.298 175.775Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M124.913 175.872L119.141 178.291L118.947 176.549L124.687 174.131L124.913 175.872Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M125.493 181.354L119.753 183.772L119.141 178.291L124.913 175.872L125.493 181.354Z",
      fill: "#638487"
    }), /* @__PURE__ */ jsx("path", {
      d: "M130.911 181.257L125.139 183.676L119.753 183.772L125.493 181.354L130.911 181.257Z",
      fill: "#5E7D80"
    }), /* @__PURE__ */ jsx("path", {
      d: "M120.269 175.937L119.624 170.165H124.236L124.881 175.969L120.269 175.937Z",
      fill: "url(#paint12_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M124.913 175.872L119.141 178.291L114.497 178.355L120.269 175.937L124.913 175.872Z",
      fill: "#3C0E52"
    }), /* @__PURE__ */ jsx("path", {
      d: "M126.783 192.866L121.043 195.316L119.786 184.03L125.526 181.612L126.783 192.866Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M143.873 246.427L138.101 248.877L130.911 189.061L136.683 186.61L143.873 246.427Z",
      fill: "#638487"
    }), /* @__PURE__ */ jsx("path", {
      d: "M131.974 192.769L126.202 195.22L121.043 195.316L126.783 192.866L131.974 192.769Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M125.525 181.612L119.786 184.03L114.368 184.127L120.14 181.709L125.525 181.612Z",
      fill: "#020C1B"
    }), /* @__PURE__ */ jsx("path", {
      d: "M120.269 175.937L114.497 178.355L109.338 178.452L115.11 176.034L120.269 175.937Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M120.14 181.709L114.368 184.127L113.723 178.387L119.495 175.969L120.14 181.709Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M115.11 176.033L109.338 178.452L107.468 161.716L113.24 159.297L115.11 176.033Z",
      fill: "#27606A"
    }), /* @__PURE__ */ jsx("path", {
      d: "M107.822 159.394L102.082 161.813L101.438 156.041L107.177 153.622L107.822 159.394Z",
      fill: "#27606A"
    }), /* @__PURE__ */ jsx("path", {
      d: "M113.24 159.297L107.468 161.716L102.083 161.813L107.822 159.394L113.24 159.297Z",
      fill: "#255B64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M155.772 225.628L158.771 248.2C153.753 248.334 148.741 247.781 143.873 246.556L136.844 186.61H131.684L131.072 181.161H125.687L125.042 175.679H130.459L131.136 181.483H136.521L135.876 175.679H140.52L140.971 180.967H145.582L146.227 186.739L156.836 186.546L156.191 180.774H160.803L160.19 175.292H169.864L170.476 180.741H175.12L175.765 186.513H181.15L185.019 219.662H179.602V220.114H179.409L179.989 225.144L155.772 225.628ZM154.16 208.86L154.837 214.922L179.28 214.503L178.764 208.441L154.321 208.86H154.16ZM161.609 186.481L163.479 203.217H168.896L167.026 186.481H161.609Z",
      fill: "url(#paint13_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M138.263 244.717L132.491 247.136L126.203 195.22L131.975 192.769L138.263 244.717Z",
      fill: "#020D1D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M131.523 186.707H136.682L143.873 246.555C141.971 246.072 140.1 245.491 138.23 244.814L131.974 192.898H126.815L125.525 181.644H120.14L119.495 175.872H124.88L125.525 181.354H130.91L131.523 186.707Z",
      fill: "#041735"
    }), /* @__PURE__ */ jsx("path", {
      d: "M92.7634 185.288C87.862 149.043 110.853 117.99 143.551 117.571C181.118 116.475 213.815 156.911 209.204 197.251C208.816 201.238 208.049 205.179 206.914 209.021C206.06 211.958 204.982 214.826 203.69 217.598C200.177 225.55 194.705 232.48 187.785 237.742C180.866 243.003 172.725 246.424 164.124 247.684L161.867 231.561L181.214 231.238L180.569 225.434H185.729L185.019 219.662H190.437L186.051 180.257H190.404L189.115 168.713H184.761L181.537 140.724H176.152L175.539 135.371L135.586 136.08L136.167 141.272H131.297L131.975 147.334H127.073L127.718 153.106L107.113 153.461L107.758 159.233H113.175L115.045 175.969H119.431L120.076 181.741H125.461L126.751 192.994H131.91L138.166 244.911C113.433 235.785 96.0202 211.02 92.7634 185.288Z",
      fill: "url(#paint14_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M138.23 244.717C95.7945 230.723 76.4791 170.842 105.339 135.822C109.954 130.13 115.776 125.533 122.385 122.366C128.993 119.198 136.223 117.538 143.551 117.507C136.291 117.728 129.166 119.523 122.669 122.769C116.171 126.015 110.456 130.634 105.92 136.306C77.5755 171.519 97.6648 228.627 138.166 244.685L138.23 244.717Z",
      fill: "#D2EBF3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M174.249 245.459L176.667 244.427H176.377L174.636 245.169L176.377 244.427L173.926 245.459H173.41L172.798 245.685L172.153 245.878C169.53 246.689 166.844 247.282 164.124 247.652L158.352 250.07C161.083 249.701 163.779 249.108 166.413 248.297L167.026 248.103L167.638 247.91L168.187 247.716C168.864 247.491 170.089 247.007 171.411 246.459L170.637 246.781H170.928L171.637 246.459L174.249 245.459Z",
      fill: "#3E0F55"
    }), /* @__PURE__ */ jsx("path", {
      d: "M162.995 247.813H162.318H161.609H160.899H158.771H152.644H151.935H151.064C148.642 247.525 146.24 247.083 143.873 246.491C141.971 246.007 140.101 245.427 138.23 244.75C113.433 235.785 96.0202 211.02 92.7634 185.288C88.8616 156.524 102.663 130.663 125.009 121.408C99.2126 129.857 82.8316 156.105 87.0235 187.706C90.2482 213.503 107.726 238.075 132.523 247.136C134.362 247.813 136.234 248.395 138.134 248.877C140.501 249.466 142.902 249.908 145.324 250.199H146.195H147.066H148.968H155.16H155.869H156.578H157.256H157.965L163.737 247.749L162.995 247.813Z",
      fill: "url(#paint15_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M218.878 314.272L90.7639 325.494C88.48 325.724 86.1958 325.06 84.3917 323.641C82.5875 322.221 81.404 320.158 81.0901 317.884L76.2209 283.703C76.0477 282.408 76.1508 281.091 76.5234 279.838C76.896 278.585 77.5296 277.426 78.3825 276.436C79.2355 275.446 80.2884 274.648 81.4721 274.094C82.6557 273.54 83.9432 273.243 85.2498 273.223L214.234 270.256C216.387 270.19 218.491 270.909 220.152 272.28C221.814 273.65 222.919 275.579 223.263 277.705L227.197 303.502C227.411 304.763 227.362 306.054 227.052 307.295C226.742 308.535 226.179 309.698 225.397 310.71C224.616 311.722 223.633 312.561 222.511 313.174C221.388 313.787 220.151 314.161 218.878 314.272Z",
      fill: "url(#paint16_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M223.328 307.984L95.214 316.949C92.9171 317.119 90.6411 316.412 88.8456 314.969C87.05 313.527 85.8687 311.457 85.5401 309.177L80.7032 274.9C80.3831 273.34 80.4073 271.73 80.7744 270.181C81.1414 268.632 81.8423 267.182 82.8282 265.932C83.814 264.682 85.0609 263.662 86.4818 262.944C87.9026 262.227 89.4632 261.828 91.0542 261.776L218.62 263.872C220.798 263.849 222.911 264.618 224.566 266.035C226.22 267.453 227.304 269.422 227.616 271.578L231.55 297.601C231.741 298.83 231.675 300.085 231.358 301.287C231.04 302.489 230.478 303.613 229.706 304.588C228.934 305.563 227.969 306.368 226.871 306.952C225.774 307.536 224.567 307.888 223.328 307.984Z",
      fill: "#28B287"
    }), /* @__PURE__ */ jsx("path", {
      d: "M226.359 304.921L98.1482 313.885C95.8562 314.057 93.5843 313.354 91.7896 311.918C89.9948 310.482 88.8103 308.42 88.4744 306.146L83.6375 271.869C83.4556 270.576 83.5559 269.26 83.9315 268.01C84.3072 266.761 84.9493 265.607 85.8136 264.63C86.6779 263.652 87.7438 262.873 88.938 262.347C90.1321 261.821 91.4262 261.56 92.7309 261.582L221.715 260.84C223.89 260.831 225.996 261.605 227.647 263.02C229.299 264.435 230.387 266.397 230.712 268.547L234.646 294.57C234.826 295.801 234.752 297.055 234.426 298.256C234.101 299.456 233.532 300.577 232.754 301.548C231.977 302.519 231.008 303.32 229.907 303.9C228.807 304.48 227.599 304.828 226.359 304.921Z",
      fill: "#36CEA2"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.6",
      d: "M226.359 304.921L98.1482 313.885C95.8562 314.057 93.5843 313.354 91.7896 311.918C89.9948 310.482 88.8103 308.42 88.4744 306.146L83.6375 271.869C83.4556 270.576 83.5559 269.26 83.9315 268.01C84.3072 266.761 84.9493 265.607 85.8136 264.63C86.6779 263.652 87.7438 262.873 88.938 262.347C90.1321 261.821 91.4262 261.56 92.7309 261.582L221.715 260.84C223.89 260.831 225.996 261.605 227.647 263.02C229.299 264.435 230.387 266.397 230.712 268.547L234.646 294.57C234.826 295.801 234.752 297.055 234.426 298.256C234.101 299.456 233.532 300.577 232.754 301.548C231.977 302.519 231.008 303.32 229.907 303.9C228.807 304.48 227.599 304.828 226.359 304.921Z",
      fill: "url(#paint17_radial_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M88.6679 306.146C87.2813 297.891 86.1204 289.636 84.8951 281.381C84.0268 277.278 83.5838 273.096 83.573 268.902C83.9786 266.792 85.1237 264.895 86.8023 263.553C88.4809 262.212 90.5831 261.513 92.7309 261.582C90.6788 261.69 88.722 262.482 87.173 263.832C85.624 265.182 84.5722 267.013 84.1857 269.031C84.274 273.164 84.6945 277.283 85.4433 281.349C86.5396 289.604 87.7005 297.859 88.6679 306.178V306.146Z",
      fill: "#D2EBF3"
    }), /* @__PURE__ */ jsx("path", {
      d: "M54.0033 92.2257L27.9485 82.4229L213.879 98.1912L253.445 106.124L54.0033 92.2257Z",
      fill: "url(#paint18_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M54.0033 92.2257L27.9485 82.4229L42.1368 83.616L78.8328 94.0959L54.0033 92.2257Z",
      fill: "url(#paint19_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.8",
      d: "M103.727 95.676L66.5471 85.6797L42.1368 83.616L78.8329 94.0959L103.727 95.676Z",
      fill: "url(#paint20_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.8",
      d: "M103.727 95.6762L66.547 85.6799L89.6674 87.6469L128.524 97.4175L103.727 95.6762Z",
      fill: "url(#paint21_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M128.524 97.4173L89.6998 87.6467L121.043 90.3876L153.579 99.1586L128.524 97.4173Z",
      fill: "url(#paint22_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.8",
      d: "M178.602 100.9L145.453 92.387L121.043 90.3877L153.579 99.1586L178.602 100.9Z",
      fill: "url(#paint23_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.8",
      d: "M175.249 100.255L144.906 92.29L161.029 93.9023L200.078 101.996L175.249 100.255Z",
      fill: "url(#paint24_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M201.335 101.964L161.027 93.3862L194.885 97.1273L229.003 103.899L201.335 101.964Z",
      fill: "url(#paint25_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.8",
      d: "M252.929 106.156L215.846 98.7393L191.661 97.127L229.003 103.899L252.929 106.156Z",
      fill: "url(#paint26_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M255.477 121.699L232.163 145.593L227.39 112.637L255.477 121.699Z",
      fill: "url(#paint27_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M236.129 145.851L232.163 145.593L252.929 123.601L254.058 127.309L236.129 145.851Z",
      fill: "#197DE3"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35.494 144.658L40.2342 144.367L60.8394 117.99L58.034 111.315L35.494 144.658Z",
      fill: "url(#paint28_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M70.965 124.762C64.0966 124.407 57.5507 117.571 56.3898 109.509L53.9069 92.2256L78.8331 94.0959L81.316 110.993C82.4769 118.958 77.8657 125.117 70.965 124.762Z",
      fill: "url(#paint29_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M95.8911 126.149C88.9904 125.794 82.4767 119.054 81.3159 111.09L78.8007 94.0959L103.759 95.8372L106.21 112.476C107.403 120.344 102.759 126.407 95.8911 126.149Z",
      fill: "url(#paint30_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M120.721 127.341C113.852 126.987 107.338 120.344 106.178 112.476L103.727 95.8369L128.653 97.546L131.104 113.959C132.297 121.731 127.686 127.728 120.721 127.341Z",
      fill: "url(#paint31_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M145.711 128.664C142.009 128.149 138.58 126.43 135.951 123.773C133.323 121.115 131.642 117.667 131.168 113.959L128.718 97.5461L153.676 99.2552L156.094 115.378C157.223 123.117 152.58 129.018 145.711 128.664Z",
      fill: "url(#paint32_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M170.605 129.954C166.952 129.445 163.565 127.754 160.962 125.14C158.36 122.525 156.684 119.131 156.191 115.475L153.773 99.3523L178.699 101.061L181.118 117.184C182.149 124.504 177.474 130.309 170.605 129.954Z",
      fill: "url(#paint33_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M195.531 131.244C191.88 130.785 188.482 129.137 185.859 126.556C183.237 123.974 181.537 120.602 181.021 116.958L178.602 100.835L203.561 102.577L205.947 118.313C207.075 125.858 202.4 131.598 195.531 131.244Z",
      fill: "url(#paint34_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M220.425 132.598C216.804 132.152 213.428 130.534 210.814 127.989C208.199 125.444 206.49 122.114 205.947 118.506L203.561 102.77L228.519 104.479L230.873 119.989C231.969 127.245 227.294 132.888 220.425 132.598Z",
      fill: "url(#paint35_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M245.319 133.823C241.722 133.407 238.361 131.822 235.751 129.311C233.142 126.801 231.428 123.503 230.873 119.925L228.519 104.415L253.445 106.124L255.799 121.44C256.175 122.977 256.182 124.581 255.819 126.121C255.456 127.661 254.734 129.093 253.712 130.3C252.69 131.508 251.397 132.457 249.938 133.069C248.48 133.681 246.897 133.939 245.319 133.823Z",
      fill: "url(#paint36_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M54.0033 92.2257L27.9485 82.4229L35.4941 144.658L57.2602 112.96L54.0033 92.2257Z",
      fill: "url(#paint37_linear_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M150.645 285.186C151.163 285.342 151.661 285.559 152.128 285.831C152.565 286.077 152.966 286.381 153.321 286.734C153.663 287.12 153.945 287.555 154.159 288.024C154.399 288.569 154.562 289.144 154.643 289.733C154.793 290.478 154.793 291.245 154.643 291.99C154.454 292.65 154.099 293.249 153.611 293.732C153.089 294.27 152.449 294.678 151.741 294.925C150.873 295.247 149.958 295.422 149.032 295.441L139.907 295.989L137.391 276.254H146.42C146.925 276.22 147.431 276.22 147.936 276.254C148.374 276.31 148.806 276.407 149.226 276.544L150.354 277.06C150.693 277.271 151.007 277.52 151.29 277.802L151.805 278.382C151.986 278.598 152.138 278.837 152.257 279.092C152.384 279.352 152.492 279.622 152.579 279.898C152.678 280.191 152.743 280.494 152.773 280.801C152.838 281.293 152.838 281.792 152.773 282.284C152.718 282.702 152.587 283.107 152.386 283.477C151.998 284.165 151.43 284.734 150.741 285.122L150.645 285.186ZM149.742 289.249C149.716 289 149.639 288.758 149.516 288.54C149.387 288.33 149.21 288.153 149 288.024C148.773 287.854 148.507 287.743 148.226 287.701C147.872 287.664 147.516 287.664 147.162 287.701H143.486L143.937 291.313L147.71 291.12C148.031 291.171 148.357 291.171 148.678 291.12C148.917 291.037 149.137 290.905 149.323 290.733C149.508 290.583 149.643 290.381 149.709 290.152C149.775 289.909 149.775 289.653 149.709 289.411L149.742 289.249ZM142.486 280.672L142.938 283.896H146.162C146.48 283.883 146.794 283.828 147.098 283.735C147.35 283.695 147.585 283.583 147.775 283.413C147.939 283.264 148.062 283.075 148.129 282.865C148.198 282.622 148.198 282.365 148.129 282.123C148.088 281.877 148.012 281.638 147.904 281.413C147.776 281.222 147.612 281.057 147.42 280.93C147.203 280.784 146.963 280.675 146.711 280.607C146.389 280.572 146.065 280.572 145.743 280.607H142.519",
      fill: "#F2F6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M187.696 275.706L184.116 286.605L185.181 293.312L181.15 293.57L180.086 286.831L172.701 275.867L177.409 275.835L181.408 282.155L183.342 275.77L187.696 275.706Z",
      fill: "#F2F6FF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M170.508 275.899L172.024 285.863C172.215 287.135 172.215 288.429 172.024 289.701C171.88 290.673 171.516 291.599 170.96 292.409C170.428 293.145 169.718 293.733 168.896 294.118C167.958 294.527 166.952 294.757 165.929 294.796C164.842 294.887 163.747 294.766 162.705 294.441C161.744 294.164 160.861 293.667 160.125 292.99C159.311 292.265 158.663 291.375 158.223 290.378C157.669 289.172 157.299 287.889 157.126 286.573L155.643 276.061H160.222L161.705 286.347C161.78 286.948 161.943 287.535 162.189 288.088C162.361 288.545 162.625 288.962 162.963 289.314C163.242 289.625 163.598 289.858 163.995 289.991C164.382 290.152 164.802 290.218 165.22 290.184C165.634 290.176 166.041 290.077 166.413 289.894C166.74 289.719 167.018 289.464 167.219 289.153C167.429 288.774 167.561 288.357 167.606 287.927C167.686 287.371 167.686 286.807 167.606 286.25L166.091 275.996L170.508 275.899Z",
      fill: "#F2F6FF"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.6",
      children: /* @__PURE__ */ jsxs("g", {
        opacity: "0.6",
        children: [/* @__PURE__ */ jsx("path", {
          d: "M273.406 205.474C275.936 205.679 278.307 206.79 280.084 208.602C281.861 210.415 282.925 212.808 283.079 215.341L285.337 235.785C285.524 236.945 285.465 238.132 285.162 239.267C284.86 240.402 284.321 241.461 283.582 242.374C282.842 243.287 281.918 244.034 280.87 244.565C279.823 245.097 278.674 245.402 277.501 245.459L206.559 246.781C204.056 246.595 201.702 245.516 199.926 243.741C198.151 241.965 197.072 239.611 196.886 237.107L194.886 213.826C194.704 212.666 194.767 211.482 195.072 210.349C195.376 209.215 195.915 208.159 196.654 207.247C197.392 206.335 198.314 205.588 199.359 205.055C200.405 204.522 201.55 204.214 202.722 204.152L273.406 205.474Z",
          fill: "url(#paint38_radial_10025_65882)"
        }), /* @__PURE__ */ jsx("path", {
          d: "M273.406 205.474C275.936 205.679 278.307 206.79 280.084 208.602C281.861 210.415 282.925 212.808 283.079 215.341L285.337 235.785C285.524 236.945 285.465 238.132 285.162 239.267C284.86 240.402 284.321 241.461 283.582 242.374C282.842 243.287 281.918 244.034 280.87 244.565C279.823 245.097 278.674 245.402 277.501 245.459L206.559 246.781C204.056 246.595 201.702 245.516 199.926 243.741C198.151 241.965 197.072 239.611 196.886 237.107L194.886 213.826C194.704 212.666 194.767 211.482 195.072 210.349C195.376 209.215 195.915 208.159 196.654 207.247C197.392 206.335 198.314 205.588 199.359 205.055C200.405 204.522 201.55 204.214 202.722 204.152L273.406 205.474Z",
          fill: "url(#paint39_radial_10025_65882)"
        })]
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M277.501 245.653L206.56 246.975C204.056 246.788 201.702 245.709 199.926 243.934C198.151 242.159 197.072 239.805 196.886 237.301L194.886 213.826C194.616 211.938 194.959 210.014 195.865 208.337C196.77 206.659 198.191 205.316 199.917 204.507L195.951 206.119C194.214 206.916 192.785 208.256 191.877 209.937C190.97 211.619 190.634 213.549 190.92 215.438L193.145 238.784C193.344 241.283 194.427 243.63 196.2 245.403C197.973 247.176 200.32 248.259 202.819 248.458H223.585C224.585 248.458 275.566 246.942 276.437 246.588L280.403 245.008C279.484 245.401 278.5 245.62 277.501 245.653Z",
      fill: "url(#paint40_radial_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M277.501 245.653L206.56 246.975C204.056 246.788 201.702 245.709 199.926 243.934C198.151 242.159 197.072 239.805 196.886 237.301L194.886 213.826C194.616 211.938 194.959 210.014 195.865 208.337C196.77 206.659 198.191 205.316 199.917 204.507L195.951 206.119C194.214 206.916 192.785 208.256 191.877 209.937C190.97 211.619 190.634 213.549 190.92 215.438L193.145 238.784C193.344 241.283 194.427 243.63 196.2 245.403C197.973 247.176 200.32 248.259 202.819 248.458H223.585C224.585 248.458 275.566 246.942 276.437 246.588L280.403 245.008C279.484 245.401 278.5 245.62 277.501 245.653Z",
      fill: "url(#paint41_radial_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M211.009 216.76C213.299 216.76 214.685 218.34 214.976 221.468L215.814 230.368C216.104 233.238 215.427 235.237 212.589 235.237C209.752 235.237 208.881 233.27 208.623 230.4L207.785 221.629C207.43 218.372 208.559 216.76 211.009 216.76ZM213.654 230.561L212.783 221.306C212.783 219.759 212.073 219.017 211.138 219.017C210.203 219.017 209.784 219.694 209.945 221.371L210.816 230.626C210.816 232.173 211.461 232.947 212.46 232.947C213.46 232.947 213.815 232.27 213.654 230.561Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M220.812 231.045L221.167 235.011H218.974L218.587 231.045H220.812Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M225.843 216.76C228.326 216.76 229.293 218.501 229.519 220.984V221.661C229.713 223.725 229.197 224.692 228.326 225.112C229.033 225.429 229.626 225.954 230.029 226.616C230.432 227.278 230.625 228.046 230.583 228.82V230.303C230.873 233.205 230.261 235.237 227.359 235.237C224.456 235.237 223.683 233.592 223.425 231.077V230.529H225.456V231.077C225.456 232.173 225.972 233.205 227.133 233.205C228.294 233.205 228.519 232.27 228.39 230.626L228.197 228.852C228.036 227.014 227.391 226.337 226.004 226.337H225.327L225.134 224.176H225.779C226.972 224.176 227.423 223.628 227.262 221.919V220.92C227.262 219.759 226.843 218.824 225.843 218.824C224.843 218.824 224.618 219.759 224.714 220.823V221.5H222.941V220.984C222.715 219.081 223.005 216.76 225.843 216.76Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M239.773 228.304H241.031V230.368H240.031L240.45 235.011H238.419L237.967 230.368H233.453L233.259 228.53L235.807 216.986H238.741L239.773 228.304ZM237.387 224.628C237.193 222.855 237.097 221.081 236.968 219.308C236.452 222.339 235.904 225.305 235.323 228.304H237.709L237.387 224.628Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M253.091 216.502L253.284 218.791H249.415L249.931 224.048H253.575L253.8 226.337H250.124L250.737 232.722H254.929L254.864 235.011H248.738L246.996 216.502H253.091Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M262.829 216.502L263.055 218.791H260.411L261.958 235.011H259.733L258.186 218.791H255.509L255.316 216.502H262.829Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M272.728 216.502L274.502 235.011H272.277L271.439 226.208H268.407L269.246 235.011H267.021L265.28 216.502H267.505L268.182 223.983H271.213L270.503 216.502H272.728Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.6",
      children: /* @__PURE__ */ jsxs("g", {
        opacity: "0.6",
        children: [/* @__PURE__ */ jsxs("g", {
          opacity: "0.6",
          children: [/* @__PURE__ */ jsx("path", {
            d: "M283.66 255.133C285.293 255.274 286.818 256.007 287.946 257.196C289.075 258.384 289.73 259.944 289.787 261.582L291.625 275.803C291.754 276.542 291.724 277.301 291.537 278.028C291.35 278.755 291.01 279.434 290.541 280.02C290.071 280.606 289.482 281.085 288.812 281.425C288.143 281.765 287.409 281.959 286.659 281.994H272.31C270.717 281.872 269.223 281.178 268.102 280.04C266.982 278.902 266.312 277.397 266.215 275.803L264.796 261.098C264.702 260.386 264.754 259.661 264.949 258.97C265.144 258.278 265.479 257.633 265.931 257.075C266.384 256.517 266.946 256.056 267.582 255.723C268.219 255.389 268.916 255.188 269.633 255.133H283.66Z",
            fill: "url(#paint42_radial_10025_65882)"
          }), /* @__PURE__ */ jsx("path", {
            d: "M283.66 255.133C285.293 255.274 286.818 256.007 287.946 257.196C289.075 258.384 289.73 259.944 289.787 261.582L291.625 275.803C291.754 276.542 291.724 277.301 291.537 278.028C291.35 278.755 291.01 279.434 290.541 280.02C290.071 280.606 289.482 281.085 288.812 281.425C288.143 281.765 287.409 281.959 286.659 281.994H272.31C270.717 281.872 269.223 281.178 268.102 280.04C266.982 278.902 266.312 277.397 266.215 275.803L264.796 261.098C264.702 260.386 264.754 259.661 264.949 258.97C265.144 258.278 265.479 257.633 265.931 257.075C266.384 256.517 266.946 256.056 267.582 255.723C268.219 255.389 268.916 255.188 269.633 255.133H283.66Z",
            fill: "url(#paint43_radial_10025_65882)"
          })]
        }), /* @__PURE__ */ jsxs("g", {
          opacity: "0.6",
          children: [/* @__PURE__ */ jsx("path", {
            d: "M283.66 255.133C285.293 255.274 286.818 256.007 287.946 257.196C289.075 258.384 289.73 259.944 289.787 261.582L291.625 275.803C291.754 276.542 291.724 277.301 291.537 278.028C291.35 278.755 291.01 279.434 290.541 280.02C290.071 280.606 289.482 281.085 288.812 281.425C288.143 281.765 287.409 281.959 286.659 281.994H272.31C270.717 281.872 269.223 281.178 268.102 280.04C266.982 278.902 266.312 277.397 266.215 275.803L264.796 261.098C264.702 260.386 264.754 259.661 264.949 258.97C265.144 258.278 265.479 257.633 265.931 257.075C266.384 256.517 266.946 256.056 267.582 255.723C268.219 255.389 268.916 255.188 269.633 255.133H283.66Z",
            fill: "url(#paint44_radial_10025_65882)"
          }), /* @__PURE__ */ jsx("path", {
            d: "M283.66 255.133C285.293 255.274 286.818 256.007 287.946 257.196C289.075 258.384 289.73 259.944 289.787 261.582L291.625 275.803C291.754 276.542 291.724 277.301 291.537 278.028C291.35 278.755 291.01 279.434 290.541 280.02C290.071 280.606 289.482 281.085 288.812 281.425C288.143 281.765 287.409 281.959 286.659 281.994H272.31C270.717 281.872 269.223 281.178 268.102 280.04C266.982 278.902 266.312 277.397 266.215 275.803L264.796 261.098C264.702 260.386 264.754 259.661 264.949 258.97C265.144 258.278 265.479 257.633 265.931 257.075C266.384 256.517 266.946 256.056 267.582 255.723C268.219 255.389 268.916 255.188 269.633 255.133H283.66Z",
            fill: "url(#paint45_radial_10025_65882)"
          })]
        })]
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M286.562 281.994H272.212C270.62 281.872 269.126 281.178 268.005 280.04C266.885 278.902 266.214 277.397 266.118 275.803L264.699 261.098C264.529 259.903 264.751 258.685 265.333 257.626C265.914 256.568 266.823 255.727 267.924 255.229L265.408 256.229C264.306 256.732 263.395 257.579 262.814 258.643C262.233 259.707 262.012 260.93 262.184 262.13L263.603 276.834C263.668 278.455 264.324 279.995 265.446 281.165C266.569 282.335 268.081 283.054 269.697 283.187H282.789C283.816 283.136 284.834 282.963 285.82 282.671L288.335 281.671C287.771 281.895 287.169 282.005 286.562 281.994Z",
      fill: "url(#paint46_radial_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M286.562 281.994H272.212C270.62 281.872 269.126 281.178 268.005 280.04C266.885 278.902 266.214 277.397 266.118 275.803L264.699 261.098C264.529 259.903 264.751 258.685 265.333 257.626C265.914 256.568 266.823 255.727 267.924 255.229L265.408 256.229C264.306 256.732 263.395 257.579 262.814 258.643C262.233 259.707 262.012 260.93 262.184 262.13L263.603 276.834C263.668 278.455 264.324 279.995 265.446 281.165C266.569 282.335 268.081 283.054 269.697 283.187H282.789C283.816 283.136 284.834 282.963 285.82 282.671L288.335 281.671C287.771 281.895 287.169 282.005 286.562 281.994Z",
      fill: "url(#paint47_radial_10025_65882)"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.6",
      children: /* @__PURE__ */ jsxs("g", {
        opacity: "0.6",
        children: [/* @__PURE__ */ jsxs("g", {
          opacity: "0.6",
          children: [/* @__PURE__ */ jsx("path", {
            d: "M257.778 277.705C258.608 277.778 259.387 278.141 259.977 278.731C260.566 279.32 260.93 280.099 261.002 280.93L261.905 288.54C261.969 288.927 261.951 289.323 261.851 289.702C261.75 290.081 261.571 290.435 261.324 290.74C261.077 291.044 260.769 291.293 260.419 291.47C260.069 291.647 259.685 291.747 259.293 291.765H251.683C250.85 291.698 250.068 291.337 249.477 290.746C248.886 290.155 248.525 289.373 248.458 288.54L247.749 280.93C247.685 280.546 247.703 280.152 247.801 279.775C247.899 279.398 248.076 279.046 248.319 278.742C248.562 278.437 248.867 278.188 249.213 278.009C249.56 277.831 249.94 277.727 250.329 277.705H257.778Z",
            fill: "url(#paint48_radial_10025_65882)"
          }), /* @__PURE__ */ jsx("path", {
            d: "M257.778 277.705C258.608 277.778 259.387 278.141 259.977 278.731C260.566 279.32 260.93 280.099 261.002 280.93L261.905 288.54C261.969 288.927 261.951 289.323 261.851 289.702C261.75 290.081 261.571 290.435 261.324 290.74C261.077 291.044 260.769 291.293 260.419 291.47C260.069 291.647 259.685 291.747 259.293 291.765H251.683C250.85 291.698 250.068 291.337 249.477 290.746C248.886 290.155 248.525 289.373 248.458 288.54L247.749 280.93C247.685 280.546 247.703 280.152 247.801 279.775C247.899 279.398 248.076 279.046 248.319 278.742C248.562 278.437 248.867 278.188 249.213 278.009C249.56 277.831 249.94 277.727 250.329 277.705H257.778Z",
            fill: "url(#paint49_radial_10025_65882)"
          })]
        }), /* @__PURE__ */ jsxs("g", {
          opacity: "0.6",
          children: [/* @__PURE__ */ jsx("path", {
            d: "M257.778 277.705C258.608 277.778 259.387 278.141 259.977 278.731C260.566 279.32 260.93 280.099 261.002 280.93L261.905 288.54C261.969 288.927 261.951 289.323 261.851 289.702C261.75 290.081 261.571 290.435 261.324 290.74C261.077 291.044 260.769 291.293 260.419 291.47C260.069 291.647 259.685 291.747 259.293 291.765H251.683C250.85 291.698 250.068 291.337 249.477 290.746C248.886 290.155 248.525 289.373 248.458 288.54L247.749 280.93C247.685 280.546 247.703 280.152 247.801 279.775C247.899 279.398 248.076 279.046 248.319 278.742C248.562 278.437 248.867 278.188 249.213 278.009C249.56 277.831 249.94 277.727 250.329 277.705H257.778Z",
            fill: "url(#paint50_radial_10025_65882)"
          }), /* @__PURE__ */ jsx("path", {
            d: "M257.778 277.705C258.608 277.778 259.387 278.141 259.977 278.731C260.566 279.32 260.93 280.099 261.002 280.93L261.905 288.54C261.969 288.927 261.951 289.323 261.851 289.702C261.75 290.081 261.571 290.435 261.324 290.74C261.077 291.044 260.769 291.293 260.419 291.47C260.069 291.647 259.685 291.747 259.293 291.765H251.683C250.85 291.698 250.068 291.337 249.477 290.746C248.886 290.155 248.525 289.373 248.458 288.54L247.749 280.93C247.685 280.546 247.703 280.152 247.801 279.775C247.899 279.398 248.076 279.046 248.319 278.742C248.562 278.437 248.867 278.188 249.213 278.009C249.56 277.831 249.94 277.727 250.329 277.705H257.778Z",
            fill: "url(#paint51_radial_10025_65882)"
          })]
        })]
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M259.229 291.829H251.619C250.786 291.763 250.004 291.402 249.413 290.811C248.822 290.22 248.461 289.438 248.394 288.605L247.749 280.93C247.622 280.266 247.734 279.578 248.064 278.989C248.394 278.399 248.922 277.944 249.555 277.706L248.201 278.222C247.607 278.501 247.121 278.968 246.818 279.551C246.515 280.133 246.412 280.799 246.524 281.446L247.298 289.25C247.358 290.085 247.717 290.871 248.309 291.463C248.901 292.055 249.687 292.414 250.522 292.474H257.455C258 292.438 258.539 292.352 259.068 292.216L260.39 291.668C260.023 291.82 259.623 291.876 259.229 291.829Z",
      fill: "url(#paint52_radial_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M259.229 291.829H251.619C250.786 291.763 250.004 291.402 249.413 290.811C248.822 290.22 248.461 289.438 248.394 288.605L247.749 280.93C247.622 280.266 247.734 279.578 248.064 278.989C248.394 278.399 248.922 277.944 249.555 277.706L248.201 278.222C247.607 278.501 247.121 278.968 246.818 279.551C246.515 280.133 246.412 280.799 246.524 281.446L247.298 289.25C247.358 290.085 247.717 290.871 248.309 291.463C248.901 292.055 249.687 292.414 250.522 292.474H257.455C258 292.438 258.539 292.352 259.068 292.216L260.39 291.668C260.023 291.82 259.623 291.876 259.229 291.829Z",
      fill: "url(#paint53_radial_10025_65882)"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.6",
      children: /* @__PURE__ */ jsxs("g", {
        opacity: "0.6",
        children: [/* @__PURE__ */ jsxs("g", {
          opacity: "0.6",
          children: [/* @__PURE__ */ jsx("path", {
            d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
            fill: "url(#paint54_radial_10025_65882)"
          }), /* @__PURE__ */ jsx("path", {
            d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
            fill: "url(#paint55_radial_10025_65882)"
          }), /* @__PURE__ */ jsx("path", {
            d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
            fill: "url(#paint56_radial_10025_65882)"
          })]
        }), /* @__PURE__ */ jsxs("g", {
          opacity: "0.6",
          children: [/* @__PURE__ */ jsx("path", {
            d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
            fill: "url(#paint57_radial_10025_65882)"
          }), /* @__PURE__ */ jsx("path", {
            d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
            fill: "url(#paint58_radial_10025_65882)"
          }), /* @__PURE__ */ jsx("path", {
            d: "M42.6676 158.524C45.1455 158.722 47.4676 159.811 49.2045 161.59C50.9414 163.368 51.9756 165.715 52.1157 168.197L54.7921 190.35C55.0158 191.497 54.9897 192.678 54.7155 193.814C54.4412 194.949 53.9254 196.012 53.2032 196.931C52.4809 197.849 51.5691 198.6 50.5301 199.134C49.491 199.668 48.349 199.972 47.182 200.024L24.9967 200.314C22.5197 200.122 20.1976 199.033 18.4647 197.253C16.7318 195.473 15.7066 193.122 15.5809 190.641L13.3881 168.068C13.1755 166.923 13.2096 165.745 13.4881 164.614C13.7667 163.483 14.2834 162.425 15.0036 161.509C15.7239 160.593 16.6311 159.842 17.6649 159.305C18.6986 158.768 19.835 158.458 20.9982 158.395L42.6676 158.524Z",
            fill: "url(#paint59_radial_10025_65882)"
          })]
        })]
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M47.1175 199.8L24.9322 200.09C22.4552 199.897 20.1331 198.809 18.4002 197.028C16.6673 195.248 15.6421 192.897 15.5164 190.416L13.3236 167.844C13.0577 166.003 13.3905 164.125 14.2731 162.488C15.1556 160.85 16.5411 159.54 18.225 158.75L14.42 160.234C12.7353 161.014 11.3478 162.317 10.4645 163.95C9.58124 165.583 9.24943 167.458 9.51859 169.295L11.7113 191.867C11.8302 194.351 12.8532 196.705 14.5875 198.487C16.3217 200.269 18.6477 201.355 21.1272 201.541H41.3455C42.9272 201.451 44.4948 201.192 46.0211 200.767L49.8907 199.187C49.0191 199.582 48.0745 199.791 47.1175 199.8Z",
      fill: "url(#paint60_radial_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.6",
      d: "M51.053 212.408C54.5016 212.68 57.7366 214.186 60.1648 216.65C62.5931 219.113 64.0519 222.37 64.2739 225.822L68.0467 256.778C68.3226 258.37 68.2574 260.003 67.8555 261.567C67.4535 263.132 66.724 264.594 65.715 265.856C64.7061 267.118 63.4408 268.151 62.0028 268.888C60.5648 269.624 58.9869 270.047 57.3733 270.128L26.3848 270.515C22.9451 270.257 19.715 268.763 17.2908 266.31C14.8667 263.856 13.4123 260.608 13.1961 257.165L10.165 225.435C9.45557 218.051 14.228 212.021 20.7739 212.021L51.053 212.408Z",
      fill: "url(#paint61_radial_10025_65882)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M57.373 270.128L26.3846 270.515C22.9449 270.257 19.7148 268.763 17.2906 266.31C14.8665 263.856 13.4121 260.608 13.1959 257.165L10.1648 225.435C9.77389 222.867 10.2295 220.241 11.4628 217.955C12.6961 215.669 14.6401 213.846 17.001 212.762L11.6481 215.052C9.29976 216.129 7.36064 217.934 6.1178 220.199C4.87497 222.464 4.39447 225.069 4.74744 227.628L7.77857 259.358C8.00134 262.798 9.45793 266.043 11.8808 268.495C14.3036 270.947 17.53 272.443 20.9672 272.708H49.2148C51.399 272.587 53.5625 272.219 55.664 271.612L61.0813 269.451C59.8961 269.898 58.6399 270.128 57.373 270.128Z",
      fill: "url(#paint62_radial_10025_65882)"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_10025_65882",
        x1: "31.6244",
        y1: "213.374",
        x2: "261.152",
        y2: "213.374",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_10025_65882",
        x1: "24.4016",
        y1: "212.02",
        x2: "256.348",
        y2: "212.02",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_10025_65882",
        x1: "143.002",
        y1: "186.83",
        x2: "142.813",
        y2: "109.207",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#D6FAF8",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.16",
          stopColor: "#C1E9EF",
          stopOpacity: "0.13"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#8CBED7",
          stopOpacity: "0.47"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3879B2"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint3_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(138.392 214.244) rotate(-0.572939) scale(121.413 109.248)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_10025_65882",
        x1: "114.948",
        y1: "267.967",
        x2: "140.229",
        y2: "184.353",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#BAE3EB",
          stopOpacity: "0.18"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#A4D1E2",
          stopOpacity: "0.32"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#80B4D2",
          stopOpacity: "0.55"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_10025_65882",
        x1: "174.81",
        y1: "109.23",
        x2: "183.156",
        y2: "193.603",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5D1780"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.25",
          stopColor: "#6C2E93"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#946AC3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A584D8"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint6_linear_10025_65882",
        x1: "237.403",
        y1: "338.905",
        x2: "291.117",
        y2: "445.224",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5D1780"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.25",
          stopColor: "#6C2E93"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#946AC3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A584D8"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint7_linear_10025_65882",
        x1: "160.738",
        y1: "171.874",
        x2: "166.413",
        y2: "201.766",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#47B2C4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#5EC9D3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.75",
          stopColor: "#73DFE2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint8_linear_10025_65882",
        x1: "156.718",
        y1: "161.256",
        x2: "160.027",
        y2: "189.578",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#95D3E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#B8F5F9"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint9_linear_10025_65882",
        x1: "144.118",
        y1: "134.475",
        x2: "148.455",
        y2: "194.873",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#00728B"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.24",
          stopColor: "#17879E"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.66",
          stopColor: "#47B2C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint10_linear_10025_65882",
        x1: "412.715",
        y1: "410.599",
        x2: "422.894",
        y2: "465.382",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#47B2C4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#5EC9D3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.75",
          stopColor: "#73DFE2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint11_linear_10025_65882",
        x1: "378.488",
        y1: "284.518",
        x2: "389.411",
        y2: "414.295",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5D1780"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.25",
          stopColor: "#6C2E93"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#946AC3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A584D8"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint12_linear_10025_65882",
        x1: "338.282",
        y1: "319.5",
        x2: "354.175",
        y2: "470.597",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5D1780"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.25",
          stopColor: "#6C2E93"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#946AC3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A584D8"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint13_linear_10025_65882",
        x1: "151.311",
        y1: "161.88",
        x2: "154.62",
        y2: "190.202",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#B8F5F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#B8F5F9"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint14_linear_10025_65882",
        x1: "5788.58",
        y1: "4300.86",
        x2: "6145.7",
        y2: "7689.68",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5D1780"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.25",
          stopColor: "#6C2E93"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#946AC3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A584D8"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint15_linear_10025_65882",
        x1: "127.105",
        y1: "230.4",
        x2: "117.657",
        y2: "162.812",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.1",
          stopColor: "#572C5F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3E0F55"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint16_linear_10025_65882",
        x1: "122.461",
        y1: "329.794",
        x2: "126.278",
        y2: "291.478",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#BAE3EB",
          stopOpacity: "0.18"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#A4D1E2",
          stopOpacity: "0.32"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#80B4D2",
          stopOpacity: "0.55"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint17_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(159.505 259.477) rotate(-4.51) scale(84.388 61.6033)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#3CD1A9",
          stopOpacity: "0.6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#3ED1AA",
          stopOpacity: "0.61"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D4E8E6"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint18_linear_10025_65882",
        x1: "27.9485",
        y1: "94.2572",
        x2: "253.445",
        y2: "94.2572",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint19_linear_10025_65882",
        x1: "752.032",
        y1: "225.418",
        x2: "1554.99",
        y2: "225.418",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint20_linear_10025_65882",
        x1: "1189.56",
        y1: "236.537",
        x2: "2365.93",
        y2: "236.537",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint21_linear_10025_65882",
        x1: "73.8991",
        y1: "84.7448",
        x2: "118.012",
        y2: "97.4175",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#EAAFBD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E03760"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint22_linear_10025_65882",
        x1: "2222",
        y1: "247.086",
        x2: "3487.45",
        y2: "247.086",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint23_linear_10025_65882",
        x1: "2601.85",
        y1: "243.235",
        x2: "3628.7",
        y2: "243.235",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint24_linear_10025_65882",
        x1: "3279.46",
        y1: "237.918",
        x2: "3557.44",
        y2: "659.814",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#EAAFBD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#ED1818"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint25_linear_10025_65882",
        x1: "3271.89",
        y1: "271.167",
        x2: "4074.84",
        y2: "271.167",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint26_linear_10025_65882",
        x1: "4207.98",
        y1: "283.477",
        x2: "5384.35",
        y2: "283.477",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint27_linear_10025_65882",
        x1: "2363.92",
        y1: "933.888",
        x2: "2608.83",
        y2: "933.888",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint28_linear_10025_65882",
        x1: "35.494",
        y1: "127.986",
        x2: "60.8394",
        y2: "127.986",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#29A2D9",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3879B2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint29_linear_10025_65882",
        x1: "668.567",
        y1: "695.393",
        x2: "904.444",
        y2: "695.393",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint30_linear_10025_65882",
        x1: "906.961",
        y1: "703.887",
        x2: "1142.91",
        y2: "703.887",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint31_linear_10025_65882",
        x1: "103.791",
        y1: "111.605",
        x2: "131.33",
        y2: "111.605",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#E05986"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#E03760"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint32_linear_10025_65882",
        x1: "1381.51",
        y1: "718.643",
        x2: "1616.75",
        y2: "718.643",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint33_linear_10025_65882",
        x1: "1616.65",
        y1: "724.551",
        x2: "1851.11",
        y2: "724.551",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint34_linear_10025_65882",
        x1: "1855.5",
        y1: "736.385",
        x2: "2090.19",
        y2: "736.385",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#EF296B"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#ED1818"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint35_linear_10025_65882",
        x1: "2090.6",
        y1: "740.117",
        x2: "2324.66",
        y2: "740.117",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint36_linear_10025_65882",
        x1: "2335.46",
        y1: "746.7",
        x2: "2570.06",
        y2: "746.7",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint37_linear_10025_65882",
        x1: "445.054",
        y1: "1332.72",
        x2: "711.497",
        y2: "1332.72",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#90CFEB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint38_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(240.03 219.662) rotate(1.36393) scale(67.736 31.6774)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.833401",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint39_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(247.658 213.622) scale(93.3566 43.6163)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#BCDBD5",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BDE9DC"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint40_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(6604.02 2346.26) scale(2290.62 1123.84)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint41_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(235.529 220.498) rotate(1.4231) scale(66.9333 32.659)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.833401",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint42_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(2758.17 2023.66) scale(231.795 231.005)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint43_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(280.47 261.1) scale(27.755 27.4829)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#BCDBD5",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BDE9DC"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint44_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(2758.17 2023.66) scale(231.795 231.005)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint45_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(280.47 261.1) scale(27.755 27.4829)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#BCDBD5",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BDE9DC"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint46_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(2591.27 2054.28) scale(280.168 298.864)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint47_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(275.207 265.402) rotate(3.09178) scale(19.6047 20.7505)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.833401",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint48_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(1457.51 1303.19) scale(64.8943 64.1104)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint49_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(256.011 280.829) scale(14.6547 14.3848)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#BCDBD5",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BDE9DC"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint50_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(1457.51 1303.19) scale(64.8943 64.1104)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint51_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(256.011 280.829) scale(14.6547 14.3848)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#BCDBD5",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#BDE9DC"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint52_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(1402.11 1343.27) scale(78.7295 83.5909)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint53_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(253.422 283.079) rotate(3.07736) scale(10.4048 10.9618)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.833401",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint54_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(37.6049 167.52) scale(42.7906)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint55_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(37.5659 167.707) scale(42.9326 42.8905)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint56_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(37.5659 167.707) scale(42.9326 42.8905)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint57_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(37.6049 167.52) scale(42.7906)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint58_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(37.5659 167.707) scale(42.9326 42.8905)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint59_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(37.5659 167.707) scale(42.9326 42.8905)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint60_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(33.0263 168.257) scale(41.6671 43.7813)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint61_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(43.9911 225.016) scale(59.8487)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint62_radial_10025_65882",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(37.5552 226.08) scale(58.1264 61.3334)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#C1E8E0",
          stopOpacity: "0.8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7F9EF"
        })]
      })]
    })]
  });
};
const pack = (width = "300", height = "398") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 300 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M296.004 225.257C299.318 198.067 294.495 170.505 282.146 146.056C269.796 121.608 250.475 101.369 226.624 87.9006C202.773 74.432 175.465 68.3379 148.151 70.3889C120.837 72.4398 94.7442 82.5437 73.1722 99.4229C51.6003 116.302 35.5176 139.199 26.9578 165.218C18.398 191.237 17.7454 219.21 25.0825 245.6C32.4196 271.99 47.4169 295.611 68.1782 313.478C88.9396 331.345 114.533 342.655 141.721 345.977C159.779 348.184 178.094 346.812 195.621 341.939C213.148 337.066 229.543 328.788 243.87 317.577C258.197 306.367 270.175 292.444 279.12 276.603C288.066 260.763 293.803 243.315 296.004 225.257Z",
      fill: "#EDC418"
    }), /* @__PURE__ */ jsx("path", {
      d: "M133.959 106.759L25.156 114.682L19.9059 127.373L135.344 116.422L133.959 106.759Z",
      fill: "url(#paint0_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M133.959 144.669L36.0424 149.984L19.9377 127.437L135.344 116.422L133.959 144.669Z",
      fill: "url(#paint1_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M147.777 136.359L36.0425 148.857L60.5215 164.349L170.194 152.078C170.342 152.054 170.48 151.987 170.589 151.884C170.698 151.781 170.773 151.647 170.804 151.501C170.836 151.354 170.822 151.202 170.765 151.063C170.708 150.924 170.61 150.806 170.484 150.725L147.777 136.359Z",
      fill: "url(#paint2_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M147.777 136.359L36.0425 148.856L20.8075 126.567L135.344 116.422L147.777 136.359Z",
      fill: "url(#paint3_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M133.959 106.759L25.1558 114.682L20.8075 126.568L135.344 116.422L133.959 106.759Z",
      fill: "url(#paint4_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M147.777 136.359L36.0425 148.857L60.5215 164.349L170.033 152.078C170.2 152.067 170.359 152.002 170.487 151.893C170.614 151.784 170.702 151.637 170.738 151.474C170.775 151.31 170.757 151.139 170.688 150.987C170.619 150.834 170.502 150.709 170.355 150.628L147.777 136.359ZM40.7128 149.919L147.39 138.002L167.585 150.886L60.8758 162.707L40.7128 149.919Z",
      fill: "url(#paint5_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M154.058 272.379V139.612C154.063 138.956 153.928 138.305 153.661 137.705C153.394 137.105 153.002 136.568 152.511 136.132C152.019 135.696 151.441 135.37 150.813 135.176C150.186 134.981 149.524 134.924 148.872 135.007L55.465 143.542C54.065 143.667 52.7588 144.299 51.792 145.319C50.8252 146.339 50.2643 147.677 50.2149 149.082V281.881C50.209 282.537 50.3442 283.186 50.6113 283.785C50.8784 284.384 51.2712 284.918 51.7631 285.352C52.2549 285.786 52.8343 286.109 53.4619 286.299C54.0895 286.489 54.7507 286.542 55.4006 286.455L148.808 277.919C150.208 277.794 151.514 277.162 152.481 276.142C153.447 275.122 154.008 273.784 154.058 272.379Z",
      fill: "url(#paint6_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M148.421 270.382V137.583C148.422 136.929 148.283 136.282 148.014 135.686C147.745 135.089 147.352 134.557 146.862 134.124C146.371 133.692 145.794 133.368 145.169 133.176C144.543 132.984 143.884 132.927 143.235 133.009L49.8283 141.545C48.4373 141.678 47.1427 142.314 46.1878 143.334C45.2328 144.354 44.6834 145.688 44.6426 147.085V279.852C44.6374 280.508 44.7727 281.159 45.0396 281.759C45.3064 282.359 45.6985 282.896 46.1897 283.332C46.6809 283.768 47.2596 284.094 47.8872 284.288C48.5148 284.483 49.1766 284.54 49.8283 284.458L143.235 275.922C144.624 275.783 145.914 275.144 146.868 274.125C147.822 273.107 148.373 271.777 148.421 270.382Z",
      fill: "url(#paint7_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M150.321 271.542V138.743C150.322 138.089 150.183 137.442 149.914 136.845C149.645 136.249 149.253 135.717 148.762 135.284C148.271 134.851 147.694 134.528 147.069 134.336C146.444 134.144 145.784 134.087 145.136 134.169L51.7285 142.705C50.3343 142.837 49.0359 143.472 48.0757 144.491C47.1155 145.511 46.5592 146.845 46.5106 148.245V281.011C46.5054 281.668 46.6408 282.319 46.9076 282.919C47.1744 283.519 47.5666 284.055 48.0577 284.492C48.5489 284.928 49.1277 285.254 49.7552 285.448C50.3828 285.642 51.0447 285.7 51.6963 285.617L145.103 277.082C146.5 276.956 147.802 276.323 148.764 275.302C149.726 274.281 150.28 272.944 150.321 271.542Z",
      fill: "url(#paint8_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M152.672 272.766V139.967C152.673 139.312 152.534 138.666 152.265 138.069C151.997 137.473 151.604 136.941 151.113 136.508C150.623 136.075 150.045 135.752 149.42 135.56C148.795 135.367 148.136 135.311 147.487 135.393L54.0798 143.928C52.6887 144.061 51.3941 144.698 50.4392 145.718C49.4843 146.738 48.9348 148.072 48.8941 149.468V282.235C48.8888 282.892 49.0242 283.542 49.291 284.143C49.5579 284.743 49.95 285.279 50.4412 285.715C50.9323 286.152 51.5111 286.478 52.1387 286.672C52.7662 286.866 53.4281 286.924 54.0798 286.841L147.487 278.306C148.878 278.173 150.172 277.536 151.127 276.516C152.082 275.496 152.632 274.162 152.672 272.766Z",
      fill: "url(#paint9_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M154.218 273.861V141.094C154.224 140.437 154.088 139.787 153.821 139.186C153.555 138.586 153.162 138.05 152.671 137.614C152.18 137.177 151.601 136.851 150.974 136.657C150.346 136.463 149.684 136.405 149.033 136.488L55.6257 145.024C54.2373 145.163 52.9465 145.801 51.9929 146.82C51.0393 147.839 50.4876 149.169 50.44 150.564V283.362C50.4341 284.018 50.5693 284.668 50.8364 285.267C51.1035 285.865 51.4963 286.4 51.9882 286.834C52.48 287.268 53.0594 287.59 53.687 287.781C54.3146 287.971 54.9758 288.024 55.6257 287.936L149.033 279.401C150.421 279.261 151.712 278.623 152.665 277.604C153.619 276.585 154.171 275.255 154.218 273.861Z",
      fill: "url(#paint10_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M156.022 275.02V142.189C156.028 141.532 155.892 140.882 155.625 140.282C155.359 139.681 154.966 139.145 154.475 138.709C153.984 138.273 153.405 137.947 152.778 137.752C152.15 137.558 151.488 137.501 150.837 137.583L57.4298 146.119C56.0234 146.278 54.7256 146.951 53.7861 148.01C52.8466 149.068 52.3317 150.437 52.3407 151.852V284.522C52.3401 285.176 52.4788 285.823 52.7477 286.42C53.0165 287.016 53.4093 287.548 53.8999 287.981C54.3906 288.414 54.9677 288.737 55.593 288.929C56.2183 289.121 56.8774 289.178 57.5264 289.096L150.933 280.56C152.307 280.406 153.578 279.76 154.514 278.742C155.449 277.724 155.985 276.402 156.022 275.02Z",
      fill: "url(#paint11_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M158.213 276.212V143.445C158.2 142.799 158.051 142.163 157.776 141.579C157.501 140.994 157.107 140.473 156.617 140.051C156.128 139.629 155.556 139.314 154.937 139.128C154.319 138.941 153.668 138.887 153.027 138.968L59.8776 147.375C58.4859 147.514 57.1913 148.151 56.2324 149.169C55.2735 150.187 54.7149 151.517 54.6597 152.915V285.714C54.6436 286.378 54.7726 287.038 55.0374 287.647C55.3023 288.257 55.6968 288.801 56.1934 289.242C56.6901 289.684 57.2769 290.012 57.9132 290.203C58.5494 290.395 59.2197 290.446 59.8776 290.352L153.285 281.816C154.64 281.624 155.881 280.954 156.785 279.926C157.689 278.898 158.195 277.581 158.213 276.212Z",
      fill: "url(#paint12_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M160.854 277.468V144.702C160.86 144.046 160.724 143.396 160.457 142.797C160.19 142.199 159.797 141.664 159.306 141.23C158.814 140.796 158.234 140.473 157.607 140.283C156.979 140.093 156.318 140.04 155.668 140.128L62.3577 148.631C60.9667 148.764 59.6721 149.4 58.7172 150.42C57.7623 151.441 57.2128 152.774 57.172 154.171V287.131C57.1668 287.788 57.3021 288.438 57.569 289.039C57.8358 289.639 58.228 290.175 58.7191 290.611C59.2103 291.048 59.7891 291.374 60.4166 291.568C61.0442 291.762 61.706 291.82 62.3577 291.737L155.765 283.169C157.165 283.011 158.459 282.342 159.398 281.29C160.336 280.239 160.855 278.878 160.854 277.468Z",
      fill: "url(#paint13_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M163.366 278.499V145.7C163.366 145.046 163.228 144.399 162.959 143.803C162.69 143.206 162.297 142.674 161.806 142.241C161.316 141.808 160.739 141.485 160.113 141.293C159.488 141.101 158.829 141.044 158.18 141.126L64.773 149.662C63.4148 149.806 62.1525 150.43 61.2136 151.422C60.2747 152.414 59.7209 153.709 59.6518 155.073V287.968C59.6465 288.625 59.7819 289.276 60.0487 289.876C60.3156 290.476 60.7077 291.012 61.1989 291.449C61.69 291.885 62.2688 292.211 62.8964 292.405C63.5239 292.599 64.1858 292.657 64.8375 292.574L158.244 284.039C159.621 283.885 160.897 283.24 161.837 282.223C162.777 281.205 163.32 279.884 163.366 278.499Z",
      fill: "url(#paint14_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M165.878 217.172V84.3733C165.88 83.7161 165.74 83.0661 165.469 82.4672C165.199 81.8683 164.803 81.3343 164.309 80.9011C163.814 80.4678 163.233 80.1454 162.604 79.9554C161.975 79.7654 161.312 79.7123 160.661 79.7996L67.2536 88.3351C65.88 88.4899 64.6086 89.1357 63.6734 90.1537C62.7383 91.1717 62.2025 92.4933 62.1646 93.8751V226.642C62.164 227.3 62.3035 227.951 62.574 228.551C62.8445 229.152 63.2397 229.687 63.7333 230.123C64.2269 230.559 64.8076 230.885 65.4368 231.078C66.066 231.272 66.7292 231.33 67.3825 231.248L160.693 222.712C162.084 222.579 163.378 221.943 164.333 220.923C165.288 219.903 165.838 218.569 165.878 217.172Z",
      fill: "url(#paint15_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M137.307 184.176C155.1 171.23 159.733 147.278 147.655 130.679C135.578 114.08 111.363 111.119 93.5695 124.065C75.7764 137.012 71.1432 160.963 83.221 177.562C95.2987 194.162 119.514 197.123 137.307 184.176Z",
      fill: "url(#paint16_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M134.666 135.006L114.246 136.745L114.342 141.448L110.445 141.77L101.813 142.511L102.006 151.529L96.8206 151.98L96.9816 159.614L97.046 161.707L97.0782 163.254L102.232 162.835L102.844 192.854L117.112 191.662L116.919 183.223L131.703 181.967L131.607 177.297L135.504 176.975L134.666 135.006Z",
      fill: "#BCFAFF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M125.133 157.391L121.396 157.713L121.622 167.956L125.358 167.634L125.133 157.391Z",
      fill: "#76E4E7"
    }), /* @__PURE__ */ jsx("path", {
      d: "M104.325 152.366L100.621 152.689V156.199L104.358 155.877L104.325 152.366Z",
      fill: "#76E4E7"
    }), /* @__PURE__ */ jsx("path", {
      d: "M114.922 171.66L131.832 170.211L131.896 173.882L114.987 175.3L114.922 171.66Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M100.653 156.006L96.917 156.296L96.8526 153.011L100.589 152.689L100.524 149.21L96.7882 149.532L96.8526 153.011L93.1163 153.333L93.1808 156.811L96.917 156.489L97.0781 163.253L100.621 162.963L101.265 193.176L105.002 192.854L104.293 159.002L100.718 159.292L100.653 156.006Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M131.864 180.324L118.691 181.419L115.115 181.741H114.954L115.148 191.984L118.884 191.694L118.755 185.059L132.09 183.932L132.025 180.453L135.601 180.163L135.536 176.717L131.8 177.007L131.864 180.324Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M141.656 145.57L138.628 145.828L138.435 135.908L134.699 136.23L134.892 146.15L131.156 146.44L127.935 146.73L121.171 147.31L117.982 147.567L110.67 148.179L107.449 148.469L104.261 148.727L104.132 142.317L100.396 142.607L100.589 152.689L104.325 152.367L107.546 152.109L107.611 155.394L110.831 155.137L110.896 158.583L118.207 157.971L118.111 154.492L121.332 154.235L121.235 150.949L128.031 150.37L128.096 153.655L131.284 153.397L131.381 156.876L135.117 156.554L135.536 176.717L139.272 176.395L138.789 152.753L141.785 152.495L141.656 145.57Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M138.274 128.983L134.538 129.273L134.473 125.987L106.87 128.338L106.934 131.463L103.552 131.753L103.617 135.392L100.235 135.682L100.299 139.161L93.3743 139.741L90.3466 139.998L89.799 140.03L86.0627 140.353L86.1594 143.831L89.8957 143.509L90.0889 153.591L93.6641 153.301L93.5675 149.79L96.7884 149.532L96.724 146.569L100.46 146.279L100.396 142.8L103.778 142.511L107.16 142.221L120.688 141.061L120.784 144.733L131.639 143.799L131.574 140.159L134.763 139.869L134.699 136.391L138.435 136.101L138.274 128.983Z",
      fill: "#49B6C8"
    }), /* @__PURE__ */ jsx("path", {
      d: "M65.5141 318.761L60.5217 164.349L36.0426 148.857L35.7205 297.567C35.5935 299.675 36.1069 301.772 37.1933 303.582C38.2798 305.393 39.8884 306.833 41.8081 307.713L65.5141 318.761Z",
      fill: "url(#paint17_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M65.5141 318.761L0.805664 301.496V253.182L35.8172 254.922V297.728C35.6901 299.836 36.2035 301.933 37.29 303.744C38.3764 305.554 39.9851 306.994 41.9047 307.874L65.5141 318.761Z",
      fill: "url(#paint18_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M168.648 149.565L60.8758 162.707L40.6806 149.919L36.0425 148.857L60.5215 164.349L168.745 153.946H172.223L172.062 151.723L168.648 149.565Z",
      fill: "url(#paint19_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M172.224 154.236L171.901 298.855C171.91 301.343 171.001 303.746 169.35 305.606C167.698 307.466 165.418 308.652 162.947 308.937L69.9269 319.34C68.7064 319.477 67.4708 319.353 66.3015 318.978C65.1321 318.602 64.0556 317.983 63.1428 317.162C62.2299 316.34 61.5014 315.335 61.0052 314.211C60.5091 313.088 60.2565 311.872 60.2641 310.644L60.5862 164.349L114.376 158.294L169.84 152.078C170.143 152.04 170.45 152.069 170.741 152.161C171.032 152.253 171.299 152.407 171.525 152.612C171.751 152.816 171.931 153.067 172.051 153.348C172.172 153.628 172.23 153.931 172.224 154.236Z",
      fill: "url(#paint20_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M75.5312 309.903C73.88 309.902 72.2866 309.295 71.0541 308.196C70.3545 307.573 69.7947 306.809 69.4117 305.954C69.0286 305.099 68.8309 304.172 68.8317 303.235L69.186 178.167C69.1917 176.522 69.8021 174.937 70.9009 173.714C71.9997 172.49 73.5102 171.714 75.1447 171.532L156.022 162.449C156.96 162.352 157.909 162.451 158.807 162.74C159.705 163.028 160.533 163.499 161.24 164.124C161.944 164.75 162.506 165.52 162.889 166.38C163.272 167.241 163.468 168.174 163.463 169.116L163.205 293.251C163.21 294.911 162.606 296.516 161.508 297.763C160.41 299.009 158.894 299.81 157.246 300.015L76.272 309.871L75.5312 309.903ZM75.2413 172.273C73.8033 172.445 72.4771 173.135 71.5109 174.214C70.5446 175.292 70.0044 176.686 69.9912 178.135L69.5403 303.235C69.5362 304.057 69.7048 304.869 70.0349 305.621C70.3651 306.373 70.8495 307.047 71.4569 307.6C72.0642 308.153 72.7808 308.571 73.5604 308.829C74.3399 309.087 75.165 309.179 75.9821 309.098L157.15 299.145C158.593 298.958 159.92 298.255 160.885 297.166C161.85 296.076 162.388 294.674 162.4 293.218L162.657 169.084C162.652 168.266 162.476 167.457 162.143 166.71C161.809 165.963 161.325 165.293 160.72 164.742C160.115 164.192 159.402 163.772 158.627 163.511C157.852 163.249 157.031 163.151 156.215 163.222L75.2413 172.273Z",
      fill: "url(#paint21_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M162.947 308.937L99.6237 316.119L83.809 317.891L75.9821 318.696L72.0204 319.115C70.7131 319.345 69.3846 319.431 68.0586 319.372C66.7477 319.201 65.4907 318.743 64.3772 318.03C63.2637 317.318 62.3212 316.368 61.6168 315.25C60.9144 314.118 60.4844 312.839 60.3606 311.513C60.3606 310.193 60.3606 308.872 60.3606 307.551V291.64L60.6505 164.349C60.9404 185.543 61.2302 206.769 61.198 227.995L61.3913 291.64V307.551C61.3913 308.808 61.3913 310.322 61.3913 311.417C61.4846 312.559 61.849 313.664 62.4542 314.638C63.0685 315.631 63.8956 316.476 64.8759 317.111C65.8562 317.746 66.9653 318.155 68.123 318.309C68.7131 318.342 69.3045 318.342 69.8946 318.309L71.8915 318.084L75.8211 317.665L83.7445 316.86L99.5593 315.185L131.221 311.964L162.947 308.937Z",
      fill: "url(#paint22_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M60.5219 164.349L124.683 157.166L156.892 153.559L164.912 152.657L168.906 152.206C169.566 152.077 170.244 152.077 170.903 152.206C171.221 152.316 171.509 152.498 171.744 152.738C171.978 152.979 172.154 153.271 172.256 153.591C172.449 158.97 172.256 164.349 172.256 169.696L171.966 298.823C171.708 277.307 171.451 255.791 171.483 234.404L171.322 169.825V155.62C171.364 155.052 171.364 154.481 171.322 153.913C171.268 153.744 171.177 153.589 171.054 153.46C170.931 153.332 170.78 153.233 170.613 153.172C170.434 153.121 170.245 153.121 170.066 153.172H169.067L165.041 153.591L157.021 154.461L124.812 157.682L92.6023 161.096L60.5219 164.349Z",
      fill: "url(#paint23_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M153.124 228.735L153.285 235.338L146.295 236.047L146.811 256.628L140.369 257.305L139.821 236.659L132.799 237.367L132.606 230.732L153.124 228.735Z",
      fill: "url(#paint24_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M104.488 233.438L105.228 260.913L99.4629 261.525L88.8016 247.417L89.2525 262.555L82.6496 263.232L81.8766 235.596L88.0608 235.016L98.3355 248.609L97.949 234.05L104.488 233.438Z",
      fill: "url(#paint25_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M129.289 231.055L129.45 237.69L117.146 238.882L117.275 243.552L128.387 242.457L128.58 248.705L117.436 249.833L117.693 259.624L111.123 260.301L110.382 232.858L129.289 231.055Z",
      fill: "url(#paint26_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M153.703 262.942L147.616 271.992L154.444 282.46L148.872 283.04L144.459 276.212L142.817 278.563L142.945 283.62L138.307 284.103L137.792 264.488L142.43 264.037L142.656 271.992L148.196 263.489L153.703 262.942Z",
      fill: "url(#paint27_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M127.259 265.132C128.05 265.017 128.852 265.017 129.643 265.132C130.325 265.253 130.986 265.47 131.607 265.776C132.199 266.095 132.751 266.484 133.25 266.935C133.738 267.399 134.171 267.918 134.539 268.481L131.124 271.96C130.889 271.65 130.619 271.369 130.319 271.122C130.066 270.862 129.772 270.645 129.449 270.478C128.819 270.105 128.081 269.957 127.356 270.06C126.769 270.114 126.205 270.314 125.713 270.639C125.212 270.953 124.783 271.37 124.457 271.863C124.11 272.399 123.849 272.986 123.684 273.603C123.497 274.273 123.41 274.968 123.426 275.664C123.455 276.364 123.574 277.056 123.781 277.725C123.976 278.305 124.282 278.841 124.682 279.304C125.009 279.745 125.437 280.102 125.93 280.343C126.424 280.584 126.968 280.703 127.517 280.689C127.922 280.63 128.322 280.533 128.709 280.399C129.052 280.244 129.377 280.05 129.675 279.819C129.97 279.556 130.25 279.277 130.512 278.982C130.792 278.64 131.04 278.273 131.253 277.886L134.861 280.463C134.487 281.125 134.067 281.761 133.604 282.364C133.133 282.953 132.593 283.483 131.994 283.942C131.386 284.411 130.713 284.791 129.997 285.069C129.189 285.374 128.344 285.569 127.485 285.649C126.399 285.719 125.312 285.554 124.296 285.166C123.223 284.779 122.253 284.151 121.462 283.33C120.601 282.47 119.931 281.439 119.497 280.302C118.982 279.032 118.709 277.678 118.692 276.308C118.653 274.922 118.849 273.539 119.271 272.218C119.654 270.947 120.266 269.758 121.075 268.707C121.832 267.72 122.773 266.889 123.845 266.259C124.894 265.653 126.056 265.269 127.259 265.132Z",
      fill: "url(#paint28_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M109.866 267.064L117.661 286.39L112.604 286.905L111.412 283.33L104.681 283.91L103.553 287.549L98.5286 288.161L105.26 267.515L109.866 267.064ZM105.937 279.594L109.802 279.207L107.74 273.796L105.937 279.594Z",
      fill: "url(#paint29_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M90.7017 269.061C91.6933 268.96 92.6949 269.025 93.6649 269.255C94.5054 269.462 95.2874 269.859 95.9518 270.414C96.6129 270.971 97.1319 271.678 97.4656 272.476C98.1797 274.431 98.1797 276.576 97.4656 278.531C97.1624 279.422 96.6676 280.235 96.0162 280.914C95.3614 281.604 94.5721 282.152 93.6971 282.525C92.7636 282.926 91.7759 283.186 90.7661 283.298L88.3826 283.523L88.5436 289.192L83.7767 289.675L83.1969 269.802L90.7017 269.061ZM93.2784 276.115C93.2785 275.739 93.2018 275.366 93.0529 275.02C92.9362 274.722 92.7482 274.456 92.5054 274.247C92.2348 274.05 91.9285 273.908 91.6035 273.828C91.2188 273.776 90.8287 273.776 90.444 273.828L88.2215 274.054V279.304L90.5084 279.078C90.8987 279.051 91.2807 278.953 91.6357 278.789C91.9522 278.641 92.2367 278.433 92.4732 278.177C92.7052 277.927 92.8809 277.63 92.9885 277.307C93.1121 276.956 93.1667 276.584 93.1496 276.212",
      fill: "url(#paint30_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M140.304 214.885L119.207 178.424L95.3398 220.908L140.304 214.885Z",
      fill: "url(#paint31_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M140.304 214.885L119.207 178.424L119.626 204.707L140.304 214.885Z",
      fill: "url(#paint32_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M140.304 214.885L119.207 178.424L119.626 204.707L140.304 214.885Z",
      fill: "url(#paint33_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M119.626 204.707L119.207 178.424L95.3398 220.908L119.626 204.707Z",
      fill: "url(#paint34_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M95.3076 220.908L140.207 214.467L139.917 215.046L119.207 178.424L140.658 214.692C140.724 214.768 140.76 214.865 140.76 214.966C140.76 215.066 140.724 215.164 140.658 215.24H140.401L95.3076 220.908Z",
      fill: "url(#paint35_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M264.439 340.373L105.84 333.416L159.146 320.854L234.742 276.405V319.211C234.614 321.311 235.124 323.4 236.205 325.205C237.285 327.01 238.886 328.446 240.797 329.325L264.439 340.373Z",
      fill: "url(#paint36_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M268.284 335.469L289.931 181.444C290.387 178.203 288.129 175.206 284.887 174.75L179.44 159.931C176.198 159.475 173.202 161.733 172.746 164.975L151.099 319C150.644 322.241 152.902 325.238 156.143 325.693L261.591 340.513C264.832 340.968 267.829 338.71 268.284 335.469Z",
      fill: "url(#paint37_linear_10025_65883)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M221.311 291.705C246.802 291.705 267.466 271.04 267.466 245.549C267.466 220.057 246.802 199.393 221.311 199.393C195.819 199.393 175.155 220.057 175.155 245.549C175.155 271.04 195.819 291.705 221.311 291.705Z",
      fill: "#1EC5F9"
    }), /* @__PURE__ */ jsx("path", {
      d: "M239.541 276.244C242.762 260.816 253.649 219.524 228.268 217.817C222.755 217.469 217.24 218.459 212.193 220.702C207.146 222.946 202.715 226.376 199.279 230.7C196.61 234.331 194.158 238.117 191.936 242.038C190.723 244.277 189.356 246.43 187.845 248.48C187.649 248.976 187.424 249.46 187.169 249.929C187.083 252.511 186.051 254.971 184.269 256.842C182.487 258.713 180.08 259.863 177.506 260.075C179.572 266.404 182.984 272.21 187.508 277.094C192.032 281.978 197.56 285.824 203.712 288.368C209.864 290.911 216.495 292.092 223.147 291.828C229.799 291.565 236.315 289.863 242.247 286.841C240.989 285.415 240.088 283.711 239.618 281.868C239.148 280.026 239.121 278.099 239.541 276.244Z",
      fill: "#2E7EAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M249.59 260.88L247.304 260.558L251.33 231.924L207.879 225.804L201.083 273.86L244.566 279.98L246.144 268.771L248.431 269.093L249.59 260.88Z",
      fill: "#BCFAFF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M259.318 228.768L258.673 233.567L250.396 232.407L227.366 229.154V229.122L217.993 227.801V227.833L198.603 225.096L199.247 220.458L202.339 220.876L204.594 221.198L204.916 218.879L206.365 219.105L207.074 214.177L209.619 214.531L209.973 211.986L215.03 212.695L215.352 210.344L222.148 211.31L222.47 208.894L236.868 210.924L236.546 213.339L243.857 214.37L243.535 216.721L245.983 217.076L245.629 219.427L247.948 219.749L247.561 222.326L249.88 222.68L249.494 225.225L252.167 225.611L251.877 227.737L259.318 228.768Z",
      fill: "#DF7DE2"
    }), /* @__PURE__ */ jsx("path", {
      d: "M244.308 278.982L243.76 282.783L240.894 282.364V282.75L237.351 282.235L236.932 285.23L227.656 283.91L227.463 285.198L230.265 285.585L230.039 287.002L220.924 285.746L207.493 283.91L207.783 281.784L200.117 280.689L200.6 277.178L197.766 276.792L198.249 273.571L194.802 273.088L195.318 269.512L192.87 269.19L193.353 265.647L189.778 265.132L190.261 261.589L179.696 260.075L180.501 254.406L182.434 254.696L183.014 250.444L184.753 250.67L186.331 239.397L188.972 239.751L189.488 236.337L191.936 236.691L192.29 234.243L195.06 234.63L195.414 232.085L197.766 232.407L198.41 227.801L217.735 230.507L217.381 232.955L212.389 232.246L212.099 234.436L200.31 232.761L199.988 235.016L197.476 234.662L197.121 237.11L194.577 236.723L194.158 239.493L191.807 239.171L190.357 248.48L192.741 248.802L192.354 251.475L195.157 251.701L194.802 254.148L197.315 254.503L197.025 256.693L203.853 257.659L204.143 255.469L206.752 255.856L207.138 253.086L204.53 252.731L204.143 255.469L197.315 254.503L197.669 252.055L195.157 251.701L195.543 249.027L192.805 248.641L194.126 239.171L196.703 239.525L197.089 236.788L201.598 237.528L201.212 240.105L206.527 240.846L206.881 238.301L208.91 238.559L207.557 248.222L209.522 248.48L209.2 250.928L211.648 251.25L211.358 253.472L219.024 254.535L218.669 257.015L216.254 256.693L215.899 259.302L213.387 258.948L212.067 268.353L214.579 268.707L214.225 271.219L216.544 271.542L216.189 274.118L218.637 274.44L218.347 276.47L239.283 279.433L239.573 277.404L242.15 277.79L242.536 275.213L244.92 275.568L244.405 279.111L244.308 278.982ZM202.436 249.993L202.758 247.61L200.568 247.288L200.89 245.065L203.08 245.355L203.402 243.004L198.99 242.36L198.023 249.349L202.436 249.993Z",
      fill: "#2E7EAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M249.913 236.015L249.719 237.335L248.141 237.11L248.495 234.662L250.041 234.887L249.913 236.015Z",
      fill: "#2E7EAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M241.312 233.664L240.958 236.112L238.091 235.693L237.769 237.883L235.933 237.625L233.518 237.271L231.166 236.949L231.488 234.759L226.657 234.082L227.011 231.635L241.312 233.664Z",
      fill: "#2E7EAF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M207.461 250.573L204.852 250.187L205.174 247.836L202.629 247.481L202.307 249.833L198.893 249.349L199.537 244.743L205.754 245.645L206.43 240.814L201.148 240.073L201.502 237.529L196.993 236.917L196.638 239.429L194.126 239.075L193.45 243.874L192.644 249.414L195.382 249.8L195.028 252.28L197.54 252.635L197.154 255.437L201.438 256.049L203.982 256.403L204.369 253.601L206.978 253.955L207.461 250.573Z",
      fill: "#BCFAFF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M259.344 228.865L258.667 233.649L260.581 233.92L261.257 229.136L259.344 228.865Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M258.319 236.08L258.158 237.175L256.226 236.885L255.839 239.558L251.072 238.882L250.943 239.751L252.972 240.041H253.069L254.841 240.299L254.229 244.615L252.489 244.357L252.425 244.744L252.328 244.712L251.652 249.285L249.236 248.963L248.882 251.443L248.592 251.411L240.057 250.187L240.089 249.801L241.377 249.962L241.538 248.963L242.827 249.157L242.955 248.126L244.276 248.319L244.598 245.936H244.63L244.92 243.906L246.209 244.1L246.498 241.942L247.787 242.135L248.077 240.106L246.788 239.912L246.885 239.172L247.851 239.3L248.141 237.11L249.719 237.336L249.913 236.015L250.041 234.888L248.495 234.662L248.141 237.11L240.958 236.112L241.313 233.664L227.012 231.635L226.657 234.083L217.317 232.762L217.639 230.314L198.442 227.609L197.766 232.214L195.447 231.892L195.06 234.469L192.29 234.05L192.644 231.474L193.289 231.57L194.126 225.547L195.704 225.773L195.833 224.71L196.51 220.072L199.247 220.458L198.603 225.096L217.993 227.834V227.802L227.366 229.122V229.155L250.396 232.408L258.674 233.567L258.319 236.08Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M252.186 225.647L251.888 227.752L259.351 228.806L259.649 226.701L252.186 225.647Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M256.999 242.779H256.612C256.838 242.586 256.999 242.586 256.999 242.779Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M251.781 262.008L250.814 268.997L249.043 268.739L248.495 268.675L249.494 261.686L251.781 262.008Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M249.043 268.74L248.366 273.603L246.112 273.281L245.79 275.6L245.757 275.665L247.529 275.89L247.046 279.369L245.274 279.111L244.727 282.912L244.566 284.039L243.632 283.91L242.15 283.717L241.764 286.39L236.964 285.714L236.9 285.263L237.319 282.267L240.829 282.751L240.894 282.364L243.76 282.783L244.308 278.982L244.791 275.503L244.823 275.471L242.44 275.117L242.762 272.798L245.145 273.152H245.242L245.919 268.353V268.321L248.495 268.675L249.043 268.74Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M247.585 258.715L247.201 261.426L249.497 261.751L249.881 259.04L247.585 258.715Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M245.851 253.899L245.215 258.396L247.607 258.734L248.243 254.237L245.851 253.899Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M249.859 222.679L249.494 225.262L252.173 225.64L252.538 223.057L249.859 222.679Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M245.919 268.321V268.353L222.084 265.003L222.406 262.62L246.241 266.002L245.919 268.321Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M246.808 239.915L246.52 241.956L247.795 242.137L248.084 240.095L246.808 239.915Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M247.946 219.763L247.581 222.346L249.877 222.67L250.242 220.087L247.946 219.763Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M239.82 274.769L239.459 277.32L242.043 277.685L242.403 275.133L239.82 274.769Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M246.498 241.941L246.208 244.099L244.92 243.906L245.5 239.751L246.788 239.912L246.498 241.941Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M246.885 239.171L246.788 239.912L245.5 239.751L244.211 239.558L243.438 244.969H243.406L242.118 244.808L240.829 244.615L240.088 249.801L240.056 250.187L236.706 249.704L237.061 247.224L234.613 246.902L235.257 242.296L232.841 241.974L232.197 246.547L229.749 246.193L229.395 248.673L220.602 247.449L220.666 247.031L221.955 247.224L222.083 246.225L223.404 246.386L223.533 245.388L224.821 245.549L225.176 243.198L225.465 241.168L226.754 241.329L227.076 239.204L228.364 239.397L228.622 237.368L227.366 237.174L226.077 236.981L226.174 236.24L226.335 236.273L226.657 234.082L231.489 234.759L231.166 236.949L233.518 237.271L235.933 237.625L237.769 237.883L238.091 235.693L240.958 236.112L240.668 238.302L246.885 239.171Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M244.92 243.906L244.63 245.935H244.598L244.727 245.162L243.439 244.969L244.212 239.558L245.5 239.751L244.92 243.906Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M244.598 245.935L244.276 248.319L242.955 248.126L243.406 244.969H243.438L243.342 245.774L244.598 245.935Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M243.445 245.008L243.337 245.773L244.612 245.953L244.72 245.188L243.445 245.008Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M243.181 253.826L242.569 258.239L240.185 257.917L240.507 255.727L238.253 255.405L237.931 257.595L235.579 257.273L235.869 255.083L236.191 252.86L238.543 253.182L240.797 253.504L243.181 253.826Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M245.983 217.161L245.649 219.521L247.946 219.846L248.279 217.486L245.983 217.161Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M218.527 274.373L218.243 276.383L239.197 279.342L239.48 277.333L218.527 274.373Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M242.955 248.125L242.826 249.156L241.538 248.963L242.118 244.808L243.406 244.969L242.955 248.125Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M179.052 263.489H179.986C180.417 262.32 180.922 261.179 181.5 260.075L179.567 259.817L180.373 254.149L182.273 254.406L182.885 250.122L184.624 250.38L186.235 239.075L184.624 238.817L183.916 243.648L182.015 243.391L180.727 252.538L179.052 252.409L177.667 262.072L179.406 262.33L179.052 263.489Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M241.538 248.963L241.377 249.961L240.089 249.8L240.829 244.615L242.118 244.808L241.538 248.963Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M243.885 214.374L243.552 216.734L245.976 217.076L246.309 214.716L243.885 214.374Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M243.555 216.761L243.226 219.089L245.65 219.431L245.978 217.103L243.555 216.761Z",
      fill: "#B3D8F9"
    }), /* @__PURE__ */ jsx("path", {
      d: "M241.59 214.089L241.261 216.417L243.557 216.742L243.886 214.413L241.59 214.089Z",
      fill: "#B3D8F9"
    }), /* @__PURE__ */ jsx("path", {
      d: "M236.905 211.008L236.562 213.432L243.897 214.469L244.24 212.046L236.905 211.008Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M234.398 210.623L234.056 213.047L236.543 213.399L236.886 210.975L234.398 210.623Z",
      fill: "#B3D8F9"
    }), /* @__PURE__ */ jsx("path", {
      d: "M233.614 252.506L233.002 256.887L230.651 256.564L230.941 254.374L228.686 254.052L228.364 256.242L226.013 255.92L226.303 253.73L226.625 251.508L229.009 251.83L231.263 252.152L233.614 252.506Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M222.786 206.745L222.48 208.913L236.863 210.945L237.17 208.776L222.786 206.745Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M227.365 237.183L227.077 239.224L228.353 239.405L228.641 237.364L227.365 237.183Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M227.076 239.204L226.754 241.329L225.465 241.168L226.077 236.981L227.366 237.174L227.076 239.204Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M225.466 241.168L225.176 243.197L225.272 242.424L224.016 242.231L224.757 236.82L226.078 236.981L225.466 241.168Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M226.174 236.24L226.078 236.981L224.757 236.82L224.016 242.231H223.984L222.696 242.038L221.375 241.877L220.666 247.03L220.602 247.449L217.252 246.966L217.607 244.486L215.159 244.132L215.803 239.558L211.39 238.946L210.037 248.48L211.905 248.738L211.551 251.153L209.103 250.831L209.425 248.383L207.461 248.126L208.781 238.559L206.784 238.302L206.43 240.846L201.115 240.105L201.502 237.529L199.537 237.271L197.025 236.917L197.379 234.469L199.891 234.823L200.213 232.568L209.458 233.889L211.97 234.243L212.292 232.053L217.317 232.762L216.995 234.952L218.927 235.21L226.174 236.24Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M225.176 243.198L224.821 245.549L223.533 245.388L223.984 242.231H224.016L223.887 243.004L225.176 243.198Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M224.006 242.244L223.898 243.009L225.174 243.189L225.282 242.424L224.006 242.244Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M220.45 259.809L220.094 262.328L222.391 262.653L222.746 260.133L220.45 259.809Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M223.533 245.388L223.404 246.386L222.084 246.225L222.696 242.038L223.984 242.231L223.533 245.388Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M218.916 254.46L218.564 256.947L221.084 257.303L221.435 254.816L218.916 254.46Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M216.469 271.478L216.108 274.029L218.564 274.376L218.924 271.825L216.469 271.478Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M222.084 246.225L221.955 247.224L220.666 247.031L221.375 241.877L222.696 242.038L222.084 246.225Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M218.186 259.463V259.56L215.803 259.206L216.189 256.597L218.573 256.919L218.186 259.463Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M211.555 251.171L211.244 253.371L218.898 254.453L219.209 252.252L211.555 251.171Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M214.473 268.619L214.117 271.138L216.445 271.467L216.801 268.947L214.473 268.619Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M213.32 258.887L211.991 268.296L214.479 268.647L215.808 259.239L213.32 258.887Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M215.696 207.932L215.353 210.355L222.146 211.315L222.489 208.891L215.696 207.932Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M210.312 209.657L209.983 211.985L215.022 212.697L215.351 210.369L210.312 209.657Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M204.502 252.856L204.115 255.599L206.698 255.964L207.085 253.221L204.502 252.856Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M197.279 254.686L196.973 256.855L203.798 257.819L204.104 255.65L197.279 254.686Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M207.43 211.609L207.065 214.193L209.617 214.553L209.982 211.97L207.43 211.609Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M202.694 247.481L202.372 249.833L200.149 249.543L197.927 249.221L198.281 246.869L198.603 244.615L198.925 242.231L203.338 242.875L203.016 245.227L200.826 244.937L200.503 247.159L202.694 247.481Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M207.074 214.177L206.365 219.105L204.916 218.88L204.594 221.199L202.339 220.876L199.247 220.458L199.601 217.881L202.693 218.3L202.855 217.108L204.207 217.301L204.723 213.855L207.074 214.177Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M195.091 251.859L194.744 254.314L197.264 254.67L197.61 252.215L195.091 251.859Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M192.757 248.806L192.379 251.485L195.122 251.872L195.5 249.193L192.757 248.806Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M194.459 236.618L194.071 239.36L196.654 239.726L197.042 236.983L194.459 236.618Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M191.709 238.994L190.371 248.466L192.763 248.804L194.101 239.332L191.709 238.994Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M189.823 233.75L189.48 236.174L191.936 236.521L192.279 234.097L189.823 233.75Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M186.843 235.812L186.361 239.224L189.008 239.598L189.49 236.186L186.843 235.812Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M243.149 286.261L238.607 288.323V285.102H242.955L243.149 286.261Z",
      fill: "#041836"
    }), /* @__PURE__ */ jsx("path", {
      d: "M97.6258 103.892L97.3682 105.824H98.5277V107.467H97.0783L96.8206 109.432L95.1135 109.593L95.3712 107.628L93.4708 107.789L93.2132 109.754L91.5061 109.915L91.7637 107.95H90.7653V106.308H92.0536L92.3113 104.375H91.1518V102.7H92.6012L92.8589 100.8L94.566 100.639L94.3083 102.539H96.2086L96.4341 100.639L98.1734 100.478L97.9157 102.378H98.9142V104.021L97.6258 103.892ZM94.0184 104.214L93.7607 106.147L95.6611 105.953L95.9187 104.021L94.0184 104.214Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M100.75 100.188L107.192 99.608V101.09L103.391 108.981L101.137 109.206L104.97 101.508L100.686 101.895L100.75 100.188Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M116.179 106.437C116.029 106.787 115.797 107.096 115.503 107.339C115.174 107.609 114.804 107.826 114.408 107.983C113.963 108.147 113.496 108.244 113.023 108.273C112.554 108.355 112.074 108.355 111.606 108.273C111.205 108.212 110.821 108.07 110.478 107.854C110.16 107.665 109.895 107.399 109.705 107.081C109.508 106.774 109.407 106.415 109.415 106.05C109.363 105.569 109.465 105.085 109.705 104.665C109.991 104.263 110.366 103.933 110.8 103.699C110.443 103.546 110.132 103.301 109.898 102.99C109.681 102.641 109.559 102.242 109.544 101.831C109.542 101.488 109.608 101.149 109.737 100.832C109.893 100.503 110.112 100.207 110.382 99.9626C110.668 99.7076 110.995 99.5009 111.348 99.3506C111.769 99.1831 112.215 99.0852 112.668 99.0607C113.094 98.9789 113.531 98.9789 113.957 99.0607C114.335 99.1458 114.696 99.2985 115.02 99.5116C115.301 99.7011 115.533 99.9551 115.696 100.252C115.849 100.541 115.937 100.86 115.954 101.187C115.978 101.61 115.889 102.033 115.696 102.41C115.474 102.751 115.19 103.046 114.859 103.28C115.286 103.438 115.671 103.692 115.986 104.021C116.271 104.388 116.42 104.844 116.405 105.309C116.45 105.699 116.371 106.094 116.179 106.437ZM113.989 104.568C113.64 104.397 113.248 104.33 112.862 104.375C112.459 104.405 112.071 104.538 111.734 104.762C111.599 104.862 111.49 104.993 111.417 105.145C111.344 105.296 111.309 105.463 111.316 105.631C111.323 105.787 111.368 105.939 111.446 106.073C111.525 106.208 111.635 106.321 111.767 106.404C112.134 106.586 112.544 106.664 112.953 106.63C113.362 106.596 113.753 106.451 114.086 106.211C114.211 106.111 114.311 105.983 114.378 105.838C114.445 105.693 114.477 105.534 114.472 105.374C114.481 105.207 114.44 105.041 114.354 104.897C114.268 104.753 114.141 104.639 113.989 104.568ZM113.699 100.864C113.419 100.667 113.072 100.586 112.733 100.639C112.375 100.647 112.031 100.784 111.767 101.025C111.561 101.23 111.445 101.508 111.445 101.799C111.455 101.946 111.494 102.091 111.561 102.224C111.627 102.356 111.719 102.474 111.831 102.572C112.113 102.766 112.458 102.847 112.797 102.797C113.145 102.784 113.477 102.647 113.731 102.41C113.839 102.306 113.923 102.181 113.978 102.042C114.034 101.903 114.059 101.755 114.053 101.605C114.052 101.463 114.02 101.323 113.959 101.195C113.898 101.067 113.809 100.954 113.699 100.864Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M126.131 104.279C125.977 104.844 125.726 105.378 125.39 105.857C125.106 106.34 124.734 106.766 124.295 107.113C123.792 107.405 123.231 107.581 122.652 107.629C122.084 107.672 121.514 107.595 120.977 107.403C120.479 107.214 120.028 106.917 119.657 106.534C119.287 106.128 118.992 105.659 118.787 105.149C118.58 104.557 118.461 103.939 118.433 103.313C118.427 102.683 118.502 102.055 118.658 101.445C118.837 100.894 119.098 100.372 119.431 99.8986C119.778 99.4491 120.203 99.067 120.688 98.7712C121.192 98.4904 121.754 98.3254 122.33 98.2881C122.896 98.2193 123.47 98.2855 124.005 98.4813C124.494 98.6713 124.934 98.9685 125.293 99.351C125.686 99.7521 125.983 100.236 126.163 100.768C126.398 101.341 126.518 101.953 126.517 102.572C126.489 103.159 126.358 103.737 126.131 104.279ZM124.295 101.477C124.19 101.166 124.038 100.872 123.844 100.607C123.678 100.374 123.456 100.186 123.2 100.06C122.938 99.9385 122.65 99.8832 122.362 99.8986C122.074 99.9266 121.797 100.026 121.557 100.188C121.307 100.354 121.097 100.574 120.945 100.833C120.776 101.134 120.656 101.46 120.591 101.799C120.54 102.184 120.54 102.574 120.591 102.958C120.603 103.341 120.668 103.721 120.784 104.086C120.871 104.398 121.013 104.693 121.203 104.955C121.38 105.199 121.612 105.397 121.879 105.535C122.154 105.605 122.442 105.605 122.717 105.535C123.004 105.502 123.28 105.403 123.522 105.245C123.757 105.063 123.964 104.846 124.134 104.601C124.2 104.368 124.254 104.131 124.295 103.893C124.328 103.517 124.328 103.14 124.295 102.765C124.34 102.337 124.34 101.905 124.295 101.477Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M134.634 97.0963L134.859 102.636H136.051V104.247H134.859V106.179L132.927 106.373V104.408L128.482 104.794L128.095 103.442L132.895 97.2574L134.634 97.0963ZM132.83 99.9951L130.511 103.023L132.927 102.797L132.83 99.9951Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M214.482 182.548L213.87 184.416H214.998L214.772 186.058L213.355 185.833L212.743 187.733L211.036 187.476L211.648 185.608L209.812 185.318L209.2 187.186L207.493 186.928L208.105 185.06H207.139L207.396 183.385L208.653 183.578L209.232 181.742L208.041 181.581L208.298 179.939L209.715 180.164L210.295 178.328L212.002 178.586L211.39 180.422L213.258 180.68L213.87 178.876L215.545 179.101L214.933 180.937H215.932L215.674 182.58L214.482 182.548ZM210.939 182.032L210.327 183.868L212.196 184.158L212.808 182.29L210.939 182.032Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M224.693 186.96C224.429 187.467 224.08 187.924 223.662 188.313C223.256 188.684 222.771 188.959 222.245 189.118C221.692 189.233 221.122 189.233 220.57 189.118C220.003 189.042 219.462 188.832 218.991 188.506C218.538 188.203 218.154 187.808 217.864 187.346C217.567 186.853 217.37 186.306 217.284 185.736C217.188 185.117 217.188 184.487 217.284 183.868C217.377 183.243 217.562 182.635 217.832 182.064C218.093 181.556 218.442 181.098 218.863 180.711C219.277 180.352 219.759 180.078 220.28 179.906C220.831 179.776 221.404 179.776 221.955 179.906C222.519 179.971 223.06 180.17 223.533 180.486C223.979 180.797 224.362 181.191 224.66 181.645C224.953 182.141 225.149 182.688 225.24 183.256C225.337 183.875 225.337 184.505 225.24 185.124C225.154 185.761 224.969 186.38 224.693 186.96ZM223.243 183.739C223.208 183.405 223.121 183.079 222.985 182.773C222.868 182.511 222.692 182.279 222.47 182.096C222.246 181.896 221.964 181.772 221.665 181.742C221.392 181.662 221.101 181.662 220.827 181.742C220.564 181.842 220.331 182.009 220.151 182.225C219.918 182.48 219.732 182.774 219.603 183.095C219.465 183.459 219.368 183.837 219.314 184.222C219.265 184.607 219.265 184.997 219.314 185.382C219.349 185.715 219.436 186.041 219.571 186.348C219.697 186.614 219.872 186.855 220.087 187.057C220.321 187.234 220.599 187.345 220.892 187.379C221.163 187.474 221.458 187.474 221.729 187.379C221.998 187.271 222.239 187.106 222.438 186.896C222.66 186.639 222.835 186.344 222.953 186.026C223.088 185.672 223.185 185.305 223.243 184.931C223.294 184.524 223.294 184.113 223.243 183.707V183.739Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M229.975 183.288C229.603 183.506 229.257 183.765 228.944 184.061L227.72 182.741C227.964 182.478 228.233 182.24 228.525 182.032C228.774 181.841 229.044 181.679 229.33 181.549C229.627 181.421 229.943 181.345 230.264 181.323C230.628 181.276 230.996 181.276 231.36 181.323C231.796 181.384 232.221 181.514 232.616 181.71C232.952 181.883 233.248 182.124 233.485 182.419C233.716 182.713 233.881 183.053 233.969 183.417C234.05 183.799 234.05 184.194 233.969 184.577C233.946 184.927 233.847 185.267 233.679 185.575C233.529 185.855 233.345 186.114 233.131 186.348C232.866 186.604 232.575 186.831 232.261 187.025L231.102 187.733L229.491 188.635L233.389 189.215L233.131 190.922L226.496 189.956L226.754 188.377L229.975 186.38L230.812 185.865L231.36 185.382C231.487 185.259 231.595 185.118 231.682 184.963C231.783 184.81 231.839 184.631 231.843 184.448C231.883 184.288 231.887 184.12 231.853 183.959C231.82 183.797 231.75 183.645 231.649 183.514C231.433 183.274 231.134 183.125 230.812 183.095C230.52 183.073 230.228 183.141 229.975 183.288Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M243.277 189.762C243.019 190.272 242.67 190.73 242.247 191.115C241.841 191.469 241.371 191.743 240.862 191.92C240.3 192.051 239.716 192.051 239.155 191.92C238.595 191.835 238.058 191.638 237.576 191.34C237.131 191.025 236.758 190.619 236.481 190.149C236.189 189.665 235.992 189.129 235.902 188.57C235.788 187.942 235.788 187.298 235.902 186.67C235.991 186.051 236.188 185.451 236.481 184.899C236.723 184.378 237.075 183.917 237.512 183.546C237.913 183.168 238.399 182.892 238.929 182.74C239.468 182.577 240.037 182.536 240.594 182.62C241.151 182.703 241.683 182.909 242.15 183.224C242.607 183.512 242.983 183.911 243.245 184.383C243.543 184.877 243.74 185.424 243.825 185.994C243.938 186.611 243.938 187.244 243.825 187.862C243.756 188.523 243.571 189.166 243.277 189.762ZM241.86 186.541C241.825 186.208 241.738 185.882 241.603 185.575C241.476 185.3 241.289 185.058 241.055 184.866C240.831 184.685 240.565 184.563 240.282 184.512C240.007 184.447 239.72 184.447 239.445 184.512C239.176 184.635 238.936 184.81 238.736 185.027C238.522 185.278 238.348 185.561 238.221 185.865C238.06 186.223 237.952 186.603 237.898 186.992C237.867 187.378 237.867 187.766 237.898 188.152C237.937 188.499 238.035 188.837 238.188 189.15C238.304 189.413 238.48 189.645 238.704 189.827C238.927 190.008 239.193 190.13 239.477 190.181C239.752 190.248 240.039 190.248 240.314 190.181C240.589 190.069 240.832 189.892 241.023 189.665C241.249 189.424 241.425 189.139 241.538 188.828C241.702 188.471 241.811 188.091 241.86 187.701C241.91 187.305 241.91 186.905 241.86 186.509V186.541Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M246.692 185.511L246.949 183.804L253.037 184.738L252.811 186.219L250.202 188.055C250.506 188.151 250.798 188.281 251.072 188.442C251.348 188.58 251.59 188.778 251.781 189.022C251.97 189.261 252.112 189.534 252.199 189.827C252.283 190.198 252.283 190.583 252.199 190.954C252.132 191.353 251.99 191.735 251.781 192.081C251.595 192.428 251.33 192.726 251.008 192.951C250.664 193.171 250.281 193.324 249.88 193.402C249.422 193.484 248.953 193.484 248.495 193.402C247.838 193.31 247.209 193.074 246.653 192.712C246.096 192.351 245.626 191.871 245.274 191.308L246.82 190.213C247.05 190.576 247.345 190.892 247.69 191.147C248.03 191.398 248.43 191.553 248.85 191.598C249.17 191.665 249.504 191.608 249.784 191.437C249.911 191.354 250.02 191.245 250.103 191.118C250.186 190.99 250.242 190.847 250.267 190.696C250.302 190.526 250.291 190.349 250.234 190.185C250.177 190.021 250.077 189.875 249.945 189.762C249.585 189.477 249.147 189.309 248.688 189.279H247.851V187.959L250.331 186.123L246.692 185.511Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M186.879 307.552C186.601 307.707 186.31 307.837 186.009 307.938C185.673 308.037 185.327 308.101 184.978 308.132C184.582 308.162 184.183 308.162 183.787 308.132C183.158 308.04 182.556 307.82 182.015 307.487C181.496 307.187 181.046 306.781 180.694 306.296C180.332 305.808 180.079 305.248 179.954 304.653C179.822 304.037 179.822 303.401 179.954 302.785C180.04 302.16 180.248 301.558 180.566 301.013C180.863 300.502 181.257 300.054 181.725 299.693C182.209 299.311 182.769 299.036 183.368 298.888C184.007 298.773 184.661 298.773 185.3 298.888L186.428 299.145C186.744 299.263 187.046 299.414 187.33 299.596C187.592 299.742 187.831 299.926 188.038 300.144C188.266 300.346 188.472 300.573 188.65 300.82L187.169 302.076C186.896 301.726 186.57 301.422 186.202 301.174C185.853 300.92 185.441 300.764 185.01 300.723C184.661 300.643 184.297 300.643 183.948 300.723C183.613 300.812 183.305 300.978 183.046 301.207C182.76 301.431 182.529 301.718 182.369 302.044C182.185 302.361 182.065 302.711 182.015 303.075C181.934 303.446 181.934 303.831 182.015 304.202C182.076 304.557 182.207 304.897 182.402 305.201C182.59 305.491 182.844 305.734 183.142 305.909C183.428 306.136 183.777 306.271 184.141 306.296C184.584 306.412 185.05 306.412 185.494 306.296C185.899 306.13 186.287 305.925 186.653 305.684L187.716 307.133C187.452 307.302 187.172 307.442 186.879 307.552Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M195.962 307.648C195.711 308.033 195.395 308.371 195.028 308.647C194.642 308.933 194.205 309.141 193.739 309.259C192.731 309.506 191.665 309.344 190.776 308.808C190.351 308.587 189.987 308.266 189.713 307.874C189.424 307.514 189.215 307.097 189.101 306.65C188.991 306.173 188.991 305.677 189.101 305.2C189.164 304.72 189.329 304.259 189.584 303.848C189.834 303.453 190.15 303.104 190.518 302.817C190.916 302.559 191.35 302.364 191.807 302.237C192.815 301.99 193.881 302.152 194.77 302.688C195.2 302.901 195.567 303.223 195.833 303.622C196.122 303.982 196.331 304.399 196.445 304.846C196.541 305.324 196.541 305.817 196.445 306.296C196.382 306.776 196.217 307.237 195.962 307.648ZM194.545 306.006C194.593 305.761 194.593 305.509 194.545 305.265C194.501 305.02 194.402 304.789 194.255 304.588C194.116 304.386 193.942 304.211 193.739 304.073C193.521 303.944 193.281 303.856 193.031 303.815C192.775 303.767 192.513 303.767 192.258 303.815L191.646 304.138C191.479 304.297 191.338 304.482 191.227 304.685C191.108 304.908 191.021 305.146 190.969 305.394C190.921 305.638 190.921 305.89 190.969 306.134C191.026 306.375 191.125 306.604 191.259 306.811C191.387 307.002 191.551 307.167 191.742 307.294C191.966 307.443 192.218 307.542 192.483 307.584C192.738 307.633 193.001 307.633 193.256 307.584C193.476 307.509 193.682 307.4 193.868 307.262C194.035 307.102 194.176 306.917 194.287 306.714C194.41 306.496 194.486 306.255 194.512 306.006H194.545Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M204.465 308.904C204.233 309.312 203.914 309.664 203.531 309.935C203.146 310.221 202.708 310.429 202.243 310.547C201.732 310.644 201.207 310.644 200.697 310.547C200.195 310.489 199.712 310.324 199.279 310.064C198.875 309.814 198.516 309.498 198.217 309.13C197.937 308.752 197.729 308.327 197.605 307.874C197.491 307.408 197.491 306.922 197.605 306.456C197.662 305.975 197.827 305.512 198.088 305.104C198.338 304.71 198.654 304.361 199.022 304.073C199.412 303.782 199.864 303.584 200.342 303.493C200.84 303.373 201.359 303.373 201.856 303.493C202.358 303.551 202.841 303.716 203.273 303.976C203.693 304.205 204.056 304.524 204.336 304.91C204.616 305.288 204.824 305.714 204.948 306.167C205.046 306.645 205.046 307.138 204.948 307.616C204.882 308.075 204.717 308.515 204.465 308.904ZM203.048 307.262C203.096 307.017 203.096 306.765 203.048 306.521C202.998 306.288 202.899 306.068 202.758 305.877C202.629 305.667 202.452 305.491 202.243 305.361C202.031 305.218 201.788 305.13 201.534 305.104C201.279 305.056 201.017 305.056 200.761 305.104C200.536 305.165 200.327 305.275 200.149 305.426C199.975 305.579 199.833 305.765 199.73 305.973C199.608 306.192 199.531 306.433 199.505 306.682C199.457 306.926 199.457 307.178 199.505 307.423C199.568 307.651 199.666 307.868 199.795 308.067C199.915 308.284 200.093 308.462 200.31 308.582C200.755 308.85 201.288 308.931 201.792 308.808C202.017 308.746 202.225 308.636 202.404 308.486C202.586 308.332 202.739 308.146 202.855 307.938C202.954 307.71 203.029 307.473 203.08 307.229L203.048 307.262Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M205.946 311.223L207.331 301.818L209.296 302.108L208.04 311.513L205.946 311.223Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M220.441 313.382L219.925 311.256L216.125 310.676L215.03 312.576L213 312.286L218.186 303.783L220.022 304.073L222.502 313.736L220.441 313.382ZM218.734 306.457L217.091 309.194L219.475 309.549L218.734 306.457Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M230.909 312.898C230.692 313.279 230.408 313.617 230.071 313.897C229.745 314.148 229.373 314.333 228.976 314.444C228.571 314.508 228.158 314.508 227.752 314.444C227.298 314.378 226.866 314.201 226.496 313.929C226.215 313.682 225.966 313.401 225.755 313.091L225.337 316.023L223.372 315.733L224.692 306.778L226.657 307.101V308.067C226.944 307.78 227.283 307.551 227.656 307.39C228.088 307.271 228.544 307.271 228.976 307.39C229.372 307.467 229.753 307.609 230.104 307.809C230.455 308.028 230.761 308.312 231.005 308.647C231.248 309.021 231.422 309.435 231.521 309.871C231.619 310.392 231.619 310.927 231.521 311.449C231.425 311.971 231.216 312.465 230.909 312.898ZM229.459 311.095C229.509 310.828 229.509 310.555 229.459 310.289C229.427 310.047 229.339 309.815 229.202 309.613C229.083 309.423 228.916 309.268 228.719 309.162C228.537 309.031 228.327 308.943 228.107 308.904C227.882 308.872 227.654 308.872 227.43 308.904C227.217 308.972 227.02 309.081 226.85 309.226C226.675 309.387 226.523 309.571 226.399 309.774C226.276 310.017 226.189 310.278 226.142 310.547C226.093 310.813 226.093 311.086 226.142 311.352C226.173 311.585 226.262 311.806 226.399 311.996C226.527 312.188 226.691 312.352 226.883 312.48C227.006 312.657 227.172 312.801 227.366 312.898C227.589 312.946 227.819 312.946 228.042 312.898C228.257 312.836 228.455 312.726 228.622 312.576C228.813 312.432 228.968 312.244 229.073 312.029C229.211 311.791 229.299 311.528 229.331 311.256L229.459 311.095Z",
      fill: "black"
    }), /* @__PURE__ */ jsx("path", {
      d: "M239.187 313.124V313.349L234.42 312.64C234.411 312.842 234.444 313.043 234.516 313.231C234.588 313.42 234.698 313.591 234.838 313.736C235.11 314.024 235.475 314.206 235.869 314.251C236.166 314.316 236.474 314.316 236.771 314.251C237.084 314.165 237.378 314.023 237.641 313.832L238.607 314.992C238.231 315.346 237.779 315.61 237.286 315.765C236.747 315.897 236.183 315.897 235.644 315.765C235.148 315.682 234.669 315.519 234.226 315.282C233.826 315.052 233.476 314.746 233.196 314.38C232.927 314 232.73 313.575 232.616 313.124C232.534 312.633 232.534 312.132 232.616 311.642C232.745 310.702 233.215 309.842 233.937 309.226C234.283 308.954 234.676 308.746 235.096 308.614C235.563 308.517 236.046 308.517 236.513 308.614C237.027 308.682 237.521 308.857 237.963 309.13C238.338 309.396 238.656 309.736 238.897 310.128C239.126 310.523 239.269 310.962 239.315 311.417C239.38 311.898 239.38 312.385 239.315 312.866C239.25 312.939 239.206 313.028 239.187 313.124ZM237.029 310.74C236.925 310.583 236.787 310.452 236.625 310.357C236.463 310.263 236.282 310.206 236.095 310.193C235.917 310.155 235.733 310.156 235.555 310.195C235.377 310.234 235.21 310.31 235.064 310.418C234.753 310.684 234.519 311.029 234.387 311.417L237.318 311.867C237.349 311.47 237.247 311.074 237.029 310.74Z",
      fill: "black"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_10025_65883",
        x1: "77.5735",
        y1: "121.093",
        x2: "76.74",
        y2: "111.936",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#3C88C4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2D5382"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_10025_65883",
        x1: "4281.88",
        y1: "-2494.71",
        x2: "4266.5",
        y2: "-2719.94",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#3C88C4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2D5382"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_10025_65883",
        x1: "103.129",
        y1: "135.562",
        x2: "103.708",
        y2: "161.661",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_10025_65883",
        x1: "4877.37",
        y1: "-2455.66",
        x2: "4866.76",
        y2: "-2674.89",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_10025_65883",
        x1: "4050.19",
        y1: "-1594.61",
        x2: "4047.88",
        y2: "-1651.57",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_10025_65883",
        x1: "102.091",
        y1: "143.222",
        x2: "113.645",
        y2: "203.867",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#297EA4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#25A6C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint6_linear_10025_65883",
        x1: "57.6996",
        y1: "211.59",
        x2: "49.8105",
        y2: "211.722",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint7_linear_10025_65883",
        x1: "3262.81",
        y1: "-8579.51",
        x2: "3008.25",
        y2: "-8551.41",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint8_linear_10025_65883",
        x1: "3332.12",
        y1: "-8535.92",
        x2: "3077.65",
        y2: "-8508.54",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint9_linear_10025_65883",
        x1: "3414.43",
        y1: "-8493.79",
        x2: "3159.87",
        y2: "-8465.69",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint10_linear_10025_65883",
        x1: "3468.91",
        y1: "-8450.52",
        x2: "3214.51",
        y2: "-8423.16",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint11_linear_10025_65883",
        x1: "3531.91",
        y1: "-8411.89",
        x2: "3276.55",
        y2: "-8383.86",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint12_linear_10025_65883",
        x1: "3604.5",
        y1: "-8361.35",
        x2: "3350.64",
        y2: "-8334.1",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint13_linear_10025_65883",
        x1: "3701.6",
        y1: "-8331.63",
        x2: "3447.25",
        y2: "-8303.61",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint14_linear_10025_65883",
        x1: "5955.8",
        y1: "-9347.18",
        x2: "3937.6",
        y2: "-8431.03",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint15_linear_10025_65883",
        x1: "94.7274",
        y1: "160.763",
        x2: "198.741",
        y2: "132.572",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#B2F5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#F0FDFC"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint16_linear_10025_65883",
        x1: "130.391",
        y1: "131.684",
        x2: "97.0185",
        y2: "192.442",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5D1780"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.25",
          stopColor: "#6C2E93"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#946AC3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A584D8"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint17_linear_10025_65883",
        x1: "804.269",
        y1: "-5073.99",
        x2: "660.938",
        y2: "-4992.14",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint18_linear_10025_65883",
        x1: "52.727",
        y1: "327.232",
        x2: "24.7372",
        y2: "287.292",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint19_linear_10025_65883",
        x1: "5996.68",
        y1: "-1089.78",
        x2: "6009.76",
        y2: "-751.983",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#297EA4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#25A6C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint20_linear_10025_65883",
        x1: "62.2186",
        y1: "313.009",
        x2: "176.478",
        y2: "144.095",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#38AFDB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint21_linear_10025_65883",
        x1: "68.8317",
        y1: "236.144",
        x2: "163.463",
        y2: "236.144",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.04",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.62",
          stopColor: "white",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.68",
          stopColor: "white",
          stopOpacity: "0.01"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.73",
          stopColor: "white",
          stopOpacity: "0.05"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "white",
          stopOpacity: "0.12"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "white",
          stopOpacity: "0.21"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.86",
          stopColor: "white",
          stopOpacity: "0.33"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.9",
          stopColor: "white",
          stopOpacity: "0.48"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.94",
          stopColor: "white",
          stopOpacity: "0.65"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "white",
          stopOpacity: "0.85"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint22_linear_10025_65883",
        x1: "49.4094",
        y1: "239.783",
        x2: "170.742",
        y2: "256.725",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint23_linear_10025_65883",
        x1: "1971.52",
        y1: "7454.02",
        x2: "6477.07",
        y2: "7933.42",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint24_linear_10025_65883",
        x1: "1350.3",
        y1: "-381.605",
        x2: "1484.01",
        y2: "-362.696",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint25_linear_10025_65883",
        x1: "1084.87",
        y1: "-345.785",
        x2: "1275.53",
        y2: "-318.824",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint26_linear_10025_65883",
        x1: "1106.25",
        y1: "-380.645",
        x2: "1224.46",
        y2: "-363.927",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint27_linear_10025_65883",
        x1: "1108.2",
        y1: "102.538",
        x2: "1205.03",
        y2: "116.231",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint28_linear_10025_65883",
        x1: "967.679",
        y1: "129.003",
        x2: "1051.99",
        y2: "140.925",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint29_linear_10025_65883",
        x1: "997.689",
        y1: "155.222",
        x2: "1107.05",
        y2: "170.687",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint30_linear_10025_65883",
        x1: "688.325",
        y1: "154.407",
        x2: "758.77",
        y2: "164.369",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#B2F5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint31_linear_10025_65883",
        x1: "129.748",
        y1: "186.991",
        x2: "88.7824",
        y2: "250.492",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#E8B414"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#D7830A"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint32_linear_10025_65883",
        x1: "138.115",
        y1: "181.477",
        x2: "119.746",
        y2: "209.938",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2A54D3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#43E8E1"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint33_linear_10025_65883",
        x1: "116.846",
        y1: "176.335",
        x2: "133.273",
        y2: "239.796",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#EDC418"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#C95900"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint34_linear_10025_65883",
        x1: "113.133",
        y1: "200.155",
        x2: "123.719",
        y2: "206.296",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#D7830A"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#EABC16"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint35_linear_10025_65883",
        x1: "94.9211",
        y1: "199.65",
        x2: "140.691",
        y2: "199.65",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.67",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint36_linear_10025_65883",
        x1: "13296.5",
        y1: "5587.64",
        x2: "8364.04",
        y2: "4154.09",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint37_linear_10025_65883",
        x1: "285.364",
        y1: "260.257",
        x2: "147.831",
        y2: "239.054",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#B2F5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      })]
    })]
  });
};
const polygonLogo = (width = "120", height = "160") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0,0,120,160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M87.3956 62.2618C86.3447 61.7043 85.1717 61.4126 83.9803 61.4126C82.7889 61.4126 81.6158 61.7043 80.565 62.2618L65.1693 71.3015L54.4126 77.2366L39.0169 86.2829C37.9661 86.8405 36.793 87.1321 35.6016 87.1321C34.4102 87.1321 33.2372 86.8405 32.1863 86.2829L19.9505 79.2128C18.9439 78.6365 18.102 77.8148 17.5043 76.8253C16.9067 75.8358 16.5732 74.7113 16.5352 73.5581V59.4378C16.5131 58.272 16.8216 57.1236 17.4255 56.1236C18.0294 55.1237 18.9044 54.3126 19.9505 53.7831L32.1863 47C33.2372 46.4425 34.4102 46.1508 35.6016 46.1508C36.793 46.1508 37.9661 46.4425 39.0169 47L51.2527 53.7831C52.2593 54.3593 53.1012 55.1811 53.6989 56.1706C54.2965 57.1601 54.6301 58.2846 54.668 59.4378V68.4775L65.1693 62.2619V53.5026C65.1965 52.3424 64.896 51.1978 64.3019 50.1985C63.7078 49.1991 62.8439 48.3848 61.8078 47.8479L39.2993 34.8492C38.2484 34.2917 37.0754 34 35.884 34C34.6926 34 33.5195 34.2917 32.4687 34.8492L9.70463 47.8479C8.56833 48.2854 7.59961 49.0671 6.9359 50.0821C6.27218 51.0971 5.94718 52.2939 6.007 53.5027V79.7803C5.98992 80.9416 6.30083 82.0844 6.90447 83.0792C7.50812 84.0739 8.38035 84.8808 9.42227 85.4084L32.1863 98.4337C33.2372 98.9913 34.4102 99.283 35.6016 99.283C36.793 99.283 37.9661 98.9913 39.0169 98.4337L54.4126 89.6745L64.9408 83.4589L80.2826 74.7264C81.3335 74.1689 82.5065 73.8772 83.6979 73.8772C84.8893 73.8772 86.0623 74.1689 87.1132 74.7264L99.349 81.5095C100.356 82.0858 101.198 82.9075 101.795 83.897C102.393 84.8865 102.726 86.011 102.764 87.1642V101.011C102.786 102.177 102.478 103.325 101.874 104.325C101.27 105.325 100.395 106.136 99.349 106.666L87.1132 113.729C86.0624 114.287 84.8893 114.578 83.6979 114.578C82.5065 114.578 81.3335 114.287 80.2826 113.729L68.0468 106.946C67.0402 106.37 66.1983 105.548 65.6007 104.558C65.003 103.569 64.6695 102.444 64.6315 101.291V92.2181L54.4126 98.1466V107.186C54.3904 108.352 54.6989 109.5 55.3028 110.5C55.9068 111.5 56.7817 112.311 57.8278 112.841L80.5919 125.84C81.6427 126.397 82.8158 126.689 84.0072 126.689C85.1986 126.689 86.3716 126.397 87.4224 125.84L110.186 112.841C111.187 112.262 112.023 111.44 112.616 110.452C113.209 109.464 113.539 108.342 113.575 107.193V80.9086C113.597 79.7428 113.289 78.5943 112.685 77.5944C112.081 76.5944 111.206 75.7834 110.16 75.2538L87.3956 62.2618Z",
      fill: "url(#paint0_linear_30_8716)",
      fillOpacity: "0.7"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M31.8828 33.745C33.1144 33.0916 34.4886 32.75 35.884 32.75C37.2793 32.75 38.6535 33.0916 39.8851 33.745L39.9049 33.7555L62.4094 46.7518C63.6401 47.3958 64.6677 48.3675 65.3764 49.5597C66.0876 50.7561 66.449 52.1264 66.4193 53.5165V62.9746L53.418 70.6699V59.4594C53.384 58.5271 53.1128 57.618 52.6289 56.8168C52.143 56.0123 51.4584 55.3428 50.6389 54.872L38.4214 48.0991C37.5538 47.6408 36.5854 47.4008 35.6016 47.4008C34.6178 47.4008 33.6495 47.6408 32.7819 48.0991L20.536 54.8877L20.5151 54.8983C19.6773 55.3224 18.9778 55.9713 18.4955 56.7699C18.0133 57.5683 17.7673 58.4846 17.785 59.4141L17.7852 59.426V73.5364C17.8192 74.4687 18.0904 75.3778 18.5743 76.1791C19.0617 76.9859 19.7488 77.657 20.5715 78.128L20.5759 78.1305L32.7912 85.1888C33.6564 85.6439 34.6213 85.8821 35.6016 85.8821C36.5804 85.8821 37.5439 85.6446 38.4081 85.1908L53.7939 76.1503L64.5508 70.2151L79.9553 61.1703L79.9791 61.1576C81.2107 60.5042 82.5849 60.1626 83.9803 60.1626C85.3756 60.1626 86.7499 60.5042 87.9814 61.1576L87.9984 61.1667L110.753 74.1534C111.995 74.7886 113.035 75.7561 113.755 76.9481C114.478 78.146 114.849 79.522 114.825 80.9197V107.213L114.824 107.232C114.781 108.595 114.39 109.925 113.688 111.095C112.986 112.265 111.996 113.238 110.813 113.923L110.806 113.927L88.0254 126.935L88.0083 126.944C86.7767 127.597 85.4025 127.939 84.0072 127.939C82.6118 127.939 81.2376 127.597 80.006 126.944L79.9889 126.935L57.2341 113.941C55.9926 113.306 54.9528 112.339 54.2328 111.147C53.5094 109.949 53.1383 108.573 53.1626 107.175V97.4267L65.8815 90.0478V101.27C65.9155 102.202 66.1867 103.111 66.6706 103.912C67.1566 104.717 67.8413 105.386 68.6609 105.857C68.6632 105.858 68.6655 105.86 68.6679 105.861L80.8781 112.63C81.7457 113.088 82.7141 113.328 83.6979 113.328C84.6783 113.328 85.6432 113.09 86.5085 112.635L98.7538 105.566L98.7845 105.55C99.6223 105.126 100.322 104.477 100.804 103.679C101.286 102.88 101.532 101.964 101.515 101.034L101.514 101.023V87.186C101.48 86.2537 101.209 85.3445 100.725 84.5433C100.239 83.7387 99.5546 83.0691 98.735 82.5983C98.7326 82.5969 98.7303 82.5956 98.728 82.5943L86.5176 75.8255C85.65 75.3672 84.6817 75.1272 83.6979 75.1272C82.7164 75.1272 81.7502 75.3661 80.8841 75.8223L65.5678 84.5403L55.0394 90.756L39.619 99.5293L39.6028 99.5379C38.3712 100.191 36.997 100.533 35.6016 100.533C34.2063 100.533 32.832 100.191 31.6005 99.5379L31.5829 99.5286L8.82788 86.5085C7.59161 85.8756 6.55531 84.9133 5.83584 83.7276C5.11223 82.5352 4.73831 81.1649 4.757 79.7716V53.532C4.69146 52.07 5.08772 50.6245 5.88971 49.398C6.67944 48.1903 7.82297 47.2554 9.16307 46.7177L31.8657 33.7541L31.8828 33.745ZM33.0709 35.9448L10.2422 48.9804L10.1538 49.0144C9.2611 49.3581 8.50168 49.9716 7.98208 50.7662C7.46257 51.5607 7.20873 52.4964 7.25547 53.4409L7.257 53.4718V79.7895L7.25686 79.7987C7.24324 80.7246 7.49109 81.6364 7.97311 82.4307C8.45517 83.2251 9.15248 83.8707 9.98693 84.2932L10.0154 84.3076L32.789 97.3384C33.6548 97.7943 34.6205 98.033 35.6016 98.033C36.5832 98.033 37.5494 97.794 38.4156 97.3377L53.7857 88.593L64.3138 82.3775L79.6804 73.6309L79.6968 73.6222C80.9283 72.9688 82.3026 72.6272 83.6979 72.6272C85.0933 72.6272 86.4675 72.9688 87.699 73.6222L87.7092 73.6276L99.9626 80.4204L99.9701 80.4247C101.161 81.1062 102.157 82.0787 102.865 83.2508C103.573 84.423 103.969 85.7558 104.014 87.1231L104.014 87.1437V101C104.038 102.397 103.667 103.773 102.944 104.971C102.225 106.162 101.186 107.129 99.9456 107.764L87.7188 114.823L87.699 114.833C86.4675 115.487 85.0933 115.828 83.6979 115.828C82.3026 115.828 80.9283 115.487 79.6968 114.833L79.6866 114.828L67.4332 108.035L67.4257 108.031C66.2353 107.349 65.2386 106.377 64.5307 105.205C63.8227 104.032 63.4272 102.7 63.3822 101.332L63.3815 101.312V94.3884L55.6626 98.8665V107.198L55.6623 107.21C55.6447 108.139 55.8906 109.056 56.3728 109.854C56.8551 110.653 57.5546 111.302 58.3924 111.726L58.4204 111.74L81.1941 124.744C82.06 125.2 83.0259 125.439 84.0072 125.439C84.9885 125.439 85.9543 125.2 86.8203 124.744L109.56 111.759C109.562 111.758 109.563 111.758 109.564 111.757C110.38 111.284 111.061 110.613 111.544 109.809C112.024 109.009 112.292 108.102 112.325 107.172V80.8967L112.325 80.8848C112.343 79.9553 112.097 79.039 111.615 78.2406C111.132 77.4421 110.433 76.7931 109.595 76.369L109.567 76.3549L86.7934 63.3575C85.9275 62.9014 84.9616 62.6626 83.9803 62.6626C83.0014 62.6626 82.0379 62.9002 81.1736 63.354L65.7878 72.3878L55.0312 78.3229L39.6267 87.3744L39.6027 87.3871C38.3712 88.0406 36.997 88.3821 35.6016 88.3821C34.2063 88.3821 32.832 88.0406 31.6005 87.3871L31.5805 87.3766L19.3294 80.2976C19.3287 80.2972 19.3279 80.2968 19.3272 80.2964C18.1377 79.6149 17.1418 78.6429 16.4344 77.4715C15.7264 76.2993 15.3309 74.9665 15.2859 73.5992L15.2852 73.5786V59.4492C15.261 58.0514 15.632 56.6753 16.3555 55.4774C17.0768 54.2831 18.1193 53.3142 19.364 52.6789L31.5903 45.9012L31.6005 45.8958C32.832 45.2424 34.2063 44.9008 35.6016 44.9008C36.997 44.9008 38.3712 45.2424 39.6028 45.8958L39.6129 45.9012L51.8663 52.694L51.8738 52.6983C53.0642 53.3798 54.0609 54.3522 54.7689 55.5243C55.4768 56.6965 55.8723 58.0293 55.9173 59.3967L55.918 59.4172V66.285L63.9193 61.5492V53.488L63.9197 53.4734C63.9413 52.5483 63.7018 51.6352 63.2274 50.8372C62.753 50.0391 62.0624 49.3877 61.2327 48.9577L61.2074 48.9446L38.6945 35.9434C37.8293 35.4883 36.8643 35.25 35.884 35.25C34.9027 35.25 33.9368 35.4888 33.0709 35.9448Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("defs", {
      children: /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_30_8716",
        x1: "59.788",
        y1: "34",
        x2: "59.788",
        y2: "126.689",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.3"
        })]
      })
    })]
  });
};
const servers = (width = "323", height = "398") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 323 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      opacity: "0.7",
      d: "M292.365 226.24C301.592 150.424 247.556 81.4911 171.672 72.2729C95.789 63.0547 26.7939 117.042 17.5674 192.858C8.34098 268.673 62.377 337.607 138.26 346.825C214.144 356.043 283.139 302.055 292.365 226.24Z",
      fill: "#21BF96"
    }), /* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip0_8801_37918)",
      children: [/* @__PURE__ */ jsx("path", {
        d: "M121.923 110.553C120.613 110.553 118.008 109.257 118.008 107.976V71.8593C118.076 70.8486 118.513 69.8981 119.234 69.1871C119.955 68.4762 120.911 68.0539 121.923 67.9999C122.449 67.921 122.987 67.9661 123.493 68.1314C123.999 68.2968 124.46 68.5779 124.839 68.9525C125.217 69.3271 125.503 69.7849 125.674 70.2895C125.845 70.794 125.896 71.3315 125.823 71.8593V107.99C127.147 109.257 125.823 110.553 121.923 110.553Z",
        fill: "url(#paint0_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.61",
        d: "M55.9292 276.763V340.37L154.667 397.971V334.393L55.9292 276.763Z",
        fill: "url(#paint1_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.61",
        d: "M154.667 334.393V398L267.338 334.077V268.972L154.667 334.393Z",
        fill: "url(#paint2_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M168.585 212.263L55.9003 276.057V277.353L154.667 334.393L267.338 269.275V267.993L168.585 212.263ZM238.35 254.025L250.426 260.994V261.498L238.35 268.468H238.062L226 261.498V260.994L238.062 254.025H238.35ZM156.308 269.534V269.044L168.384 262.074H168.672L180.748 269.044V269.534L168.672 276.504H168.384L156.308 269.534ZM166.815 277.08V277.584L154.753 284.553H154.466L142.39 277.584V277.08L154.466 270.11H154.753L166.815 277.08ZM170.241 261.498V260.994L182.302 254.025H182.59L194.666 260.994V261.498L182.59 268.468H182.302L170.241 261.498ZM180.748 253.449L168.672 260.418H168.384L156.365 253.434V252.945L168.441 245.96H168.729L180.805 252.945L180.748 253.449ZM166.815 260.994V261.498L154.753 268.468H154.466L142.39 261.498V260.994L154.466 254.025H154.753L166.815 260.994ZM152.897 269.044V269.534L140.821 276.504H140.533L128.457 269.534V269.044L140.533 262.074H140.821L152.897 269.044ZM138.964 277.08V277.584L126.902 284.553H126.615L114.539 277.584V277.08L126.615 270.11H126.902L138.964 277.08ZM128.586 285.115L140.662 278.145H140.95L153.026 285.115V285.605L140.95 292.589H140.662L128.586 285.605V285.115ZM142.519 293.151L154.595 286.181H154.883L166.945 293.151V293.755L154.883 300.725H154.595L142.519 293.755V293.151ZM156.437 285.605V285.115L168.513 278.145H168.801L180.877 285.115V285.605L168.801 292.589H168.513L156.437 285.605ZM170.37 277.569V277.065L182.432 270.095H182.72L194.796 277.065V277.569L182.72 284.539H182.432L170.37 277.569ZM184.288 269.519V269.03L196.235 262.074H196.523L208.584 269.044V269.534L196.523 276.504H196.235L184.288 269.519ZM198.221 261.484V260.98L210.283 254.01H210.571L222.647 260.98V261.484L210.571 268.454H210.283L198.221 261.484ZM208.714 253.434L196.652 260.404H196.364L184.288 253.434V252.945L196.364 245.96H196.652L208.714 252.945V253.434ZM194.796 245.399L182.72 252.369H182.432L170.37 245.399V244.895L182.432 237.925H182.72L194.796 244.895V245.399ZM180.877 237.349L168.801 244.319H168.513L156.437 237.349V236.845L168.513 229.875H168.801L180.877 236.845V237.349ZM166.945 244.895V245.399L154.883 252.369H154.595L142.519 245.399V244.895L154.595 237.925H154.883L166.945 244.895ZM153.026 252.945V253.434L140.95 260.404H140.662L128.586 253.434V252.945L140.662 245.96H140.95L153.026 252.945ZM139.093 260.98V261.484L127.032 268.454H126.744L114.668 261.484V260.98L126.744 254.01H127.032L139.093 260.98ZM125.175 269.03V269.519L113.099 276.489H112.811L100.75 269.519V269.03L112.754 262.074H113.042L125.175 269.03ZM111.243 277.065V277.569L99.1809 284.539H98.893L86.8171 277.569V277.065L98.893 270.095H99.1809L111.243 277.065ZM100.75 285.115L112.811 278.145H113.099L125.175 285.115V285.605L113.099 292.589H112.811L100.75 285.605V285.115ZM114.668 293.151L126.744 286.181H127.032L139.093 293.151V293.755L127.032 300.725H126.744L114.668 293.755V293.151ZM128.586 301.2L140.662 294.231H140.95L153.026 301.2V301.704L140.95 308.674H140.662L128.586 301.704V301.2ZM142.519 309.25L154.595 302.266H154.883L166.945 309.25V309.74L154.883 316.71H154.595L142.519 309.74V309.25ZM156.437 301.704V301.2L168.513 294.231H168.801L180.877 301.2V301.704L168.801 308.674H168.513L156.437 301.704ZM170.327 293.755V293.251L182.389 286.282H182.676L194.752 293.251V293.755L182.676 300.725H182.389L170.327 293.755ZM184.245 285.706V285.115L196.321 278.145H196.609L208.671 285.115V285.605L196.609 292.589H196.321L184.245 285.706ZM198.178 277.67V277.166L210.24 270.196H210.527L222.603 277.166V277.67L210.527 284.64H210.24L198.178 277.67ZM212.096 269.62V269.131L224.172 262.161H224.46L236.522 269.131V269.62L224.46 276.59H224.172L212.096 269.62ZM224.46 246.061L236.522 253.045V253.434L224.46 260.404H224.172L212.068 253.434V252.945L224.143 245.96L224.46 246.061ZM210.527 238.026L222.603 244.996V245.5L210.527 252.469H210.24L198.178 245.5V244.996L210.24 238.026H210.527ZM196.609 229.976L208.671 236.946V237.45L196.609 244.42H196.321L184.245 237.45V236.946L196.321 229.976H196.609ZM182.676 221.941L194.752 228.91V229.4L182.676 236.384H182.389L170.327 229.4V228.91L182.389 221.941H182.676ZM156.394 220.86L168.47 213.891H168.758L180.834 220.86V221.365L168.758 228.334H168.47L156.394 221.365V220.86ZM142.476 228.91L154.552 221.941H154.84L166.901 228.91V229.4L154.84 236.384H154.552L142.476 229.4V228.91ZM128.586 236.874L140.662 229.904H140.95L153.026 236.874V237.378L140.95 244.348H140.662L128.586 237.378V236.874ZM114.668 244.924L126.744 237.954H127.032L139.093 244.924V245.428L127.032 252.397H126.744L114.668 245.428V244.924ZM100.75 252.973L112.811 245.989H113.099L125.175 252.973V253.434L113.099 260.404H112.811L100.75 253.434V252.973ZM86.8171 261.009L98.893 254.039H99.1809L111.243 261.009V261.513L99.1809 268.483H98.893L86.8171 261.513V261.009ZM72.8987 269.059L84.9603 262.089H85.2482L97.3242 269.059V269.548L85.2482 276.518H84.9603L72.8987 269.548V269.059ZM71.0132 284.568L58.9372 277.598V277.094L71.0132 270.124H71.3011L83.3627 277.094V277.598L71.3011 284.568H71.0132ZM84.9316 292.618L72.87 285.634V285.115L84.9316 278.145H85.2194L97.2954 285.115V285.605L85.2194 292.589L84.9316 292.618ZM98.8643 300.653L86.7883 293.683V293.179L98.8643 286.21H99.1521L111.214 293.179V293.755L99.1521 300.725L98.8643 300.653ZM112.783 308.703L100.721 301.733V301.229L112.783 294.259H113.07L125.146 301.229V301.733L113.07 308.703H112.783ZM126.715 316.738L114.639 309.769V309.279L126.715 302.295H127.003L139.065 309.279V309.769L127.003 316.738H126.715ZM140.634 324.788L128.558 317.818V317.314L140.634 310.345H140.921L152.997 317.314V317.818L140.921 324.788H140.634ZM166.916 325.854L154.854 332.824H154.566L142.49 325.854V325.436L154.566 318.466H154.854L166.916 325.436V325.854ZM180.848 317.818L168.772 324.788H168.485L156.409 317.818V317.314L168.485 310.345H168.772L180.848 317.314V317.818ZM194.767 309.769L182.691 316.738H182.403L170.341 309.769V309.279L182.403 302.295H182.691L194.767 309.279V309.769ZM208.685 301.733L196.624 308.703H196.336L184.26 301.733V301.229L196.336 294.259H196.624L208.685 301.229V301.733ZM222.618 293.683L210.542 300.653H210.254L198.192 293.683V293.179L210.254 286.21H210.542L222.618 293.179V293.683ZM236.536 285.634L224.475 292.618H224.187L212.111 285.634V285.115L224.187 278.145H224.475L236.536 285.115V285.634ZM250.469 277.598L238.393 284.568H238.105L226.043 277.598V277.094L238.105 270.124H238.393L250.469 277.094V277.598ZM252.326 276.518H252.038L239.962 269.548V269.059L252.038 262.089H252.326L264.387 269.059V269.548L252.326 276.518Z",
        fill: "url(#paint3_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M154.178 332.708L56.8361 276.489L169.248 211.558L266.59 267.777L154.178 332.708Z",
        fill: "url(#paint4_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M55.9003 276.057L168.585 210.982L267.338 268.022L154.667 333.112L55.9003 276.057ZM142.447 324.083V324.572L154.523 331.542H154.811L166.873 324.572V324.083L154.811 317.098H154.523L142.447 324.083ZM156.365 316.033V316.537L168.441 323.507H168.729L180.805 316.537V316.033L168.729 309.063H168.441L156.365 316.033ZM128.514 316.033V316.537L140.59 323.507H140.878L152.954 316.537V316.033L140.878 309.063H140.59L128.514 316.033ZM170.255 307.983V308.487L182.317 315.457H182.604L194.68 308.487V307.983L182.604 301.013H182.317L170.255 307.983ZM142.404 307.983V308.487L154.48 315.457H154.768L166.829 308.487V307.983L154.768 301.013H154.48L142.404 307.983ZM114.553 307.983V308.487L126.629 315.457H126.917L138.978 308.487V307.983L126.917 301.013H126.629L114.553 307.983ZM196.235 292.978L184.159 299.947V300.437L196.235 307.421H196.523L208.584 300.437V299.947L196.523 292.978H196.235ZM168.384 292.978L156.308 299.947V300.437L168.384 307.421H168.672L180.748 300.437V299.947L168.672 292.978H168.384ZM128.586 299.947V300.437L140.662 307.421H140.95L153.026 300.437V299.947L140.95 292.978H140.662L128.586 299.947ZM112.754 292.978L100.692 299.947V300.437L112.754 307.421H113.042L125.118 300.437V299.947L113.042 292.978H112.754ZM198.164 291.898V292.402L210.225 299.371H210.513L222.589 292.402V291.898L210.513 284.928H210.225L198.164 291.898ZM170.313 291.898V292.402L182.374 299.371H182.662L194.738 292.402V291.898L182.662 284.928H182.374L170.313 291.898ZM142.462 291.898V292.402L154.538 299.371H154.825L166.887 292.402V291.898L154.825 284.928H154.538L142.462 291.898ZM114.611 291.898V292.402L126.686 299.371H126.974L139.036 292.402V291.898L126.974 284.928H126.686L114.611 291.898ZM86.7595 291.898V292.402L98.8354 299.371H99.1233L111.185 292.402V291.898L99.1233 284.928H98.8354L86.7595 291.898ZM212.082 283.862V284.352L224.158 291.322H224.446L236.507 284.352V283.862L224.446 276.892H224.158L212.082 283.862ZM184.231 283.862V284.352L196.307 291.322H196.595L208.656 284.352V283.862L196.595 276.892H196.307L184.231 283.862ZM156.38 283.862V284.352L168.456 291.322H168.744L180.82 284.352V283.862L168.744 276.892H168.456L156.38 283.862ZM128.529 283.862V284.352L140.605 291.322H140.893L152.969 284.352V283.862L140.893 276.892H140.605L128.529 283.862ZM100.692 283.862V284.352L112.754 291.322H113.042L125.118 284.352V283.862L113.042 276.892H112.754L100.692 283.862ZM72.8412 283.862V284.352L84.9028 291.322H85.1906L97.2666 284.352V283.862L85.1906 276.892H84.9028L72.8412 283.862ZM226.015 275.812V276.316L238.076 283.286H238.364L250.44 276.316V275.812L238.364 268.843H238.076L226.015 275.812ZM210.182 268.843L198.12 275.812V276.316L210.182 283.286H210.47L222.546 276.316V275.812L210.47 268.843H210.182ZM170.327 275.812V276.316L182.389 283.286H182.676L194.752 276.316V275.812L182.676 268.843H182.389L170.327 275.812ZM142.476 275.812V276.316L154.552 283.286H154.84L166.901 276.316V275.812L154.84 268.843H154.552L142.476 275.812ZM114.625 275.812V276.316L126.701 283.286H126.989L139.05 276.316V275.812L126.989 268.843H126.701L114.625 275.812ZM86.7739 275.812V276.316L98.8499 283.286H99.1377L111.199 276.316V275.812L99.1377 268.843H98.8499L86.7739 275.812ZM70.9413 268.843L58.8653 275.812V276.316L70.9413 283.286H71.2291L83.2907 276.316V275.812L71.2291 268.843H70.9413ZM239.89 267.777V268.267L251.966 275.236H252.254L264.315 268.267V267.835L252.254 260.85H251.966L239.89 267.777ZM212.068 267.835V268.324L224.143 275.294H224.431L236.493 268.324V267.835L224.431 260.85H224.143L212.068 267.835ZM184.216 267.835V268.324L196.292 275.294H196.58L208.642 268.324V267.835L196.58 260.85H196.292L184.216 267.835ZM156.365 267.835V268.324L168.441 275.294H168.729L180.805 268.324V267.835L168.729 260.85H168.441L156.365 267.835ZM128.586 267.835V268.324L140.662 275.294H140.95L153.026 268.324V267.835L140.95 260.85H140.662L128.586 267.835ZM100.75 267.835V268.324L112.811 275.294H113.099L125.175 268.324V267.835L113.099 260.85H112.811L100.75 267.835ZM72.8987 267.835V268.324L84.9603 275.294H85.2482L97.3242 268.324V267.835L85.2482 260.85H84.9603L72.8987 267.835ZM226.072 259.785V260.289L238.134 267.259H238.422L250.498 260.289V259.785L238.422 252.815H238.134L226.072 259.785ZM198.221 259.785V260.289L210.283 267.259H210.571L222.647 260.289V259.785L210.571 252.815H210.283L198.221 259.785ZM170.37 259.785V260.289L182.432 267.259H182.72L194.796 260.289V259.785L182.72 252.815H182.432L170.37 259.785ZM142.519 259.785V260.289L154.595 267.259H154.883L166.945 260.289V259.785L154.883 252.815H154.595L142.519 259.785ZM114.668 259.785V260.289L126.744 267.259H127.032L139.093 260.289V259.785L127.032 252.815H126.744L114.668 259.785ZM86.8171 259.785V260.289L98.893 267.259H99.1809L111.243 260.289V259.785L99.1809 252.815H98.893L86.8171 259.785ZM212.139 251.735V252.239L224.215 259.209H224.503L236.565 252.239V251.735L224.503 244.765H224.215L212.139 251.735ZM196.307 244.765L184.231 251.735V252.239L196.235 259.194H196.523L208.584 252.225V251.72L196.523 244.751L196.307 244.765ZM168.456 244.765L156.38 251.735V252.239L168.456 259.209H168.744L180.82 252.239V251.735L168.744 244.765H168.456ZM128.586 251.677V252.181L140.662 259.151H140.95L153.026 252.181V251.677L140.95 244.707H140.662L128.586 251.677ZM112.754 244.707L100.692 251.677V252.181L112.754 259.194H113.042L125.118 252.225V251.72L113.042 244.751L112.754 244.707ZM198.164 243.642V244.131L210.225 251.116H210.513L222.589 244.131V243.642L210.513 236.672H210.225L198.164 243.642ZM170.313 243.642V244.131L182.374 251.116H182.662L194.738 244.131V243.642L182.662 236.672H182.374L170.313 243.642ZM142.462 243.642V244.131L154.538 251.116H154.825L166.887 244.131V243.642L154.825 236.672H154.538L142.462 243.642ZM114.611 243.642V244.131L126.686 251.116H126.974L139.036 244.131V243.642L126.974 236.672H126.686L114.611 243.642ZM184.231 235.592V236.154L196.307 243.123H196.595L208.656 236.154V235.65L196.595 228.68H196.307L184.231 235.592ZM156.38 235.592V236.154L168.456 243.123H168.744L180.82 236.154V235.65L168.744 228.68H168.456L156.38 235.592ZM128.529 235.592V236.154L140.605 243.123H140.893L152.969 236.154V235.65L140.893 228.68H140.605L128.529 235.592ZM170.269 227.557V228.046L182.331 235.016H182.619L194.695 228.046V227.513L182.619 220.544H182.331L170.269 227.557ZM142.418 227.557V228.046L154.494 235.016H154.782L166.844 228.046V227.513L154.782 220.544H154.494L142.418 227.557ZM168.413 212.537L156.337 219.507V220.011L168.413 226.981H168.701L180.776 220.011V219.507L168.701 212.537H168.413Z",
        fill: "url(#paint5_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.3",
        d: "M158.755 289.666L95.2086 252.959L168.586 210.564L232.132 247.285L158.755 289.666Z",
        fill: "url(#paint6_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M266.057 201.838L168.586 145.532L55.3248 210.953L154.639 268.324L267.885 202.903L266.057 201.838Z",
        fill: "#007BC4"
      }), /* @__PURE__ */ jsx("path", {
        d: "M267.914 202.903C267.914 202.903 200.668 166.7 168.6 148.182C131.753 169.465 55.3391 210.967 55.3391 210.967V213.603L154.653 270.974L267.899 205.553L267.914 202.903Z",
        fill: "url(#paint7_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M266.057 201.838L168.586 145.532L55.3248 210.953L154.639 268.324L267.885 202.903L266.057 201.838Z",
        fill: "url(#paint8_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M174.645 175.557L155.444 164.468C154.538 163.95 154.653 163.028 155.704 162.424C156.24 162.129 156.838 161.963 157.45 161.938C158.062 161.913 158.671 162.03 159.23 162.28L178.431 173.368C179.323 173.901 179.222 174.808 178.171 175.413C177.636 175.71 177.038 175.878 176.425 175.903C175.813 175.928 175.203 175.81 174.645 175.557Z",
        fill: "#FFEC55"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.3",
        d: "M225.151 216.108L145.6 170.157C144.693 169.638 144.808 168.717 145.844 168.126C146.379 167.826 146.976 167.656 147.589 167.628C148.201 167.601 148.811 167.717 149.371 167.968L228.937 213.934C229.843 214.452 229.728 215.374 228.678 215.964C228.143 216.265 227.545 216.435 226.932 216.46C226.319 216.485 225.709 216.364 225.151 216.108Z",
        fill: "url(#paint9_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.3",
        d: "M215.306 221.753L135.783 175.845C134.876 175.326 134.991 174.405 136.042 173.814C136.577 173.514 137.175 173.344 137.788 173.319C138.401 173.294 139.011 173.414 139.569 173.67L219.12 219.622C220.027 220.14 219.912 221.062 218.876 221.652C218.331 221.95 217.723 222.114 217.103 222.132C216.482 222.149 215.867 222.02 215.306 221.753Z",
        fill: "url(#paint10_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.3",
        d: "M205.447 227.513L125.895 181.547C124.988 181.029 125.104 180.107 126.14 179.517C126.676 179.219 127.274 179.051 127.886 179.026C128.498 179.001 129.108 179.12 129.666 179.373L209.189 225.31C210.096 225.843 209.981 226.75 208.93 227.355C208.401 227.648 207.811 227.814 207.207 227.842C206.603 227.869 206 227.757 205.447 227.513Z",
        fill: "url(#paint11_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M122.613 225.181L86.4861 204.3C85.5793 203.782 85.6945 202.86 86.7308 202.269C87.2655 201.969 87.8638 201.799 88.4767 201.774C89.0896 201.749 89.6997 201.869 90.2571 202.125L126.399 222.992C127.305 223.51 127.19 224.432 126.14 225.037C125.604 225.334 125.006 225.502 124.394 225.527C123.781 225.552 123.172 225.433 122.613 225.181Z",
        fill: "url(#paint12_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.3",
        d: "M185.742 238.875L106.191 192.952C105.284 192.434 105.399 191.512 106.435 190.908C106.972 190.613 107.57 190.447 108.182 190.422C108.793 190.397 109.402 190.514 109.962 190.764L189.528 236.73C190.435 237.248 190.319 238.17 189.269 238.76C188.732 239.056 188.132 239.221 187.519 239.241C186.906 239.261 186.298 239.136 185.742 238.875Z",
        fill: "url(#paint13_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M175.897 244.564L156.711 233.49C155.804 232.957 155.919 232.05 156.956 231.445C157.491 231.147 158.089 230.979 158.702 230.954C159.314 230.929 159.924 231.048 160.482 231.301L179.668 242.389C180.575 242.908 180.46 243.829 179.424 244.42C178.889 244.72 178.291 244.89 177.678 244.915C177.065 244.94 176.455 244.82 175.897 244.564Z",
        fill: "url(#paint14_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.3",
        d: "M146.305 227.513L96.3313 198.713C95.4245 198.194 95.5397 197.273 96.5904 196.682C97.1251 196.382 97.7225 196.212 98.3348 196.184C98.9471 196.157 99.5573 196.273 100.117 196.524L150.076 225.325C150.983 225.843 150.868 226.765 149.831 227.355C149.298 227.658 148.7 227.83 148.087 227.858C147.474 227.885 146.863 227.767 146.305 227.513Z",
        fill: "url(#paint15_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M203.014 191.944L183.813 180.842C182.907 180.323 183.022 179.402 184.058 178.811C184.594 178.514 185.192 178.346 185.804 178.321C186.417 178.296 187.026 178.414 187.585 178.667L206.785 189.756C207.692 190.274 207.577 191.196 206.541 191.786C206.006 192.086 205.408 192.256 204.796 192.284C204.184 192.311 203.574 192.195 203.014 191.944Z",
        fill: "url(#paint16_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M135.236 198.324L116.036 187.236C115.129 186.703 115.244 185.795 116.295 185.191C116.83 184.893 117.428 184.725 118.041 184.7C118.653 184.675 119.263 184.794 119.821 185.047L139.022 196.135C139.914 196.653 139.799 197.575 138.763 198.18C138.226 198.474 137.628 198.64 137.016 198.665C136.405 198.69 135.795 198.573 135.236 198.324Z",
        fill: "url(#paint17_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M178.632 223.395L144.419 203.609C143.512 203.09 143.627 202.169 144.664 201.578C145.198 201.278 145.797 201.108 146.41 201.083C147.023 201.058 147.633 201.178 148.19 201.434L182.432 221.206C183.339 221.724 183.223 222.646 182.173 223.251C181.634 223.547 181.034 223.715 180.419 223.74C179.805 223.765 179.193 223.647 178.632 223.395Z",
        fill: "#DD80A6"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.3",
        d: "M158.755 224.619L95.2086 187.912L168.586 145.517L232.132 182.224L158.755 224.619Z",
        fill: "url(#paint18_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M257.896 134.872C257.368 134.951 256.828 134.905 256.32 134.739C255.812 134.573 255.35 134.291 254.97 133.915C254.59 133.539 254.303 133.079 254.132 132.573C253.96 132.067 253.908 131.528 253.981 130.998V121.911C253.908 121.382 253.96 120.842 254.132 120.336C254.303 119.83 254.59 119.371 254.97 118.995C255.35 118.619 255.812 118.336 256.32 118.17C256.828 118.004 257.368 117.959 257.896 118.038C258.424 117.961 258.962 118.009 259.468 118.176C259.974 118.343 260.434 118.626 260.812 119.001C261.19 119.377 261.476 119.835 261.647 120.34C261.818 120.845 261.869 121.383 261.797 121.911V130.926C261.752 131.951 261.328 132.922 260.607 133.651C259.886 134.381 258.92 134.816 257.896 134.872Z",
        fill: "url(#paint19_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M267.914 137.885C267.914 137.885 200.668 101.683 168.6 83.1637C131.753 104.448 55.3391 145.95 55.3391 145.95V148.585L154.653 205.97L267.899 140.549L267.914 137.885Z",
        fill: "url(#paint20_radial_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M266.057 136.791L168.586 80.4851L55.3248 145.906L154.639 203.278L267.885 137.856L266.057 136.791Z",
        fill: "url(#paint21_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M152.364 176.291L100.117 146.05C98.3318 145.028 98.5621 143.17 100.62 142.033L160.943 107.184C162.002 106.592 163.186 106.257 164.399 106.207C165.611 106.157 166.819 106.393 167.923 106.896L220.157 137.064C221.941 138.101 221.711 139.945 219.653 141.097L159.331 175.946C158.278 176.547 157.099 176.891 155.889 176.951C154.678 177.011 153.471 176.785 152.364 176.291Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M188.189 152.271L141.699 125.414C140.835 124.91 140.936 123.974 141.943 123.456L157.416 114.513C157.933 114.228 158.509 114.068 159.099 114.046C159.689 114.023 160.276 114.139 160.813 114.384L207.303 141.226C208.181 141.73 208.066 142.666 207.059 143.199L191.6 152.127C191.082 152.415 190.504 152.577 189.912 152.602C189.32 152.627 188.73 152.514 188.189 152.271Z",
        fill: "#F7F8FA"
      }), /* @__PURE__ */ jsx("path", {
        d: "M163.13 130.512L151.242 123.643C149.673 122.736 149.802 121.152 151.673 120.101C152.604 119.58 153.643 119.286 154.708 119.241C155.773 119.196 156.834 119.401 157.805 119.842L169.708 126.711C171.277 127.618 171.076 129.202 169.262 130.253C168.332 130.773 167.292 131.068 166.227 131.113C165.162 131.158 164.101 130.952 163.13 130.512Z",
        fill: "url(#paint22_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M166.772 164.641L120.296 137.784C119.418 137.28 119.519 136.344 120.541 135.826L135.999 126.883C136.516 126.598 137.092 126.438 137.682 126.416C138.272 126.393 138.859 126.509 139.396 126.754L185.886 153.596C186.764 154.1 186.649 155.036 185.642 155.569L170.183 164.497C169.665 164.785 169.087 164.947 168.495 164.972C167.902 164.997 167.313 164.884 166.772 164.641Z",
        fill: "#F7F8FA"
      }), /* @__PURE__ */ jsx("path", {
        d: "M146.924 167.622L115.129 149.247C113.114 148.095 113.359 146.05 115.69 144.711C116.883 144.045 118.215 143.668 119.58 143.611C120.945 143.553 122.304 143.816 123.549 144.38L155.358 162.712C157.373 163.878 157.114 165.908 154.797 167.248C153.606 167.924 152.273 168.31 150.905 168.375C149.537 168.44 148.173 168.182 146.924 167.622Z",
        fill: "url(#paint23_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M141.641 142.882L129.752 136.013C128.183 135.106 128.313 133.522 130.199 132.471C131.129 131.95 132.168 131.656 133.233 131.611C134.298 131.566 135.359 131.771 136.33 132.212L148.219 139.081C149.788 139.988 149.658 141.572 147.773 142.623C146.842 143.143 145.803 143.438 144.738 143.483C143.673 143.528 142.612 143.322 141.641 142.882Z",
        fill: "url(#paint24_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M164.356 144.864C168.901 144.309 172.331 141.773 172.018 139.2C171.704 136.626 167.765 134.989 163.22 135.543C158.675 136.098 155.245 138.633 155.558 141.207C155.872 143.781 159.811 145.418 164.356 144.864Z",
        fill: "#F7F8FA",
        stroke: "white",
        strokeWidth: "0.58",
        strokeMiterlimit: "10"
      }), /* @__PURE__ */ jsx("path", {
        d: "M201.992 114.758L162.439 91.9047C160.784 90.9543 161 89.2839 162.9 88.175L163.317 87.9446C164.297 87.3999 165.39 87.0916 166.509 87.0441C167.629 86.9966 168.744 87.2112 169.766 87.671L209.318 110.524C210.974 111.475 210.758 113.145 208.858 114.254L208.44 114.485C207.461 115.029 206.368 115.338 205.249 115.385C204.129 115.433 203.014 115.218 201.992 114.758Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M173.508 96.9448L164.613 91.8182C163.447 91.127 163.591 89.9462 164.944 89.1686C165.64 88.7774 166.418 88.5554 167.216 88.5204C168.013 88.4854 168.808 88.6383 169.536 88.9669L178.431 94.1079C179.611 94.7847 179.453 95.98 178.1 96.7576C177.404 97.1508 176.625 97.3729 175.826 97.4055C175.028 97.438 174.234 97.2801 173.508 96.9448Z",
        fill: "url(#paint25_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M187.398 104.966L178.503 99.8249C177.322 99.1481 177.466 97.9672 178.834 97.1752C179.529 96.7898 180.305 96.5722 181.1 96.5397C181.895 96.5072 182.686 96.6607 183.411 96.988L192.306 102.129C193.486 102.806 193.342 104.001 191.989 104.779C191.291 105.164 190.512 105.382 189.715 105.414C188.919 105.447 188.125 105.293 187.398 104.966Z",
        fill: "#F7F8FA"
      }), /* @__PURE__ */ jsx("path", {
        d: "M223.438 125.789L214.543 120.648C213.363 119.971 213.507 118.79 214.874 117.998C215.57 117.613 216.346 117.395 217.141 117.363C217.935 117.33 218.727 117.484 219.451 117.811L228.347 122.952C229.527 123.629 229.383 124.81 228.015 125.602C227.32 125.987 226.544 126.205 225.749 126.237C224.954 126.27 224.163 126.116 223.438 125.789Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M250.368 141.341L247.95 139.901C247.216 139.484 247.302 138.749 248.152 138.26L250.023 137.18C250.458 136.932 250.947 136.792 251.448 136.772C251.949 136.752 252.447 136.852 252.901 137.064L255.334 138.504C256.053 138.922 255.967 139.656 255.118 140.146L253.261 141.226C252.824 141.478 252.333 141.619 251.829 141.639C251.325 141.659 250.824 141.557 250.368 141.341Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M245.057 136.92L229.93 128.151C229.21 127.733 229.311 127.013 230.131 126.538C230.557 126.299 231.032 126.164 231.519 126.141C232.006 126.119 232.492 126.21 232.938 126.408L248.065 135.149C248.771 135.567 248.684 136.287 247.864 136.776C247.439 137.015 246.964 137.152 246.477 137.177C245.99 137.202 245.504 137.114 245.057 136.92Z",
        fill: "url(#paint26_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M201.589 113.174L192.694 108.033C191.528 107.356 191.672 106.161 193.025 105.384C193.724 104.998 194.502 104.78 195.299 104.748C196.096 104.715 196.889 104.869 197.617 105.196L206.512 110.337C207.692 111.014 207.534 112.195 206.181 112.987C205.482 113.373 204.704 113.59 203.907 113.623C203.11 113.655 202.317 113.502 201.589 113.174Z",
        fill: "#F7F8FA"
      }), /* @__PURE__ */ jsx("path", {
        d: "M246.424 227.038C245.896 227.117 245.356 227.072 244.848 226.905C244.341 226.739 243.878 226.457 243.498 226.081C243.118 225.705 242.831 225.246 242.66 224.74C242.488 224.233 242.437 223.694 242.509 223.164V176.752C242.437 176.222 242.488 175.683 242.66 175.177C242.831 174.67 243.118 174.211 243.498 173.835C243.878 173.459 244.341 173.177 244.848 173.011C245.356 172.845 245.896 172.799 246.424 172.878C246.952 172.802 247.49 172.849 247.996 173.016C248.502 173.184 248.962 173.466 249.34 173.842C249.719 174.217 250.004 174.676 250.175 175.181C250.346 175.686 250.397 176.224 250.325 176.752V223.193C250.256 224.2 249.821 225.147 249.103 225.855C248.384 226.563 247.432 226.984 246.424 227.038Z",
        fill: "url(#paint27_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M255.809 254.082C255.28 254.161 254.741 254.116 254.233 253.949C253.725 253.783 253.263 253.501 252.883 253.125C252.503 252.749 252.216 252.29 252.044 251.784C251.872 251.277 251.821 250.738 251.894 250.209V241.179C251.823 240.651 251.877 240.113 252.049 239.609C252.222 239.104 252.51 238.647 252.889 238.273C253.269 237.899 253.73 237.618 254.237 237.453C254.743 237.287 255.282 237.242 255.809 237.32C256.335 237.241 256.873 237.286 257.379 237.452C257.885 237.617 258.346 237.898 258.725 238.273C259.103 238.647 259.39 239.105 259.56 239.61C259.731 240.114 259.782 240.652 259.709 241.179V250.209C259.647 251.22 259.216 252.174 258.496 252.889C257.777 253.603 256.821 254.028 255.809 254.082Z",
        fill: "url(#paint28_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M41.8382 288.298C39.2474 288.298 37.9376 287.002 37.9376 285.72V254.773C38.0028 253.763 38.4355 252.81 39.154 252.097C39.8726 251.383 40.8274 250.957 41.8382 250.9C42.3667 250.821 42.9063 250.866 43.4142 251.032C43.9221 251.199 44.3844 251.481 44.7643 251.857C45.1442 252.233 45.4314 252.692 45.603 253.198C45.7747 253.704 45.8261 254.244 45.7532 254.773V284.424C45.8261 284.953 45.7747 285.493 45.603 285.999C45.4314 286.505 45.1442 286.965 44.7643 287.341C44.3844 287.717 43.9221 287.999 43.4142 288.165C42.9063 288.331 42.3667 288.376 41.8382 288.298Z",
        fill: "url(#paint29_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M75.4754 253.535C72.8702 253.535 71.5748 252.239 71.5748 250.957V220.011C71.6369 218.999 72.0686 218.045 72.7878 217.331C73.507 216.617 74.4635 216.192 75.4754 216.137C76.0039 216.058 76.5435 216.104 77.0514 216.27C77.5593 216.436 78.0215 216.718 78.4015 217.094C78.7814 217.47 79.0685 217.929 79.2402 218.436C79.4119 218.942 79.4633 219.481 79.3904 220.011V249.661C79.4633 250.191 79.4119 250.73 79.2402 251.237C79.0685 251.743 78.7814 252.202 78.4015 252.578C78.0215 252.954 77.5593 253.236 77.0514 253.402C76.5435 253.568 76.0039 253.614 75.4754 253.535Z",
        fill: "url(#paint30_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M52.2158 196.409C50.906 196.409 48.3152 195.127 48.3152 193.831V157.729C48.3773 156.717 48.809 155.763 49.5282 155.049C50.2474 154.335 51.2039 153.91 52.2158 153.855C52.7432 153.779 53.2811 153.826 53.7871 153.993C54.2931 154.161 54.7534 154.443 55.1316 154.819C55.5098 155.194 55.7957 155.653 55.9665 156.158C56.1374 156.663 56.1887 157.201 56.1163 157.729V193.831C57.4261 195.127 56.1163 196.409 52.2158 196.409Z",
        fill: "url(#paint31_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M260.185 226.275C260.185 228.954 261.494 230.293 264.1 230.293C266.705 230.293 268 228.954 268 226.275C268 223.597 266.705 222.257 264.1 222.257C263.069 222.333 262.102 222.784 261.381 223.524C260.66 224.264 260.234 225.243 260.185 226.275Z",
        fill: "url(#paint32_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M45.3212 138.562C45.6683 138.558 46.0113 138.486 46.3303 138.349C46.6494 138.212 46.9384 138.014 47.1805 137.765C47.4226 137.516 47.6131 137.222 47.7411 136.899C47.8691 136.576 47.9321 136.231 47.9263 135.884C47.9321 135.536 47.8691 135.191 47.7411 134.868C47.6131 134.546 47.4226 134.251 47.1805 134.002C46.9384 133.753 46.6494 133.555 46.3303 133.418C46.0113 133.281 45.6683 133.209 45.3212 133.205C44.6213 133.216 43.9543 133.505 43.4662 134.007C42.978 134.508 42.7083 135.183 42.716 135.884C42.7083 136.584 42.978 137.259 43.4662 137.761C43.9543 138.263 44.6213 138.551 45.3212 138.562Z",
        fill: "url(#paint33_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M32.9891 155C34.6048 154.972 36.1435 154.324 37.2695 153.198C38.3955 152.072 39.0174 150.559 38.9996 148.989C39.0173 147.422 38.3947 145.911 37.2681 144.788C36.1415 143.666 34.6028 143.023 32.9891 143C31.3792 143.028 29.8462 143.674 28.7243 144.796C27.6025 145.918 26.9829 147.425 27.0007 148.989C26.977 150.557 27.594 152.07 28.7164 153.197C29.8389 154.323 31.3754 154.972 32.9891 155Z",
        fill: "url(#paint34_linear_8801_37918)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M68.8256 185.752C69.1728 185.748 69.5157 185.676 69.8348 185.539C70.1539 185.402 70.4428 185.204 70.6849 184.955C70.927 184.706 71.1175 184.412 71.2455 184.089C71.3735 183.766 71.4365 183.421 71.4308 183.074C71.4365 182.726 71.3735 182.381 71.2455 182.059C71.1175 181.736 70.927 181.441 70.6849 181.193C70.4428 180.944 70.1539 180.745 69.8348 180.608C69.5157 180.471 69.1728 180.399 68.8256 180.395C68.4785 180.399 68.1355 180.471 67.8164 180.608C67.4973 180.745 67.2084 180.944 66.9663 181.193C66.7242 181.441 66.5337 181.736 66.4057 182.059C66.2777 182.381 66.2147 182.726 66.2204 183.074C66.2147 183.421 66.2777 183.766 66.4057 184.089C66.5337 184.412 66.7242 184.706 66.9663 184.955C67.2084 185.204 67.4973 185.402 67.8164 185.539C68.1355 185.676 68.4785 185.748 68.8256 185.752Z",
        fill: "url(#paint35_linear_8801_37918)"
      })]
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_8801_37918",
        x1: "122.167",
        y1: "66.9343",
        x2: "122.167",
        y2: "109.963",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_8801_37918",
        x1: "105.08",
        y1: "311.86",
        x2: "90.1101",
        y2: "357.928",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#86D6F5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#86D6F5",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_8801_37918",
        x1: "210.754",
        y1: "306.333",
        x2: "226.806",
        y2: "355.597",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#86D6F5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#86D6F5",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint3_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(206.497 323.334) scale(180.233 180.322)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#490F66"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#212C6B"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_8801_37918",
        x1: "86.1696",
        y1: "272.126",
        x2: "238.364",
        y2: "272.126",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint5_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(206.497 322.052) scale(180.233 180.322)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#304B7F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#42206D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#490F66"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint6_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(163.678 250.122) scale(55.9036 55.9312)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#168B99"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#304B7F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42206D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#490F66"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint7_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-52673.8 35701.5) scale(12818.2 7404.38)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#304B7F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#42206D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#490F66"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint8_linear_8801_37918",
        x1: "168.802",
        y1: "265.862",
        x2: "150.101",
        y2: "112.384",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint9_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-19323.5 13714) scale(2027.77 1171.15)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#168B99"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#304B7F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42206D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#490F66"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint10_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-19912.5 13906.8) scale(2027.77 1170.66)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#168B99"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#304B7F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42206D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#490F66"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint11_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-20490.3 14106.7) scale(2026.74 1170.77)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#168B99"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#304B7F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42206D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#490F66"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint12_linear_8801_37918",
        x1: "85.8672",
        y1: "213.646",
        x2: "127.003",
        y2: "213.646",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FAF1C2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#F5E48C"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint13_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-21678.2 14504.7) scale(2027.77 1170.81)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#168B99"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#304B7F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42206D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#490F66"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint14_linear_8801_37918",
        x1: "-5935.22",
        y1: "4550.2",
        x2: "-5528.71",
        y2: "4550.2",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FAF1C2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#F5E48C"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint15_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-15006.3 9421.46) scale(856.957 493.912)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#168B99"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#304B7F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42206D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#490F66"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint16_linear_8801_37918",
        x1: "-5456.11",
        y1: "3987.83",
        x2: "-5049.37",
        y2: "3987.83",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FAF1C2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#F5E48C"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint17_linear_8801_37918",
        x1: "-6663.36",
        y1: "4056.47",
        x2: "-6256.59",
        y2: "4056.47",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FAF1C2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#F5E48C"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint18_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(12716.8 6575.68) scale(5318.11 3072.3)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#168B99"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#304B7F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42206D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#490F66"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint19_linear_8801_37918",
        x1: "257.892",
        y1: "117.592",
        x2: "257.892",
        y2: "134.675",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint20_radial_8801_37918",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-52673.8 30095.9) scale(12818.2 7405.25)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#304B7F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#42206D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#490F66"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint21_linear_8801_37918",
        x1: "55.3248",
        y1: "141.903",
        x2: "267.914",
        y2: "141.903",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#F7F8FA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E5D4E7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint22_linear_8801_37918",
        x1: "150.105",
        y1: "125.184",
        x2: "170.701",
        y2: "125.184",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#E66BAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E8006F"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint23_linear_8801_37918",
        x1: "-11968.4",
        y1: "6397.2",
        x2: "-10686.7",
        y2: "6397.2",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#E66BAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E8006F"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint24_linear_8801_37918",
        x1: "-5460.4",
        y1: "2978.31",
        x2: "-5165.2",
        y2: "2978.31",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#E66BAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E8006F"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint25_linear_8801_37918",
        x1: "-3632.16",
        y1: "1943.48",
        x2: "-3467.4",
        y2: "1943.48",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#E66BAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E8006F"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint26_linear_8801_37918",
        x1: "-3607.17",
        y1: "2726.32",
        x2: "-3353.79",
        y2: "2726.32",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#E66BAC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E8006F"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint27_linear_8801_37918",
        x1: "246.42",
        y1: "171.532",
        x2: "246.42",
        y2: "226.324",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint28_linear_8801_37918",
        x1: "255.804",
        y1: "236.876",
        x2: "255.804",
        y2: "253.886",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint29_linear_8801_37918",
        x1: "41.8644",
        y1: "249.958",
        x2: "41.8644",
        y2: "287.816",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint30_linear_8801_37918",
        x1: "75.5016",
        y1: "215.195",
        x2: "75.5016",
        y2: "253.053",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint31_linear_8801_37918",
        x1: "52.4646",
        y1: "152.792",
        x2: "52.4646",
        y2: "195.818",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint32_linear_8801_37918",
        x1: "264.1",
        y1: "230.091",
        x2: "264.1",
        y2: "222.905",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#3C88C4",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint33_linear_8801_37918",
        x1: "-1669.01",
        y1: "-68.8058",
        x2: "-1673.67",
        y2: "-51.835",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#3C88C4",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint34_linear_8801_37918",
        x1: "33.0044",
        y1: "142.71",
        x2: "33.0044",
        y2: "154.834",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint35_linear_8801_37918",
        x1: "68.8275",
        y1: "180.266",
        x2: "68.8275",
        y2: "185.678",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_8801_37918",
        children: /* @__PURE__ */ jsx("rect", {
          width: "237",
          height: "330",
          fill: "white",
          transform: "translate(31 68)"
        })
      })]
    })]
  });
};
const token = (width = "284", height = "398") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 284 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M278.986 226.283C282.288 199.191 277.483 171.729 265.178 147.368C252.874 123.008 233.622 102.843 209.857 89.4226C186.093 76.0026 158.882 69.9305 131.667 71.974C104.452 74.0175 78.4533 84.0849 56.9592 100.903C35.4652 117.722 19.4406 140.536 10.9117 166.461C2.38273 192.386 1.73247 220.258 9.04309 246.552C16.3537 272.847 31.2969 296.383 51.9833 314.186C72.6696 331.988 98.1702 343.257 125.261 346.568C143.253 348.766 161.502 347.399 178.966 342.543C196.429 337.688 212.765 329.44 227.041 318.27C241.316 307.1 253.251 293.227 262.164 277.444C271.077 261.66 276.793 244.276 278.986 226.283Z",
      fill: "#36CEA2"
    }), /* @__PURE__ */ jsx("path", {
      d: "M251.86 191.45C253.493 184.897 249.504 178.262 242.951 176.629C236.399 174.997 229.763 178.985 228.131 185.538C226.498 192.091 230.487 198.726 237.039 200.359C243.592 201.991 250.228 198.003 251.86 191.45Z",
      fill: "url(#paint0_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M240.443 188.477H239.159V328.467H240.443V188.477Z",
      fill: "url(#paint1_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M243.235 186.552C242.721 185.696 241.89 185.077 240.922 184.831C239.954 184.584 238.928 184.73 238.068 185.236C237.554 185.435 237.091 185.744 236.709 186.14C236.327 186.537 236.036 187.012 235.857 187.532C235.677 188.053 235.613 188.606 235.67 189.154C235.726 189.701 235.901 190.23 236.182 190.703C236.464 191.176 236.845 191.582 237.3 191.893C237.754 192.204 238.271 192.412 238.814 192.502C239.357 192.593 239.913 192.564 240.444 192.417C240.974 192.271 241.467 192.011 241.887 191.655C242.731 191.147 243.344 190.33 243.596 189.377C243.848 188.424 243.718 187.411 243.235 186.552Z",
      fill: "#A7F9EF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M23.0123 205.615C23.0123 205.615 23.0123 205.615 23.0123 205.808L17.4923 209.017V200.352C17.4715 200.324 17.4602 200.29 17.4602 200.256C17.4602 200.221 17.4715 200.187 17.4923 200.159L23.0123 196.95V205.615Z",
      fill: "url(#paint2_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M23.0121 218.26C23.0264 218.29 23.0338 218.323 23.0338 218.356C23.0338 218.389 23.0264 218.422 23.0121 218.452L17.4921 221.662V212.997C17.4752 212.967 17.4663 212.934 17.4663 212.9C17.4663 212.867 17.4752 212.833 17.4921 212.804L23.0121 209.595V218.26Z",
      fill: "url(#paint3_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M31.4207 207.412C31.435 207.442 31.4424 207.475 31.4424 207.509C31.4424 207.542 31.435 207.575 31.4207 207.605L25.9007 210.814V199.902C25.8864 199.872 25.879 199.84 25.879 199.806C25.879 199.773 25.8864 199.74 25.9007 199.71L31.4528 196.501L31.4207 207.412Z",
      fill: "url(#paint4_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M44.932 130.132C44.9461 130.157 44.9535 130.184 44.9535 130.212C44.9535 130.241 44.9461 130.268 44.932 130.293L39.412 133.502V124.837C39.3979 124.812 39.3905 124.785 39.3905 124.757C39.3905 124.728 39.3979 124.701 39.412 124.676L44.932 121.467V130.132Z",
      fill: "url(#paint5_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M44.9319 142.777C44.9462 142.807 44.9536 142.84 44.9536 142.873C44.9536 142.907 44.9462 142.939 44.9319 142.969L39.4119 146.179V137.514C39.395 137.484 39.3861 137.451 39.3861 137.417C39.3861 137.384 39.395 137.35 39.4119 137.321L44.9319 134.112V142.777Z",
      fill: "url(#paint6_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M53.34 131.929C53.3543 131.96 53.3617 131.992 53.3617 132.026C53.3617 132.059 53.3543 132.092 53.34 132.122L47.82 135.331V124.259C47.8057 124.229 47.7983 124.196 47.7983 124.163C47.7983 124.13 47.8057 124.097 47.82 124.067L53.34 121.05V131.929Z",
      fill: "url(#paint7_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M23.0121 231.065L17.3638 234.306V225.545L23.0121 222.271V231.065Z",
      fill: "url(#paint8_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M189.222 277.118L186.301 278.819V277.728L189.222 276.027V277.118Z",
      fill: "url(#paint9_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.11",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.11",
        d: "M137.841 302.6C136.584 301.867 135.156 301.481 133.701 301.481C132.246 301.481 130.818 301.867 129.561 302.6L80.202 331.035C80.029 331.137 79.8856 331.282 79.786 331.457C79.6864 331.631 79.634 331.829 79.634 332.03C79.634 332.23 79.6864 332.428 79.786 332.602C79.8856 332.777 80.029 332.922 80.202 333.024L129.978 361.908C131.09 362.554 132.352 362.893 133.637 362.893C134.922 362.893 136.184 362.554 137.295 361.908L187.136 333.024C187.316 332.925 187.467 332.778 187.572 332.6C187.677 332.423 187.732 332.22 187.732 332.014C187.732 331.807 187.677 331.605 187.572 331.427C187.467 331.249 187.316 331.103 187.136 331.003L137.841 302.6Z",
        fill: "url(#paint10_linear_9599_45580)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.11",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.11",
        d: "M137.841 294.352C136.582 293.626 135.155 293.243 133.701 293.243C132.248 293.243 130.82 293.626 129.561 294.352L80.2021 322.69C80.0295 322.797 79.8871 322.945 79.7883 323.122C79.6894 323.299 79.6376 323.499 79.6376 323.701C79.6376 323.904 79.6894 324.103 79.7883 324.28C79.8871 324.457 80.0295 324.606 80.2021 324.712L129.978 353.596C131.09 354.241 132.352 354.581 133.637 354.581C134.922 354.581 136.184 354.241 137.296 353.596L187.136 324.712C187.317 324.612 187.467 324.466 187.572 324.288C187.677 324.11 187.732 323.908 187.732 323.701C187.732 323.495 187.677 323.292 187.572 323.115C187.467 322.937 187.317 322.79 187.136 322.69L137.841 294.352Z",
        fill: "url(#paint11_linear_9599_45580)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.11",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.11",
        d: "M137.841 285.944C136.582 285.217 135.155 284.835 133.701 284.835C132.248 284.835 130.82 285.217 129.561 285.944L80.2021 314.378C80.0295 314.485 79.8871 314.633 79.7883 314.81C79.6894 314.987 79.6376 315.187 79.6376 315.389C79.6376 315.592 79.6894 315.791 79.7883 315.968C79.8871 316.145 80.0295 316.294 80.2021 316.4L129.978 345.284C131.095 345.914 132.355 346.245 133.637 346.245C134.919 346.245 136.179 345.914 137.296 345.284L187.136 316.4C187.317 316.3 187.467 316.154 187.572 315.976C187.677 315.798 187.732 315.596 187.732 315.389C187.732 315.183 187.677 314.98 187.572 314.802C187.467 314.625 187.317 314.478 187.136 314.378L137.841 285.944Z",
        fill: "url(#paint12_linear_9599_45580)"
      })
    }), /* @__PURE__ */ jsx("g", {
      opacity: "0.11",
      children: /* @__PURE__ */ jsx("path", {
        opacity: "0.11",
        d: "M137.841 277.632C136.582 276.905 135.155 276.522 133.701 276.522C132.248 276.522 130.82 276.905 129.561 277.632L80.2021 306.066C80.0295 306.172 79.8871 306.321 79.7883 306.498C79.6894 306.675 79.6376 306.874 79.6376 307.077C79.6376 307.28 79.6894 307.479 79.7883 307.656C79.8871 307.833 80.0295 307.982 80.2021 308.088L129.978 336.972C131.095 337.602 132.355 337.933 133.637 337.933C134.919 337.933 136.179 337.602 137.296 336.972L187.136 308.248C187.317 308.148 187.467 308.002 187.572 307.824C187.677 307.646 187.732 307.444 187.732 307.237C187.732 307.031 187.677 306.828 187.572 306.651C187.467 306.473 187.317 306.326 187.136 306.227L137.841 277.632Z",
        fill: "url(#paint13_linear_9599_45580)"
      })
    }), /* @__PURE__ */ jsx("path", {
      d: "M187.136 306.098L137.841 277.632C136.583 276.905 135.155 276.522 133.701 276.522C132.248 276.522 130.82 276.905 129.561 277.632L80.2022 306.066C80.0227 306.17 79.8743 306.32 79.7726 306.5C79.671 306.681 79.6199 306.886 79.6246 307.093V332.029C79.6256 332.231 79.6794 332.429 79.7808 332.604C79.8821 332.778 80.0274 332.923 80.2022 333.024L129.979 361.908C131.09 362.553 132.352 362.893 133.637 362.893C134.922 362.893 136.184 362.553 137.296 361.908L187.136 333.024C187.319 332.93 187.473 332.788 187.58 332.612C187.688 332.437 187.745 332.235 187.746 332.029V307.189C187.764 306.967 187.715 306.745 187.607 306.551C187.498 306.357 187.334 306.199 187.136 306.098Z",
      fill: "url(#paint14_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M187.136 306.098L137.841 277.632C136.583 276.905 135.155 276.522 133.701 276.522C132.248 276.522 130.82 276.905 129.561 277.632L80.2022 306.066C80.0227 306.17 79.8743 306.32 79.7726 306.5C79.671 306.681 79.6199 306.886 79.6246 307.093L130.139 335.977C131.256 336.622 132.524 336.961 133.814 336.961C135.104 336.961 136.371 336.622 137.488 335.977L187.746 307.093C187.745 306.887 187.688 306.686 187.58 306.51C187.473 306.335 187.319 306.192 187.136 306.098Z",
      fill: "url(#paint15_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M187.136 306.965L137.296 335.688C136.179 336.318 134.919 336.649 133.637 336.649C132.355 336.649 131.095 336.318 129.979 335.688L80.2023 306.804C80.0238 306.7 79.8704 306.557 79.753 306.387C79.6121 306.657 79.5801 306.97 79.6637 307.263C79.7473 307.556 79.9401 307.805 80.2023 307.96L129.979 336.843C131.095 337.473 132.355 337.804 133.637 337.804C134.919 337.804 136.179 337.473 137.296 336.843L187.136 308.12C187.407 307.965 187.606 307.71 187.69 307.41C187.774 307.11 187.736 306.788 187.585 306.515C187.487 306.709 187.33 306.866 187.136 306.965Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.2",
      d: "M133.669 310.463C137.586 310.463 140.762 308.624 140.762 306.355C140.762 304.086 137.586 302.247 133.669 302.247C129.752 302.247 126.576 304.086 126.576 306.355C126.576 308.624 129.752 310.463 133.669 310.463Z",
      fill: "#180D5B"
    }), /* @__PURE__ */ jsxs("g", {
      opacity: "0.61",
      children: [/* @__PURE__ */ jsx("path", {
        opacity: "0.61",
        d: "M137.135 278.563C136.096 277.963 134.917 277.647 133.717 277.647C132.517 277.647 131.338 277.963 130.299 278.563L89.5732 302.023C89.4265 302.107 89.3047 302.229 89.22 302.375C89.1353 302.522 89.0907 302.688 89.0907 302.857C89.0907 303.026 89.1353 303.192 89.22 303.339C89.3047 303.485 89.4265 303.607 89.5732 303.691L130.62 327.376C131.535 327.912 132.576 328.194 133.637 328.194C134.697 328.194 135.739 327.912 136.654 327.376L177.765 303.691C177.911 303.607 178.033 303.485 178.118 303.339C178.203 303.192 178.247 303.026 178.247 302.857C178.247 302.688 178.203 302.522 178.118 302.375C178.033 302.229 177.911 302.107 177.765 302.023L137.135 278.563Z",
        fill: "url(#paint16_linear_9599_45580)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.61",
        d: "M137.135 271.695C136.096 271.095 134.917 270.779 133.717 270.779C132.517 270.779 131.338 271.095 130.299 271.695L89.5732 295.155C89.4265 295.239 89.3047 295.361 89.22 295.507C89.1353 295.654 89.0907 295.82 89.0907 295.989C89.0907 296.158 89.1353 296.324 89.22 296.471C89.3047 296.617 89.4265 296.739 89.5732 296.823L130.62 320.508C131.535 321.044 132.576 321.327 133.637 321.327C134.697 321.327 135.739 321.044 136.654 320.508L177.765 296.856C177.911 296.771 178.033 296.65 178.118 296.503C178.203 296.357 178.247 296.19 178.247 296.021C178.247 295.852 178.203 295.686 178.118 295.539C178.033 295.393 177.911 295.271 177.765 295.187L137.135 271.695Z",
        fill: "url(#paint17_linear_9599_45580)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.61",
        d: "M137.135 264.859C136.096 264.259 134.917 263.943 133.717 263.943C132.517 263.943 131.338 264.259 130.299 264.859L89.5732 288.287C89.4265 288.371 89.3047 288.493 89.22 288.639C89.1353 288.786 89.0907 288.952 89.0907 289.121C89.0907 289.29 89.1353 289.457 89.22 289.603C89.3047 289.75 89.4265 289.871 89.5732 289.956L130.62 313.608C131.556 314.152 132.619 314.439 133.701 314.439C134.783 314.439 135.846 314.152 136.782 313.608L177.893 289.923C178.04 289.839 178.162 289.717 178.246 289.571C178.331 289.424 178.376 289.258 178.376 289.089C178.376 288.92 178.331 288.754 178.246 288.607C178.162 288.461 178.04 288.339 177.893 288.255L137.135 264.859Z",
        fill: "url(#paint18_linear_9599_45580)"
      })]
    }), /* @__PURE__ */ jsx("rect", {
      x: "213.484",
      y: "345.156",
      width: "1.54046",
      height: "1.54046",
      fill: "url(#pattern0)"
    }), /* @__PURE__ */ jsx("rect", {
      x: "221.187",
      y: "291.239",
      width: "1.54046",
      height: "1.54046",
      fill: "url(#pattern1)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M213.24 224.352C213.614 216.509 207.559 209.848 199.716 209.474C191.873 209.1 185.212 215.155 184.838 222.998C184.464 230.841 190.519 237.502 198.362 237.876C206.205 238.25 212.866 232.195 213.24 224.352Z",
      fill: "url(#paint19_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M202.861 221.437C202.423 220.688 201.773 220.085 200.992 219.705C200.212 219.325 199.336 219.184 198.476 219.301C197.616 219.418 196.809 219.786 196.158 220.36C195.507 220.935 195.041 221.689 194.818 222.528C194.595 223.367 194.625 224.253 194.905 225.075C195.184 225.896 195.701 226.617 196.39 227.145C197.078 227.674 197.908 227.987 198.774 228.045C199.64 228.103 200.504 227.903 201.257 227.47C202.267 226.88 203.002 225.915 203.303 224.784C203.604 223.654 203.445 222.451 202.861 221.437Z",
      fill: "url(#paint20_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M235.789 245.667C235.088 244.457 234.044 243.483 232.789 242.867C231.533 242.251 230.124 242.022 228.738 242.209C227.352 242.395 226.053 242.989 225.005 243.915C223.957 244.84 223.208 246.056 222.852 247.408C222.496 248.76 222.549 250.188 223.005 251.509C223.461 252.831 224.3 253.988 225.414 254.832C226.528 255.677 227.868 256.172 229.263 256.254C230.659 256.337 232.048 256.003 233.254 255.295C234.054 254.831 234.754 254.213 235.314 253.477C235.875 252.741 236.285 251.902 236.52 251.008C236.756 250.113 236.812 249.181 236.687 248.265C236.561 247.348 236.256 246.466 235.789 245.667Z",
      fill: "url(#paint21_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M231.585 248.138C231.442 247.889 231.251 247.671 231.024 247.496C230.796 247.321 230.536 247.192 230.259 247.118C229.982 247.043 229.693 247.024 229.408 247.062C229.123 247.099 228.849 247.192 228.6 247.336C228.098 247.626 227.731 248.103 227.581 248.662C227.43 249.222 227.509 249.819 227.798 250.321C228.087 250.823 228.564 251.19 229.124 251.34C229.684 251.491 230.28 251.412 230.783 251.123C231.032 250.98 231.25 250.789 231.425 250.562C231.6 250.334 231.729 250.075 231.803 249.797C231.878 249.52 231.897 249.231 231.859 248.946C231.822 248.661 231.729 248.387 231.585 248.138Z",
      fill: "url(#paint22_radial_9599_45580)"
    }), /* @__PURE__ */ jsxs("g", {
      opacity: "0.5",
      children: [/* @__PURE__ */ jsx("path", {
        opacity: "0.4",
        d: "M226.642 250.738C226.172 249.951 225.479 249.32 224.651 248.925C223.823 248.531 222.897 248.389 221.989 248.519C221.081 248.649 220.231 249.045 219.547 249.656C218.863 250.267 218.375 251.067 218.144 251.955C217.914 252.843 217.95 253.779 218.25 254.646C218.55 255.513 219.099 256.272 219.828 256.828C220.558 257.383 221.436 257.711 222.351 257.77C223.267 257.828 224.179 257.615 224.974 257.157C225.508 256.848 225.976 256.437 226.35 255.946C226.724 255.455 226.997 254.894 227.152 254.297C227.307 253.699 227.342 253.077 227.255 252.466C227.167 251.855 226.959 251.268 226.642 250.738Z",
        fill: "url(#paint23_radial_9599_45580)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.5",
        d: "M223.818 252.375C223.624 252.042 223.306 251.799 222.934 251.697C222.563 251.595 222.166 251.642 221.828 251.829C221.497 252.025 221.256 252.344 221.16 252.718C221.063 253.091 221.119 253.487 221.315 253.819C221.511 254.151 221.83 254.391 222.203 254.488C222.577 254.584 222.973 254.528 223.305 254.332C223.63 254.138 223.866 253.825 223.962 253.459C224.058 253.092 224.006 252.703 223.818 252.375Z",
        fill: "url(#paint24_radial_9599_45580)"
      })]
    }), /* @__PURE__ */ jsx("path", {
      d: "M220.224 247.785C219.836 247.135 219.208 246.663 218.476 246.471C217.744 246.279 216.965 246.382 216.308 246.758C215.986 246.95 215.704 247.203 215.48 247.504C215.255 247.805 215.092 248.146 215 248.51C214.908 248.874 214.888 249.252 214.942 249.623C214.995 249.994 215.122 250.351 215.314 250.674C215.496 251.001 215.743 251.288 216.039 251.518C216.335 251.748 216.675 251.915 217.037 252.011C217.4 252.107 217.778 252.129 218.149 252.076C218.52 252.022 218.876 251.895 219.197 251.701C219.522 251.512 219.806 251.26 220.034 250.961C220.262 250.661 220.428 250.32 220.524 249.956C220.619 249.593 220.642 249.213 220.59 248.841C220.539 248.468 220.414 248.11 220.224 247.785Z",
      fill: "url(#paint25_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M218.395 248.78C218.335 248.679 218.256 248.591 218.162 248.521C218.068 248.452 217.961 248.402 217.847 248.375C217.733 248.348 217.614 248.344 217.499 248.364C217.383 248.384 217.273 248.428 217.175 248.491C217.075 248.547 216.987 248.623 216.918 248.715C216.849 248.806 216.799 248.911 216.772 249.022C216.745 249.134 216.741 249.249 216.761 249.362C216.78 249.475 216.823 249.583 216.886 249.679C216.943 249.778 217.018 249.865 217.109 249.935C217.199 250.005 217.303 250.057 217.413 250.087C217.523 250.116 217.639 250.124 217.752 250.109C217.865 250.094 217.975 250.057 218.074 250C218.276 249.879 218.424 249.684 218.484 249.456C218.544 249.228 218.512 248.985 218.395 248.78Z",
      fill: "url(#paint26_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M223.594 209.338C222.839 208.034 221.714 206.983 220.362 206.319C219.009 205.656 217.49 205.408 215.997 205.609C214.504 205.81 213.104 206.449 211.975 207.447C210.845 208.444 210.038 209.755 209.655 211.212C209.271 212.669 209.329 214.207 209.821 215.631C210.313 217.055 211.217 218.301 212.418 219.21C213.619 220.12 215.063 220.653 216.567 220.74C218.071 220.828 219.567 220.468 220.866 219.704C222.597 218.686 223.855 217.025 224.366 215.083C224.877 213.141 224.599 211.076 223.594 209.338Z",
      fill: "url(#paint27_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M219.068 211.97C218.753 211.429 218.237 211.036 217.632 210.876C217.027 210.717 216.384 210.804 215.843 211.119C215.303 211.434 214.909 211.951 214.75 212.556C214.59 213.16 214.678 213.804 214.993 214.344C215.308 214.885 215.824 215.278 216.429 215.438C217.034 215.597 217.677 215.51 218.218 215.195C218.758 214.88 219.152 214.363 219.311 213.758C219.471 213.153 219.383 212.51 219.068 211.97Z",
      fill: "url(#paint28_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M206.456 203.914C205.693 202.627 204.567 201.594 203.218 200.946C201.87 200.298 200.36 200.064 198.878 200.274C197.397 200.483 196.011 201.127 194.895 202.123C193.778 203.12 192.982 204.424 192.607 205.872C192.232 207.321 192.293 208.848 192.785 210.261C193.276 211.674 194.175 212.91 195.368 213.813C196.561 214.716 197.995 215.245 199.488 215.334C200.982 215.423 202.468 215.067 203.76 214.312C204.622 213.809 205.376 213.14 205.978 212.344C206.581 211.548 207.02 210.64 207.27 209.674C207.521 208.708 207.578 207.701 207.438 206.713C207.298 205.724 206.964 204.773 206.456 203.914Z",
      fill: "url(#paint29_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M201.159 209.762C202.254 209.074 202.583 207.627 201.894 206.532C201.205 205.437 199.759 205.107 198.664 205.796C197.569 206.485 197.239 207.931 197.928 209.027C198.617 210.122 200.063 210.451 201.159 209.762Z",
      fill: "url(#paint30_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M55.394 245.827C65.0361 245.827 72.8526 238.011 72.8526 228.369C72.8526 218.727 65.0361 210.91 55.394 210.91C45.7519 210.91 37.9354 218.727 37.9354 228.369C37.9354 238.011 45.7519 245.827 55.394 245.827Z",
      fill: "url(#paint31_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M60.0477 225.641C59.5081 224.722 58.708 223.983 57.7485 223.518C56.7891 223.053 55.7133 222.883 54.6573 223.029C53.6012 223.176 52.6123 223.632 51.8155 224.34C51.0186 225.049 50.4497 225.977 50.1806 227.009C49.9115 228.041 49.9542 229.129 50.3035 230.136C50.6528 231.144 51.2928 232.025 52.1428 232.668C52.9927 233.312 54.0144 233.689 55.0787 233.752C56.143 233.815 57.2021 233.561 58.1221 233.023C58.7335 232.665 59.2683 232.19 59.6959 231.625C60.1236 231.06 60.4358 230.417 60.6146 229.731C60.7935 229.045 60.8354 228.331 60.7382 227.63C60.6409 226.928 60.4063 226.252 60.0477 225.641Z",
      fill: "url(#paint32_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.4",
      d: "M77.1269 279.733C80.8193 275.288 80.2097 268.692 75.7653 265C71.3209 261.307 64.7246 261.917 61.0321 266.361C57.3397 270.806 57.9493 277.402 62.3937 281.094C66.8381 284.787 73.4344 284.177 77.1269 279.733Z",
      fill: "url(#paint33_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M89.7658 232.605C89.5065 232.08 89.1418 231.613 88.6943 231.234C88.2468 230.856 87.7261 230.574 87.1647 230.405C86.6033 230.237 86.0132 230.185 85.4312 230.255C84.8492 230.325 84.2877 230.513 83.7818 230.809C83.2759 231.105 82.8364 231.502 82.4907 231.976C82.145 232.449 81.9005 232.988 81.7724 233.56C81.6443 234.132 81.6353 234.725 81.7462 235.3C81.857 235.876 82.0851 236.422 82.4165 236.906C82.6757 237.432 83.0404 237.898 83.4879 238.277C83.9354 238.655 84.4561 238.938 85.0175 239.106C85.5789 239.275 86.169 239.326 86.751 239.256C87.333 239.187 87.8945 238.998 88.4004 238.702C88.9063 238.406 89.3458 238.009 89.6915 237.536C90.0372 237.062 90.2818 236.523 90.4099 235.951C90.538 235.379 90.5469 234.787 90.4361 234.211C90.3252 233.636 90.0971 233.089 89.7658 232.605Z",
      fill: "url(#paint34_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M87.2306 234.082C87.0508 233.785 86.761 233.571 86.4244 233.487C86.0879 233.403 85.7317 233.455 85.4334 233.633C85.2805 233.716 85.1462 233.829 85.0386 233.966C84.9309 234.103 84.8522 234.26 84.8071 234.428C84.7621 234.596 84.7517 234.771 84.7766 234.944C84.8015 235.116 84.8612 235.281 84.952 235.43C85.1265 235.732 85.4139 235.952 85.7509 236.043C86.0879 236.133 86.447 236.086 86.7492 235.911C87.0535 235.73 87.2746 235.437 87.3647 235.095C87.4547 234.753 87.4066 234.389 87.2306 234.082Z",
      fill: "url(#paint35_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M87.3266 220.153C86.7267 219.129 85.8367 218.306 84.7692 217.788C83.7016 217.27 82.5044 217.08 81.3289 217.242C80.1534 217.404 79.0523 217.911 78.1648 218.699C77.2774 219.487 76.6433 220.52 76.3429 221.668C76.0424 222.816 76.0891 224.027 76.4769 225.149C76.8647 226.27 77.5762 227.251 78.5216 227.969C79.467 228.686 80.6038 229.107 81.7883 229.178C82.9728 229.249 84.1518 228.968 85.1764 228.369C85.8606 227.974 86.4596 227.447 86.9388 226.819C87.4179 226.191 87.7676 225.474 87.9676 224.71C88.1676 223.946 88.2139 223.15 88.1039 222.367C87.9939 221.585 87.7297 220.833 87.3266 220.153Z",
      fill: "url(#paint36_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M83.7321 222.239C83.6124 222.026 83.4512 221.839 83.2579 221.689C83.0646 221.539 82.8432 221.43 82.6068 221.367C82.3705 221.304 82.1239 221.289 81.8817 221.323C81.6395 221.357 81.4066 221.44 81.1968 221.565C80.986 221.69 80.8019 221.854 80.6548 222.05C80.5077 222.245 80.4005 222.468 80.3394 222.705C80.2783 222.942 80.2645 223.188 80.2987 223.431C80.3329 223.673 80.4145 223.906 80.5389 224.117C80.6632 224.328 80.8278 224.512 81.0233 224.659C81.2188 224.806 81.4414 224.913 81.6783 224.974C81.9152 225.035 82.1619 225.049 82.4041 225.015C82.6464 224.981 82.8795 224.899 83.0903 224.775C83.3009 224.652 83.485 224.489 83.6316 224.295C83.7783 224.1 83.8847 223.878 83.9445 223.642C84.0043 223.406 84.0163 223.16 83.9798 222.919C83.9433 222.678 83.8591 222.447 83.7321 222.239Z",
      fill: "url(#paint37_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M82.545 232.894C82.2802 232.411 81.877 232.019 81.3873 231.767C80.8976 231.515 80.3437 231.416 79.7969 231.481C79.2501 231.546 78.7354 231.774 78.319 232.134C77.9026 232.495 77.6034 232.971 77.4601 233.503C77.3168 234.035 77.3358 234.597 77.5147 235.118C77.6936 235.639 78.0242 236.094 78.464 236.426C78.9038 236.757 79.4327 236.949 79.9827 236.978C80.5326 237.006 81.0785 236.869 81.5501 236.585C82.1602 236.217 82.6044 235.628 82.7899 234.94C82.9753 234.252 82.8875 233.519 82.545 232.894Z",
      fill: "url(#paint38_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M80.908 233.857C80.852 233.757 80.776 233.67 80.6846 233.6C80.5933 233.531 80.4886 233.481 80.3772 233.454C80.2658 233.427 80.15 233.423 80.037 233.443C79.924 233.462 79.8163 233.505 79.7206 233.568C79.6215 233.621 79.5347 233.694 79.4656 233.782C79.3965 233.871 79.3467 233.973 79.3195 234.082C79.2923 234.191 79.2882 234.304 79.3075 234.415C79.3269 234.525 79.3692 234.63 79.4318 234.724C79.4852 234.822 79.5579 234.908 79.6454 234.978C79.733 235.048 79.8336 235.099 79.9414 235.129C80.0492 235.159 80.1619 235.167 80.2728 235.152C80.3838 235.138 80.4906 235.101 80.5871 235.044C80.7815 234.924 80.923 234.735 80.9826 234.514C81.0422 234.294 81.0155 234.059 80.908 233.857Z",
      fill: "url(#paint39_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M112.744 222.175C112.561 221.861 112.317 221.587 112.028 221.367C111.738 221.147 111.408 220.986 111.057 220.894C110.705 220.801 110.339 220.779 109.978 220.828C109.618 220.877 109.271 220.997 108.957 221.18C108.643 221.364 108.368 221.607 108.148 221.897C107.928 222.186 107.768 222.516 107.675 222.868C107.583 223.22 107.561 223.586 107.61 223.946C107.659 224.306 107.779 224.653 107.962 224.967C108.142 225.286 108.383 225.564 108.672 225.787C108.961 226.01 109.292 226.173 109.645 226.266C109.998 226.359 110.367 226.38 110.728 226.327C111.089 226.275 111.437 226.151 111.749 225.962C112.064 225.78 112.34 225.537 112.56 225.247C112.781 224.958 112.942 224.628 113.034 224.276C113.127 223.924 113.149 223.557 113.099 223.197C113.049 222.836 112.929 222.489 112.744 222.175Z",
      fill: "url(#paint40_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M111.108 223.138C110.988 222.943 110.796 222.803 110.573 222.748C110.351 222.694 110.116 222.73 109.92 222.849C109.821 222.902 109.734 222.975 109.665 223.063C109.596 223.152 109.546 223.254 109.519 223.362C109.492 223.471 109.488 223.585 109.507 223.695C109.526 223.806 109.569 223.911 109.631 224.004C109.685 224.103 109.757 224.189 109.845 224.259C109.933 224.328 110.033 224.38 110.141 224.41C110.249 224.44 110.361 224.448 110.472 224.433C110.583 224.419 110.69 224.382 110.787 224.325C110.981 224.205 111.123 224.016 111.182 223.795C111.242 223.574 111.215 223.339 111.108 223.138Z",
      fill: "url(#paint41_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M272.918 181.36C274.55 174.807 270.562 168.171 264.009 166.539C257.456 164.906 250.821 168.895 249.188 175.448C247.556 182 251.544 188.636 258.097 190.268C264.65 191.901 271.285 187.912 272.918 181.36Z",
      fill: "url(#paint42_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M261.495 178.4H260.212V318.39H261.495V178.4Z",
      fill: "url(#paint43_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M264.32 176.475C263.945 175.825 263.387 175.302 262.715 174.97C262.043 174.639 261.287 174.514 260.544 174.612C259.801 174.71 259.104 175.026 258.541 175.52C257.977 176.015 257.574 176.665 257.38 177.389C257.187 178.113 257.213 178.878 257.454 179.588C257.696 180.297 258.143 180.919 258.738 181.374C259.333 181.829 260.05 182.098 260.798 182.146C261.546 182.193 262.291 182.018 262.94 181.642C263.8 181.133 264.427 180.306 264.685 179.34C264.943 178.374 264.812 177.345 264.32 176.475Z",
      fill: "#A7F9EF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M263.627 165.576C265.26 159.024 261.271 152.388 254.719 150.755C248.166 149.123 241.53 153.111 239.898 159.664C238.265 166.217 242.254 172.852 248.807 174.485C255.359 176.118 261.995 172.129 263.627 165.576Z",
      fill: "url(#paint44_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M252.22 162.578H250.937V302.568H252.22V162.578Z",
      fill: "url(#paint45_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M255.013 160.685C254.62 160.054 254.052 159.553 253.377 159.244C252.702 158.934 251.951 158.83 251.218 158.943C250.484 159.057 249.8 159.384 249.251 159.883C248.701 160.382 248.311 161.032 248.127 161.751C247.944 162.471 247.977 163.228 248.22 163.929C248.464 164.631 248.909 165.245 249.499 165.695C250.089 166.146 250.798 166.413 251.539 166.464C252.28 166.514 253.019 166.346 253.665 165.98C254.109 165.728 254.497 165.39 254.807 164.984C255.117 164.578 255.341 164.114 255.467 163.62C255.593 163.125 255.618 162.61 255.54 162.106C255.462 161.601 255.282 161.118 255.013 160.685Z",
      fill: "#A7F9EF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M40.5198 267.499C42.1524 260.946 38.1638 254.31 31.6111 252.678C25.0584 251.045 18.4229 255.034 16.7904 261.587C15.1578 268.139 19.1464 274.775 25.6991 276.407C32.2518 278.04 38.8873 274.051 40.5198 267.499Z",
      fill: "url(#paint46_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M28.1792 264.538H29.4629L29.4629 124.548H28.1792L28.1792 264.538Z",
      fill: "url(#paint47_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M25.3871 266.431C25.7645 267.079 26.3258 267.601 26.9998 267.929C27.6739 268.258 28.4304 268.379 29.1734 268.278C29.9164 268.176 30.6125 267.856 31.1734 267.358C31.7343 266.86 32.1348 266.207 32.3241 265.482C32.5134 264.756 32.483 263.99 32.2367 263.282C31.9904 262.574 31.5394 261.954 30.9408 261.503C30.3421 261.051 29.6229 260.787 28.8741 260.745C28.1254 260.702 27.3809 260.883 26.735 261.264C25.8798 261.779 25.2599 262.607 25.008 263.573C24.756 264.539 24.8921 265.565 25.3871 266.431Z",
      fill: "#A7F9EF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M47.8235 281.33C49.456 274.778 45.4674 268.142 38.9147 266.51C32.362 264.877 25.7265 268.866 24.094 275.418C22.4614 281.971 26.45 288.607 33.0027 290.239C39.5554 291.872 46.1909 287.883 47.8235 281.33Z",
      fill: "url(#paint48_radial_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M35.4964 278.37H36.7802L36.7802 138.38H35.4964L35.4964 278.37Z",
      fill: "url(#paint49_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M32.7043 280.296C33.0824 280.94 33.643 281.459 34.3153 281.786C34.9877 282.113 35.7417 282.233 36.4824 282.132C37.2232 282.031 37.9174 281.713 38.4778 281.219C39.0381 280.724 39.4395 280.074 39.6313 279.352C39.8231 278.629 39.7967 277.866 39.5555 277.158C39.3143 276.451 38.8691 275.83 38.276 275.375C37.6828 274.92 36.9683 274.651 36.2223 274.601C35.4764 274.552 34.7325 274.724 34.0843 275.097C33.6507 275.346 33.2707 275.678 32.9663 276.075C32.6619 276.472 32.4391 276.925 32.3108 277.408C32.1825 277.892 32.1512 278.396 32.2188 278.891C32.2863 279.387 32.4513 279.864 32.7043 280.296Z",
      fill: "#A7F9EF"
    }), /* @__PURE__ */ jsx("path", {
      d: "M217.015 80.2278L186.526 62.673C170.865 53.2376 149.17 54.3288 125.1 68.225C78.0199 95.3757 39.8292 161.263 39.8292 215.307C39.8292 243.228 50.0669 262.516 66.4343 270.892L97.1152 288.544L106.486 272.24C112.978 270.121 119.219 267.302 125.1 263.832C172.085 236.585 210.371 170.891 210.371 116.846C210.427 109.688 209.651 102.548 208.061 95.5683L217.015 80.2278Z",
      fill: "url(#paint50_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M215.771 218.822C249.28 161.501 249.625 99.3567 216.543 80.0172C183.461 60.6778 129.478 91.4672 95.9696 148.787C62.4611 206.107 62.1154 268.252 95.1977 287.592C128.28 306.931 182.262 276.142 215.771 218.822Z",
      fill: "url(#paint51_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M194.132 74.2583V75.6062C222.278 75.6062 239.768 98.0713 239.768 134.561C239.768 188.092 201.834 253.53 155.203 280.456C143.872 287.533 130.878 291.507 117.526 291.977C89.3804 291.977 71.9218 269.512 71.9218 233.022C71.9218 179.523 109.856 114.054 156.487 87.1276C167.809 80.0554 180.791 76.0823 194.132 75.6062V74.2583ZM194.132 74.2583C180.636 74.7835 167.508 78.8092 156.038 85.9402C108.957 113.155 70.7665 179.01 70.7665 233.022C70.7665 271.277 90.0223 293.357 117.751 293.357C131.327 292.814 144.525 288.732 156.038 281.515C203.118 254.332 241.309 188.445 241.309 134.433C241.148 96.3383 222.021 74.2583 194.132 74.2583Z",
      fill: "#DEFCF2"
    }), /* @__PURE__ */ jsx("path", {
      d: "M201.53 210.497C227.068 166.81 227.329 119.445 202.112 104.703C176.895 89.9618 135.749 113.426 110.211 157.112C84.6721 200.799 84.4117 248.164 109.629 262.905C134.846 277.647 175.992 254.183 201.53 210.497Z",
      fill: "url(#paint52_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M200.583 103.88C207.772 111.743 211.976 123.81 211.976 139.471C211.976 180.679 182.868 230.872 146.988 251.572C129.657 261.585 113.932 262.869 102.282 256.932C113.996 269.769 133.637 271.213 155.877 258.376C191.757 237.644 220.866 187.45 220.866 146.275C220.866 124.965 213.067 110.267 200.583 103.88Z",
      fill: "url(#paint53_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      opacity: "0.2",
      d: "M171.025 210.365L191.18 190.628L146.442 128.72L145.576 146.821L102.699 231.963L102.057 248.588L171.025 210.365Z",
      fill: "url(#paint54_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M183.06 185.557L154.562 133.759L146.442 128.72L102.699 231.963L110.819 237.002L183.06 185.557Z",
      fill: "url(#paint55_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M191.18 190.628L154.562 133.759L110.819 237.002L191.18 190.628Z",
      fill: "url(#paint56_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M191.18 190.628L154.562 133.759V186.038L191.18 190.628Z",
      fill: "url(#paint57_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M191.18 190.628L154.562 133.759V186.038L191.18 190.628Z",
      fill: "url(#paint58_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M154.562 186.038V133.759L110.819 237.002L154.562 186.038Z",
      fill: "url(#paint59_linear_9599_45580)"
    }), /* @__PURE__ */ jsx("path", {
      d: "M191.18 190.628L153.952 135.909L154.626 136.583L110.819 237.002L154.562 133.759L191.18 190.628Z",
      fill: "#DEFCF2"
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsx("pattern", {
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1",
        children: /* @__PURE__ */ jsx("use", {
          transform: "scale(0.5 0.333333)"
        })
      }), /* @__PURE__ */ jsx("pattern", {
        id: "pattern1",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1",
        children: /* @__PURE__ */ jsx("use", {
          transform: "scale(0.5 0.333333)"
        })
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint0_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(238.973 226.869) rotate(-30.2031) scale(12.2787)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint1_linear_9599_45580",
        x1: "239.801",
        y1: "191.269",
        x2: "239.801",
        y2: "326.702",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint2_linear_9599_45580",
        x1: "20.1881",
        y1: "208.985",
        x2: "20.1881",
        y2: "196.95",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint3_linear_9599_45580",
        x1: "82.4387",
        y1: "853.247",
        x2: "82.4387",
        y2: "808.116",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_9599_45580",
        x1: "105.528",
        y1: "911.603",
        x2: "105.528",
        y2: "847.908",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_9599_45580",
        x1: "142.362",
        y1: "432.93",
        x2: "142.362",
        y2: "387.799",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint6_linear_9599_45580",
        x1: "142.44",
        y1: "493.949",
        x2: "142.44",
        y2: "448.818",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint7_linear_9599_45580",
        x1: "165.296",
        y1: "498.65",
        x2: "165.296",
        y2: "435.098",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint8_linear_9599_45580",
        x1: "83.2802",
        y1: "911.75",
        x2: "83.2802",
        y2: "866.619",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint9_linear_9599_45580",
        x1: "372.889",
        y1: "474.713",
        x2: "372.889",
        y2: "472.284",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint10_linear_9599_45580",
        x1: "79.6243",
        y1: "332.126",
        x2: "187.746",
        y2: "332.126",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5761D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.07",
          stopColor: "#5472D8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.28",
          stopColor: "#4E9CDB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#49BDDD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.67",
          stopColor: "#45D5DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#43E3E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint11_linear_9599_45580",
        x1: "3343.01",
        y1: "5518.04",
        x2: "6984.71",
        y2: "5518.04",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5761D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.07",
          stopColor: "#5472D8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.28",
          stopColor: "#4E9CDB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#49BDDD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.67",
          stopColor: "#45D5DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#43E3E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint12_linear_9599_45580",
        x1: "3343.01",
        y1: "5356.09",
        x2: "6984.71",
        y2: "5356.09",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5761D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.07",
          stopColor: "#5472D8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.28",
          stopColor: "#4E9CDB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#49BDDD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.67",
          stopColor: "#45D5DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#43E3E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint13_linear_9599_45580",
        x1: "3343.01",
        y1: "5188.72",
        x2: "6984.71",
        y2: "5188.72",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5761D7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.07",
          stopColor: "#5472D8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.28",
          stopColor: "#4E9CDB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#49BDDD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.67",
          stopColor: "#45D5DF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#43E3E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint14_linear_9599_45580",
        x1: "79.6246",
        y1: "319.641",
        x2: "187.746",
        y2: "319.641",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2D5382"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3C88C4"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint15_linear_9599_45580",
        x1: "79.6246",
        y1: "306.804",
        x2: "187.746",
        y2: "306.804",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#1D9DD7"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint16_linear_9599_45580",
        x1: "4282.12",
        y1: "4696.02",
        x2: "4282.12",
        y2: "4166.28",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint17_linear_9599_45580",
        x1: "4276.77",
        y1: "4591.6",
        x2: "4279.35",
        y2: "3947.6",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint18_linear_9599_45580",
        x1: "4288.16",
        y1: "4389.94",
        x2: "4288.16",
        y2: "3969.31",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.71",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#A7F9EF"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint19_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(234.936 245.714) rotate(-30.4853) scale(14.2747)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#53A5F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#446AB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.79",
          stopColor: "#312061"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2A023F"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint20_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(163.956 190.531) rotate(-30.1735) scale(4.37382)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint21_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(11008.1 26409) rotate(-30.1735) scale(31.0704 31.0446)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#53A5F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#446AB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.79",
          stopColor: "#312061"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2A023F"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint22_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-1404.05 -11139.1) scale(2.9729)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint23_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(6260.43 14734.3) rotate(-30.1735) scale(13.4248)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#53A5F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#446AB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.79",
          stopColor: "#312061"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2A023F"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint24_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-866.756 -7274.13) scale(1.30298 1.30039)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint25_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(182.387 216.006) rotate(-30.1736) scale(2.84138)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#41E5DE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#39B8C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.13",
          stopColor: "#3190AA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2",
          stopColor: "#2A6C95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.27",
          stopColor: "#254E83"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#203674"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.45",
          stopColor: "#1C2469"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#1A1761"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7",
          stopColor: "#180F5C"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#180D5B"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint26_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-447.724 -4344.75) scale(0.494255)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint27_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(12030.2 28922.1) rotate(-30.1735) scale(35.7134)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#53A5F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#446AB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.79",
          stopColor: "#312061"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2A023F"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint28_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-1535.05 -12019.5) scale(3.44359)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint29_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(11875.2 28754.5) rotate(-30.1735) scale(35.5627)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#53A5F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#446AB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.79",
          stopColor: "#312061"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2A023F"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint30_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(1787.85 3536.98) rotate(-30.4516) scale(3.42201)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint31_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(29388.7 76754.8) rotate(-30.1735) scale(188.959)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#53A5F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#446AB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.79",
          stopColor: "#312061"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2A023F"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint32_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-4444.45 -27504.6) scale(18.1159)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint33_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(16784.6 43301.1) rotate(-30.3948) scale(68.187)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#53A5F8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#446AB6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.79",
          stopColor: "#312061"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2A023F"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint34_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-3540.24 -23129.6) scale(11.7623 12.0519)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#41E5DE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#39B8C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.13",
          stopColor: "#3190AA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2",
          stopColor: "#2A6C95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.27",
          stopColor: "#254E83"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#203674"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.45",
          stopColor: "#1C2469"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#1A1761"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7",
          stopColor: "#180F5C"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#180D5B"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint35_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-998.719 -6570.55) scale(1.0847 1.08214)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint36_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-4835.24 -30679.9) scale(22.4676 22.4452)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#41E5DE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#39B8C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.13",
          stopColor: "#3190AA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2",
          stopColor: "#2A6C95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.27",
          stopColor: "#254E83"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#203674"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.45",
          stopColor: "#1C2469"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#1A1761"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7",
          stopColor: "#180F5C"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#180D5B"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint37_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-1440.39 -9374.73) scale(2.15761 2.16214)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint38_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-2191.69 -13992.7) scale(4.7472)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#41E5DE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#39B8C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.13",
          stopColor: "#3190AA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2",
          stopColor: "#2A6C95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.27",
          stopColor: "#254E83"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#203674"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.45",
          stopColor: "#1C2469"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#1A1761"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7",
          stopColor: "#180F5C"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#180D5B"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint39_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-626.977 -4221.71) scale(0.463907 0.466808)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint40_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-2115.61 -14098.1) scale(4.76485 4.77535)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#41E5DE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#39B8C3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.13",
          stopColor: "#3190AA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2",
          stopColor: "#2A6C95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.27",
          stopColor: "#254E83"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#203674"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.45",
          stopColor: "#1C2469"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#1A1761"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7",
          stopColor: "#180F5C"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#180D5B"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint41_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-579.939 -4202.79) scale(0.463907 0.463367)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint42_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(2369.54 1141.2) scale(93.173)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint43_linear_9599_45580",
        x1: "371.459",
        y1: "5881.58",
        x2: "371.459",
        y2: "11789.1",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint44_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(21642.1 51434.7) rotate(-30.203) scale(93.5636)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint45_linear_9599_45580",
        x1: "358.474",
        y1: "5175.61",
        x2: "358.474",
        y2: "11083.2",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint46_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(72336.3 28533.7) rotate(180) scale(93.173)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint47_linear_9599_45580",
        x1: "28.821",
        y1: "261.746",
        x2: "28.821",
        y2: "126.313",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint48_radial_9599_45580",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(53355.6 -21393.8) rotate(149.797) scale(93.5636)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "#CFF9FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.41",
          stopColor: "#96F2F1",
          stopOpacity: "0.3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint49_linear_9599_45580",
        x1: "36.1383",
        y1: "275.578",
        x2: "36.1383",
        y2: "140.145",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#A7F9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.82",
          stopColor: "#42E8E0",
          stopOpacity: "0.25"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint50_linear_9599_45580",
        x1: "187.746",
        y1: "64.1171",
        x2: "58.5394",
        y2: "274.391",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#43E8E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.45",
          stopColor: "#3A8FA2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.84",
          stopColor: "#387E97"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#385397"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint51_linear_9599_45580",
        x1: "235.181",
        y1: "63.7286",
        x2: "87.5848",
        y2: "287.256",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.17",
          stopColor: "#AAF4F1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#BDF7F4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.38",
          stopColor: "#E6FCFB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.63",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.84",
          stopColor: "#42E8E0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#DAFAF9"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint52_linear_9599_45580",
        x1: "198.177",
        y1: "106.669",
        x2: "80.6527",
        y2: "320.954",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.01",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#42E8E0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint53_linear_9599_45580",
        x1: "135.755",
        y1: "262.709",
        x2: "253.761",
        y2: "51.2156",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#43E8E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#3A8FA2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#387E97"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint54_linear_9599_45580",
        x1: "152.764",
        y1: "232.862",
        x2: "142.43",
        y2: "210.525",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#180D5B"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint55_linear_9599_45580",
        x1: "4820.69",
        y1: "3325.2",
        x2: "1190.27",
        y2: "8367.27",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.06",
          stopColor: "#43E8E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#3A8FA2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#387E97"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint56_linear_9599_45580",
        x1: "165.923",
        y1: "146.917",
        x2: "128.855",
        y2: "313.223",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#43E8E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2A54D3"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint57_linear_9599_45580",
        x1: "180.332",
        y1: "128.624",
        x2: "163.195",
        y2: "205.551",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2A54D3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#43E8E1"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint58_linear_9599_45580",
        x1: "139.189",
        y1: "137.642",
        x2: "201.321",
        y2: "227.695",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#43E8E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#2A54D3",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint59_linear_9599_45580",
        x1: "133.284",
        y1: "185.685",
        x2: "151.609",
        y2: "194.222",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#2E6DD5"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#43E8E1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsx("image", {
        id: "image0_9599_45580",
        width: "2",
        height: "3"
      })]
    })]
  });
};
const wizard = (width = "241", height = "210") => {
  return /* @__PURE__ */ jsxs("svg", {
    width,
    height,
    viewBox: "0 0 241 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip0_906_20424)",
      children: [/* @__PURE__ */ jsx("path", {
        d: "M186.771 140.439C186.771 140.439 209.827 106.943 222.227 104.425C222.227 104.425 181.347 80.3101 154.417 79.2017C127.485 78.0911 121.875 78.1995 121.875 78.1995L114.438 77.8112C114.438 77.8112 108.825 77.7028 81.8954 78.8134C54.9633 79.924 14.0856 104.036 14.0856 104.036C26.4859 106.553 49.5413 140.051 49.5413 140.051C49.5413 140.051 14.0856 174.674 14.0856 238.531C49.8626 284.62 101.382 258.379 121.616 257.776C134.598 257.387 190.471 292.58 229 246.603C229 187.493 186.776 140.439 186.776 140.439H186.771Z",
        fill: "url(#paint0_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M186.771 140.439C186.771 140.439 209.827 106.943 222.227 104.425C222.227 104.425 181.347 80.3101 154.417 79.2017C127.485 78.0911 121.875 78.1995 121.875 78.1995L114.438 77.8112C114.438 77.8112 108.825 77.7028 81.8954 78.8134C54.9633 79.924 14.0856 104.036 14.0856 104.036C26.4859 106.553 49.5413 140.051 49.5413 140.051C49.5413 140.051 14.0856 174.674 14.0856 238.531C49.8626 284.62 101.382 258.379 121.616 257.776C134.598 257.387 190.471 292.58 229 246.603C229 187.493 186.776 140.439 186.776 140.439H186.771Z",
        fill: "url(#paint1_radial_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M166.162 119.653C164.926 116.963 165.391 112.937 164.156 106.376C162.921 99.8138 160.193 100.443 160.193 100.443C160.193 100.443 153.835 91.5059 154.729 100.098C155.624 108.692 155.196 112.683 154.341 118.104C155.706 120.041 156.396 124.449 156.978 128.902C139.154 126.579 133.61 127.399 129.034 127.267C129.338 129.672 128.027 131.165 125.46 132.145C124.852 132.377 124.353 132.887 124.075 133.542C122.714 136.763 119.879 137.865 118.11 137.854C116.341 137.844 113.506 136.703 112.145 133.481C111.868 132.824 111.371 132.317 110.761 132.084C108.193 131.102 106.882 129.612 107.186 127.206C101.447 126.818 85.7539 127.399 79.5527 128.562C79.1642 127.206 80.9006 119.655 82.2659 117.718C81.4128 112.297 80.4035 108.885 81.2978 100.291C82.1921 91.6968 76.0299 100.382 76.0299 100.382C76.0299 100.382 73.3015 99.7531 72.0665 106.315C70.8315 112.876 70.5211 117.933 69.286 120.623C68.051 123.312 48.0061 166.403 48.1754 181.314C48.3469 196.222 54.3896 217.25 58.9999 223.059C63.6079 228.868 103.982 246.787 119.395 246.59C134.808 246.393 172.235 228.868 176.843 223.059C181.451 217.25 189.145 196.222 189.317 181.314C189.488 166.405 167.397 122.345 166.162 119.655V119.653Z",
        fill: "url(#paint2_radial_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M166.162 119.653C164.926 116.963 165.391 112.937 164.156 106.376C162.921 99.8138 160.193 100.443 160.193 100.443C160.193 100.443 153.835 91.5059 154.729 100.098C155.624 108.692 155.196 112.683 154.341 118.104C155.706 120.041 156.396 124.449 156.978 128.902C139.154 126.579 133.61 127.399 129.034 127.267C129.338 129.672 128.027 131.165 125.46 132.145C124.852 132.377 124.353 132.887 124.075 133.542C122.714 136.763 119.879 137.865 118.11 137.854C116.341 137.844 113.506 136.703 112.145 133.481C111.868 132.824 111.371 132.317 110.761 132.084C108.193 131.102 106.882 129.612 107.186 127.206C101.447 126.818 85.7539 127.399 79.5527 128.562C79.1642 127.206 80.9006 119.655 82.2659 117.718C81.4128 112.297 80.4035 108.885 81.2978 100.291C82.1921 91.6968 76.0299 100.382 76.0299 100.382C76.0299 100.382 73.3015 99.7531 72.0665 106.315C70.8315 112.876 70.5211 117.933 69.286 120.623C68.051 123.312 48.0061 166.403 48.1754 181.314C48.3469 196.222 54.3896 217.25 58.9999 223.059C63.6079 228.868 103.982 246.787 119.395 246.59C134.808 246.393 172.235 228.868 176.843 223.059C181.451 217.25 189.145 196.222 189.317 181.314C189.488 166.405 167.397 122.345 166.162 119.655V119.653Z",
        fill: "url(#paint3_radial_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M114.553 138.027C114.553 138.027 118.282 153.647 94.2805 150.098C70.2787 146.55 78.6114 184.015 78.6114 184.015L81.737 207.778L67.2747 218.275L51.5057 204.759C51.5057 204.759 44.1237 180.781 53.5938 159.473C63.0639 138.166 72.0976 131.37 79.5035 128.899C86.9094 126.428 107.189 127.203 107.189 127.203C107.189 127.203 107.306 129.357 107.642 129.975C108.241 131.075 110.488 131.528 111.361 132.426C112.348 133.444 114.553 138.027 114.553 138.027V138.027Z",
        fill: "url(#paint4_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M121.931 138.027C121.931 138.027 118.202 153.647 142.204 150.098C166.206 146.55 157.873 184.015 157.873 184.015L154.747 207.778L169.21 218.275L184.979 204.759C184.979 204.759 192.361 180.781 182.89 159.473C173.42 138.166 164.387 131.37 156.981 128.899C149.575 126.428 129.296 127.203 129.296 127.203C129.296 127.203 129.178 129.357 128.842 129.975C128.243 131.075 125.996 131.528 125.124 132.426C124.136 133.444 121.931 138.027 121.931 138.027V138.027Z",
        fill: "url(#paint5_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M78.6005 109.183C77.9147 109.057 77.1552 109.356 76.5259 109.599C75.8966 109.842 75.2434 110.172 74.6444 110.536C74.0433 110.9 73.4726 111.312 72.9365 111.766C72.6588 112.002 72.3918 112.249 72.1358 112.51C72.0077 112.64 71.8775 112.77 71.7603 112.909C71.6952 112.985 71.6388 113.052 71.6019 113.147C71.5694 113.238 71.5498 113.334 71.5433 113.431C71.539 113.635 71.5368 113.659 71.5368 113.501C71.5086 113.622 71.4847 114.058 71.654 114.125C71.9274 114.234 71.9253 114.171 72.062 114.023C72.1249 113.956 72.1879 113.891 72.2508 113.826C72.3593 113.715 72.4721 113.605 72.585 113.499C72.8302 113.264 73.0841 113.039 73.3467 112.822C73.861 112.399 74.4057 112.013 74.9764 111.67C75.5472 111.328 76.1461 111.026 76.7559 110.759C77.3831 110.484 78.0905 110.284 78.6569 109.894C78.8023 109.794 78.8067 109.22 78.6027 109.183H78.6005Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M79.2249 114.732C78.5477 114.719 77.8336 115.119 77.2454 115.42C76.6094 115.746 75.9994 116.123 75.4112 116.526C74.2065 117.353 73.1017 118.314 72.114 119.392C71.8362 119.694 71.567 120.004 71.3087 120.32C71.02 120.674 70.6771 121.028 70.5816 121.485C70.5403 121.687 70.5034 122.316 70.8095 122.362C70.9745 122.388 71.0743 122.192 71.159 122.08C71.2675 121.934 71.3804 121.789 71.4932 121.646C71.7212 121.359 71.9556 121.08 72.1987 120.806C72.6632 120.284 73.1624 119.791 73.6834 119.325C74.7513 118.366 75.9083 117.542 77.1368 116.804C77.8466 116.379 78.6606 116.043 79.2857 115.496C79.4073 115.388 79.468 114.737 79.2271 114.732H79.2249Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M78.6269 123.067C78.1558 123.082 77.7261 123.227 77.2941 123.405C76.834 123.594 76.3825 123.8 75.9462 124.043C75.091 124.518 74.2597 125.041 73.4696 125.62C71.8677 126.793 70.4091 128.151 69.1154 129.657C68.397 130.492 67.6763 131.379 67.1185 132.333C66.9622 132.6 66.9579 132.969 67.0404 133.262C67.0881 133.433 67.2531 133.741 67.4311 133.496C68.0019 132.709 68.5337 131.906 69.1523 131.153C69.7709 130.401 70.459 129.657 71.1753 128.971C72.5818 127.626 74.1425 126.435 75.8051 125.425C76.7623 124.843 77.8129 124.342 78.6681 123.613C78.7528 123.54 78.794 123.067 78.6269 123.071V123.067Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M113.904 139.958C113.837 140.552 113.735 141.094 113.546 141.663C113.357 142.231 113.069 142.812 112.728 143.335C111.996 144.461 110.994 145.389 109.878 146.129C108.706 146.908 107.412 147.478 106.049 147.825C104.328 148.263 102.548 148.415 100.777 148.465C97.4557 148.558 94.113 148.266 90.8138 148.762C87.9985 149.185 85.1269 150.172 83.0952 152.248C80.8899 154.502 79.9066 157.652 79.288 160.671C79.2099 161.053 79.1361 161.437 79.0645 161.819C79.0102 162.112 78.995 162.526 79.1925 162.773C79.3901 163.02 79.5442 162.684 79.5876 162.513C80.3342 159.628 80.9529 156.615 82.9563 154.261C84.8469 152.042 87.712 150.968 90.5164 150.502C93.8026 149.955 97.1366 150.224 100.449 150.159C103.677 150.096 107.015 149.676 109.782 147.886C112.114 146.381 114.071 143.951 114.262 141.094C114.288 140.71 114.275 140.329 114.228 139.947C114.217 139.869 114.18 139.617 114.056 139.621C113.932 139.626 113.911 139.875 113.902 139.955L113.904 139.958Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M109.765 136.432C109.511 137.182 109.281 137.918 108.871 138.601C108.46 139.284 107.9 139.957 107.29 140.521C105.99 141.725 104.395 142.575 102.708 143.104C98.6277 144.382 94.2822 143.991 90.1017 144.677C88.9817 144.861 87.8704 145.135 86.8068 145.536C85.7432 145.937 84.6514 146.458 83.8071 147.254C83.6855 147.369 83.6508 148.039 83.9026 147.944C84.8316 147.597 85.7215 147.174 86.6744 146.889C87.6273 146.605 88.6409 146.401 89.6415 146.241C91.7296 145.903 93.8525 145.837 95.9601 145.696C99.9496 145.432 104.171 144.896 107.264 142.113C108.732 140.794 109.986 138.898 110.073 136.874C110.08 136.725 110.088 136.48 109.978 136.356C109.889 136.254 109.802 136.317 109.763 136.434L109.765 136.432Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M67.3788 143.986C66.7037 144.789 66.1763 145.68 65.6618 146.591C65.1409 147.513 64.659 148.459 64.2097 149.418C63.2742 151.411 62.4428 153.455 61.7395 155.541C60.3265 159.728 59.3692 164.069 58.9416 168.468C58.5249 172.752 58.6182 177.084 59.2607 181.34C59.9032 185.596 61.0211 189.544 62.6577 193.399C64.2813 197.225 66.4085 200.839 69.0675 204.041C69.3779 204.414 69.7295 204.759 70.0682 205.108C70.2006 205.245 70.3265 205.08 70.3677 204.952C70.4263 204.766 70.3916 204.544 70.2744 204.39C67.7868 201.115 65.5316 197.707 63.7973 193.967C62.0629 190.227 60.8821 186.464 60.1463 182.518C59.4105 178.572 59.1543 174.39 59.4126 170.31C59.6818 166.056 60.4676 161.839 61.7157 157.765C62.3495 155.698 63.0918 153.661 63.9384 151.672C64.7892 149.674 65.7769 147.745 66.7211 145.791C66.975 145.268 67.2181 144.743 67.4526 144.209C67.4721 144.164 67.4526 143.895 67.3766 143.986H67.3788Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M166.162 119.653C164.927 116.963 165.391 112.937 164.156 106.376C162.921 99.8138 160.193 100.443 160.193 100.443C160.193 100.443 153.835 91.5059 154.729 100.098C155.624 108.692 155.196 112.683 154.341 118.104C155.706 120.041 156.396 124.449 156.978 128.902C139.154 126.579 133.61 127.399 129.035 127.267C129.338 129.672 128.027 131.165 125.46 132.145C124.852 132.377 124.353 132.887 124.075 133.542C122.714 136.763 119.879 137.865 118.11 137.854C116.341 137.844 113.506 136.703 112.146 133.481C111.868 132.824 111.371 132.317 110.761 132.084C108.193 131.102 106.882 129.612 107.186 127.206C101.447 126.818 85.754 127.399 79.5528 128.562C79.1642 127.206 80.9007 119.655 82.2659 117.718C81.4129 112.297 80.4036 108.885 81.2979 100.291C82.1921 91.6968 76.03 100.382 76.03 100.382C76.03 100.382 73.3016 99.7531 72.0666 106.315C70.8315 112.877 70.5212 117.933 69.2861 120.623C68.0511 123.312 53.4238 161.283 53.5931 176.192C53.7646 191.101 58.3727 200.977 62.9807 206.784C67.5888 212.593 89.0944 234.085 118.11 234.278V234.339C147.126 234.146 168.632 212.654 173.24 206.845C177.848 201.036 182.456 191.162 182.627 176.253C182.799 161.344 167.394 122.343 166.159 119.653H166.162Z",
        fill: "url(#paint6_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M91.2573 154.322C90.363 156.385 89.7726 158.589 89.1996 160.758C88.6266 162.927 88.1295 165.213 87.7215 167.467C86.8967 172.014 86.4148 176.621 86.2564 181.239C86.0979 185.881 86.2672 190.528 86.7686 195.146C87.2678 199.742 88.1035 204.3 89.2517 208.779C90.3999 213.258 91.8195 217.629 93.7252 221.803C93.9596 222.319 94.2005 222.831 94.4458 223.34C94.5153 223.484 94.6477 223.468 94.7345 223.364C94.8387 223.243 94.8365 222.989 94.7779 222.85C93.035 218.638 91.47 214.347 90.2393 209.959C89.0151 205.597 88.1078 201.15 87.524 196.658C86.9423 192.191 86.6775 187.684 86.7274 183.181C86.7773 178.623 87.168 174.07 87.8734 169.567C88.5832 165.044 89.6511 160.593 90.9382 156.203C91.0988 155.656 91.2378 155.105 91.3788 154.552C91.3984 154.48 91.3376 154.138 91.2573 154.322V154.322Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M101.365 130.912C95.4571 130.429 89.4664 132.42 84.5393 135.595C79.3756 138.923 75.2429 143.645 72.4668 149.107C69.3998 155.14 68.015 161.936 67.8609 168.671C67.7024 175.671 68.9245 182.645 71.0603 189.297C72.1542 192.705 73.4739 196.037 74.9434 199.299C76.3911 202.512 77.9539 205.724 79.7641 208.75C80.2047 209.486 80.6671 210.206 81.1099 210.939C81.2054 211.095 81.3399 211.074 81.4311 210.93C81.5353 210.768 81.5006 210.499 81.4159 210.336C80.5737 208.735 79.7945 207.102 78.961 205.497C78.1275 203.891 77.3657 202.369 76.6168 200.781C75.1062 197.588 73.7062 194.343 72.5254 191.013C70.2659 184.645 68.7356 177.983 68.5555 171.209C68.3862 164.764 69.4085 158.244 71.9719 152.307C74.3877 146.715 78.1883 141.825 83.1111 138.218C87.8103 134.773 93.4125 132.593 99.2577 132.32C99.9697 132.287 100.686 132.279 101.4 132.287C101.736 132.292 101.736 130.943 101.365 130.912V130.912Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M108.337 154.968C107.727 157.263 107.516 159.693 107.319 162.055C107.115 164.48 107.019 166.914 106.989 169.345C106.926 174.176 107.123 179.007 107.31 183.833C107.497 188.644 107.69 193.456 107.981 198.262C108.271 203.076 108.653 207.887 109.22 212.676C109.78 217.429 110.494 222.188 111.601 226.848C111.733 227.405 111.883 227.96 112.033 228.514C112.07 228.652 112.176 228.776 112.315 228.687C112.454 228.598 112.456 228.297 112.43 228.162C111.532 223.498 110.674 218.835 110.069 214.121C109.463 209.408 109.035 204.681 108.719 199.941C108.404 195.206 108.193 190.466 107.998 185.725C107.803 180.983 107.575 176.178 107.553 171.4C107.531 166.608 107.744 161.81 108.417 157.064C108.501 156.463 108.567 155.86 108.63 155.257C108.651 155.042 108.46 154.506 108.339 154.966L108.337 154.968Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M157.206 109.896C157.781 110.282 158.488 110.483 159.12 110.761C159.751 111.038 160.328 111.329 160.901 111.672C161.474 112.014 162.019 112.398 162.533 112.823C162.796 113.04 163.048 113.266 163.295 113.5C163.542 113.734 163.749 114.001 164.002 114.213C164.183 114.363 164.282 113.912 164.293 113.836C164.33 113.587 164.324 113.255 164.17 113.04C164.291 113.65 164.334 113.778 164.295 113.42C164.285 113.322 164.258 113.229 164.224 113.138C164.185 113.049 164.13 112.984 164.068 112.91C163.944 112.769 163.811 112.637 163.679 112.505C163.423 112.244 163.156 111.997 162.878 111.761C162.342 111.307 161.772 110.895 161.173 110.531C160.574 110.167 159.947 109.846 159.291 109.594C158.636 109.342 157.902 109.054 157.227 109.182C157.017 109.221 157.069 109.802 157.208 109.896H157.206Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M156.579 115.498C157.144 115.984 157.86 116.294 158.5 116.668C159.141 117.041 159.716 117.399 160.293 117.806C161.45 118.626 162.531 119.566 163.49 120.611C163.755 120.9 164.011 121.197 164.257 121.501C164.389 121.663 164.517 121.826 164.643 121.993C164.741 122.123 164.871 122.394 165.062 122.362C165.37 122.31 165.29 121.668 165.246 121.475C165.155 121.067 164.86 120.752 164.604 120.433C164.376 120.149 164.139 119.869 163.894 119.598C163.412 119.06 162.9 118.548 162.362 118.062C161.287 117.093 160.087 116.221 158.806 115.54C158.452 115.353 158.097 115.173 157.727 115.021C157.358 114.869 156.981 114.724 156.597 114.73C156.349 114.735 156.458 115.396 156.575 115.496L156.579 115.498Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M157.191 123.609C157.977 124.266 158.921 124.742 159.802 125.262C160.631 125.752 161.43 126.293 162.205 126.865C163.777 128.028 165.211 129.366 166.475 130.856C167.189 131.7 167.799 132.605 168.443 133.499C168.621 133.746 168.786 133.405 168.823 133.247C168.893 132.941 168.858 132.596 168.699 132.323C168.198 131.468 167.562 130.67 166.928 129.911C166.294 129.154 165.615 128.434 164.901 127.752C163.471 126.388 161.888 125.193 160.173 124.208C159.709 123.941 159.231 123.696 158.736 123.488C158.242 123.28 157.749 123.082 157.206 123.065C157.035 123.058 157.111 123.54 157.191 123.607V123.609Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M121.611 139.958C121.423 141.425 121.859 142.952 122.564 144.231C123.231 145.44 124.197 146.481 125.286 147.32C127.819 149.273 130.975 149.952 134.112 150.119C137.5 150.299 140.908 149.956 144.285 150.355C147.146 150.691 150.07 151.55 152.227 153.546C154.489 155.637 155.268 158.602 156.002 161.455C156.093 161.813 156.184 162.173 156.275 162.531C156.317 162.689 156.46 162.991 156.649 162.808C156.838 162.626 156.842 162.208 156.799 161.98C156.223 158.9 155.457 155.628 153.48 153.112C151.641 150.774 148.891 149.531 146.033 148.952C142.829 148.303 139.56 148.503 136.313 148.49C133.066 148.477 129.699 148.262 126.81 146.663C125.629 146.01 124.531 145.173 123.671 144.127C123.272 143.641 122.916 143.112 122.64 142.546C122.495 142.249 122.367 141.941 122.269 141.626C122.219 141.464 122.109 141.08 122.078 140.887C122.048 140.694 122.035 140.631 122.007 140.429C121.985 140.271 121.957 140.112 121.939 139.952C121.931 139.874 121.891 139.622 121.768 139.626C121.644 139.631 121.625 139.88 121.614 139.96L121.611 139.958Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M125.766 136.76C125.846 138.582 126.832 140.317 128.082 141.603C129.332 142.89 130.902 143.859 132.59 144.456C136.727 145.911 141.166 145.562 145.453 146.128C146.586 146.278 147.706 146.486 148.809 146.781C149.911 147.076 150.906 147.551 151.956 147.948C152.208 148.044 152.136 147.365 152.019 147.254C151.257 146.547 150.311 146.059 149.354 145.671C148.396 145.282 147.437 145.018 146.445 144.812C144.435 144.397 142.373 144.291 140.328 144.17C136.402 143.933 132.23 143.545 129.052 140.981C128.321 140.391 127.665 139.699 127.144 138.914C126.649 138.17 126.367 137.363 126.094 136.519C126.066 136.434 126.011 136.243 125.885 136.313C125.759 136.382 125.759 136.651 125.764 136.762L125.766 136.76Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M168.395 144.214C169.301 146.251 170.364 148.216 171.291 150.244C172.194 152.223 172.991 154.249 173.677 156.312C175.027 160.368 175.932 164.566 176.323 168.824C176.698 172.922 176.568 177.067 175.93 181.13C175.307 185.095 174.182 188.987 172.602 192.679C171.013 196.395 168.947 199.911 166.487 203.117C166.166 203.536 165.869 203.974 165.55 204.397C165.435 204.551 165.42 204.785 165.485 204.963C165.532 205.098 165.658 205.241 165.791 205.104C168.645 202.182 170.833 198.558 172.55 194.87C174.308 191.098 175.563 187.089 176.309 182.995C177.082 178.757 177.328 174.434 177.032 170.132C176.728 165.728 175.906 161.364 174.606 157.147C173.954 155.032 173.182 152.956 172.298 150.928C171.439 148.954 170.497 146.965 169.316 145.158C169.049 144.75 168.769 144.361 168.458 143.986C168.38 143.893 168.376 144.173 168.393 144.214H168.395Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M144.471 154.557C145.053 156.782 145.735 158.98 146.286 161.214C146.837 163.448 147.306 165.617 147.695 167.843C148.474 172.302 148.943 176.81 149.079 181.335C149.216 185.838 149.032 190.348 148.537 194.825C148.033 199.367 147.206 203.872 146.047 208.293C144.895 212.684 143.39 216.946 141.736 221.172C141.526 221.709 141.309 222.245 141.09 222.781C141.02 222.95 140.996 223.18 141.103 223.343C141.189 223.475 141.337 223.495 141.413 223.334C143.403 219.202 144.938 214.861 146.162 210.445C147.391 206.011 148.291 201.482 148.873 196.918C149.455 192.354 149.715 187.61 149.633 182.942C149.55 178.32 149.151 173.691 148.4 169.127C147.66 164.626 146.616 160.166 145.166 155.839C144.992 155.322 144.793 154.821 144.578 154.32C144.497 154.134 144.452 154.492 144.467 154.557H144.471Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M134.48 132.287C137.391 132.246 140.291 132.582 143.091 133.394C145.9 134.207 148.582 135.463 151.044 137.038C156.077 140.259 160.182 144.823 162.882 150.148C165.819 155.942 167.18 162.398 167.299 168.87C167.423 175.603 166.155 182.267 164.102 188.66C163.032 191.994 161.731 195.252 160.29 198.443C158.829 201.672 157.176 204.796 155.6 207.969C155.205 208.763 154.825 209.562 154.415 210.347C154.287 210.59 154.495 211.356 154.749 210.933C155.671 209.408 156.611 207.904 157.447 206.33C158.282 204.755 159.07 203.204 159.839 201.618C161.393 198.403 162.784 195.102 163.976 191.735C166.329 185.083 167.829 178.146 167.985 171.076C168.135 164.328 167.045 157.489 164.369 151.268C161.92 145.58 158.072 140.558 153.093 136.856C148.363 133.337 142.587 130.995 136.649 130.849C135.913 130.832 135.181 130.854 134.448 130.912C134.092 130.94 134.131 132.294 134.483 132.287H134.48Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        d: "M127.222 155.268C127.469 157.639 127.832 159.992 128.007 162.372C128.183 164.751 128.27 167.163 128.289 169.562C128.331 174.332 128.118 179.1 127.925 183.864C127.734 188.606 127.534 193.345 127.243 198.083C126.952 202.814 126.566 207.54 126.006 212.247C125.444 216.959 124.667 221.629 123.766 226.288C123.651 226.88 123.545 227.477 123.432 228.069C123.399 228.24 123.371 228.544 123.527 228.672C123.684 228.8 123.786 228.661 123.827 228.505C125.073 223.896 125.811 219.145 126.423 214.414C127.035 209.683 127.443 204.898 127.756 200.126C128.07 195.321 128.279 190.51 128.467 185.699C128.658 180.842 128.876 175.981 128.873 171.118C128.873 166.272 128.641 161.409 127.862 156.619C127.771 156.059 127.645 155.511 127.502 154.962C127.473 154.853 127.417 154.736 127.304 154.808C127.191 154.879 127.215 155.164 127.226 155.266L127.222 155.268Z",
        fill: "#FFC683"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.42",
        d: "M118.112 223.056C136.711 223.056 151.788 207.989 151.788 189.402C151.788 170.815 136.711 155.747 118.112 155.747C99.5134 155.747 84.4362 170.815 84.4362 189.402C84.4362 207.989 99.5134 223.056 118.112 223.056Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.33",
        d: "M118.113 234.338C142.947 234.338 163.078 214.22 163.078 189.402C163.078 164.585 142.947 144.466 118.113 144.466C93.2798 144.466 73.1483 164.585 73.1483 189.402C73.1483 214.22 93.2798 234.338 118.113 234.338Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        d: "M156.815 116.799C157.275 114.04 158.165 99.0034 158.165 99.0034H80.7944C80.7944 99.0034 81.6843 114.04 82.1445 116.799C80.3516 121.415 78.9863 130.628 78.9863 130.628C78.9863 130.628 90.2883 125.658 107.24 127.691C108.145 134.918 110.802 133.233 113.09 137.463C115.258 141.476 119.089 141.547 119.48 141.545C119.873 141.547 123.702 141.476 125.87 137.463C128.158 133.231 130.814 134.918 131.72 127.691C148.671 125.658 159.973 130.628 159.973 130.628C159.973 130.628 158.61 121.415 156.815 116.799V116.799Z",
        fill: "url(#paint7_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M121.805 136.934V101.908H158.418L160.549 130.837L121.805 136.934Z",
        fill: "url(#paint8_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M114.638 136.934V101.908H78.0253L75.8938 130.837L95.2661 133.886L114.638 136.934Z",
        fill: "url(#paint9_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M107.179 127.197L114.153 106.203C114.153 106.203 109.215 112.841 99.6302 113.394C91.5882 113.858 81.0523 104.83 81.0523 104.83L77.3319 111.312L77.5924 131.251L97.8243 132.594L107.179 127.197Z",
        fill: "url(#paint10_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M129.158 127.197L122.184 106.203C122.184 106.203 128.24 113.201 136.707 113.394C146.523 113.617 155.285 104.83 155.285 104.83L159.005 111.312L158.745 131.251L138.513 132.594L129.158 127.197V127.197Z",
        fill: "url(#paint11_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M174.88 209.781C174.88 209.781 175.286 220.213 172.961 227.183C170.636 234.153 160.491 249.376 158.164 252.086C153.119 254.216 133.428 258.164 121.415 257.969C118.509 249.07 126.955 238.532 131.261 234.018C135.566 229.504 174.88 209.777 174.88 209.777V209.781Z",
        fill: "#062E6D"
      }), /* @__PURE__ */ jsx("path", {
        d: "M169.475 220.02C169.475 220.02 172.878 217.419 173.501 211.168C174.124 204.916 173.931 191.758 169.475 187.881C165.018 184.005 162.112 188.847 161.919 190.589C161.726 192.33 162.307 199.933 161.919 205.814C161.53 211.695 160.482 216.487 161.878 218.061C163.273 219.636 164.825 222.346 169.475 220.022V220.02Z",
        fill: "url(#paint12_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M161.173 187.224C162.725 186.747 165.017 187.684 166.181 191.363C167.344 195.042 168.497 199.324 168.792 203.669C169.087 208.013 170.878 217.567 169.886 220.922C168.894 224.278 169.15 231.757 161.175 234.02C152.812 233.959 155.525 223.115 155.525 223.115C155.525 223.115 157.639 215.781 157.657 210.53C157.674 205.278 157.464 202.009 157.268 198.33C157.075 194.651 155.912 188.842 161.175 187.222L161.173 187.224Z",
        fill: "url(#paint13_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M160.173 235.896C161.482 231.612 161.643 224.618 161.877 218.059C162.112 211.499 161.725 201.777 160.173 200.345C158.624 198.913 156.119 198.512 153.974 200.655C151.65 202.979 151.261 209.95 151.068 212.467C150.875 214.983 149.904 222.729 148.936 225.245C147.968 227.761 142.737 234.54 144.48 237.25C146.223 239.961 147.193 242.67 150.293 242.477C153.392 242.284 158.148 242.519 160.173 235.894V235.896Z",
        fill: "url(#paint14_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M147.867 243.973C147.867 243.973 150.68 239.38 152.037 234.927C153.393 230.474 154.361 227.376 153.78 223.309C153.198 219.242 153.656 213.018 150.487 210.53C147.774 208.4 143.317 212.467 142.931 223.89C142.855 226.146 137.661 228.582 135.935 230.688C134.212 232.797 131.887 234.539 131.887 237.443C131.887 240.348 132.269 247.207 147.869 243.97L147.867 243.973Z",
        fill: "url(#paint15_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M60.7921 209.781C60.7921 209.781 60.3862 220.213 62.7109 227.182C65.0355 234.152 75.9427 248.718 78.2673 251.429C82.9167 253.124 97.2229 257.176 113.845 257.822C116.752 248.924 108.716 238.534 104.41 234.02C100.105 229.505 60.7921 209.779 60.7921 209.779V209.781Z",
        fill: "#062E6D"
      }), /* @__PURE__ */ jsx("path", {
        d: "M66.1987 220.02C66.1987 220.02 62.7953 217.419 62.1723 211.168C61.5494 204.916 61.7425 191.758 66.1987 187.881C70.6549 184.005 73.5613 188.847 73.7545 190.589C73.9477 192.33 73.3659 199.933 73.7545 205.814C74.143 211.695 75.1914 216.487 73.7957 218.061C72.3979 219.634 70.8481 222.346 66.1987 220.022V220.02Z",
        fill: "url(#paint16_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M74.4995 187.224C72.9475 186.747 70.6554 187.684 69.492 191.363C68.3286 195.042 67.176 199.324 66.8808 203.669C66.5856 208.013 64.7949 217.567 65.7868 220.922C66.7788 224.278 66.5226 231.757 74.4973 234.02C82.8605 233.959 80.1473 223.115 80.1473 223.115C80.1473 223.115 78.0332 215.781 78.0158 210.53C77.9984 205.278 78.209 202.009 78.4043 198.33C78.5997 194.651 79.7609 188.842 74.4973 187.222L74.4995 187.224Z",
        fill: "url(#paint17_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M75.5005 235.896C74.1917 231.612 74.0311 224.618 73.7966 218.059C73.5622 211.499 73.9486 201.777 75.5005 200.345C77.0503 198.913 79.5552 198.512 81.6997 200.655C84.0244 202.979 84.4129 209.95 84.6061 212.467C84.7992 214.983 85.7695 222.729 86.7376 225.245C87.7056 227.761 92.9367 234.54 91.1937 237.25C89.4508 239.961 88.4805 242.67 85.381 242.477C82.2814 242.284 77.5257 242.519 75.5005 235.894V235.896Z",
        fill: "url(#paint18_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M86.7441 243.618C86.7441 243.618 84.2349 238.854 83.1691 234.323C82.1034 229.791 81.3372 226.637 82.1815 222.616C83.0237 218.596 82.9716 212.356 86.2947 210.076C89.1404 208.126 93.3231 212.47 92.9692 223.896C92.8998 226.152 97.9247 228.917 99.5092 231.132C101.094 233.347 103.301 235.236 103.112 238.134C102.923 241.032 102.099 247.852 86.7419 243.616L86.7441 243.618Z",
        fill: "url(#paint19_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.42",
        d: "M118.197 222.737C136.795 222.737 151.873 207.67 151.873 189.083C151.873 170.496 136.795 155.428 118.197 155.428C99.5981 155.428 84.5209 170.496 84.5209 189.083C84.5209 207.67 99.5981 222.737 118.197 222.737Z",
        fill: "white"
      }), /* @__PURE__ */ jsx("path", {
        opacity: "0.33",
        d: "M118.344 234.019C143.178 234.019 163.309 213.901 163.309 189.083C163.309 164.265 143.178 144.147 118.344 144.147C93.511 144.147 73.3795 164.265 73.3795 189.083C73.3795 213.901 93.511 234.019 118.344 234.019Z",
        fill: "#BDFFF1"
      }), /* @__PURE__ */ jsx("path", {
        d: "M85.8154 104.507C85.8154 104.507 95.303 109.179 99.961 108.793C104.619 108.407 111.448 105.027 111.448 105.027C111.448 105.027 108.168 109.715 103.901 110.876C99.6333 112.036 94.0527 112.162 92.9045 110.876C91.7563 109.589 85.8176 104.507 85.8176 104.507H85.8154Z",
        fill: "#062E6D"
      }), /* @__PURE__ */ jsx("path", {
        d: "M150.521 104.507C150.521 104.507 141.033 109.179 136.375 108.793C131.717 108.407 124.889 105.027 124.889 105.027C124.889 105.027 128.169 109.715 132.436 110.876C136.703 112.038 142.284 112.162 143.432 110.876C144.58 109.589 150.519 104.507 150.519 104.507H150.521Z",
        fill: "#062E6D"
      }), /* @__PURE__ */ jsx("path", {
        d: "M202.864 76.5424C194.534 74.8006 170.897 70.3473 165.47 66.4732C164.166 65.5426 161.021 64.868 157.001 64.3821C155.154 59.7271 150.556 51.9572 147.743 45.1742C144.451 37.2351 140.769 35.8793 139.799 31.6213C138.831 27.361 135.925 27.7493 136.7 25.8123C137.475 23.8752 134.761 22.1334 134.761 22.1334C134.761 22.1334 142.317 25.6192 145.612 26.9749C148.905 28.3307 155.299 28.3307 161.887 26.2005C156.074 19.4241 150.65 14.9708 145.612 8.77352C141.293 3.46124 133.018 0.641334 129.53 0.253054C125.827 -0.159086 121.2 -0.135225 112.092 0.834389C102.985 1.804 102.212 5.09462 100.274 10.1292C98.3354 15.1639 96.5925 28.7168 92.7181 32.0096C88.8437 35.3023 86.7122 42.658 84.1922 48.8553C82.2279 53.686 77.4397 61.6902 75.4232 64.9873C73.3395 65.3908 71.7529 65.881 70.9194 66.4753C65.4952 70.3473 41.858 74.8006 33.5253 76.5446C25.1948 78.2864 12.406 85.8394 12.406 85.8394C64.7182 109.073 118.966 107.525 118.966 107.525C118.966 107.525 171.665 109.073 223.977 85.8394C223.977 85.8394 211.19 78.2886 202.858 76.5446L202.864 76.5424Z",
        fill: "url(#paint20_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M202.864 76.5424C194.534 74.8006 170.897 70.3473 165.47 66.4732C164.166 65.5426 161.021 64.868 157.001 64.3821C155.154 59.7271 150.556 51.9572 147.743 45.1742C144.451 37.2351 140.769 35.8793 139.799 31.6213C138.831 27.361 135.925 27.7493 136.7 25.8123C137.475 23.8752 134.761 22.1334 134.761 22.1334C134.761 22.1334 142.317 25.6192 145.612 26.9749C148.905 28.3307 155.299 28.3307 161.887 26.2005C156.074 19.4241 150.65 14.9708 145.612 8.77352C141.293 3.46124 133.018 0.641334 129.53 0.253054C125.827 -0.159086 121.2 -0.135225 112.092 0.834389C102.985 1.804 102.212 5.09462 100.274 10.1292C98.3354 15.1639 96.5925 28.7168 92.7181 32.0096C88.8437 35.3023 86.7122 42.658 84.1922 48.8553C82.2279 53.686 77.4397 61.6902 75.4232 64.9873C73.3395 65.3908 71.7529 65.881 70.9194 66.4753C65.4952 70.3473 41.858 74.8006 33.5253 76.5446C25.1948 78.2864 12.406 85.8394 12.406 85.8394C64.7182 109.073 118.966 107.525 118.966 107.525C118.966 107.525 171.665 109.073 223.977 85.8394C223.977 85.8394 211.19 78.2886 202.858 76.5446L202.864 76.5424Z",
        fill: "url(#paint21_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M202.864 76.5424C194.534 74.8006 170.897 70.3473 165.47 66.4732C164.166 65.5426 161.021 64.868 157.001 64.3821C155.154 59.7271 150.556 51.9572 147.743 45.1742C144.451 37.2351 140.769 35.8793 139.799 31.6213C138.831 27.361 135.925 27.7493 136.7 25.8123C137.475 23.8752 134.761 22.1334 134.761 22.1334C134.761 22.1334 142.317 25.6192 145.612 26.9749C148.905 28.3307 155.299 28.3307 161.887 26.2005C156.074 19.4241 150.65 14.9708 145.612 8.77352C141.293 3.46124 133.018 0.641334 129.53 0.253054C125.827 -0.159086 121.2 -0.135225 112.092 0.834389C102.985 1.804 102.212 5.09462 100.274 10.1292C98.3354 15.1639 96.5925 28.7168 92.7181 32.0096C88.8437 35.3023 86.7122 42.658 84.1922 48.8553C82.2279 53.686 77.4397 61.6902 75.4232 64.9873C73.3395 65.3908 71.7529 65.881 70.9194 66.4753C65.4952 70.3473 41.858 74.8006 33.5253 76.5446C25.1948 78.2864 12.406 85.8394 12.406 85.8394C64.7182 109.073 118.966 107.525 118.966 107.525C118.966 107.525 171.665 109.073 223.977 85.8394C223.977 85.8394 211.19 78.2886 202.858 76.5446L202.864 76.5424Z",
        fill: "url(#paint22_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M12.4094 85.8372C64.7215 109.071 118.97 107.522 118.97 107.522C118.97 107.522 171.668 109.071 223.98 85.8372C155.956 108.828 85.4914 109.383 12.4072 85.8372H12.4094Z",
        fill: "url(#paint23_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M84.1959 48.9503C84.1959 48.9503 91.3652 58.6313 116.359 58.4382C138.101 58.269 149.102 48.5642 149.102 48.5642L156.955 64.3839C156.955 64.3839 145.082 77.132 117.52 77.6093C89.9587 78.0843 75.6614 64.5249 75.6614 64.5249C75.6614 64.5249 82.6939 53.5034 84.1959 48.9525V48.9503Z",
        fill: "url(#paint24_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M116.356 59.213C132.075 59.6837 152.461 55.1372 150.473 51.1069C149.49 49.1134 148.543 47.1047 147.744 45.1742C144.452 37.2351 140.771 35.8793 139.8 31.6213C138.83 27.3632 135.926 27.7493 136.701 25.8123C137.476 23.8752 134.762 22.1334 134.762 22.1334C134.762 22.1334 142.318 25.6192 145.613 26.9749C148.906 28.3307 155.3 28.3307 161.888 26.2006C156.075 19.4241 150.651 14.9708 145.613 8.77352C141.294 3.46124 133.02 0.641334 129.532 0.253054C125.829 -0.159086 121.201 -0.135225 112.093 0.834389C102.988 1.80183 102.213 5.09462 100.275 10.1292C98.3365 15.1639 96.5936 28.7168 92.7192 32.0096C88.8447 35.3023 86.7133 42.658 84.1933 48.8553C82.7216 52.4734 100.637 58.7445 116.356 59.2152V59.213Z",
        fill: "url(#paint25_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M137.68 57.3581C135.418 57.5077 124.021 58.3797 116.357 58.4383C110.457 58.4839 105.552 57.9785 101.499 57.1824C99.5026 58.3494 116.335 59.3776 111.445 69.7527C107.738 77.6202 75.6614 64.525 75.6614 64.525C75.6614 64.525 89.9587 78.0844 117.52 77.6094C145.082 77.1343 156.955 64.384 156.955 64.384C156.955 64.384 134.648 74.7591 129.512 71.1886C125.139 68.1475 126.734 61.7376 137.68 57.3581Z",
        fill: "url(#paint26_linear_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M129.252 50.8508C118.451 51.777 123.589 41.6013 121.054 24.0591L118.039 37.1393C121.165 47.1132 118.705 52.2195 109.079 51.0785C109.079 51.0785 127.199 58.8486 101.352 57.2694C106.112 58.3258 111.345 59.0655 116.357 59.2152C123.333 59.4234 131.229 58.6447 137.68 57.3605C123.361 56.8833 122.321 54.4538 129.252 50.8529V50.8508Z",
        fill: "url(#paint27_linear_906_20424)"
      }), /* @__PURE__ */ jsx("rect", {
        x: "96.1305",
        y: "166.541",
        width: "44.2673",
        height: "44.2673",
        rx: "22.1337",
        fill: "white"
      }), /* @__PURE__ */ jsx("rect", {
        x: "96.1305",
        y: "166.541",
        width: "44.2673",
        height: "44.2673",
        rx: "22.1337",
        fill: "url(#paint28_radial_906_20424)"
      }), /* @__PURE__ */ jsx("path", {
        d: "M132.418 183.207C131.108 180.442 128.435 178.528 125.422 178.302C123.946 178.165 122.423 178.415 121.093 179.085C120.199 179.528 119.404 180.143 118.735 180.876C117.357 179.313 115.409 178.29 113.306 178.184C108.886 177.918 105.076 180.78 104.148 185.222C103.584 187.882 104.199 190.66 105.42 193C106.639 195.308 108.419 197.36 110.733 198.566C112.348 199.352 113.862 197.358 112.681 195.964C112.304 195.542 111.957 195.094 111.641 194.615C111.347 194.171 111.083 193.704 110.843 193.226C110.178 191.863 109.682 190.327 109.583 188.815C109.525 187.854 109.651 187.026 110.05 186.19C110.428 185.41 111.04 184.739 111.843 184.424C113.093 183.95 114.397 184.205 115.347 185.229C115.964 185.864 116.247 186.754 116.562 187.575C116.586 187.634 116.611 187.691 116.638 187.748C117.265 189.683 120.142 189.733 120.679 187.531C120.695 187.456 120.712 187.38 120.729 187.304C120.732 187.291 120.735 187.28 120.738 187.268C120.742 187.255 120.744 187.243 120.747 187.23C120.793 187.033 120.846 186.837 120.915 186.654C121.128 186.063 121.485 185.493 121.913 185.058C122.557 184.402 123.379 184.006 124.279 184.094C124.783 184.122 125.351 184.259 125.76 184.481C128.057 185.727 127.818 189.001 126.833 191.157C126.141 192.668 125.033 193.932 123.805 195.025C123.501 195.294 123.154 195.591 122.84 195.841C121.4 196.96 121.031 199.078 122.169 200.596C123.391 202.264 125.823 202.345 127.22 200.861C127.494 200.59 127.759 200.308 128.02 200.025C130.656 197.081 133.051 192.711 133.424 188.684C133.577 186.802 133.243 184.921 132.417 183.207H132.418Z",
        fill: "url(#paint29_radial_906_20424)"
      })]
    }), /* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsxs("linearGradient", {
        id: "paint0_linear_906_20424",
        x1: "118.154",
        y1: "257.826",
        x2: "118.154",
        y2: "77.8091",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#44EDD6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.07",
          stopColor: "#38C9C2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#299AA8"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#1C7393"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.39",
          stopColor: "#125582"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.49",
          stopColor: "#0B3F76"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.59",
          stopColor: "#07326F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.69",
          stopColor: "#062E6D"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint1_radial_906_20424",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(168.827 192.995) rotate(-166.275) scale(140.93 163.268)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#00C2FF",
          stopOpacity: "0.6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.56",
          stopColor: "#2F67C1",
          stopOpacity: "0.98"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#3162BE"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint2_radial_906_20424",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(118.746 171.476) scale(72.9019 72.8556)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FFAA55"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.35",
          stopColor: "#FEAC54"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.54",
          stopColor: "#FEB454"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7",
          stopColor: "#FDC254"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.84",
          stopColor: "#FCD654"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.96",
          stopColor: "#FBEF54"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#FBF954"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint3_radial_906_20424",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(118.746 171.479) scale(72.9019 72.8556)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FFB855"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.37",
          stopColor: "#FEB553"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.57",
          stopColor: "#FBAD4F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.74",
          stopColor: "#F59F48"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.89",
          stopColor: "#EE8B3F"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#E77735"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint4_linear_906_20424",
        x1: "81.7652",
        y1: "218.277",
        x2: "81.7652",
        y2: "127.088",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FF802C",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.16",
          stopColor: "#FE7F2B",
          stopOpacity: "0.01"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#FD7D29",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.42",
          stopColor: "#FC7A26",
          stopOpacity: "0.13"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.54",
          stopColor: "#FA7521",
          stopOpacity: "0.24"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.65",
          stopColor: "#F86F1B",
          stopOpacity: "0.37"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#F56814",
          stopOpacity: "0.54"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.87",
          stopColor: "#F15F0B",
          stopOpacity: "0.73"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#ED5501",
          stopOpacity: "0.95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#ED5400"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint5_linear_906_20424",
        x1: "154.719",
        y1: "218.277",
        x2: "154.719",
        y2: "127.088",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FF802C",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.16",
          stopColor: "#FE7F2B",
          stopOpacity: "0.01"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#FD7D29",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.42",
          stopColor: "#FC7A26",
          stopOpacity: "0.13"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.54",
          stopColor: "#FA7521",
          stopOpacity: "0.24"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.65",
          stopColor: "#F86F1B",
          stopOpacity: "0.37"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#F56814",
          stopOpacity: "0.54"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.87",
          stopColor: "#F15F0B",
          stopOpacity: "0.73"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#ED5501",
          stopOpacity: "0.95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#ED5400"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint6_linear_906_20424",
        x1: "118.112",
        y1: "234.339",
        x2: "118.112",
        y2: "96.3648",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#FF802C",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.16",
          stopColor: "#FE7F2B",
          stopOpacity: "0.01"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.29",
          stopColor: "#FD7D29",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.42",
          stopColor: "#FC7A26",
          stopOpacity: "0.13"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.54",
          stopColor: "#FA7521",
          stopOpacity: "0.24"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.65",
          stopColor: "#F86F1B",
          stopOpacity: "0.37"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#F56814",
          stopOpacity: "0.54"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.87",
          stopColor: "#F15F0B",
          stopOpacity: "0.73"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#ED5501",
          stopOpacity: "0.95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#ED5400"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint7_linear_906_20424",
        x1: "119.48",
        y1: "141.545",
        x2: "119.48",
        y2: "99.0034",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.17",
          stopColor: "#FBFDFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.33",
          stopColor: "#F0F9FD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#DEF1FA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.62",
          stopColor: "#C5E6F7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.76",
          stopColor: "#A4D9F3"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8",
          stopColor: "#9AD5F2"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint8_linear_906_20424",
        x1: "160.549",
        y1: "119.42",
        x2: "121.807",
        y2: "119.42",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.26",
          stopColor: "#FDFEFE",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.4",
          stopColor: "#F6FBFE",
          stopOpacity: "0.04"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#EAF7FD",
          stopOpacity: "0.1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.61",
          stopColor: "#DAF2FC",
          stopOpacity: "0.18"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.69",
          stopColor: "#C5EAFA",
          stopOpacity: "0.29"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.77",
          stopColor: "#ABE1F8",
          stopOpacity: "0.42"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#8CD7F5",
          stopOpacity: "0.57"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.92",
          stopColor: "#68CAF3",
          stopOpacity: "0.75"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#40BCEF",
          stopOpacity: "0.95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#36B9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint9_linear_906_20424",
        x1: "75.8938",
        y1: "119.42",
        x2: "114.638",
        y2: "119.42",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.26",
          stopColor: "#FDFEFE",
          stopOpacity: "0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.4",
          stopColor: "#F6FBFE",
          stopOpacity: "0.04"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.51",
          stopColor: "#EAF7FD",
          stopOpacity: "0.1"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.61",
          stopColor: "#DAF2FC",
          stopOpacity: "0.18"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.69",
          stopColor: "#C5EAFA",
          stopOpacity: "0.29"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.77",
          stopColor: "#ABE1F8",
          stopOpacity: "0.42"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#8CD7F5",
          stopOpacity: "0.57"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.92",
          stopColor: "#68CAF3",
          stopOpacity: "0.75"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.98",
          stopColor: "#40BCEF",
          stopOpacity: "0.95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#36B9EF"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint10_linear_906_20424",
        x1: "77.3319",
        y1: "118.711",
        x2: "114.153",
        y2: "118.711",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#36B9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.04",
          stopColor: "#4DC1F0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.11",
          stopColor: "#76CFF4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.19",
          stopColor: "#9BDCF7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.27",
          stopColor: "#BAE7F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#D3EFFB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#E7F6FD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.58",
          stopColor: "#F4FBFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.73",
          stopColor: "#FCFEFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint11_linear_906_20424",
        x1: "159.005",
        y1: "118.711",
        x2: "122.184",
        y2: "118.711",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#36B9EF"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.04",
          stopColor: "#4DC1F0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.11",
          stopColor: "#76CFF4"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.19",
          stopColor: "#9BDCF7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.27",
          stopColor: "#BAE7F9"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#D3EFFB"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.46",
          stopColor: "#E7F6FD"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.58",
          stopColor: "#F4FBFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.73",
          stopColor: "#FCFEFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint12_linear_906_20424",
        x1: "173.694",
        y1: "202.97",
        x2: "161.161",
        y2: "204.148",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#A6D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.19",
          stopColor: "#A7D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.33",
          stopColor: "#C6E4F6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#DFF0FA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#F1F8FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8",
          stopColor: "#FBFDFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint13_linear_906_20424",
        x1: "170.179",
        y1: "210.564",
        x2: "155.102",
        y2: "210.564",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.18",
          stopColor: "#A7D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.33",
          stopColor: "#C6E4F6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.48",
          stopColor: "#DFF0FA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.63",
          stopColor: "#F1F8FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8",
          stopColor: "#FBFDFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint14_linear_906_20424",
        x1: "165.074",
        y1: "223.592",
        x2: "142.253",
        y2: "218.078",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.19",
          stopColor: "#A6D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2",
          stopColor: "#A7D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#C6E4F6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.49",
          stopColor: "#DFF0FA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#F1F8FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8",
          stopColor: "#FBFDFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint15_linear_906_20424",
        x1: "154.643",
        y1: "231.6",
        x2: "137.989",
        y2: "225.245",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.21",
          stopColor: "#A6D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.22",
          stopColor: "#A7D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#C6E4F6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5",
          stopColor: "#DFF0FA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.65",
          stopColor: "#F1F8FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.81",
          stopColor: "#FBFDFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint16_linear_906_20424",
        x1: "61.977",
        y1: "202.97",
        x2: "74.5097",
        y2: "204.148",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.21",
          stopColor: "#A6D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.22",
          stopColor: "#A7D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#C6E4F6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5",
          stopColor: "#DFF0FA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.65",
          stopColor: "#F1F8FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.81",
          stopColor: "#FBFDFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint17_linear_906_20424",
        x1: "65.4916",
        y1: "210.564",
        x2: "80.5684",
        y2: "210.564",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.21",
          stopColor: "#A6D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.22",
          stopColor: "#A7D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#C6E4F6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5",
          stopColor: "#DFF0FA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.65",
          stopColor: "#F1F8FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.81",
          stopColor: "#FBFDFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint18_linear_906_20424",
        x1: "70.5972",
        y1: "223.592",
        x2: "93.4213",
        y2: "218.078",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.19",
          stopColor: "#A6D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.2",
          stopColor: "#A7D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.34",
          stopColor: "#C6E4F6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.49",
          stopColor: "#DFF0FA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#F1F8FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.8",
          stopColor: "#FBFDFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint19_linear_906_20424",
        x1: "80.778",
        y1: "230.833",
        x2: "97.8091",
        y2: "225.571",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.21",
          stopColor: "#A6D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.22",
          stopColor: "#A7D5F2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.36",
          stopColor: "#C6E4F6"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5",
          stopColor: "#DFF0FA"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.65",
          stopColor: "#F1F8FC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.81",
          stopColor: "#FBFDFE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint20_linear_906_20424",
        x1: "118.198",
        y1: "107.344",
        x2: "118.198",
        y2: "-0.198128",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#34C2BE"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.03",
          stopColor: "#2DACB2"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.1",
          stopColor: "#21869D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.16",
          stopColor: "#17668B"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.23",
          stopColor: "#0F4D7E"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.3",
          stopColor: "#0A3B74"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.38",
          stopColor: "#07316E"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.47",
          stopColor: "#062E6D"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint21_linear_906_20424",
        x1: "129.513",
        y1: "7.35902",
        x2: "140.363",
        y2: "109.758",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#20489D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.35",
          stopColor: "#20499D",
          stopOpacity: "0.99"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.5",
          stopColor: "#224C9E",
          stopOpacity: "0.98"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.61",
          stopColor: "#2856A1",
          stopOpacity: "0.92"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.7",
          stopColor: "#3267A6",
          stopOpacity: "0.82"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.78",
          stopColor: "#407FAD",
          stopOpacity: "0.69"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.85",
          stopColor: "#529DB6",
          stopOpacity: "0.51"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.92",
          stopColor: "#68C3C2",
          stopOpacity: "0.29"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#82EFCF",
          stopOpacity: "0.04"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#86F6D1",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint22_linear_906_20424",
        x1: "-82.5711",
        y1: "48.5301",
        x2: "234.892",
        y2: "48.5301",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#20489D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.35",
          stopColor: "#20499D",
          stopOpacity: "0.99"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.42",
          stopColor: "#204DA0",
          stopOpacity: "0.95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.52",
          stopColor: "#205AA7",
          stopOpacity: "0.84"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#206EB2",
          stopOpacity: "0.65"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.77",
          stopColor: "#1F8BC2",
          stopOpacity: "0.39"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.91",
          stopColor: "#1FAFD7",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.93",
          stopColor: "#1FB5DA",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint23_linear_906_20424",
        x1: "118.197",
        y1: "107.505",
        x2: "118.197",
        y2: "85.7959",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#82FFDC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#4A85BA"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint24_linear_906_20424",
        x1: "116.307",
        y1: "77.6201",
        x2: "116.307",
        y2: "48.5642",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5DF0C7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#4A85BA"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint25_linear_906_20424",
        x1: "49.192",
        y1: "26.7351",
        x2: "165.9",
        y2: "26.7351",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#20489D"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.35",
          stopColor: "#20499D",
          stopOpacity: "0.99"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.42",
          stopColor: "#204DA0",
          stopOpacity: "0.95"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.52",
          stopColor: "#205AA7",
          stopOpacity: "0.84"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.64",
          stopColor: "#206EB2",
          stopOpacity: "0.65"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.77",
          stopColor: "#1F8BC2",
          stopOpacity: "0.39"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.91",
          stopColor: "#1FAFD7",
          stopOpacity: "0.06"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.93",
          stopColor: "#1FB5DA",
          stopOpacity: "0"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint26_linear_906_20424",
        x1: "117.106",
        y1: "78.8263",
        x2: "113.956",
        y2: "22.0656",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#82FFDC"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#4A85BA"
        })]
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "paint27_linear_906_20424",
        x1: "119.515",
        y1: "82.5817",
        x2: "119.515",
        y2: "-2.67836",
        gradientUnits: "userSpaceOnUse",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "#5DF0C7"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.99",
          stopColor: "#4A85BA"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint28_radial_906_20424",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(96.1305 166.481) rotate(44.7377) scale(60.5943 99.1979)",
        children: [/* @__PURE__ */ jsx("stop", {
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "0.344027",
          stopColor: "white"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#F5F7FF",
          stopOpacity: "0.945257"
        })]
      }), /* @__PURE__ */ jsxs("radialGradient", {
        id: "paint29_radial_906_20424",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(124.154 200.31) rotate(-125.286) scale(25.5537 38.8343)",
        children: [/* @__PURE__ */ jsx("stop", {
          offset: "0.0001",
          stopColor: "#09FFD0"
        }), /* @__PURE__ */ jsx("stop", {
          offset: "1",
          stopColor: "#009EFF"
        })]
      }), /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_906_20424",
        children: /* @__PURE__ */ jsx("rect", {
          width: "240.594",
          height: "210",
          fill: "white",
          transform: "translate(0.406006)"
        })
      })]
    })]
  });
};
const getLogo = (logo, width, height) => {
  switch (logo) {
    case "ethereum":
      return ethereumLogo(width, height);
    case "binance":
      return binanceLogo(width, height);
    case "polygon":
      return polygonLogo(width, height);
    case "avalanche":
      return avalancheLogo(width, height);
    case "fantom":
      return fantomLogo(width, height);
    case "arbitrum":
      return arbitrum(width, height);
    case "cryptoweb":
      return cryptoLogo(width, height);
    case "coinbase":
      return coinbaseLogo(width, height);
    case "cronos":
      return cronosLogo(width, height);
    case "comingSoon":
      return comingSoon(width, height);
    case "confirmed":
      return confirmed(width, height);
    case "looking":
      return looking(width, height);
    case "servers":
      return servers(width, height);
    case "token":
      return token(width, height);
    case "lazyNft":
      return lazyNft(width, height);
    case "pack":
      return pack(width, height);
    case "marketplace":
      return marketplace(width, height);
    case "chest":
      return chest(width, height);
    case "bundle":
      return bundle(width, height);
    case "documentation":
      return documentation(width, height);
    case "discord":
      return discord(width, height);
    case "wizard":
      return wizard(width, height);
    default:
      return ethereumLogo();
  }
};
const StyledIllustration = styled$1.div`
    ${resetCSS}
    align-items: center;
    display: flex;
    height: ${(props) => props.height};
    justify-content: center;
    width: ${(props) => props.width};
`;
const Illustration = ({
  height,
  id = String(Date.now()),
  logo,
  width,
  ...props
}) => {
  return /* @__PURE__ */ jsx(StyledIllustration, {
    "data-testid": "test-illustration",
    height,
    id,
    width,
    ...props,
    children: getLogo(logo, width, height)
  });
};
var bgConfig = {
  arbitrum: "linear-gradient(113.54deg, rgba(60, 87, 140, 0.5) 14.91%, rgba(70, 86, 169, 0.5) 43.21%, rgba(125, 150, 217, 0.345) 44.27%, rgba(129, 161, 225, 0.185) 55.76%), linear-gradient(151.07deg, #141659 33.25%, #4152A7 98.24%)",
  fantom: "linear-gradient(113.54deg, rgba(117, 183, 251, 0.531738) 14.91%, rgba(10, 41, 255, 0.6) 42.57%, rgba(25, 105, 255, 0.336) 45.98%, rgba(25, 105, 255, 0.03) 55.76%), linear-gradient(160.75deg, #071AFF 41.37%, #45D4FF 98.29%)",
  avalanche: "linear-gradient(113.54deg, rgba(119, 0, 1, 0.5) 14.91%, rgba(216, 43, 44, 0.5) 43.21%, rgba(255, 130, 130, 0.345) 44.27%, rgba(220, 96, 97, 0.185) 55.76%), linear-gradient(151.07deg, #8F0E0F 33.25%, #FA4A4B 98.24%)",
  polygon: "linear-gradient(113.54deg, rgba(103, 58, 194, 0.6) 14.91%, rgba(122, 74, 221, 0.498) 44.27%, rgba(170, 129, 255, 0.222) 45.98%, rgba(209, 103, 255, 0.03) 55.76%), linear-gradient(160.75deg, #7A4ADD 41.37%, #D57BFF 98.29%)",
  binance: "linear-gradient(113.54deg, rgba(217, 166, 54, 0.6) 14.91%, rgba(230, 166, 26, 0.6) 44.27%, rgba(207, 168, 28, 0) 45.98%, rgba(250, 228, 30, 0) 55.76%, rgba(245, 223, 30, 0) 55.76%), linear-gradient(147.17deg, #F5D116 48.73%, #CD9614 98.22%)",
  ethereum: "linear-gradient(113.54deg, rgba(117, 183, 251, 0.531738) 14.91%, rgba(215, 38, 243, 0.6) 42.57%, rgba(252, 84, 255, 0.336) 45.98%, rgba(209, 103, 255, 0.03) 55.76%), linear-gradient(160.75deg, #AB42CB 41.37%, #45FFFF 98.29%)",
  cronos: "#012d74",
  coinbase: "#333dfb",
  cryptoweb: "linear-gradient(113.54deg, rgba(45, 91, 104, 0.531738) 14.91%, rgba(0, 4, 48, 0.6) 42.57%, rgba(45, 91, 104, 0.336) 45.98%, rgba(0, 4, 48, 0.03) 55.76%), linear-gradient(160.75deg, #000430 41.37%, #223F47 98.29%), linear-gradient(113.54deg, rgba(117, 183, 251, 0.531738) 14.91%, rgba(10, 41, 255, 0.6) 42.57%, rgba(25, 105, 255, 0.336) 45.98%, rgba(25, 105, 255, 0.03) 55.76%), linear-gradient(160.75deg, #071AFF 41.37%, #45D4FF 98.29%)"
};
const getBackground = (chain) => bgConfig[chain];
const getSize = (size2) => Ce$1`
  height: ${size2};
  width: ${size2};
`;
const DivStyledCryptoLogo$1 = styled$1.div`
  ${resetCSS};
  ${(props) => getSize(props.size)}
  align-items: center;
  border-radius: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: relative;
  background: ${(props) => (props == null ? void 0 : props.bgColor) || getBackground(props.chain)};
`;
var styles$j = {
  DivStyledCryptoLogo: DivStyledCryptoLogo$1
};
const {
  DivStyledCryptoLogo
} = styles$j;
const CryptoLogos = ({
  chain,
  size: size2 = "48px",
  bgColor,
  ...props
}) => {
  return /* @__PURE__ */ jsx(DivStyledCryptoLogo, {
    bgColor,
    chain,
    "data-testid": "test-crypto-logo",
    size: size2,
    ...props,
    children: /* @__PURE__ */ jsx(Illustration, {
      height: "90%",
      logo: chain,
      width: "90%"
    })
  });
};
const getChainLogoName = (chain) => {
  switch (chain) {
    case "0x89":
    case "0x13881":
      return "polygon";
    case "0x38":
    case "0x61":
      return "binance";
    case "0x66eeb":
    case "0xa4b1":
      return "arbitrum";
    case "0xa86a":
    case "0xa869":
      return "avalanche";
    case "0xfa":
      return "fantom";
    case "0x19":
    case "0x152":
      return "cronos";
    case "0x1":
    case "0x2a":
    case "0x3":
    case "0x4":
    case "0x5":
    case "0x539":
    default:
      return "ethereum";
  }
};
const GridStyled$1 = styled$1.div`
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fill, minmax(154px, 1fr));
    width: 100%;
`;
const GridElementStyled$1 = styled$1.div`
    height: 144px;
    & > div {
        height: 100%;
    }
`;
const CardContentStyled$1 = styled$1.div`
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
    margin-top: 13px;
`;
const ChainSelectStyles = { GridStyled: GridStyled$1, GridElementStyled: GridElementStyled$1, CardContentStyled: CardContentStyled$1 };
const {
  GridStyled,
  CardContentStyled,
  GridElementStyled
} = ChainSelectStyles;
const ChainSelector = ({
  IsMultipleAllowed,
  providers,
  values,
  setValue,
  isCompatibilityChecked,
  ...props
}) => {
  const getChainNameById = (chainId) => {
    var _a;
    return (_a = providers.find((provider) => provider.chainId === chainId)) == null ? void 0 : _a.chain;
  };
  const isAllSelected = useMemo(() => {
    let availableChains = [];
    if (!isCompatibilityChecked) {
      availableChains = providers.map((o) => getChainNameById(o.chainId));
    } else {
      providers.forEach((provider) => {
        if (isCompatibilityChecked && availableChains.includes(provider.chain)) {
          return;
        } else
          availableChains.push(provider.chain);
      });
    }
    const selectedChains = values.map((o) => getChainNameById(o.chainId));
    return availableChains.every((elem) => selectedChains.includes(elem));
  }, [providers, values, isCompatibilityChecked]);
  const checkIncompatibleChains = (providerOption) => {
    if (!isCompatibilityChecked)
      return;
    return !!providers.filter((o) => values.map((x2) => x2.chainId).includes(o.chainId) && o.chainId !== providerOption.chainId).some((c2) => c2.chain === providerOption.chain);
  };
  const toggleEvm = (chain) => {
    if (values.map((x2) => x2.chainId).includes(chain)) {
      const newArray = values.filter((e2) => e2.chainId !== chain);
      setValue(newArray);
    } else if (IsMultipleAllowed) {
      const newArray = [...values, {
        chainId: chain,
        maxRecordsPerCategory: 50,
        userSync: true
      }];
      setValue(newArray);
    } else {
      setValue([{
        chainId: chain,
        maxRecordsPerCategory: 50,
        userSync: true
      }]);
    }
  };
  const handleBatchSelect = () => {
    if (isAllSelected)
      setValue([]);
    else {
      const newArray = [];
      const addedChains = [];
      providers.forEach((provider) => {
        if (isCompatibilityChecked && addedChains.includes(provider.chain)) {
          return;
        }
        addedChains.push(provider.chain);
        newArray.push({
          chainId: provider.chainId,
          maxRecordsPerCategory: 50
        });
      });
      setValue(newArray);
    }
  };
  return /* @__PURE__ */ jsx("div", {
    "data-testid": "test-chain-selector",
    ...props,
    children: (providers == null ? void 0 : providers.length) > 0 ? /* @__PURE__ */ jsxs(GridStyled, {
      children: [providers.map((option) => /* @__PURE__ */ jsx(GridElementStyled, {
        children: /* @__PURE__ */ jsx(Card, {
          title: option.chain,
          description: option.name,
          onClick: () => toggleEvm(option.chainId),
          isSelected: values.map((x2) => x2.chainId).includes(option.chainId),
          isDisabled: checkIncompatibleChains(option),
          children: /* @__PURE__ */ jsx(CardContentStyled, {
            children: /* @__PURE__ */ jsx(CryptoLogos, {
              chain: getChainLogoName(option.chainId)
            })
          })
        })
      }, `crypto_card-${option.chainId}`)), IsMultipleAllowed && /* @__PURE__ */ jsx(GridElementStyled, {
        children: /* @__PURE__ */ jsx(Card, {
          onClick: handleBatchSelect,
          children: /* @__PURE__ */ jsx(CardContentStyled, {
            children: /* @__PURE__ */ jsx(Typography, {
              variant: "subtitle2",
              color: color.blue,
              children: isAllSelected ? "Deselect all" : "Select all"
            })
          })
        })
      })]
    }) : /* @__PURE__ */ jsx(Loading, {
      spinnerColor: color.blue
    })
  });
};
const inputStyles = Ce$1`
    ${resetCSS};
    height: 10px;
    left: -12px;
    position: absolute;
    top: 0;
    width: 10px;
`;
const labelStyles = Ce$1`
    ${resetCSS};
    ${fonts.text};
    color: ${color.blueDark};
    cursor: pointer;
    display: block;
    font-size: 18px;
    margin-bottom: 4px;
    overflow: hidden;
    position: relative;
    width: fit-content;
`;
const labelDisabled = Ce$1`
    opacity: 50%;
    pointer-events: none;
`;
const boxStyles = Ce$1`
    padding-left: 28px;

    &:before,
    .after {
        border-radius: 5px;
        content: '';
        display: block;
        height: 20px;
        left: 0;
        pointer-events: none;
        position: absolute;
        top: 1px;
        transition: all 0.1s ease-out;
        width: 20px;
    }

    &:before {
        background-color: ${color.blueLight};
        border: 1px solid ${color.blueSky};
        z-index: 0;
    }

    .after {
        align-items: center;
        display: flex;
        justify-content: center;
        left: 1px;
        opacity: 0;
        top: 2px;
        z-index: 1;
    }

    &:hover {
        &:before {
            filter: brightness(95%);
        }
    }

    &:active {
        &:before {
            filter: brightness(90%);
        }
    }
`;
const boxCheckedStyles = Ce$1`
    &:before {
        background-color: ${color.green};
        border-color: ${color.greenLight};
    }
    .after {
        opacity: 1;
    }
`;
const switchStyles = Ce$1`
    padding-left: 48px;

    &:before {
        background-color: ${color.greyLight};
        border-radius: 7px;
        content: '';
        display: block;
        height: 14px;
        left: 3px;
        opacity: 0.4;
        position: absolute;
        top: calc(50% - 7px);
        transition: all 0.1s ease-out;
        width: 34px;
    }

    &:after {
        background-color: ${color.blueLight};
        border-radius: 50%;
        border: 1px solid ${color.blue};
        content: '';
        display: block;
        height: 20px;
        left: 0;
        position: absolute;
        top: calc(50% - 11px);
        transition: all 0.1s ease-out;
        width: 20px;
    }

    &:hover {
        &:after {
            filter: brightness(95%);
        }
    }

    &:active {
        &:after {
            filter: brightness(90%);
        }
    }
`;
const switchOnStyles = Ce$1`
    &:before {
        background-color: ${color.green};
    }

    &:after {
        background-color: ${color.green};
        border: 1px solid ${color.green};
        left: 18px;
    }
`;
const StyledInput$1 = styled$1.input`
    ${inputStyles}
`;
const StyledLabel$1 = styled$1.label`
    ${labelStyles}
    ${(p2) => p2.disabled && labelDisabled}
    ${(p2) => p2.layout === "box" && boxStyles}
    ${(p2) => p2.layout === "box" && p2.checked && boxCheckedStyles}
    ${(p2) => p2.layout === "switch" && switchStyles}
    ${(p2) => p2.layout === "switch" && p2.checked && switchOnStyles}
`;
var styles$i = { StyledInput: StyledInput$1, StyledLabel: StyledLabel$1 };
const {
  StyledInput,
  StyledLabel
} = styles$i;
const Checkbox = ({
  checked,
  disabled = false,
  id,
  ref,
  label,
  labelWhenChecked,
  layout = "box",
  name = "",
  onChange,
  onBlur,
  validation,
  ...props
}) => {
  const [isChecked, setIsChecked] = useState(Boolean(checked));
  const valueChanged = (event) => {
    if (disabled)
      return;
    setIsChecked(Boolean(event.target.checked));
    onChange && onChange(event);
  };
  useEffect(() => setIsChecked(Boolean(checked)), [checked]);
  return /* @__PURE__ */ jsxs(StyledLabel, {
    checked: isChecked,
    "data-layout": layout,
    "data-testid": "test-checkbox-label",
    disabled,
    layout,
    children: [layout === "box" && /* @__PURE__ */ jsx("span", {
      className: "after",
      children: /* @__PURE__ */ jsx(SvgCheck, {
        title: "check icon",
        titleId: "checkbox check icon",
        fill: "#fff"
      })
    }), /* @__PURE__ */ jsx(StyledInput, {
      "data-testid": "test-checkbox-input",
      defaultChecked: isChecked,
      disabled,
      id,
      ref,
      layout,
      name,
      onChange: valueChanged,
      onBlur: (event) => onBlur && onBlur(event),
      required: validation == null ? void 0 : validation.required,
      type: "checkbox",
      value: `${isChecked}`,
      ...props
    }), /* @__PURE__ */ jsx("span", {
      "data-testid": "test-checkbox-text",
      children: isChecked ? labelWhenChecked || label : label
    })]
  });
};
const TextAreaStyled$3 = styled$1.textarea`
  ${resetCSS};
  ${fonts.ibmMono};
  ${fonts.textSmall}
  background: ${color.blueLight};
  overflow-x: auto;
  padding: 16px 8px;
  position: relative;
  width: 100vw;

  color: ${color.blueDark};
  font-style: italic;
  overflow-y: hidden;
  white-space: pre;
  resize: none;
`;
const ContentStyled$1 = styled$1.div`
  display: flex;
`;
const DivStyledButtonWrap$1 = styled$1.div`
  margin: 19px;
  position: absolute;
  right: 0;
`;
const SideStyled$1 = styled$1.div`
  background: ${color.blueLight2};
  overflow: hidden;
  padding: 16px 8px 0px 23px;
`;
const StyledUl$1 = styled$1.ul`
  ${resetCSS};
  list-style: none;
  text-align: right;
`;
const WrapperStyled$1 = styled$1.div`
  border-radius: 16px;
  border: 2px solid ${color.paleBlue2};
  display: flex;
  max-height: 100%;
  max-width: fit-content;
  overflow: hidden;
  position: relative;
  flex-direction: column;
`;
const notExpanded = Ce$1`
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  box-shadow: 0px 8px 5px -2px ${color.blueSky};
  overflow: hidden;
`;
const WidthWrapperStyled$1 = styled$1.div`
  border-bottom: 2px solid ${color.paleBlue2};
  max-height: ${(p2) => p2.maxHeight};
  max-width: ${(p2) => p2.maxWidth};

  ${(p2) => p2.maxHeight && !p2.isMaximized && notExpanded};
`;
const HeaderStyled$6 = styled$1.div`
  padding: 8px 16px;
  border-bottom: 1px solid ${color.paleBlue2};
`;
const CodeAreaStyles = {
  WidthWrapperStyled: WidthWrapperStyled$1,
  SideStyled: SideStyled$1,
  StyledUl: StyledUl$1,
  TextAreaStyled: TextAreaStyled$3,
  WrapperStyled: WrapperStyled$1,
  ContentStyled: ContentStyled$1,
  HeaderStyled: HeaderStyled$6,
  DivStyledButtonWrap: DivStyledButtonWrap$1
};
const {
  SideStyled,
  StyledUl
} = CodeAreaStyles;
const LineNumbers = ({
  currentValue
}) => {
  const rowNumbers = useMemo(() => {
    const rowsAmount = currentValue.split(/\r\n|\r|\n/).length;
    const numberComps = [];
    for (let i = 1; i < rowsAmount + 1; i++) {
      numberComps.push(/* @__PURE__ */ jsx("li", {
        children: /* @__PURE__ */ jsx(Typography, {
          variant: "caption14",
          monospace: true,
          color: color.grey,
          italic: true,
          children: i
        })
      }, i));
    }
    return numberComps;
  }, [currentValue]);
  return /* @__PURE__ */ jsx(SideStyled, {
    children: /* @__PURE__ */ jsx(StyledUl, {
      "data-testid": "test-codearea-linenumbers",
      children: rowNumbers
    })
  });
};
const {
  ContentStyled,
  HeaderStyled: HeaderStyled$5,
  DivStyledButtonWrap,
  TextAreaStyled: TextAreaStyled$2,
  WidthWrapperStyled,
  WrapperStyled
} = CodeAreaStyles;
const CodeArea = ({
  text: text2,
  maxWidth = "100%",
  onChange,
  headerComponent,
  disabled,
  minHeight,
  maxHeight,
  ...props
}) => {
  const [currentValue, setCurrentValue] = useState(text2);
  const [isMaximized, setIsMaximized] = useState(false);
  const hasMaxHeight = Boolean(maxHeight);
  useEffect(() => setCurrentValue(text2), [text2]);
  const textareaRef = useRef(null);
  const valueChanged = (event) => {
    setCurrentValue(event.target.value);
    onChange && onChange(event);
  };
  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = "0px";
      textareaRef.current.style.minHeight = minHeight || "unset";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + "px";
      textareaRef.current.style.minHeight = scrollHeight + "px";
    }
  }, [currentValue]);
  return /* @__PURE__ */ jsx(WidthWrapperStyled, {
    maxHeight,
    maxWidth,
    isMaximized,
    ...props,
    children: /* @__PURE__ */ jsxs(WrapperStyled, {
      "data-testid": "test-codearea-wrapper",
      children: [headerComponent && /* @__PURE__ */ jsx(HeaderStyled$5, {
        "data-testid": "test-codearea-header",
        children: headerComponent
      }), /* @__PURE__ */ jsxs(ContentStyled, {
        children: [/* @__PURE__ */ jsx(LineNumbers, {
          currentValue
        }), /* @__PURE__ */ jsx(TextAreaStyled$2, {
          "data-testid": "test-codearea",
          ref: textareaRef,
          onChange: (event) => valueChanged(event),
          spellCheck: false,
          value: currentValue,
          disabled
        }), hasMaxHeight && /* @__PURE__ */ jsx(DivStyledButtonWrap, {
          "data-testid": "test-codearea-maximize-button-wrapper",
          children: /* @__PURE__ */ jsx(Button, {
            "data-testid": isMaximized ? "test-button-minimize" : "test-button-maximize",
            icon: isMaximized ? /* @__PURE__ */ jsx(SvgMinimize, {
              fontSize: 20
            }) : /* @__PURE__ */ jsx(SvgMaximize, {
              fontSize: 20
            }),
            iconLayout: "icon-only",
            id: "test-button-primary-icon-only",
            isTransparent: true,
            onClick: () => {
              setIsMaximized(!isMaximized);
            },
            radius: 20,
            theme: "secondary",
            type: "button"
          })
        })]
      })]
    })
  });
};
const CredentialsStyled$1 = styled$1.div`
    background: ${color.blueLight};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    padding: 16px;
    position: relative;
    width: ${(p2) => p2.width};

    @media (max-width: 600px) {
        padding: 16px 8px;
    }
`;
const PreformattedStyled$1 = styled$1.pre`
    ${resetCSS};
    display: flex;
    height: max-content;
    justify-content: space-between;
    position: relative;

    @media (max-width: 600px) {
        width: 100%;
    }
`;
const ToolsStyled$1 = styled$1.div`
    align-self: flex-end;
    display: flex;
    font-size: 24px;
    margin-left: 8px;
`;
const DividerStyled$1 = styled$1.div`
    position: relative;
    margin: 0 8px;
    &:before {
        border-left: 2px solid ${color.paleBlue2};
        content: '';
        height: 24px;
        position: absolute;
        width: 0;
    }
`;
const DivWrapperStyled$7 = styled$1.div`
    ${resetCSS};
    overflow-x: ${(p2) => p2.isHidden ? "hidden" : p2.isMultiline && "auto"};
    width: 90%;

    @media (max-width: 600px) {
        width: 80%;
    }
`;
var styles$h = {
  CredentialsStyled: CredentialsStyled$1,
  DivWrapperStyled: DivWrapperStyled$7,
  DividerStyled: DividerStyled$1,
  PreformattedStyled: PreformattedStyled$1,
  ToolsStyled: ToolsStyled$1
};
const HeaderStyled$4 = styled$1.div`
    align-items: center;
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
`;
const CredentialsHeader = ({
  title,
  titleColor = color.blueDark,
  icon
}) => {
  if (!title && !icon)
    return null;
  return /* @__PURE__ */ jsxs(HeaderStyled$4, {
    children: [icon && icon, title && /* @__PURE__ */ jsx(Typography, {
      variant: "body16",
      weight: "600",
      color: titleColor,
      "data-testid": "test-cred-header-text",
      children: title
    })]
  });
};
const HideButtonStyled = styled$1.button`
    ${resetButtonCSS};
    cursor: pointer;
`;
const HideButton = ({
  iconColor = color.blue,
  iconSize = 24,
  isHidden = false,
  onToggle,
  ...props
}) => {
  return /* @__PURE__ */ jsx(HideButtonStyled, {
    onClick: onToggle,
    "data-testid": "test-hide-button",
    ...props,
    children: isHidden ? /* @__PURE__ */ jsx(SvgEyeClosed, {
      title: "eye closed icon",
      titleId: "hidebutton eye closed icon",
      fontSize: iconSize,
      fill: `${iconColor}`
    }) : /* @__PURE__ */ jsx(SvgEye, {
      title: "eye icon",
      titleId: "hidebutton eye icon",
      fontSize: iconSize,
      fill: `${iconColor}`
    })
  });
};
const truncateString = ({
  leftPercentage = 50,
  measurements,
  replaceString,
  text: text2
}) => {
  if (measurements.text && measurements.component && measurements.text > measurements.component) {
    const size2 = (percentage) => measurements.component * (percentage / 100);
    const portion = (size22) => Math.floor(text2.length * size22 / measurements.text);
    const leftPart = text2.slice(0, Math.max(0, portion(size2(leftPercentage)) - replaceString.length));
    const rightPart = text2.slice(text2.length - portion(size2(100 - leftPercentage)) + replaceString.length, text2.length);
    return `${leftPart}${replaceString}${rightPart}`;
  } else {
    return text2;
  }
};
const TruncateString = ({
  replaceString = "...",
  percentageOfCharsAfterTrunc = 50,
  text: text2 = ""
}) => {
  const [truncating, setTruncating] = useState(true);
  const [truncatedString, setTruncatedString] = useState(null);
  const componentRef = useRef(null);
  const textRef = useRef(null);
  const replaceStrRef = useRef(null);
  const getTruncatedString = (text22) => {
    var _a, _b, _c;
    const measurements = {
      component: ((_a = componentRef.current) == null ? void 0 : _a.offsetWidth) || 0,
      replace: ((_b = replaceStrRef.current) == null ? void 0 : _b.offsetWidth) || 0,
      text: ((_c = textRef.current) == null ? void 0 : _c.offsetWidth) || 0
    };
    return truncateString({
      leftPercentage: percentageOfCharsAfterTrunc,
      measurements,
      replaceString,
      text: text22
    });
  };
  useEffect(() => {
    if (!(truncatedString == null ? void 0 : truncatedString.includes("..."))) {
      setTruncatedString(text2);
    } else {
      setTruncating(true);
    }
  }, [text2]);
  useEffect(() => {
    if (truncating) {
      const ts = getTruncatedString(text2);
      setTruncatedString(ts);
      setTruncating(false);
    }
  }, [truncating]);
  useEffect(() => {
    let timeoutId = null;
    const truncateListener = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setTruncating(true), 50);
    };
    window.addEventListener("resize", truncateListener);
    return () => {
      window.removeEventListener("resize", truncateListener);
    };
  }, []);
  return /* @__PURE__ */ jsxs("div", {
    ref: componentRef,
    style: {
      display: "block",
      overflow: "hidden",
      whiteSpace: "nowrap"
    },
    children: [truncating && /* @__PURE__ */ jsx("span", {
      ref: textRef,
      children: text2
    }), truncating && /* @__PURE__ */ jsx("span", {
      ref: replaceStrRef,
      children: replaceString
    }), !truncating && truncatedString]
  });
};
const {
  CredentialsStyled,
  DividerStyled,
  DivWrapperStyled: DivWrapperStyled$6,
  PreformattedStyled,
  ToolsStyled
} = styles$h;
const Credentials = ({
  hasCopyButton = true,
  hasHideButton = true,
  hiddenText = "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
  icon,
  isHidden = false,
  text: text2,
  textColor = color.blueDark,
  title,
  titleColor,
  width = "auto",
  ...props
}) => {
  const [isValueHidden, setIsValueHidden] = useState(isHidden);
  const [isMultiline, setIsMultiline] = useState((text2.match(/\n/g) || []).length > 0);
  useEffect(() => setIsValueHidden(isHidden), [isHidden]);
  useEffect(() => setIsMultiline((text2.match(/\n/g) || []).length > 0), [text2]);
  return /* @__PURE__ */ jsxs(CredentialsStyled, {
    "data-testid": "test-credentials",
    width,
    ...props,
    children: [/* @__PURE__ */ jsx(CredentialsHeader, {
      "data-testid": "test-credentials-header",
      icon,
      title,
      titleColor,
      ...props
    }), /* @__PURE__ */ jsxs(PreformattedStyled, {
      "data-testid": "test-credentials-pre",
      children: [/* @__PURE__ */ jsx(DivWrapperStyled$6, {
        isHidden: isValueHidden,
        isMultiline,
        children: /* @__PURE__ */ jsx(Typography, {
          color: isValueHidden ? color.grey : textColor,
          "data-testid": "test-cred-new-comp-heading",
          monospace: true,
          variant: isValueHidden ? "caption14" : "body16",
          weight: "400",
          children: isValueHidden ? hiddenText : isMultiline ? text2 : /* @__PURE__ */ jsx(TruncateString, {
            text: text2,
            percentageOfCharsAfterTrunc: 55
          })
        })
      }), /* @__PURE__ */ jsxs(ToolsStyled, {
        "data-testid": "test-credentials-tools",
        children: [hasHideButton && /* @__PURE__ */ jsx(HideButton, {
          onToggle: () => setIsValueHidden(!isValueHidden),
          isHidden: isValueHidden
        }), hasHideButton && hasCopyButton && /* @__PURE__ */ jsx(DividerStyled, {}), hasCopyButton && /* @__PURE__ */ jsx(CopyButton, {
          text: text2,
          iconSize: 24
        })]
      })]
    })]
  });
};
const getMoralisLogo = () => /* @__PURE__ */ jsxs("svg", {
  width: "29",
  height: "23",
  viewBox: "0 0 29 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ jsx("path", {
    d: "M27.0946 4.85404C25.8482 2.21456 23.3058 0.388139 20.44 0.172173C19.0359 0.0412256 17.5869 0.279668 16.3211 0.919747C15.471 1.34288 14.7144 1.93019 14.0785 2.62988C12.7669 1.13669 10.9129 0.160446 8.91279 0.0588152C4.70815 -0.194285 1.08385 2.53705 0.200664 6.77819C-0.335871 9.31798 0.249352 11.9702 1.41103 14.2041C2.57077 16.4077 4.26314 18.3671 6.46479 19.5182C8.00136 20.2687 9.44154 18.3651 8.31783 17.0341C7.95949 16.6315 7.62939 16.2035 7.3285 15.7461C7.04904 15.322 6.79781 14.8764 6.56995 14.4201C5.93702 13.1184 5.46475 11.6526 5.37127 10.2092C5.31577 9.2916 5.43554 8.50103 5.8153 7.70264C6.17461 6.958 6.75691 6.31792 7.52131 6.01693C8.71025 5.56448 9.95081 5.80781 10.8544 6.78503C11.4416 7.39188 11.7104 8.24109 12.0103 9.02482C12.0327 9.0815 12.057 9.13622 12.0823 9.18997C12.6793 11.0379 15.4155 11.0848 15.9267 8.9828C15.9423 8.91146 15.9579 8.83915 15.9744 8.76585C15.9773 8.75413 15.9803 8.74338 15.9832 8.73165C15.9861 8.71992 15.9881 8.7082 15.991 8.69549C16.0348 8.50787 16.0854 8.32024 16.1507 8.14532C16.3542 7.58146 16.693 7.03715 17.1001 6.62183C17.7135 5.99543 18.4955 5.61725 19.3514 5.70129C19.8305 5.72865 20.3709 5.8596 20.7604 6.07166C22.9455 7.26093 22.7176 10.3861 21.7809 12.4451C21.1226 13.8875 20.069 15.0943 18.9005 16.137C18.6113 16.394 18.2812 16.6774 17.9823 16.9169C16.6122 17.985 16.2617 20.0068 17.3445 21.456C18.5062 23.0489 20.8198 23.1261 22.149 21.7091C22.4099 21.4502 22.6621 21.1814 22.9104 20.9108C25.4178 18.1003 27.6964 13.9285 28.0508 10.0841C28.1969 8.28702 27.8785 6.49088 27.0927 4.85502L27.0946 4.85404Z",
    fill: "url(#paint0_radial_14842_207372)"
  }), /* @__PURE__ */ jsx("defs", {
    children: /* @__PURE__ */ jsxs("radialGradient", {
      id: "paint0_radial_14842_207372",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(19.3022 21.4237) rotate(-125.194) scale(24.3695 36.9876)",
      children: [/* @__PURE__ */ jsx("stop", {
        stopColor: "#00FFCE"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#56BEFF"
      })]
    })
  })]
});
const getMoralisDefault = (color2) => {
  switch (color2) {
    case "blue":
      return moralisLogoDefaultBlue();
    default:
    case "white":
      return moralisLogoDefaultWhite();
  }
};
const moralisLogoDefaultWhite = () => {
  return /* @__PURE__ */ jsxs("svg", {
    fill: "none",
    height: "171",
    viewBox: "0 0 571 171",
    width: "571",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsxs("radialGradient", {
      id: "a",
      cx: "0",
      cy: "0",
      gradientTransform: "matrix(-77.82610115 -110.11323072 167.24896419 -118.20863595 129.956 141.22)",
      gradientUnits: "userSpaceOnUse",
      r: "1",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: "#00ffce"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#56beff"
      })]
    }), /* @__PURE__ */ jsx("path", {
      d: "m173.135 49.6033c-6.906-14.5941-20.994-24.6928-36.874-25.8869-7.78-.724-15.809.5944-22.824 4.1335-4.71 2.3396-8.902 5.5869-12.426 9.4556-7.2678-8.2561-17.5412-13.6539-28.6239-14.2159-23.2986-1.3994-43.3813 13.7026-48.2752 37.1526-2.973 14.043.2698 28.7074 6.7068 41.0588 6.4263 12.185 15.804 23.018 28.0037 29.383 8.5143 4.15 16.4946-6.376 10.2679-13.735-1.9856-2.226-3.8147-4.593-5.482-7.121-1.5485-2.345-2.9406-4.809-4.2032-7.333-3.5072-7.1966-6.1241-15.3015-6.6421-23.282-.3076-5.0737.3561-9.4449 2.4604-13.8593 1.991-4.1173 5.2177-7.6564 9.4533-9.3206 6.5881-2.5017 13.4622-1.1563 18.4694 4.247 3.2536 3.3554 4.7428 8.0508 6.4047 12.3842.1241.3133.259.6159.3993.9131 3.3075 10.2175 18.4689 10.4769 21.3019-1.1455.087-.3944.173-.7943.265-1.1995.016-.0648.032-.1243.048-.1891.016-.0649.027-.1297.043-.1999.243-1.0375.524-2.0749.885-3.0421 1.128-3.1176 3.006-6.1272 5.261-8.4236 3.399-3.4635 7.732-5.5545 12.475-5.0898 2.655.1513 5.649.8753 7.807 2.0478 12.108 6.5757 10.846 23.8552 5.655 35.2398-3.647 7.9752-9.486 14.6485-15.96 20.4135-1.603 1.421-3.432 2.988-5.088 4.312-7.592 5.905-9.535 17.085-3.535 25.098 6.437 8.807 19.258 9.234 26.623 1.399 1.446-1.432 2.843-2.918 4.219-4.414 13.894-15.54 26.52-38.6064 28.484-59.8627.809-9.9365-.955-19.8676-5.309-28.9126z",
      fill: "url(#a)"
    }), /* @__PURE__ */ jsxs("g", {
      fill: "#fff",
      children: [/* @__PURE__ */ jsx("path", {
        d: "m269.918 61.1714c5.697 0 10.273 1.8209 13.721 5.4626 3.448 3.6418 5.169 8.4885 5.169 14.5455v29.6745h-14.914v-28.4155c0-2.4477-.615-4.382-1.84-5.7977-1.224-1.4156-3-2.1288-5.32-2.1288-2.455 0-4.36.805-5.714 2.4152-1.36 1.6102-2.039 3.8363-2.039 6.6676v27.2592h-14.914v-28.4155c0-2.4477-.615-4.382-1.84-5.7977-1.225-1.4156-3-2.1288-5.32-2.1288-2.455 0-4.36.805-5.714 2.4152-1.36 1.6102-2.04 3.8363-2.04 6.6676v27.2592h-14.913v-48.3318h14.913v4.4468c2.72-3.8687 7.16-5.7976 13.322-5.7976 5.768 0 10.106 2.1289 13.025 6.3812 3.049-4.2523 7.857-6.3812 14.418-6.3812z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m341.098 104.813c-5.105 4.928-11.337 7.397-18.691 7.397s-13.586-2.464-18.691-7.397c-5.104-4.9275-7.656-10.9683-7.656-18.1222s2.552-13.1947 7.656-18.1224c5.105-4.9278 11.337-7.3916 18.691-7.3916s13.586 2.4638 18.691 7.3916c5.104 4.9277 7.656 10.9685 7.656 18.1224s-2.552 13.1947-7.656 18.1222zm-26.844-9.9093c2.185 2.1289 4.905 3.1879 8.153 3.1879s5.962-1.0644 8.153-3.1879c2.185-2.1289 3.28-4.8629 3.28-8.2183s-1.095-6.0894-3.28-8.2183-4.905-3.1879-8.153-3.1879-5.968 1.0644-8.153 3.1879-3.281 4.8683-3.281 8.2183 1.096 6.0894 3.281 8.2183z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m371.238 110.86h-15.847v-48.5969h15.054v11.7142c2.39-8.9639 8.671-12.9353 14.654-12.9353 1.991 0 4.187.1027 6.88 1.3238l-3.885 15.2803c-3.291-1.2211-5.682-1.2211-7.176-1.2211-5.979 0-9.669 3.4634-9.669 17.7226v16.7174z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m431.491 62.5224h14.914v48.3316h-14.914v-5.722c-1.883 4.863-8.449 7.073-14.811 7.073-6.361 0-12.162-2.464-16.802-7.397-4.64-4.9277-6.96-10.9685-6.96-18.1224s2.32-13.1947 6.96-18.1224c4.64-4.9278 10.241-7.5051 16.802-7.3916 11.31.1945 15.087 5.5977 14.811 8.2993zm-20.379 32.7651c2.185 2.1289 5.034 3.1879 8.552 3.1879s6.362-1.0644 8.552-3.1879c2.191-2.1234 3.281-4.9926 3.281-8.6019 0-3.6094-1.095-6.4785-3.281-8.6019-2.185-2.1235-5.039-3.188-8.552-3.188s-6.361 1.0645-8.552 3.188c-2.185 2.1288-3.281 4.9925-3.281 8.6019 0 3.6093 1.096 6.4785 3.281 8.6019z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m457.428 110.854v-70.5605h14.914v70.5605z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m497.324 55.7088c-1.759 1.7075-3.863 2.5612-6.313 2.5612-2.449 0-4.559-.8537-6.313-2.5612-1.759-1.7074-2.633-3.7552-2.633-6.138s.88-4.4307 2.633-6.1381c1.754-1.7074 3.858-2.5611 6.313-2.5611s4.554.8537 6.313 2.5611c1.754 1.7074 2.633 3.7553 2.633 6.1381s-.879 4.4306-2.633 6.138zm-13.77 55.1452v-48.3317h14.914v48.3317z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m523.542 76.6355c0 .9672.847 1.7561 2.536 2.3667 1.689.6105 3.728 1.2265 6.113 1.837 2.385.6106 4.77 1.3995 7.16 2.3667 2.385.9671 4.425 2.5611 6.113 4.7818 1.689 2.2207 2.536 5.0088 2.536 8.3588 0 5.2195-1.991 9.1695-5.967 11.8385-3.977 2.675-8.882 4.009-14.714 4.009-10.473 0-17.596-3.831-21.373-11.503l12.923-7.1542c1.327 3.8039 4.139 5.7004 8.45 5.7004 3.577 0 5.368-.9996 5.368-2.9988 0-.9671-.847-1.7722-2.536-2.4152-1.688-.643-3.728-1.2698-6.113-1.8857-2.385-.6106-4.77-1.4157-7.16-2.4153-2.385-.9996-4.424-2.5611-6.113-4.69-1.689-2.1288-2.536-4.7386-2.536-7.8292 0-5.025 1.872-8.9262 5.617-11.698 3.744-2.7719 8.368-4.1551 13.867-4.1551 4.111 0 7.856.8861 11.233 2.6584 3.378 1.7722 6.098 4.3334 8.153 7.6834l-12.723 6.6676c-1.591-2.8367-3.814-4.2524-6.663-4.2524s-4.177.9024-4.177 2.707z"
      })]
    })]
  });
};
const moralisLogoDefaultBlue = () => {
  return /* @__PURE__ */ jsxs("svg", {
    fill: "none",
    height: "171",
    viewBox: "0 0 570 171",
    width: "570",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsxs("radialGradient", {
      id: "a",
      cx: "0",
      cy: "0",
      gradientTransform: "matrix(-77.81043965 -110.00550682 167.15174418 -118.23181474 130.067 139.775)",
      gradientUnits: "userSpaceOnUse",
      r: "1",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: ".0001",
        stopColor: "#09ffd0"
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: "#009eff"
      })]
    }), /* @__PURE__ */ jsxs("g", {
      fill: "#5a7196",
      children: [/* @__PURE__ */ jsx("path", {
        d: "m270.435 61.1592c5.699 0 10.275 1.82 13.723 5.4602 3.448 3.6401 5.169 8.4846 5.169 14.5389v29.6607h-14.915v-28.4023c0-2.4466-.615-4.3801-1.84-5.7951s-3-2.1279-5.32-2.1279c-2.456 0-4.36.8047-5.715 2.4142-1.36 1.6094-2.04 3.8345-2.04 6.6645v27.2466h-14.915v-28.4023c0-2.4466-.615-4.3801-1.84-5.7951s-3-2.1279-5.32-2.1279c-2.455 0-4.36.8047-5.715 2.4142-1.36 1.6094-2.039 3.8345-2.039 6.6645v27.2466h-14.915v-48.3096h14.915v4.4448c2.719-3.8669 7.16-5.795 13.323-5.795 5.768 0 10.107 2.1279 13.026 6.3783 3.049-4.2504 7.857-6.3783 14.418-6.3783z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m340.817 104.781c-5.105 4.925-11.337 7.393-18.692 7.393s-13.588-2.462-18.692-7.393c-5.105-4.9257-7.657-10.9638-7.657-18.1144 0-7.1507 2.552-13.1887 7.657-18.1143 5.104-4.9255 11.337-7.3882 18.692-7.3882s13.587 2.4627 18.692 7.3882c5.105 4.9256 7.657 10.9636 7.657 18.1143 0 7.1506-2.552 13.1887-7.657 18.1144zm-26.846-9.9052c2.186 2.1279 4.905 3.1864 8.154 3.1864 3.248 0 5.963-1.0639 8.153-3.1864 2.186-2.1279 3.281-4.8607 3.281-8.2146s-1.095-6.0867-3.281-8.2146c-2.185-2.1279-4.905-3.1865-8.153-3.1865-3.249 0-5.968 1.064-8.154 3.1865-2.185 2.1225-3.28 4.8661-3.28 8.2146s1.095 6.0867 3.28 8.2146z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m370.577 110.825h-15.849v-48.5751h15.055v11.7089c2.391-8.9599 8.672-12.9295 14.656-12.9295 2.482 0 5.181.2322 7.879 1.8525l-4.317 14.9601c-3.778-1.4582-5.936-1.442-7.749-1.442-5.979 0-9.67 3.4619-9.67 17.7146v16.7105z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m430.301 62.5086h14.915v48.3104h-14.915v-5.72c-1.883 4.861-8.45 7.07-14.812 7.07s-12.163-2.463-16.804-7.394c-4.64-4.9254-6.961-10.9635-6.961-18.1141 0-7.1507 2.321-13.1887 6.961-18.1142 4.641-4.9256 10.242-7.5017 16.804-7.3883 11.31.1944 15.087 5.5952 14.812 8.2956zm-20.381 32.7503c2.185 2.1279 5.035 3.1865 8.553 3.1865s6.362-1.064 8.553-3.1865 3.281-4.9903 3.281-8.598-1.096-6.4756-3.281-8.5981c-2.186-2.1225-5.04-3.1864-8.553-3.1864s-6.362 1.0639-8.553 3.1864c-2.185 2.1279-3.281 4.9904-3.281 8.5981s1.096 6.4755 3.281 8.598z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m456.24 110.819v-70.529h14.915v70.529z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m496.139 55.6987c-1.759 1.7067-3.863 2.56-6.313 2.56s-4.56-.8533-6.314-2.56c-1.759-1.7066-2.633-3.7535-2.633-6.1353 0-2.3817.88-4.4286 2.633-6.1353 1.754-1.7066 3.859-2.5599 6.314-2.5599s4.554.8533 6.313 2.5599c1.754 1.7067 2.634 3.7536 2.634 6.1353 0 2.3818-.88 4.4287-2.634 6.1353zm-13.771 55.1203v-48.3099h14.915v48.3099z"
      }), /* @__PURE__ */ jsx("path", {
        d: "m522.359 76.6159c0 .9667.848 1.7552 2.537 2.3655 1.688.6103 3.728 1.226 6.113 1.8363s4.77 1.3988 7.161 2.3655c2.385.9668 4.425 2.56 6.114 4.7797 1.689 2.2198 2.536 5.0066 2.536 8.3551 0 5.217-1.991 9.165-5.968 11.833-3.977 2.673-8.882 4.007-14.715 4.007-10.474 0-17.597-3.829-21.374-11.498l12.923-7.1504c1.328 3.8021 4.139 5.6978 8.451 5.6978 3.577 0 5.369-.9992 5.369-2.9974 0-.9668-.847-1.7715-2.536-2.4142s-3.729-1.2692-6.114-1.8849c-2.385-.6103-4.77-1.415-7.161-2.4141-2.385-.9992-4.425-2.56-6.114-4.6879s-2.536-4.7365-2.536-7.8258c0-5.0227 1.873-8.9221 5.618-11.6927 3.744-2.7706 8.369-4.1532 13.868-4.1532 4.111 0 7.856.8857 11.234 2.6572s6.098 4.3314 8.154 7.6799l-12.724 6.6646c-1.592-2.8354-3.815-4.2504-6.664-4.2504-2.85 0-4.177.9019-4.177 2.7058z"
      })]
    }), /* @__PURE__ */ jsx("path", {
      d: "m173.63 49.5791c-6.906-14.5805-20.994-24.6751-36.874-25.8681-7.781-.7234-15.809.5938-22.824 4.1296-4.71 2.3374-8.903 5.5817-12.426 9.4468-7.268-8.243-17.5361-13.6412-28.6188-14.1972-23.2986-1.4035-43.3814 13.6898-48.2753 37.1126-2.973 14.0299.2698 28.6806 6.7069 41.0212 6.4262 12.173 15.8039 22.996 28.0036 29.355 8.5144 4.146 16.4947-6.37 10.268-13.722-1.9856-2.224-3.8147-4.589-5.482-7.115-1.5486-2.343-2.9407-4.804-4.2033-7.325-3.5072-7.1907-6.1241-15.288-6.642-23.2612-.3076-5.0689.3561-9.436 2.4604-13.8463 1.991-4.1135 5.2176-7.6493 9.4532-9.3119 6.5882-2.4994 13.4623-1.1552 18.4695 4.243 3.2536 3.3522 4.7428 8.0433 6.4047 12.3726.1241.3131.259.6154.3993.9123 3.3075 10.208 18.4698 10.4671 21.3018-1.1444.087-.3941.173-.7935.265-1.1984.016-.0648.032-.1242.048-.1889.017-.0648.027-.1296.043-.1998.243-1.0364.524-2.0729.885-3.0391 1.128-3.1148 3.006-6.1216 5.261-8.4158 3.399-3.4603 7.732-5.5494 12.475-5.0851 2.655.1511 5.649.8745 7.808 2.0459 12.108 6.5696 10.845 23.833 5.654 35.207-3.647 7.9677-9.485 14.6341-15.96 20.3941-1.603 1.42-3.432 2.985-5.088 4.308-7.592 5.9-9.535 17.069-3.534 25.075 6.437 8.799 19.257 9.225 26.622 1.398 1.446-1.431 2.843-2.915 4.219-4.411 13.894-15.525 26.52-38.5696 28.484-59.8061.81-9.9273-.955-19.8492-5.309-28.8858z",
      fill: "url(#a)"
    })]
  });
};
const getVisaLogo = (size2) => {
  return size2 === "regular" ? visaLogoRegular() : visaLogoSmall();
};
const visaLogoRegular = () => {
  return /* @__PURE__ */ jsx("svg", {
    width: "45",
    height: "32",
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx("path", {
      d: "M23.2729 12.8118C23.2473 14.9083 25.0769 16.0784 26.4552 16.7739C27.8713 17.4877 28.3469 17.9454 28.3415 18.5835C28.3307 19.5604 27.2119 19.9915 26.1646 20.0083C24.3377 20.0377 23.2756 19.4974 22.4311 19.0888L21.773 22.2784C22.6203 22.6828 24.1891 23.0355 25.816 23.0509C29.6347 23.0509 32.1332 21.0985 32.1467 18.0713C32.1616 14.2295 27.0159 14.0168 27.0511 12.2996C27.0632 11.7789 27.5429 11.2233 28.5942 11.082C29.1145 11.0106 30.5509 10.956 32.1791 11.7328L32.8183 8.64675C31.9427 8.31646 30.8171 8.00016 29.4158 8.00016C25.8214 8.00016 23.2932 9.97912 23.2729 12.8118ZM38.9598 8.26607C38.2626 8.26607 37.6748 8.68734 37.4126 9.33393L31.9575 22.8242H35.7735L36.5329 20.6507H41.1962L41.6367 22.8242H45L42.065 8.26607H38.9598ZM39.4936 12.1988L40.5949 17.6654H37.5788L39.4936 12.1988ZM18.6462 8.26607L15.6382 22.8242H19.2745L22.2811 8.26607H18.6462ZM13.2668 8.26607L9.48186 18.1749L7.95087 9.7496C7.77115 8.8091 7.06174 8.26607 6.27395 8.26607H0.0864813L0 8.68874C1.27019 8.97425 2.71335 9.4347 3.58762 9.92734C4.12273 10.2282 4.27542 10.4914 4.45108 11.2065L7.35091 22.8242H11.1939L17.0855 8.26607H13.2668Z",
      fill: "white"
    })
  });
};
const visaLogoSmall = () => {
  return /* @__PURE__ */ jsx("svg", {
    width: "33",
    height: "24",
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx("path", {
      d: "M17.0668 9.60889C17.048 11.1813 18.3897 12.0588 19.4005 12.5805C20.439 13.1158 20.7878 13.459 20.7838 13.9377C20.7759 14.6704 19.9554 14.9936 19.1874 15.0062C17.8477 15.0283 17.0688 14.6231 16.4495 14.3166L15.9669 16.7088C16.5882 17.0121 17.7387 17.2767 18.9317 17.2882C21.7321 17.2882 23.5644 15.8239 23.5743 13.5535C23.5852 10.6722 19.8117 10.5126 19.8375 9.22471C19.8464 8.83424 20.1982 8.41752 20.9691 8.3115C21.3506 8.25797 22.404 8.21704 23.598 8.7996L24.0668 6.48509C23.4246 6.23737 22.5992 6.00015 21.5716 6.00015C18.9357 6.00015 17.0817 7.48437 17.0668 9.60889ZM28.5705 6.19959C28.0592 6.19959 27.6282 6.51553 27.4359 7.00048L23.4355 17.1182H26.2339L26.7908 15.488H30.2105L30.5336 17.1182H33L30.8477 6.19959H28.5705ZM28.962 9.14913L29.7696 13.2491H27.5578L28.962 9.14913ZM13.6739 6.19959L11.4681 17.1182H14.1346L16.3395 6.19959H13.6739ZM9.72896 6.19959L6.95337 13.6312L5.83064 7.31223C5.69885 6.60685 5.17861 6.19959 4.60089 6.19959H0.0634196L0 6.51658C0.931476 6.73071 1.98979 7.07605 2.63092 7.44553C3.02333 7.67121 3.13531 7.86855 3.26413 8.40492L5.39067 17.1182H8.20888L12.5293 6.19959H9.72896Z",
      fill: "white"
    })
  });
};
const getMastercardLogo = (size2) => {
  return size2 === "regular" ? mastercardLogoRegular() : mastercardLogoSmall();
};
const mastercardLogoRegular = () => {
  return /* @__PURE__ */ jsxs("svg", {
    width: "34",
    height: "32",
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip0_244_13197)",
      children: [/* @__PURE__ */ jsx("path", {
        d: "M21.607 7.61462H12.3606V24.3869H21.607V7.61462Z",
        fill: "#FF5F00"
      }), /* @__PURE__ */ jsx("path", {
        d: "M12.9553 16.0003C12.9538 14.385 13.3164 12.7905 14.0157 11.3376C14.7149 9.88471 15.7325 8.61142 16.9913 7.61415C15.4325 6.37731 13.5603 5.60813 11.5888 5.39454C9.61729 5.18095 7.62604 5.53155 5.84263 6.40629C4.05921 7.28103 2.55559 8.64462 1.50362 10.3412C0.451656 12.0377 -0.106201 13.9988 -0.106201 16.0003C-0.106201 18.0017 0.451656 19.9628 1.50362 21.6594C2.55559 23.3559 4.05921 24.7195 5.84263 25.5942C7.62604 26.469 9.61729 26.8196 11.5888 26.606C13.5603 26.3924 15.4325 25.6232 16.9913 24.3864C15.7325 23.3891 14.715 22.1158 14.0157 20.6629C13.3165 19.21 12.9538 17.6156 12.9553 16.0003Z",
        fill: "#EB001B"
      }), /* @__PURE__ */ jsx("path", {
        d: "M34.0814 16.0003C34.0815 18.0017 33.5237 19.9628 32.4718 21.6593C31.4199 23.3559 29.9163 24.7195 28.1329 25.5942C26.3495 26.469 24.3583 26.8196 22.3868 26.606C20.4154 26.3924 18.5432 25.6232 16.9844 24.3864C18.2421 23.3881 19.2589 22.1146 19.958 20.6619C20.6572 19.2093 21.0204 17.6153 21.0204 16.0003C21.0204 14.3852 20.6572 12.7913 19.958 11.3386C19.2589 9.88592 18.2421 8.61243 16.9844 7.61415C18.5432 6.3773 20.4154 5.60812 22.3868 5.39454C24.3583 5.18095 26.3495 5.53157 28.1329 6.40632C29.9163 7.28107 31.4199 8.64465 32.4718 10.3412C33.5237 12.0378 34.0815 13.9988 34.0814 16.0003Z",
        fill: "#F79E1B"
      }), /* @__PURE__ */ jsx("path", {
        d: "M33.0867 22.6121V22.2688H33.2238V22.1988H32.8745V22.2688H33.0117V22.6121H33.0867ZM33.7649 22.6121V22.1981H33.6578L33.5347 22.4829L33.4115 22.1981H33.3043V22.6121H33.3799V22.2998L33.4954 22.5691H33.5738L33.6893 22.2992V22.6121H33.7649Z",
        fill: "#F79E1B"
      })]
    }), /* @__PURE__ */ jsx("defs", {
      children: /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_244_13197",
        children: /* @__PURE__ */ jsx("rect", {
          width: "34",
          height: "32",
          fill: "white"
        })
      })
    })]
  });
};
const mastercardLogoSmall = () => {
  return /* @__PURE__ */ jsxs("svg", {
    width: "26",
    height: "24",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsxs("g", {
      clipPath: "url(#clip0_248_13976)",
      children: [/* @__PURE__ */ jsx("path", {
        d: "M16.5229 5.71094H9.45215V18.2901H16.5229V5.71094Z",
        fill: "#FF5F00"
      }), /* @__PURE__ */ jsx("path", {
        d: "M9.90713 12.0002C9.90601 10.7888 10.1833 9.59293 10.718 8.50324C11.2528 7.41356 12.0309 6.4586 12.9935 5.71065C11.8014 4.78301 10.3698 4.20613 8.86217 4.04593C7.35456 3.88574 5.83184 4.14869 4.46805 4.80475C3.10426 5.46081 1.95443 6.48349 1.14999 7.75591C0.345542 9.02833 -0.0810547 10.4991 -0.0810547 12.0002C-0.0810547 13.5013 0.345542 14.9721 1.14999 16.2446C1.95443 17.517 3.10426 18.5397 4.46805 19.1957C5.83184 19.8518 7.35456 20.1147 8.86217 19.9545C10.3698 19.7943 11.8014 19.2175 12.9935 18.2898C12.0309 17.5419 11.2528 16.5869 10.7181 15.4972C10.1833 14.4075 9.90602 13.2117 9.90713 12.0002Z",
        fill: "#EB001B"
      }), /* @__PURE__ */ jsx("path", {
        d: "M26.0622 12.0002C26.0623 13.5013 25.6357 14.9721 24.8313 16.2445C24.0269 17.5169 22.8771 18.5396 21.5134 19.1957C20.1496 19.8518 18.6269 20.1147 17.1193 19.9545C15.6117 19.7943 14.1801 19.2175 12.988 18.2898C13.9498 17.5411 14.7274 16.586 15.262 15.4965C15.7966 14.407 16.0744 13.2115 16.0744 12.0002C16.0744 10.789 15.7966 9.59349 15.262 8.50398C14.7274 7.41447 13.9498 6.45935 12.988 5.71064C14.1801 4.78301 15.6117 4.20612 17.1193 4.04593C18.6269 3.88574 20.1496 4.1487 21.5134 4.80477C22.8771 5.46083 24.0269 6.48352 24.8313 7.75593C25.6357 9.02835 26.0623 10.4992 26.0622 12.0002Z",
        fill: "#F79E1B"
      }), /* @__PURE__ */ jsx("path", {
        d: "M25.3017 16.9591V16.7015H25.4065V16.6491H25.1394V16.7015H25.2443V16.9591H25.3017ZM25.8203 16.9591V16.6486H25.7384L25.6442 16.8621L25.55 16.6486H25.4681V16.9591H25.5259V16.7248L25.6142 16.9268H25.6742L25.7625 16.7243V16.9591H25.8203Z",
        fill: "#F79E1B"
      })]
    }), /* @__PURE__ */ jsx("defs", {
      children: /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_248_13976",
        children: /* @__PURE__ */ jsx("rect", {
          width: "26",
          height: "24",
          fill: "white"
        })
      })
    })]
  });
};
const getAmexLogo = (size2) => {
  return size2 === "regular" ? amexLogoRegular() : amexLogoSmall();
};
const amexLogoRegular = () => {
  return /* @__PURE__ */ jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "44",
    height: "15",
    viewBox: "0 0 44 15",
    fill: "none",
    children: /* @__PURE__ */ jsx("path", {
      d: "M2.22743 0.299099L0.00830078 5.45869H1.45308L1.86254 4.42549H4.24293L4.65024 5.45869H6.12687L3.90976 0.299099H2.22743ZM3.04847 1.49985L3.77403 3.30534H2.3208L3.04847 1.49985ZM6.2796 5.45781V0.298218L8.33267 0.30583L9.52683 3.63244L10.6924 0.298218H12.7291V5.45781H11.4392V1.65601L10.0719 5.45781H8.94062L7.56949 1.65601V5.45781H6.2796ZM13.6116 5.45781V0.298218H17.8208V1.45233H14.9151V2.33488H17.7529V3.42115H14.9151V4.33767H17.8208V5.45781H13.6116ZM18.5676 0.299099V5.45869H19.8575V3.62566H20.4006L21.9472 5.45869H23.5235L21.8263 3.55777C22.5228 3.49899 23.2413 2.90116 23.2413 1.97298C23.2413 0.887244 22.3892 0.299099 21.4381 0.299099H18.5676ZM19.8575 1.45321H21.3319C21.6857 1.45321 21.943 1.72989 21.943 1.9963C21.943 2.33906 21.6096 2.53944 21.3511 2.53944H19.8575V1.45321ZM25.085 5.45781H23.7679V0.298218H25.085V5.45781ZM28.2079 5.45781H27.9236C26.5481 5.45781 25.713 4.3741 25.713 2.89922C25.713 1.38787 26.5387 0.298218 28.2758 0.298218H29.7014V1.52023H28.2237C27.5185 1.52023 27.0198 2.07053 27.0198 2.91194C27.0198 3.91118 27.5901 4.33085 28.4115 4.33085H28.751L28.2079 5.45781ZM31.0147 0.299099L28.7956 5.45869H30.2404L30.6498 4.42549H33.0302L33.4375 5.45869H34.9141L32.6971 0.299099H31.0147ZM31.8357 1.49985L32.5613 3.30534H31.108L31.8357 1.49985ZM35.0647 5.45781V0.298218H36.7047L38.7986 3.53995V0.298218H40.0886V5.45781H38.5016L36.3546 2.13125V5.45781H35.0647ZM9.40253 14.4871V9.32751H13.6116V10.4816H10.706V11.3642H13.5437V12.4504H10.706V13.367H13.6116V14.4871H9.40253ZM30.0274 14.4871V9.32751H34.2365V10.4816H31.3308V11.3642H34.155V12.4504H31.3308V13.367H34.2364V14.4871H30.0274ZM13.775 14.4871L15.8244 11.9392L13.7262 9.32751H15.3513L16.6009 10.942L17.8548 9.32751H19.4163L17.3456 11.9073L19.3988 14.4871H17.774L16.5606 12.8981L15.3768 14.4871H13.775ZM19.552 9.32839V14.488H20.8758V12.8587H22.2336C23.3825 12.8587 24.2533 12.2491 24.2533 11.0638C24.2533 10.0819 23.5703 9.32839 22.4012 9.32839H19.552ZM20.8758 10.4953H22.3057C22.6769 10.4953 22.9422 10.7227 22.9422 11.0893C22.9422 11.4336 22.6782 11.6833 22.3015 11.6833H20.8758V10.4953ZM24.8134 9.32751V14.4871H26.1033V12.6541H26.6465L28.193 14.4871H29.7693L28.0721 12.5862C28.7687 12.5274 29.4872 11.9296 29.4872 11.0014C29.4872 9.91566 28.635 9.32751 27.6839 9.32751H24.8134ZM26.1033 10.4816H27.5778C27.9315 10.4816 28.1888 10.7583 28.1888 11.0248C28.1888 11.3675 27.8554 11.5679 27.5969 11.5679H26.1033V10.4816ZM34.8339 14.4871V13.367H37.4154C37.7974 13.367 37.9628 13.1605 37.9628 12.9341C37.9628 12.7172 37.7979 12.498 37.4154 12.498H36.2488C35.2349 12.498 34.6701 11.8802 34.6701 10.9526C34.6701 10.1253 35.1873 9.32751 36.6941 9.32751H39.206L38.6629 10.4884H36.4904C36.0751 10.4884 35.9473 10.7063 35.9473 10.9145C35.9473 11.1283 36.1053 11.3642 36.4225 11.3642H37.6445C38.7749 11.3642 39.2654 12.0054 39.2654 12.845C39.2654 13.7478 38.7188 14.4871 37.583 14.4871H34.8339ZM39.5681 14.4871V13.367H42.1496C42.5316 13.367 42.697 13.1605 42.697 12.9341C42.697 12.7172 42.5321 12.498 42.1496 12.498H40.9831C39.9691 12.498 39.4044 11.8802 39.4044 10.9526C39.4044 10.1253 39.9215 9.32751 41.4283 9.32751H43.9402L43.3971 10.4884H41.2246C40.8094 10.4884 40.6815 10.7063 40.6815 10.9145C40.6815 11.1283 40.8395 11.3642 41.1568 11.3642H42.3788C43.5091 11.3642 43.9996 12.0054 43.9996 12.845C43.9996 13.7478 43.4531 14.4871 42.3172 14.4871H39.5681Z",
      fill: "white"
    })
  });
};
const amexLogoSmall = () => {
  return /* @__PURE__ */ jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "12",
    viewBox: "0 0 34 12",
    fill: "none",
    children: /* @__PURE__ */ jsx("path", {
      d: "M2.38534 0.974293L0.745117 4.84399H1.813L2.11564 4.06909H3.87506L4.17611 4.84399H5.26754L3.62881 0.974293H2.38534ZM2.9922 1.87486L3.52848 3.22898H2.45436L2.9922 1.87486ZM5.38042 4.84333V0.973633L6.89791 0.979342L7.78055 3.4743L8.64205 0.973633H10.1474V4.84333H9.19404V1.99198L8.18339 4.84333H7.34726L6.33383 1.99198V4.84333H5.38042ZM10.7998 4.84333V0.973633H13.9109V1.83922H11.7632V2.50113H13.8607V3.31583H11.7632V4.00322H13.9109V4.84333H10.7998ZM14.4629 0.974293V4.84399H15.4163V3.46922H15.8177L16.9608 4.84399H18.1259L16.8714 3.4183C17.3863 3.37421 17.9174 2.92584 17.9174 2.22971C17.9174 1.4154 17.2875 0.974293 16.5845 0.974293H14.4629ZM15.4163 1.83988H16.5061C16.7675 1.83988 16.9577 2.04738 16.9577 2.2472C16.9577 2.50427 16.7113 2.65455 16.5202 2.65455H15.4163V1.83988ZM19.2801 4.84333H18.3066V0.973633H19.2801V4.84333ZM21.5883 4.84333H21.3782C20.3615 4.84333 19.7442 4.03054 19.7442 2.92439C19.7442 1.79088 20.3546 0.973633 21.6385 0.973633H22.6922V1.89014H21.6C21.0788 1.89014 20.7102 2.30287 20.7102 2.93393C20.7102 3.68335 21.1316 3.9981 21.7388 3.9981H21.9897L21.5883 4.84333ZM23.6629 0.974293L22.0227 4.84399H23.0906L23.3932 4.06909H25.1526L25.4537 4.84399H26.5451L24.9064 0.974293H23.6629ZM24.2698 1.87486L24.806 3.22898H23.7319L24.2698 1.87486ZM26.6564 4.84333V0.973633H27.8685L29.4162 3.40493V0.973633H30.3697V4.84333H29.1967L27.6098 2.34841V4.84333H26.6564ZM7.68868 11.6153V7.7456H10.7998V8.61119H8.6521V9.27314H10.7496V10.0878H8.6521V10.7752H10.7998V11.6153H7.68868ZM22.9331 11.6153V7.7456H26.0442V8.61119H23.8965V9.27314H25.984V10.0878H23.8965V10.7752H26.0442V11.6153H22.9331ZM10.9205 11.6153L12.4353 9.70434L10.8844 7.7456H12.0856L13.0092 8.95647L13.936 7.7456H15.0901L13.5597 9.68045L15.0772 11.6153H13.8763L12.9795 10.4235L12.1045 11.6153H10.9205ZM15.1905 7.74626V11.616H16.1689V10.394H17.1725C18.0217 10.394 18.6654 9.93683 18.6654 9.04784C18.6654 8.31139 18.1605 7.74626 17.2964 7.74626H15.1905ZM16.1689 8.62142H17.2258C17.5002 8.62142 17.6963 8.79203 17.6963 9.06692C17.6963 9.32518 17.5012 9.51245 17.2227 9.51245H16.1689V8.62142ZM19.0793 7.7456V11.6153H20.0327V10.2405H20.4342L21.5773 11.6153H22.7424L21.488 10.1896C22.0028 10.1456 22.5338 9.69715 22.5338 9.00102C22.5338 8.18671 21.904 7.7456 21.201 7.7456H19.0793ZM20.0327 8.61119H21.1226C21.384 8.61119 21.5742 8.81869 21.5742 9.01854C21.5742 9.27561 21.3278 9.42586 21.1367 9.42586H20.0327V8.61119ZM26.4858 11.6153V10.7752H28.3938C28.6762 10.7752 28.7984 10.6204 28.7984 10.4506C28.7984 10.2879 28.6766 10.1234 28.3938 10.1234H27.5316C26.7821 10.1234 26.3647 9.66012 26.3647 8.96445C26.3647 8.34396 26.747 7.7456 27.8607 7.7456H29.7173L29.3159 8.61631H27.7101C27.4032 8.61631 27.3087 8.77972 27.3087 8.93581C27.3087 9.09619 27.4255 9.27314 27.66 9.27314H28.5632C29.3987 9.27314 29.7612 9.75401 29.7612 10.3837C29.7612 11.0608 29.3572 11.6153 28.5177 11.6153H26.4858ZM29.985 11.6153V10.7752H31.893C32.1754 10.7752 32.2976 10.6204 32.2976 10.4506C32.2976 10.2879 32.1758 10.1234 31.893 10.1234H31.0308C30.2813 10.1234 29.864 9.66012 29.864 8.96445C29.864 8.34396 30.2462 7.7456 31.3599 7.7456H33.2165L32.8151 8.61631H31.2094C30.9024 8.61631 30.8079 8.77972 30.8079 8.93581C30.8079 9.09619 30.9247 9.27314 31.1592 9.27314H32.0624C32.8979 9.27314 33.2604 9.75401 33.2604 10.3837C33.2604 11.0608 32.8565 11.6153 32.0169 11.6153H29.985Z",
      fill: "white"
    })
  });
};
const getDinersLogo = (size2) => {
  return size2 === "regular" ? dinersLogoRegular() : dinersLogoSmall();
};
const dinersLogoRegular = () => {
  return /* @__PURE__ */ jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "23",
    viewBox: "0 0 34 23",
    fill: "none",
    children: [/* @__PURE__ */ jsx("circle", {
      cx: "11.2087",
      cy: "11.2088",
      r: "10.8352",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M33.6216 8.30363C33.2451 6.89234 32.5895 5.5563 31.7007 4.40561C30.8117 3.25472 29.6891 2.28939 28.5179 1.57482C27.3467 0.860259 26.1267 0.396868 25.249 0.157996C24.3716 -0.080876 23.8495 0.0220542 23.3217 0.0220542H10.6789C10.3354 0.0220542 9.99342 0.0222593 9.11524 0.241242C8.23706 0.460225 6.82433 0.865795 5.56025 1.56006C4.29637 2.25433 3.18134 3.23709 2.29602 4.39659C1.40869 5.56047 0.757244 6.8878 0.378558 8.30343C0.00169206 9.71956 -0.095008 11.1962 0.0939301 12.6497C0.284795 14.103 0.758059 15.5045 1.48685 16.7747C2.21434 18.04 3.19298 19.1597 4.35211 20.0266C5.51125 20.8935 6.85067 21.5078 7.93426 21.889C9.01784 22.27 9.84559 22.4176 10.6784 22.4176H23.3211C24.1537 22.4176 24.9817 22.27 26.0651 21.889C27.1487 21.5078 28.4881 20.8937 29.6474 20.0266C30.8063 19.1595 31.785 18.04 32.5127 16.7747C33.2415 15.5045 33.7147 14.103 33.9056 12.6497C34.0951 11.1963 33.9986 9.71967 33.6216 8.30363ZM21.3273 13.9406C20.9671 15.2871 20.3475 16.5496 19.5035 17.6567C18.658 18.7628 17.6043 19.6913 16.4024 20.3895C15.1994 21.0857 13.8718 21.5377 12.4952 21.72C11.1185 21.9005 9.71989 21.8081 8.37855 21.4481C7.03772 21.0864 5.78055 20.4641 4.67819 19.6165C3.5768 18.7675 2.65226 17.7094 1.95708 16.5024C1.26376 15.2943 0.813593 13.9611 0.63215 12.5787C0.451859 11.2006 0.544557 9.78689 0.902893 8.44449C1.26123 7.1021 1.88459 5.83146 2.72663 4.72855C3.57213 3.62247 4.62578 2.69396 5.82773 1.99577C7.03072 1.29957 8.35818 0.847436 9.73472 0.665061C11.1115 0.48457 12.5101 0.57694 13.8514 0.936944C15.1923 1.29869 16.4495 1.92097 17.552 2.76857C18.6503 3.61436 19.5813 4.67913 20.2733 5.88272C20.9653 7.08631 21.4177 8.4285 21.598 9.80658C21.7783 11.1847 21.6854 12.5982 21.3273 13.9406Z",
      fill: "#383E93"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.95427 7.32289C6.48248 7.84267 6.11047 8.44558 5.857 9.10121C5.60386 9.75709 5.47371 10.4543 5.47314 11.1578C5.47314 11.859 5.60443 12.5602 5.857 13.2143C6.10957 13.8682 6.48343 14.4747 6.95427 14.9926C7.42511 15.5106 7.99252 15.9395 8.61711 16.2532V6.0623C7.99077 6.37691 7.42718 6.80417 6.95427 7.32289ZM15.2987 7.29316C14.8176 6.77284 14.2446 6.34648 13.6089 6.03564V16.2799C14.2446 15.969 14.8175 15.5426 15.2987 15.0224C15.7788 14.501 16.1577 13.8942 16.416 13.2332C16.6739 12.5718 16.8065 11.868 16.8072 11.1578C16.8072 10.4496 16.6735 9.74175 16.416 9.08234C16.1577 8.4213 15.7788 7.81451 15.2987 7.29316Z",
      fill: "#383E93"
    })]
  });
};
const dinersLogoSmall = () => {
  return /* @__PURE__ */ jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "26",
    height: "18",
    viewBox: "0 0 26 18",
    fill: "none",
    children: [/* @__PURE__ */ jsx("ellipse", {
      cx: "8.71954",
      cy: "9.15665",
      rx: "8.0086",
      ry: "8.12637",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.2856 6.97772C25.0073 5.91925 24.5227 4.91722 23.8657 4.05421C23.2086 3.19104 22.3789 2.46704 21.5133 1.93112C20.6476 1.39519 19.7459 1.04765 19.0971 0.868497C18.4486 0.689343 18.0627 0.766541 17.6726 0.766541H8.32788C8.07404 0.766541 7.82125 0.766694 7.17216 0.930932C6.52307 1.09517 5.47888 1.39935 4.54456 1.92005C3.61039 2.44075 2.78624 3.17781 2.13187 4.04744C1.47602 4.92036 0.994516 5.91585 0.714618 6.97757C0.436065 8.03967 0.364591 9.14712 0.504241 10.2373C0.645315 11.3272 0.995119 12.3784 1.53379 13.331C2.0715 14.28 2.79484 15.1198 3.65159 15.77C4.50834 16.4201 5.49835 16.8809 6.29926 17.1667C7.10018 17.4525 7.71199 17.5632 8.32758 17.5632H17.6721C18.2876 17.5632 18.8995 17.4525 19.7003 17.1667C20.5012 16.8809 21.4912 16.4203 22.3481 15.77C23.2047 15.1196 23.9281 14.28 24.4659 13.331C25.0046 12.3784 25.3544 11.3272 25.4955 10.2373C25.6356 9.14721 25.5642 8.03976 25.2856 6.97772ZM16.1984 11.2055C15.9322 12.2153 15.4743 13.1622 14.8505 13.9926C14.2255 14.8221 13.4467 15.5185 12.5584 16.0421C11.6691 16.5643 10.6879 16.9033 9.67043 17.04C8.65284 17.1754 7.61908 17.1061 6.62766 16.8361C5.63661 16.5648 4.70739 16.0981 3.89261 15.4624C3.07854 14.8256 2.39518 14.032 1.88135 13.1268C1.3689 12.2207 1.03617 11.2208 0.902056 10.184C0.768797 9.15049 0.837313 8.09017 1.10217 7.08337C1.36703 6.07657 1.82777 5.1236 2.45015 4.29641C3.07509 3.46685 3.85387 2.77047 4.74226 2.24683C5.63143 1.72467 6.6126 1.38558 7.63004 1.2488C8.64763 1.11343 9.68139 1.18271 10.6728 1.45271C11.6639 1.72402 12.5932 2.19073 13.408 2.82643C14.2198 3.46077 14.908 4.25935 15.4194 5.16204C15.9309 6.06473 16.2653 7.07138 16.3986 8.10493C16.5318 9.13849 16.4632 10.1987 16.1984 11.2055Z",
      fill: "#383E93"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.57497 6.24217C5.22625 6.632 4.95129 7.08418 4.76395 7.5759C4.57684 8.06782 4.48064 8.59075 4.48022 9.11832C4.48022 9.64425 4.57726 10.1702 4.76395 10.6607C4.95063 11.1511 5.22696 11.606 5.57497 11.9945C5.92298 12.3829 6.34238 12.7046 6.80403 12.9399V5.29673C6.34108 5.53269 5.92451 5.85313 5.57497 6.24217ZM11.7426 6.21987C11.387 5.82963 10.9635 5.50986 10.4936 5.27673V12.9599C10.9635 12.7267 11.3869 12.407 11.7426 12.0168C12.0974 11.6258 12.3775 11.1707 12.5684 10.6749C12.759 10.1789 12.8571 9.65099 12.8576 9.11832C12.8576 8.58716 12.7587 8.05631 12.5684 7.56176C12.3775 7.06598 12.0974 6.61088 11.7426 6.21987Z",
      fill: "#383E93"
    })]
  });
};
const Logo = ({
  theme,
  color: color2,
  size: size2,
  ...props
}) => {
  switch (theme) {
    case "amex":
      return /* @__PURE__ */ jsx("div", {
        "data-testid": "test-logo-amex",
        ...props,
        children: getAmexLogo(size2 || "regular")
      });
    case "default":
      return /* @__PURE__ */ jsx("div", {
        "data-testid": "test-logo-default",
        ...props,
        children: getMoralisDefault(color2 || "white")
      });
    case "diners":
      return /* @__PURE__ */ jsx("div", {
        "data-testid": "test-logo-diners",
        ...props,
        children: getDinersLogo(size2 || "regular")
      });
    case "mastercard":
      return /* @__PURE__ */ jsx("div", {
        "data-testid": "test-logo-mastercard",
        ...props,
        children: getMastercardLogo(size2 || "regular")
      });
    case "icon":
      return /* @__PURE__ */ jsx("div", {
        "data-testid": "test-logo-icon",
        ...props,
        children: getMoralisLogo()
      });
    case "visa":
      return /* @__PURE__ */ jsx("div", {
        "data-testid": "test-logo-visa",
        ...props,
        children: getVisaLogo(size2 || "regular")
      });
  }
};
const getBgGradient = (brand) => {
  switch (brand) {
    case "amex":
      return gradientColors.lightBlue;
    case "diners":
      return gradientColors.purpleToPink;
    case "mastercard":
      return gradientColors.blue;
    case "visa":
      return gradientColors.goldShiny;
  }
};
const DivStyledCreditCard = styled$1.div`
    ${resetCSS};
    ${fonts.text};
    background: ${({ brand }) => getBgGradient(brand)};
    border: 2px solid ${colorPercentage(color.white, 40)};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: end;
    gap: 17%;
    padding: 16px;
    height: 154px;
    width: 277px;

    ${({ isExpired, pressed }) => isExpired ? expiredStyles : pressed ? pressedStyles : ""}
`;
const DivStyledFlexEnd = styled$1.div`
    align-items: center;
    display: flex;
    justify-content: flex-end;
`;
const DivStyledFlex = styled$1.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;

    svg {
        cursor: pointer;
    }
`;
const DivStyledFlexText = styled$1.div`
    color: white;
    display: flex;
    margin-right: 8px;
`;
styled$1.div`
    display: grid;
    place-items: center;

    :hover {
        cursor: pointer;
    }
`;
const PStyledDigits = styled$1.p`
    ${fonts.semiBold};
    color: ${color.white};
    font-size: 18px;
    line-height: 24px;
    margin: 0;
`;
const PStyledText = styled$1.p`
    ${fonts.semiBold}
    color: ${(p2) => p2.isExpired ? color.red : color.white};
    font-size: 12px;
    line-height: 16px;
    margin: 0 0 0 5px;
`;
const expiredStyles = Ce$1`
    border-color: ${color.red};
`;
const pressedStyles = Ce$1`
    border-color: ${color.green};
`;
const CreditCard = ({
  brand,
  expiresAt,
  isExpired,
  isRemovable = true,
  lastDigits,
  name,
  onRemove,
  pressed,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(DivStyledCreditCard, {
    brand,
    "data-testid": "test-credit-card",
    isExpired,
    pressed,
    ...props,
    children: [/* @__PURE__ */ jsx(DivStyledFlexEnd, {
      children: /* @__PURE__ */ jsx(Tooltip, {
        children: /* @__PURE__ */ jsx(Fragment, {
          children: (isRemovable || isExpired) && /* @__PURE__ */ jsx(Button, {
            icon: /* @__PURE__ */ jsx(SvgBin, {
              fontSize: 20,
              fill: color.red
            }),
            iconLayout: "icon-only",
            isTransparent: true,
            onClick: () => onRemove && onRemove(),
            size: "small",
            theme: "colored"
          })
        }),
        content: "Remove",
        position: "bottom"
      })
    }), /* @__PURE__ */ jsx(PStyledDigits, {
      "data-testid": "test-credit-card-digits",
      children: `\u2022\u2022\u2022\u2022 ${lastDigits}`
    }), /* @__PURE__ */ jsxs(DivStyledFlex, {
      children: [/* @__PURE__ */ jsxs(DivStyledFlexText, {
        children: [/* @__PURE__ */ jsx(PStyledText, {
          "data-testid": "test-credit-card-name",
          isExpired: false,
          children: name
        }), /* @__PURE__ */ jsxs(PStyledText, {
          "data-testid": "test-credit-card-exp",
          isExpired,
          children: [`${expiresAt.month} / ${expiresAt.year}`, " ", isExpired && "*expired"]
        })]
      }), /* @__PURE__ */ jsx(Logo, {
        "data-testid": "test-credit-card-logo",
        size: "small",
        theme: brand
      })]
    })]
  });
};
const DivStyledCryptoCard$1 = styled$1.div`
  ${resetCSS};
  align-items: center;
  background: ${(props) => props.color};
  border-radius: 16px;
  border: 1px solid ${getShade("light", 10)};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  left: 20px;
  max-width: 256px;
  overflow: hidden;
  padding: 24px, 40px, 24px, 40px;
  position: relative;
  top: 20px;
  width: 100%;

  :after {
    content: '';
    display: block;
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transition: all 0.3s ease;
    width: 100%;
    z-index: 0;
  }

  :hover {
    box-shadow: 0px 0px 400px 400px rgba(4, 24, 54, 0.2) inset;
  }
  background: ${(props) => props.color};
`;
const DivStyledImage$1 = styled$1.div`
  flex-grow: 0;
  flex: none;
  height: 160px;
  left: 21px;
  order: 0;
  position: static;
  top: 0px;
  width: 120px;
`;
const DivStyledInfo$1 = styled$1.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex: none;
  height: 224px;
  left: 51.5px;
  margin: 16px 0px;
  order: 0;
  padding: 0px;
  position: static;
  top: 28px;
  width: 162px;
`;
const DivStyledLogo$1 = styled$1.div`
  border-radius: 0px;
  height: 136px;
`;
const DivStyledNetworkInfo$1 = styled$1.div`
  bottom: 0%;
  color: ${color.white};
  flex-grow: 0;
  flex: none;
  height: 64px;
  left: calc(50% - 162px / 2);
  margin: 0px 0px;
  order: 1;
  overflow: hidden;
  position: static;
  text-align: center;
  top: 71.43%;
  width: 100%;
`;
const DivStyledButton$1 = styled$1.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-grow: 0;
  flex: none;
  height: 40px;
  justify-content: center;
  left: 39px;
  margin: 16px 0px;
  order: 1;
  position: static;
  top: 268px;
  width: 187px;
`;
const PStyledChainName$1 = styled$1.p`
  ${fonts.openSans};
  ${fonts.textBold500};
  font-size: 32px;
  height: 55%;
  margin: 0;
  overflow: hidden;
  word-break: break-all;
`;
const PStyledNetwork$1 = styled$1.p`
  ${fonts.openSans};
  ${fonts.textBold700};
  font-size: 20px;
  height: 36px;
  line-height: 36px;
  margin: 0;
  overflow: hidden;
  word-break: break-all;
`;
var styles$g = {
  DivStyledCryptoCard: DivStyledCryptoCard$1,
  DivStyledButton: DivStyledButton$1,
  DivStyledImage: DivStyledImage$1,
  DivStyledInfo: DivStyledInfo$1,
  DivStyledLogo: DivStyledLogo$1,
  DivStyledNetworkInfo: DivStyledNetworkInfo$1,
  PStyledChainName: PStyledChainName$1,
  PStyledNetwork: PStyledNetwork$1
};
const {
  DivStyledCryptoCard,
  DivStyledButton,
  DivStyledImage,
  DivStyledInfo,
  DivStyledLogo,
  DivStyledNetworkInfo,
  PStyledChainName,
  PStyledNetwork
} = styles$g;
const CryptoCards = ({
  bgColor,
  btnText,
  chain,
  chainType,
  onClick,
  settingsIcon,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(DivStyledCryptoCard, {
    color: bgColor,
    "data-testid": "test-crypto-card",
    ...props,
    children: [/* @__PURE__ */ jsxs(DivStyledInfo, {
      children: [/* @__PURE__ */ jsx(DivStyledImage, {
        children: /* @__PURE__ */ jsx(DivStyledLogo, {
          children: /* @__PURE__ */ jsx(Illustration, {
            logo: chain
          })
        })
      }), /* @__PURE__ */ jsxs(DivStyledNetworkInfo, {
        children: [/* @__PURE__ */ jsx(PStyledChainName, {
          "data-testid": "test-crypto-card-name",
          children: `${chain.charAt(0).toUpperCase()}${chain.slice(1)}`
        }), /* @__PURE__ */ jsx(PStyledNetwork, {
          "data-testid": "test-crypto-card-network",
          children: chainType || "Network"
        })]
      })]
    }), /* @__PURE__ */ jsx(DivStyledButton, {
      "data-testid": "test-crypto-card-button",
      children: /* @__PURE__ */ jsx(Button, {
        icon: settingsIcon || /* @__PURE__ */ jsx(SvgCog, {
          title: "cog icon",
          titleId: "cryptoCards cog icon"
        }),
        onClick,
        text: btnText,
        theme: "translucent"
      })
    })]
  });
};
const SpanStyled$4 = styled$1.span`
  ${resetCSS};
  align-items: center;
  background-color: ${color.white};
  border-radius: 50%;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 5px;
  pointer-events: none;
  position: absolute;
  right: 10px;
  top: 0;
`;
const DivWrapperStyled$5 = styled$1.div`
    ${resetCSS}
    border-radius: 16px;
    display: flex;
    max-width: 100%;
    min-width: fit-content;
    outline: 1px solid;
    position: relative;
    transition: all 0.1s linear;

    outline-color: ${({ state }) => {
  switch (state) {
    case "error":
      return color.red;
    case "confirmed":
      return color.green;
    case "disabled":
      return color.greyDisabled;
    default:
      return color.greyLight;
  }
}};

    & > * > * > * {
        ${(p2) => p2.state === "disabled" && ` fill: ${color.greyDisabled};`};
    }

    &:hover {
        outline-color: ${(p2) => p2.state !== "disabled" && color.blue};

        strong {
            overflow: visible;
            text-overflow: unset;
            white-space: pre-wrap;
        }
    }

    &:hover > .input_prefixIcon > svg {
        fill: ${(p2) => !(p2 == null ? void 0 : p2.state) && color.blue};
    }

    input {
        & + label {
            color: ${({ state }) => {
  switch (state) {
    case "error":
      return color.red;
    case "confirmed":
      return color.green;
    case "disabled":
      return color.greyDisabled;
    default:
      return color.grey;
  }
}};
        }
    }

    &:hover {
        ${(p2) => p2.state === "error" && `outline-color: ${color.red};`}
        ${(p2) => p2.state === "confirmed" && `outline-color: ${color.green};`}

        label {
            ${(p2) => !(p2 == null ? void 0 : p2.state) && `color: ${color.blue};`}
        }
    }

    :not(&:focus-within) {
        &.input_filled {
            outline-color: ${color.blueSky} !important;
        }
    }

    &:focus-within,
    &.input_filled {
        outline: 2px solid ${color.blue};

        label {
            font-weight: 600;
            ${(p2) => !(p2 == null ? void 0 : p2.state) && `color: ${color.blue};`}
        }

        ${(p2) => p2.state === "error" && `outline-color: ${color.red};`}
        ${(p2) => p2.state === "confirmed" && `outline-color: ${color.green};`}
    }

    ${({ size: size2 }) => {
  switch (size2) {
    case "large":
      return Ce$1`
                    height: 56px;
                    padding: 14px 16px;
                    & > label {
                        top: 15px;
                    }
                `;
    case "regular":
    default:
      return Ce$1`
                    height: 40px;
                    padding: 8px 16px;
                    & > label {
                        top: 8px;
                    }
                `;
  }
}}
`;
const LabelStyled$a = styled$1.label`
    ${resetCSS}
    ${fonts.text}
    background-color: ${({ labelBgColor }) => labelBgColor || color.white};
    height: 24px;
    left: ${({ hasPrefix }) => hasPrefix ? "48px" : "16px"};
    pointer-events: none;
    position: absolute;
    transition: all 0.1s ease-out;
    z-index: 1;
`;
const InputStyled$6 = styled$1.input`
    ${resetCSS}
    ${fonts.text}
    background-color: transparent;
    overflow: hidden;
    transition: all 0.1s ease-out;
    width: 100%;
    ${(p2) => p2.customInput && "width: 0px; height:0px;"}

    &:focus,
    &:placeholder-shown,
    .input_filled & {
        + label {
            font-size: 14px;
            height: 18px;
            line-height: 1;
            padding: 2px 4px;
            top: -13px;
            left: 12px;
        }
    }

    &:focus {
        &::placeholder {
            display: none;
            visibility: visible;
            color: ${color.grey};
        }
    }

    &:-webkit-autofill,
    :-webkit-autofill:focus {
        transition: background-color 600000s 0s, color 600000s 0s;
    }
`;
const inputIconStyle = Ce$1`
    ${resetCSS}
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    max-width: 24px;
    width: 100%;

    & :first-child {
        fill: ${color.grey};
        transition: fill 0.2s ease-out;
        width: 100%;
        height: 100%;
    }
`;
const DivStyled$m = styled$1.div`
    ${inputIconStyle}
    margin-right: 12px;
`;
const CopyContainerStyled$1 = styled$1.div`
    height: 100%;
    justify-content: center;
    margin-left: 24px;
    max-width: 24px;
    position: relative;
    width: 100%;

    & :first-child {
        width: 100%;
        height: 100%;
    }

    &:before {
        border-left: 1px solid ${color.paleBlue2};
        content: '';
        height: 24px;
        left: -12px;
        position: absolute;
        width: 0;
    }
`;
const VisibilityIcon$1 = styled$1.button`
    ${resetButtonCSS}
    ${inputIconStyle}
    position: relative;
    margin-left: 12px;

    &:hover > svg {
        fill: ${color.blue};
    }
`;
const StrongStyled$2 = styled$1.strong`
    ${resetCSS}
    ${fonts.text}
    bottom: -23px;
    color: ${(props) => props.isError ? color.red : color.grey};
    font-size: 12px;
    height: 24px;
    left: 16px;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 26px);
`;
var InputStyles = {
  CopyContainerStyled: CopyContainerStyled$1,
  DivStyled: DivStyled$m,
  DivWrapperStyled: DivWrapperStyled$5,
  InputStyled: InputStyled$6,
  LabelStyled: LabelStyled$a,
  StrongStyled: StrongStyled$2,
  VisibilityIcon: VisibilityIcon$1
};
const {
  DivWrapperStyled: DivWrapperStyled$4,
  InputStyled: InputStyled$5,
  LabelStyled: LabelStyled$9,
  StrongStyled: StrongStyled$1
} = InputStyles;
const DatePicker = ({
  disabled = false,
  id,
  label,
  name = "Select a date",
  onChange,
  state = disabled ? "disabled" : void 0,
  type = "date",
  validation,
  value = new Date().toISOString().substring(0, type === "date" ? 10 : 7),
  ...props
}) => {
  const [current, setCurrent] = useState(value);
  const [currentState, setCurrentState] = useState(state);
  const [invalidMessage, setInvalidMessage] = useState("");
  useEffect(() => setCurrentState(state), [state]);
  const dateChanged = (event) => {
    var _a, _b, _c;
    setCurrent((_a = event == null ? void 0 : event.target) == null ? void 0 : _a.value);
    onChange && ((_b = event == null ? void 0 : event.target) == null ? void 0 : _b.valueAsDate) && onChange({
      date: (_c = event == null ? void 0 : event.target) == null ? void 0 : _c.valueAsDate,
      event
    });
  };
  const hasValidation = () => Boolean((validation == null ? void 0 : validation.required) || (validation == null ? void 0 : validation.max) || (validation == null ? void 0 : validation.min) || (validation == null ? void 0 : validation.required));
  const validate = (event) => {
    if (!hasValidation())
      return;
    if (!(event == null ? void 0 : event.target.checkValidity())) {
      setInvalidMessage(event == null ? void 0 : event.target.validationMessage);
      setCurrentState("error");
      return;
    }
    if (currentState === "error") {
      setCurrentState("confirmed");
      setTimeout(() => setCurrentState("initial"), 3e3);
    }
  };
  return /* @__PURE__ */ jsxs(DivWrapperStyled$4, {
    className: label && "input_filled",
    "data-testid": "test-date-picker",
    state: currentState,
    ...props,
    children: [/* @__PURE__ */ jsx(InputStyled$5, {
      "data-testid": "test-date-picker-input",
      disabled: currentState == "disabled",
      id,
      max: validation == null ? void 0 : validation.max,
      min: validation == null ? void 0 : validation.min,
      name,
      onBlur: (event) => validate(event),
      onChange: dateChanged,
      required: validation == null ? void 0 : validation.required,
      type,
      value: current
    }), label && /* @__PURE__ */ jsx(LabelStyled$9, {
      "data-testid": "test-date-picker-label",
      hasPrefix: false,
      htmlFor: id,
      labelBgColor: "white",
      children: label
    }), /* @__PURE__ */ jsx(SpanStyled$4, {
      "data-testid": "test-date-picker-icon",
      children: /* @__PURE__ */ jsx(SvgCalendar, {
        title: "calendar icon",
        titleId: "date picker calendar icon",
        fill: color.greyDark,
        fontSize: 22
      })
    }), currentState === "error" && /* @__PURE__ */ jsx(StrongStyled$1, {
      "data-testid": "test-date-picker-feedback",
      isError: false,
      children: invalidMessage
    })]
  });
};
const StyledSelectParentDiv = styled$1.div`
  ${resetCSS}
  display: flex;
  fill: ${color.grey};
  flex-direction: column;
  height: fit-content;
  position: relative;
  row-gap: 16px;
  ${(props) => props.isDisabled && "opacity: 50%;"}
`;
const DivStyledSelected = styled$1.div`
  border-radius: 16px;
  border: 1px solid ${(p2) => p2.hasOutline ? color.greyLight : "transparent"};
  color: ${color.blue};
  cursor: pointer;
  height: 40px;
  min-height: fit-content;
  min-width: fit-content;
  outline: 0px solid transparent;
  transition: all 0.3s ease;
  width: ${(props) => props.width};
  & > div {
    align-items: center;
    color: inherit;
    display: flex;
    gap: 2px;
    padding: 8px;
    transition: all 0.3s ease;
    & :nth-child(2) {
      margin-right: auto;
      white-space: nowrap;
    }
    & :nth-child(3) {
      margin-left: auto;
    }
  }
  &:hover {
    border-color: ${(p2) => p2.hasOutline ? color.blueSky : "transparent"};
  }
  &:focus {
    border: 2px solid ${color.blueSky};
  }
  ${(props) => props.isOpen && Ce$1`
      ${props.hasOutline && "outline: 4px solid rgba(158, 204, 234, 0.3)"};
      border-color: ${props.hasOutline ? color.blue : "transparent"};
    `};
`;
const DivStyledOptionsContainer = styled$1.div`
  background-color: #f2f6ff;
  border-radius: 16px;
  border: 2px solid ${color.blueSky};
  display: flex;
  flex-direction: column;
  margin-top: -8px;
  overflow: hidden;
  position: absolute;
  top: 56px;
  transition: all 0.3s ease;
  width: ${(props) => props.width};
  z-index: 999;
  display: ${(props) => !props.isOpen ? "none" : "block"};
`;
const DivInnerStyledOptionsContainer = styled$1.div`
  padding: 8px;
`;
const DivStyledOptionItem = styled$1.div`
  color: #041836;
  cursor: pointer;
  display: flex;
  grid-gap: 8px;
  padding: 6px 16px 6px 16px;
  transition: all 0.3s ease;
  &:hover {
    border-radius: 8px;
    background-color: #ebeff9;
  }
`;
const DivStyledNoData = styled$1.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px 0px;
`;
const Dropdown = ({
  defaultOptionIndex,
  dropdownArrowType = "normal",
  hasOutline = true,
  hideSelected = true,
  icon,
  isDisabled = false,
  isLabelFixed = true,
  isLabelVisible = true,
  label,
  onChange,
  options,
  selectedState,
  showSelected = true,
  width = "250px",
  ...props
}) => {
  var _a, _b, _c;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(defaultOptionIndex);
  useEffect(() => {
    if (isDisabled) {
      setIsOpen(false);
    }
  }, [isDisabled, isOpen]);
  useEffect(() => {
    if (typeof selectedState == "number") {
      setSelectedIndex(selectedState);
    }
  }, [selectedState, selectedIndex]);
  const handleSelectOptionClick = (selectedOption) => {
    setIsOpen(false);
    const indexOf = options.indexOf(selectedOption);
    setSelectedIndex(indexOf);
    onChange(selectedOption);
  };
  const RenderOptions = useCallback(() => {
    if (options.length == 0 || options.length == 1 && selectedIndex != null && hideSelected) {
      return /* @__PURE__ */ jsx(DivStyledOptionsContainer, {
        "data-testid": "test-dropdown-container",
        isOpen,
        width,
        ...props,
        children: /* @__PURE__ */ jsx(DivInnerStyledOptionsContainer, {
          children: /* @__PURE__ */ jsxs(DivStyledNoData, {
            "data-testid": "test-dropdown-data",
            children: [/* @__PURE__ */ jsx(Illustration, {
              logo: "looking",
              width: "100%",
              height: "100px"
            }), /* @__PURE__ */ jsx(Typography, {
              variant: "caption14",
              weight: "400",
              children: "No Data"
            })]
          })
        })
      });
    }
    return /* @__PURE__ */ jsx(DivStyledOptionsContainer, {
      "data-testid": "test-dropdown-options-container",
      isOpen,
      width,
      children: /* @__PURE__ */ jsx(DivInnerStyledOptionsContainer, {
        children: options.filter((optionItem) => options.indexOf(optionItem) != selectedIndex || !hideSelected).map((option) => /* @__PURE__ */ jsxs(DivStyledOptionItem, {
          onClick: () => {
            handleSelectOptionClick(option);
          },
          children: [option == null ? void 0 : option.prefix, isLabelVisible && /* @__PURE__ */ jsx(Typography, {
            variant: "caption14",
            weight: "400",
            color: "#041836",
            children: option.label
          })]
        }, option.id))
      })
    });
  }, [isOpen]);
  return /* @__PURE__ */ jsxs(StyledSelectParentDiv, {
    "data-testid": "test-dropdown",
    isDisabled,
    width,
    children: [/* @__PURE__ */ jsx(DivStyledSelected, {
      "data-testid": "test-dropdown-wrap",
      hasOutline,
      isOpen: !!isOpen,
      onClick: () => {
        if (!isDisabled) {
          setIsOpen(!isOpen);
        }
      },
      width,
      children: /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsxs("span", {
          "data-testid": "test-dropdown-icon",
          children: [icon && icon, typeof selectedIndex == "number" && ((_a = options[selectedIndex]) == null ? void 0 : _a.prefix) && ((_b = options[selectedIndex]) == null ? void 0 : _b.prefix)]
        }), isLabelVisible && /* @__PURE__ */ jsxs(Typography, {
          variant: "caption14",
          weight: "400",
          children: [(isLabelFixed || typeof selectedIndex != "number") && label, typeof selectedIndex === "number" && showSelected && ((_c = options[selectedIndex]) == null ? void 0 : _c.label)]
        }), dropdownArrowType === "normal" ? isOpen ? /* @__PURE__ */ jsx(SvgChevronUp, {
          title: "chevron up icon",
          titleId: "dropdown chevron up icon",
          fontSize: 24,
          style: {
            fill: "currentColor"
          }
        }) : /* @__PURE__ */ jsx(SvgChevronDown, {
          fontSize: 24,
          title: "chevron down icon",
          titleId: "dropdown chevron down icon",
          style: {
            fill: "currentColor"
          }
        }) : isOpen ? /* @__PURE__ */ jsx(SvgTriangleUp, {
          title: "triangle up icon",
          titleId: "dropdown triangle up icon",
          fontSize: 24,
          style: {
            fill: "currentColor"
          }
        }) : /* @__PURE__ */ jsx(SvgTriangleDown, {
          title: "triangle down icon",
          titleId: "dropdown triangle down icon",
          fontSize: 24,
          style: {
            fill: "currentColor"
          }
        })]
      })
    }), /* @__PURE__ */ jsx(RenderOptions, {})]
  });
};
const {
  CopyContainerStyled,
  DivStyled: DivStyled$l,
  DivWrapperStyled: DivWrapperStyled$3,
  InputStyled: InputStyled$4,
  LabelStyled: LabelStyled$8,
  StrongStyled,
  VisibilityIcon
} = InputStyles;
const Input = ({
  autoComplete = true,
  autoFocus = false,
  disabled = false,
  description,
  errorMessage = "Sorry this is not valid",
  hasCopyButton = false,
  id,
  ref,
  inputHidden = false,
  label,
  name,
  onChange,
  onBlur,
  placeholder = "",
  prefixIcon,
  size: size2 = "regular",
  state = disabled ? "disabled" : void 0,
  style,
  type = "text",
  validation,
  value = "",
  width = "320px",
  labelBgColor,
  iconPosition = "front",
  customInput,
  ...props
}) => {
  const [currentValue, setCurrentValue] = useState(value);
  const [currentState, setCurrentState] = useState(state);
  const [mainType, setMainType] = useState(type);
  const [isInputHidden, setIsInputHidden] = useState(inputHidden);
  const [invalidMessage, setInvalidMessage] = useState(errorMessage);
  useEffect(() => setIsInputHidden(type === "password"), [inputHidden]);
  useEffect(() => setCurrentState(state), [state]);
  useEffect(() => setMainType(type), [type]);
  useEffect(() => setCurrentValue(value), [value]);
  useEffect(() => setInvalidMessage(errorMessage), [errorMessage]);
  const valueChanged = (event) => {
    if (currentValue && (validation == null ? void 0 : validation.characterMaxLength)) {
      setCurrentValue(event.target.value.slice(0, validation == null ? void 0 : validation.characterMaxLength));
    } else {
      setCurrentValue(event.target.value);
    }
    onChange && onChange(event);
  };
  const canToggleHideInput = () => {
    return mainType === "password";
  };
  const toggleHideInput = () => {
    if (currentState === "disabled")
      return;
    setIsInputHidden(!isInputHidden);
  };
  const hasValidation = () => Boolean((validation == null ? void 0 : validation.required) || (validation == null ? void 0 : validation.numberMax) || (validation == null ? void 0 : validation.numberMin) || (validation == null ? void 0 : validation.characterMaxLength) || (validation == null ? void 0 : validation.characterMinLength) || (validation == null ? void 0 : validation.regExp));
  const validate = (event) => {
    onBlur && onBlur(event);
    if (!hasValidation())
      return;
    if (validation == null ? void 0 : validation.regExp) {
      const re2 = new RegExp(validation == null ? void 0 : validation.regExp);
      if (!re2.test(event == null ? void 0 : event.target.value)) {
        setInvalidMessage((validation == null ? void 0 : validation.regExpInvalidMessage) || (event == null ? void 0 : event.target.validationMessage) || errorMessage);
        setCurrentState("error");
        return;
      }
    }
    if (!(event == null ? void 0 : event.target.checkValidity())) {
      setInvalidMessage((event == null ? void 0 : event.target.validationMessage) || errorMessage);
      setCurrentState("error");
      return;
    }
    if (currentState === "error") {
      setCurrentState("confirmed");
      setTimeout(() => setCurrentState(void 0), 3e3);
    }
  };
  const isInputEmpty = useMemo(() => {
    if (typeof currentValue === "string") {
      return currentValue.length > 0;
    } else if (typeof currentValue === "number") {
      return true;
    } else
      return false;
  }, [currentValue]);
  return /* @__PURE__ */ jsxs(DivWrapperStyled$3, {
    className: `input input_${isInputEmpty ? "filled" : "empty"}`,
    "data-testid": "test-input",
    size: size2,
    state: currentState,
    style: {
      ...style,
      width
    },
    children: [prefixIcon && iconPosition == "front" && /* @__PURE__ */ jsx(DivStyled$l, {
      className: "input_prefixIcon",
      children: prefixIcon
    }), customInput && customInput, /* @__PURE__ */ jsx(InputStyled$4, {
      autoComplete: `${autoComplete}`,
      autoFocus,
      customInput,
      "data-testid": "test-input-input",
      disabled: currentState == "disabled",
      id,
      max: type === "number" ? validation == null ? void 0 : validation.numberMax : void 0,
      maxLength: validation == null ? void 0 : validation.characterMaxLength,
      min: type === "number" ? validation == null ? void 0 : validation.numberMin : void 0,
      minLength: validation == null ? void 0 : validation.characterMinLength,
      name,
      ref,
      onBlur: (event) => validate(event),
      onChange: (event) => valueChanged(event),
      pattern: validation == null ? void 0 : validation.regExp,
      placeholder,
      required: validation == null ? void 0 : validation.required,
      type: mainType !== "password" ? type : isInputHidden ? "password" : "text",
      value: currentValue,
      ...props
    }), label && /* @__PURE__ */ jsxs(LabelStyled$8, {
      "data-testid": "test-input-label",
      htmlFor: id,
      hasPrefix: typeof prefixIcon !== "undefined" && iconPosition == "front",
      labelBgColor,
      children: [label, (validation == null ? void 0 : validation.required) && "*"]
    }), currentState === "error" && /* @__PURE__ */ jsx(StrongStyled, {
      "data-testid": "test-input-feedback",
      isError: true,
      children: invalidMessage
    }), description && !(currentState === "error") && /* @__PURE__ */ jsx(StrongStyled, {
      "data-testid": "test-input-feedback",
      isError: false,
      children: description
    }), canToggleHideInput() && /* @__PURE__ */ jsx(VisibilityIcon, {
      className: "input_visibility",
      "data-testid": "test-input-icon-visibility",
      onClick: () => toggleHideInput(),
      type: "button",
      children: isInputHidden ? /* @__PURE__ */ jsx(SvgEyeClosed, {
        title: "eye closed icon",
        titleId: "input eye closed icon"
      }) : /* @__PURE__ */ jsx(SvgEye, {
        title: "eye icon",
        titleId: "input eye icon"
      })
    }), prefixIcon && iconPosition == "end" && /* @__PURE__ */ jsx(DivStyled$l, {
      className: "input_prefixIcon",
      "data-testid": "test-input-icon-prefix",
      children: prefixIcon
    }), hasCopyButton && /* @__PURE__ */ jsx(CopyContainerStyled, {
      "data-testid": "test-input-copy",
      children: /* @__PURE__ */ jsx(CopyButton, {
        text: currentValue
      })
    })]
  });
};
const FieldsetStyled$1 = styled$1.fieldset`
    ${resetCSS};
    display: flex;
    flex-direction: 'column';
    flex-wrap: wrap;
    overflow: hidden;
    position: relative;
`;
const LegendStyled$1 = styled$1.legend`
    ${resetCSS};
    ${fonts.heading}
    ${fonts.h3}
    color: ${color.grey};
    display: block;
    margin-bottom: 4px;
`;
const DivStyled$k = styled$1.div`
    opacity: ${(props) => props.disabled && 0.5};
    position: relative;
`;
const DivWrapperStyled$2 = styled$1.div`
    align-items: ${({ isRow }) => isRow ? "center" : "flex-start"};
    flex-direction: ${(p2) => p2.isRow ? "row" : "column"};
    gap: ${(p2) => p2.isRow && "12px"};
    display: flex;
    flex-wrap: wrap;
`;
const LabelStyled$7 = styled$1.label`
    ${resetCSS};
    /* ${fonts.heading} */
    ${fonts.text}
    padding-left: ${(p2) => p2.isCreditCardMode ? "0" : "28px"};
    align-content: center;
    color: ${color.greyDark};
    display: flex;
    line-height: 20px;
    margin-bottom: 12px;
    position: relative;
    width: fit-content;

    &:before {
        left: ${(p2) => p2.isCreditCardMode ? "20px" : "0"};
        top: ${(p2) => p2.isCreditCardMode ? "20px" : "0"};
        background-color: ${color.blueLight};
        border-radius: 50%;
        border: 1px solid ${color.blueSky};
        content: '';
        display: block;
        height: 18px;
        position: absolute;
        transition: all 0.1s ease-out;
        width: 18px;
    }

    &:after {
        left: ${(p2) => p2.isCreditCardMode ? "26px" : "6px"};
        top: ${(p2) => p2.isCreditCardMode ? "26px" : "6px"};
        background-color: ${color.white};
        border-radius: 50%;
        content: '';
        display: block;
        height: 8px;
        opacity: 0;
        position: absolute;
        transition: all 0.2s ease-out;
        width: 8px;
    }

    &:hover {
        &:before {
            filter: brightness(95%);
        }
    }

    &:active {
        &:before {
            filter: brightness(90%);
        }
    }
`;
const RadioButtonStyled$1 = styled$1.input`
    position: absolute;

    &:checked {
        & + label {
            &:before {
                background-color: ${color.green};
                border-color: ${color.greenLight};
            }
            &:after {
                opacity: 1;
            }
        }
    }
`;
var styles$f = {
  DivStyled: DivStyled$k,
  DivWrapperStyled: DivWrapperStyled$2,
  FieldsetStyled: FieldsetStyled$1,
  LabelStyled: LabelStyled$7,
  LegendStyled: LegendStyled$1,
  RadioButtonStyled: RadioButtonStyled$1
};
const {
  DivStyled: DivStyled$j,
  DivWrapperStyled: DivWrapperStyled$1,
  FieldsetStyled,
  LabelStyled: LabelStyled$6,
  LegendStyled,
  RadioButtonStyled
} = styles$f;
const Radios = ({
  disabled = false,
  id,
  isRow = false,
  items,
  onBlur,
  onChange,
  onCreditCardRemoved,
  ref,
  selectedState,
  setWhichIsChecked,
  suffix,
  title,
  validation,
  ...props
}) => {
  const formattedID = id == null ? void 0 : id.replace(/\s/g, "-");
  const isCreditCards = Boolean(typeof items[0] === "object");
  const [whichIsChecked, setChecked] = useState(setWhichIsChecked || items.length);
  useEffect(() => {
    if (typeof selectedState != "undefined") {
      setChecked(selectedState);
    }
  }, [selectedState]);
  const renderCreditCard = (item, arrayIndex) => /* @__PURE__ */ jsx(CreditCard, {
    ...item,
    onRemove: () => onCreditCardRemoved && onCreditCardRemoved(arrayIndex)
  });
  return /* @__PURE__ */ jsxs(FieldsetStyled, {
    id: `${formattedID}`,
    "data-testid": "test-radios",
    children: [title && /* @__PURE__ */ jsx(LegendStyled, {
      "data-testid": "test-radios-legend",
      children: title
    }), /* @__PURE__ */ jsxs(DivWrapperStyled$1, {
      isRow,
      children: [items.map((item, i) => /* @__PURE__ */ jsxs(DivStyled$j, {
        disabled,
        children: [/* @__PURE__ */ jsx(RadioButtonStyled, {
          checked: i === whichIsChecked,
          "data-testid": `test-radios-input-${i}`,
          id: `${formattedID}_${i}`,
          ref,
          name: `${formattedID}_group`,
          onChange: (e2) => {
            if (disabled) {
              return;
            }
            onChange(e2);
            if (typeof selectedState == "undefined") {
              setChecked(i);
            }
          },
          onBlur: (e2) => onBlur && onBlur(e2),
          required: validation == null ? void 0 : validation.required,
          type: "radio",
          value: i,
          ...props
        }), /* @__PURE__ */ jsx(LabelStyled$6, {
          "data-testid": `test-radios-label-${i}`,
          htmlFor: `${formattedID}_${i}`,
          isCreditCardMode: isCreditCards,
          role: "label",
          children: typeof item === "string" ? item : renderCreditCard(item, i)
        })]
      }, `${formattedID}_${i}`)), suffix && /* @__PURE__ */ jsx("span", {
        "data-testid": "test-radios-suffix",
        children: suffix
      })]
    })]
  });
};
const DivStyledWrapper$5 = styled$1.div`
    ${resetCSS};
    display: inline-block;
    position: relative;
`;
const LabelStyled$5 = styled$1.label`
  ${resetCSS}
  ${fonts.text}
    background-color: ${color.white};
  height: 24px;
  left: ${({ hasPrefixIcon, hasSelectedIndex }) => hasPrefixIcon && !hasSelectedIndex ? 50 : 12}px;
  line-height: 1;
  pointer-events: none;
  position: absolute;
  padding: 0 4px;
  transition: all 0.1s ease-out;
  ${({ hasSelectedIndex }) => hasSelectedIndex ? "top: -9px; font-size: 14px;" : "top: 20px;"};
`;
const PrefixSpan$1 = styled$1.span`
    margin-right: px;
`;
const SelectedItem$1 = styled$1.div`
    ${resetCSS};
    ${fonts.text};
    background-color: ${color.white};
    border-radius: 16px;
    border: 2px solid;
    cursor: pointer;
    display: flex;
    height: 56px;
    overflow: hidden;
    padding: 14px 50px 14px 16px;
    transition: all 0.1s linear;

    border-color: ${({ state }) => {
  switch (state) {
    case "error":
      return color.red;
    case "confirmed":
      return color.green;
    case "disabled":
      return color.greyDisabled;
    default:
      return color.greyLight;
  }
}};

    ${({ hasPrefixIcon }) => hasPrefixIcon && "gap: 13px"};

    ${({ state }) => state === "disabled" && `& * {fill: ${color.greyDisabled};} color: ${color.greyDisabled} !important;`};

    &:hover {
        border-color: ${(p2) => p2.state !== "disabled" && color.blueSky};
    }

    &:focus {
        border-color: ${color.blue};

        & + label {
            color: ${color.blue};
        }
    }

    &:hover {
        ${(p2) => p2.state === "error" && `border-color: ${color.red};`}
        ${(p2) => p2.state === "confirmed" && `border-color: ${color.green};`}

        & + label {
            ${(p2) => !(p2 == null ? void 0 : p2.state) && `color: ${color.blue};`}
        }
    }

    &:focus {
        ${(p2) => p2.state === "error" && `border-color: ${color.red};`}
        ${(p2) => p2.state === "confirmed" && `border-color: ${color.green};`}
        & + label {
            ${(p2) => p2.state === "error" && `color: ${color.red};`}
            ${(p2) => p2.state === "confirmed" && `color: ${color.green};`}
        }
    }

    & + label {
        color: ${({ state }) => {
  switch (state) {
    case "error":
      return color.red;
    case "confirmed":
      return color.green;
    case "disabled":
      return color.greyDisabled;
    default:
      return color.grey;
  }
}};
    }
`;
const iconStyle = Ce$1`
    align-items: center;
    display: flex;
    justify-content: center;
    max-height: 24px;
    max-width: 24px;
    width: 100%;
`;
const PrefixIcon$1 = styled$1.div`
    ${resetCSS}
    ${iconStyle}
    margin-right: 13px;
    & :first-child {
        width: 100%;
        height: 100%;
    }
`;
const DropDownIcon$1 = styled$1.div`
    ${iconStyle};
    position: absolute;
    right: 16px;
`;
const ErrorLabel$1 = styled$1.label`
    ${resetCSS}
    ${fonts.text}
    bottom: -23px;
    color: ${color.red};
    font-size: 12px;
    height: 24px;
    left: 16px;
    pointer-events: none;
    position: absolute;
`;
const Options$1 = styled$1.div`
  ${resetCSS}
  ${fonts.text}
    background-color: ${color.blueLight};
  border-radius: 16px;
  border: 2px solid ${color.blueSky};
  left: 0;
  margin-top: 10px;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 10;
  max-height: 265px;
  overflow: auto;

  &::-webkit-scrollbar {
    background: none;
    height: 0;
    width: 20px;
  }
  &::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    background-color: ${color.greyIcons};
    border-radius: 30px;
    border: 8px solid transparent;
  }
  &::-webkit-scrollbar-button {
    display: none;
  }
  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
const Option$1 = styled$1.div`
    ${resetCSS};
    align-items: center;
    cursor: pointer;
    display: flex;
    padding: 14px 50px 14px 16px;
    &:hover {
        background-color: rgba(128, 128, 128, 0.1);
    }
    &:first-child {
        border-top-right-radius: 7px;
        border-top-left-radius: 7px;
    }
    &:last-child {
        border-bottom-right-radius: 7px;
        border-bottom-left-radius: 7px;
    }
`;
const NoDataTextStyled$1 = styled$1.p`
    text-align: center;
    margin-top: -12px;
    margin-bottom: 5px;
`;
const DivStyledDescription$3 = styled$1.div`
    ${resetCSS};
    ${fonts.text};
    bottom: -23px;
    color: ${color.grey};
    font-size: 12px;
    height: 24px;
    left: 16px;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 26px);
`;
var SelectStyles = {
  DivStyledDescription: DivStyledDescription$3,
  DivStyledWrapper: DivStyledWrapper$5,
  DropDownIcon: DropDownIcon$1,
  ErrorLabel: ErrorLabel$1,
  LabelStyled: LabelStyled$5,
  NoDataTextStyled: NoDataTextStyled$1,
  Option: Option$1,
  Options: Options$1,
  PrefixIcon: PrefixIcon$1,
  PrefixSpan: PrefixSpan$1,
  SelectedItem: SelectedItem$1
};
const {
  DivStyledDescription: DivStyledDescription$2,
  DivStyledWrapper: DivStyledWrapper$4,
  DropDownIcon,
  ErrorLabel,
  LabelStyled: LabelStyled$4,
  NoDataTextStyled,
  Option,
  Options,
  PrefixIcon,
  PrefixSpan,
  SelectedItem
} = SelectStyles;
const Select$1 = ({
  customNoDataText = "No Data",
  defaultOptionIndex,
  description,
  disabled = false,
  errorMessage = "",
  id = String(Date.now()),
  label,
  onBlurTraditional,
  onChange,
  onChangeTraditional,
  options = [],
  prefixIcon,
  prefixText,
  ref,
  refTraditional,
  state = disabled ? "disabled" : void 0,
  style,
  traditionalHTML5 = false,
  validation,
  value,
  width = "200px",
  ...props
}) => {
  var _a, _b, _c;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(defaultOptionIndex);
  const toggling = (event) => {
    if (disabled)
      return;
    setIsOpen(!isOpen);
    event.stopPropagation();
  };
  const onOptionClicked = (selectedIndex) => () => {
    setSelectedOptionIndex(selectedIndex);
    setIsOpen(false);
    if (onChange) {
      onChange(options[selectedIndex]);
    }
  };
  useEffect(() => {
    const handleClickOutside = () => {
      setIsOpen(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (value) {
      const valueOptionItem = options.find((optionItem) => optionItem.id == value);
      setSelectedOptionIndex(valueOptionItem ? options.indexOf(valueOptionItem) : 0);
    }
  }, [selectedOptionIndex, value]);
  return /* @__PURE__ */ jsxs(DivStyledWrapper$4, {
    "aria-label": "select",
    "data-testid": "test-select",
    id,
    ref,
    state,
    style: {
      ...style,
      width
    },
    ...props,
    children: [/* @__PURE__ */ jsxs(SelectedItem, {
      "aria-label": "option-selected",
      "data-testid": "test-select-selected",
      onClick: toggling,
      state,
      hasPrefixIcon: Boolean(prefixIcon),
      children: [prefixIcon && prefixIcon, typeof selectedOptionIndex !== "undefined" && /* @__PURE__ */ jsxs(Fragment, {
        children: [prefixText && /* @__PURE__ */ jsx(PrefixSpan, {
          children: prefixText
        }), ((_a = options[selectedOptionIndex]) == null ? void 0 : _a.prefix) && !Boolean(prefixIcon) && /* @__PURE__ */ jsx(PrefixIcon, {
          children: (_b = options[selectedOptionIndex]) == null ? void 0 : _b.prefix
        }), (_c = options[selectedOptionIndex]) == null ? void 0 : _c.label]
      }), /* @__PURE__ */ jsx(DropDownIcon, {
        "data-testid": "test-select-icon",
        children: isOpen ? /* @__PURE__ */ jsx(SvgTriangleUp, {
          title: "triangle up icon",
          titleId: "select triangle up icon",
          fill: color.grey
        }) : /* @__PURE__ */ jsx(SvgTriangleDown, {
          title: "triangle down icon",
          titleId: "select triangle down icon",
          fill: color.grey
        })
      })]
    }), label && /* @__PURE__ */ jsx(LabelStyled$4, {
      "data-testid": "test-select-label",
      htmlFor: id,
      hasSelectedIndex: typeof selectedOptionIndex !== "undefined",
      hasPrefixIcon: Boolean(prefixIcon),
      children: label
    }), isOpen && /* @__PURE__ */ jsx(Options, {
      "aria-label": "select-options",
      "data-testid": "test-select-options",
      children: (options == null ? void 0 : options.length) ? options.map((option, i) => i !== selectedOptionIndex && /* @__PURE__ */ jsxs(Option, {
        "aria-label": "select-option",
        "data-testid": `test-seclect-option-${i}`,
        id: option.id.toString(),
        onClick: onOptionClicked(i),
        children: [option.prefix && /* @__PURE__ */ jsx(PrefixIcon, {
          children: option.prefix
        }), option == null ? void 0 : option.label]
      }, option == null ? void 0 : option.label)) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(Illustration, {
          height: "60px",
          logo: "servers",
          width: "100%"
        }), /* @__PURE__ */ jsx(NoDataTextStyled, {
          children: customNoDataText
        })]
      })
    }), state === "error" && errorMessage ? /* @__PURE__ */ jsx(ErrorLabel, {
      children: errorMessage
    }) : description && /* @__PURE__ */ jsx(DivStyledDescription$2, {
      children: description
    })]
  });
};
const SelectStyled$1 = styled$1.select`
    ${resetCSS}
    ${fonts.text}
    background-color: transparent;
    overflow: hidden;
    transition: all 0.1s ease-out;
    width: 100%;

    &:focus,
    .input_filled & {
        + label {
            font-size: 14px;
            height: 18px;
            line-height: 1;
            padding: 2px 4px;
            top: -13px;
            left: 12px;
        }
    }
`;
const DivStyledDescription$1 = styled$1.div`
    ${resetCSS};
    ${fonts.text};
    bottom: -23px;
    color: ${color.grey};
    font-size: 12px;
    height: 24px;
    left: 16px;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 26px);
`;
var TraditionalSelectStyles = {
  DivStyledDescription: DivStyledDescription$1,
  SelectStyled: SelectStyled$1
};
const {
  DivWrapperStyled,
  LabelStyled: LabelStyledTrad
} = InputStyles;
const {
  DivStyledDescription,
  SelectStyled
} = TraditionalSelectStyles;
const TraditionalSelect = ({
  customNoDataText = "No Data",
  defaultOptionIndex,
  description,
  disabled = false,
  errorMessage = "",
  id = String(Date.now()),
  label,
  onBlurTraditional,
  onChange,
  onChangeTraditional,
  options = [],
  prefixIcon,
  prefixText,
  ref,
  refTraditional,
  state = disabled ? "disabled" : void 0,
  style,
  traditionalHTML5 = false,
  validation,
  value,
  width = "200px",
  ...props
}) => {
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(defaultOptionIndex);
  useEffect(() => {
    if (value) {
      const valueOptionItem = options.find((optionItem) => optionItem.id == value);
      setSelectedOptionIndex(valueOptionItem ? options.indexOf(valueOptionItem) : 0);
    }
  }, [selectedOptionIndex, value]);
  return /* @__PURE__ */ jsxs(DivWrapperStyled, {
    className: "input_filled",
    "data-testid": "test-select",
    style: {
      ...style,
      width
    },
    ...props,
    children: [/* @__PURE__ */ jsxs(SelectStyled, {
      "data-testid": "test-select-select",
      defaultValue: "Please choose",
      id,
      ref: refTraditional,
      onChange: (event) => onChangeTraditional && onChangeTraditional(event),
      onBlur: (event) => onBlurTraditional && onBlurTraditional(event),
      required: validation == null ? void 0 : validation.required,
      children: [/* @__PURE__ */ jsx("option", {
        disabled: true,
        children: "Please choose"
      }), options.map((option, i) => i !== selectedOptionIndex && /* @__PURE__ */ jsx("option", {
        "data-testid": `test-seclect-option-${i}`,
        id: String(option == null ? void 0 : option.id),
        children: option == null ? void 0 : option.label
      }, option == null ? void 0 : option.id))]
    }), label && /* @__PURE__ */ jsx(LabelStyledTrad, {
      "data-testid": "test-select-label",
      hasPrefix: false,
      htmlFor: id,
      children: label
    }), description && /* @__PURE__ */ jsx(DivStyledDescription, {
      "data-testid": "test-select-description",
      children: description
    })]
  });
};
var KEY = /* @__PURE__ */ ((KEY2) => {
  KEY2["DOWN"] = "ArrowDown";
  KEY2["END"] = "End";
  KEY2["ENTER"] = "Enter";
  KEY2["ESC"] = "Escape";
  KEY2["HOME"] = "Home";
  KEY2["TAB"] = "Tab";
  KEY2["UP"] = "ArrowUp";
  return KEY2;
})(KEY || {});
const DivStyledWrapper$3 = styled$1.div`
    ${resetCSS};
    --arrow-width: 2.5em;
    --checkbox-width: 2em;
    display: block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial,
        sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
    font-size: 0.88em;
    line-height: 1;
    margin-bottom: 5px;
    &[aria-expanded='true'] {
        border-color: ${color.blueSky};
        & .w3uik__dropdown-wrapper {
            display: block;
        }

        .w3uik__select-overlay {
            display: block;
        }
    }
`;
const DivStyledSelectWrapper$1 = styled$1.div`
    background-color: ${color.white};
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    min-height: ${(p2) => {
  var _a;
  return (_a = p2.height) != null ? _a : "40px";
}};
    padding: 8px 20px 8px 10px;
    position: relative;
    transition: all 0.1s linear;
`;
const LabelStyled$3 = styled$1.label`
    ${resetCSS};
    background-color: ${color.white};
    color: ${color.grey};
    font-weight: 500;
    font-size: 14px;
    height: 24px;
    left: 12px;
    line-height: 1;
    padding: 0 4px;
    pointer-events: none;
    position: absolute;
    top: -9px;
    transition: all 0.1s ease-out;
    z-index: 10;
    &[aria-disabled='true'] {
        color: ${color.greyLight};
    }
`;
const ButtonStyledSelect$1 = styled$1.button`
    appearance: none;
    background: none;
    border: 1px solid ${color.greyLight};
    border-radius: 16px;
    box-sizing: border-box;
    color: black;
    font-size: 1em;
    height: 100%;
    left: 0;
    padding: 0;
    position: absolute;
    flex-grow: 1;
    text-align: left;
    top: 0;
    transition: border-color 150ms linear;
    width: 100%;
    z-index: 3;

    &[aria-expanded='true'],
    &:focus:enabled {
        border-color: ${color.blueSky};
        outline: none;
        /* On Tab - set box shadow */
        -webkit-box-shadow: 0px 0px 0px 2px ${color.blueSky};
        -moz-box-shadow: 0px 0px 0px 2px ${color.blueSky};
        box-shadow: 0px 0px 0px 2px ${color.blueSky};
        label {
            color: ${color.blue};
        }
    }

    &:hover:enabled {
        border-color: ${color.blueSky};
        label {
            color: ${color.blue};
        }
    }

    :disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;
const ListStyledSelected$1 = styled$1.ul`
    display: flex;
    flex-wrap: wrap;
    font-family: inherit;
    grid-auto-flow: column;
    grid-gap: 0.5em;
    left: 0.5em;
    list-style: none;
    margin: 0;
    max-width: calc(100% - var(--arrow-width));
    padding-bottom: 2px;
    padding-left: 0;
    padding-top: 2px;
    position: relative;
    z-index: 10;
    &[aria-disabled='true'] {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;
const ListItemStyledTag$1 = styled$1.li`
    display: flex;
    z-index: -10;
    align-items: center;
    width: 100%;
    line-break: loose;
`;
const DivStyledPlaceholder$1 = styled$1.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-family: inherit;
    grid-auto-flow: column;
    grid-gap: 0.5em;
    left: 0.5em;
    list-style: none;
    margin: 0;
    max-width: calc(100% - var(--arrow-width));
    opacity: 0.6;
    padding-bottom: 0;
    padding-left: 0;
    padding-top: 0;
    pointer-events: none;
    position: relative;
    z-index: 10;
`;
const DivStyledOverlay$1 = styled$1.div`
    bottom: 0;
    display: none;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
`;
const MenuStyledWrapper$1 = styled$1.menu`
    display: none;
    margin: 0;
    margin-top: 5px;
    padding: 0;
    position: relative;
    z-index: 3;
`;
const DivStyledDropdown$1 = styled$1.div`
    background: ${color.blueLight};
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 20;
    border: 2px solid ${color.blueSky};
    border-radius: 16px;
`;
const InputStyledSearch$1 = styled$1.input`
    background-color: ${color.blueLight};
    appearance: none;
    border: 0;
    border-bottom: 1px solid ${color.paleBlue2};
    border-radius: 16px 16px 0 0;
    color: ${color.blueDark};
    display: block;
    font-family: inherit;
    font-size: 1em;
    padding-bottom: 1em;
    padding-left: 3em;
    padding-right: 0.5em;
    padding-top: 1em;
    width: 100%;

    &[aria-hidden='true'] {
        // Use position to hide input - this helps to make arrow keys functional
        position: absolute;
        right: 200vw;
        & + .w3uik__search-icon {
            display: none;
        }
    }
    &:focus {
        outline: none;
    }
`;
const ListStyledDropdown$1 = styled$1.ul`
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    box-shadow: 0 4px 8px rgba(248, 174, 174, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    list-style: none;
    margin: 0;
    max-height: ${(p2) => {
  var _a;
  return (_a = p2.height) != null ? _a : "200px";
}};
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0;

    // Scrollbar in options
    &::-webkit-scrollbar {
        background: none;
        height: 0;
        width: 10px;
    }
    &::-webkit-scrollbar-thumb {
        background-clip: padding-box;
        background-color: ${color.greyIcons};
        border-radius: 30px;
        border: 4px solid transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
    &::-webkit-scrollbar-corner {
        background-color: transparent;
    }

    // For 1st option in list - first child is input so select 2nd child
    :nth-child(2),
    :nth-child(2):hover,
    :nth-child(2):focus {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
    }

    // For Last option in list
    :last-child,
    :last-child:hover,
    :last-child:focus {
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
    }
`;
const ListItemStyledDropdown$1 = styled$1.li`
    display: block;
    margin: 0;
    padding: 0;
    background-color: transparent;
`;
const SpanStyledItemIcon$2 = styled$1.span`
    align-items: center;
    display: flex;
    height: 24px;
    justify-content: center;
    margin: 0 4px;
    padding: 0 5px;
    width: 24px;
    // Any component(svg/img) used as icon will have a common width
    * {
        height: 100%;
        object-fit: contain;
        width: 24px !important;
    }
`;
const SpanStyledItemText$1 = styled$1.span`
    margin-left: ${(p2) => p2.noPrefix ? "10px" : "0px"};
`;
const SpanStyledItemSelected$1 = styled$1.span`
    overflow: hidden;
    white-space: pre;
    text-overflow: ellipsis;
    color: ${color.grey};
`;
const ButtonStyledListItem$1 = styled$1.button`
    align-items: center;
    appearance: none;
    background: none;
    border: none;
    color: ${color.blueDark};
    display: flex;
    padding-bottom: 0.375em;
    padding-left: 0.5em;
    padding-right: 0.5em;
    padding-top: 0.375em;
    text-align: left;
    transition-duration: 150ms;
    transition-property: background-color, color;
    transition-timing-function: linear;
    width: 100%;

    &::before {
        content: '';
        display: flex;
        height: 3em;
        justify-content: center;
    }

    // Option Selected Styles
    &[aria-selected='true'] {
        color: ${color.blueDark2};
        &::before {
            background-size: contain;
            content: '';
        }
    }

    &:hover {
        background: ${color.beauBlue};
    }

    &[data-highlighted='true'],
    &:focus {
        background: ${color.beauBlue};
        outline: none;
    }

    &[disabled] {
        color: ${color.grey};
        cursor: not-allowed;
    }
`;
const SpanStyledNoResults$1 = styled$1.span`
    display: block;
    color: ${color.grey};
    padding: 1em;
    text-align: center;
`;
const DivStyledDesc$1 = styled$1.div`
    color: ${color.grey};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    overflow: hidden;
    padding: 4px 4px;
    position: absolute;
    text-overflow: ellipsis;
    top: 100%;
    white-space: nowrap;
    width: 90%;
    &:hover {
        overflow: visible;
        white-space: normal;
    }
    &[aria-invalid='true'] {
        color: ${color.red};
    }
`;
const SearchIconStyled$1 = styled$1(SvgSearch)`
    background-size: contain;
    height: 1em;
    pointer-events: none;
    position: absolute;
    left: 0.5em;
    top: 1em;
    transform: translateY(-50%);
    width: 1em;
`;
const TriangleDownIconStyled$1 = styled$1(SvgTriangleDown)`
    color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: var(--arrow-width);
`;
const TriangleUpIconStyled$1 = styled$1(SvgTriangleUp)`
    color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: var(--arrow-width);
`;
const CheckmarkIconStyled$1 = styled$1(SvgCheckmark)`
    color: ${color.green};
    margin-left: auto;
    flex-shrink: 0;
    display: none;
    height: 12px;
    width: 12px;
    &[aria-selected='true'] {
        display: block;
    }
`;
var styles$e = {
  ButtonStyledListItem: ButtonStyledListItem$1,
  ButtonStyledSelect: ButtonStyledSelect$1,
  CheckmarkIconStyled: CheckmarkIconStyled$1,
  DivStyledDesc: DivStyledDesc$1,
  DivStyledDropdown: DivStyledDropdown$1,
  DivStyledOverlay: DivStyledOverlay$1,
  DivStyledPlaceholder: DivStyledPlaceholder$1,
  DivStyledSelectWrapper: DivStyledSelectWrapper$1,
  DivStyledWrapper: DivStyledWrapper$3,
  InputStyledSearch: InputStyledSearch$1,
  LabelStyled: LabelStyled$3,
  ListItemStyledDropdown: ListItemStyledDropdown$1,
  ListItemStyledTag: ListItemStyledTag$1,
  ListStyledDropdown: ListStyledDropdown$1,
  ListStyledSelected: ListStyledSelected$1,
  MenuStyledWrapper: MenuStyledWrapper$1,
  SearchIconStyled: SearchIconStyled$1,
  SpanStyledItemIcon: SpanStyledItemIcon$2,
  SpanStyledItemSelected: SpanStyledItemSelected$1,
  SpanStyledItemText: SpanStyledItemText$1,
  SpanStyledNoResults: SpanStyledNoResults$1,
  TriangleDownIconStyled: TriangleDownIconStyled$1,
  TriangleUpIconStyled: TriangleUpIconStyled$1
};
function escapeRegex(val) {
  return val.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
const {
  ButtonStyledListItem,
  CheckmarkIconStyled,
  DivStyledDropdown,
  InputStyledSearch,
  ListItemStyledDropdown,
  ListStyledDropdown,
  MenuStyledWrapper,
  SearchIconStyled,
  SpanStyledItemIcon: SpanStyledItemIcon$1,
  SpanStyledItemText,
  SpanStyledNoResults
} = styles$e;
const SelectMenuList = ({
  addItem,
  customNoDataText,
  elementId,
  isMulti,
  isOpen,
  isSearch = true,
  max,
  menuHeight = "200px",
  options = [],
  setIsOpen,
  value = []
}) => {
  const listRef = useRef(null);
  const searchRef = useRef(null);
  const [activeDescendantIndex, setActiveDescendantIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const visibleIndices = [];
  const visibleOptions = [];
  options.forEach((option, index) => {
    if (new RegExp(escapeRegex(searchTerm), "i").test(option.label)) {
      visibleOptions.push(option);
      visibleIndices.push(index);
    }
  });
  const shouldDisplaySearch = isSearch === true && options.length > 4;
  const isMaxed = value.length === max;
  const optionId = (option) => {
    if (option === void 0)
      return;
    return elementId(`option-${option}`);
  };
  const scrollTo = (wrapper, selector) => {
    if (wrapper) {
      const el = wrapper.querySelector(selector);
      if (el) {
        el.scrollIntoView(false);
      }
    }
  };
  const onKeyDown = (evt) => {
    var _a, _b, _c;
    const first = visibleIndices[0];
    const last = visibleIndices[visibleIndices.length - 1];
    switch (evt.key) {
      case KEY.ENTER: {
        evt.preventDefault();
        addItem((_a = options[activeDescendantIndex]) == null ? void 0 : _a.id);
        break;
      }
      case KEY.DOWN:
      case KEY.UP: {
        evt.preventDefault();
        const sum = evt.key === KEY.UP ? -1 : 1;
        const fallback = evt.key === KEY.UP ? last : first;
        const nextIndex = visibleIndices.indexOf(activeDescendantIndex) + sum;
        const next = (_b = visibleIndices[nextIndex] !== void 0 ? visibleIndices[nextIndex] : fallback) != null ? _b : 0;
        setActiveDescendantIndex(next);
        scrollTo(listRef.current, `#${optionId(next)}`);
        break;
      }
      case KEY.END:
      case KEY.HOME: {
        const next = (_c = evt.key === KEY.HOME ? first : last) != null ? _c : 0;
        setActiveDescendantIndex(next);
        scrollTo(listRef.current, `#${optionId(next)}`);
        break;
      }
      case KEY.ESC:
        setIsOpen(false);
        break;
      case KEY.TAB:
        setIsOpen(false);
        break;
      default:
        if (!isSearch) {
          evt.preventDefault();
        }
        break;
    }
  };
  useEffect(() => {
    if (searchRef.current && isOpen) {
      searchRef.current.focus();
    }
  });
  useEffect(() => {
    var _a;
    if (visibleIndices.indexOf(activeDescendantIndex) === -1) {
      setActiveDescendantIndex((_a = visibleIndices[0]) != null ? _a : 0);
    }
  }, [activeDescendantIndex, visibleIndices]);
  return /* @__PURE__ */ jsx(MenuStyledWrapper, {
    id: elementId("menu"),
    className: "w3uik__dropdown-wrapper",
    "aria-label": "select-options",
    "data-testid": "test-select-options",
    children: /* @__PURE__ */ jsxs(DivStyledDropdown, {
      children: [/* @__PURE__ */ jsx(InputStyledSearch, {
        "aria-activedescendant": optionId(activeDescendantIndex),
        "aria-hidden": shouldDisplaySearch === false || void 0,
        "aria-label": "Filter Options",
        onChange: (e2) => setSearchTerm(e2.target.value),
        onKeyDown,
        ref: searchRef,
        type: "search",
        value: searchTerm,
        "data-testid": "test-select-search-input"
      }), shouldDisplaySearch && /* @__PURE__ */ jsx(SearchIconStyled, {
        className: "w3uik__search-icon",
        fontSize: 22,
        fill: color.blue
      }), /* @__PURE__ */ jsxs(ListStyledDropdown, {
        ref: listRef,
        height: menuHeight,
        children: [visibleOptions.map((option, index) => {
          const isSelected = isMulti ? value.indexOf(option.id) !== -1 : value === option.id;
          let ariaSelected = isSelected;
          if (ariaSelected === false && isMaxed === true) {
            ariaSelected = void 0;
          }
          return /* @__PURE__ */ jsx(ListItemStyledDropdown, {
            "aria-label": "select-option",
            "data-testid": `test-select-option-${index}`,
            children: /* @__PURE__ */ jsxs(ButtonStyledListItem, {
              "aria-selected": ariaSelected,
              "data-highlighted": activeDescendantIndex === visibleIndices[index] || void 0,
              disabled: isMaxed && !isSelected,
              id: optionId(visibleIndices[index]),
              onClick: () => addItem(option.id),
              role: "option",
              type: "button",
              children: [option.prefix && /* @__PURE__ */ jsx(SpanStyledItemIcon$1, {
                children: option.prefix
              }), /* @__PURE__ */ jsx(SpanStyledItemText, {
                noPrefix: !Boolean(option.prefix),
                children: option.label
              }), /* @__PURE__ */ jsx(CheckmarkIconStyled, {
                "aria-selected": ariaSelected
              })]
            })
          }, option.id);
        }), options.length >= 0 && visibleOptions.length === 0 && /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx(Illustration, {
            height: "60px",
            logo: "servers",
            width: "100%"
          }), /* @__PURE__ */ jsx(SpanStyledNoResults, {
            children: options.length === 0 ? customNoDataText : `No results for \u201C${searchTerm}\u201D`
          })]
        })]
      })]
    })
  });
};
const {
  DivStyledPlaceholder,
  ListItemStyledTag,
  ListStyledSelected,
  SpanStyledItemIcon,
  SpanStyledItemSelected
} = styles$e;
const colors$1 = ["blue", "green", "grey", "yellow", "purple", "blueLight", "pink"];
const SelectedItemsList = ({
  isMulti = false,
  name = "select",
  disabled = false,
  options = [],
  placeholder,
  value = [],
  setIsOpen,
  addItem
}) => {
  const MultiSelection = () => {
    return value.map((option, i) => {
      var _a;
      return /* @__PURE__ */ jsx(ListItemStyledTag, {
        onClick: (e2) => e2.stopPropagation(),
        children: /* @__PURE__ */ jsx(Tag, {
          text: (_a = options.find((curr) => curr.id === option)) == null ? void 0 : _a.label,
          theme: "chips",
          tone: "light",
          color: i < colors$1.length ? colors$1[i] : colors$1[i % colors$1.length],
          onCancelClick: () => {
            if (!disabled)
              addItem(option);
          },
          active: false,
          hasCancel: isMulti
        })
      }, option);
    });
  };
  const SingleSelection = () => {
    const currItem = options.find((option) => option.id === value);
    return currItem ? /* @__PURE__ */ jsxs(ListItemStyledTag, {
      "aria-label": "option-selected",
      "data-testid": "test-select-selected",
      style: {
        margin: "auto"
      },
      children: [(currItem == null ? void 0 : currItem.prefix) && /* @__PURE__ */ jsx(SpanStyledItemIcon, {
        children: currItem == null ? void 0 : currItem.prefix
      }), /* @__PURE__ */ jsx(SpanStyledItemSelected, {
        children: currItem == null ? void 0 : currItem.label
      })]
    }) : null;
  };
  return value.length > 0 ? /* @__PURE__ */ jsx(ListStyledSelected, {
    "aria-disabled": disabled,
    "aria-label": "options-selected",
    "data-testid": "test-select-selected-items",
    onClick: () => {
      if (!disabled)
        setIsOpen((prev) => !prev);
    },
    children: isMulti ? MultiSelection() : /* @__PURE__ */ jsx(SingleSelection, {})
  }) : /* @__PURE__ */ jsx(DivStyledPlaceholder, {
    children: placeholder != null ? placeholder : `Select ${name}`
  });
};
const {
  ButtonStyledSelect,
  DivStyledDesc,
  DivStyledOverlay,
  DivStyledSelectWrapper,
  DivStyledWrapper: DivStyledWrapper$2,
  LabelStyled: LabelStyled$2,
  TriangleDownIconStyled,
  TriangleUpIconStyled
} = styles$e;
const SelectBeta = ({
  customNoDataText = "No Data",
  defaultOptionIndex,
  description,
  disabled = false,
  errorMessage,
  height = "40px",
  id,
  isMulti = false,
  isSearch = true,
  label = "Select",
  max = Infinity,
  menuHeight = "200px",
  name = "options",
  onChange,
  options = [],
  placeholder,
  ref,
  style,
  value = [],
  width = "100%",
  ...props
}) => {
  const {
    onBlurTraditional,
    onChangeTraditional,
    prefixIcon,
    prefixText,
    refTraditional,
    state,
    traditionalHTML5,
    validation,
    tryBeta,
    ...rest
  } = props;
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const elementId = (component) => {
    if (component === void 0)
      return;
    const newName = name.replace(/ /g, "-");
    return `w3uik-${newName}-${component}`;
  };
  const addItem = (option) => {
    if (!option)
      return;
    if (isMulti === true) {
      const selected = [...value];
      const index = selected.findIndex((item) => item === option);
      if (index !== -1) {
        selected.splice(index, 1);
      } else if (selected.length < max) {
        selected.push(option);
      }
      onChange == null ? void 0 : onChange(selected);
      return;
    }
    onChange == null ? void 0 : onChange(options.find((item) => item.id === option));
    setIsOpen(false);
  };
  useEffect(() => {
    var _a;
    if (defaultOptionIndex && options && defaultOptionIndex >= 0 && defaultOptionIndex < (options == null ? void 0 : options.length)) {
      addItem((_a = options[defaultOptionIndex]) == null ? void 0 : _a.id);
    }
  }, []);
  return /* @__PURE__ */ jsxs(DivStyledWrapper$2, {
    "aria-expanded": isOpen === true,
    "aria-label": "select",
    className: "w3uik-select-component",
    "data-testid": "test-select",
    id,
    ref,
    role: "listbox",
    style: {
      ...style,
      width
    },
    ...rest,
    children: [/* @__PURE__ */ jsxs(DivStyledSelectWrapper, {
      className: "w3uik_container",
      height,
      children: [/* @__PURE__ */ jsxs(ButtonStyledSelect, {
        "aria-controls": elementId("menu"),
        "aria-expanded": isOpen === true,
        "aria-haspopup": "listbox",
        "aria-selected": value.length > 0,
        "data-testid": "test-select-button",
        disabled,
        onClick: () => {
          if (!disabled)
            setIsOpen((prev) => !prev);
        },
        onKeyDown: (e2) => {
          if (e2.key === KEY.DOWN) {
            setIsOpen(true);
          }
        },
        ref: triggerRef,
        type: "button",
        children: [label && /* @__PURE__ */ jsx(LabelStyled$2, {
          "aria-disabled": disabled,
          "data-testid": "test-select-label",
          htmlFor: name,
          children: label
        }), isOpen ? /* @__PURE__ */ jsx(TriangleUpIconStyled, {
          "data-testid": "test-select-icon",
          fontSize: "20px",
          fill: color.blue,
          title: "triangle up icon"
        }) : /* @__PURE__ */ jsx(TriangleDownIconStyled, {
          "data-testid": "test-select-icon",
          fontSize: "20px",
          fill: color.blue,
          title: "triangle down icon"
        })]
      }), /* @__PURE__ */ jsx(SelectedItemsList, {
        addItem,
        disabled,
        elementId,
        isMulti,
        isOpen,
        isSearch,
        max,
        name,
        options,
        placeholder,
        setIsOpen,
        value
      }), (description || errorMessage) && /* @__PURE__ */ jsx(DivStyledDesc, {
        "aria-invalid": state === "error",
        children: state === "error" ? errorMessage : description && description
      })]
    }), !disabled && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(DivStyledOverlay, {
        "aria-label": "Close Dropdown",
        className: "w3uik__select-overlay",
        onClick: () => setIsOpen(false)
      }), /* @__PURE__ */ jsx(SelectMenuList, {
        addItem,
        customNoDataText,
        disabled,
        elementId,
        isMulti,
        isOpen,
        isSearch,
        max,
        menuHeight,
        name,
        options,
        placeholder,
        setIsOpen,
        value
      })]
    }), /* @__PURE__ */ jsx("input", {
      name,
      type: "hidden",
      value: isMulti ? value.join(",") : value
    })]
  });
};
const Select = (props) => {
  if (props.tryBeta)
    return /* @__PURE__ */ jsx(SelectBeta, {
      ...props
    });
  return props.traditionalHTML5 ? /* @__PURE__ */ jsx(TraditionalSelect, {
    ...props
  }) : /* @__PURE__ */ jsx(Select$1, {
    ...props
  });
};
const TextAreaWrapper$1 = styled$1.div`
  ${resetCSS};
  background-color: ${color.white};
  border-radius: 16px;
  border: 1px solid ${color.greyLight};
  display: inline-block;
  max-width: 100%;
  padding: 12px;
  position: relative;
  transition: all 0.1s linear;
  width: ${(p2) => p2.width ? p2.width : "294px"};

  &:hover {
    border-color: ${(p2) => p2.state === "disabled" ? color.greyLight : color.blue};
  }

  &:focus {
    border-color: ${color.blue};

    + label {
      color: ${color.blue};
    }
  }

  ${(p2) => p2.state === "error" && `border-color: ${color.red};`}
  ${(p2) => p2.state === "confirmed" && `border-color: ${color.green};`}

    &:hover {
    ${(p2) => p2.state === "error" && `border-color: ${color.red};`}
    ${(p2) => p2.state === "confirmed" && `border-color: ${color.green};`}

        label {
      ${(p2) => p2.state !== "error" && p2.state !== "confirmed" && p2.state !== "disabled" && `color: ${color.blue};`}
    }
  }

  &:focus {
    ${(p2) => p2.state === "error" && `border-color: ${color.red};`}
    ${(p2) => p2.state === "confirmed" && `border-color: ${color.green};`}
        & + label {
      ${(p2) => p2.state === "error" && `color: ${color.red};`}
      ${(p2) => p2.state === "confirmed" && `color: ${color.green};`}
    }
  }

  textarea {
    & + label {
      ${(p2) => p2.state === "error" && `color: ${color.red};`}
      ${(p2) => p2.state === "confirmed" && `color: ${color.green};`}
    }
  }
`;
const LabelStyled$1 = styled$1.label`
  ${resetCSS}
  ${fonts.text}
    background-color: ${color.white};
  height: 24px;
  left: 12px;
  padding: 0 4px;
  pointer-events: none;
  position: absolute;
  top: 14px;
  transition: all 0.1s ease-out;
`;
const TextAreaStyled$1 = styled$1.textarea`
  ${resetCSS}
  ${fonts.text}
    background-color: transparent;
  display: block;
  max-width: 100%;
  min-height: 128px;
  overflow: hidden;
  padding: 2px;
  width: 100%;

  &::placeholder {
    opacity: 0;
  }

  &:focus,
  .filled & {
    + label {
      font-size: 14px;
      height: 18px;
      line-height: 1;
      padding: 2px 4px;
      top: -10px;
    }
  }

  &:focus {
    &::placeholder {
      opacity: 1;
      color: ${color.grey};
    }
  }
`;
var styles$d = {
  TextAreaStyled: TextAreaStyled$1,
  LabelStyled: LabelStyled$1,
  TextAreaWrapper: TextAreaWrapper$1
};
const {
  TextAreaStyled,
  LabelStyled,
  TextAreaWrapper
} = styles$d;
const TextArea = ({
  autoComplete = true,
  id = String(Date.now()),
  label,
  name,
  ref,
  onChange,
  onBlur,
  placeholder,
  state,
  validation,
  value = "",
  width = "300px",
  ...props
}) => {
  const [currentValue, setCurrentValue] = useState(value);
  const myRef = useRef(ref ? ref.current : null);
  const textareaRef = useRef(null);
  const valueChanged = (event) => {
    setCurrentValue(event.target.value);
    onChange && onChange(event);
  };
  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = "0px";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + "px";
    }
  }, [currentValue]);
  return /* @__PURE__ */ jsxs(TextAreaWrapper, {
    className: currentValue.length > 0 ? "filled" : "empty",
    "data-testid": "test-textarea-wrapper",
    state,
    width,
    children: [/* @__PURE__ */ jsx(TextAreaStyled, {
      autoComplete: `${autoComplete}`,
      "data-testid": "test-textarea",
      disabled: state === "disabled",
      id,
      maxLength: validation == null ? void 0 : validation.characterMaxLength,
      minLength: validation == null ? void 0 : validation.characterMinLength,
      name,
      onChange: (event) => valueChanged(event),
      onBlur: (event) => onBlur && onBlur(event),
      placeholder,
      ref: (event) => {
        textareaRef.current = event;
        if (myRef)
          myRef.current = event;
      },
      required: validation == null ? void 0 : validation.required,
      rows: 4,
      value: currentValue,
      ...props
    }), label && /* @__PURE__ */ jsx(LabelStyled, {
      "data-testid": "test-textarea-label",
      htmlFor: id,
      children: label
    })]
  });
};
const H3Styled$1 = styled$1.h3`
  ${resetCSS};
  ${fonts.heading};
  ${fonts.h3};
  margin-bottom: 18px;
`;
const H4Styled$1 = styled$1.h4`
  ${resetCSS};
  ${fonts.heading};
  ${fonts.h4};
  margin-bottom: 12px;
  margin-top: 32px;
`;
const FormStyled$1 = styled$1.form`
  ${resetCSS};
  background-color: ${color.white};
  border-radius: 16px;
  padding: 16px;

  .form-item + .form-item {
    margin-top: 30px;
  }

  > button[type='submit'],
  .customFooter {
    margin-top: 32px;
  }
`;
var styles$c = {
  FormStyled: FormStyled$1,
  H4Styled: H4Styled$1,
  H3Styled: H3Styled$1
};
const {
  H3Styled,
  H4Styled,
  FormStyled
} = styles$c;
const Form = ({
  buttonConfig,
  customFooter,
  data,
  id,
  isDisabled = false,
  onSubmit,
  title,
  ...props
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const formSubmitted = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.target;
    if (form.checkValidity()) {
      const dataReturned = data.map((item) => ({
        inputName: item.name,
        inputResult: item.selectedCard || item.selected || item.value,
        key: item.key
      }));
      onSubmit && onSubmit({
        id,
        data: dataReturned
      });
      data.map((input) => input.value = "");
      setIsSubmitted(true);
    } else {
      form.reportValidity();
    }
  };
  const optionAdded = (elementIndex, opt, isRadio) => {
    var _a, _b;
    if (isRadio) {
      const selectRadioValue = data[elementIndex].options[Number(opt)];
      if (typeof selectRadioValue === "string") {
        data[elementIndex].selected = [selectRadioValue];
      } else {
        data[elementIndex].selectedCard = selectRadioValue;
      }
      return;
    }
    if (!data[elementIndex].selected) {
      data[elementIndex].selected = [String(opt)];
    } else {
      (_b = (_a = data[elementIndex]) == null ? void 0 : _a.selected) == null ? void 0 : _b.push(String(opt));
    }
  };
  const optionToggled = (event, elementIndex, opt) => {
    var _a, _b;
    const isRadio = Boolean(event.target.type === "radio");
    if (event.target.checked) {
      optionAdded(elementIndex, opt, isRadio);
    } else {
      const filtered = (_b = (_a = data[elementIndex]) == null ? void 0 : _a.selected) == null ? void 0 : _b.filter((item) => item !== opt);
      data[elementIndex].selected = filtered;
    }
  };
  const renderDatePicker = (input, type, index) => {
    var _a;
    return /* @__PURE__ */ jsx(DatePicker, {
      id: `${type}_${index}`,
      label: input.name,
      onChange: (e2) => data[index].selected = [String(e2.date)],
      validation: {
        required: (_a = input.validation) == null ? void 0 : _a.required
      },
      disabled: isDisabled
    });
  };
  const renderInput = (input, type, index) => {
    var _a, _b, _c, _d, _e2, _f, _g;
    return /* @__PURE__ */ jsx(Input, {
      id: `input_${index}`,
      value: input.value,
      label: input.name,
      name: input.name,
      onChange: (e2) => data[index].value = e2.target.value,
      type,
      width: input.inputWidth,
      disabled: isDisabled,
      validation: {
        characterMaxLength: (_a = input.validation) == null ? void 0 : _a.characterMaxLength,
        characterMinLength: (_b = input.validation) == null ? void 0 : _b.characterMinLength,
        numberMax: (_c = input.validation) == null ? void 0 : _c.numberMax,
        numberMin: (_d = input.validation) == null ? void 0 : _d.numberMin,
        regExp: (_e2 = input.validation) == null ? void 0 : _e2.regExp,
        regExpInvalidMessage: (_f = input.validation) == null ? void 0 : _f.regExpInvalidMessage,
        required: (_g = input.validation) == null ? void 0 : _g.required
      }
    }, `input_${index}`);
  };
  const renderCheckbox = (input, layout, index) => /* @__PURE__ */ jsxs(Fragment$1, {
    children: [/* @__PURE__ */ jsx(H4Styled, {
      children: input.value
    }), (input.options || []).map((opt, i) => {
      var _a;
      return /* @__PURE__ */ jsx(Checkbox, {
        label: String(opt),
        layout,
        name: input.name,
        onChange: (e2) => optionToggled(e2, index, String(opt)),
        validation: {
          required: (_a = input.validation) == null ? void 0 : _a.required
        },
        disabled: isDisabled
      }, `cb_${index}-${i}`);
    })]
  }, `cb-group_${index}`);
  const renderRadioGroup = (input, index) => {
    var _a;
    return /* @__PURE__ */ jsxs(Fragment$1, {
      children: [/* @__PURE__ */ jsx(H4Styled, {
        children: input.value
      }), /* @__PURE__ */ jsx(Radios, {
        id: `${input.name}_${index}`,
        items: input.options || [],
        onChange: (e2) => optionToggled(e2, index, e2.target.value),
        validation: {
          required: (_a = input.validation) == null ? void 0 : _a.required
        },
        disabled: isDisabled
      })]
    }, `${input.name}_${index}`);
  };
  const renderTextArea = (input, index) => {
    var _a, _b, _c;
    return /* @__PURE__ */ jsxs(Fragment$1, {
      children: [/* @__PURE__ */ jsx(H4Styled, {
        children: input.name
      }), /* @__PURE__ */ jsx(TextArea, {
        id: `textarea_${index}`,
        name: input.name,
        onChange: (e2) => data[index].value = e2.target.value,
        value: input.value,
        width: input.inputWidth,
        state: isDisabled ? "disabled" : void 0,
        validation: {
          characterMaxLength: (_a = input.validation) == null ? void 0 : _a.characterMaxLength,
          characterMinLength: (_b = input.validation) == null ? void 0 : _b.characterMinLength,
          required: (_c = input.validation) == null ? void 0 : _c.required
        }
      })]
    }, `${input.name}_${index}`);
  };
  const renderSelect = (input, type, index) => {
    var _a;
    return /* @__PURE__ */ jsx(Select, {
      id: `${input.name}_${index}`,
      label: input.name,
      onChangeTraditional: (e2) => data[index].value = e2.target.value,
      options: input.selectOptions,
      traditionalHTML5: type === "traditional",
      validation: {
        required: Boolean((_a = input.validation) == null ? void 0 : _a.required)
      },
      width: input.inputWidth,
      disabled: isDisabled
    });
  };
  const renderInputType = (input, index) => {
    switch (input.type) {
      case "text":
        return renderInput(input, "text", index);
      case "tel":
        return renderInput(input, "tel", index);
      case "password":
        return renderInput(input, "password", index);
      case "email":
        return renderInput(input, "email", index);
      case "number":
        return renderInput(input, "number", index);
      case "box":
        return renderCheckbox(input, "box", index);
      case "switch":
        return renderCheckbox(input, "switch", index);
      case "radios":
        return renderRadioGroup(input, index);
      case "select":
        return renderSelect(input, "traditional", index);
      case "textarea":
        return renderTextArea(input, index);
      case "date":
        return renderDatePicker(input, "date", index);
      default:
        return;
    }
  };
  return /* @__PURE__ */ jsxs(FormStyled, {
    "data-testid": "test-form",
    id,
    onSubmit: formSubmitted,
    ...props,
    children: [title && /* @__PURE__ */ jsx(H3Styled, {
      "data-testid": "test-form-title",
      children: title
    }), data && data.map((input, i) => /* @__PURE__ */ jsx("div", {
      className: "form-item",
      "data-testclass": "form-ele",
      "data-testid": `test-form-ele-${i}`,
      children: renderInputType(input, i)
    }, `form-ele-${i}`)), customFooter ? /* @__PURE__ */ jsx("div", {
      className: "customFooter",
      children: customFooter
    }) : /* @__PURE__ */ jsx(Button, {
      disabled: isDisabled || isSubmitted,
      id: "form-submit",
      text: "Submit",
      type: "submit",
      ...buttonConfig
    })]
  });
};
const setImageAlign = (align) => {
  switch (align) {
    case "center":
      return Ce$1`
                margin: auto;
            `;
    case "left":
      return Ce$1`
                margin-right: auto;
            `;
    case "right":
      return Ce$1`
                margin-left: auto;
            `;
  }
};
const SectionStyled$5 = styled$1.section`
    ${resetCSS};
    background-color: ${(p2) => p2.backgroundColor};
    background-image: ${({ backgroundURL, linearGradient = "" }) => backgroundURL ? `${linearGradient && linearGradient + ", "} url(${backgroundURL})` : linearGradient};
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: ${(p2) => p2.rounded || "0px"};
    display: flex;
    justify-content: space-between;
    height: ${({ height }) => height || "100%"};
    max-width: 100%;
    overflow: hidden;

    * {
        color: ${(p2) => p2.textColor || color.white} !important;
    }

    @media (max-width: ${breakpoints.sm}) {
        align-items: center;
        text-align: center;
        flex-direction: column;
        gap: 20px;
        height: fit-content;
    }
`;
const LeftContainerDiv$1 = styled$1.div`
    display: flex;
    flex-grow: 1;
    width: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
    padding: ${(p2) => p2.padding || "20px"};
    @media (max-width: ${breakpoints.sm}) {
        padding: 20px;
        width: 100%;
        align-items: center;
    }
`;
const RightContainerDiv$1 = styled$1.div`
    display: flex;
    flex-grow: 1;
    width: 50%;
    @media (max-width: ${breakpoints.sm}) {
        width: 100%;
    }
`;
const ImageStyled$3 = styled$1.img`
    block-size: auto;
    height: 100%;
    max-inline-size: 100%;
    object-fit: contain;
    ${(p2) => setImageAlign(p2.align || "center")};
    @media (max-width: ${breakpoints.sm}) {
        margin: auto;
    }
`;
var styles$b = {
  ImageStyled: ImageStyled$3,
  LeftContainerDiv: LeftContainerDiv$1,
  RightContainerDiv: RightContainerDiv$1,
  SectionStyled: SectionStyled$5
};
const {
  ImageStyled: ImageStyled$2,
  LeftContainerDiv,
  RightContainerDiv,
  SectionStyled: SectionStyled$4
} = styles$b;
const Hero = ({
  align = "center",
  backgroundColor = `${color.greyLight}`,
  backgroundURL = "",
  children,
  customImage = {
    url: null,
    align: "center",
    styles: {}
  },
  height = "100%",
  linearGradient,
  padding,
  rounded = "20px",
  subTitle,
  textColor = `${color.greyDark}`,
  title,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(SectionStyled$4, {
    backgroundColor,
    linearGradient,
    backgroundURL,
    "data-testid": "test-hero",
    height,
    rounded,
    textColor,
    ...props,
    children: [/* @__PURE__ */ jsxs(LeftContainerDiv, {
      padding,
      children: [title && /* @__PURE__ */ jsx(Typography, {
        color: textColor,
        "data-testid": "test-hero-title",
        variant: "h1",
        children: title
      }), subTitle && /* @__PURE__ */ jsx(Typography, {
        color: textColor,
        "data-testid": "test-hero-text",
        variant: "body16",
        weight: "regular",
        children: /* @__PURE__ */ jsx("strong", {
          children: subTitle
        })
      }), children && children]
    }), (customImage == null ? void 0 : customImage.url) && /* @__PURE__ */ jsx(RightContainerDiv, {
      children: /* @__PURE__ */ jsx(ImageStyled$2, {
        align,
        loading: "lazy",
        src: customImage.url,
        alt: "Hero-image",
        style: customImage == null ? void 0 : customImage.styles
      })
    })]
  });
};
const DivStyled$i = styled$1.div`
  ${resetCSS};
  ${fonts.text};
  ${fonts.textBold};
  background-color: ${color.white};
  border-radius: 16px;
  border: 2px solid ${color.blueSkyLight};
  display: grid;
  grid-gap: 5px;
  margin: 0;
  padding: 16px;
  width: 100%;
`;
const PStyledTopic$1 = styled$1.p`
  color: ${color.blue};
  margin: 0;
`;
const PStyledInfo$1 = styled$1.p`
  color: ${color.blueDark};
  font-size: 24px;
  margin: 0;
`;
var styles$a = { DivStyled: DivStyled$i, PStyledTopic: PStyledTopic$1, PStyledInfo: PStyledInfo$1 };
const {
  DivStyled: DivStyled$h,
  PStyledTopic,
  PStyledInfo
} = styles$a;
const Info = ({
  id,
  information,
  topic,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(DivStyled$h, {
    id,
    "data-testid": "test-info",
    ...props,
    children: [/* @__PURE__ */ jsx(PStyledTopic, {
      "data-testid": "test-info-topic",
      children: topic
    }), /* @__PURE__ */ jsx(PStyledInfo, {
      "data-testid": "test-info-info",
      children: information
    })]
  });
};
const LinkStyled$1 = styled$1.a`
    ${resetCSS}
    ${fonts.text}
    align-items: center;
    color: ${color.blue};
    display: inline-block;
    font-weight: 600;
    height: fit-content;
    max-width: 100%;
    width: fit-content;

    &:hover {
        filter: brightness(0.7);
    }
`;
const InternalLinkStyled$1 = styled$1(Link)`
    ${resetCSS}
    ${fonts.text}
    align-items: center;
    color: ${color.blue};
    display: inline-block;
    font-weight: 600;
    max-width: 100%;
    width: fit-content;
    &:hover {
        filter: brightness(0.7);
    }
`;
const SpanStyledFlex$1 = styled$1.span`
    align-items: baseline;
    display: flex;
    flex-direction: ${({ iconLayout }) => iconLayout === "leading" ? "row" : "row-reverse"};
    margin: ${(p2) => p2.iconLayout === "leading" ? "auto 2px auto 4px" : "auto 4px auto 2px"};

    svg {
        margin: ${(p2) => p2.iconLayout === "leading" ? "auto 4px auto 0" : "auto 0 auto 4px"};
    }
`;
const SpanStyledText$1 = styled$1.span`
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
var styles$9 = {
  InternalLinkStyled: InternalLinkStyled$1,
  LinkStyled: LinkStyled$1,
  SpanStyledFlex: SpanStyledFlex$1,
  SpanStyledText: SpanStyledText$1
};
const {
  InternalLinkStyled,
  LinkStyled,
  SpanStyledFlex,
  SpanStyledText
} = styles$9;
const LinkTo = ({
  address,
  iconLayout = "leading",
  text: text2,
  type = "external",
  ...props
}) => {
  const renderContent = () => /* @__PURE__ */ jsxs(SpanStyledFlex, {
    iconLayout,
    "data-testid": "test-link-flex",
    children: [iconLayout !== "none" && type !== "internal" && (type === "email" ? /* @__PURE__ */ jsx(SvgMail, {
      title: "mail icon",
      titleId: "linkto mail icon",
      fill: color.blue,
      fontSize: 18,
      style: {
        marginTop: "auto"
      }
    }) : /* @__PURE__ */ jsx(SvgLink, {
      title: "link icon",
      titleId: "linkto link icon",
      fill: color.blue,
      fontSize: 18,
      style: {
        marginTop: "auto"
      }
    })), /* @__PURE__ */ jsx(SpanStyledText, {
      "data-testid": "test-link-text",
      children: text2 || address
    })]
  });
  return type !== "internal" ? /* @__PURE__ */ jsx(LinkStyled, {
    "data-testid": "test-link-to",
    href: `${type === "email" ? "mailto:" : ""}${address}`,
    target: `${type === "email" ? "_self" : "_blank"}`,
    ...props,
    children: renderContent()
  }) : /* @__PURE__ */ jsx(InternalLinkStyled, {
    "data-testid": "test-link-to",
    to: address,
    children: renderContent()
  });
};
const overflow = () => {
  return `
            overflow: auto;
            scrollbar-width: none;
            ::-webkit-scrollbar {
              display: none;
            }
            -ms-overflow-style: none;
        `;
};
const DivStyledWrap$1 = styled$1.div`
    ${(p2) => !p2.canOverflow && overflow()}
    ${fonts.text};
    background-color: ${color.white};
    border-radius: 20px;
    box-shadow: 0 4px 10px rgba(48, 71, 105, 0.1);
    margin: 80px auto;
    max-width: ${(p2) => p2.width};
    width: 96%;
`;
const HeaderStyled$3 = styled$1.header`
    ${(p2) => p2.fixedMode && "position: sticky; top: 0;background-color: white;"}
    ${(p2) => typeof p2.title === "string" && `h3 {
        color: ${color.blue};
        padding-right: 8px;
        margin-block-start: 0;
        margin-block-end: 0;
    }`}
    align-items: center;
    display: flex;
    padding: 24px 32px 20px;
    justify-content: ${(p2) => p2.title ? "space-between" : "flex-end"};
    border-bottom: ${(p2) => p2.headerHasBottomBorder ? `1px solid ${color.paleBlue2}` : void 0};

    div {
        border-color: ${color.blue};
        border-radius: 15px;
    }

    button {
        min-width: 30px;
    }

    #modal-close-button {
        border: 3px solid ${color.paleBlue2};
        background-color: white;
    }
`;
const DivStyledContent$4 = styled$1.div`
    padding: 0px 32px 0px;
`;
const FooterStyled$3 = styled$1.footer`
    ${(p2) => p2.fixedMode && "position: sticky;bottom: 0;background-color: white;"}
    border-top: 1px solid ${color.paleBlue2};
    display: flex;
    flex-wrap: wrap;
    padding: 24px 32px 32px;
    justify-content: ${(p2) => p2.hasCancel ? "space-between" : "flex-end"};

    button {
        margin: 3px 0;
    }

    #modal-cancel-button {
        color: ${color.grey};
        :hover {
            color: ${color.black};
        }
    }
`;
const DivStyled$g = styled$1.div`
    align-items: ${({ isCentered }) => isCentered ? " center" : "flex-start"};
    background: rgba(${hexToRgb(color.blueDark)}, 0.7);
    bottom: 0;
    display: ${({ isVisible }) => isVisible ? " flex" : "none"};
    height: 100vh;
    justify-content: center;
    left: 0;
    overflow: auto;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 5;
`;
const CustomFooterStyled$1 = styled$1.footer`
    ${(p2) => p2.fixedMode && "position: sticky;bottom: 0;background-color: white;"}
    border-top: 1px solid ${color.paleBlue2};
    display: flex;
    padding: 0px 32px 32px;
`;
const CustomButtonStyle = styled$1.div`
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
`;
var styles$8 = {
  CustomButtonStyle,
  CustomFooterStyled: CustomFooterStyled$1,
  DivStyled: DivStyled$g,
  DivStyledContent: DivStyledContent$4,
  DivStyledWrap: DivStyledWrap$1,
  FooterStyled: FooterStyled$3,
  HeaderStyled: HeaderStyled$3
};
const {
  CustomFooterStyled,
  DivStyled: DivStyled$f,
  DivStyledContent: DivStyledContent$3,
  DivStyledWrap,
  FooterStyled: FooterStyled$2,
  HeaderStyled: HeaderStyled$2
} = styles$8;
const Modal = ({
  canOverflow = false,
  cancelText = "Cancel",
  children,
  closeButton,
  customFooter,
  fixedMode = false,
  hasCancel = true,
  hasFooter = true,
  headerHasBottomBorder = false,
  id = String(Date.now()),
  isCancelDisabled,
  isCentered = false,
  isOkDisabled,
  isVisible = true,
  okButtonColor,
  okText = "Ok",
  onCancel,
  onCloseButtonPressed,
  onOk,
  title,
  width = "70vw",
  ...props
}) => {
  const [visible, setVisible] = useState(isVisible);
  useEffect(() => {
    document.addEventListener("click", handleContentClick);
    return () => document.removeEventListener("click", handleContentClick);
  }, []);
  const handleContentClick = (event) => {
    const target = event.target;
    if (target.id === "close")
      toggleVisibility();
  };
  useEffect(() => {
    setVisible(isVisible);
  }, [isVisible]);
  const toggleVisibility = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ jsx(DivStyled$f, {
    "data-testid": "test-modal",
    id,
    isCentered,
    isVisible: visible,
    ...props,
    children: /* @__PURE__ */ jsxs(DivStyledWrap, {
      width,
      canOverflow,
      children: [/* @__PURE__ */ jsx(HeaderStyled$2, {
        "data-testid": "test-modal-header",
        title,
        fixedMode,
        headerHasBottomBorder,
        children: /* @__PURE__ */ jsxs(Fragment, {
          children: [typeof title == "string" ? /* @__PURE__ */ jsx("h3", {
            children: title
          }) : title, closeButton ? closeButton : /* @__PURE__ */ jsx(Button, {
            iconColor: "#68738D",
            theme: "secondary",
            radius: 100,
            id: "modal-close-button",
            "data-testid": "modal-close-test-id",
            icon: /* @__PURE__ */ jsx(SvgCross, {
              title: "cross icon",
              titleId: "modal cross icon",
              fontSize: 12
            }),
            iconLayout: "icon-only",
            onClick: onCloseButtonPressed ? onCloseButtonPressed : toggleVisibility
          })]
        })
      }), /* @__PURE__ */ jsx(DivStyledContent$3, {
        id: "content",
        "data-testid": "test-modal-content",
        children
      }), hasFooter && !customFooter && /* @__PURE__ */ jsxs(FooterStyled$2, {
        "data-testid": "test-modal-footer",
        hasCancel,
        fixedMode,
        children: [hasCancel && /* @__PURE__ */ jsx(Button, {
          id: "modal-cancel-button",
          "data-testid": "test-modal-button",
          disabled: isCancelDisabled,
          text: cancelText,
          onClick: onCancel ? onCancel : () => {
          },
          theme: "outline"
        }), /* @__PURE__ */ jsx(Button, {
          color: okButtonColor,
          "data-testid": "test-modal-ok-button",
          disabled: isOkDisabled,
          onClick: onOk ? onOk : () => {
          },
          text: okText,
          theme: okButtonColor ? "colored" : "primary"
        })]
      }), customFooter && /* @__PURE__ */ jsx(CustomFooterStyled, {
        fixedMode,
        children: customFooter
      })]
    })
  });
};
const error = Ce$1`
    border-color: ${color.red};
    & > svg {
        fill: ${color.red};
    }
`;
const info = Ce$1`
    border-color: ${color.blue};
    & > svg {
        fill: ${color.blue};
    }
`;
const success = Ce$1`
    border-color: ${color.green};
    & > svg {
        fill: ${color.green};
    }
`;
const warning = Ce$1`
    border-color: ${color.yellow};
    & > svg {
        fill: ${color.yellow};
    }
`;
const openRight = Ue` 
    0% {
        left: 150%;
    }

    100% {
        left: 0;
    }
`;
const closeRight = Ue` 
    0% {
        left: 0;
    }

    100% {
        left: 150%;
    }
`;
const openLeft = Ue` 
    0% {
        left: -150%;
    }

    100% {
        left: 0;
    }
`;
const closeLeft = Ue` 
    0% {
        left: 0;
    }

    100% {
        left: -150%;
    }
`;
const getNotificationTheme = (type) => {
  switch (type) {
    case "error":
      return error;
    case "success":
      return success;
    case "warning":
      return warning;
    case "info":
    default:
      return info;
  }
};
const getNotificationPosition = (position) => {
  switch (position) {
    case "bottomL":
      return Ce$1`
                left: 0;
                bottom: 0;
            `;
    case "topL":
      return Ce$1`
                left: 0;
                top: 0;
            `;
    case "bottomR":
      return Ce$1`
                right: 0;
                bottom: 0;
            `;
    case "topR":
    default:
      return Ce$1`
                right: 0;
                top: 0;
            `;
  }
};
const getNotificationColor = (type) => {
  switch (type) {
    case "error":
      return color.red;
    case "success":
      return color.green;
    case "warning":
      return color.yellow;
    case "info":
    default:
      return color.blue;
  }
};
const getNotificationAnimation = (position, isClosing) => {
  switch (position) {
    case "bottomL":
    case "topL":
      return Ce$1`
                animation: ${isClosing ? closeLeft : openLeft} 1s;
            `;
    case "bottomR":
    case "topR":
      return Ce$1`
                animation: ${isClosing ? closeRight : openRight} 1s;
            `;
    default:
      throw new Error("Make sure you provided position");
  }
};
const NotificationContainerStyled$1 = styled$1.div`
    position: fixed;
    z-index: 30;

    ${(p2) => getNotificationPosition(p2.position)}
`;
const IconWrapperStyled$1 = styled$1.div`
    ${resetCSS}
    align-items: center;
    border-radius: 100%;
    display: flex;
    height: 24px;
    justify-content: center;
    width: 24px;
`;
const TextContentStyled$3 = styled$1.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-left: 10px;
    width: 100%;
`;
const SpanStyled$3 = styled$1.span`
    ${fonts.ibm}
    color: ${color.grey};
    display: inline-block;
    white-space: pre-wrap;
    word-break: break-word;
`;
const TitleStyled$1 = styled$1.h5`
    ${fonts.h5};
    display: inline-block;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
    word-break: break-word;
`;
const CloseWrapperStyled$1 = styled$1.div`
    ${resetCSS}
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 16px;
`;
const BarStyled$1 = styled$1.div`
    background-color: rgba(158, 204, 234, 0.3);
    bottom: 0;
    height: 6px;
    left: 0;
    position: absolute;
`;
const NotificationStyled$1 = styled$1.div`
    ${resetCSS}
    ${fonts.text}
    animation-fill-mode: forwards;
    background-color: ${color.white};
    border-radius: 20px;
    box-shadow: 0px 4px 10px rgba(48, 71, 105, 0.1);
    color: ${color.grey};
    display: flex;
    margin: 18px;
    padding: 16px 48px 16px 16px;
    position: relative;
    width: 320px;
    overflow: hidden;
    z-index: 9999;

    ${(p2) => getNotificationAnimation(p2.position, p2.isClosing)}

    & > ${IconWrapperStyled$1} {
        ${(p2) => getNotificationTheme(p2.type)}
    }
    & > ${TextContentStyled$3} > ${TitleStyled$1} {
        color: ${(p2) => getNotificationColor(p2.type)};
    }
`;
const NotificationStyles = {
  CloseWrapperStyled: CloseWrapperStyled$1,
  IconWrapperStyled: IconWrapperStyled$1,
  NotificationStyled: NotificationStyled$1,
  SpanStyled: SpanStyled$3,
  TextContentStyled: TextContentStyled$3,
  TitleStyled: TitleStyled$1,
  NotificationContainerStyled: NotificationContainerStyled$1,
  BarStyled: BarStyled$1
};
const {
  BarStyled,
  CloseWrapperStyled,
  IconWrapperStyled,
  NotificationStyled,
  SpanStyled: SpanStyled$2,
  TextContentStyled: TextContentStyled$2,
  TitleStyled
} = NotificationStyles;
const Notification = ({
  dispatch,
  icon,
  id,
  message,
  position = "topL",
  title = "New Message",
  type = "info",
  ...props
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [intervalId, setIntervalId] = useState();
  const [barWidth, setBarWidth] = useState(0);
  const notificationWidth = 320;
  const startTimer = () => {
    if (isClosing)
      return;
    const idInt = setInterval(() => {
      setBarWidth((prev) => {
        if (prev < notificationWidth)
          return prev + 1;
        clearInterval(idInt);
        return prev;
      });
    }, 20);
    setIntervalId(idInt);
  };
  const pauseTimer = () => {
    clearInterval(intervalId);
  };
  useEffect(() => {
    if (isClosing)
      return;
    if (barWidth === notificationWidth)
      closeNotification();
  }, [barWidth, isClosing]);
  useEffect(() => startTimer(), []);
  const closeNotification = () => {
    pauseTimer();
    setIsClosing(true);
    setTimeout(() => {
      dispatch({
        type: "remove_notification",
        id
      });
    }, 400);
  };
  const getIcon = () => {
    if (icon)
      return icon;
    if (type === "error" || type === "warning") {
      return /* @__PURE__ */ jsx(SvgExclamation, {
        title: "exclamation icon",
        titleId: "notification exclamation icon",
        fill: getIconColor2(type)
      });
    }
    if (type === "info")
      return /* @__PURE__ */ jsx(SvgInfo, {
        title: "info icon",
        titleId: "notification info icon",
        fill: getIconColor2(type)
      });
    return /* @__PURE__ */ jsx(SvgCheckmark, {
      title: "checkmark icon",
      titleId: "notification checkmark icon",
      fill: getIconColor2(type)
    });
  };
  const getIconColor2 = (type2) => {
    return getNotificationColor(type2);
  };
  return /* @__PURE__ */ jsxs(NotificationStyled, {
    "data-testid": "test-notification",
    id,
    isClosing,
    onMouseEnter: pauseTimer,
    onMouseLeave: startTimer,
    position,
    type,
    ...props,
    children: [/* @__PURE__ */ jsx(IconWrapperStyled, {
      "data-testid": "test-notification-icon-wrapper",
      children: getIcon()
    }), /* @__PURE__ */ jsxs(TextContentStyled$2, {
      children: [/* @__PURE__ */ jsx(TitleStyled, {
        "data-testid": "test-notification-title",
        children: title
      }), /* @__PURE__ */ jsx(CloseWrapperStyled, {
        onClick: closeNotification,
        "data-testid": "test-notification-x",
        children: /* @__PURE__ */ jsx(SvgCross, {
          title: "cross icon",
          titleId: "notification cross icon",
          fontSize: 10,
          fill: color.greyIcons
        })
      }), /* @__PURE__ */ jsx(SpanStyled$2, {
        "data-testid": "test-notification-message",
        children: message
      })]
    }), /* @__PURE__ */ jsx(BarStyled, {
      style: {
        width: barWidth
      }
    })]
  });
};
const NotificationContext = createContext();
const {
  NotificationContainerStyled
} = NotificationStyles;
const initialState = [];
function reducer(state, action) {
  switch (action.type) {
    case "add_notification":
      return [...state, {
        ...action.payload
      }];
    case "remove_notification":
      return state.filter((toast) => toast.id !== action.id);
    case "clear_notifications":
      return [];
    default:
      return state;
  }
}
const NotificationProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const toasts = useMemo(() => {
    const toaster = {
      topR: [],
      topL: [],
      bottomR: [],
      bottomL: []
    };
    state.forEach((toast) => toaster[toast.position].push(toast));
    return Object.keys(toaster).map((pos) => {
      var _a;
      return /* @__PURE__ */ jsx(NotificationContainerStyled, {
        position: pos,
        children: (_a = toaster == null ? void 0 : toaster[pos]) == null ? void 0 : _a.map((toast) => /* @__PURE__ */ jsx(Notification, {
          id: toast.id || String(Date.now()),
          dispatch,
          ...toast
        }, toast.id))
      }, `container-${pos}`);
    });
  }, [state]);
  return /* @__PURE__ */ jsxs(NotificationContext.Provider, {
    value: dispatch,
    children: [toasts, props.children]
  });
};
const useNotification = () => {
  const dispatch = useContext(NotificationContext);
  if (dispatch === void 0) {
    throw new Error("useNotification hook must be used within a NotificationProvider");
  }
  return (props) => {
    dispatch({
      type: "add_notification",
      payload: {
        id: String(Date.now()),
        ...props
      }
    });
  };
};
const DivStyled$e = styled$1.div`
  background: #ffffff;
  border-radius: 20px;
  border: 2px solid #c1d8e7;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 448px;
  max-width: 386.67px;
  padding: 32px;
  ${(props) => props.isActive && `
      border-color: ${color.green};
    `}
`;
DivStyled$e.displayName = "DivStyled";
const DivStyledFeatures$1 = styled$1.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  overflow-y: auto;
  row-gap: 8px;
  & > div {
    display: flex;
    align-items: center;
  }
`;
const DivStyledCardFooter$1 = styled$1.div`
  margin-top: auto;
`;
var styles$7 = {
  DivStyled: DivStyled$e,
  DivStyledFeatures: DivStyledFeatures$1,
  DivStyledCardFooter: DivStyledCardFooter$1
};
const StyledDiv$1 = styled$1.div`
    align-items: center;
    display: flex;
    height: 40px;
    justify-content: center;
`;
var styles$6 = {
  StyledDiv: StyledDiv$1
};
const {
  StyledDiv
} = styles$6;
const YourPlanButton = () => {
  return /* @__PURE__ */ jsx(StyledDiv, {
    children: /* @__PURE__ */ jsx(Typography, {
      color: color.grey,
      weight: "600",
      variant: "body16",
      children: "Your Plan"
    })
  });
};
const {
  DivStyled: DivStyled$d,
  DivStyledFeatures,
  DivStyledCardFooter
} = styles$7;
const PlanCard = ({
  description,
  footer,
  subTitle,
  descriptionTitle,
  title,
  isActive,
  isCurrentPlan,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(DivStyled$d, {
    className: "PlanCard",
    "data-testid": "test-plan-card",
    isActive,
    ...props,
    children: [/* @__PURE__ */ jsx(Typography, {
      variant: "subtitle1",
      weight: "600",
      color: color.blueDark,
      children: subTitle
    }), /* @__PURE__ */ jsx(Typography, {
      children: title
    }), /* @__PURE__ */ jsxs(DivStyledFeatures, {
      children: [/* @__PURE__ */ jsx(Typography, {
        variant: "caption14",
        weight: "semibold",
        color: color.blueDark,
        children: descriptionTitle
      }), description.map((feature, index) => /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx(SvgCheck, {
          title: "check icon",
          titleId: "plan-card check icon",
          fill: color.green
        }), /* @__PURE__ */ jsx(Typography, {
          variant: "caption14",
          weight: "semibold",
          color: color.grey,
          children: feature
        })]
      }, index))]
    }), /* @__PURE__ */ jsx(DivStyledCardFooter, {
      children: isCurrentPlan ? /* @__PURE__ */ jsx(YourPlanButton, {}) : footer
    })]
  });
};
const sizeValue = 20;
const halfSizeValue = sizeValue / 2;
const size = `${sizeValue}px`;
const halfSize = `${halfSizeValue}px`;
const DivStyled$c = styled$1.div`
    ${resetCSS};
    position: relative;

    &:hover > ul {
        display: block;
    }
`;
const positionBottomStyles = (moveBody) => Ce$1`
    left: 50%;
    top: calc(100% + ${halfSize});
    transform: translateX(calc(-50% + ${moveBody || 0}px));

    &:before {
        height: ${halfSize};
        left: 0;
        top: -${halfSize};
        width: 100%;
    }

    &:after {
        left: calc((50% - ${halfSize}) - ${moveBody || 0}px);
        top: -6px;
    }
`;
const positionTopStyles = (moveBody) => Ce$1`
    left: 50%;
    bottom: calc(100% + ${halfSize});
    transform: translateX(calc(-50% + ${moveBody || 0}px));

    &:before {
        bottom: -${halfSize};
        height: ${halfSize};
        left: 0;
        width: 100%;
    }

    &:after {
        left: calc((50% - ${halfSize}) - ${moveBody || 0}px);
        bottom: -6px;
    }
`;
const positionRightStyles = (moveBody) => Ce$1`
    left: calc(100% + ${halfSize});
    top: 50%;
    transform: translateY(calc(-50% + ${moveBody || 0}px));

    &:before {
        height: 100%;
        left: -${halfSize};
        top: 0;
        width: ${halfSize};
    }

    &:after {
        top: calc((50% - ${halfSize}) - ${moveBody || 0}px);
        left: -2px;
    }
`;
const positionLeftStyles = (moveBody) => Ce$1`
    right: calc(100% + ${halfSize});
    top: 50%;
    transform: translateY(calc(-50% + ${moveBody || 0}px));

    &:before {
        height: 100%;
        right: -${halfSize};
        top: 0;
        width: ${halfSize};
    }

    &:after {
        top: calc((50% - ${halfSize}) - ${moveBody || 0}px);
        right: -2px;
    }
`;
const setPosition = (position, moveBody) => {
  switch (position) {
    case "top":
      return positionTopStyles(moveBody);
    case "left":
      return positionLeftStyles(moveBody);
    case "right":
      return positionRightStyles(moveBody);
    default:
      return positionBottomStyles(moveBody);
  }
};
const ListStyled$1 = styled$1.ul`
    ${resetCSS};
    background-color: ${(p2) => `${p2.backgroundColor}`};
    border-radius: ${size};
    display: none;
    list-style: none;
    min-width: ${(p2) => `${p2.width}`};
    padding: 8px;
    position: absolute;
    ${(p2) => p2.position && setPosition(p2.position, p2.moveBody)};

    &:hover {
        display: block;
    }

    li {
        ${resetCSS};
        display: block;
        list-style: none;
        position: relative;
        z-index: 2;
    }

    &:before {
        // dead-zone buffer to prevent off-hover bug
        background-color: transparent;
        content: '';
        display: block;
        position: absolute;
        // dynamic values come from setPosition()
    }

    &:after {
        // the tail of the popover box
        background-color: ${(p2) => `${p2.backgroundColor}`};
        content: '';
        display: block;
        height: ${size};
        position: absolute;
        transform: rotate(45deg);
        width: ${size};
        z-index: 1;
        // dynamic values come from setPosition()
    }
`;
var styles$5 = {
  DivStyled: DivStyled$c,
  ListStyled: ListStyled$1,
  halfSize
};
const depreciatedWarning = (description) => {
  console.log("--------");
  console.log("DEPRECIATION WARNING!");
  console.log(`${description} has been depreciated, you should remove this from your code as it will soon be fully removed and will cause breaks in your app / dapp`);
  console.log("Thanks for using the kit, you can reach us anytime at Discord > Moralis DAO > web3uiKit");
  console.log("http://moralis.io/discord");
  console.log("--------");
};
const {
  DivStyled: DivStyled$b,
  ListStyled
} = styles$5;
const PopoverDropdown = ({
  backgroundColor = color.blueDark,
  children,
  id,
  move,
  moveBody,
  parent,
  position = "bottom",
  width = "150px",
  ...props
}) => {
  if (move) {
    depreciatedWarning("move prop in PopoverDropdown");
  }
  return /* @__PURE__ */ jsxs(DivStyled$b, {
    "aria-haspopup": "true",
    "data-comp": "PopoverDropdown",
    "data-testid": "test-popover-dropdown",
    id,
    ...props,
    children: [parent, /* @__PURE__ */ jsx(ListStyled, {
      backgroundColor,
      "data-testid": "test-popover-dropdown-list",
      moveBody,
      position,
      role: "menu",
      width,
      children: children.map((child, index) => {
        return /* @__PURE__ */ jsx("li", {
          "data-testid": "test-popover-dropdown-child",
          children: child
        }, `dropdown-element-${index}`);
      })
    })]
  });
};
const DivContainerStyled$1 = styled$1.div`
    background: ${(p2) => p2.backgroundColor ? p2.backgroundColor : ""};
    cursor: pointer;
    display: inline-block;
`;
const DivStyled$a = styled$1.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    padding-left: 16px;
    padding-right: 16px;
    height: ${(p2) => p2.height ? `${p2.height}px` : "auto"};
    width: ${(p2) => p2.width ? `${p2.width}px` : "auto"};
`;
const DivImageStyled$1 = styled$1.div`
    align-items: center;
    display: flex;
    width: 24px;
    height: 24px;
    margin: auto 0;
    padding-right: 8px;
`;
const TextStyled$1 = styled$1.p`
    ${fonts.openSans};
    ${fonts.textBold};
    color: ${(p2) => p2.textColor ? p2.textColor : color.white};
    font-size: ${(p2) => p2.textSize ? `${p2.textSize}px` : ""};
    overflow: hidden;
    text-overflow: ellipsis;
`;
var PopoverElementStyles = {
  DivContainerStyled: DivContainerStyled$1,
  DivImageStyled: DivImageStyled$1,
  DivStyled: DivStyled$a,
  TextStyled: TextStyled$1
};
const {
  DivContainerStyled,
  DivStyled: DivStyled$9,
  DivImageStyled,
  TextStyled
} = PopoverElementStyles;
const PopoverElement = ({
  backgroundColor = "transparent",
  height,
  icon = /* @__PURE__ */ jsx(SvgCheck, {
    fontSize: 20,
    title: "check icon",
    titleId: "popover element check icon"
  }),
  iconColor = "white",
  iconSize = 20,
  id,
  onClick,
  text: text2 = "Text",
  textColor = "white",
  textSize = 14,
  width,
  ...props
}) => {
  return /* @__PURE__ */ jsx(DivContainerStyled, {
    backgroundColor,
    "data-testid": "test-dropdown-element",
    icon,
    iconColor,
    id,
    ...props,
    children: /* @__PURE__ */ jsxs(DivStyled$9, {
      "data-testid": "test-dropdown-element-click",
      height,
      onClick: () => {
        {
          onClick ? onClick() : "";
        }
      },
      width,
      children: [icon ? /* @__PURE__ */ jsx(DivImageStyled, {
        children: icon
      }) : "", /* @__PURE__ */ jsx(TextStyled, {
        "data-testid": "test-dropdown-element-text",
        textColor,
        textSize,
        children: text2
      })]
    })
  });
};
const getConfig = (breakPointConfig, toGet, span) => {
  if (Object.keys(breakPointConfig).includes(toGet)) {
    return breakPointConfig[toGet];
  }
  return span;
};
const RowDiv$1 = styled$1.div`
  ${fonts.text}
  display: flex;
  flex-wrap: wrap;
  align-items: ${(props) => props.alignItems && props.alignItems};
  gap: ${(props) => props.rowGap ? `${props.rowGap}px ${props.colGap}px` : "15px 15px"};
  justify-content: ${(props) => props.justifyItems && props.justifyItems};
  margin-left: ${(props) => props.colGap && `${props.colGap / 2}px`};
  width: ${(props) => `${props.width && `${props.width}px`} `};
`;
const ColDiv$1 = styled$1.div`
  color: white;
  order: ${(props) => props.order};
  ${fonts.text}
  // xSmall devices (landscape phones, 576px and up)
        @media (max-width: 767px) {
    flex: ${(props) => props.span ? `${100 / (props.xs ? props.xs : 0) * getConfig(props.breakpointsConfig, "xs", props.span)}%` : "100%"};

    max-width: ${(props) => props.span ? `calc(${100 / (props.xs ? props.xs : 0) * getConfig(props.breakpointsConfig, "xs", props.span)}% - ${props.colGap}px)` : "100%"};
    ${(props) => props.isFullWidth && "max-width: 100%; flex: 100%;"}
  }

  // sm devices (tablets, 768px and up)
  @media (min-width: 768px) and (max-width: 991px) {
    color: black;
    flex: ${(props) => props.span ? `${100 / (props.sm ? props.sm : 0) * getConfig(props.breakpointsConfig, "sm", props.span)}%` : "100%"};

    max-width: ${(props) => props.span ? `calc(${100 / (props.sm ? props.sm : 0) * getConfig(props.breakpointsConfig, "sm", props.span)}% - ${props.colGap}px)` : "100%"};
    ${(props) => props.isFullWidth && "max-width: 100%; flex: 100%;"}
  }

  // Meduim(desktops, 992px and up)
  @media (min-width: 992px) and (max-width: 1199px) {
    flex: ${(props) => props.span ? `${getConfig(props.breakpointsConfig, "md", props.span) * (100 / (props.md ? props.md : 0))}%` : "100%"};

    max-width: ${(props) => props.span ? `calc(${100 / (props.md ? props.md : 0) * getConfig(props.breakpointsConfig, "md", props.span)}% - ${props.colGap}px)` : "100%"};
    ${(props) => props.isFullWidth && "max-width: 100%; flex: 100%;"}
  }

  // large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {
    flex: ${(props) => props.span ? `${100 / (props.lg ? props.lg : 0) * getConfig(props.breakpointsConfig, "lg", props.span)}%` : "90%"};

    max-width: ${(props) => props.span ? `calc(${100 / (props.lg ? props.lg : 0) * getConfig(props.breakpointsConfig, "lg", props.span)}% - ${props.colGap}px )` : "90%"};

    ${(props) => props.isFullWidth && "max-width: 100%; flex: 100%;"}
  }
`;
var styles$4 = {
  ColDiv: ColDiv$1,
  RowDiv: RowDiv$1
};
const {
  ColDiv,
  RowDiv
} = styles$4;
const Context = createContext({
  lg: 0,
  md: 0,
  sm: 0,
  xs: 0,
  rowGap: 15,
  colGap: 15
});
function Col({
  breakpointsConfig = {},
  children,
  isFullWidth = false,
  order = 0,
  span = 0,
  ...props
}) {
  const prov = useContext(Context);
  return /* @__PURE__ */ jsx(ColDiv, {
    breakpointsConfig,
    colGap: prov.colGap,
    "data-testid": "test-row-col",
    isFullWidth,
    lg: prov.lg,
    md: prov.md,
    order,
    role: "col",
    rowGap: prov.rowGap,
    sm: prov.sm,
    span,
    xs: prov.xs,
    ...props,
    children
  });
}
function Row({
  alignItems = "start",
  justifyItems = "flex-start",
  colGap = 15,
  rowGap = 15,
  children,
  xs = 8,
  sm = 16,
  md = 24,
  lg = 24,
  width,
  ...props
}) {
  return /* @__PURE__ */ jsx(Context.Provider, {
    value: {
      xs,
      md,
      sm,
      lg,
      rowGap,
      colGap
    },
    children: /* @__PURE__ */ jsx(RowDiv, {
      alignItems,
      colGap,
      "data-testid": "test-row",
      justifyItems,
      rowGap,
      width,
      ...props,
      children
    })
  });
}
Row.Col = Col;
const DivStyled$8 = styled$1.div`
  ${resetCSS};
  animation: progress 1.5s linear infinite;
  background: ${color.white} no-repeat;
  background-image: ${gradientColors.lightGrey};
  background-size: 200px 100%;
  box-sizing: border-box;
  display: inline-block;
  flex-shrink: 0;
  outline: none;
  overflow: hidden;
  position: relative;
  border-radius: ${({ borderRadius }) => borderRadius};
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  &:after,
  &:before {
    box-sizing: border-box;
  }
  @keyframes progress {
    0% {
      background-position: -300px 0;
    }
    100% {
      background-position: calc(300px + 100%) 0;
    }
  }
`;
const getDefault = (theme) => {
  switch (theme) {
    case "image":
      return {
        width: "60px",
        height: "60px"
      };
    case "subtitle":
      return {
        width: "100%",
        height: "10px"
      };
    case "text":
      return {
        width: "100%",
        height: "20px"
      };
    default:
      return {
        width: "100%",
        height: "20px"
      };
  }
};
const Skeleton = ({
  borderRadius = "10px",
  theme,
  height = getDefault(theme).height,
  width = getDefault(theme).width,
  ...props
}) => {
  return /* @__PURE__ */ jsx(DivStyled$8, {
    borderRadius,
    "data-testid": "test-skeleton",
    height,
    theme,
    width,
    ...props
  });
};
const SectionStyled$3 = styled$1.section`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  position: relative;
`;
const OrderedListStyled$1 = styled$1.ol`
  ${resetCSS};
  align-items: center;
  display: flex;
  justify-content: space-between;
  list-style: none;
  margin-bottom: 24px;
  position: relative;
  text-align: center;
  width: 100%;
`;
const ListItemStyled$1 = styled$1.li`
  ${resetCSS};
  ${fonts.text};
  align-items: center;
  border-radius: 50%;
  border: 2px solid ${color.green};
  color: ${color.white};
  display: flex;
  font-size: 24px;
  height: 32px;
  justify-content: center;
  line-height: 0;
  position: relative;
  width: 32px;

  background-color: ${(p2) => p2.activeStep <= p2.thisStep ? color.green : color.white};
  opacity: ${(p2) => p2.activeStep < p2.thisStep ? "50%" : "100%"};
`;
const SpanStyled$1 = styled$1.span`
  background-color: rgba(46, 125, 175, 0.3);
  border: none;
  display: block;
  height: 2px;

  &:last-of-type {
    display: none;
  }

  width: calc((100% / ${(p2) => p2.stepTotal - 1}) - (${(p2) => p2.stepTotal === 2 ? "90px" : "64px"}));
`;
const DivStyled$7 = styled$1.div`
  text-align: center;

  & > div[role='spinner'] {
    margin: 30px auto;
  }
`;
const DivStyledContent$2 = styled$1.div`
  ${resetCSS};
  ${fonts.text};
  display: inline-block;
  margin: 20px 20px 32px;
  p,
  i {
    ${resetCSS};
    ${fonts.text};
  }

  :hover {
    display: inline-block;
    height: auto;
  }
`;
const NavStyled$1 = styled$1.nav`
  display: flex;
  justify-content: center;
  margin-top: 12px;

  button {
    margin: 0 12px;
  }
`;
const FooterStyled$1 = styled$1.footer``;
const DivStyledHelper$1 = styled$1.div`
  margin-top: 26px;
  text-align: center;

  p,
  i,
  span {
    ${fonts.text};
    font-size: 12px;
  }

  img,
  button {
    margin: 0 auto;
  }
`;
const HeaderStyled$1 = styled$1.header`
  ${(p2) => p2.headerWidth && `max-width: ${p2.headerWidth}px`};
  width: 100%;
`;
var HeaderStyles = {
  DivStyled: DivStyled$7,
  DivStyledContent: DivStyledContent$2,
  DivStyledHelper: DivStyledHelper$1,
  FooterStyled: FooterStyled$1,
  HeaderStyled: HeaderStyled$1,
  ListItemStyled: ListItemStyled$1,
  NavStyled: NavStyled$1,
  OrderedListStyled: OrderedListStyled$1,
  SectionStyled: SectionStyled$3,
  SpanStyled: SpanStyled$1
};
const {
  DivStyled: DivStyled$6,
  DivStyledHelper,
  FooterStyled,
  ListItemStyled,
  NavStyled,
  OrderedListStyled,
  SectionStyled: SectionStyled$2,
  SpanStyled,
  HeaderStyled
} = HeaderStyles;
const Stepper = ({
  step = 0,
  stepData,
  hasNavButtons = true,
  helperContent,
  completeTitle = "all done, nice!",
  completeMessage = "You should tell the user what to do next, or use the onComplete function to programmatically fire an event",
  onComplete = () => null,
  headerWidth,
  ...props
}) => {
  const [activeStep, setActiveStep] = useState(step);
  const myStepRef = useRef(activeStep);
  useEffect(() => {
    document.addEventListener("prev", prevStep);
    document.addEventListener("next", nextStep);
    return () => {
      document.removeEventListener("prev", prevStep);
      document.removeEventListener("next", nextStep);
    };
  }, []);
  const setStep = (data) => {
    myStepRef.current = data;
    setActiveStep(data);
  };
  const prevStep = () => {
    if (myStepRef.current <= 1)
      return;
    setStep(myStepRef.current - 1);
  };
  const nextStep = () => {
    if (activeStep === stepData.length + 1) {
      onComplete();
      return;
    }
    setStep(myStepRef.current + 1);
  };
  const handleContentClick = (event) => {
    const target = event.target;
    if (!target.id)
      return;
    if (target.id === "prev")
      prevStep();
    if (target.id === "next")
      nextStep();
    return;
  };
  const renderPreloader = () => /* @__PURE__ */ jsxs(DivStyled$6, {
    children: [/* @__PURE__ */ jsx(Typography, {
      children: "Just one sec...",
      "data-testid": "test-stepper-title",
      variant: "h2"
    }), /* @__PURE__ */ jsx(Loading, {
      size: 20,
      spinnerColor: color.green
    })]
  });
  const renderContent = () => {
    var _a, _b;
    return /* @__PURE__ */ jsxs(DivStyled$6, {
      id: `step-${activeStep}`,
      children: [/* @__PURE__ */ jsx("div", {
        id: "stepper-title",
        "data-testid": "test-stepper-title",
        children: activeStep <= stepData.length ? /* @__PURE__ */ jsx(Typography, {
          children: ((_a = stepData[Number(activeStep - 1)]) == null ? void 0 : _a.title) || "",
          variant: "h2"
        }) : /* @__PURE__ */ jsx(Typography, {
          variant: "h2",
          children: completeTitle
        })
      }), /* @__PURE__ */ jsx("div", {
        onClick: handleContentClick,
        "data-testid": "test-stepper-content",
        id: "stepper-content",
        children: activeStep <= stepData.length ? /* @__PURE__ */ jsx(Typography, {
          children: (_b = stepData[Number(activeStep - 1)]) == null ? void 0 : _b.content
        }) : completeMessage
      })]
    });
  };
  const renderStepperNumbers = () => /* @__PURE__ */ jsx(OrderedListStyled, {
    "data-testid": "test-stepper-numbers",
    children: stepData.map((step2, index) => /* @__PURE__ */ jsxs(Fragment$1, {
      children: [/* @__PURE__ */ jsx(ListItemStyled, {
        activeStep,
        "aria-label": `step ${Number(index + 1)} ${step2.title}`,
        stepTotal: stepData.length,
        thisStep: Number(index + 1),
        children: activeStep <= Number(index + 1) ? Number(index + 1) : /* @__PURE__ */ jsx(SvgCheck, {
          title: "check icon",
          titleId: "stepper check icon",
          fill: color.green,
          fontSize: 15
        })
      }), /* @__PURE__ */ jsx(SpanStyled, {
        activeStep,
        stepTotal: stepData.length,
        thisStep: Number(index + 1),
        "aria-hidden": "true"
      })]
    }, `step_${index}`))
  });
  return /* @__PURE__ */ jsxs(SectionStyled$2, {
    "data-testid": "test-stepper",
    ...props,
    children: [/* @__PURE__ */ jsx(HeaderStyled, {
      headerWidth,
      style: {
        alignSelf: "center"
      },
      children: renderStepperNumbers()
    }), activeStep === 0 ? renderPreloader() : renderContent(), /* @__PURE__ */ jsxs(FooterStyled, {
      children: [hasNavButtons && /* @__PURE__ */ jsxs(NavStyled, {
        "data-testid": "test-stepper-nav",
        children: [/* @__PURE__ */ jsx(Button, {
          disabled: activeStep === 0,
          onClick: prevStep,
          text: "Prev",
          theme: "secondary",
          type: "button"
        }), /* @__PURE__ */ jsx(Button, {
          disabled: activeStep === 0,
          onClick: nextStep,
          text: activeStep === stepData.length + 1 ? "Done!" : "Next",
          theme: "primary",
          type: "button"
        })]
      }), helperContent && /* @__PURE__ */ jsx(DivStyledHelper, {
        "data-testid": "test-stepper-helper",
        children: helperContent
      })]
    })]
  });
};
const getModuleAnimation = (module) => {
  switch (module) {
    case "Token":
      return /* @__PURE__ */ jsx(Illustration, {
        logo: "token",
        width: "100%",
        height: "180px"
      });
    case "NFT Marketplace":
      return /* @__PURE__ */ jsx(Illustration, {
        logo: "marketplace",
        width: "100%",
        height: "180px"
      });
    case "NFT Collection":
      return /* @__PURE__ */ jsx(Illustration, {
        logo: "chest",
        width: "100%",
        height: "180px"
      });
    case "Bundle":
      return /* @__PURE__ */ jsx(Illustration, {
        logo: "bundle",
        width: "100%",
        height: "180px"
      });
    case "Lazy NFT":
      return /* @__PURE__ */ jsx(Illustration, {
        logo: "lazyNft",
        width: "100%",
        height: "180px"
      });
    case "Pack":
      return /* @__PURE__ */ jsx(Illustration, {
        logo: "pack",
        width: "100%",
        height: "180px"
      });
    default:
      return /* @__PURE__ */ jsx(Illustration, {
        logo: "servers",
        width: "100%",
        height: "180px"
      });
  }
};
function paginate(totalItems, currentPage = 1, pageSize = 10, maxPages = 10) {
  const totalPages = Math.ceil(totalItems / pageSize);
  if (currentPage < 1) {
    currentPage = 1;
  } else if (currentPage > totalPages) {
    currentPage = totalPages;
  }
  let startPage;
  let endPage;
  if (totalPages <= maxPages) {
    startPage = 1;
    endPage = totalPages;
  } else {
    const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
    const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
    if (currentPage <= maxPagesBeforeCurrentPage) {
      startPage = 1;
      endPage = maxPages;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      startPage = totalPages - maxPages + 1;
      endPage = totalPages;
    } else {
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  }
  const pages = Array.from(Array(endPage + 1 - startPage).keys()).map((i) => startPage + i);
  return pages;
}
function getInnerText(obj) {
  let buf = "";
  if (obj === null)
    return null;
  if (obj) {
    const type = typeof obj;
    if (type === "string" || type === "number") {
      buf += obj;
    } else if (type === "object") {
      let children = null;
      if (Array.isArray(obj)) {
        children = obj;
      } else {
        const props = obj.props;
        if (props) {
          children = props.children;
        }
      }
      if (children) {
        if (Array.isArray(children)) {
          children.forEach((o) => {
            buf += getInnerText(o);
          });
        } else {
          buf += getInnerText(children);
        }
      }
    }
  }
  return buf;
}
const TableParent = styled$1.div`
  display: flex;
  flex-direction: column;
`;
const NoData = styled$1.div`
  ${resetCSS}
  ${fonts.text}
    display: grid;
  min-height: fit-content;
  align-items: flex-start;
  justify-content: center;
  grid-column: 1 / -1;
  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
`;
const Divider = styled$1.div`
  padding-top: 1px;
  background: radial-gradient(106.45% 108.64% at 32.33% -4.84%, #ecf5fc 0.52%, #cee4f3 100%);
  grid-column: 1 / -1;
`;
const Pagination = styled$1.div`
  ${resetCSS}
  ${fonts.text}
    display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 12px 0px;
  > div {
    display: flex;
    flex-direction: row;
    min-width: 50px;
    justify-content: space-evenly;
    align-items: center;
  }
`;
const PaginationText = styled$1.div`
  cursor: ${(props) => props.isActive ? "pointer" : "cursor"};
  color: ${(props) => props.isActive ? color.blue : color.greyLight};
`;
const DivTableCell = styled$1.div`
  align-items: ${(props) => props.alignCellItems};
  justify-content: ${(props) => props.justifyCellItems};
  display: flex;
  padding: 16px 0;
`;
const TableGrid = styled$1.div.attrs((props) => ({
  columns: props.columns
}))`
  ${resetCSS}
  ${fonts.text}
    padding-bottom: 11px;
  border-radius: 20px;
  box-shadow: 0 4px 10px rgba(48, 71, 105, 0.1);
  background-color: white;
  display: grid;
  grid-template-columns: ${(props) => props.columns};
  // row-gap: 22px;
  column-gap: 11px;
  overflow: hidden;
  min-height: fit-content;
  min-width: fit-content;
  & > .firstCol {
    padding-left: 22px;
  }
  & > .lastCol {
    padding-right: 22px;
  }
  & > div.table_header {
    font-weight: 600;
    padding: 12px 0;

    &:first-of-type {
      padding-left: 22px;
    }
  }
`;
const TableGridContainer = styled$1.div`
  background: radial-gradient(106.45% 108.64% at 32.33% -4.84%, #ecf5fc 0.52%, #cee4f3 100%);
  border-radius: 20px;
  padding: 1px;
  position: relative;
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const PaginationTag = styled$1.div`
  width: 32px;
  height: 32px;
  border: 2px solid transparent;
  border-radius: 12px;
  margin: 0px 5px;
  display: grid;
  align-items: center;
  justify-content: center;
  border-color: ${(props) => props.active && color.blue};
  background-color: ${(props) => !props.active && "#EBEFF9"};
  cursor: ${(props) => !props.active && "pointer"};
`;
const DivSpinnerLoaderParent = styled$1.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-column: 1 / -1;
  & > h3 {
    margin-top: 29px;
  }
`;
const Table = ({
  alignCellItems = "start",
  columnsConfig,
  customLoadingContent,
  customNoDataComponent,
  customNoDataText = "No Data",
  customPageNumber,
  data,
  header,
  isColumnSortable = [],
  isLoading = false,
  justifyCellItems = "start",
  maxPages,
  noPagination,
  onPageNumberChanged,
  onRowClick,
  pageSize,
  ...props
}) => {
  const [pageNum, setPageNum] = useState(customPageNumber ? customPageNumber : 0);
  const [tableData, setTableData] = useState(data);
  const [sortField, setSortField] = useState(-1);
  const [order, setOrder] = useState("asc");
  useEffect(() => {
    if (typeof onPageNumberChanged != "undefined") {
      onPageNumberChanged(pageNum);
    }
  }, [pageNum]);
  useEffect(() => {
    setTableData(data);
    setPageNum(0);
  }, [data]);
  useEffect(() => {
    handleSetPageNumber(customPageNumber ? customPageNumber : 0);
  }, [customPageNumber]);
  const handleSetPageNumber = (state) => {
    if (typeof customPageNumber == "number") {
      setPageNum(customPageNumber);
    } else {
      setPageNum(state);
    }
  };
  const computeCurrentData = () => {
    if (noPagination) {
      return tableData;
    }
    const from = pageNum * pageSize;
    const to = from + pageSize;
    return tableData == null ? void 0 : tableData.slice(from, to);
  };
  const handlePrev = () => {
    if (pageNum != 0) {
      handleSetPageNumber(pageNum - 1);
    }
  };
  const handleNext = () => {
    if (pageNum + 1 < Math.ceil((tableData == null ? void 0 : tableData.length) / pageSize)) {
      handleSetPageNumber(pageNum + 1);
    }
  };
  const handleSortingChange = (fieldId) => {
    if (isColumnSortable.length !== 0 && isColumnSortable.length > fieldId && !isLoading && isColumnSortable[fieldId]) {
      const sortOrder = fieldId === sortField && order === "asc" ? "desc" : "asc";
      setSortField(fieldId);
      setOrder(sortOrder);
      handleSorting(fieldId, sortOrder);
    }
  };
  const handleSorting = (fieldId, sortOrder) => {
    const sorted = [...data].sort((a, b2) => {
      let x2 = getInnerText(a[fieldId]);
      let y2 = getInnerText(b2[fieldId]);
      if (!x2 && !y2)
        return 0;
      if (!x2)
        return 1;
      if (!y2)
        return -1;
      const pattern = /(\d{2})\/(\d{2})\/(\d{4})(.*)/g;
      if (pattern.test(x2)) {
        x2 = x2.replace(pattern, "$3-$2-$1 $4");
      }
      if (pattern.test(y2)) {
        y2 = y2.replace(pattern, "$3-$2-$1 $4");
      }
      return x2.localeCompare(y2, "en", {
        numeric: true,
        sensitivity: "base"
      }) * (sortOrder === "asc" ? 1 : -1);
    });
    setTableData(sorted);
  };
  const RenderTableHeader = () => {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [header.map((col, key) => /* @__PURE__ */ jsx(Fragment$1, {
        children: /* @__PURE__ */ jsxs(DivTableCell, {
          role: "table-header",
          className: "table_header",
          "data-testid": "test-table-cell",
          alignCellItems,
          justifyCellItems,
          onClick: () => handleSortingChange(key),
          children: [col, sortField === key && (order === "asc" ? /* @__PURE__ */ jsx(SvgTriangleUp, {
            title: "triangle up icon",
            titleId: "table triangle up icon",
            fill: color.grey
          }) : /* @__PURE__ */ jsx(SvgTriangleDown, {
            title: "triangle down icon",
            titleId: "table triangle down icon",
            fill: color.grey
          }))]
        }, `header_${key}`)
      }, `header-wrap-${key}`)), /* @__PURE__ */ jsx(Divider, {})]
    });
  };
  const RenderNoData = () => {
    if (customNoDataComponent) {
      return /* @__PURE__ */ jsx(NoData, {
        children: customNoDataComponent
      });
    }
    return /* @__PURE__ */ jsx(NoData, {
      children: /* @__PURE__ */ jsxs("div", {
        children: [getModuleAnimation(void 0), /* @__PURE__ */ jsx("p", {
          children: customNoDataText
        })]
      })
    });
  };
  const RenderTable = () => {
    if (tableData && computeCurrentData().length == 0) {
      return /* @__PURE__ */ jsx(RenderNoData, {});
    }
    return /* @__PURE__ */ jsx(Fragment, {
      children: tableData && computeCurrentData().map((row, rowKey, arr) => /* @__PURE__ */ jsxs(Fragment$1, {
        children: [row.map((item, colKey, rowData) => /* @__PURE__ */ jsx(DivTableCell, {
          "data-key": `tr_${rowKey}_${colKey}`,
          role: "table-item",
          className: `${colKey == 0 && "firstCol"} ${colKey == rowData.length - 1 && "lastCol"}`,
          alignCellItems,
          justifyCellItems,
          onClick: (e2) => {
            if (onRowClick && e2.target === e2.currentTarget) {
              onRowClick(rowKey + pageSize * pageNum);
            }
          },
          children: item
        }, `tr_${rowKey}_${colKey}`)), rowKey != arr.length - 1 && /* @__PURE__ */ jsx(Divider, {}, `divider_${rowKey}`)]
      }, `fragment_${rowKey}`))
    });
  };
  const RenderPagination = () => {
    if (noPagination || (tableData == null ? void 0 : tableData.length) == 0) {
      return /* @__PURE__ */ jsx(Fragment, {});
    }
    return /* @__PURE__ */ jsx(Pagination, {
      children: /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx(PaginationText, {
          "data-testid": "test-table-pagination-prev",
          isActive: pageNum != 0,
          onClick: handlePrev,
          children: "Prev"
        }), paginate(tableData == null ? void 0 : tableData.length, pageNum, pageSize, maxPages).map((key) => /* @__PURE__ */ jsx(PaginationTag, {
          "data-testid": `test-table-pagination-${key - 1 == pageNum}`,
          active: key - 1 == pageNum,
          onClick: () => handleSetPageNumber(key - 1),
          role: "pagination-item",
          children: /* @__PURE__ */ jsx("span", {
            children: key
          })
        }, `pagination_${key}`)), /* @__PURE__ */ jsx(PaginationText, {
          "data-testid": "test-table-pagination-next",
          isActive: pageNum + 1 < Math.ceil((tableData == null ? void 0 : tableData.length) / pageSize),
          onClick: handleNext,
          children: "Next"
        })]
      })
    });
  };
  const Loader = () => /* @__PURE__ */ jsx(DivSpinnerLoaderParent, {
    children: customLoadingContent ? customLoadingContent : /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Loading, {
        spinnerType: "wave",
        spinnerColor: "#B0B5BF",
        size: 6
      }), /* @__PURE__ */ jsx(Typography, {
        weight: "400",
        variant: "h3",
        color: "#B0B5BF",
        children: "Loading Content"
      })]
    })
  });
  return /* @__PURE__ */ jsxs(TableParent, {
    "data-testid": "test-table",
    ...props,
    children: [/* @__PURE__ */ jsx(TableGridContainer, {
      children: /* @__PURE__ */ jsxs(TableGrid, {
        columns: columnsConfig,
        children: [/* @__PURE__ */ jsx(RenderTableHeader, {}), isLoading ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsx(RenderTable, {})]
      })
    }), /* @__PURE__ */ jsx(RenderPagination, {})]
  });
};
const StyleTabBarParent = styled$1.div`
    ${resetCSS}
    ${fonts.text}
    min-height: fit-content;
    display: flex;
    flex-direction: row;
    ${(props) => !props.isVertical && "flex-direction:column"}
`;
const StyledTabBar = styled$1.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    max-height: fit-content;
    min-width: fit-content;
    row-gap: 5px;
    ${(props) => props.isVertical && "flex-direction: column;"}

    ${(props) => props.haveBackground && !props.isVertical && Ce$1`
            & > span {
                background-color: ${color.blueCultured};
            }
            & > span:first-child {
                border-radius: 16px 0 0 16px;
            }

            & > span:last-child {
                border-radius: 0 16px 16px 0;
            }
        `};
    ${(props) => props.haveBackground && props.isVertical && Ce$1`
            background-color: ${color.blueCultured};
            border-radius: 16px;
        `};
    ${(props) => props.isWidthAuto && Ce$1`
            & > span {
                flex-grow: 1;
            }
        `}
`;
const StyledTabContent = styled$1.div`
    padding: ${(props) => props.isVertical ? "0px 11px" : "11px 0px"};
`;
const StyledTab = styled$1.div`
    transition-duration: 500ms;
    transition-property: border;
    transition-timing-function: ease-in-out;
    margin: 0px 48px 0px 0px;
    padding-bottom: 4px;
    line-height: 24px;
    padding-bottom: 4px;
    margin-bottom: 11px;

    cursor: pointer;
    ${(props) => props.isActive && "font-weight:600;"};
    ${(props) => props.isActive && "border-bottom: 2px solid #21BF96;"};
    ${(props) => (props.isActive || props.isDisabled) && "pointer-events: none;"};
    ${(props) => !props.isActive && `color:${color.greyIcons};`};
    line-height: ${(props) => props.lineHeight && `${props.lineHeight}px`};
    ${(props) => props.isDisabled && `color:${color.greyDisabled};`}
`;
const BulbTab = styled$1.div`
    transition-duration: 200ms;
    transition-timing-function: ease-in-out;
    border-radius: 16px;
    padding: 8px 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${color.blueCultured};
    border: 2px solid transparent;
    cursor: pointer;
    color: ${color.blue};
    min-width: fit-content;
    ${({ isActive }) => isActive && Ce$1`
            border-color: ${color.blueSky};
            background: ${color.white};
        `};
    ${(props) => props.isDisabled && "pointer-events: none;"};
    ${(props) => props.hasMargin && "margin-right:6px;"};
    ${(props) => props.isDisabled && `opacity: 0.5; background-color: ${color.white};`};
    line-height: ${(props) => props.lineHeight && `${props.lineHeight}px`};
    &:hover {
        background: ${color.blueLight2};
        ${({ isActive }) => isActive && Ce$1`
                background: ${gradientColors.beauBlue};
            `};
    }

    & > span {
        font-weight: 600;
        font-size: 14px;
        text-align: center;
    }
`;
const TabContext = createContext({
  selectedKey: 0,
  setSelectedKey: null,
  tabStyle: "bar"
});
const getTabs = (children) => {
  const data = {};
  Children.forEach(children, (element) => {
    if (element.type == Tab) {
      data[element.props.tabKey] = element.props.children;
    }
  });
  return data;
};
function TabList({
  children = /* @__PURE__ */ jsx(Fragment, {}),
  defaultActiveKey = 1,
  isVertical = false,
  isWidthAuto = false,
  onChange,
  tabStyle = "bar",
  ...props
}) {
  const [tabChildren, setTabChildren] = useState(getTabs(children));
  const [selectedKey, setSelectedKey] = useState(defaultActiveKey);
  useEffect(() => {
    if (onChange) {
      onChange(selectedKey);
    }
  }, [selectedKey]);
  useEffect(() => {
    setSelectedKey(defaultActiveKey);
  }, [defaultActiveKey]);
  useEffect(() => {
    setTabChildren(getTabs(children));
  }, [children]);
  return /* @__PURE__ */ jsx(TabContext.Provider, {
    value: {
      selectedKey,
      setSelectedKey,
      tabStyle
    },
    children: /* @__PURE__ */ jsxs(StyleTabBarParent, {
      isVertical,
      "data-testid": "test-tab-list",
      ...props,
      children: [/* @__PURE__ */ jsx(StyledTabBar, {
        haveBackground: tabStyle == "bulbUnion",
        isVertical,
        isWidthAuto,
        children
      }), /* @__PURE__ */ jsx(StyledTabContent, {
        isVertical,
        children: tabChildren[selectedKey]
      })]
    })
  });
}
function Tab({
  activeState,
  isDisabled = false,
  lineHeight = 24,
  tabKey,
  tabName
}) {
  const {
    selectedKey,
    setSelectedKey,
    tabStyle
  } = useContext(TabContext);
  const handleTabClick = (key) => {
    if (isDisabled) {
      return;
    }
    setSelectedKey(key);
  };
  const RenderBulbTab = () => {
    return /* @__PURE__ */ jsx(BulbTab, {
      role: "tab-Item",
      "data-testid": `test-tab-item-${tabKey}_${activeState ? activeState : tabKey == selectedKey}`,
      isActive: activeState ? activeState : tabKey == selectedKey,
      onClick: () => {
        handleTabClick(tabKey);
      },
      hasMargin: tabStyle == "bulbSeperate",
      lineHeight,
      isDisabled,
      children: /* @__PURE__ */ jsx("span", {
        children: tabName
      })
    }, tabKey);
  };
  const RenderBarTab = () => {
    return /* @__PURE__ */ jsx(StyledTab, {
      role: "tab-Item",
      "data-testid": `test-tab-item-${tabKey}_${activeState ? activeState : tabKey == selectedKey}`,
      isActive: activeState ? activeState : tabKey == selectedKey,
      onClick: () => {
        handleTabClick(tabKey);
      },
      lineHeight,
      isDisabled,
      children: /* @__PURE__ */ jsx("span", {
        "data-testid": `test-tab-disabled-${isDisabled}_${tabKey}`,
        children: tabName
      })
    }, tabKey);
  };
  return /* @__PURE__ */ jsx("span", {
    "data-testid": "test-tabs",
    children: tabStyle == "bar" ? /* @__PURE__ */ jsx(RenderBarTab, {}) : /* @__PURE__ */ jsx(RenderBulbTab, {})
  });
}
TabList.Tab = Tab;
const DivStyled$5 = styled$1.section`
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
    flex-wrap: wrap;
`;
const DivStyledContent$1 = styled$1.div`
    display: flex;
    flex-direction: ${({ fullWidth }) => fullWidth ? "column" : "row"};
    flex-wrap: wrap;
    gap: 16px;
`;
const SectionStyled$1 = styled$1.section`
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    padding: 16px;
`;
var styles$3 = {
  DivStyled: DivStyled$5,
  DivStyledContent: DivStyledContent$1,
  SectionStyled: SectionStyled$1
};
const {
  DivStyled: DivStyled$4,
  DivStyledContent,
  SectionStyled
} = styles$3;
const colors = ["green", "grey", "yellow", "blue", "blueLight", "purple", "pink"];
const Todo = ({
  buttonText = "Add",
  fullWidth = false,
  label,
  onChange,
  pattern,
  todos = [],
  ...props
}) => {
  const key = useMemo(() => Math.random(), []);
  const [inputValue, setInputValue] = useState("");
  const [isInputValid, setIsInputValid] = useState(false);
  const [lists, setLists] = useState(todos);
  useEffect(() => onChange && onChange(lists), [lists]);
  useEffect(() => setLists(todos), [todos]);
  useEffect(() => {
    const expression = new RegExp(pattern || "(.*?)");
    setIsInputValid(expression.test(inputValue));
  }, [inputValue]);
  const removeTodo = (id) => {
    const updatedList = lists.filter((item) => item !== lists[id]);
    setLists([...updatedList]);
  };
  const addTodo = () => {
    if (inputValue == "")
      return;
    setLists((prevTodo) => Array.from(/* @__PURE__ */ new Set([...prevTodo, inputValue])));
    setInputValue("");
    const input = document.querySelector(`input[key="${key}"]`);
    input == null ? void 0 : input.focus();
  };
  return /* @__PURE__ */ jsxs(SectionStyled, {
    "data-testid": "test-todo",
    ...props,
    children: [/* @__PURE__ */ jsxs(DivStyled$4, {
      children: [/* @__PURE__ */ jsx(Input, {
        "data-testid": "test-todo-input",
        id: "todo-input",
        label,
        onChange: (e2) => setInputValue(e2.target.value),
        size: "large",
        validation: {
          regExp: pattern
        },
        value: inputValue
      }, key), /* @__PURE__ */ jsx(Button, {
        "data-testid": "test-todo-button",
        disabled: !isInputValid,
        icon: /* @__PURE__ */ jsx(SvgPlus, {
          title: "plus icon",
          titleId: "todo plus icon",
          fontSize: 14
        }),
        onClick: addTodo,
        size: "large",
        text: buttonText,
        theme: "primary"
      })]
    }), /* @__PURE__ */ jsx(DivStyledContent, {
      "data-testid": "test-todo-content",
      fullWidth,
      children: lists.map((todo, i) => /* @__PURE__ */ jsx(Tag, {
        color: i < colors.length ? colors[i] : colors[i % colors.length],
        hasCancel: true,
        onCancelClick: () => removeTodo(i),
        text: todo,
        theme: "chips"
      }, i))
    })]
  });
};
const DivStyled$3 = styled$1.div`
    ${resetCSS};
    align-items: center;
    background: ${color.white};
    border-radius: 13px;
    border: 2px dashed ${color.blueSky};
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    min-height: 160px;
    overflow: hidden;
    padding: 8px;
    position: relative;
    text-align: center;
    user-select: none;
    width: 100%;
    ${(props) => !props.isFileSelected && Ce$1`
            &:hover {
                background: radial-gradient(
                    102.8% 102.8% at 3.14% -9.06%,
                    #e9fffc 0%,
                    #e8fefb 4.74%,
                    #e4f4f7 50.11%,
                    #e1eef4 83.07%,
                    #e0ecf3 100%
                );
            }
        `}

    ${(props) => !props.isFileSelected && Ce$1`
            &:active {
                background: radial-gradient(
                    102.8% 102.8% at 3.14% -9.06%,
                    #d3fff8 0%,
                    #d2fdf7 4.74%,
                    #c8e9ef 50.11%,
                    #c2dde9 83.07%,
                    #c0d8e7 100%
                );
            }
        `}
`;
const TextContentStyled$1 = styled$1.div`
    ${resetCSS};
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
`;
const InputStyled$3 = styled$1.input`
    display: none;
`;
const ImageStyled$1 = styled$1.img`
    border-radius: 8px;
    height: 144px;
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
`;
const IconDivStyled$1 = styled$1.div`
    cursor: pointer;
    position: absolute;
    top: 8px;
    right: 8px;
`;
var styles$2 = {
  DivStyled: DivStyled$3,
  TextContentStyled: TextContentStyled$1,
  InputStyled: InputStyled$3,
  ImageStyled: ImageStyled$1,
  IconDivStyled: IconDivStyled$1
};
const {
  DivStyled: DivStyled$2,
  IconDivStyled,
  ImageStyled,
  InputStyled: InputStyled$2,
  TextContentStyled
} = styles$2;
const Upload = ({
  onChange,
  theme = "withIcon"
}) => {
  const [fileSelected, setFileSelected] = useState(null);
  const inputFile = useRef(null);
  const onClickHandler = () => {
    inputFile.current && inputFile.current.click();
  };
  const onChangeFile = (event) => {
    event.preventDefault();
    const file = event.target.files && event.target.files[0];
    setFileSelected(file);
    onChange && onChange(file);
  };
  const onDropHandler = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    setFileSelected(file);
  };
  return /* @__PURE__ */ jsxs(DivStyled$2, {
    "data-testid": "test-upload",
    isFileSelected: Boolean(fileSelected),
    onClick: onClickHandler,
    onDragOver: (e2) => e2.preventDefault(),
    onDrop: onDropHandler,
    children: [fileSelected === null && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(InputStyled$2, {
        "data-testid": "test-upload-input",
        id: "file",
        onChange: onChangeFile,
        ref: inputFile,
        type: "file"
      }), theme === "textOnly" && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsxs(Typography, {
          variant: "h4",
          weight: "400",
          children: ["Drag & Drop File ", /* @__PURE__ */ jsx("br", {}), " or"]
        }), /* @__PURE__ */ jsx(Typography, {
          color: color.blue,
          variant: "body16",
          weight: "500",
          children: "Browse Files"
        })]
      }), theme === "withIcon" && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(SvgImage, {
          "data-testid": "test-upload-icon",
          fill: color.blueSky,
          fontSize: 48
        }), /* @__PURE__ */ jsxs(TextContentStyled, {
          children: [/* @__PURE__ */ jsx(Typography, {
            color: color.blue,
            variant: "body16",
            children: "Click or Drag File to Upload"
          }), /* @__PURE__ */ jsx(Typography, {
            variant: "caption12",
            weight: "400",
            children: "Recommendation: minimum of 350px by 350px"
          })]
        })]
      })]
    }), fileSelected && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(ImageStyled, {
        alt: "image",
        src: URL.createObjectURL(fileSelected)
      }), /* @__PURE__ */ jsx(IconDivStyled, {
        onClick: () => setFileSelected(null),
        children: /* @__PURE__ */ jsx(SvgBin, {
          "data-testid": "test-upload-icon",
          fill: color.blue,
          fontSize: 24
        })
      })]
    })]
  });
};
const globalStyles = {
  height: "92px",
  spacing: "12px",
  width: "92.8px"
};
const DivStyledWrapper$1 = styled$1.div`
  ${resetCSS};
  display: flex;
  flex-wrap: wrap;
  gap: ${globalStyles.spacing};
  justify-content: flex-start;
  margin: 10px 0px 4px 0px;
  position: relative;
  width: 100%;
  @media only screen and (max-width: 420px) {
    gap: 5px;
  }
`;
const InputStyled$1 = styled$1.input`
  ${resetCSS};
  ${fonts.openSans};
  border-radius: 20px;
  border: 0;
  box-shadow: inset 0 0 0 1px ${color.greyLight};
  color: ${color.blueDark};
  font-size: 18px;
  font-weight: 600;
  height: ${globalStyles.height};
  line-height: ${globalStyles.height};
  padding: 0;
  text-align: center;
  transition: box-shadow 0.2s ease-out;
  width: ${globalStyles.width};
  &::placeholder {
    color: ${color.greyIcons};
    opacity: 1; // firefox
  }
  &:focus {
    box-shadow: inset 0 0 0 2px ${color.blueSky} !important;
  }
  &.is-filled {
    background: ${color.blueLight};
    box-shadow: none;
  }
  &:hover {
    box-shadow: inset 0 0 0 1px ${color.blueSky};
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media only screen and (max-width: 420px) {
    width: 52px;
    height: 52px;
    line-height: 52px;
    border-radius: 10px;
  }
  /* Firefox */
  -moz-appearance: textfield;
  caret-color: transparent;
`;
const DivStyledTooltip$1 = styled$1.div`
  background-color: ${color.red};
  border-radius: 4px;
  color: ${color.white};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding: 8px 12px;
  position: absolute;
  width: fit-content;
  &::after {
    content: ' ';
    position: absolute;
    left: 30px;
    top: -4px;
    border-top: none;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    border-bottom: 4px solid ${color.red};
  }
`;
var styles$1 = {
  InputStyled: InputStyled$1,
  DivStyledWrapper: DivStyledWrapper$1,
  DivStyledTooltip: DivStyledTooltip$1
};
const {
  InputStyled,
  DivStyledWrapper,
  DivStyledTooltip
} = styles$1;
const VerifyCode = ({
  autoFocus = false,
  length = 5,
  label = "Enter Code",
  onCompleted = () => {
  },
  placeholder = "X",
  state = "default",
  errorMessage = "Entered code is invalid. Please re-send code and try again."
}) => {
  const [code, setCode] = useState(new Array(length).fill(""));
  const inputRefs = useMemo(() => new Array(length).fill(null).map(() => createRef()), [length]);
  const processInput = (e2, idx) => {
    var _a, _b;
    const newCode = [...code];
    const num = newCode[idx] === e2.target.value[0] ? e2.target.value[1] : e2.target.value[0];
    newCode[idx] = num || "";
    setCode(newCode);
    if (idx !== length - 1) {
      (_b = (_a = inputRefs[idx + 1]) == null ? void 0 : _a.current) == null ? void 0 : _b.focus();
    }
    if (newCode.every((num2) => num2 !== "")) {
      onCompleted(newCode.join(""));
    }
  };
  const onKeyUp = (e2, idx) => {
    var _a, _b;
    if (e2.key === "ArrowUp" || e2.key === "ArrowDown")
      return;
    const isDeleting = e2.key === "Delete" || e2.key === "Backspace";
    if (isDeleting && !code[idx] && idx !== 0) {
      const newCode = [...code];
      newCode[idx - 1] = "";
      setCode(newCode);
      (_b = (_a = inputRefs[idx - 1]) == null ? void 0 : _a.current) == null ? void 0 : _b.focus();
    }
  };
  const onPaste = (e2) => {
    var _a;
    e2.preventDefault();
    const pastedString = (_a = e2.clipboardData) == null ? void 0 : _a.getData("text");
    if (!pastedString)
      return;
    const isNumber = !Number.isNaN(+pastedString);
    const newCode = pastedString.split("").slice(0, length);
    if (isNumber) {
      setCode(newCode);
      if (newCode.every((num) => num !== "")) {
        onCompleted(newCode.join(""));
      }
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "VerifyCode",
    "data-testid": "test-verify-code",
    children: [/* @__PURE__ */ jsx(Typography, {
      variant: "subtitle2",
      weight: "semibold",
      color: color.black,
      children: label
    }), /* @__PURE__ */ jsx(DivStyledWrapper, {
      className: "verify-code",
      "data-testid": "test-verify-code-wrap",
      children: code.map((num, idx) => /* @__PURE__ */ jsx(InputStyled, {
        autoFocus: autoFocus && !code[0].length && idx === 0,
        className: `${num !== "" && "is-filled"}`,
        "data-testid": `test-verify-code-input-${idx}`,
        inputMode: "numeric",
        maxLength: 1,
        onChange: (e2) => processInput(e2, idx),
        onKeyDown: (e2) => ["e", "E", "+", "-", "."].includes(e2.key) && e2.preventDefault(),
        onKeyUp: (e2) => onKeyUp(e2, idx),
        onPaste: (e2) => onPaste(e2),
        placeholder: placeholder[0],
        ref: inputRefs[idx],
        type: "number",
        value: num
      }, idx))
    }), state === "error" && errorMessage !== "" && /* @__PURE__ */ jsx(DivStyledTooltip, {
      "data-testid": "test-verify-code-error",
      children: errorMessage
    })]
  });
};
const DivStyled$1 = styled$1.div`
  ${resetCSS};
  background-color: ${color.white};
  border: 1px solid ${color.paleBlue2};
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  padding: 32px;
  width: 100%;
  :first-child {
    :first-child {
      ${fonts.openSans};
      font-weight: 400;
    }
    :nth-child(1) {
      ${fonts.openSans};
      font-weight: 600;
    }
  }
`;
var styles = {
  DivStyled: DivStyled$1
};
const {
  DivStyled
} = styles;
const Widget = ({
  children,
  info: info2,
  title,
  isLoading,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(DivStyled, {
    "data-testid": "test-widget",
    ...props,
    children: [/* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx(Typography, {
        color: color.blueDark,
        "data-testid": "test-widget-title",
        variant: "caption12",
        weight: "400",
        children: title
      }), /* @__PURE__ */ jsx(Typography, {
        color: color.blueDark,
        "data-testid": "test-widget-info",
        variant: "h3",
        weight: "400",
        children: isLoading ? /* @__PURE__ */ jsx(Skeleton, {
          height: "24px",
          width: "100%",
          theme: "subtitle"
        }) : info2
      })]
    }), children]
  });
};
export { Typography as $, Accordion as A, ButtonBase as B, Ce$1 as C, DatePicker as D, NotificationProvider as E, Form as F, useNotification as G, Hero as H, Illustration as I, PopoverDropdown as J, PopoverElement as K, LinkTo as L, Modal as M, Notification as N, Row as O, PlanCard as P, Skeleton as Q, Radios as R, Select as S, Stepper as T, Table as U, TabList as V, Tab as W, Tag as X, TextArea as Y, Todo as Z, Tooltip as _, gradientColors as a, Upload as a0, VerifyCode as a1, Widget as a2, Avatar as b, color as c, Badge as d, BannerStrip as e, Breadcrumbs as f, getShade as g, Button as h, Card as i, jsx as j, ChainSelector as k, Checkbox as l, CodeArea as m, CopyButton as n, Credentials as o, CreditCard as p, CryptoCards as q, CryptoLogos as r, styled$1 as s, Dropdown as t, useCopyToClipboard as u, HideButton as v, Info as w, Input as x, Loading as y, Logo as z };
